<template>
    <div @mouseover.prevent="checkSiteIfCorrect()" @click.prevent="checkIfDocumentTypeIsCorrect()" id="document-form">
        <div id="logoDiv" style="display: none;"></div>
        <!--
            Full-screen loading overlay shown while the document is still being loaded/built
            (initializeDocument). This gives the user a clear visual cue that loading is in
            progress and — because it captures pointer events — guarantees the Update/Confirm/Post
            buttons cannot be clicked until loading has fully completed. This prevents the
            "first click does nothing" behaviour on large (500+ line) imports where the main
            thread is still busy right after the form becomes visible.
        -->
        <div
            v-if="showDocumentLoadingOverlay"
            class="document-loading-overlay"
            data-testid="document-loading-overlay"
            aria-live="polite"
            aria-busy="true"
        >
            <a-spin size="large" />
            <div class="document-loading-overlay__text">Loading document, please wait...</div>
        </div>
        <a-spin :tip="spinMessage" :spinning="spinning || isInitializing" :disabled="spinning || isInitializing">
          <base-header type="instore" class="pb-5 pt-5 pt-md-8">
          </base-header>

          <div class="container sticky-top sticky-header pt-3" style="background-color: #f5365c; visibility: hidden; border-radius: 0 0 5px 5px;">
              <div class="row ">
                  <div class="col-auto">
                      <router-link :to="backLink" >
                          <h6 id="back-buttonx" class="heading-small" style='color: white;'> ⟵   {{ backLabel }} </h6>
                      </router-link>
                  </div>
                  <div class="col p-0">
                    <div class="float-right">
                        <base-dropdown class="nav-link pr-0 float-right" position="right">
                            <div class="media align-items-center" slot="title">
                                <i id="document-action-button" class="fa fa-ellipsis-v float-right ml-2 btn-sm" style='color: white; cursor: pointer;'></i>
                            </div>
                            <template>
                                <div class="dropdown-header noti-title">
                                    <h6 class="text-overflow m-0">ACTIONS</h6>
                                </div>
                                <template v-if="relatedDocument.length > 0">
                                    <template v-if="documentRelation == 'parent'">
                                        <div v-for="item in relatedDocument" :key="item.id">
                                            <a class="dropdown-item" @click.prevent='openRelatedDocument(item.id, item.document_type_id)'><i class="fa fa-angle-double-right"></i>{{item.friendly_code}} #{{item.document_no}}</a>
                                        </div>
                                    </template>
                                    <template v-else>
                                        <div v-for="item in relatedDocument" :key="item.id">
                                            <a class="dropdown-item" @click.prevent='openRelatedDocument(item.id, item.document_type_id)'><i class="fa fa-angle-double-left"></i>{{item.friendly_code}} #{{item.document_no}}</a>
                                        </div>
                                    </template>
                                </template>
                                <a class="dropdown-item" @click.prevent="showDrawer('history')"><i class="fas fa-history"></i><span>History</span></a>
                                <a class="dropdown-item" @click.prevent="showDrawer('references')"><i class="fa fa-asterisk"></i><span>References</span></a>
                                <a class="dropdown-item" @click.prevent="showDrawer('extras')"><i class="fa fa-plus"></i><span>Extras</span></a>
                                <a class="dropdown-item" v-if="documentNumber > 0" @click.prevent="showDocumentPayment()"><i class="fa fa-money-bill"></i><span>Document Payments</span></a>
                                <a class="dropdown-item" v-if="documentNumber > 0" @click.prevent="showDrawer('document_image')"><i class="fa fa-file-image"></i><span>Document Image</span></a>
                                <a class="dropdown-item" v-if="canMergePhysicalCountV2SimilarEntries" @click.prevent="mergePhysicalCountV2SimilarEntries()"><i class="fas fa-compress-arrows-alt"></i><span>Merge Similar Entries</span></a>
                                <template v-if="currentDocumentTypeCode == 'OTHPWS'">
                                    <a class="dropdown-item" v-if="accessRights.includes('D') && documentNumber>0 && (documentStatus == 'Saved' || documentStatus == 'Confirmed' || documentStatus == 'Upload Error') && postedASMDSM == false && orderSource!='shopee' && orderSource!='lazada' && orderSource!='shopify' && orderSource!='zalora'" @click.prevent="voided()"><i class="fas fa-window-close" style="color: Tomato;" ></i><span>Void Request</span></a>
                                    <a class="dropdown-item" v-if="accessRights.includes('D') && documentNumber>0 && (documentStatus == 'Saved' || documentStatus == 'Confirmed' || documentStatus == 'Upload Error') && postedASMDSM == false && (orderSource == 'shopee' || orderSource == 'lazada' || orderSource == 'shopify' || orderSource == 'zalora') && currentDocumentTypeCode=='RELDDE'" @click.prevent="voidEcomOrder()"><i class="fas fa-window-close" style="color: Tomato;" ></i><span>Void Request</span></a>
                                </template>
                                <template v-else>
                                    <a class="dropdown-item" v-if="accessRights.includes('D') && documentNumber>0 && (documentStatus == 'Saved' || documentStatus == 'Upload Error' || documentStatus == 'Posted') && postedASMDSM == false && orderSource!='shopee' && orderSource!='lazada' && orderSource!='shopify' && orderSource!='zalora'" @click.prevent="voided()"><i class="fas fa-window-close" style="color: Tomato;" ></i><span>Void Request</span></a>
                                    <a class="dropdown-item" v-if="accessRights.includes('D') && documentNumber>0 && (documentStatus == 'Saved' || documentStatus == 'Upload Error') && postedASMDSM == false && (orderSource == 'shopee' || orderSource == 'lazada' || orderSource == 'shopify' || orderSource == 'zalora') && currentDocumentTypeCode=='RELDDE'" @click.prevent="voidEcomOrder()"><i class="fas fa-window-close" style="color: Tomato;" ></i><span>Void Request</span></a>
                                </template>
                                <a class="dropdown-item" v-if="documentNumber > 0 && (documentStatus == 'Saved' || documentStatus == 'Upload Error')" @click.prevent="copyDocument()"><i class="fas fa-clone"></i><span>Duplicate Document</span></a>
                                <a class="dropdown-item" v-if="currentDocumentTypeCode=='OTHTRA' || currentDocumentTypeCode=='OTHPCK'" @click.prevent="showDrawer('view_allocation')"><i class="fas fa-eye"></i><span>View Allocation</span></a>
                                <a class="dropdown-item" v-if="documentId > 0" @click.prevent="showInternalDocumentId"><i class="fa fa-file-alt"></i><span>View Internal ID</span></a>
                            </template>
                          </base-dropdown>
                          <p v-if="accessRights.includes('T') && documentNumber>0  && orderSource!='shopee' && orderSource!='lazada' && orderSource!='zalora' && currentDocumentTypeCode!='ORIPOX' && currentDocumentTypeCode!='OTHTRA' && currentDocumentTypeCode!='OTHPCK' && currentDocumentTypeCode!='OTHBAR'" class="fas fa-print float-right ml-2 pt-2 btn-sm" style='color: white; cursor: pointer;' @click="isPhysicalCountV2Document ? modalFormPrinting = true : print()"> <b style="font-family: 'Arial', sans-serif;" > PRINT</b> </p>
                          <p v-if="accessRights.includes('T') && documentNumber>0 && currentDocumentTypeCode=='OTHBAR' && documentStatus == 'Confirmed'" class="fas fa-print float-right ml-2 pt-2 btn-sm" style='color: white; cursor: pointer;' @click="showBarcodePrintingModal()"> <b style="font-family: 'Arial', sans-serif;" > PRINT</b> </p>
                          <a-dropdown v-if="accessRights.includes('T') && documentNumber>0 && orderSource!='shopee' && orderSource!='lazada' && orderSource!='zalora' && currentDocumentTypeCode=='ORIPOX'">
                              <p class="fas fa-print float-right ml-2 pt-2 btn-sm" style='color: white; cursor: pointer;'> <b style="font-family: 'Arial', sans-serif;" @click="modalFormPrinting = true"> PRINT</b> </p>
                          </a-dropdown>
                          <a-dropdown v-if="accessRights.includes('T') && documentNumber>0 && (currentDocumentTypeCode=='OTHTRA' || currentDocumentTypeCode=='OTHPCK')">
                              <p class="fas fa-print float-right ml-2 pt-2 btn-sm" style='color: white; cursor: pointer;'> <b style="font-family: 'Arial', sans-serif;" @click="modalFormPrinting = true"> PRINT</b> </p>
                          </a-dropdown>
                          <a-dropdown v-if="accessRights.includes('T') && documentNumber>0 && (orderSource=='shopee' || orderSource=='lazada' || orderSource=='zalora')">
                              <p class="fas fa-print float-right ml-2 pt-2 btn-sm" style='color: white; cursor: pointer;'> <b style="font-family: 'Arial', sans-serif;" @click="modalFormPrinting = true"> PRINT</b> </p>
                          </a-dropdown>
                          <i v-if='false' class="fas fa-sync-alt float-right ml-2 pt-2 btn-sm" style='color: white; cursor: pointer;'> <b style="font-family: 'Arial', sans-serif;"> REFRESH</b></i>
                      </div>
                  </div>
                  <div class='col-auto ml-2'>
                      <div class="float-right">
                          <!-- FREEZE INVENTORY -->
                          <button v-if="documentOrderStatus != 'Frozen' && documentNumber>0 && currentDocumentTypeCode=='OTHPCN' && showFreezeButton && isPostDisabled == false" type="button" class="btn btn-light btn-sm"  :disabled="isfreezeDisabled" @click.prevent="freeze()">Freeze Inventory</button>
                          
                          <!-- FOR MR. SPEEDY - BOOK DELIVERY -->
                          <button v-if="documentStatus == 'Posted' && showBookingButton" type="button"  @click.prevent="showBooking()" class="btn btn-primary btn-sm">Book Delivery</button>
                          
                          <!-- DELIVER BUTTON -->
                          <button v-if="documentStatus == 'Posted' && showDeliverButton && false" type="button"  @click.prevent="deliver()" class="btn btn-primary btn-sm">Deliver</button>
                          
                          <!-- CREATE ASN -->
                          <button v-if="documentStatus == 'Posted' && documentOrderStatus !== 'Fulfilled' && documentOrderStatus !== 'Done' && showCreateChildDocButton && currentDocumentTypeCode=='ORIPOX' & asnModule > 0" type="button" class="btn btn-primary btn-sm" @click='processChildDocument(true)'>Create ASN</button>
                          
                          <div v-if="accessRights.includes('A') && documentNumber==0">
                              <!-- CREATING ACTUAL DOCUMENT (Current Selected Document) -->
                              <button v-show="createButtonMain" type="button" class="btn btn-primary btn-sm" @click.prevent="save()" :disabled="isSaveDisabled">
                                  Create {{currentDocumentTypeName}}
                              </button>
                              
                              <!-- CHILD DOCUMENT -->
                              <button v-show="createButtonMain" v-if="documentStatus == 'Posted' && documentOrderStatus !== 'Fulfilled' && documentOrderStatus !== 'Done' && showCreateChildDocButton" type="button" class="btn btn-primary btn-sm" @click='processChildDocument(false)'>
                                  {{createChildDocButtonLabel}}
                              </button>
                          </div>
                          
                          <!-- UPDATE BUTTON -->
                          <button data-testid="document-button-post" v-if="accessRights.includes('W') && documentNumber>0 && documentStatus == 'Saved' || documentStatus == 'Upload Error'" type="button" class="btn btn-primary btn-sm" @click.prevent="update()" :disabled="updateButtonDisabled">Update </button>

                          <!-- POST BUTTON -->
                          <a-popconfirm :okButtonProps="{'data-testid': 'yes-post-button'}" v-if="canShowPostAction && documentNumber!=0 && (documentStatus == 'Saved' || documentStatus == 'Confirmed' || documentStatus == 'Upload Error') && orderSource!='shopee' && orderSource!='lazada' && orderSource!='zalora' && currentDocumentTypeCode!='OTHBAR'" title="Are you sure you want to post this document?" @confirm="post()" okText="Yes" cancelText="No" :disabled="postButtonDisabled">
                              <a type="button" data-testid="document-button-post" class="btn btn-info btn-sm text-white" :disabled="postButtonDisabled">Post</a>
                          </a-popconfirm>
                          <a-popconfirm v-if="canShowPostAction && documentNumber!=0 && (documentStatus == 'Saved' || documentStatus == 'Confirmed') && (orderSource=='shopee' || orderSource=='lazada'|| orderSource=='zalora') && currentDocumentTypeCode=='RELDDE'" title="Are you sure you want to post this document?" @confirm="postEcomOrder()" okText="Yes" cancelText="No" :disabled="postButtonDisabled">
                              <a type="button" data-testid="document-button-post-ecom-del" class="btn btn-info btn-sm text-white" :disabled="postButtonDisabled">Post</a>
                          </a-popconfirm>
                          <a-popconfirm v-if="canShowPostAction && documentNumber!=0 && (documentStatus == 'Saved' || documentStatus == 'Confirmed') && (orderSource=='shopee' || orderSource=='lazada'|| orderSource=='zalora') && currentDocumentTypeCode!='RELDDE'" title="Are you sure you want to post this document?" @confirm="post()" okText="Yes" cancelText="No" :disabled="postButtonDisabled">
                              <a type="button" data-testid="document-button-post-ecom" class="btn btn-info btn-sm text-white" :data-testid="'post-button'" :disabled="postButtonDisabled">Post</a>
                          </a-popconfirm>

                          <!-- CONFIRM BUTTON -->
                          <button data-testid="document-button-confirm" v-if="accessRights.includes('C') && documentNumber!=0 && documentStatus == 'Saved' && showconfirmUnconfirmButton || documentStatus == 'Upload Error' && showconfirmUnconfirmButton" :disabled="confirmButtonDisabled" type="button" class="btn btn-light btn-sm" @click.prevent="confirm()">Confirm</button>

                          <!-- UNCONFIRM BUTTON -->
                          <button data-testid="document-button-unconfirm" v-if="documentNumber!=0 && documentStatus == 'Confirmed'" type="button" class="btn btn-light btn-sm" @click.prevent="unconfirm()">Unconfirm</button>
                      </div>
                  </div>
              </div>
          </div>

          <!-- FOR PO -->
          <div class="container-fluid mt--7 spin-content">
              <div class="row regular-header">
                  <div class="col-auto">
                      <router-link  :to="backLink" >
                          <h6 id="back-button" class="heading-small" style='color: white;'> ⟵   {{ backLabel }} </h6>
                      </router-link>
                  </div>
                  <div class="col p-0">
                      <div class="float-right">
                          <base-dropdown class="nav-link pr-0 float-right" position="right">
                              <div class="media align-items-center" slot="title">
                              <i id="document-action-button" class="fa fa-ellipsis-v float-right ml-2 btn-sm" style='color: white; cursor: pointer;'></i>
                              </div>
                              <template>
                                  <div class="dropdown-header noti-title">
                                      <h6 class="text-overflow m-0">ACTIONS</h6>
                                  </div>
                                  <template v-if="relatedDocument.length > 0">
                                      <template v-if="documentRelation == 'parent'">
                                          <div v-for="item in relatedDocument" :key="item.id">
                                              <a class="dropdown-item" @click.prevent='openRelatedDocument(item.id, item.document_type_id)'><i class="fa fa-angle-double-right"></i>{{item.friendly_code}} #{{item.document_no}}</a>
                                          </div>
                                      </template>
                                      <template v-else>
                                          <div v-for="item in relatedDocument" :key="item.id">
                                              <a class="dropdown-item" @click.prevent='openRelatedDocument(item.id, item.document_type_id)'><i class="fa fa-angle-double-left"></i>{{item.friendly_code}} #{{item.document_no}}</a>
                                          </div>
                                      </template>
                                  </template>
                                  <a id="document-action-history" class="dropdown-item" @click.prevent="showDrawer('history')"><i class="fas fa-history"></i><span>History</span></a>
                                  <a id="document-action-references" class="dropdown-item" @click.prevent="showDrawer('references')"><i class="fa fa-asterisk"></i><span>References</span></a>
                                  <a id="document-action-extras" class="dropdown-item" @click.prevent="showDrawer('extras')" v-if="currentDocumentTypeCode !== 'OTHPWS'"><i class="fa fa-plus" ></i><span>Extras</span></a>
                                  <a id="document-action-purchase-variance" class="dropdown-item" v-if="currentDocumentTypeCode == 'RECDEL' && documentStatus == 'Posted' && purchaseVarianceAccess == 1" @click.prevent="enableAdditionalCharges()"><i class="fa fa-pencil"></i><span>Purchase Variance</span></a>
                                  <a id="document-action-doc-payments" class="dropdown-item" v-if="documentNumber > 0 && currentDocumentTypeCode !== 'OTHPWS'" @click.prevent="showDocumentPayment()"><i class="fa fa-money-bill"></i><span>Document Payments</span></a>
                                  <a id="document-action-doc-image" class="dropdown-item" v-if="documentNumber > 0 && currentDocumentTypeCode !== 'OTHPWS'" @click.prevent="showDrawer('document_image')"><i class="fa fa-file-image"></i><span>Document Image</span></a>
                                  <a id="document-action-physical-count-v2-merge-similar" class="dropdown-item" v-if="canMergePhysicalCountV2SimilarEntries" @click.prevent="mergePhysicalCountV2SimilarEntries()"><i class="fas fa-compress-arrows-alt"></i><span>Merge Similar Entries</span></a>
                                  <template v-if="currentDocumentTypeCode != 'OTHPWS'">
                                      <a id="document-action-void-request" class="dropdown-item" v-if="accessRights.includes('D') && documentNumber>0 && (documentStatus == 'Saved' || documentStatus == 'Upload Error' || documentStatus == 'Posted') && postedASMDSM == false && orderSource!='shopee' && orderSource!='lazada' && orderSource!='shopify' && orderSource!='zalora'" @click.prevent="voided()"><i class="fas fa-window-close" style="color: Tomato;" ></i><span>Void Request</span></a>
                                      <a id="document-action-void-request-ecom" class="dropdown-item" v-if="accessRights.includes('D') && documentNumber>0 && (documentStatus == 'Saved' || documentStatus == 'Upload Error') && postedASMDSM == false && (orderSource == 'shopee' || orderSource == 'lazada' || orderSource == 'shopify' || orderSource == 'zalora') && currentDocumentTypeCode=='RELDDE'" @click.prevent="voidEcomOrder()"><i class="fas fa-window-close" style="color: Tomato;" ></i><span>Void Request</span></a>
                                  </template>
                                  <a id="document-action-duplicate-doc" class="dropdown-item" v-if="documentNumber > 0 && (documentStatus == 'Saved' || documentStatus == 'Upload Error')" @click.prevent="copyDocument()"><i class="fas fa-clone"></i><span>Duplicate Document</span></a>
                                  <a id="document-action-view-alloc" class="dropdown-item" v-if="currentDocumentTypeCode=='OTHTRA' || currentDocumentTypeCode=='OTHPCK'" @click.prevent="showDrawer('view_allocation')"><i class="fas fa-eye"></i><span>View Allocation</span></a>
                                  <a id="document-action-view-id" class="dropdown-item" v-if="documentId > 0" @click.prevent="showInternalDocumentId"><i class="fa fa-file-alt"></i><span>View Internal ID</span></a>
                                  <a-popconfirm title="Are you sure you want to mark this document 'DONE'?" @confirm="updateOrderStatus('D')" okText="Yes" cancelText="No">
                                    <a id="document-action-mark-done" class="dropdown-item" v-if="documentId > 0 && currentDocumentTypeCode === 'ORIPOX' && documentOrderStatus === 'Partially Delivered'" ><i class="fa fa-check"></i><span>Mark Document as Done</span></a>
                                  </a-popconfirm>
                              </template>
                          </base-dropdown>
                          <a-dropdown v-if='accessRights.includes("T") && documentNumber>0 && orderSource!="shopee" && orderSource!="lazada"&& orderSource!="zalora" && currentDocumentTypeCode!="ORIPOX" && currentDocumentTypeCode!="OTHTRA" && currentDocumentTypeCode!="OTHPCK" && currentDocumentTypeCode !="OTHBAR"'>
                              <p id="document-action-print" class="fas fa-print float-right ml-2 pt-2 btn-sm" style='color: white; cursor: pointer;' @click="modalFormPrinting = true"> <b style="font-family: 'Arial', sans-serif;"> PRINT</b> </p>
                          </a-dropdown>
                          <a-dropdown v-if="accessRights.includes('T') && documentNumber>0 && orderSource!='shopee' && orderSource!='lazada' && orderSource!='zalora' && currentDocumentTypeCode=='ORIPOX'">
                              <p id="document-action-print-po" class="fas fa-print float-right ml-2 pt-2 btn-sm" style='color: white; cursor: pointer;'> <b style="font-family: 'Arial', sans-serif;" @click="modalFormPrinting = true"> PRINT</b> </p>
                          </a-dropdown>
                          <a-dropdown v-if="accessRights.includes('T') && documentNumber>0 && (currentDocumentTypeCode=='OTHTRA' || currentDocumentTypeCode=='OTHPCK')">
                              <p id="document-action-print-trapck" class="fas fa-print float-right ml-2 pt-2 btn-sm" style='color: white; cursor: pointer;'> <b style="font-family: 'Arial', sans-serif;" @click="modalFormPrinting = true"> PRINT</b> </p>
                          </a-dropdown>
                          <a-dropdown v-if='accessRights.includes("T") && documentNumber>0 && (orderSource=="shopee" || orderSource=="lazada" || orderSource=="zalora")'>
                              <p id="document-action-print-ecom" class="fas fa-print float-right ml-2 pt-2 btn-sm" style='color: white; cursor: pointer;'> <b style="font-family: 'Arial', sans-serif;" @click="modalFormPrinting = true"> PRINT</b> </p>
                          </a-dropdown>
                          <p id="document-action-print-barcode" v-if="accessRights.includes('T') && documentNumber>0 && currentDocumentTypeCode=='OTHBAR' && documentStatus == 'Confirmed'" class="fas fa-print float-right ml-2 pt-2 btn-sm" style='color: white; cursor: pointer;' @click="showBarcodePrintingModal()"> <b style="font-family: 'Arial', sans-serif;" > PRINT</b> </p>
                          <i id="document-action-refresh" v-if='false' class="fas fa-sync-alt float-right ml-2 pt-2 btn-sm" style='color: white; cursor: pointer;' @click.prevent=""> <b style="font-family: 'Arial', sans-serif;"> REFRESH</b></i>
                      </div>
                  </div>
                  <div class='col-auto ml-2'>
                      <div class="float-right">
                          <button id="document-button-freeze" v-if="documentStatus != 'Posted' && documentNumber>0 && currentDocumentTypeCode=='OTHPCN' && showFreezeButton && isPostDisabled == false" type="button" class="btn btn-light btn-sm" :disabled="isfreezeDisabled" @click.prevent="freeze()">
                            <div v-if="documentOrderStatus != 'Frozen'"> Freeze Inventory </div>
                            <div v-else> Unfreeze Inventory </div>
                          </button>
                          <button id="document-button-deliver" v-if="documentStatus == 'Posted' && showDeliverButton && false" type="button"  @click.prevent="deliver()" class="btn btn-primary btn-sm">Deliver</button>

                          <!-- FOR MR. SPEEDY SAMPLE -->
                          <button id="document-button-booking" v-if="documentStatus == 'Posted' && showBookingButton" type="button"  @click.prevent="showBooking()" class="btn btn-primary btn-sm">Booking Details</button>
                          
                          <!-- CHILD DOCUMENT -->
                          <button data-testid="document-button-create-child" v-show="createButtonMain" v-if="documentStatus == 'Posted' && showCreateChildDocButton && documentOrderStatus !== 'Fulfilled' && documentOrderStatus !== 'Done'" type="button" class="btn btn-primary btn-sm" @click='processChildDocument(false)'>{{createChildDocButtonLabel}}</button>
                          <button data-testid="document-button-create-asn" v-if="documentStatus == 'Posted' && showCreateChildDocButton && documentOrderStatus !== 'Fulfilled' && currentDocumentTypeCode=='ORIPOX' && asnModule > 0" type="button" class="btn btn-primary btn-sm" @click='processChildDocument(true)'>Create ASN</button>
                          
                          <!-- CREATE DOCUMENT -->
                          <button data-testid="document-button-create" v-show="createButtonMain" v-if="accessRights.includes('A') && documentNumber==0 " type="button" class="btn btn-primary btn-sm" @click.prevent="save()" :disabled="isSaveDisabled">Create {{currentDocumentTypeName}}</button>

                          <!-- UPDATE DOCUMENT -->
                          <button data-testid="document-button-update" v-if="accessRights.includes('W') && documentNumber>0 && documentStatus == 'Saved' || documentStatus == 'Upload Error'" type="button" class="btn btn-primary btn-sm" @click.prevent="update()" :disabled="updateButtonDisabled">Update </button>
                          <a-popconfirm :okButtonProps="{'data-testid': 'yes-post-button'}" v-if="canShowPostAction && documentNumber!=0 && (documentStatus == 'Saved' || documentStatus == 'Confirmed' || documentStatus == 'Upload Error') && orderSource!='shopee' && orderSource!='lazada'&& orderSource!='zalora' && currentDocumentTypeCode!='OTHBAR'" title="Are you sure you want to post this document?" @confirm="post()" okText="Yes" cancelText="No" :disabled="postButtonDisabled">
                              <a data-testid="document-button-post" type="button" class="btn btn-info btn-sm text-white" :disabled="postButtonDisabled">Post</a>
                          </a-popconfirm>
                          <a-popconfirm v-if="canShowPostAction && documentNumber!=0 && (documentStatus == 'Saved' || documentStatus == 'Confirmed') && (orderSource=='shopee' || orderSource=='lazada'|| orderSource=='zalora') && currentDocumentTypeCode=='RELDDE'" title="Are you sure you want to post this document?" @confirm="postEcomOrder()" okText="Yes" cancelText="No" :disabled="postButtonDisabled">
                              <a data-testid="document-button-post-ecom-del" type="button" class="btn btn-info btn-sm text-white" :disabled="postButtonDisabled">Post</a>
                          </a-popconfirm>
                          <a-popconfirm v-if="canShowPostAction && documentNumber!=0 && (documentStatus == 'Saved' || documentStatus == 'Confirmed') && (orderSource=='shopee' || orderSource=='lazada'|| orderSource=='zalora') && currentDocumentTypeCode!='RELDDE'" title="Are you sure you want to post this document?" @confirm="post()" okText="Yes" cancelText="No" :disabled="postButtonDisabled">
                              <a data-testid="document-button-post-ecom" type="button" class="btn btn-info btn-sm text-white" :disabled="postButtonDisabled">Post</a>
                          </a-popconfirm>
                          <button data-testid="document-button-confirm" v-if="accessRights.includes('C') && documentNumber!=0 && documentStatus == 'Saved' && showconfirmUnconfirmButton || documentStatus == 'Upload Error' && showconfirmUnconfirmButton" :disabled="confirmButtonDisabled" type="button" class="btn btn-light btn-sm" @click.prevent="confirm()">Confirm</button>
                          <button data-testid="document-button-unconfirm" v-if="documentNumber!=0 && documentStatus == 'Confirmed'" type="button" class="btn btn-light btn-sm" @click.prevent="unconfirm()">Unconfirm</button>
                      </div>
                  </div>
              </div>

              <!-- View Internal ID Modal -->
              <a-modal id="modal-view-internal-id" title="Internal Document ID" :visible="modalInternalDocumentId"
                      @cancel="handleCancel">
                  <template slot="footer">
                      <a-button id="modal-view-internal-id-close" key="back" @click="handleCancel">Close</a-button>
                  </template>
                  <b>Document Id: </b> {{this.documentId}}
              </a-modal>

              <!-- Count Set: View Document Lines Modal -->
              <a-modal title="Count Set Document Lines" :visible="countSetLinesModalVisible" width="80%"
                      :maskClosable="false" @cancel="countSetLinesModalVisible = false">
                  <template slot="footer">
                      <a-button key="back" @click="countSetLinesModalVisible = false">Close</a-button>
                  </template>
                  <a-table rowKey="line_no" :columns="countSetLinesColumns" :dataSource="countSetLinesData"
                      :loading="countSetLinesLoading" :pagination="true" size="small"
                      :locale="{ emptyText: countSetLinesEmptyText }">
                  </a-table>
              </a-modal>

              <!-- Additional Charges Modal -->
              <!-- Arvin -->
              <a-modal title="Additional Charges" :visible="modalAdditionalCharges" :maskClosable = "false"
                      @cancel="modalAdditionalCharges = false; showChargesTable = false;" width='70%' wrap-class-name="full-modal">
                  <template slot="footer">
                      <a-popconfirm v-if="additionalChargeData.length > 0" placement="top" @confirm="saveAdditionalCharges()" okText="Yes" cancelText="No">
                          <template #title>
                          <p class="text-small">This will recompute the received cost of all
                          <br>remaining inventory quantity from this document.
                          <br>Do you want to continue?</p>
                          </template>
                              <a type="button" class="btn btn-danger btn-sm text-white" :disabled="disableSaveCharges">Apply Charges</a>
                      </a-popconfirm>
                      <a-button key="back" @click="modalAdditionalCharges = false; showChargesTable = false;">Cancel</a-button>
                  </template>
                  <a-spin :tip="spinMessage" :spinning="spinning2">
                  <div class="row pb-2">
                      <div class="col ">
                          <h6 class="heading-small text-muted">Charges</h6>
                      </div>
                      <div class="col-2 d-flex align-items-end" v-if="additionalChargeSelectedRowKeys && additionalChargeSelectedRowKeys.length > 0">
                          <button type="button" class="btn btn-danger btn-sm btn-block align-bottom" @click="mass_delete_charge()">Delete Charge</button>
                      </div>
                      <div class="col-2 d-flex align-items-end">
                          <button type="button" class="btn btn-primary btn-sm btn-block align-bottom" @click="showDrawer('charges')">Add Charge</button>
                      </div>
                  </div>
                  <a-table :rowSelection="additionalChargeRowSelection" rowKey='line_no' :columns="additionalChargeColumns" :dataSource="additionalChargeData" :pagination="true" size="small">
                  <span slot="amount" slot-scope="text, record">
                      {{formatMyNumber(Number(record.amount), 2)}}
                  </span> 
                  <template #footer>Total Additional Charges: {{formatMyNumber(Number(totalPurchaseVariance), 2)}}</template>
                  </a-table>
                  <hr/>
                  <base-input label="Charge Distribution Quantity"><br>
                      <a-radio-group name="chargeDistributionQuantity" v-model="chargeDistributionQuantity">
                        <a-radio :value="1">
                          Document Quantity
                        </a-radio>
                        <a-radio :value="2">
                          Inventory Quantity
                        </a-radio>
                      </a-radio-group>
                      <button type="button" v-if="additionalChargeData.length > 0" class="btn btn-success btn-sm align-bottom" @click="applyAdditionalCharges()">View Charges</button>
                  </base-input>
                  <hr/>
                  <a-table rowKey='line_no' :columns="itemsAdditionalChargeColumns" :dataSource="itemCostLayerData" :pagination="true" size="small">
                      <span slot="new_cost" slot-scope="text, record">
                          {{formatMyNumber(Number(record.new_cost), 2)}}
                      </span> 
                      <span slot="charge_share" slot-scope="text, record">
                          {{formatMyNumber(Number(record.charge_share), 2)}}
                      </span> 
                      <span slot="rr_quantity" slot-scope="text, record">
                          {{formatMyNumber(Number(record.rr_quantity), 0)}}
                      </span> 
                      <span slot="quantity" slot-scope="text, record">
                          {{formatMyNumber(Number(record.quantity), 0)}}
                      </span> 
                      <span slot="cost" slot-scope="text, record">
                          {{formatMyNumber(Number(record.cost), 2)}}
                      </span>      
                  </a-table>
                  </a-spin>
              </a-modal>

              <!-- Min/Max products modal -->
              <a-modal title="Auto-Rep (Min/Max)" :visible="modalMinMaxProducts" :maskClosable = "false"
                      @cancel="modalMinMaxProducts = false;">
                  <template slot="footer">
                      <a-button key="submit" type="primary" @click="populateMinMaxProducts()">Yes</a-button>
                      <a-button key="back" @click="modalMinMaxProducts = false;">No</a-button>
                  </template>
                  This will list all items that need to be replenished based on re-order level. {{overrideMinMaxProducts}} Do you want to continue?
              </a-modal>

              <!-- Offtake products modal -->
              <a-modal title="Auto-Rep (By Offtake)" :visible="modalOffTakeProducts" :maskClosable = "false"
                      @cancel="modalOffTakeProducts = false;">
                  <template slot="footer">
                      <a-button key="submit" type="primary" @click="populateOffTakeProducts()">Yes</a-button>
                      <a-button key="back" @click="modalOffTakeProducts = false;">No</a-button>
                  </template>
                  This will list all items that need to be replenished based on offtake for the last {{offtakeDays}} days. {{overrideOfftakeProducts}} Do you want to continue?
              </a-modal>
              
              <!-- Header -->
              <div class="row mt-2">
                  <div class="col">
                      <div class="card shadow">
                          <!-- doc type with id and document status -->
                          <div class="card-header px-4 py-3 bg-transparent">
                              <div class="row px-3">
                                  <h6 v-if='documentNumber!=undefined && documentNumber!=0' class="heading-small p-0 m-0"> {{ friendlyCodeAndDocumentNo }} <br> {{ friendlyOriginDocumentNo }}</h6>
                                  <h6 v-else class="heading-small"> Create {{currentDocumentTypeName}} </h6>
                                  <div class="col d-flex justify-content-end">
                                      <h6 class="heading-small p-0 m-0 mr-2"> {{documentOrderStatus}} </h6><i :class="headerOrderStatusIcon"></i>
                                      <h6 class="heading-small p-0 m-0 mr-2"> {{documentStatus}} </h6> <i :class="headerStatusIcon"></i>
                                  </div>
                              </div>
                              <div v-if="isPhysicalCountV2Document && documentNumber!=undefined && documentNumber!=0 && physicalCountCreatedFromLabel" class="row px-3 mt-1">
                                  <a-tooltip placement="topLeft" :title="physicalCountCreatedFromTooltip">
                                      <span class="heading-small text-muted"><i class="fa fa-info-circle mr-1"></i>Created From: {{ physicalCountCreatedFromLabel }}</span>
                                  </a-tooltip>
                              </div>
                              <template v-if='documentNumber!=undefined && documentNumber!=0 && relatedDocument.length > 0'>
                                   <div v-if="documentRelation == 'parent'" class="row px-3">
                                      <span v-for="item in relatedDocument" :key="item.id" class="heading-small">
                                          <a @click.prevent='openRelatedDocument(item.id, item.document_type_id)'>Parent Document No: {{item.friendly_code}}#{{item.document_no}}&nbsp;</a>
                                      </span>
                                   </div>
                                   <div v-else class="row px-3">
                                      <span v-for="item in relatedDocument" :key="item.id" class="heading-small">
                                          <a @click.prevent='openRelatedDocument(item.id, item.document_type_id)'>Child Document No: {{item.friendly_code}}#{{item.document_no}}&nbsp;</a>
                                      </span>
                                   </div>
                              </template>
                          </div>

                          <!-- document name and fields -->
                          <div class="card-body mx-4">
                              <!-- header label -->
                              <div class="row">
                                  <div class="col p-0"><h3 class='font-weight-bold'>{{currentDocumentTypeName}} Header</h3></div>
                                  <div class="col-auto p-0 mr-2 float-right">
                                      <a-tooltip placement="top" :title="currencyRateLabel" v-if="currentDocumentTypeCode !== 'OTHPWS'">
                                          <a-select 
                                              size="small"
                                              labelInValue
                                              :value="currency"
                                              style="width: 100%"
                                              :filterOption="false"
                                              @dropdownVisibleChange="fetchCurrencies"
                                              @change="selectCurrency"
                                              :disabled="documentStatus == 'Posted' ? true : false"
                                              :notFoundContent="fetching ? undefined : null"
                                          >
                                              <a-spin v-if="fetching" slot="notFoundContent" size="small"/>
                                              <a-select-option v-for="c in currencies" :key="'currencies'+c.id.toString()">{{c.name}}</a-select-option>
                                          </a-select>
                                      </a-tooltip>
                                  </div>
                                  <div v-if='header.showDocumentHeader && showTradeToggle' class="col-auto p-0 float-right">
                                      <a-popconfirm title="This action will clear all document lines?"
                                          ok-text="Continue"
                                          cancel-text="Cancel"
                                          @confirm="toggleDocumentTrade"
                                          :disabled="isTradeToggleDisabled"
                                      >
                                          <a-switch :checked='isDocumentTrade' checked-children="Trade Items" un-checked-children="Non-Trade Items" :disabled="isTradeToggleDisabled"/>
                                      </a-popconfirm>
                                  </div>
                                  <div class="col-auto p-0 float-right">
                                    <a v-if="!isEditing"
                                       class="refresh-document"
                                       href="#"
                                       @click.prevent="refreshDocument">
                                      <label><a-icon type="reload" /></label>
                                    </a>
                                    <a-popconfirm
                                      v-else
                                      class="refresh-document"
                                      title="This action will reload the current Document. Any unsaved changes will be removed. Do you want to continue?"
                                      ok-text="Yes"
                                      cancel-text="Cancel"
                                      @confirm="refreshDocument">
                                      <label><a-icon type="reload" /></label>
                                    </a-popconfirm>
                                  </div>
                              </div>

                              <!-- header fields -->
                              <div class="row mt-2">

                                  <!-- Supplying Branch -->
                                  <div v-if='header.showSupplyingSite' class="col mr-1">
                                      <div class="row"><h4 class="btn-blockheading-small font-weight-normal">Supplying Branch</h4></div>
                                      <div class="row mt-2">
                                          <a-select
                                          labelInValue
                                          showSearch
                                          :value="supplyingSite"
                                          placeholder="Select a supplying site"
                                          style="width: 100%"
                                          :filterOption="filterOption"
                                          @dropdownVisibleChange="handleSitesDropdownVisibleChange($event, 'supplyingSite')"
                                          @change="selectSupplyingSite"
                                          :notFoundContent="fetching ? undefined : null"
                                          :disabled='isSupplyingSiteDisabled'
                                          >
                                              <a-spin v-if="fetching" slot="notFoundContent" size="small"/>
                                              <a-select-option v-for="s in supplyingSites" :key="'sites'+s.id.toString()">{{s.name}}</a-select-option>
                                          </a-select>
                                      </div>
                                  </div>

                                  <!-- Supplier -->
                                  <div v-if='header.showSupplier' class="col mr-1">
                                      <div class="row">
                                          <div v-if='header.showRecevingReport' class="col p-0 mr-1"><h4 class="btn-blockheading-small font-weight-normal">Receving Report No</h4></div>
                                          <div class="col p-0 mr-1"><h4 class="btn-blockheading-small font-weight-normal">Supplier</h4></div>
                                      </div>
                                      <div class="row mt-2">
                                          <template>
                                              <a-modal
                                                  title="Changing Supplier"
                                                  :visible="showChangeSupplierModal"
                                                  :confirm-loading="confirmLoadingonSuppModal"
                                                  @ok="changeCostBySupplier"
                                                  @cancel="showChangeSupplierModal = false"
                                                  >
                                                  <p>Changing supplier will automatically change cost of all items below. Do you want to change the supplier</p>
                                                  </a-modal>
                                          </template>

                                            <!-- /barter-11/bxi-backend/-/issues/2252 -->
                                            <!-- Created a pop-up modal for clearing document line -->
                                          <template>
                                              <a-modal
                                                  :title="popUpModal.message"
                                                  :visible="popUpModal.isVisible"
                                                  @ok="popUpModal.initializeProcess"
                                                  @cancel="popUpModal.isVisible = false"
                                                  :cancelButtonProps="{ style: { display: popUpModal.isAutoPopulate ? 'none': null }}"
                                                  :closable="false"
                                                  >
                                                  <p>{{popUpModal.text}}</p>
                                                  </a-modal>
                                              <a-modal
                                                  title="Adding Item(s)"
                                                  :visible="showAddingProgress.isVisible"
                                                  :closable="false"
                                                  :footer="null"
                                                  >
                                                  <p>{{`${showAddingProgress.productAdded} out of ${showAddingProgress.productCount}`}}</p>
                                                  
                                                  <a-progress :percent="showAddingProgress.productCount?Math.floor((100 / showAddingProgress.productCount ) * showAddingProgress.productAdded): 0" size="small" />
                                                  <!-- <p>{{`${showAddingProgress.productCount?Math.floor((100 / showAddingProgress.productCount ) * showAddingProgress.productAdded): 0}% Completed`}}</p> -->
                                                  <!-- <button @click.prevent="showAddingProgress.isVisible = false"  class="btn btn-sm btn-dark"> Stop</button> -->
                                                  </a-modal>
                                          </template>

                                         <div v-if='header.showRecevingReport' class="col p-0 mr-1">
                                              <a-input style="width: 100%" v-model='receivingReport' placeholder="Receiving Report Number" :disabled='isRecevingReportDisabled'/>
                                          </div>
                                          <div class="col p-0 pr-2">
                                              <a-auto-complete ref="supplierAutoCompleteInput"
                                                  style="width: 100%"
                                                  placeholder="Search supplier"
                                                  @select="selectSupplier"
                                                  :value="supplier.label"
                                                  @search="fetchSuppliers"
                                                  @focus="fetchSuppliers"
                                                  @blur="showSupplierModal"
                                                  :disabled='isSupplierDisabled'
                                                  :data-testid="'search-supplier-input'"
                                                  :allowClear='true'
                                              >
                                                  <template slot="dataSource">
                                                      <a-select-option v-for="s in suppliers" :key="'selectSupplier'+s.id.toString()" :text="s.name">{{s.name}}</a-select-option>
                                                  </template>
                                              </a-auto-complete>

                                          </div>
                                          <div class="col-auto p-0" v-if="showSupplierOptions && supplier.key > 0 || currentDocumentTypeCode =='ORIPOX' || currentDocumentTypeCode =='OTHPWS' ">
                                              <a-dropdown>
                                                  <a class="ant-dropdown-link" @click="e => e.preventDefault()">
                                                  <i class="fa fa-ellipsis-v btn-sm"> </i>
                                                  </a>
                                                  <a-menu slot="overlay">
                                                  <a-menu-item key="1">
                                                      <!-- <a class="btn btn-success btn-sm text-white">Open</a> -->
                                                      <a v-if="supplier.key > 0 || currentDocumentTypeCode=='ORIPOX' || currentDocumentTypeCode=='OTHPWS'" type="button" class="float-right btn btn-light btn-sm" @click.prevent="checkDocumentLine">Auto Populate Products By Supplier</a>
                                                  </a-menu-item>
                                                  </a-menu>
                                              </a-dropdown>
                                          </div>
                                      </div>
                                  </div>

                                  <!-- For this Site -->
                                  <div v-if='header.showForThisSite' class="col ml-1">
                                      <div class="row">
                                          <h4 class="btn-blockheading-small font-weight-normal">For This Site </h4>
                                          <div v-if="showApplyDocumentToOtherSitesButton()"
                                               class="float-right"
                                               style="flex-grow: 1">
                                              <button type="primary"
                                                        class="btn float-right ml-1 btn-primary btn-sm"
                                                        @click.prevent="toggleApplyDocumentToOtherSitesDrawer(true)">
                                                  Apply Document to Other Sites
                                              </button>
                                          </div>
                                      </div>
                                      <div class="row mt-2">
                                          <a-select
                                              labelInValue
                                              :value="forThisSite"
                                              placeholder="Select a site"
                                              style="width: 100%"
                                              :filterOption="false"
                                              @dropdownVisibleChange="fetchForThisSites"
                                              @change="selectForThisSite"
                                              :disabled="isForThisSiteDisabled"
                                              :notFoundContent="fetching ? undefined : null"
                                              >
                                              <a-spin v-if="fetching" slot="notFoundContent" size="small"/>
                                              <a-select-option v-for="s in forThisSites" :key="'forThisSites'+s.id.toString()">{{s.name}}</a-select-option>
                                          </a-select>
                                      </div>
                                  </div>

                                  <!-- Revenue Branch -->
                                  <div v-if='header.showRevenue' class="col ml-1">
                                      <div class="row"><h4 class="btn-blockheading-small font-weight-normal">Revenue Crediting</h4></div>
                                      <div class="row mt-2">
                                          <a-select
                                              v-model="revenue"
                                              placeholder="Select a Revenue site"
                                              style="width: 100%"
                                              @change="selectRevenue"
                                              :filterOption="filterOption"
                                              :notFoundContent="fetching ? undefined : null"
                                              :disabled="isRevenueDisabled"
                                          >
                                              <a-spin v-if="fetching" slot="notFoundContent" size="small"/>
                                              <a-select-option v-for="s in revenueOption" :key="s.key">{{s.value}}</a-select-option>
                                          </a-select>
                                      </div>
                                  </div>

                                  <!-- Requesting Branch -->
                                  <div v-if='header.showRequestingSite' class="col ml-1">
                                      <div class="row"><h4 class="btn-blockheading-small font-weight-normal">{{RequestingLabel}} Branch</h4></div>
                                      <div class="row mt-2">
                                          <a-select
                                              showSearch
                                              labelInValue
                                              :value="requestingSite"
                                              :placeholder="'Select a '+RequestingLabel+' site'"
                                              style="width: 100%"
                                              :filterOption="filterOption"
                                              @dropdownVisibleChange="handleSitesDropdownVisibleChange($event, 'requestingSite')"
                                              @change="selectRequestingSite"
                                              :notFoundContent="fetching ? undefined : null"
                                              :disabled="isRequestingSiteDisabled"
                                          >
                                              <a-spin v-if="fetching" slot="notFoundContent" size="small"/>
                                              <a-select-option v-for="s in requestingSites" :key="'selectRequestingSite'+s.id.toString()">{{s.name}}</a-select-option>
                                          </a-select>
                                      </div>
                                  </div>
                                  <!-- Party -->
                                  <div v-if='header.showParty' class="col">
                                      <div class="row"><h4 class="btn-blockheading-small font-weight-normal">Party</h4></div>
                                      <div class="row mt-2"> 
                                          <a-input style="width: 100%" v-model='party' placeholder="Party" :disabled='isPartyDisabled'/>
                                      </div>
                                  </div>

                                  <!-- Sublocation -->
                                  <div v-if='header.showSublocation' class="col">
                                      <div class="row"><h4 class="btn-blockheading-small font-weight-normal">Sublocation</h4></div>
                                      <div class="row mt-2">

                                          <a-select
                                          labelInValue
                                          :value="siteSublocation"
                                          placeholder="Select a sublocation"
                                          style="width: 100%"
                                          :filterOption="false"
                                          @dropdownVisibleChange="fetchPcountSublocations"
                                          @change="selectSiteSublocation"
                                          :notFoundContent="fetching ? undefined : null"
                                          :disabled='isSiteSublocationDisabled'
                                          >
                                              <a-spin v-if="fetching" slot="notFoundContent" size="small"/>
                                              <a-select-option v-for="s in sublocations" :key="'sublocations'+s.id.toString()">{{s.name}}</a-select-option>
                                          </a-select>


                                      </div>
                                  </div>

                                  <!-- SO DD SI -->
                                  <div v-if='header.showSublocationHeader' class="col mr-1">

                                      <!-- Label and Input, Site -->
                                      <div v-if='header.showSublocationSite' class="row">
                                          <div v-if='header.showSalesOrder' class="col p-0 mr-1"><h4 class="btn-blockheading-small font-weight-normal">Sales Order No</h4></div>
                                          <div v-if='header.showDeliveryDocument' class="col p-0 mr-1"><h4 class="btn-blockheading-small font-weight-normal">Delivery Document No</h4></div>
                                          <div v-if='header.showSublocationSite' class="col p-0 mr-1"><h4 class="btn-blockheading-small font-weight-normal">Site Name</h4></div>
                                      </div>
                                      <div class="row mt-2">
                                          <div v-if='header.showSalesOrder' class="col p-0 mr-1">
                                              <a-input style="width: 100%" v-model='salesOrder' placeholder="Sales Order Number" :disabled='isSalesOrderDisabled'/>
                                          </div>
                                          <div v-if='header.showDeliveryDocument' class="col p-0 mr-1">
                                              <a-input style="width: 100%" v-model='deliveryDocument' placeholder="Delivery Document Number" :disabled='isDeliveryDocumentDisabled'/>
                                          </div>
                                          <div v-if='header.showSublocationSite' class="col p-0 mr-1">
                                              <a-select
                                                  labelInValue
                                                  showSearch
                                                  style="width: 100%"
                                                  placeholder="Select a site"
                                                  :filterOption="filterOption"
                                                  @dropdownVisibleChange="handleDistributionSitesDropdownVisibleChange"
                                                  @change="selectDistributionSite"
                                                  :value="distributionSite"
                                                  :notFoundContent="fetching ? undefined : null"
                                                  :disabled='isDistributionSiteDisabled'
                                              >
                                                  <a-spin v-if="fetching" slot="notFoundContent" size="small"/>
                                                  <a-select-option v-for="s in distributionSites" :key="'sites1'+s.id.toString()">{{s.name}}</a-select-option>
                                              </a-select>
                                          </div>
                                      </div>

                                      <!-- Label and Input, Site -->
                                      <div class="row mt-2">
                                          <div v-if='header.showOrderSource' class="col p-0 mr-1"><h4 class="btn-blockheading-small font-weight-normal">Order Source</h4></div>
                                          <div v-if='header.showSublocationOrigin' class="col p-0 mr-1"><h4 class="btn-blockheading-small font-weight-normal">{{sublocationOriginLabel}}</h4></div>
                                          <div v-if='header.showSublocationDestination' class="col p-0 mr-1"><h4 class="btn-blockheading-small font-weight-normal">{{sublocationDestinationLabel}}</h4></div>
                                          <div v-if='header.showCustomer' class="col p-0"><h4 class="btn-blockheading-small font-weight-normal">Customer Name</h4></div>
                                          <div v-if='header.showSalesman' class="col p-0"><h4 class="btn-blockheading-small font-weight-normal">Salesman Name</h4></div>
                                      </div>
                                      <div class="row mt-2">
                                          <!-- Order Source -->
                                          <div v-if='header.showOrderSource' class="col p-0 mr-1">
                                              <a-select v-model='orderSource' placeholder='Order Source' style="width: 100%;" input-classes="form-control" :disabled="isOrderSourceDisabled">
                                                  <a-select-option v-for="s in orderSources" :key="s.toString()">{{s}}</a-select-option>
                                              </a-select>
                                          </div>
                                          <!-- Sublocation Origin -->
                                          <div v-if='header.showSublocationOrigin' class="col p-0 mr-1">
                                              <a-select
                                              labelInValue
                                              :value="originSublocation"
                                              placeholder="Select a sublocation"
                                              style="width: 100%"
                                              :filterOption="false"
                                              @dropdownVisibleChange="fetchSublocations"
                                              @change="selectOriginSublocation"
                                              :notFoundContent="fetching ? undefined : null"
                                              :disabled='isOriginSublocationDisabled'
                                              >
                                                  <a-spin v-if="fetching" slot="notFoundContent" size="small"/>
                                                  <a-select-option v-for="s in sublocations" :key="'sublocations1'+s.id.toString()">{{s.name}}</a-select-option>
                                              </a-select>
                                          </div>
                                          <!-- Sublocation Destination -->
                                          <div v-if='header.showSublocationDestination' class="col p-0 mr-1">
                                              <a-select
                                              labelInValue
                                              :value="destinationSublocation"
                                              placeholder="Select a sublocation"
                                              style="width: 100%"
                                              :filterOption="false"
                                              @dropdownVisibleChange="fetchSublocations"
                                              @change="selectDestinationSublocation"
                                              :notFoundContent="fetching ? undefined : null"
                                              :disabled='isDestinationSublocationDisabled'
                                              >
                                                  <a-spin v-if="fetching" slot="notFoundContent" size="small"/>
                                                  <a-select-option v-for="s in sublocations" :key="'sublocations2'+s.id.toString()">{{s.name}}</a-select-option>
                                              </a-select>
                                          </div>
                                          <!-- Customer -->
                                          <div v-if='header.showCustomer' class="col p-0 mr-1">
                                            <a-input-group compact class="si_customer_name">
                                                <a-auto-complete 
                                                placeholder="Search customer"
                                                class="si_customer_name_input" 
                                                @select="selectCustomer"
                                                @search="fetchCustomers" 
                                                @focus="fetchCustomers" 
                                                :value="customer.label" 
                                                :filter-option="autocompleteFilterOption" 
                                                :disabled='isCustomerDisabled'>
                                                  <template slot="dataSource">
                                                    <a-select-option v-for="c in customers" :key="'customers'+c.id.toString()" :text="c.name">{{c.name}}
                                                    </a-select-option>
                                                  </template>
                                                </a-auto-complete>
                                          
                                                <a-button class="si_customer_name_btn" @click.prevent="createCustomer()" :disabled="isCustomerCreateDisabled">
                                                  <a-icon style="margin-bottom: 3px" type="plus-circle" />
                                                </a-button>
                                            </a-input-group>
                                          </div>
                                          <!-- Salesman -->
                                          <div v-if='header.showSalesman' class="col p-0 mr-1">
                                              <a-input-group compact>
                                                  <a-auto-complete
                                                      style="width: 90%"
                                                      placeholder="Search salesman"
                                                      :filter-option="autocompleteFilterOption"
                                                      @select="selectSalesman"
                                                      :value="salesman.label"
                                                      @search="fetchSalesmen"
                                                      @focus="fetchSalesmen"
                                                      :disabled='isSalesmanDisabled'
                                                  >
                                                      <template slot="dataSource">
                                                          <a-select-option v-for="s in salesmen" :key="'salesman'+s.id.toString()" :text="s.name">{{s.name}}</a-select-option>
                                                      </template>
                                                  </a-auto-complete>
                                              </a-input-group>
                                          </div>
                                      </div>

                                       <!-- Label and Input, Customer Address -->
                                      <div class="row mt-2">
                                          <div v-if='header.showCustomer' class="col p-0"><h4 class="btn-blockheading-small font-weight-normal">Customer Address</h4></div>
                                          <div v-if='header.showCustomer' class="col p-0"><h4 class="btn-blockheading-small font-weight-normal">Customer Contact</h4></div>
                                      </div>
                                      <div class="row mt-2">
                                          <div v-if='header.showCustomer' class="col p-0 mr-1">
                                              <a-input style="width: 100%" v-model='customerAddress' placeholder="Customer Address" :disabled='true'/>
                                          </div>

                                          <div v-if='header.showCustomer' class="col p-0 mr-1">
                                              <a-input-group compact>
                                                  <a-select v-model="selectedCustomerContact" @select="selectCustomerContact" style="width: 30%">
                                                      <a-select-option value="Telephone">Telephone</a-select-option>
                                                      <a-select-option value="Mobile">Mobile</a-select-option>
                                                      <a-select-option value="Fax">Fax</a-select-option>
                                                      <a-select-option value="Email">Email</a-select-option>
                                                  </a-select>
                                                  <a-input style="width: 70%" v-model='activeCustomerContact' placeholder="Customer Contact" :disabled='true'/>
                                              </a-input-group>

                                          </div>
                                      </div>
                                  </div>
                              </div>

                              <!-- Additional Options, when header with record is Posted -->
                              <div v-if='documentStatus=="Posted"' class="row mt-2">
                                  <div class="col p-0">
                                      <h6 class="heading-small text-muted">{{currentDocumentTypeFriendlyCode}} Date</h6>
                                      <a-date-picker v-model='documentDate' @change="disabledDate" placeholder="Document Date" style="width: 100%" :disabled='true'/>
                                  </div>
                                  <div v-if="showTargetDate" class="col p-0 mx-2">
                                      <h6 v-if='currentDocumentTypeCode == "OTHPWS"' class="heading-small text-muted">Effectivity Date</h6>
                                      <h6 v-else class="heading-small text-muted">Target Date</h6>
                                      <a-date-picker v-model='targetDate' placeholder="Target Date" style="width: 100%" :disabled='true'/>
                                  </div>
                                  <div v-if="showCancellationDate" class="col p-0">
                                      <h6 class="heading-small text-muted">Cancellation Date</h6>
                                      <a-date-picker v-model='cancellationDate' placeholder="Cancellation Date" style="width: 100%" :disabled='true'/>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>

              <!-- Body -->
              <div v-if='!isHeaderOnly'>
                  <div v-if='showDocumentBodyHeader'>
                      <div v-if="documentStatus=='Saved' || documentStatus=='Upload Error'" class='mt-4'>
                          <base-dropdown class='' hidden>
                              <base-button slot="title" type="danger" class="dropdown-toggle btn-sm">
                                  {{productFormMode}} Product
                              </base-button>
                              <a v-for="productFormMode in productFormModeOptions" :key="'productFormModeOptions'+productFormMode.value" :value="productFormMode.value" class="dropdown-item" href="#" @click.prevent="changeProductFormMode(productFormMode.value)">{{productFormMode.label}}</a>
                          </base-dropdown>
                      </div>
                      <div v-else>
                              <h3 class='font-weight-bold mt-4'>{{productFormMode}} Products</h3>
                      </div>
                  </div>
                  <div v-else>
                      <h3 v-if="currentDocumentTypeCode=='OTHCNS'" class='font-weight-bold mt-4'>Physical Documents </h3>
                      <h3 v-else class='font-weight-bold mt-4'>Products </h3>
                  </div>

                  <div class="row mt-2">
                      <div class="col">
                          <div class="card shadow">
                              <div v-if='showDocumentBodyHeader'>
                                  <div v-if='productFormMode=="Add" && !HideDeleteAndAddProductButton && !isPhysicalCountV2ProductListLocked' class="card-body" style="background: #FAFAFA; border: 1px solid #E0E0E0;">
                                      <div class="row mb-2">
                                          <div class="col-auto">
                                              <base-dropdown :data-testid="'search-product-filter-dropdown'" v-model="formattedsearchFilter" >
                                                  <base-button slot="title" type="primary" class="dropdown-toggle">{{_.startCase(formattedsearchFilter)}}</base-button>
                                                  <a class="dropdown-item" :data-testid="'search-product-filter-barcode'" @click.prevent="changeSearchFilter('barcode')">Barcode</a>
                                                  <a class="dropdown-item" :data-testid="'search-product-filter-name'" @click.prevent="changeSearchFilter('name')">Name</a>
                                                  <a class="dropdown-item" :data-testid="'search-product-filter-stock'" @click.prevent="changeSearchFilter('stock_no')">Stock</a>
                                                  <!-- <a class="dropdown-item" @click.prevent="changeSearchFilter('code')">Code</a> -->
                                                  <a class="dropdown-item" :data-testid="'search-product-filter-reference-code'" @click.prevent="changeSearchFilter('reference_code')">Reference Code</a>
                                              </base-dropdown>
                                          </div>
                                          <div class="col-5">
                                              <!-- <form v-on:submit.prevent="onEnterScanner"> -->
                                                <!-- bryan -->
                                                  <autocomplete
                                                      ref="autocomplete"
                                                      :placeholder="placeholder"
                                                      :source="productEndpoint"
                                                      input-class="form-control"
                                                      :resultsFormatter='filterExistingProducts'
                                                      results-property="data"
                                                      :results-display="formattedDisplay"
                                                      :request-headers="authHeaders"
                                                      :data-testid="'search-product-input'"
                                                      @selected="getProduct"
                                                      @clear="clearProduct"
                                                      :disableInput='isProductSearchDisabled'
                                                      v-on:keyup.native.enter="onEnterScanner">
                                                  </autocomplete>
                                              <!-- </form> -->
                                          </div>

                                          <div class="col">
                                              <a-input addonBefore="Product Name" size="large" v-model="productName" :disabled='isProductNameDisabled' :maxLength="Number(100)" />
                                          </div>
                                          <div v-if='showFilteredBySupplier' class="col-auto pt-2 float-right">
                                              <a-checkbox :v-model='filteredBySupplier' @change='filteredBySupplierChange'>Filtered by supplier</a-checkbox>
                                          </div>
                                          <div v-else class="col-auto pt-2 float-right px-0">
                                              <base-dropdown class="nav-link float-right" position="right">
                                                  <div class="media align-items-center" slot="title">
                                                  <i class="fa fa-ellipsis-v float-right btn-sm" style='color: black;'></i>
                                                  </div>
                                                  <template>
                                                      <div class="dropdown-header noti-title">
                                                          <h6 class="text-overflow m-0">ACTIONS</h6>
                                                      </div>
                                                      <a v-if="(((documentStatus=='Saved' || documentStatus=='Upload Error' || documentStatus=='Upload terminated') && productFormMode == 'Add') || documentStatus == null) && !isPhysicalCountV2ProductListLocked" class="dropdown-item" @click.prevent="showDrawer('massAdd')">
                                                          <i class="fa fa-upload"></i>
                                                          <span>Import</span>
                                                      </a>
                                                      <a class="dropdown-item" v-if="['RELTRX', 'ORISOX'].includes(currentDocumentTypeCode)" @click="showScanningScreenModal()">
                                                          <i class="fas fa-barcode"></i>
                                                          <span>Scanning Screen</span>
                                                      </a>
                                                      <a v-if="(((documentStatus=='Saved' || documentStatus=='Upload Error' || documentStatus=='Upload terminated') && productFormMode == 'Add') || documentStatus == null) && !isPhysicalCountV2ProductListLocked && (currentDocumentTypeCode=='OTHTRA' || currentDocumentTypeCode=='OTHPCK')" class="dropdown-item" @click.prevent="showDrawer('massAddWithAllocation')">
                                                          <i class="fa fa-upload"></i>
                                                          <span>Import With Allocation</span>
                                                      </a>
                                                      <a class="dropdown-item" @click="exportCsvDocument()">
                                                          <i class="fas fa-file-csv"></i>
                                                          <span>Export CSV</span>
                                                      </a>
                                                      <a class="dropdown-item" @click="exportExcelDocument()">
                                                          <i class="fas fa-file-excel"></i>
                                                          <span>Export Excel Sheet</span>
                                                      </a>
                                                      <a class="dropdown-item" @click="exportWithAllocationDocument()">
                                                          <i class="fas fa-file-excel"></i>
                                                          <span>Export With Allocation</span>
                                                      </a>


                                                      <a class="dropdown-item" @click="exportWithAllocationDocumentFormatted()">
                                                          <i class="fas fa-file-excel"></i>
                                                          <span>Export With Allocation (display per site name)</span>
                                                      </a>
                                                      
                                                      <a class="dropdown-item" v-if="['ORIPOX', 'ORITRQ'].includes(currentDocumentTypeCode) && autoRepMinMaxAccess == 1" @click="getMinMaxProducts()">
                                                          <i class="fas fa-gears"></i>
                                                          <span>Auto-Rep by Min/Max</span>
                                                      </a>

                                                      <a class="dropdown-item" v-if="['ORIPOX', 'ORITRQ'].includes(currentDocumentTypeCode) && autoRepOfftakeAccess == 1" @click="getOffTakeProducts()">
                                                          <i class="fas fa-shopping-cart"></i>
                                                          <span>Auto-Rep by Offtake</span>
                                                      </a>

                                                      <a class="dropdown-item" @click="showCustomizeListDrawer()">
                                                          <i class="fas fa-bars"></i>
                                                          <span>Customize List</span>
                                                      </a>
                                                      <a class="dropdown-item" @click="showSortDrawer('sort')">
                                                          <i class="fas fa-sort"></i>
                                                          <span>Sort</span>
                                                      </a>
                                                      <a v-if="documentStatus!='Fulfilled' || documentStatus!='Voided'" class="dropdown-item" @click="refreshInventory()">
                                                          <i class="fas fa-sync-alt"></i>
                                                          <span>Refresh Inventory</span>
                                                      </a>
                                                      <a v-if="selectedDocumentLines.length > 0 && selectedDocumentLines[0].is_require_lotcode" class="dropdown-item" @click.prevent="showLotCodeExpiry(selectedDocumentLines)">
                                                          <i class="fas fa-hourglass-end"></i>
                                                          <span>Lot Code and Expiry</span>
                                                      </a>
                                                  </template>
                                              </base-dropdown>
                                          </div>
                                      </div>
                                      <div class="row pt-2">
                                          <div v-if='showQuantity' class="col">
                                              <h6 class="heading-small text-muted text-nowrap">Quantity</h6>
                                              <a-input :data-testid="'quantity-input'" v-model='quantity' :maxLength="Number(8)" onkeypress='return event.charCode >= 46 && event.charCode <= 57' @change="calculateSelectedProduct" input-classes="form-control" :disabled="isDocumentLineFormDisabled || isPhysicalCountV2QuantityEditLocked"/>
                                          </div>
                                          <div v-if='showActualYield' class="col">
                                              <a-tooltip>
                                                  <template slot="title">
                                                      Tolerance Quantity: {{tolerance_quantity}}
                                                  </template>
                                                  <h6 class="heading-small text-muted text-nowrap">Actual Yield Quantity</h6>
                                                  <a-input v-model='actual_yield' :maxLength="Number(8)" onkeypress='return event.charCode >= 46 && event.charCode <= 57' input-classes="form-control" :disabled="isDocumentLineFormDisabled || isPhysicalCountV2QuantityEditLocked"/>
                                              </a-tooltip>
                                          </div>
                                          <div class="col">
                                              <h6 class="heading-small text-muted text-nowrap">Unit</h6>
                                              <a-select
                                                  labelInValue
                                                  :value="productComposition"
                                                  style="width: 100%;"
                                                  :filterOption="false"
                                                  @dropdownVisibleChange="fetchProductCompositions"
                                                  @change="selectProductComposition"
                                                  :notFoundContent="fetching ? undefined : null"
                                                  :disabled="isDocumentLineFormDisabled"
                                                  :data-testid="'unit-select'"
                                              >
                                                  <a-spin v-if="fetching" slot="notFoundContent" size="small"/>
                                                  <a-select-option v-for="s in productCompositions" :key="'productCompositions'+s.key.toString()">{{s.label}}</a-select-option>
                                              </a-select>
                                          </div>

                                          <template v-if='showPwsCosts'>
                                              <div class="col">
                                                  <h6 class="heading-small text-muted text-nowrap">Old Ordering</h6>
                                                  <a-input min='0' v-model='oldOrdering' :maxLength="Number(8)" :type="costInputTypeAccessRights()" onkeypress='return event.charCode >= 46 && event.charCode <= 57' input-classes="form-control" :disabled="true"/>
                                              </div>
                                              <div class="col">
                                                  <h6 class="heading-small text-muted text-nowrap">Old Landed</h6>
                                                  <a-input min='0' v-model='oldLanded' :maxLength="Number(8)" :type="costInputTypeAccessRights()" onkeypress='return event.charCode >= 46 && event.charCode <= 57' input-classes="form-control" :disabled="true"/>
                                              </div>
                                              <div class="col">
                                                  <h6 class="heading-small text-muted text-nowrap">Old Price</h6>
                                                  <a-input min='0' v-model='oldRetailPrice' :maxLength="Number(8)" :type="priceInputTypeAccessRights()" onkeypress='return event.charCode >= 46 && event.charCode <= 57' input-classes="form-control" :disabled="true"/>
                                              </div>
                                              <div class="col">
                                                  <h6 class="heading-small text-muted text-nowrap">New Ordering</h6>
                                                  <a-input min='0' v-model='newOrdering' :maxLength="Number(8)" :type="costInputTypeAccessRights()" onkeypress='return event.charCode >= 46 && event.charCode <= 57' input-classes="form-control" :disabled="isDocumentLineFormDisabled  || disableCostAccessRightsValidation()"/>
                                              </div>
                                              <div class="col">
                                                  <h6 class="heading-small text-muted text-nowrap">New Landed</h6>
                                                  <a-input min='0' v-model='newLanded' :maxLength="Number(8)" :type="costInputTypeAccessRights()" onkeypress='return event.charCode >= 46 && event.charCode <= 57' input-classes="form-control" @change="calculatePwsCosts('newLanded')" :disabled="isDocumentLineFormDisabled  || disableCostAccessRightsValidation()"/>
                                              </div>
                                              <div class="col">
                                                  <h6 class="heading-small text-muted text-nowrap">New Price</h6>
                                                  <a-input min='0' v-model='newRetailPrice' :maxLength="Number(8)" :type="priceInputTypeAccessRights()" onkeypress='return event.charCode >= 46 && event.charCode <= 57' input-classes="form-control" @change="calculatePwsCosts('newPrice')" :disabled="isDocumentLineFormDisabled  || disablePriceAccessRightsValidation()"/>
                                              </div>
                                              <div class="col">
                                                  <h6 class="heading-small text-muted text-nowrap">Mark Up %</h6>
                                                  <a-input min='0' v-model='markUp' :maxLength="Number(8)" onkeypress='return event.charCode >= 46 && event.charCode <= 57' input-classes="form-control" @change="calculatePwsCosts('markUp')" :disabled="isDocumentLineFormDisabled"/>
                                              </div>
                                          </template>

                                          <div v-if='showUnitCost' class="col">
                                              <h6 class="heading-small text-muted text-nowrap">{{productPriceChoice.split('_').pop()}}</h6>
                                              <a-input min='0' :data-testid="'price-choice-input'" v-model='unitCost' step="0.0001" :maxLength="Number(8)" onkeypress='return event.charCode >= 46 && event.charCode <= 57' input-classes="form-control" @change="calculateCost" :disabled="isUnitCostDisabled() || accessRightsDisableValidation()" :type="accessRightsInputTypeValidation()"/>
                                          </div>
                                          <div v-if='showDiscount' class="col">
                                              <h6 class="heading-small text-muted text-nowrap">Discount</h6>
                                              <a-select mode="tags" :data-testid="'discount-input'" :maxTagCount='2'  maxTagPlaceholder='...' v-model='discountText' style="width: 100%;" @change="calculateSelectedProduct" input-classes="form-control" :disabled="isDocumentLineFormDisabled"></a-select>
                                          </div>
                                          <div v-if='showUnitNetCost' class="col">
                                              <h6 class="heading-small text-muted text-nowrap">Unit Net Cost</h6>
                                              <a-input  :data-testid="'unit-net-cost-input'" v-model='unitNetCost' :type="accessRightsInputTypeValidation()" input-classes="form-control" disabled/>
                                          </div>
                                          <div v-if='showSubtotal' class="col d-flex align-items-end" style="border-left: 1px solid #E0E0E0;">
                                              <span class="mr-auto font-weight-bold h3 ">Subtotal: {{this.accessRightsMaskValidation(subTotal)}}</span>
                                          </div>

                                          <div class="col d-flex align-items-end" v-if="selectedDocumentLines && selectedDocumentLines.length > 0 && productName == ''">
                                              <base-dropdown v-if="selectedDocumentLines.length == 1" class="nav-link pr-2 float-right" position="right">
                                                  <div class="media align-items-center" slot="title">
                                                      <i class="fa fa-ellipsis-v float-right ml-2 btn-sm" style='color: black;'></i>
                                                  </div>
                                                  <template>
                                                      <div class="dropdown-header noti-title">
                                                          <h6 class="text-overflow m-0">ACTIONS</h6>
                                                      </div>
                                                      <div class="dropdown-item" @click.prevent="showStockCard(selectedDocumentLines)">
                                                           <i class="fas fa-layer-group"></i>
                                                          <span>View Stock Card</span>
                                                      </div>
                                                      <div v-if="selectedDocumentLines[0].product_type == 'S'" class="dropdown-item" @click.prevent="showSerialization(selectedDocumentLines)">
                                                          <i class="fas fa-layer-group"></i>
                                                          <span>Enter/View Serial Number</span>
                                                      </div>
                                                      <div v-if='allowSublocationAllocation' class="dropdown-item" @click.prevent="showSublocationAllocation(selectedDocumentLines)">
                                                          <i class="fas fa-stream"></i>
                                                          <span>Sublocation Allocation</span>
                                                      </div>
                                                      <div v-if='allowSiteAllocation' class="dropdown-item" @click.prevent="showSiteAllocation(selectedDocumentLines)">
                                                          <i class="fas fa-stream"></i>
                                                          <span>Site Allocation</span>
                                                      </div>
                                                      <div v-if="selectedDocumentLines.length > 0 && selectedDocumentLines[0].is_require_lotcode" class="dropdown-item" @click.prevent="showLotCodeExpiry(selectedDocumentLines)">
                                                          <i class="fas fa-hourglass-end"></i>
                                                          <span>Lot Code and Expiry</span>
                                                      </div>
                                                      <div class="dropdown-item" @click.prevent="duplicateDocumentLines" v-if="documentStatus!='Confirmed' && documentStatus!='Posted' &&  documentStatus!='Voided' && !isPhysicalCountV2ProductListLocked">
                                                          <i class="fas fa-regular fa-copy"></i>
                                                         <span>Duplicate Line</span>
                                                     </div>
                                                  </template>
                                              </base-dropdown>
                                              <button type="button" class="btn btn-danger btn-block align-bottom" @click="mass_delete_line()" :disabled="isPhysicalCountV2ProductListLocked">Delete</button>
                                          </div>
                                          <div class="col d-flex align-items-end" v-else>
                                              <a-popconfirm
                                                  title="Input quantity is more than the available quantity, do you want to proceed?"
                                                  :visible="addProductConfirmationVisible"
                                                  ok-text="Yes"
                                                  cancel-text="Cancel"
                                                  @visibleChange="handleAddProductVisibleChange"
                                                  @confirm="addProduct"
                                                  @cancel="addProductCancel"
                                                  :disabled="isDocumentLineFormDisabled || isPhysicalCountV2ProductListLocked"
                                              >
                                                  <a :data-testid="'add-product-button'" type="button" class="btn btn-primary btn-block align-bottom text-white mt-2" :class="{ disabled: isPhysicalCountV2ProductListLocked }">+ Add Product</a>
                                              </a-popconfirm>
                                          </div>
                                      </div>

                                      <div v-if="rewardCode != null" class="row mt-3">
                                          <div class="col-auto float-right">
                                              <small><span class="fa fa-info-circle text-blue"/> &nbsp; Promo Applied - {{promoName}} ({{rewardCode}})</small>
                                          </div>
                                      </div>

                                  </div>
                                  <div v-else class="card-body" style="background: #FAFAFA; border: 1px solid #E0E0E0;">
                                      <div class="row">
                                          <div class="col">
                                              <a-input-search size='large' v-on:keyup="searchProducts" @search="searchProducts" :placeholder="placeholder" v-model='productSearchInput'>
                                                  <a-select slot="addonBefore" defaultValue="Barcode" @select="changeSearchFilter">
                                                      <a-select-option value='barcode'>Barcode</a-select-option>
                                                      <a-select-option value='product_name'>Name</a-select-option>
                                                      <a-select-option value='stock_no'>Stock No</a-select-option>
                                                      <a-select-option value='ref_code'>Ref Code</a-select-option>
                                                      <!-- <a-select-option value='product_id'>Code</a-select-option> -->
                                                  </a-select>
                                              </a-input-search>
                                          </div>

                                          <div class="col-auto d-flex align-items-end justify-content-end p-0" >
                                              <base-dropdown  class="nav-link pr-2 float-right" position="right">
                                                  <div class="media align-items-center" slot="title">
                                                  <i class="fa fa-ellipsis-v float-right btn-sm" style='color: black;'></i>
                                                  </div>
                                                  <template>
                                                      <div class="dropdown-header noti-title">
                                                          <h6 class="text-overflow m-0">ACTIONS</h6>
                                                      </div>
                                                      <a v-if="selectedDocumentLines.length == 1" class="dropdown-item" @click.prevent="showStockCard(selectedDocumentLines)">
                                                          <i class="fas fa-layer-group"></i>
                                                          <span>View Stock Card</span>
                                                      </a>
                                                      <a v-if="selectedDocumentLines.length == 1 && selectedDocumentLines[0].product_type == 'S'" class="dropdown-item" @click.prevent="showSerialization(selectedDocumentLines)">
                                                          <i class="fas fa-layer-group"></i>
                                                          <span>Enter/View Serial Number</span>
                                                      </a>
                                                      <a v-if='allowSublocationAllocation && selectedDocumentLines.length == 1' class="dropdown-item" @click.prevent="showSublocationAllocation(selectedDocumentLines)">
                                                          <i class="fas fa-stream"></i>
                                                          <span>Sublocation Allocation</span>
                                                      </a>
                                                      <div v-if='allowSiteAllocation && selectedDocumentLines.length == 1' class="dropdown-item" @click.prevent="showSiteAllocation(selectedDocumentLines)">
                                                          <i class="fas fa-stream"></i>
                                                          <span>Site Allocation</span>
                                                      </div>
                                                      <a v-if="(((documentStatus=='Saved' || documentStatus=='Upload Error' || documentStatus=='Upload terminated') && productFormMode == 'Add') || documentStatus == null) && !isPhysicalCountV2ProductListLocked && (currentDocumentTypeCode=='OTHTRA' || currentDocumentTypeCode=='OTHPCK')" class="dropdown-item" @click.prevent="showDrawer('massAddWithAllocation')">
                                                          <i class="fa fa-upload"></i>
                                                          <span>Import With Allocation</span>
                                                      </a>
                                                      <a class="dropdown-item" @click="exportCsvDocument()">
                                                          <i class="fas fa-file-csv"></i>
                                                          <span>Export CSV</span>
                                                      </a>
                                                      <a class="dropdown-item" @click="exportExcelDocument()">
                                                          <i class="fas fa-file-excel"></i>
                                                          <span>Export Excel Sheet</span>
                                                      </a>
                                                      <a class="dropdown-item" @click="exportWithAllocationDocument()">
                                                          <i class="fas fa-file-excel"></i>
                                                          <span>Export With Allocation</span>
                                                      </a>
                                                      <a class="dropdown-item" @click="exportWithAllocationDocumentFormatted()">
                                                          <i class="fas fa-file-excel"></i>
                                                          <span>Export With Allocation Formatted (With Site Name)</span>
                                                      </a>
                                                      <a class="dropdown-item" @click="showCustomizeListDrawer()">
                                                          <i class="fas fa-bars"></i>
                                                          <span>Customize List</span>
                                                      </a>
                                                      <a class="dropdown-item" @click="showSortDrawer()">
                                                          <i class="fas fa-sort"></i>
                                                          <span>Sort</span>
                                                      </a>
                                                      <a v-if="documentStatus!='Fulfilled' || documentStatus!='Voided'" class="dropdown-item" @click="refreshInventory()">
                                                          <i class="fas fa-sync-alt"></i>
                                                          <span>Refresh Inventory</span>
                                                      </a>
                                                      <a v-if="selectedDocumentLines.length > 0 && selectedDocumentLines[0].is_require_lotcode" class="dropdown-item" @click.prevent="showLotCodeExpiry(selectedDocumentLines)">
                                                          <i class="fas fa-hourglass-end"></i>
                                                          <span>Lot Code and Expiry</span>
                                                      </a>
                                                      <div class="dropdown-item" @click.prevent="duplicateDocumentLines" v-if="documentStatus!='Confirmed' && documentStatus!='Posted' &&  documentStatus!='Voided' && !isPhysicalCountV2ProductListLocked">
                                                          <i class="fas fa-regular fa-copy"></i>
                                                         <span>Duplicate Line</span>
                                                     </div>
                                                  </template>
                                              </base-dropdown>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                              <div v-if="currentDocumentTypeCode=='OTHCNS' && documentStatus!='Posted' &&  documentStatus!='Voided'" class="card-body" style="background: #FAFAFA; border: 1px solid #E0E0E0;">
                                  <div class="row mb-2">
                                      <div class="col-auto">
                                          <base-dropdown  v-model="formattedsearchFilter" >
                                              <base-button slot="title" type="primary" class="dropdown-toggle">{{_.startCase(formattedsearchFilter)}}</base-button>
                                              <a class="dropdown-item" @click.prevent="changeSearchFilter('document_no')">Document No</a>
                                              <a class="dropdown-item" @click.prevent="changeSearchFilter('document_id')">Document ID</a>
                                          </base-dropdown>
                                      </div>
                                      <div class="col-4">
                                          <autocomplete
                                              ref="autocomplete"
                                              :placeholder="placeholder"
                                              :source="documentEndpoint"
                                              input-class="form-control"
                                              :resultsFormatter='filterExistingDocuments'
                                              results-property="data"
                                              :results-display="formattedDocumentDisplay"
                                              :request-headers="authHeaders"
                                              @selected="getDocument"
                                              @clear="clearDocument">
                                          </autocomplete>
                                      </div>
                                      <div class="col">
                                          <a-input addonBefore="Document ID" size="large" v-model="documentID" :disabled='isProductNameDisabled' :maxLength="Number(100)" />
                                      </div>
                                      <div class="col-auto" v-if="selectedDocumentLines && selectedDocumentLines.length > 0">
                                          <button type="button" class="btn btn-danger btn-block align-bottom" @click="mass_delete_document_line()" >Delete</button>
                                      </div>
                                      <div class="col-auto" v-else>
                                          <a-popconfirm
                                              title="are you sure?"
                                              :visible="addPCountDocumentConfirmationVisible"
                                              ok-text="Yes"
                                              cancel-text="Cancel"
                                              @visibleChange="handleAddDocumentVisibleChange"
                                              @confirm="addPCount"
                                              @cancel="addPCountCancel"
                                          >
                                              <a type="button" class="btn btn-primary btn-block align-bottom text-white">+ Add Physical Documents</a>
                                          </a-popconfirm>
                                      </div>
                                      <div class="col-auto pt-2 float-right px-0">
                                          <base-dropdown class="nav-link float-right" position="right">
                                              <div class="media align-items-center" slot="title">
                                              <i class="fa fa-ellipsis-v float-right btn-sm" style='color: black;'></i>
                                              </div>
                                              <template>
                                                  <div class="dropdown-header noti-title">
                                                      <h6 class="text-overflow m-0">ACTIONS</h6>
                                                  </div>
                                                  <a class="dropdown-item" @click="exportCsvDocument()">
                                                      <i class="fas fa-file-csv"></i>
                                                      <span>Export CSV</span>
                                                  </a>
                                                  <a class="dropdown-item" @click="exportExcelDocument()">
                                                      <i class="fas fa-file-excel"></i>
                                                      <span>Export Excel Sheet</span>
                                                  </a>
                                                  <div class="dropdown-item" @click.prevent="viewCountSetDocumentLines()">
                                                          <i class="fas fa-layer-group"></i>
                                                      <span>View Document Lines</span>
                                                  </div>
                                                  <a v-if="documentStatus!='Fulfilled' || documentStatus!='Voided'" class="dropdown-item" @click="refreshInventory()">
                                                      <i class="fas fa-sync-alt"></i>
                                                      <span>Refresh Inventory</span>
                                                  </a>
                                              </template>
                                          </base-dropdown>
                                      </div>
                                  </div>
                              </div>

                              <div v-if='productFormMode=="Add" && !HideDeleteAndAddProductButton && !isPhysicalCountV2ProductListLocked' class="row mt-4 ml-2 mr-2">
                                  <div class="col-auto">
                                      <base-dropdown v-model="formattedsearchFilterAddedProduct" >
                                          <base-button slot="title" type="primary" class="dropdown-toggle">{{_.startCase(formattedsearchFilterAddedProduct)}}</base-button>
                                          <a class="dropdown-item" @click.prevent="changesearchFilterAddedProduct('barcode')">Barcode</a>
                                          <a class="dropdown-item" @click.prevent="changesearchFilterAddedProduct('name')">Name</a>
                                          <a class="dropdown-item" @click.prevent="changesearchFilterAddedProduct('stock_no')">Stock</a>
                                          <!-- <a class="dropdown-item" @click.prevent="changesearchFilterAddedProduct('code')">Code</a> -->
                                          <a class="dropdown-item" @click.prevent="changesearchFilterAddedProduct('ref_code')">Reference Code</a>
                                      </base-dropdown>
                                  </div>
                                  <div class="col">
                                      <a-input-search size="large" v-on:keyup="searchAddedProducts" @search="searchAddedProducts" :placeholder="addedProductPlaceholder" v-model='addedProductSearchInput'/>
                                  </div>

                                  <div class="col-auto pt-2 float-right px-0">
                                      <base-dropdown class="nav-link float-right" position="right">
                                          <div class="media align-items-center" slot="title">
                                          <i class="fa fa-ellipsis-v float-right btn-sm" style='color: black;'></i>
                                          </div>
                                          <template>
                                              <a class="dropdown-item" @click="showCustomizeListDrawer()">
                                                  <i class="fas fa-bars"></i>
                                                  <span>Customize List</span>
                                              </a>
                                          </template>
                                      </base-dropdown>
                                  </div>
                              </div>

                              <div class="card-body" style="background: #FFFFFF; min-height: 40vh;">
                                  <!-- S3 Import Loading Indicator -->
                                  <div v-show="isS3Importing" class="text-center py-5" style="min-height: 30vh; display: flex; flex-direction: column; align-items: center; justify-content: center;">
                                      <a-spin size="large" />
                                      <p class="mt-3 text-muted" style="font-size: 14px;">
                                          <i class="fas fa-cloud-upload-alt text-blue mr-1"></i>
                                          S3 import is in progress. Please wait...
                                      </p>
                                      <p class="text-muted" style="font-size: 12px;">
                                          Document lines will appear once the import is complete.
                                      </p>
                                  </div>
                                  <div v-show="!isS3Importing" class="table-responsive pt-2">
                                      <VueTabulator ref="tabulator"
                                          v-model="data"
                                          :options="options"
                                          @cell-edited="tabulatorCellEdit"/>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>

              <!-- Summary -->
              <h3 class='font-weight-bold mt-4'>Summary</h3>
              <div class="row mt-2">
                  <div class="col">
                      <div class="card shadow">
                          <div class="card-body">


                              <div v-if='showTotalQuantity' class="row">
                                  <div class="col">
                                      <span class="mr-auto h2 font-weight-bold">Total Quantity: {{formatMyNumber(totalQuantity,0)}}</span>
                                  </div>

                                  <div v-if="showVatExclusiveCheckbox && showVatExclusiveCheckboxConfig" class="col d-flex align-items-end" style="border-left: 1px solid #E0E0E0;">
                                      <base-checkbox :data-testid="'vat-exclusive-checkbox'" :checked="vatExclusiveCheckbox" @click="toggleVatExclusive">Show price and discount exclusive of VAT</base-checkbox>
                                  </div>
                              </div>

                              <hr v-if='showTotalQuantity' class='my-3'>

                              <div v-if='showSummaryCalculation && ((document_config!=null && !document_config.document_type_settings.additionalEditorBehaviorCheckboxes.termsAndDiscount) || ["ORISOX", "RELDDE", "OTHSIN"].includes(currentDocumentTypeCode))' class="row pb-1">
                                  <div class="col" v-if="showHeaderDiscount">
                                      <h6 class="heading-small text-muted">Header Discount</h6>
                                      <a-select mode="tags" :maxTagCount='5'  maxTagPlaceholder='...' v-model='headerDiscount' placeholder='Discount' style="width: 100%;" @change="onHeaderDiscountChange" input-classes="form-control" :disabled="isHeaderDiscountDisabled"></a-select>
                                  </div>
                                  <div class="col" v-if="showSupportDiscount">
                                      <h6 class="heading-small text-muted">Supports Discount</h6>
                                      <a-select mode="tags" :maxTagCount='5'  maxTagPlaceholder='...' v-model='supportDiscount'  @change="onSupportDiscountChange" placeholder='Discount' style="width: 100%;" input-classes="form-control" :disabled="isSupportsDiscountDisabled"></a-select>
                                  </div>
                              </div>

                              <div v-if='showSummaryCalculation' class="row pb-4">
                                  <div class="col">
                                      <h6 class="heading-small text-muted">Gross Amount
                                      <small v-if="currencyRate > 0 && showConversionRate"> {{currencyDetails.code}} {{ (grossAmountDisplay / currencyRate).toFixed(decimalPlaces) }}</small> </h6>
                                      <small v-if="currencyRate <= 0 && showConversionRate && isCurrencyToPhp"> {{currencyDetails.code || 'PHP'}} {{ (grossAmountDisplay * (documentDetails.currency_rate == null || documentDetails.currency_rate == undefined || documentDetails.currency_rate == 0 ? supplierDetails.currency_rate : documentDetails.currency_rate)).toFixed(decimalPlaces) }}</small> </h6>
                                      <a-input placeholder="0.00" v-model='grossAmountDisplay' style="width: 100%; display:none;" :disabled='true'/>
                                      <h3>{{formatMyNumber(grossAmountDisplay, decimalPlaces, 'grossAmountDisplay')}}</h3>
                                  </div>
                                  <div class="col">
                                      <h6 class="heading-small text-muted">Item Discount
                                      <small v-if="currencyRate > 0 && showConversionRate"> {{currencyDetails.code}} {{ (itemDiscount / currencyRate).toFixed(decimalPlaces) }}</small> </h6>
                                      <small v-if="currencyRate <= 0 && showConversionRate && isCurrencyToPhp"> {{currencyDetails.code || 'PHP'}} {{ (itemDiscount * (documentDetails.currency_rate == null || documentDetails.currency_rate == undefined || documentDetails.currency_rate == 0 ? supplierDetails.currency_rate : documentDetails.currency_rate)).toFixed(decimalPlaces) }}</small> </h6>
                                      <a-input placeholder="0.00" v-model='itemDiscount' style="width: 100%; display:none;" :disabled='true'/>
                                      <h3>{{formatMyNumber(itemDiscount, decimalPlaces)}}</h3>
                                  </div>
                                  <div class="col" v-if="document_config!=null && !document_config.document_type_settings.additionalEditorBehaviorCheckboxes.termsAndDiscount">
                                      <h6 class="heading-small text-muted">Overall Discount</h6>
                                      <a-input placeholder="0.00" v-model='overallDiscount' style="width: 100%; display:none;" :disabled='true'/>
                                      <h3>{{formatMyNumber(overallDiscount, decimalPlaces)}}</h3>
                                  </div>
                                  <div class="col">
                                      <h6 class="heading-small text-muted">Net Amount
                                      <small v-if="currencyRate > 0 && showConversionRate"> {{currencyDetails.code}} {{ (netAmountDisplay / currencyRate).toFixed(decimalPlaces) }}</small> </h6>
                                      <small v-if="currencyRate <= 0 && showConversionRate  && isCurrencyToPhp"> {{currencyDetails.code || 'PHP'}} {{ (netAmountDisplay * (documentDetails.currency_rate == null || documentDetails.currency_rate == undefined || documentDetails.currency_rate == 0 ? supplierDetails.currency_rate : documentDetails.currency_rate)).toFixed(decimalPlaces) }}</small> </h6>
                                      <a-input placeholder="0.00" v-model='netAmountDisplay' style="width: 100%; display:none;" :disabled='true'/>
                                      <h3>{{formatMyNumber(netAmountDisplay, decimalPlaces)}}</h3>
                                  </div>
                                  <div class="col" v-if='vatExclusiveCheckbox || displayVatAmount'>
                                      <h6 class="heading-small text-muted">VAT Amount
                                      <small v-if="currencyRate > 0 && showConversionRate"> {{currencyDetails.code}} {{ (vatAmount / currencyRate).toFixed(decimalPlaces) }}</small></h6>
                                      <small v-if="currencyRate <= 0 && showConversionRate && isCurrencyToPhp"> {{currencyDetails.code || 'PHP'}} {{ (vatAmount * (documentDetails.currency_rate == null || documentDetails.currency_rate == undefined || documentDetails.currency_rate == 0 ? supplierDetails.currency_rate : documentDetails.currency_rate)).toFixed(decimalPlaces) }}</small></h6>
                                      <a-input placeholder="0.00" v-model='vatAmount' style="width: 100%; display:none;" :disabled='true'/>
                                      <h3>{{formatMyNumber(vatAmount, decimalPlaces)}}</h3>
                                  </div>
                                  <div class="col" v-if="displayNetAmountWOVat">
                                      <h6 class="heading-small text-muted">{{displayNetAmountWOVatLabel}}
                                      <small v-if="currencyRate > 0 && showConversionRate"> {{currencyDetails.code}} {{ (netAmountWithoutTax / currencyRate).toFixed(decimalPlaces) }}</small> </h6>
                                      <small v-if="currencyRate <= 0 && showConversionRate  && isCurrencyToPhp"> {{currencyDetails.code || 'PHP'}} {{ (netAmountWithoutTax * (documentDetails.currency_rate == null || documentDetails.currency_rate == undefined || documentDetails.currency_rate == 0 ? supplierDetails.currency_rate : documentDetails.currency_rate)).toFixed(decimalPlaces) }}</small> </h6>
                                      <a-input placeholder="0.00" v-model='netAmountWithoutTax' style="width: 100%; display:none;" :disabled='true'/>
                                      <h3>{{formatMyNumber(netAmountWithoutTax, decimalPlaces)}}</h3>
                                  </div>
                                  <div class="col" v-if="vatExclusiveCheckbox && !(currentDocumentTypeCode == 'ORIPOX' && (party_tax_type == 'N' || party_tax_type == 'X'))">
                                      <h6 class="heading-small text-muted">Total with VAT
                                      <small v-if="currencyRate > 0 && showConversionRate"> {{currencyDetails.code}} {{ (totalWithVat / currencyRate).toFixed(decimalPlaces) }}</small></h6>
                                      <small v-if="currencyRate <= 0 && showConversionRate && isCurrencyToPhp"> {{currencyDetails.code || 'PHP'}} {{ (totalWithVat * (documentDetails.currency_rate == null || documentDetails.currency_rate == undefined || documentDetails.currency_rate == 0 ? supplierDetails.currency_rate : documentDetails.currency_rate)).toFixed(decimalPlaces) }}</small></h6>
                                      <a-input placeholder="0.00" v-model='totalWithVat' style="width: 100%; display:none;" :disabled='true'/>
                                      <h3>{{formatMyNumber(totalWithVat, decimalPlaces)}}</h3>
                                  </div>
                              </div>
                              <span v-if='documentStatus!="Posted"' class="h4 font-weight-bold">Document Date</span>
                              <div v-if='documentStatus!="Posted"' class="row pt-1">
                                  <div class="col">
                                      <h6 class="heading-small text-muted">{{currentDocumentTypeFriendlyCode}} Date</h6>
                                      <a-date-picker v-model='documentDate' :data-testid="'document-date-input'" @change="changeDate" placeholder="Document Date" style="width: 100%" :disabled='isDocumentDateDisabled'/>
                                  </div>
                                  <div v-if="showTargetDate" class="col">
                                      <h6 v-if='currentDocumentTypeCode == "OTHPWS"' class="heading-small text-muted">Effectivity Date</h6>
                                      <h6 v-else class="heading-small text-muted">Target Date</h6>
                                      <a-date-picker :data-testid="'target-date-input'" v-model='targetDate' @change="()=>{isEditing = true}" placeholder="Target Date" style="width: 100%" :disabled='isTargetDateDisabled'/>
                                  </div>
                                  <div v-if="showCancellationDate" class="col">
                                      <h6 class="heading-small text-muted">Cancellation Date</h6>
                                      <a-date-picker :data-testid="'cancellation-date-input'" v-model='cancellationDate' @change="()=>{isEditing = true}" placeholder="Cancellation Date" style="width: 100%" :disabled='isCancellationDateDisabled'/>
                                  </div>
                              </div>

                          </div>
                      </div>
                  </div>
              </div>

              <div class="d-flex justify-content-center mt-4">
                  <button type="button" class="btn btn-sm btn-outline-secondary" @click='showAdvancedInfoDiv' >
                      Advanced Information {{showAdvancedInfo? '↟' : '↡'}}
                  </button>
              </div>

              <h3 v-if='showAdvancedInfo' class='font-weight-bold'>Advanced Info</h3>
              <div v-if='showAdvancedInfo' class="row mt-2 advanced-info">
                  <div class="col">
                      <div class="card shadow">
                          <div class="card-body">
                              <div class="row pb-4">
                                  <div class="col" v-if="document_config!=null && !document_config.document_type_settings.additionalEditorBehaviorCheckboxes.termsAndDiscount">
                                      <h6 class="heading-small text-muted">Terms</h6>
                                      <a-select
                                              labelInValue
                                              :value="paymentTerm"
                                              placeholder="Select a payment term"
                                              style="width: 100%"
                                              :filterOption="false"
                                              @dropdownVisibleChange="fetchPaymentTerms"
                                              @change="selectPaymentTerm"
                                              :notFoundContent="fetching ? undefined : null"
                                              :disabled='isPaymentTermDisabled'
                                          >
                                          <a-spin v-if="fetching" slot="notFoundContent" size="small"/>
                                          <a-select-option v-for="s in paymentTerms" :key="'paymentTerms'+s.id.toString()">{{s.name}}</a-select-option>
                                      </a-select>
                                  </div>

                                  <div class="col" v-if="showShippingMethod">
                                      <h6 class="heading-small text-muted">Shipping Method</h6>
                                      <a-select
                                              labelInValue
                                              :value="shippingMethod"
                                              :data-testid="'shipping-method-select'" 
                                              placeholder="Select a shipping method"
                                              style="width: 100%"
                                              :filterOption="false"
                                              @dropdownVisibleChange="fetchShippingMethods"
                                              @change="selectShippingMethod"
                                              :notFoundContent="fetching ? undefined : null"
                                              :disabled='isShippingMethodDisabled'
                                          >
                                          <a-spin v-if="fetching" slot="notFoundContent" size="small"/>
                                          <a-select-option v-for="s in shippingMethods" :key="'shippingMethods'+s.id.toString()">{{s.name}}</a-select-option>
                                      </a-select>
                                  </div>
                                  <div class="col">
                                      <h6 class="heading-small text-muted">Purpose</h6>
                                      <a-select
                                              labelInValue
                                              :value="purpose"
                                              :data-testid="'purpose-select'" 
                                              placeholder="Select purpose"
                                              style="width: 100%"
                                              :filterOption="false"
                                              @dropdownVisibleChange="fetchPurposes"
                                              @change="selectPurpose"
                                              :notFoundContent="fetching ? undefined : null"
                                              :disabled='isPurposeDisabled'
                                          >
                                          <a-spin v-if="fetching" slot="notFoundContent" size="small"/>
                                          <a-select-option v-for="s in purposes" :key="'purposes'+s.id.toString()">{{s.name}}</a-select-option>
                                          </a-select>
                                  </div>
                                  <div class="col">
                                      <h6 class="heading-small text-muted">{{referenceLabel}}</h6>
                                      <a-input :data-testid="'reference-input'" style="width: 100%" @change="()=>{isEditing = true}" :maxLength="Number(50)" v-model='reference' placeholder="Reference" :disabled='isReferenceDisabled'/>
                                  </div>
                              </div>
                              <div class="row pt-1">
                                  <div class="col">
                                      <h6 class="heading-small text-muted">{{remarkLabel}}</h6>
                                      <a-input :data-testid="'remark-input'"  style="width: 100%" :maxLength="Number(255)" v-model='remark' placeholder="Remark">
                                          <a v-if='documentNumber > 0' slot="addonAfter" @click='saveRemark()' class="heading-small text-muted">Save</a>
                                      </a-input>
                                  </div>
                              </div>
                          </div>

                          <div class="card-body pt-0" v-if='showChargesTable'>
                              <div class="row pb-2">
                                  <div class="col ">
                                      <h6 class="heading-small text-muted">Charges</h6>
                                  </div>
                                  <div class="col-2 d-flex align-items-end" v-if="chargeSelectedRowKeys && chargeSelectedRowKeys.length > 0">
                                      <button type="button" class="btn btn-danger btn-sm btn-block align-bottom" @click="mass_delete_charge()" :disabled="documentStatus == 'Voided' || isAddChargeDisabled">Delete Charge</button>
                                  </div>
                                  <div class="col-2 d-flex align-items-end">
                                      <button type="button" class="btn btn-primary btn-sm btn-block align-bottom" @click="showDrawer('charges')" :disabled='isAddChargeDisabled'>Add Charge</button>
                                  </div>
                              </div>
                              <a-table :rowSelection="chargeRowSelection" rowKey='line_no' :columns="chargeColumns" :dataSource="chargeData" :pagination="true" size="small">
                              <span slot="charge_type" slot-scope="text, record">
                                  <a-tag v-if="record.charge_type == 'I'" color="green">Initial Charge</a-tag>
                                  <a-tag v-if="record.charge_type == 'A-RR'" color="blue">Additional Charge - RR Quantity</a-tag>
                                  <a-tag v-if="record.charge_type == 'A-CL'" color="red">Additional Charge - Cost Layer Quantity</a-tag>
                              </span>
                              <span slot="amount" slot-scope="text, record">
                                  {{formatMyNumber(Number(record.amount), 2)}}
                              </span>
                              <span slot="charge_date" slot-scope="text, record">
                                  {{moment(record.charge_date).format('MM/DD/YYYY HH:mm')}}
                              </span>
                              <template #footer>Total Charges: {{formatMyNumber(Number(totalCharges), 2)}}</template>
                              </a-table>

                              <a-drawer
                                  :width="480"
                                  placement="right"
                                  @close="closeDrawer('charges')"
                                  :visible="chargeDrawerVisible"
                                  style="z-index: 999999!important;"
                              >
                                  <h6 class="heading-small text-muted mb-4 text-truncate">Add Charge</h6>
                                  <form>
                                  <base-input label="Description" placeholder="" v-model="chargeDescription" input-classes="form-control" />
                                  <base-input label="Charge Type">
                                      <select class="form-control" v-model="chargeType" @change='selectChargeType'>
                                          <option v-for="option in chargeTypeOptions" v-bind:key="'chargeTypeOptions'+option.key" v-bind:value="option.key">
                                              {{option.value}}
                                          </option>
                                      </select>
                                  </base-input>
                                  <base-input label="Weight (kg)" placeholder="" v-model="chargeWeight" input-classes="form-control" :disabled='isChargeWeightDisabled' @input='calculateChargeAmount'/>
                                  <base-input label="Rate /kg" placeholder="" v-model="chargeRate" input-classes="form-control" :disabled='isChargeRateDisabled' @input='calculateChargeAmount'/>
                                  <base-input label="Amount" placeholder="" v-model="chargeAmount" input-classes="form-control" :disabled='isChargeAmountDisabled' />
                                  <div style="position: absolute; bottom: 0px;right: 0px; width: -webkit-fill-available; background-color: #f2f2f2 ;padding: 10px;">
                                      <button type="button" class="btn btn-primary float-right" @click='addCharge()' >Add</button>
                                      <button type="button" class="btn btn-danger float-right mr-2" @click="closeDrawer('charges')">Close</button>
                                  </div>
                                  </form>
                              </a-drawer>
                          </div>
                      </div>
                  </div>
              </div>
              <hr>

              <!-- Drawer for Payments -->
              <a-drawer :width="480" placement="right"  @close="closeDrawer('payments')" :visible="paymentDrawerVisible">
                  <h6 class="heading-small text-muted mb-4 text-truncate">Choose Payment Method</h6>
                  <form>
                      <a-spin :spinning="spinning">
                          <base-alert v-if="paymentErrors.length" type="danger">
                              <b>You have the following error(s):</b>
                              <li v-for="error in paymentErrors" :key="error">{{ error }}</li>
                          </base-alert>

                          <base-input label="Payment Mode">
                              <base-radio name="paymaya" class="mb-3" v-model="paymentMode" value="paymaya">
                                  Paymaya
                              </base-radio>
                              <base-radio name="dragonpay" class="mb-3" v-model="paymentMode" value="dragonpay">
                                  Dragonpay
                              </base-radio>

                              <base-input v-if="paymentMode == 'dragonpay'" label="Payment Method">
                                  <br/>
                                  <a-select showSearch style="width: 100%" placeholder="Please select payment method" optionFilterProp="children"  v-model="paymentMethod">
                                      <a-select-option v-for="option in paymentMethods" :key="'paymentMethods'+option.procId" :value="option.procId">{{option.shortName}}</a-select-option>
                                  </a-select>
                              </base-input>


                              <base-radio name="bank" class="mb-3" v-model="paymentMode" value="bank">
                                  Bank Transfer
                              </base-radio>

                              <base-input v-if="paymentMode == 'bank'" label="Reference Number">
                                  <br/>
                                  <a-input style="width: 100%" v-model='bankTransferReference' placeholder="Reference Number" />
                              </base-input>
                          </base-input>
                      </a-spin>
                      <div style="position: absolute; bottom: 0px;right: 0px; width: -webkit-fill-available; background-color: #f2f2f2 ;padding: 10px;">
                          <button type="button" class="btn btn-primary float-right" @click='pay(documentNumber)' >
                              <span v-if="paymentMode == 'bank'">Confirm</span>
                              <span v-else>Send Link</span>
                          </button>
                          <!-- @click="closeDrawer('payments')" -->
                          <button v-if="currentDocumentTypeCode != 'OTHSIN'" type="button" class="btn btn-danger float-right mr-2" @click="payLater()">Proceed Without Payment</button>
                      </div>
                  </form>

              </a-drawer>

              <!-- Drawer for Initail Deposit -->
              <a-drawer :width="480" placement="right"  @close="closeDrawer('initialDeposit')" :visible="initialDepositDrawerVisible">
                  <h6 class="heading-small text-muted mb-4 text-truncate">Initial Deposit</h6>
                  <form>
                      <a-spin :spinning="spinning">
                          <base-alert v-if="initialDepositErrors.length" type="danger">
                              <b>You have the following error(s):</b>
                              <li v-for="error in initialDepositErrors" :key="error">{{ error }}</li>
                          </base-alert>
                          <base-input label="Amount">
                              <a-input-number v-model="initialDeposit.amount" :min="1" step=".01" :max="Number(grossAmountDisplay)" style="width: 100%" input-classes="form-control" />
                          </base-input>
                          <base-input label="Reference" placeholder="" v-model="initialDeposit.reference" input-classes="form-control"/>
                      </a-spin>
                      <div style="position: absolute; bottom: 0px;right: 0px; width: -webkit-fill-available; background-color: #f2f2f2 ;padding: 10px;">
                          <button type="button" class="btn btn-primary float-right" @click='payInitialDeposit(documentNumber)' >
                              <span>Confirm</span>
                          </button>
                          <!-- @click="closeDrawer('payments')" -->
                      </div>
                  </form>
              </a-drawer>

              <a-modal title="Form Printing" :visible="modalFormPrinting" :maskClosable = "false" @cancel="modalFormPrinting = false;">
                  <div class="row ml-3">
                      <div class="col-md-2">
                          <label>Printer</label>
                      </div>
                      <div class="col-md-10">
                          <a-select v-if='accessRights.includes("T") && documentNumber>0 && orderSource!="shopee" && orderSource!="lazada"&& orderSource!="zalora" && currentDocumentTypeCode!="ORIPOX" && currentDocumentTypeCode!="OTHTRA" && currentDocumentTypeCode!="OTHPCK" && currentDocumentTypeCode !="OTHBAR"' v-model="formPrintPrinter" style="width: 100%" placeholder="Select Printer">
                              <a-select-option value="pdf">
                                  PDF
                              </a-select-option>
                              <a-select-option value="dot">
                                  PDF DOT
                              </a-select-option>
                              <a-select-option v-if="orderSource=='shopee'" value="shopee">
                                  Shopee Waybill
                              </a-select-option>
                              <a-select-option v-if="orderSource=='lazada'" value="lazada">
                                  Lazada Waybill
                              </a-select-option>
                          </a-select>
                          <a-select v-else-if="accessRights.includes('T') && documentNumber>0 && orderSource!='shopee' && orderSource!='lazada' && orderSource!='zalora' && currentDocumentTypeCode=='ORIPOX'" v-model="formPrintPrinter" style="width: 100%" placeholder="Select Printer">
                              <a-select-option value="csv">
                                  CSV
                              </a-select-option>
                              <a-select-option value="pdf">
                                  PDF
                              </a-select-option>
                              <a-select-option value="dot">
                                  PDF DOT
                              </a-select-option>
                              <a-select-option v-if="orderSource=='shopee'" value="shopee">
                                  Shopee Waybill
                              </a-select-option>
                              <a-select-option v-if="orderSource=='lazada'" value="lazada">
                                  Lazada Waybill
                              </a-select-option>
                          </a-select>
                          <a-select v-else-if="accessRights.includes('T') && documentNumber>0 && (currentDocumentTypeCode=='OTHTRA' || currentDocumentTypeCode=='OTHPCK')" v-model="formPrintPrinter" style="width: 100%" placeholder="Select Printer">
                              <a-select-option value="pdf">
                                  Print Standard
                              </a-select-option>
                              <a-select-option value="dot">
                                  Print Standard DOT
                              </a-select-option>
                              <a-select-option value="extended">
                                  Print Extended
                              </a-select-option>
                              <a-select-option value="extended_dot">
                                  Print Extended DOT
                              </a-select-option>
                          </a-select>
                          <a-select v-else-if='accessRights.includes("T") && documentNumber>0 && (orderSource=="shopee" || orderSource=="lazada" || orderSource=="zalora")' v-model="formPrintPrinter" style="width: 100%" placeholder="Select Printer">
                              <a-select-option value="pdf">
                                  Document
                              </a-select-option>
                              <a-select-option value="shopee">
                                  Shopee Waybill
                              </a-select-option>
                              <a-select-option value="lazada">
                                  Lazada Waybill
                              </a-select-option>
                              <a-select-option value="zalora" :disabled="zaloraPrintWayBillDisabled">
                                  Zalora Waybill{{ zaloraPrintWayBillStatus != null ? " - " + zaloraPrintWayBillStatus : ""}}
                              </a-select-option>
                          </a-select>
                      </div>
                  </div>
                  <div v-if="formPrintPrinter == 'pdf' || formPrintPrinter == 'dot'" class="row mt-3 ml-3">
                      <div class="col-md-2">
                          <label>Format</label>
                      </div>
                      <div class="col-md-10">
                          <a-select v-model="formPrintFormat"
                              showSearch
                              placeholder="Select Print Format"
                              optionFilterProp="children"
                              style="width: 100%"
                              :filterOption="filterOption">
                              <a-select-option v-for="option in formPrintFormatOptions" :key="option.id" :value="option.function">{{ option.name }}</a-select-option
                          >
                          </a-select>
                      </div>
                  </div>
                  
                  <template slot="footer">
                      <a-button v-if="formPrintPrinter == 'csv' && formPrintFormat == ''" class="btn-success mr-3" type="button" @click="exportCSV()">Print</a-button>
                      <a-button v-else-if="formPrintPrinter == 'pdf' && formPrintFormat == ''" class="btn-success mr-3" type="button" @click="print(true)">Print</a-button>
                      <a-button v-else-if="formPrintPrinter == 'pdf' && formPrintFormat == 'NVD'" class="btn-success mr-3" type="button" @click="print(true,'NVD')">Print</a-button>
                      <a-button v-else-if="formPrintPrinter == 'dot' && formPrintFormat == ''" class="btn-success mr-3" type="button" @click="print(true, 'dotMatrix')">Print</a-button>
                      <a-button v-else-if="formPrintPrinter == 'extended' && formPrintFormat == ''" class="btn-success mr-3" type="button" @click="print(false)">Print</a-button>
                      <a-button v-else-if="formPrintPrinter == 'extended_dot' && formPrintFormat == ''" class="btn-success mr-3" type="button" @click="print(false, 'dotMatrix')">Print</a-button>
                      <a-button v-else-if="formPrintPrinter == 'shopee' && formPrintFormat == ''" class="btn-success mr-3" type="button" @click="shopeePrintWayBill()">Print</a-button>
                      <a-button v-else-if="formPrintPrinter == 'lazada' && formPrintFormat == ''" class="btn-success mr-3" type="button" @click="lazadaPrintWayBill()">Print</a-button>
                      <a-button v-else-if="formPrintPrinter == 'zalora' && formPrintFormat == ''" class="btn-success mr-3" type="button" @click="zaloraPrintWayBill()">Print</a-button>
                      <a-button v-else-if="(formPrintPrinter == 'pdf' || formPrintPrinter == 'dot') && formPrintFormat == 'count_sheet'" class="btn-success mr-3" type="button" @click="printPhysicalCountV2CountSheet(formPrintPrinter == 'dot' ? 'dotMatrix' : null)">Print</a-button>
                      <a-button v-else-if="formPrintPrinter == 'pdf' && formPrintFormat == 'cmg_po_print'"  class="btn-success mr-3" type="button" @click="docPrint(formPrintFormat)">Print</a-button>
                      <a-button v-else-if="formPrintPrinter == 'dot' && formPrintFormat == 'cmg_po_print'"  class="btn-success mr-3" type="button" @click="docPrint(formPrintFormat, 'dotMatrix')">Print</a-button>
                      <a-button v-else-if="formPrintPrinter == 'pdf' && formPrintFormat == 'goldwing_rr_print'"  class="btn-success mr-3" type="button" @click="docPrint(formPrintFormat)">Print</a-button>
                      <a-button v-else-if="formPrintPrinter == 'dot' && formPrintFormat == 'goldwing_rr_print'"  class="btn-success mr-3" type="button" @click="docPrint(formPrintFormat, 'dotMatrix')">Print</a-button>
                      <a-button v-else-if="formPrintPrinter == 'pdf' && formPrintFormat == 'cas_default'"  class="btn-success mr-3" type="button" @click="print(true)">Print</a-button>
                      <a-button v-else-if="formPrintPrinter == 'dot' && formPrintFormat == 'cas_default'"  class="btn-success mr-3" type="button" @click="print(true, 'dotMatrix')">Print</a-button>
                      <a-button v-else-if="formPrintPrinter == 'pdf' && formPrintFormat != ''"  class="btn-success mr-3" type="button" @click="customPrint(true)">Print</a-button>
                      <a-button v-else-if="formPrintPrinter == 'dot' && formPrintFormat != ''"  class="btn-success mr-3" type="button" @click="customPrint(true, 'dotMatrix')">Print</a-button>
                  </template>
              </a-modal>
              <!-- Form Printing Module -->

              <!-- Drawer for Applying Document to Other Sites -->
              <DocumentApplyToOtherSitesDrawer
                :documentNumber="this.documentNumber"
                :currentDocumentSite="this.forThisSite"
                :showDrawer="applyDocumentToOtherSitesDrawer"
                @closeDrawer="toggleApplyDocumentToOtherSitesDrawer"
                @notification="(args) => $notification[args.type]({ message: args.msg.message, description: args.msg.description, style: getNotificationStyle(args.type) })"/>

              <!-- Drawer for Booking -->
              <a-modal
                 title="Recompute Needed"
                 :visible="recomputeModal"
                 okText="Yes"
                 cancelText="Recompute"
                 @ok="bookingProper"
                 @cancel="recomputeBooking"
               >
                  There was a change on the destination point. Do you want to proceed with the original destination point?
              </a-modal>
              <a-drawer  v-if="bookingDrawerVisible" :width="1000" placement="right"  @close="closeDrawer('booking')" :visible="bookingDrawerVisible">
                  <h6 class="heading-small text-muted mb-4 text-truncate">Booking Details</h6>


                  <div v-if="activeBooking">
                      <a-card v-if="bookingDetails.order != undefined" title="Booking Details">
                          <a-card-grid style="width:50%;text-align:center">
                            <small>Amount</small>
                            <h3>PHP {{bookingDetails.order.delivery_fee_amount}}</h3>
                          </a-card-grid>
                          <a-card-grid style="width:50%;text-align:center" :hoverable="false">
                           <small>Status</small>
                           <h3>{{bookingDetails.order.status_description}}</h3>
                          </a-card-grid>
                      </a-card>
                  </div>
                  <div v-else>
                      <a-card v-if="bookingDetails.order != undefined" title="Booking Amount">
                          <h3>PHP {{bookingDetails.order.delivery_fee_amount}}</h3>
                      </a-card>
                  </div>
                  <!-- <a v-if="addressEditMode == false" href="#" @click.prevent="addressEditMode = true"><small>Edit</small></a>
                  <a v-else href="#" @click.prevent="addressEditMode = false"><small>Save</small></a> -->

                  <form class="row mt-3" style="overflow: scroll;">

                  <div class="col-md-4">
                      <a-steps progress-dot :current="2" direction="vertical">
                        <a-step title="Pickup Address" :description="siteAddress"/>
                        <a-step title="Destination Address" :description="customerAddress" />
                      </a-steps>
                  </div>

                  <!-- <GmapMarker ref="myMarker" :position="google && new google.maps.LatLng(1.38, 103.8)" /> -->
                  <div v-if="activeBooking" class="col-md-8">
                      <google-map :center="center" :zoom="13" style="width: 100%; height: 500px" :key="mapKey">
                        <!-- <google-marker v-for="m in markers" :position="m.position" :clickable="true" :draggable="true" @click="center=m.position" :key="m.id"></google-marker> -->
                        <google-marker :position="markers[0].position" :draggable="false"></google-marker>
                        <google-marker :position="markers[1].position" :draggable="false"></google-marker>
                      </google-map>
                      <small><span class="fa fa-exclamation-circle mr-2 text-info"/>You can move the pinned location on the map if necessary.</small>
                  </div>
                  <div v-else class="col-md-8">
                      <google-map :center="center" :zoom="13" style="width: 100%; height: 500px" :key="mapKey">
                        <!-- <google-marker v-for="m in markers" :position="m.position" :clickable="true" :draggable="true" @click="center=m.position" :key="m.id"></google-marker> -->
                        <google-marker :position="markers[0].position" :draggable="false"></google-marker>
                        <google-marker :position="markers[1].position" :draggable="true" @dragend="handleDestinationChange" :key="mapKey"></google-marker>
                      </google-map>
                      <small><span class="fa fa-exclamation-circle mr-2 text-info"/>You can move the pinned location on the map if necessary.</small>
                  </div>

                  <div class="mt-3 col-md-6">
                      <h5 class="navbar-heading text-muted">PICKUP CONTACT DETAILS</h5>
                      <!-- <base-input alternative="" label="Pickup Address" v-model="siteAddress" type="text" /> -->
                      <base-input :disabled="activeBooking" alternative="" label="Pickup Contact Name" v-model="siteContactPerson" type="text"/>
                      <base-input :disabled="activeBooking" alternative="" label="Pickup Contact Number" v-model="siteContactNumber" type="text"/>
                  </div>

                  <div class="mt-3 col-md-6">
                      <h5 class="navbar-heading text-muted">DESTINATION CONTACT DETAILS</h5>
                      <!-- <base-input alternative="" label="Destination Address" v-model="customerAddress" type="text" /> -->
                      <base-input :disabled="activeBooking" alternative="" label="Destination Contact Name" type="text" v-model="customer.label"/>
                      <base-input :disabled="activeBooking" alternative="" label="Destination Contact Number" type="text" v-model="customerContactMobile"/>
                  </div>

                  <br/>

                  <div class="mt-3 col-md-12">
                      <base-input label="Vehicle Type">
                          <base-radio name="8" class="mb-3" v-model="deliveryMode" value="8" :disabled="activeBooking">
                              Motor Bike
                          </base-radio>
                          <base-radio name="7" class="mb-3" v-model="deliveryMode" value="7" :disabled="activeBooking">
                              Car
                          </base-radio>
                      </base-input>
                      <br/> <br/><br/>
                  </div>



                  <div style="position: absolute; bottom: 0px;right: 0px; width: -webkit-fill-available; background-color: #f2f2f2 ;padding: 10px;">
                      <button v-if="activeBooking == true && bookingDetails.order.status == 'new'" type="button" class="btn btn-warning float-right" @click.prevent="cancelBooking()">Cancel Booking</button>
                      <button v-if="activeBooking == false" type="button" class="btn btn-success float-right" @click.prevent="proceedBooking()">Book</button>
                      <button v-if="activeBooking == false" type="button" class="btn btn-primary float-right" @click.prevent="recomputeBooking()">Recompute</button>
                      <button type="button" class="btn btn-danger float-right mr-2" @click="closeDrawer('booking')">Close</button>
                  </div>
                  </form>
              </a-drawer>

              <!-- Drawer for Document Action History -->
              <a-drawer :width="800" placement="right" @close="closeDrawer('history')" :visible="historyDrawerVisible">
                  <h6 class="heading-small text-muted mb-4 text-truncate">Document Action History</h6>
                  <a-table :columns="historyColumns" :dataSource="historyData" size="small"/>
                  <div style="position: absolute; bottom: 0px;right: 0px; width: -webkit-fill-available; background-color: #f2f2f2 ;padding: 10px;">
                      <button type="button" class="btn btn-danger float-right mr-2" @click="closeDrawer('history')">Close</button>
                  </div>
              </a-drawer>

              <!-- Drawer for Stock Card -->
              <stock-card v-if="selectedStockCardProduct != null" :product="selectedStockCardProduct" :key="'stockCard'+stockCardKey" :visible="stockCardVisible"></stock-card>

              <!-- Drawer for Customer Form -->
              <a-drawer title="" :width="1000" placement="right" @close="onClose" :visible="customerDrawerVisible">
                  <customer-form :key="'CustomerForm'+customerDrawerKey" v-on:refreshPage="refreshPage" @closeDrawer="closeDrawer"></customer-form>
              </a-drawer>

              <!-- Drawer for Document Line Mass Add -->
              <a-drawer :width="480" placement="right" :key="'documentLineMassAdd'+massAddDrawerKey" @close="closeDrawer('massAdd')" :visible="massAddDrawerVisible">
                  <h6 class="heading-small text-muted mb-4">Mass Add Products in Document Lines</h6>
                  <base-alert v-if="massAddProductErrors.length" type="danger">
                      <b>You have the following error(s):</b>
                      <li v-for="error in massAddProductErrors" :key="error">{{ error }}</li>
                  </base-alert>
                  <base-alert v-if="massAddProductErrorsDL.length" type="info">
                      <b>Download list:</b>
                      <li v-if="dlDUplicateSkus == 1"><a href="#" @click="printDupSKUs">Duplicate Barcode/s</a></li>
                      <li v-if="dlSkusNotFound == 1"><a href="#" @click="printSKUsNotFound">Barcode/s not found</a></li>

                  </base-alert>
                  <div>
                      <a-spin tip="Validating CSV file" :spinning="spinning">
                          <label v-if="header.showSaveProductVia">
                              Save each product via:
                              <a-select
                                  v-model="saveMassUploadProductVia"
                                  style="width: 120px">
                                  <a-select-option value="barcode">
                                      Barcode
                                  </a-select-option>
                                  <a-select-option value="stock_no">
                                      Stock No
                                  </a-select-option>
                              </a-select>
                          </label>

                          <!-- <br><br> -->

                          <div class="row">
                              <div class="col-md-12">
                                  <base-input label="Importer Type">
                                      <base-radio name="0" class="mb-3" v-model="importerType" value="0">
                                          Local
                                      </base-radio>
                                      <div class="deprecation-notice text-muted small mb-3 ml-4">
                                        <i class="fas fa-exclamation-triangle text-warning"></i>
                                        <strong> Deprecation Notice:</strong> The removal of the local upload option has been extended until the end of May 2026.
                                        We recommend using S3 upload going forward.
                                      </div>
                                      <base-radio name="1" class="mb-3" v-model="importerType" value="1">
                                          S3
                                      </base-radio>
                                  </base-input>
                              </div>
                          </div>

                          <a-upload-dragger :before-upload="beforeUpload" 
                              :remove="handleRemove"
                              :fileList="fileList"
                              :multiple="false" accept=".csv, .CSV">
                              <span class="fa fa-file-import" style="font: 20pt;" />
                              <p class="ant-upload-text">Click or drag file to this area to upload</p>
                              <p class="ant-upload-hint">
                                   Upload your product list in a CSV file following the specified format.
                                   Please upload maximum of {{ maxLines }} lines per batch.
                                   You can download template below.
                              </p>
                          </a-upload-dragger>

                          <!-- <a-upload-dragger :before-upload="beforeUpload" v-if="importerType == 1"
                              :remove="handleRemove"
                              :fileList="fileListS3"
                              :multiple="false" accept=".csv, .CSV">
                              <span class="fa fa-file-import" style="font: 20pt;" />
                              <p class="ant-upload-text">Click or drag file to this area to upload</p>
                              <p class="ant-upload-hint">
                                   [S3] Upload your product list in a CSV file following the specified format.
                                   Please upload maximum of {{ maxLines }} lines per batch.
                                   You can download template below.
                              </p>
                          </a-upload-dragger> -->

                          <br><br>

                          <a-collapse>
                              <a-collapse-panel header="Templates" key="1">
                              <a-list bordered>
                                  <a-list-item>
                                  <a-list-item-meta description="Contains required data to create a document">
                                      <a @click.prevent="downloadTemplate('1')" slot="title">Download Basic Document Template</a>
                                  </a-list-item-meta>
                                  <div><a @click.prevent="downloadTemplate('1')"><span class="fa fa-file-download"/></a></div>
                                  </a-list-item>

                                  <a-list-item v-if="['OTHTRA'].includes(currentDocumentTypeCode)">
                                  <a-list-item-meta description="Contains required data to create a document">
                                      <a @click.prevent="downloadTemplate('2')" slot="title">Download Extended Document Template (with lot tables)</a>
                                  </a-list-item-meta>
                                  <div><a @click.prevent="downloadTemplate('2')"><span class="fa fa-file-download"/></a></div>
                                  </a-list-item>

                                  <a-list-item v-if="['RECDEL','RELTRX','RECTRX','RELSLO','RECSLI','OTHPCN','RECADJ','RELADJ'].includes(currentDocumentTypeCode)">
                                  <a-list-item-meta description="Contains required data to create a document with lotcode and expiry. Note: Expiry Date format: YYYY-MM-DD Sample: 2014-12-21">
                                      <a @click.prevent="downloadTemplate('2')" slot="title">Download Lot Code & Expiry Document Template</a>
                                  </a-list-item-meta>
                                  <div><a @click.prevent="downloadTemplate('2')"><span class="fa fa-file-download"/></a></div>
                                  </a-list-item>
                              </a-list>
                              </a-collapse-panel>
                          </a-collapse>

                          <br><br>

                          <div class="row" v-if='documentNumber!=undefined && documentNumber!=0'>
                              <div class="col-md-12">
                                  <base-input label="Import Mode">
                                      <base-radio name="0" class="mb-3" v-model="importMode" value="O">
                                          Add-In
                                      </base-radio>
                                      <base-radio name="1" class="mb-3" v-model="importMode" value="1">
                                          Override
                                      </base-radio>
                                  </base-input>
                              </div>
                          </div>

                          

                      </a-spin>
                  </div>
                  <div style="position: absolute;bottom: 0px;right: 0px;width: -webkit-fill-available;background-color: #f2f2f2 ;padding: 10px;">
                      <button type="button" v-if="massAddProductErrors.length < 1 && csvData != '' && spinning == false" class="btn btn-primary float-right" @click.prevent="importFile">Import</button>
                  </div>
              </a-drawer>

              <!-- Drawer for Document Line Mass Add with Allocation -->
              <a-drawer :width="480" placement="right" @close="closeDrawer('massAddWithAllocation')" :visible="massAddWithAllocationDrawerVisible">
                  <h6 class="heading-small text-muted mb-4">Mass Add Products with Allocation in Document Lines</h6>
                  <base-alert v-if="massAddWithAllocationProductErrors.length" type="danger">
                      <b>You have the following error(s):</b>
                      <li v-for="error in massAddWithAllocationProductErrors" :key="error">{{ error }}</li>
                  </base-alert>
                  <div>
                      <a-spin tip="Validating Excel (XLSX) file" :spinning="spinning">
                          <a-upload-dragger :before-upload="beforeUploadWithAllocation"
                              :remove="handleRemove"
                              :fileList="fileWithAllocationList"
                              :multiple="false" accept=".xlsx, .xls">
                              <span class="fa fa-file-import" style="font: 20pt;" />
                              <p class="ant-upload-text">Click or drag file to this area to upload</p>
                              <p class="ant-upload-hint">
                                   Upload your product list in an excel (.XLSX) file following the specified format.
                                   Please upload maximum of {{ maxLines }} lines per batch.
                                   You can download template below.
                              </p>
                          </a-upload-dragger>
                      </a-spin>

                      <br><br>

                      <a-collapse>
                          <a-collapse-panel header="Templates" key="0">
                          <a-list bordered>
                              <a-list-item>
                                  <a-list-item-meta description="Contains required data to create a document">
                                      <a @click.prevent="downloadTemplate('3')" slot="title">Download TRA with Allocation Template</a>
                                  </a-list-item-meta>
                                  <div><a @click.prevent="downloadTemplate('3')"><span class="fa fa-file-download"/></a></div>
                              </a-list-item>
                          </a-list>
                          </a-collapse-panel>
                      </a-collapse>

                  </div>
                  <div style="position: absolute;bottom: 0px;right: 0px;width: -webkit-fill-available;background-color: #f2f2f2 ;padding: 10px;">
                      <button type="button" v-if="massAddWithAllocationProductErrors.length < 1 && spinning == false" class="btn btn-primary float-right" @click.prevent="importWithAllocationFile">Import</button>
                  </div>
              </a-drawer>

              <!-- Drawer for Sublocation Allocation -->
              <a-drawer :width="520" placement="right" :key="'sublocationAllocation'+sublocationAllocationKey" @close="closeDrawer('sublocationAllocation')" :body-style="{ paddingBottom: '80px' }" :visible="sublocationAllocationVisible">
                  <h6 class="heading-small text-muted mb-4">{{selectedSublocationAllocationProduct.product_name}}</h6>
                  <div>
                      <base-alert v-if="sublocationAllocationErrors.length" type="danger">
                          <b>You have the following error(s):</b>
                          <li v-for="error in sublocationAllocationErrors" :key="error">{{ error }}</li>
                      </base-alert>

                      <div class="row">
                          <div class="col"><h4><b>Quantity: </b>{{selectedSublocationAllocationProduct.quantity}}</h4></div>
                          <div class="col"><h4><b>Remaining Quantity: </b> {{selectedSublocationAllocationProduct.quantity - drawerCurrentSublocationAllocation.reduce((a, {quantity}) => a + parseInt(quantity), 0) }}</h4></div>
                      </div>

                      <hr class="mt-1 mb-2">

                      <div class="row">
                          <div class="col">Sublocation</div>
                          <div class="col">Sublocation Quantity</div>
                      </div>

                      <div class="row">
                          <div class="col">
                              <a-select
                                  labelInValue
                                  :value="drawerSublocation"
                                  placeholder="Select a sublocation"
                                  style="width: 100%"
                                  :filterOption="false"
                                  @dropdownVisibleChange="fetchDrawerSublocations"
                                  @change="selectDrawerSublocations"
                                  :notFoundContent="fetching ? undefined : null"
                              >
                                  <a-spin v-if="fetching" slot="notFoundContent" size="small"/>
                                  <a-select-option v-for="s in drawerSublocations" :key="'drawerSublocations'+s.id.toString()">{{s.name}}</a-select-option>
                              </a-select>
                          </div>
                          <div class="col">
                              <a-input v-model='drawerSublocationQuantity' placeholder="Sublocation Quantity" :disabled="isPhysicalCountV2QuantityEditLocked" />
                          </div>
                      </div>

                      <div class="row mt-2 mx-1 mb-3">
                          <a-button @click='addDrawerSublocationQuantity' block :disabled="isPhysicalCountV2QuantityEditLocked">Add Sublocation Quantity</a-button>
                      </div>

                      <div class="table-responsive">
                          <table class="table table-bordered table-sm">
                              <thead>
                                  <tr>
                                      <th scope="col">Sublocation</th>
                                      <th scope="col">Quantity</th>
                                      <th class="text-center" scope="col">Action</th>
                                  </tr>
                              </thead>
                              <tbody>
                                  <tr v-for="(data, index) in drawerCurrentSublocationAllocation" v-bind:key="'drawerCurrentSublocationAllocation'+index">
                                      <td class="align-middle">{{ (drawerSublocations.find(x => x.id === parseInt(data.sublocation_id))) ? drawerSublocations.find(x => x.id === parseInt(data.sublocation_id)).name : "Invalid Data. Please Remove" }}</td>
                                      <td class="align-middle">{{data.quantity}}</td>
                                      <td class="text-center"><a-button size="small" @click="removeSublocationAllocation(index)">Remove</a-button></td>
                                  </tr>
                              </tbody>
                          </table>
                      </div>
                      <div v-if="documentStatus!='Posted'"
                          :style="{
                          position: 'absolute',
                          right: 0,
                          bottom: 0,
                          width: '100%',
                          borderTop: '1px solid #e9e9e9',
                          padding: '10px 16px',
                          background: '#fff',
                          textAlign: 'right',
                          zIndex: 1,
                          }"
                      >
                          <a-button @click='saveDrawerSublocationAllocation' type="primary" block>Save</a-button>
                      </div>
                  </div>
              </a-drawer>

              <!-- Drawer for Site Allocation -->
              <a-drawer :width="750" placement="right" :key="'siteAllocation'+siteAllocationKey" @close="closeDrawer('siteAllocation')" :body-style="{ paddingBottom: '80px' }" :visible="siteAllocationVisible">
                  <h6 class="heading-small text-muted mb-4">{{selectedSiteAllocationProduct.product_name}}</h6>
                  <div>
                      <base-alert v-if="siteAllocationErrors.length" type="danger">
                          <b>You have the following error(s):</b>
                          <li v-for="error in siteAllocationErrors" :key="error">{{ error }}</li>
                      </base-alert>

                      <div class="row">
                          <div class="col"><h4><b>Total Quantity: </b>{{selectedSiteAllocationProduct.quantity}}</h4></div>
                      </div>

                      <div class="row" v-if="currentDocumentTypeCode != 'OTHPCK'">
                          <div class="col">
                              <h4>
                                  <b>Remaining Quantity: </b>
                                  <span v-if="(siteAllocationRemainingQuantity!=null && siteAllocationRemainingQuantity!='') || siteAllocationRemainingQuantity==0">{{siteAllocationRemainingQuantity}}</span>
                                  <span v-else>{{selectedSiteAllocationProduct.quantity}}</span>
                              </h4>
                          </div>
                      </div>

                      <hr class="mt-1 mb-2">

                      <div class="row">
                          <div class="col">Site</div>
                          <div class="col">Site Quantity</div>
                      </div>

                      <div class="row">
                          <div class="col">
                              <a-select
                                  labelInValue
                                  show-search
                                  :value="drawerSite"
                                  placeholder="Select a site"
                                  style="width: 100%"
                                  :filterOption="false"
                                  @dropdownVisibleChange="fetchDrawerSites"
                                  @change="selectDrawerSites"
                                  @search="handleSearchDrawerSites"
                                  :notFoundContent="fetching ? undefined : null"
                              >
                                  <a-spin v-if="fetching" slot="notFoundContent" size="small"/>
                                  <a-select-option v-for="s in drawerSites" :key="'drawerSites'+s.id.toString()">{{s.name}}</a-select-option>
                              </a-select>
                          </div>
                          <div class="col">
                              <a-input v-model='drawerSiteQuantity' placeholder="Site Quantity" :disabled="isPhysicalCountV2QuantityEditLocked" />
                          </div>
                      </div>

                      <div class="row mt-2 mx-1 mb-3">
                          <a-button @click='addDrawerSiteQuantity' block :disabled="isPhysicalCountV2QuantityEditLocked">Add Site Quantity</a-button>
                      </div>

                      <div class="table-responsive">
                          <table class="table table-bordered table-sm">
                              <thead>
                                  <tr>
                                      <th scope="col">Site</th>
                                      <th scope="col">QTY Assigned</th>
                                      <th scope="col">QTY Available</th>
                                      <th scope="col">On-Hand QTY</th>
                                      <th scope="col">Balance</th>
                                      <th v-if="currentDocumentTypeCode != 'OTHPCK'" class="text-center" scope="col">Action</th>
                                  </tr>
                              </thead>
                              <tbody>
                                  <tr v-for="(data, index) in drawerCurrentSiteAllocation" v-bind:key="'drawerCurrentSiteAllocation'+index">
                                      <td class="align-middle">{{ (drawerSites.find(x => x.id === parseInt(data.site_id))) ? drawerSites.find(x => x.id === parseInt(data.site_id)).name : "Invalid Data. Please Remove" }}</td>
                                      <td class="align-middle">
                                          <a-input v-if="isEditAllocation && isEditAllocationIndex == index" v-model='data.temp_quantity' min="1" type="number" />
                                          <span v-else >{{data.quantity}}</span>
                                      </td>
                                      <td class="align-middle">{{data.available_quantity}}</td>
                                      <td class="align-middle">{{selectedSiteAllocationProduct.on_hand_quantity}}</td>
                                      
                                      <td class="align-middle">{{(parseInt(selectedSiteAllocationProduct.on_hand_quantity) - data.quantity) > 0 ? (parseInt(selectedSiteAllocationProduct.on_hand_quantity) - data.quantity) : 0}}</td>
                                      <td v-if="currentDocumentTypeCode != 'OTHPCK'" class="text-center">
                                          <a-button type="success" size="small" v-if="isEditAllocation && isEditAllocationIndex == index" @click="saveAllocation(index)">Save</a-button>
                                          <a-button type="primary" size="small" v-else @click="editAllocation(index)">Edit</a-button>
                                          <a-button type="danger" size="small" @click="removeSiteAllocation(index)">Remove</a-button>
                                      </td>
                                  </tr>
                              </tbody>
                          </table>
                      </div>
                      <div v-if="documentStatus!='Posted'"
                          :style="{
                          position: 'absolute',
                          right: 0,
                          bottom: 0,
                          width: '100%',
                          borderTop: '1px solid #e9e9e9',
                          padding: '10px 16px',
                          background: '#fff',
                          textAlign: 'right',
                          zIndex: 1,
                          }"
                      >
                          <a-button @click='saveDrawerSiteAllocation' type="primary" block>Save</a-button>
                      </div>
                  </div>
              </a-drawer>

              <!-- Drawer for Document Image -->
              <a-drawer :width="960" placement="right" :key="'documentImage'+documentImageKey" @close="closeDrawer('document_image')" :body-style="{ paddingBottom: '80px' }" :visible="documentImageDrawerVisible">

                  <h6 class="heading-small text-muted mb-4 text-truncate">Document Image Upload</h6>

                  <div class="container">
                      <a-spin tip="Processing Image Upload" :spinning="spinning">
                          <div class="row">
                              <div class='col'>
                                  <div class="custom-file">
                                      <input type="file" class="custom-file-input" id="file" ref="file" v-on:change="handleFileUpload()">
                                      <label class="custom-file-label" for="file">Choose file</label>
                                  </div>
                              </div>
                              <div class='auto-col'>
                                  <a-button class='float-right' size="large" v-on:click="submitFile()">Submit</a-button>
                              </div>
                          </div>
                          <div class="row pt-2 ml-2">
                              <div class='auto-col'>
                                  {{ file.name }}
                              </div>
                          </div>

                          <div class='row'>
                              <img style="max-width: 100%; max-height: 100%;" :src="imageFileUrl">
                          </div>
                      </a-spin>
                  </div>

              </a-drawer>

              <!-- Drawer for Serialization -->

              <a-drawer :width="520" placement="right" :key="'SerializationKey'+serializationKey" :maskClosable = "false" @close="closeDrawer('serialization')" :body-style="{ paddingBottom: '80px' }" :visible="serializationVisible">
                  <h6 class="heading-small text-muted mb-4 text-truncate">Serial Number -  {{ selectedSerialProduct.product_name }}</h6>
                  <p>{{`${currentSerialCount} out of ${ previousSerialCount } Serial Number(s) ${ serialMessage }`}}</p>
                  <a-progress :percent="Math.floor((currentSerialCount / previousSerialCount ) * 100)" size="small" :format="() => `${currentSerialCount} / ${previousSerialCount}`" v-if="documentStatus !=='Posted'"/>
                  <div>
                      <base-alert v-if="serializationErrors.length" type="danger">
                          <b>You have the following error(s):</b>
                          <li v-for="error in serializationErrors" :key="error">{{ error }}</li>
                      </base-alert>

                      <div class="row">
                          <div class="col">
                              <a-input addon-before="Serial Number" style="width: 100%" v-model='inputSerialNumber' @keyup.enter="submitDrawerSerials" v-if="!documentIsRel" :disabled="isPhysicalCountV2QuantityEditLocked" />
                              <p v-else-if="documentIsRel  && documentStatus !=='Posted'" >Select from the following serials below:</p>
                          </div>
                          <div class='col-auto'>
                              <a-button type="primary" v-if="documentStatus !== 'Posted' && !documentIsRel" @click='submitDrawerSerials' :disabled='inputSerialNumber=="" || isPhysicalCountV2QuantityEditLocked' >Submit</a-button>
                          </div>
                      </div>

                      <hr>
                      <div class="table-responsive">
                          <table class="table table-bordered table-sm">
                              <thead>
                                  <tr>
                                      <th class="text-center" scope="col"></th>
                                      <th scope="col">Serial Number</th>
                                      <th class="text-center" scope="col">{{documentStatus !== 'Posted'? "Action": ""}}</th>
                                  </tr>
                              </thead>
                              <tbody>
                                  <tr v-for="(data, index) in currentDrawerSerials" v-bind:key="'currentDrawerSerials'+index">
                                      <!-- <td class="align-middle"><a-checkbox :checked="data.status == 'A'" disabled /></td> -->
                                      <td class="align-middle"><a-checkbox @change="selectSerial" :checked="data.checked" :id="data.serial_no" :disabled="!currentDocumentTypeCode.includes('REL') || isPhysicalCountV2QuantityEditLocked"  v-if="documentStatus!='Posted'"/></td>
                                      <td class="align-middle">{{data.serial_no}}</td>
                                      <td class="text-center"><a-button size="small" @click="removeSerialNumber(index)" v-if="documentStatus !== 'Posted'" :disabled="isPhysicalCountV2QuantityEditLocked">Remove</a-button></td>
                                  </tr>
                              </tbody>
                          </table>
                      </div>

                      <div v-if="documentStatus!='Posted'"
                          :style="{
                          position: 'absolute',
                          right: 0,
                          bottom: 0,
                          width: '100%',
                          borderTop: '1px solid #e9e9e9',
                          padding: '10px 16px',
                          background: '#fff',
                          textAlign: 'right',
                          zIndex: 1,
                          }"
                      >
                          <a-button @click='saveDrawerSerialization' type="primary" block :disabled="isPhysicalCountV2QuantityEditLocked">Save</a-button>
                      </div>

                  </div>
              </a-drawer>

              <!-- Drawer For Refences -->
              <a-drawer
                  :width="520"
                  placement="right"
                  @close="closeDrawer('references')"
                  :visible="referenceDrawerVisible"
                  v-if="this.document_config != null"
              >
                  <h6 class="heading-small text-muted mb-4 text-truncate">Document References</h6>
                  <!-- {{this.document_config.document_type_settings.references}} -->

                <div class="row">
                  <div class="col text-left">
                    <small>Reference Name</small>
                  </div>
                  <div class="col text-left">
                    <small>Value</small>
                  </div>
                </div>

                <div v-for="reference in document_config.document_type_settings.references" :key="reference.name" class="row pt-2">
                  <div class="col">{{reference.name}}</div>
                  <div class="col text-left" v-if="documentStatus != 'Posted'">
                      <a-input v-if="_.isEmpty(reference.value)" placeholder="Enter value here" v-model="reference.input"/>
                      <a-select v-else style="width: 100%" placeholder="Choose value" v-model="reference.input">
                          <a-select-option v-for="value in reference.value.split(',')" :key="value" :value="value">{{value}}</a-select-option>
                      </a-select>
                  </div>
                  <div v-else class="col text-left">
                      <div v-if="_.isUndefined(reference.input)"> - </div>
                      <div v-else>
                          <!-- {{reference.input.match(/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g)}} -->
                          <div v-if="reference.input.match(/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g) !== null">
                              <!-- <a-avatar :src="reference.input" :size="200"/> -->
                              <!-- {{reference.input}} -->
                              <a :href="reference.input"><a-avatar :size="250" :src="reference.input" /></a>
                          </div>
                          <div v-else>{{reference.input}}</div>
                      </div>
                  </div>
                </div>
              </a-drawer>

              <!-- Drawer For Extras -->
              <a-drawer
                  :width="520"
                  placement="right"
                  @close="closeDrawer('extras')"
                  :visible="extrasDrawerVisible"
              >
                  <h6 class="heading-small text-muted mb-4 text-truncate">Document Extras</h6>
                  <!-- {{this.document_config.document_type_settings.references}} -->

                <div class="row">
                  <div class="col text-left">
                    <small>Extra Atrribute</small>
                  </div>
                  <div class="col text-left">
                    <small>Value</small>
                  </div>
                </div>

                <div v-for="(attribute, value) in documentExtras" :key="attribute" class="row pt-2">
                  <div class="col">{{value}}</div>
                  <div class="col text-left">
                      {{attribute}}
                  </div>
                </div>
              </a-drawer>

              <!-- Drawer For View Allocation -->
              <a-drawer
                  :width="1500"
                  placement="right"
                  @close="closeDrawer('view_allocation')"
                  :visible="viewAllocation"
              >
                  <h6 class="heading-small text-muted mb-4 text-truncate">Site Allocation</h6>
                  <!-- {{this.document_config.document_type_settings.references}} -->
                  <div class="table-responsive pt-2">
                      <VueTabulator ref="tabulator1" v-model="documentLines" :options="optionsViewAllocation"/>
                  </div>
                  <div class="row">
                      <div class="col">
                          <span class="mr-auto font-weight-bold">Total Allocated Quantity: {{formatMyNumber(totalAllocatedQty, 0)}}</span>
                      </div>
                      <div class="col"></div>
                  </div>
              </a-drawer>

              <!-- Drawer for Document Payment -->
              <a-drawer :width="960" placement="right" :key="'documentPayment'+documentPaymentsKey" @close="closeDrawer('document_payments')" :body-style="{ paddingBottom: '80px' }" :visible="documentPaymentsDrawerVisible">
                  <h6 class="heading-small text-muted mb-4 text-truncate">Document Payments</h6>
                  <table style="width:100%">
                      <tr>
                          <th>Payment Mode</th>
                          <th>Amount</th>
                          <th>Reference</th>
                          <th>Payment Date</th>
                      </tr>
                      <tr v-for="p in documentPaymentsList" v-bind:key="'documentPaymentsList'+p.id">
                          <td>{{ p.payment_mode }}</td>
                          <td>{{ p.amount }}</td>
                          <td>{{ p.reference }}</td>
                          <td>{{ moment(p.payment_date).format('MM/DD/YYYY HH:mm') }}</td>
                      </tr>
                  </table>
              </a-drawer>

              <!-- Drawer for Ecom Document -->
              <a-drawer title="" :width="600" placement="right" @close="closeDrawer('ecomForm')" :visible="documentEcomDrawerVisible" v-if="documentEcomDrawerVisible">
                  <div>
                      <document-ecom-form @closeDrawer="ecomCloseDrawer" v-on:refreshPage="refreshPage" @postOrder="ecomPost" @deleteRow="deleteRow" :ecomAction="ecomAction" :documentDetails="documentDetails"> </document-ecom-form>
                  </div>
              </a-drawer>
              <!-- Drawer for lot code and expiry Allocation -->
              <a-drawer :width="520" placement="right" @close="closeDrawer('lotCodeExpiry')" :body-style="{ paddingBottom: '80px' }" :visible="lotCodeExpiryVisible">
                  <h3 class="heading-large text-muted mb-4">ITEM: {{ selectedLotCodeExpiryProduct.product_name }} <br> QTY: {{ selectedLotCodeExpiryProduct.quantity }} </h3>
                  <div>
                      <hr class="mt-1 mb-2">           
                      <div class="row">
                          <div class="col text-left">
                              <h5>Lot Code</h5>
                          </div>
                      </div>
                      <div class="row">
                          <div class="col">
                              <a-input v-if="!isLotCodeExpiryDisabled" v-model='inputLotCode' placeholder="Lot Code" />
                              <a-select v-else v-model='inputLotCode' @select='selectlotcodeSource' placeholder='Select Lot Code' style="width: 100%;" input-classes="form-control">
                                  <a-select-option :value="''" disabled>Select Lot Code</a-select-option>
                                  <a-select-option v-for="s in lotcodeSources && lotcodeSources.length ? lotcodeSources : []" :key="s['id']"> {{ s['lotcode'] }} | {{ moment(String(s['expired_at'])).format('YYYY-MM-DD') }}</a-select-option>
                              </a-select>
                              
                          </div>
                          <div class="col-auto">
                              <div v-if="(currentDocumentTypeCode == 'OTHPCN' || currentDocumentTypeCode == 'RECADJ' || currentDocumentTypeCode == 'RELADJ' || currentDocumentTypeCode == 'RECDEL') && documentStatus!='Posted'">
                                  <a-button v-if="isLotCodeExpiryDisabled && currentDocumentTypeCode != 'RELADJ'" @click="changeFormLotCodeExpiry('Create')" type="primary" block>New Lot Code & Expiry</a-button>
                                  <a-button v-if="!isLotCodeExpiryDisabled" @click="changeFormLotCodeExpiry('Select')" type="primary" block>Select Lot Code & Expiry</a-button>
                              </div>
                          </div>
                      </div>

                      <div class="row">
                          <div class="col text-left">
                              <h5>Expiry</h5>
                          </div>
                          <div class="col text-left">
                              <h5 v-if="!isLotCodeExpiryDisabled">Quantity</h5>
                              <h5 v-else>Available Quantity: {{ lotcodeAvailableQty }}</h5>
                          </div>
                          <div class="col-auto">
                          </div>
                      </div>
                      <div class="row">
                          <div class="col">
                              <a-date-picker v-model='inputExpiryAt' :disabled="isLotCodeExpiryDisabled" :disabled-date="disabledDate" placeholder="Expiry" format="YYYY-MM-DD" />
                          </div>
                          <div class="col">
                              <a-input
                                min="0"
                                :type="isPhysicalCountV2Document ? 'text' : 'number'"
                                :inputmode="isPhysicalCountV2Document ? 'numeric' : null"
                                :pattern="isPhysicalCountV2Document ? '[0-9]*' : null"
                                v-model='inputLotCodeQuantity'
                                placeholder="Quantity"
                                @keydown.native="preventInvalidLotCodeQuantityKey"
                                @paste.native="preventInvalidLotCodeQuantityPaste"
                                @drop.native="preventInvalidLotCodeQuantityDrop"
                                @input="normalizeLotCodeQuantityInput"
                                :disabled="isPhysicalCountV2QuantityEditLocked"
                              />
                          </div>
                          <div class='col-auto'>
                              <a-button type="primary" v-if="documentStatus!='Posted'" @click='submitDrawerLotCodeExpiry' :disabled='inputLotCode=="" || inputExpiryAt == "" || isPhysicalCountV2QuantityEditLocked' >Add</a-button>
                          </div>
                      </div>
                      <hr>
                      <div class="table-responsive">
                          <table class="table table-bordered table-sm">
                              <thead>
                                  <tr>
                                      <th scope="col">Lot Codes</th>
                                      <th scope="col">Expiry Dates</th>
                                      <th scope="col">Quantity</th>
                                      <th class="text-center" scope="col">Action</th>
                                  </tr>
                              </thead>
                              <tbody>
                                  <tr v-for="(data, index) in currentDrawerLotCodeExpiry" v-bind:key="'lotCodeExpiryKey'+index">
                                      <td class="align-middle">{{data.lot_code}}</td>
                                      <td class="align-middle">{{new Date(data.expiry_at).toLocaleString('en-US', {year: 'numeric', month: 'long', day: 'numeric'})}}</td>
                                      <td class="align-middle" v-if="selectedLotCodeExpiryProduct.product_type == 'P' && currentDocumentTypeCode.includes('REL')">{{data.actual_quantity}}</td>
                                      <td class="align-middle" v-else>{{data.quantity}}</td>
                                      <td class="text-center"><a-button size="small" type="danger"  v-if="documentStatus!='Posted'" @click="removeLotCodeExpiry(index)" :disabled="isPhysicalCountV2QuantityEditLocked">Remove</a-button></td>
                                  </tr>
                              </tbody>
                              <tfoot>
                                  <tr>
                                      <td colspan="2" align="right">
                                          <h3 v-if="selectedLotCodeExpiryProduct.product_type == 'P' && currentDocumentTypeCode.includes('REL')">Lot Code Total Content Quantity</h3>
                                          <h3 v-else>Lot Code Total Quantity</h3>
                                      </td>
                                      <td colspan="2" align="left"><h3>{{ lotcodeTotalQty }}</h3></td>
                                  </tr>
                                  <tr>
                                      <td colspan="2" align="right">
                                          <h3 v-if="selectedLotCodeExpiryProduct.product_type == 'P' && currentDocumentTypeCode.includes('REL')">Line Content Quantity</h3>
                                          <h3 v-else>Line Quantity</h3>
                                      </td>
                                      <td colspan="2" align="left">
                                          <h3 v-if="selectedLotCodeExpiryProduct.product_type == 'P' && currentDocumentTypeCode.includes('REL')">{{ selectedLotCodeExpiryProduct.quantity * selectedLotCodeExpiryProduct.content_quantity }}</h3>
                                          <h3 v-else>{{ selectedLotCodeExpiryProduct.quantity }}</h3>
                                      </td>
                                  </tr>
                              </tfoot>
                          </table>
                      </div>

                      <div v-if="documentStatus!='Posted'"
                          :style="{
                          position: 'absolute',
                          right: 0,
                          bottom: 0,
                          width: '100%',
                          borderTop: '1px solid #e9e9e9',
                          padding: '10px 16px',
                          background: '#fff',
                          textAlign: 'right',
                          zIndex: 1,
                          }"
                      >
                          <a-button @click='saveDrawerLotCodeExpiry' type="primary" block :disabled="isPhysicalCountV2QuantityEditLocked">Save Lot Code Expiry</a-button>
                      </div>
                  </div>
              </a-drawer>

              <!-- drawer for customizeList -->
              <a-drawer title="" width="480" placement="right" @close="()=>{isDrawerVisible = false}" :visible="isDrawerVisible" >
                      <b>Customize Fields</b>
                      <br/>
                      <small>Check the fields that you want to see on the list.</small>
                      <br/>
                      <h3 class="heading-small text-muted list-group-item">Available Fields</h3>
                      <li v-for="field in filteredColumnFields" :key="field.name" class="list-group-item">
                        <a-checkbox :checked="field.value"  @change="onCheck" :id="field.name">
                          {{_.startCase(field.name)}}
                        </a-checkbox>
                      </li>
                      <div class="float-right" style="position: absolute; bottom: 20px; right: 20px">
                        <button class="btn btn-primary float-right" @click.prevent="closeCustomizeListDrawer" > Update List </button>
                      </div>
              </a-drawer>
              <!-- drawer for sort -->
              <a-drawer
                  title=""
                  :width="800"
                  placement="right"
                  @close="onCloseSortDrawer"
                  :visible="sortDrawerVisibility"
                  >
                      <h6 class="heading-small text-muted mb-4">Sort</h6>
                          <sort-drawer :documentTypeCode="currentDocumentTypeCode" @saveSort="saveSort"></sort-drawer>
              </a-drawer>

              <a-modal v-model:open="showPrintingModal" title="Print Details" ok-text="Print" cancel-text="Cancel" :confirm-loading="printBarcodeLoading" @ok="printBarcode()">
                  <div class="row">
                      <div class="col-md-12">
                          <base-alert v-if="barcodeTemplateErrors.length" type="danger">
                              <b>You have the following error(s):</b>
                              <li v-for="error in barcodeTemplateErrors" :key="error">{{ error }}</li>
                          </base-alert>
                          <base-input alternative="" label="Select Printer Device" inputClasses="w-100">
                              <a-select
                              ref="select"
                              style="width: 100%"
                              placeholder="Select a Printer"
                              :notFoundContent="fetchingPrinterList ? undefined : null"
                              v-model="selectedPrinter">
                                  <a-spin v-if="fetchingPrinterList" slot="notFoundContent" size="small"/>
                                  <a-select-option v-for="p in printerList" :value="p">{{p}}</a-select-option>
                              </a-select>
                          </base-input>
                          <base-input alternative="" label="Select Format" inputClasses="w-100">
                              <a-select
                              ref="select"
                              style="width: 100%"
                              placeholder="Select a Template"
                              :notFoundContent="fetchingPrinterFormatList ? undefined : null"
                              @change="changePrinterFormat"
                              v-model="selectedPrinterFormat">
                                  <a-spin v-if="fetchingPrinterFormatList" slot="notFoundContent" size="small"/>
                                  <a-select-option v-for="p in printerFormatList" :value="p.id">{{p.name}}</a-select-option>
                              </a-select>
                          </base-input>
                          <base-input v-if="selectedPrinterFormat" alternative="" label="Description">
                              <ul>
                              <li v-for="d in selectedBarcodeFormat.descriptionList" :key="`${d + Math.random()}`">
                                  {{d}}</li>
                              </ul>
                          </base-input>
                      </div>
                  </div> 
                  
              </a-modal>

               <a-modal :visible="viewScanningScreenModal" width="70%" title="Scanning Screen" @ok="handleOk" @cancel="handleClose">
                  <div class="row py-2">
                      <div class="col-md-5">
                          <a-input v-model='barcodeSearch' placeholder="Barcode" @keydown.enter="searchProductBarcode" />
                      </div>
                      <div class='col-auto'>
                          <a-button type="primary" @click="searchProductBarcode">Add</a-button>
                      </div>
                  </div>
                  <div class="table-responsive">
                      <table class="table table-bordered table-sm">
                          <thead>
                              <tr>
                                  <th scope="col">Barcode</th>
                                  <th scope="col">Product Name</th>
                                  <th scope="col">Quantity</th>
                                  <th scope="col">Action</th>
                              </tr>
                          </thead>
                          <tbody>
                              <tr v-for="(product, index) in this.scannedProduct" v-bind:key="index">
                              <!-- <tr> -->
                                  <td class="align-middle">{{product.barcode}}</td>
                                  <td class="align-middle">{{product.name}}</td>
                                  <td class="align-middle">
                                      <a-input v-if="product.editMode" type="number" style="width: 50%" v-model="product.scanQuantity" />
                                      <p v-else>{{product.scanQuantity}}</p>
                                  </td>
                                  <td class="text-center">
                                      <a-button v-if="product.editMode" type="primary" class="btn ml-1 btn-primary btn-sm" @click="handleDoneEdit(index)">Save</a-button>
                                      <a-button v-else type="primary" class="btn ml-1 btn-primary btn-sm" @click="handleEdit(index)">Edit</a-button>
                                      <a-button type="danger" class="btn ml-1 btn-danger btn-sm" @click="handleRemove(index)">Remove</a-button>
                                  </td>
                              </tr>
                          </tbody>
                      </table>
                  </div>
              </a-modal>

          </div>
        </a-spin>
    </div>
</template>

<script>

    // import VueGoogleAutocomplete from 'vue-google-autocomplete';

    // import VueGoogleAutocomplete from 'vue-google-autocomplete';
    // import {gmapApi} from 'vue2-google-maps';
    import Pusher from 'pusher-js' // import Pusher
    import StockCard from '../Products/StockCard.vue';
    import { mapState, mapActions } from "vuex";
    import HTTPRequest from '../../controllers/httpRequest.js';
    import secureStorage from '../../controllers/secureStorage.js';
    import Autocomplete from "vuejs-auto-complete";
    import ValidateField from '../../components/validateFormUtils.js';
    import { isDocumentActionDisabled, shouldShowLoadingOverlay } from '../../utils/documentButtonState.js';
    import { normalizePhysicalCountV2Lines as normalizePcv2Lines, physicalCountV2LinesDirty as pcv2LinesDirty, physicalCountV2LotSaveBlocked as pcv2LotSaveBlocked, physicalCountV2IsStaleConflict as pcv2IsStaleConflict, physicalCountV2FreezeErrorMessages as pcv2FreezeErrorMessages, physicalCountV2EmptySaveBlocked as pcv2EmptySaveBlocked } from '../../utils/physicalCountV2Quantity.js';
    import { buildCountSetExportCsv } from '../../utils/countSetExportCsv.js';
    import { classifyViewDocumentLinesSelection, buildCountSetLinesUrl, resolveCountSetLinesResponse } from '../../utils/countSetDocumentLines.js';
    import moment from 'moment';
    import axios from "axios";
    import CustomerForm from '../Customer Profiles/CustomerForm.vue';
    import jsPDF from 'jspdf';
    import 'jspdf-autotable';
    import DocumentEcomForm from '../Documents/DocumentEcomForm.vue'
    import DocumentApplyToOtherSitesDrawer from './Drawers/DocumentApplyToOtherSitesDrawer.vue';
    import * as XLSX from 'xlsx';
    // import XLSX from 'xlsx';
    import { uploadToS3BackgroundProcess } from '../../utilities.js';
    import {Epsonfont} from '@/assets/fonts/Epson1-normal'
    import {Epsonfontbold} from '@/assets/fonts/Epson1-bold'
    import SortDrawer from './Drawers/SortDrawer.vue';
    import qz from '../../directives/qz-tray.js';
    import CmgPoFormat from '../../components/cmgPoFormat.js';
    import GoldwingRrFormat from '../../components/goldwingRrFormat.js';
    // import PrintMixin from './PrintMixin' //print() function inside this
    var component_x;
    //START OF HISTORY TABLE
    const historyColumns = [
        {
        title: 'Action',
        dataIndex: 'action',
        },
        {
        title: 'Action By',
        dataIndex: 'created_by',
        },
        {
        title: 'Action At',
        dataIndex: 'action_at',
        },
        {
        title: 'Remark',
        dataIndex: 'remark',
        },
    ];
    const historyData = [];

    var columns = []

    const getNotificationStyle = type => {
        return {
            success: {
                color: 'rgba(0, 0, 0, 0.65)',
                border: '1px solid #b7eb8f',
                backgroundColor: '#f6ffed'
            },
            warning: {
                color: 'rgba(0, 0, 0, 0.65)',
                border: '1px solid #ffe58f',
                backgroundColor: '#fffbe6'
            },
            error: {
                color: 'rgba(0, 0, 0, 0.65)',
                border: '1px solid #ffa39e',
                backgroundColor: '#fff1f0'
            },
            info: {
                color: 'rgba(0, 0, 0, 0.65)',
                border: '1px solid #91d5ff',
                backgroundColor: '#e6f7ff'
            }
        }[type]
    }

    //Start of Charge Table
    const chargeColumns = [
        {
            title: 'Description',
            dataIndex: 'name',
        },
        {
            title: 'Weight',
            dataIndex: 'weight',
        },
        {
            title: 'Rate',
            dataIndex: 'rate',
        },
        {
            title: 'Amount',
            dataIndex: 'amount',
            scopedSlots: { customRender: 'amount' },
            align: 'right'
        },
        {
            title: 'Date',
            dataIndex: 'created_at',
            scopedSlots: { customRender: 'charge_date' },
        },
        {
            title: 'Charge Type',
            dataIndex: 'charge_type',
            scopedSlots: { customRender: 'charge_type' }, 
        },
    ];
    //End of Charge Table

    //Start of Additional Charge Table
    const countSetLinesColumns = [
        { title: 'Line', dataIndex: 'line_no' },
        { title: 'Stock No', dataIndex: 'stock_no' },
        { title: 'Barcode', dataIndex: 'barcode' },
        { title: 'Product', dataIndex: 'product_name' },
        { title: 'Unit', dataIndex: 'unit_name' },
        { title: 'Quantity', dataIndex: 'quantity', align: 'right' },
        { title: 'Frozen Quantity', dataIndex: 'actual_quantity', align: 'right' }
    ]

    const additionalChargeColumns = [
        {
            title: 'Description',
            dataIndex: 'name',
        },
        {
            title: 'Weight',
            dataIndex: 'weight',
        },
        {
            title: 'Rate',
            dataIndex: 'rate',
        },
        {
            title: 'Amount',
            dataIndex: 'amount',
            scopedSlots: { customRender: 'amount' },
            align: 'right'
        }
    ];
    //End of Additional Charge Table
    
    //Start of Items for Additional Charge Table
    const itemsAdditionalChargeColumns = [
        {
            title: 'Line #',
            dataIndex: 'line_no',
            align: 'center'
        },
        {
            title: 'Barcode',
            dataIndex: 'barcode',
        },
        {
            title: 'Description',
            dataIndex: 'product_name',
        },
        {
            title: 'RR Quantity',
            dataIndex: 'rr_quantity',
            scopedSlots: { customRender: 'rr_quantity' },
            align: 'right'
        },
        {
            title: 'Inventory Quantity',
            dataIndex: 'quantity',
            scopedSlots: { customRender: 'quantity' },
            align: 'right'
        },
        {
            title: 'Cost',
            dataIndex: 'cost',
            scopedSlots: { customRender: 'cost' },
            align: 'right'
        },
        {
            title: 'New Cost',
            dataIndex: 'new_cost',
            scopedSlots: { customRender: 'new_cost' },
            align: 'right'
        },
        {
            title: 'Charge Share',
            dataIndex: 'charge_share',
            scopedSlots: { customRender: 'charge_share' },
            align: 'right'
        },
    ];
    //End of Charge Table

    //DocumentSettings
    const DistributionDocuments = {
        header: {
            showSublocationHeader: true,
            showDocumentHeader: true,
            showSublocationSite: true,
            showSublocationOrigin: true,
            showSublocationDestination: true,
            showPurpose: true,
        },
        headerOriSox: {
            showSublocationHeader: true,
            showDocumentHeader: true,
            showCustomer: true,
            showSalesman: true,
            showSublocationSite: true,
            showSublocationDestination: true,
            showOrderSource: false,
        },
        headerRelDde: {
            showSublocationHeader: true,
            showDocumentHeader: true,
            showCustomer: true,
            showSalesOrder: true,
            showSublocationOrigin: true,
            showSublocationDestination: true,
            showSublocationSite: true,
            showOrderSource: false,
        },
        headerOthSin: {
            showSublocationHeader: true,
            showDocumentHeader: true,
            showCustomer: true,
            showSalesOrder: true,
            showSublocationOrigin: true,
            showSublocationDestination: true,
            showSublocationSite: true,
            showDeliveryDocument: true,
            showOrderSource: true,
        },
        headerRecCsr: {
            showSublocationHeader: true,
            showDocumentHeader: true,
            showCustomer: true,
            showDeliveryDocument: true,
            showSublocationDestination: true,
            showSublocationSite: true,
            showOrderSource: false,
        },
        headerOroRso: {
            showDocumentHeader: true,
            showRevenue:false,
            showRequestingSite: true,
        }
    }
    const InterbranchDocuments = {
        //Header
        header: {
            showDocumentHeader: true,
            showSupplier: false,
            showSupplyingSite: true,
            showRequestingSite: true,
            showPurpose: false,
            showParty: false,
        }
    }
    const PurchaseDocuments = {
        //Header
        header: {
            showDocumentHeader: true,
            showSupplier: true,
            showSupplyingSite: false,
            showRequestingSite: false,
            showPurpose: false,
            showParty: false,
        },
        headerOriPox: {
            showDocumentHeader: true,
            showSupplier: true,
            showSupplyingSite: false,
            showRequestingSite: true,
            showPurpose: false,
            showParty: false,
        },
        headerOthSbi: {
            showDocumentHeader: true,
            showSupplier: true,
            showSupplyingSite: false,
            showRequestingSite: false,
            showPurpose: false,
            showParty: false,
            showRecevingReport: true,
        },
    }
    const LocalDocuments = {
        headerAdjustments: {
            showDocumentHeader: true,
            showSupplyingSite: false,
            showRequestingSit: false,
            showPurpose: true,
            showParty: true,
        }
    }
    const PCount = {
        header: {
            showDocumentHeader: true,
            showSupplyingSite: false,
            showRequestingSit: false,
            showPurpose: false,
            showParty: false,
            showSublocation: true

        }
    }
    const PriceWorkSheet = {
        header: {
            showDocumentHeader: true,
            showSupplier: true,
            showParty: false,
            showForThisSite: true,
            showApplyDocumentToOtherSitesButton: true,
            showSaveProductVia: true,
        }
    }
    const BarcodePrinting = {
        header: {
            showDocumentHeader: true,
            showSupplier: false,
            showParty: false,
            showForThisSite: false,
        }
    }
    const TransferAllocationDocumentPicking = {
        header: {
            showDocumentHeader: true,
            showSupplyingSite: true,
        }
    }
    const CountSet = {
        header: {
            showDocumentHeader: false,
            showSupplyingSite: false,
            showRequestingSit: false,
            showPurpose: false,
            showParty: false,
        }
    }

    export default {
        // mixins: [PrintMixin],
        components: {
            Autocomplete,
            StockCard,
            CustomerForm,
            DocumentEcomForm,
            DocumentApplyToOtherSitesDrawer,
            SortDrawer
            // VueGoogleAutocomplete
        },
        data: function() {
            return {
                createButtonMain: true, 
                proceed_voiding: 0,
                allowZeroCost: 0,
                autoRepMinMaxAccess: 0,
                autoRepOfftakeAccess: 0,
                purchaseVarianceAccess: 0,
                overrideMinMaxProducts: '',
                minMaxProducts: [],
                interval: null,
                overrideOfftakeProducts: '',
                offtakeProducts: [],
                backLink: "/documents?type=" + secureStorage.getItem("documentTypeInternalCode"),
                backLabel: "Back to Dashboard",
                isRefreshInventory: false,
                friendlyCodeAndDocumentNo: '',
                friendlyOriginDocumentNo: '',
                documentId: '',
                documentNo: 0,
                importMode: 'O',
                importerType: '1',
                importLotCode: 0,
                confirmLoadingonSuppModal: false,
                confirmLoadingonMinMaxModal: false,
                showChangeSupplierModal: false,
                modalInternalDocumentId: false,
                countSetLinesModalVisible: false,
                countSetLinesData: [],
                countSetLinesLoading: false,
                // Monotonic token used to ignore out-of-order responses: only the
                // most recently initiated View Document Lines request may write
                // countSetLinesData.
                countSetLinesRequestToken: 0,
                // Title + empty-state message for the Count Set lines modal.
                countSetLinesTitle: 'Count Set Document Lines',
                countSetLinesEmptyText: 'No document lines found',
                modalMinMaxProducts: false,
                modalAdditionalCharges: false,
                chargeDistributionQuantity: 1,
                itemCostLayerData: [],
                totalCharges: 0,
                totalPurchaseVariance: 0,
                modalMinMaxProducts: false,
                modalOffTakeProducts: false,
                offtakeDays: 60,
                // for product_icon
                icon_code: JSON.parse(localStorage.getItem("businessTypeCode")),

                // for customizing column fields per document type
                customFieldsX: [],
                documentTableFilteredList: secureStorage.getItem("documentTableFilteredList"),
                defaultColumnFields : [
                  { name: "line_no", value: true },
                  { name: "product_icon", value: true },
                  { name: "stock_no", value: true },
                  { name: "product_name", value: true },
                  { name: "barcode", value: true },
                  { name: "unit_name", value: true },
                  { name: "quantity", value: true },
                  { name: "price", value: true },
                  { name: "cost", value: true },
                  { name: "subtotal", value: true },
                  { name: "discount_text", value: true },
                  { name: "on_hand_quantity", value: true },
                  { name: "remarks", value: true },
                  { name: "available_quantity", value: false },
                  { name: "supplier", value: false },
                  { name: "category_code", value: false },
                  { name: "section_code", value: false },
                  { name: "erp_code", value: false },
                  { name: "department", value: false },
                  { name: "division", value: false },
                  { name: "design", value: false },
                  { name: "size", value: false },
                  { name: "product_series", value: false },
                  { name: "product_group", value: false },
                  { name: "subtotal_without_vat", value: false }
                ],
                filteredColumnFields : [],
                isDrawerVisible: false,

                popUpModal:{
                  isVisible: false,
                  toClear:false,
                  isAutoPopulate:false,
                  initializeProcess:"",
                  message:"",
                  text:""
                },
                showAddingProgress:{
                  isVisible: false,
                  productCount:0,
                  productAdded:0
                },

                //1935
                overallDiscountWithoutSupportDiscount: 0,

                // BOOKING DATA
                bookingId: null,
                activeBooking: false,
                recomputeModal: false,
                recompute: false,
                applyDocumentToOtherSitesDrawer: false,
                saveMassUploadProductVia: "barcode",
                originalGeoLocation: {},
                bookingDetails: {},
                printFontSizeIncrease: 0,
                printValueHeaderPos: 0,
                printValueFooterPos: 0,
                // printPaperSize: 'a4',
                mapKey: 0,
                center: {
                  lat: 10.0,
                  lng: 10.0
                },
                markers: [{
                  id: 1,
                  position: {
                    lat: 10.0,
                    lng: 10.0
                  }
                }, {
                  id: 2,
                  position: {
                    lat: 11.0,
                    lng: 11.0
                  }
                }],
                from_address: {},

                suppDetails: {},

                tabKey: 0,
                options: {
                    height:"100%",
                    pagination:"local",
                    paginationSize:23,
                    // http://tabulator.info/docs/4.2/page#element
                    paginationSizeSelector: [13,23,33,43,53],
                    selectable:true,
                    rowSelectionChanged: this.rowSelectionChanged,
                    //downloadDataFormatter: this.downloadDataFormatter,
                    downloadConfig:{
                        columnCalcs:false,
                    },
                    addRowPos:"bottom",
                    movableColumns:true,
                    index: "line_no",
                    columns: [
                        {
                            frozen: true,
                            formatter:"rowSelection",
                            titleFormatter:"rowSelection",
                            download: false,
                            headerSort:false,
                        },
                        {
                            title: '#',
                            field: 'line_no',
                            sorter: 'number',
                            frozen: true,
                            visible: false,
                        },
                        {
                            field: 'product_icon',
                            frozen: true,
                            visible: false,
                            download: false,
                            formatter: this.iconFormatter
                        },
                        {
                            title: 'Stock No',
                            field: 'stock_no',
                            sorter: 'number',
                            frozen: true,
                            visible: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Brand',
                            field: 'brand_name',
                            sorter: 'string',
                            frozen: true,
                            visible: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Description',
                            field: 'product_name',
                            editor: 'input',
                            sorter: 'string',
                            frozen: true,
                            editable: this.isCellEditable,
                            visible: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Supplier Stock No.',
                            field: 'supplier_stock_no',
                            sorter: 'number',
                            formatter: this.supplierStockNumber,
                            visible: false,
                            download: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Design',
                            field: 'design',
                            sorter: 'string',
                            formatter: this.designFormatter,
                            visible: false,
                            download: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Size',
                            field: 'size',
                            sorter: 'number',
                            // formatter: this.sizeFormatter,
                            visible: false,
                            download: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Color',
                            field: 'color',
                            sorter: 'string',
                            formatter: this.colorFormatter,
                            visible: false,
                            download: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Ref Code',
                            field: 'ref_code',
                            sorter: 'number',
                            visible: false,
                            download: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'ERP Code',
                            field: 'erp_code',
                            sorter: 'number',
                            visible: false,
                            download: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Barcode',
                            field: 'barcode',
                            sorter: 'number',
                            visible: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Unit',
                            field: 'unit_name',
                            visible: false,
                            sorter: 'string',
                            //editor: "select",
                            //formatter: this.unitFormatter,
                            //editorParams: this.unitLookup,
                            //editable: this.isCellEditable,
                            //accessorDownload: this.unitAccessor,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Ordered Quantity',
                            field: 'ordered_quantity',
                            sorter: 'number',
                            align: 'right',
                            visible: false,
                            download: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Actual Quantity',
                            field: 'actual_quantity',
                            sorter: 'number',
                            align: 'right',
                            visible: false,
                            download: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Requested Quantity',
                            field: 'requested_quantity',
                            sorter: 'number',
                            editor: 'number',
                            align: 'right',
                            bottomCalc:"sum",
                            editorParams:{
                                min:0,
                                max:10000000,
                                elementAttributes:{
                                    maxlength:"8",
                                }
                            },
                            editable: this.isCellEditable,
                            validator: this.validateQuantity,
                            visible: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Quantity',
                            field: 'quantity',
                            sorter: 'number',
                            editor: 'number',
                            align: 'right',
                            bottomCalc:"sum",
                            editorParams:{
                                min:0,
                                max:10000000,
                                elementAttributes:{
                                    maxlength:"8",
                                    'data-testid':function(cell){
                                     return "tabulator-quantity-input-"+cell._cell.row.data.line_no;
                                    }
                                }
                            },
                            editable: this.isCellEditable,
                            validator: this.validateQuantity,
                            visible: false,
                            tooltip: this.quantityTooltip,
                            formatter:function(cell, formatterParams){
                                var cellElement = cell.getElement(); // Get the DOM node for the cell
                                cellElement.setAttribute("data-testid", "tabulator-quantity-input-"+cell._cell.row.data.line_no); 
                                return cell.getValue(); // Return the cell's value for display
                            },
                            cellEdited: cell => this.handleLineAmountCellEdited(cell),
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Reason',
                            field: 'reason_id',
                            visible: false,
                            sorter: 'string',
                            editor: "select",
                            download: false,
                            formatter: this.reasonFormatter,
                            editorParams: this.reasonLookup,
                            //editable: this.isCellEditable,
                            //accessorDownload: this.unitAccessor,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Actual Yield Quantity',
                            field: 'actual_yield',
                            sorter: 'number',
                            editor: 'number',
                            align: 'right',
                            bottomCalc:"sum",
                            editorParams:{
                                min:0,
                                max:10000000,
                                elementAttributes:{
                                    maxlength:"8",
                                }
                            },
                            editable: this.isCellEditable,
                            validator: this.validateQuantity,
                            visible: false,
                            download: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Delivery Quantity',
                            field: 'delivery_quantity',
                            sorter: 'number',
                            editor: 'number',
                            align: 'right',
                            bottomCalc:"sum",
                            download: false,
                            editorParams:{
                                min:0,
                                max:10000000,
                                elementAttributes:{
                                    maxlength:"8",
                                }
                            },
                            editable: this.isCellEditable,
                            validator: this.validateQuantity,
                            visible: false,
                            cellEdited: cell => this.handleLineAmountCellEdited(cell),
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Goods Issue Quantity',
                            field: 'goods_issue_quantity',
                            sorter: 'number',
                            editor: 'number',
                            align: 'right',
                            bottomCalc:"sum",
                            editorParams:{
                                min:0,
                                max:10000000,
                                elementAttributes:{
                                    maxlength:"8",
                                }
                            },
                            editable: this.isCellEditable,
                            validator: this.validateQuantity,
                            visible: false,
                            download: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Frozen Quantity',
                            field: 'frozen_quantity',
                            sorter: 'number',
                            align: 'right',
                            visible: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Balance Quantity',
                            field: 'balance_quantity',
                            sorter: 'number',
                            align: 'right',
                            download: false,
                            visible: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Delivered Quantity',
                            field: 'content_quantity',
                            sorter: 'number',
                            align: 'right',
                            download: false,
                            visible: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Quantity',
                            field: 'quantity',
                            sorter: 'number',
                            editor: 'number',
                            align: 'right',
                            bottomCalc:"sum",
                            editorParams:{
                                min:0,
                                max:10000000,
                                elementAttributes:{
                                    maxlength:"8",
                                }
                            },
                            editable: this.isCellEditable,
                            validator: this.validateQuantity,
                            visible: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Old Landed',
                            field: 'old_landed_cost',
                            sorter: 'number',
                            editor: 'number',
                            align: 'right',
                            bottomCalc:"sum",
                            download: false,
                            editorParams:{
                                elementAttributes:{
                                    maxlength:"8",
                                }
                            },
                            editable: false,
                            visible: false,
                            formatter: 'money',
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'New Landed',
                            field: 'landed_cost',
                            sorter: 'number',
                            editor: 'number',
                            align: 'right',
                            bottomCalc:"sum",
                            download: false,
                            editorParams:{
                                elementAttributes:{
                                    maxlength:"8",
                                }
                            },
                            editable: this.isCellEditable,
                            visible: false,
                            formatter: 'money',
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Old Retail Price',
                            field: 'old_retail_price',
                            sorter: 'number',
                            editor: 'number',
                            align: 'right',
                            bottomCalc:"sum",
                            download: false,
                            editorParams:{
                                elementAttributes:{
                                    maxlength:"8",
                                }
                            },
                            editable: false,
                            visible: false,
                            formatter: 'money',
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'New Retail Price',
                            field: 'retail_price',
                            sorter: 'number',
                            editor: 'number',
                            align: 'right',
                            bottomCalc:"sum",
                            download: false,
                            editorParams:{
                                elementAttributes:{
                                    maxlength:"8",
                                }
                            },
                            editable: this.isCellEditable,
                            visible: false,
                            formatter: 'money',
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Unit Price',
                            field: 'price',
                            sorter: 'number',
                            editor: 'number',
                            align: 'right',
                            bottomCalc:"sum",
                            download: true,
                            editorParams:{
                                elementAttributes:{
                                    maxlength:"8",
                                }
                            },
                            editable: this.isCellEditable,
                            visible: false,
                            formatter: 'money',
                            formatterParams:{
                            precision:4},
                            cellEdited: cell => this.handleLineAmountCellEdited(cell),
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Unit Price (PHP)',
                            field: 'price_php',
                            sorter: 'number',
                            align: 'right',
                            bottomCalc:"sum",
                            visible: false,
                            download: false,
                            formatter: this.phpFormatter,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },

                        {
                            title: 'PI Price',
                            field: 'price_pi',
                            sorter: 'number',
                            editor: 'number',
                            align: 'right',
                            bottomCalc:"sum",
                            download: false,
                            editorParams:{
                                elementAttributes:{
                                    maxlength:"8",
                                }
                            },
                            editable: this.isCellEditable,
                            visible: false,
                            formatter: 'money',
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Net Cost (PHP)',
                            field: 'cost_php',
                            sorter: 'number',
                            align: 'right',
                            bottomCalc:"sum",
                            visible: false,
                            download: false,
                            formatter: this.phpFormatter,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Total Gross',
                            field: 'total_gross',
                            sorter: 'number',
                            align: 'right',
                            mutator: this.totalGrossMutator,
                            bottomCalc:"sum",
                            download: false,
                            visible: false,
                            formatter: 'money',
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Total Gross (PHP)',
                            field: 'total_gross_php',
                            sorter: 'number',
                            align: 'right',
                            download: false,
                            bottomCalc:"sum",
                            visible: false,
                            formatter: this.phpFormatter,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Discount',
                            field: 'discount_text',
                            sorter: 'string',
                            editor: 'input',
                            align: 'right',
                            download: false,
                            validator: this.validateTableDiscount,
                            editorParams:{
                                elementAttributes:{
                                    maxlength:"8",
                                }
                            },
                            editable: this.isCellEditable,
                            formatter:function(cell, formatterParams){
                                var cellElement = cell.getElement(); // Get the DOM node for the cell
                                cellElement.setAttribute("data-testid", "tabulator-discount-input-"+cell._cell.row.data.line_no); 
                                return cell.getValue(); // Return the cell's value for display
                            },
                            visible: false,
                            cellEdited: cell => this.handleLineAmountCellEdited(cell),
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Unit Net Cost',
                            field: 'cost',
                            sorter: 'number',
                            align: 'right',
                            visible: false,
                            download: false,
                            formatter: 'money',
                            formatterParams:{
                            precision:4},
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Subtotal',
                            field: 'subtotal',
                            sorter: 'number',
                            align: 'right',
                            download: true,
                            bottomCalc:"sum",
                            visible: false,
                            formatter: 'money',
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Subtotal (PHP)',
                            field: 'subtotal_php',
                            sorter: 'number',
                            align: 'right',
                            bottomCalc:"sum",
                            download: false,
                            visible: false,
                            formatter: this.phpFormatter,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Discount Amount',
                            field: 'discount',
                            sorter: 'number',
                            bottomCalc:"sum",
                            visible: false,
                            download: false,
                            formatter: 'money',
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Discount',
                            field: 'discount_text',
                            sorter: 'string',
                            editor: 'input',
                            align: 'right',
                            download: false,
                            validator: this.validateTableDiscount,
                            editorParams:{
                                elementAttributes:{
                                    maxlength:"18",
                                }
                            },
                            editable: this.isCellEditable,
                            visible: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Markup %',
                            field: 'markup_percent',
                            sorter: 'number',
                            editor: 'number',
                            align: 'right',
                            bottomCalc:"sum",
                            download: false,
                            editorParams:{
                                elementAttributes:{
                                    maxlength:"8",
                                }
                            },
                            editable: this.isCellEditable,
                            visible: false,
                            formatter: 'money',
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Old Original',
                            field: 'old_original_cost',
                            sorter: 'number',
                            editor: 'number',
                            align: 'right',
                            bottomCalc:"sum",
                            download: false,
                            editorParams:{
                                elementAttributes:{
                                    maxlength:"8",
                                }
                            },
                            editable: false,
                            visible: false,
                            formatter: 'money',
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'New Original',
                            field: 'original_cost',
                            sorter: 'number',
                            editor: 'number',
                            align: 'right',
                            bottomCalc:"sum",
                            download: false,
                            editorParams:{
                                elementAttributes:{
                                    maxlength:"8",
                                }
                            },
                            editable: this.isCellEditable,
                            visible: false,
                            formatter: 'money',
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Old Ordering',
                            field: 'old_ordering_cost',
                            sorter: 'number',
                            editor: 'number',
                            align: 'right',
                            bottomCalc:"sum",
                            download: false,
                            editorParams:{
                                elementAttributes:{
                                    maxlength:"8",
                                }
                            },
                            editable: false,
                            visible: false,
                            formatter: 'money',
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'New Ordering',
                            field: 'ordering_cost',
                            sorter: 'number',
                            editor: 'number',
                            align: 'right',
                            bottomCalc:"sum",
                            download: false,
                            editorParams:{
                                elementAttributes:{
                                    maxlength:"8",
                                }
                            },
                            editable: this.isCellEditable,
                            visible: false,
                            formatter: 'money',
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Old Whosale Price',
                            field: 'old_wholesale_price',
                            sorter: 'number',
                            editor: 'number',
                            align: 'right',
                            bottomCalc:"sum",
                            download: false,
                            editorParams:{
                                elementAttributes:{
                                    maxlength:"8",
                                }
                            },
                            editable: false,
                            visible: false,
                            formatter: 'money',
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'New Whosale Price',
                            field: 'wholesale_price',
                            sorter: 'number',
                            editor: 'number',
                            align: 'right',
                            bottomCalc:"sum",
                            download: false,
                            editorParams:{
                                elementAttributes:{
                                    maxlength:"8",
                                }
                            },
                            editable: this.isCellEditable,
                            visible: false,
                            formatter: 'money',
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Old Least Price',
                            field: 'old_least_price',
                            sorter: 'number',
                            editor: 'number',
                            align: 'right',
                            bottomCalc:"sum",
                            download: false,
                            editorParams:{
                                elementAttributes:{
                                    maxlength:"8",
                                }
                            },
                            editable: false,
                            visible: false,
                            formatter: 'money',
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'New Least Price',
                            field: 'least_price',
                            sorter: 'number',
                            editor: 'number',
                            align: 'right',
                            bottomCalc:"sum",
                            download: false,
                            editorParams:{
                                elementAttributes:{
                                    maxlength:"8",
                                }
                            },
                            editable: this.isCellEditable,
                            visible: false,
                            formatter: 'money',
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Old Special Price',
                            field: 'old_special_price',
                            sorter: 'number',
                            editor: 'number',
                            align: 'right',
                            bottomCalc:"sum",
                            download: false,
                            editorParams:{
                                elementAttributes:{
                                    maxlength:"8",
                                }
                            },
                            editable: false,
                            visible: false,
                            formatter: 'money',
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'New Special Price',
                            field: 'special_price',
                            sorter: 'number',
                            editor: 'number',
                            align: 'right',
                            bottomCalc:"sum",
                            download: false,
                            editorParams:{
                                elementAttributes:{
                                    maxlength:"8",
                                }
                            },
                            editable: this.isCellEditable,
                            visible: false,
                            formatter: 'money',
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'On-Hand Quantity',
                            field: 'on_hand_quantity',
                            sorter: 'number',
                            align: 'right',
                            visible: false,
                            download: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Invoice Amount',
                            field: 'invoice_amount',
                            sorter: 'number',
                            align: 'right',
                            visible: false,
                            download: false,
                            formatter: 'money',
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Invoice Discount',
                            field: 'invoice_discount',
                            sorter: 'number',
                            align: 'right',
                            visible: false,
                            download: false,
                            formatter: 'money',
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Unit Price (v)',
                            field: 'unit_price_vat',
                            sorter: 'number',
                            align: 'right',
                            visible: false,
                            download: false,
                            formatter: 'money',
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Net Price (v)',
                            field: 'net_price_vat',
                            sorter: 'number',
                            align: 'right',
                            download: false,
                            visible: false,
                            formatter: 'money',
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Subtotal (v)',
                            field: 'subtotal_vat',
                            sorter: 'number',
                            align: 'right',
                            download: false,
                            visible: false,
                            formatter: 'money',
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Unit Price (nv)',
                            field: 'unit_price_no_vat',
                            sorter: 'number',
                            align: 'right',
                            visible: false,
                            download: false,
                            formatter: 'money',
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Net Price (nv)',
                            field: 'price_without_vat',
                            sorter: 'number',
                            align: 'right',
                            bottomCalc:"sum",
                            visible: false,
                            formatter: 'money',
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Subtotal (nv)',
                            field: 'subtotal_without_vat',
                            sorter: 'number',
                            align: 'right',
                            bottomCalc:"sum",
                            visible: true,
                            download: false,
                            formatter: 'money',
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Effective Discount',
                            field: 'effective_discount',
                            sorter: 'number',
                            align: 'right',
                            download: false,
                            visible: false,
                            formatter: 'money',
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Incoming Quantity',
                            field: 'incoming_quantity',
                            sorter: 'number',
                            align: 'right',
                            download: false,
                            visible: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: '#',
                            width: '10%',
                            field: 'code_and_document_no',
                            visible: false,
                            download: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Document ID',
                            width: '10%',
                            field: 'id',
                            visible: false,
                            download: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Reference',
                            width: '10%',
                            field: 'reference_1',
                            visible: false,
                            download: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Document Date',
                            width: '10%',
                            field: 'document_date',
                            visible: false,
                            download: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Total Quantity',
                            width: '10%',
                            field: 'total_quantity',
                            visible: false,
                            download: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Status',
                            width: '10%',
                            field: 'status',
                            visible: false,
                            download: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Order Status',
                            width: '15%',
                            field: 'order_status',
                            visible: false,
                            download: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Created By',
                            width: '15%',
                            field: 'created_by',
                            visible: false,
                            download: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Updated By',
                            width: '15%',
                            field: 'updated_by',
                            visible: false,
                            download: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Remark',
                            field: 'remarks',
                            editor: 'input',
                            sorter: 'string',
                            visible: false,
                            download: true,
                            editable: this.isCellEditable,
                            formatter:function(cell, formatterParams){
                                var cellElement = cell.getElement(); // Get the DOM node for the cell
                                cellElement.setAttribute("data-testid", "tabulator-remark-input-"+cell._cell.row.data.line_no); 
                                return cell.getValue(); // Return the cell's value for display
                            },
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Misc4',
                            field: 'product_grade_id',
                            editor: 'input',
                            sorter: 'string',
                            visible: false,
                            download: false,
                            editable: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Product Grade',
                            field: 'product_grade_level',
                            // editor: 'input',
                            sorter: 'string',
                            visible: false,
                            download: false,
                            editable: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Salesman',
                            field: 'salesman_name',
                            editor: 'input',
                            sorter: 'string',
                            visible: false,
                            download: false,
                            editable: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Extras',
                            field: 'line_extras',
                            editor: 'textarea',
                            visible: false,
                            download: false,
                            editable: true,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Sublocation Alloation',
                            field: 'sublocation_allocation',
                            visible: false,
                            download: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Product Type',
                            field: 'product_type',
                            visible: false,
                            download: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Serial No',
                            field: 'document_line_serials_text',
                            visible: false,
                            download: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Lot Code',
                            field: 'document_line_lot_code',
                            visible: false,
                            download: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Expiry',
                            field: 'document_line_expiry',
                            visible: false,
                            download: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Available Quantity',
                            field: 'available_quantity',
                            sorter: 'number',
                            visible: false,
                            download: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Supplier',
                            field: 'supplier',
                            visible: false,
                            sorter: 'string',
                            download: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Category',
                            field: 'category',
                            visible: false,
                            sorter: 'string',
                            download: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Section',
                            field: 'section',
                            visible: false,
                            sorter: 'string',
                            download: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Department',
                            field: 'department',
                            visible: false,
                            sorter: 'string',
                            download: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Division',
                            field: 'division',
                            visible: false,
                            sorter: 'string',
                            download: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Category Code',
                            field: 'category_code',
                            sorter: 'string',
                            visible: false,
                            download: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                         {
                            title: 'Section Code',
                            field: 'section_code',
                            sorter: 'string',
                            visible: false,
                            download: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                         {
                            title: 'Product Group',
                            field: 'product_group',
                            sorter: 'string',
                            visible: false,
                            download: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                        {
                            title: 'Product Series',
                            field: 'product_series',
                            sorter: 'string',
                            visible: false,
                            download: false,
                            cellClick:function(e, cell){e.stopPropagation();}
                        },
                    ],
                },
                historyData,
                historyColumns,

                processingCsvUpload: false,
                CsvUploadParams: {},
                isS3Importing: false,
                s3ImportPollInterval: null,

                //Global
                spinning: false,
                spinning2: false,
                spinMessage: 'Loading..',
                // True while initializeDocument() is loading/building the form (including
                // large 500+ line documents). Used to show a visible loading overlay and to
                // keep the action buttons non-clickable until loading fully completes.
                isInitializing: false,
                documentNumber: -1,
                originDocumentNumber: -1,
                originDocumentTypeId: 0,
                originDocumentTypeName: null,
                originDocumentCodeAndNumber:"",
                documentStatus: null,
                documentOrderStatus: null,
                // CNC-002: server updated_at captured on load, echoed back on
                // Freeze for optimistic concurrency / stale-document detection.
                documentKnownUpdatedAt: null,
                // CNC-002: raw server order_status ('U'/'F'/...) captured on load.
                // Echoed back on Freeze so a same-second concurrent freeze (which
                // the second-precision updated_at cannot distinguish) is still
                // detected: if the winner already flipped U -> F, the loser's
                // known value no longer matches and it is rejected as stale.
                documentKnownOrderStatus: null,
                postClickCount: 0,

                notifMessage: [],
                document_config: null,
                currentDocumentTypeId: null,
                currentDocumentTypeName: null,
                currentDocumentTypeCode: null,
                currentDocumentTypeFriendlyCode: null,
                currentDocumentTypeFriendlyCodeWithId: "",
                headerStatusIcon: '',
                headerOrderStatusIcon: '',

                //Configuration
                maximumDocumentLineNumber: 200,
                decimalPlaces: 2,
                fixedDecimalPlaces: 4,

                //Document Header
                    header: {
                        showDocumentHeader: false,
                        showSupplier: false,
                        showSupplyingSite: false,
                        showRequestingSite: false,
                        showPurpose: false,
                        showParty: false,
                    },

                    //For all
                    fetching: false,
                    sites: [],
                    supplyingSites: [],
                    requestingSites: [],
                    distributionSites: [],
                    validDocumentSitesForPosting: [],
                    supplyingSitesCacheKey: '',
                    requestingSitesCacheKey: '',
                    distributionSitesCacheKey: '',

                    //Suppliers
                    supplier: [],
                    suppliers: [],
                    isSupplierDisabled: false,
                    showSupplierOptions: false,
                    isTradeToggleDisabled: false,
                    showTradeToggle: false,

                    //Supplying Site
                    supplyingSite: [],
                    isSupplyingSiteDisabled: false,

                    //Requesting Site
                    requestingSite: [],
                    isRequestingSiteDisabled: false,

                    //Revenue Site
                    revenue:'',
                    isRevenueDisabled: false,

                    //Distributon
                    sublocations: [],
                    distributionSite: {key: secureStorage.getItem("defaultSiteId").toString(), label: secureStorage.getItem("defaultSiteName")},
                    isDistributionSiteDisabled: false,
                    originSublocation: [],
                    isOriginSublocationDisabled: false,
                    destinationSublocation: [],
                    isDestinationSublocationDisabled: false,
                    sublocationOriginLabel: 'Sublocation Origin',
                    sublocationDestinationLabel: 'Sublocation Destination',
                    showHeaderDiscount: false,

                    customer: [],
                    customers: [],
                    isCustomerDisabled: false,
                    isCustomerCreateDisabled: false,

                    salesman: {},
                    salesmen: [],
                    isSalesmanDisabled: false,

                    salesOrder: 0,
                    isSalesOrderDisabled: true,

                    deliveryDocument: 0,
                    isDeliveryDocumentDisabled: true,

                    isRecevingReportDisabled: true,
                    receivingReport: 0,

                    // Purpose and Party
                    purpose: [],
                    purposes: [],
                    party: '',

                    isPurposeDisabled: false,
                    isPartyDisabled: false,

                    //Add Product / Search Product
                    showDocumentBodyHeader: true,
                    productFormMode: "Add",
                    productFormModeOptions: [
                        { label: 'Add Products to this Document', value: 'Add' },
                        { label: 'Search within this Document', value: 'Search' },
                    ],
                    productSearchInput: '',
                    addedProductSearchInput: '',

                    selectedParentProduct: [],
                    selectedProduct: [],

                    //Search Filter
                    placeholder: "Search product by barcode",
                    addedProductPlaceholder: "Search added product by barcode",
                    searchFilter: "barcode",
                    searchFilterAddedProduct: "barcode",

                    //Product Search
                    authHeaders: { Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web", 'ip':secureStorage.getItem("ipAddress") },
                    isProductSearchDisabled: false,

                    //Product Name
                    isProductNameEditConfigDisabled: false,
                    isProductNameDisabled: true,
                    productName: '',
                    inputProduct: '',
                    productPriceChoice: 'landed_cost', //Default from config is landed_cost

                    //Document Line Form
                    isDocumentLineFormDisabled: true,
                    quantity: '',
                    actual_yield: '',
                    tolerance_quantity: '',
                    unit: [],
                    units: [],
                    productComposition: [],
                    productCompositions: [],
                    unitQuantity: 1,
                    unitCost: '',
                    discountText: [],
                    unitNetCost: '',
                    subTotal: '0.00',
                    retailPrice: 0,

                    promoName: null,
                    rewardCode: null,
                    rewardDiscountAmount: 0,

                    discountTotal: 0,

                    showPwsCosts: false,
                    showQuantity: true,
                    showActualYield: false,
                    showUnitCost: true,
                    showDiscount: true,
                    showUnitNetCost: true,
                    showSubtotal: true,

                    //isDirtyData
                    isEditing: false, // track unsaved changes
                    isChangeAction: false,

                    //Document Form Table

                    selectedDocumentLines: [],
                    origData: [],
                    data: [],
                    columns,

                //Summary
                totalQuantity: 0,
                grossAmountDisplay: 0.00,
                netAmountDisplay: 0.00,
                grossAmount: 0.00,
                itemDiscount: 0.00,
                overallDiscount: 0.00,
                netAmount: 0.00,
                vatAmount: 0.00,
                totalWithVat: 0.00,
                taxRate: 0,
                grossAmountwithoutTax: 0.00,
                netAmountWithoutTax: 0.00,

                documentDate: moment(new Date()),
                targetDate:  moment(new Date()),
                cancellationDate: moment(new Date()).add('30', 'days'),
                showTargetDate: true,
                showCancellationDate: true,

                headerDiscount: [],

                supportDiscount: [],
                showSupportDiscount: false,
                isSupportDiscountValid: true,

                isHeaderDiscountDisabled: false,
                isDocumentDateDisabled: false,
                isTargetDateDisabled: false,
                isCancellationDateDisabled: false,

                vatExclusiveCheckbox: false,
                isVatEx: false,
                showVatExclusiveCheckboxConfig: true,
                showVatExclusiveCheckbox: false,
                showSummaryCalculation: true,
                showTotalQuantity: true,

                party_tax_type: 'V',

                //Advanced Info
                paymentTerm: [],
                paymentTerms: [],

                shippingMethod: [],
                shippingMethods: [],
                showShippingMethod: false,

                showAdvancedInfo: false,
                isReferenceDisabled: false,
                isPaymentTermDisabled: false,
                isShippingMethodDisabled: false,
                isSupportsDiscountDisabled: false,

                reference : '',
                remark: '',
                remarkLabel: 'Remark',

                //Charge Table and Drawer
                disableSaveCharges: false,
                chargeData: [],
                additionalChargeData: [],
                additionalChargeSelectedRowKeys: [],
                chargeSelectedRowKeys: [],
                chargeColumns,
                additionalChargeColumns,
                countSetLinesColumns,
                itemsAdditionalChargeColumns,
                chargeDrawerVisible: false,
                chargeType: 'R',
                chargeTypeOptions: [
                    {key: "R", value: "Regular Charge"},
                    {key: "W", value: "Weighted Charge"}
                ],
                isAddChargeDisabled: false,

                chargeDescription: null,
                chargeWeight: 0,
                chargeRate: 0,
                chargeAmount: 0,
                isChargeWeightDisabled: true,
                isChargeRateDisabled: true,
                isChargeAmountDisabled: false,
                showChargesTable: false,

                //Booking Integration
                showBookingButton: false,
                bookingDrawerVisible: false,
                siteAddress: null,
                siteContactPerson: null,
                siteContactNumber: null,
                addressEditMode: false,
                deliveryMode: "8",
                orderParemeters: {},

                // payments
                paymentDrawerVisible: false,
                initialDepositDrawerVisible:false,
                paymentMode: "paymaya",
                paymentMethod: null,
                paymentMethods: [],
                bankTransferReference: '',
                baseUrl: "https://test.dragonpay.ph/api/collect/v2",

                // Document Footer Actions
                isSaveDisabled: false,
                isfreezeDisabled:false,
                isUpdateDisabled: false,
                isUpdating: false,
                isPostDisabled: false,
                showconfirmUnconfirmButton: false,
                showCreateChildDocButton: false,
                createChildDocButtonLabel: '',
                showDeliverButton: false,
                showPayButton: false,

                accessRights: [],
                accessCostPriceRights: [],

                //Document Action History
                historyDrawerVisible: false,
                tabulator: null,
                tabulator1:null,

                stockCardVisible: false,
                selectedStockCardProduct: null,
                stockCardKey: 0,


                sublocationAllocationVisible: false,
                selectedSublocationAllocationProduct: {},
                sublocationAllocationKey: 0,

                siteAllocationVisible: false,
                selectedSiteAllocationProduct: {},
                siteAllocationKey: 0,

                massAddDrawerVisible: false,
                massAddDrawerKey: 0,

                onHandQuantity: 0,

                orderSource: [],
                isOrderSourceDisabled: false,
                orderSources: [],
                isOrderSourceMode: false,
                showFreezeButton:false,

                customerDrawerVisible: false,
                customerDrawerKey: 0,
                customerAddress: "",
                customerContactMobile: "",
                customerContactTelephone: "",
                customerContactFax: "",
                customerContactEmail: "",
                selectedCustomerContact: "",
                activeCustomerContact: '',

                map: undefined,
                forPaymentIsPosting: false,
                continueAutoCreatePoExceedRr: false,
                continueWithPriceDiscrepancy: false,
                forPaymentIsProcessed: false,
                paymentErrors: [],
                initialDepositErrors:[],
                massAddProductErrors:[],
                massAddProductErrorsDL: [],
                dlDUplicateSkus: 0,
                dlDUplicateSkusItems: [],
                dlSkusNotFound: 0,
                dlSkusNotFoundItems: [],
                showPrint: false,
                postDate: null,

                isHeaderOnly: false,
                isDocumentTrade: true,

                addProductConfirmationVisible: false,

                forThisSite: {key: secureStorage.getItem("defaultSiteId").toString(), label: secureStorage.getItem("defaultSiteName")},
                forThisSites: [],

                //PWS
                oldOrdering: null,
                oldLanded: null,
                oldRetailPrice: null,
                newOrdering: null,
                newLanded: null,
                newRetailPrice: null,
                markUp: null,
                showFilteredBySupplier: false,
                filteredBySupplier: false,
                isForThisSiteDisabled: false,

                //Currency
                currency: [],
                currencies: [],
                currencyRate: 0,
                defaultCurrencyRate:0,
                hasDefaultCurrency:false,
                currencyDetails:{},
                showConversionRate:false,

                // References
                referenceDrawerVisible: false,

                drawerSublocation: {key: 0, label: "Please select a sublocation"},
                drawerSublocations: [],
                drawerSublocationSiteId: null,
                drawerSublocationQuantity: '',
                drawerCurrentSublocationAllocation: [],
                sublocationAllocationErrors: [],
                allowSublocationAllocation: false,

                //Transfer Allocation
                drawerSite: {key: 0, label: "Please select a site"},
                drawerSites: [],
                drawerSiteId: null,
                drawerSiteQuantity: '',
                drawerCurrentSiteAllocation: [],
                allowSiteAllocation: false,
                siteAllocationErrors: [],

                createdBy: '',
                postedBy: '',

                // form printing module
                modalFormPrinting: false,
                formPrintPrinter: 'pdf',
                formPrintFormat: '',
                formPrintFormatOptions: [],

                // serialization
                serializationKey: 0,
                serializationVisible: false,
                serializationErrors: [],
                selectedSerialProduct: {},
                currentDrawerSerials: [],
                currentDrawerSerialsInstance: [],
                previousSerialCount:0,
                currentSerialCount:0,
                defaultCountValue:0,
                inputSerialNumber: '',
                serialMessage: "inputted",
                documentIsRel:false,

                file: '',
                documentImageKey: 0,
                documentImageDrawerVisible: false,
                imageFileUrl: '',

                documentPaymentsKey: 0,
                documentPaymentsDrawerVisible: false,
                documentPaymentsList: [],

                siteSublocation: [],
                isSiteSublocationDisabled: false,

                postedASMDSM: false,
                documentEcomDrawerVisible:false,
                ecomAction:null,
                documentDetails:[],
                imagepath: secureStorage.getItem("account_logo"),
                documentID:null,
                isPCountDocumentSearchDisabled:false,
                addPCountDocumentConfirmationVisible: false,
                selectedDocumentID:null,
                selectedDocumentLineRows:null,
                continuePostCountSetDocument:false,
                isSetOtherItemInventoryToZero:false,
                initialDeposit:{
                    amount:0,
                    reference:null,
                    payment_mode:"Initial Deposit",
                    status:"A",
                    payment_date: moment(new Date())
                },

                asnModule: 0,
                maxLines: 0,
                autoCreateAlterSupp: false,
                filterBySupp: false,
                fileList: [],
                suppItems: [],
                csvData: '',
                documentExtras: {},
                extrasDrawerVisible: false,
                autoPostDD: false,
                autoPostDDAndSI:false,
                openCSR: false,
                configuredExtras: {},
                validationdocutypes : ["OTHPUR", "ORIPOX", "ORIASN", "RECDEL", "RECPOS"],
                HideDeleteAndAddProductButton:false,
                supplierDetails:{},
                forceFetchCurrency:false,
                isCurrencyToPhp:false,
                filterExistingProductData:[],
                isRunDefaultCurrency:false,
                defaultCurrencyDetails:{},
                isEditAllocation:false,
                isEditAllocationIndex:0,
                siteAllocationRemainingQuantity:null,
                massAddWithAllocationProductErrors:[],
                fileWithAllocationList:[],
                massAddWithAllocationDrawerVisible:false,
                processingXlsxUpload: false,
                xlsxUploadFormData: {},
                viewAllocation:false,
                documentLines:[],
                continueWithPrintPdf:true,
                printDefault:true,
                costUpdated:false,
                optionsViewAllocation: {
                    height:"100%",
                    pagination:"local",
                    paginationSize:20,
                    columns: [
                        {
                            title: 'Line No',
                            field: 'line_no',
                            sorter: 'number',
                            frozen: true,
                        },
                        {
                            title: 'Stock No',
                            field: 'stock_no',
                            sorter: 'number',
                            frozen: true,
                        },
                        {
                            title: 'Description',
                            field: 'product_name',
                            editor: 'input',
                            sorter: 'string',
                            frozen: true,
                        },
                        {
                            title: 'Barcode',
                            field: 'barcode',
                            sorter: 'number',
                        },
                        {
                            title: 'Quantity',
                            field: 'quantity',
                            sorter: 'number',
                        },
                        {
                            title: 'Cost',
                            field: 'price',
                            formatter: 'money',
                        },
                        {
                            title: 'Subtotal',
                            field: 'subtotal',
                            sorter: 'number',
                            formatter: 'money',
                        },
                    ]
                },
                totalAllocatedQty:0,
                referenceLabel:"Reference",
                displayNetAmountWOVat:false,
                displayVatAmount:false,
                displayNetAmountWOVatLabel:"Net Amount w/o VAT",
                lotCodeExpiryVisible: false,
                inputLotCode: "",
                inputLotCodeQuantity: 0,
                inputExpiryAt: undefined,
                lotCodeExpiryKey: 0,
                selectedLotCodeExpiryProduct: {},
                currentDrawerLotCodeExpiry: [],
                revenueCreditingMode:'',
                RequestingLabel:'Requesting',
                revenueOption:[
                    {key: "R", value: "Requesting"},
                    {key: "T", value: "Target"}
                ],
                revenueSiteId:0,
                continueAutoCreateTr:false,
                isConfirmDisabled:false,
                supplierCurrencyRate:0,
                supplierCurrencyId:-1,
                currencyRateLabel:null,
                sortOrder: [],
                sortDrawerVisibility: false,
                sortInput: {},
                isLotCodeExpiryDisabled: false,
                lotcodeSources: [],
                lotcodeSource: [],
                lotcodeTotalQty: 0,
                lotcodeAvailableQty: 0,
                relatedDocument: [],
                documentRelation: '',
                //zalora
                zaloraPrintWayBillStatus: null,
                zaloraPrintWayBillDisabled: true,
                zaloraPrintWayBillDLink: null,
                zaloraPrintWayBillId:null,
                //flag for documents with upload
                isUploaded: false,
                defaultSite: secureStorage.getItem("defaultSiteId"),
                documentCurrentSite:secureStorage.getItem("defaultSiteId"),
                existingDocumentTypeId:-1,
                existingDocumentTypeDetails:[],
                showPrintingModal:false,
                viewScanningScreenModal: false,
                barcodeSearch: null,
                scannedProduct: [],
                scanQuantity: 1,
                editScannedProduct: false,
                printerList:[],
                selectedPrinter:null,
                fetchingPrinterList:true,
                selectedPrinterFormat:null,
                printerFormatList:[],
                fetchingPrinterFormatList:false,
                printBarcodeLoading:false,
                selectedBarcodeFormat:{},
                loadingBarcodePrintingModal:false,
                barcodeTemplateErrors:[],
                okPostProps:{props: { 'data-testid': 'yes-post-button' }}
            }
        },
        // Track Unsaved Changes on Document
        // beforeMount() {

        // },

        // async beforeRouteLeave(to, from, next) {
        //     var data = this.tabulator.getData();
        //     if (data.length > 0) {
        //         this.isEditing = !(component_x.origData === JSON.stringify(data))
        //     }
        //     if (this.isEditing && !this.isChangeAction) {
        //         if (!window.confirm("Leave without saving?")) {
        //             return;
        //         }
        //     }
        //     next();
        // },

        async beforeRouteLeave(to, from, next) {
            if (this.isDirty && !this.isChangeAction) {
              this.$confirm({
                title:"Document line has been modified",
                content: "There are unsaved changes in the document.\n Clicking 'Ok' will discard changes. Do you want to proceed?",
                onOk(){
                  next()
                }
              })
            }else{
              next();
            }    
        },

        destroyed () {
            window.removeEventListener('scroll', this.handleScroll);
            if(this.s3ImportPollInterval) clearInterval(this.s3ImportPollInterval);
        },

        beforeMount: async function() {
            window.addEventListener("beforeunload", this.preventNav)
            this.$once("hook:beforeDestroy", () => {
                this.isEditing = false
                window.removeEventListener("beforeunload", this.preventNav);
            })

            //[ERK] Turn off ASN button
            let qryasnModule = await HTTPRequest.getRequest(this.endPoint + "system_module_categories?code=PTP-006", null, null)
            this.asnModule = qryasnModule.length

            //Fix: S3 image CORS error in jsPDF
            const corsImageModified = new Image();
            corsImageModified.crossOrigin = "Anonymous";
            corsImageModified.id = "logobarter";
            corsImageModified.src = secureStorage.getItem("account_logo") + "?not-from-cache-please";
            document.getElementById("logoDiv").appendChild(corsImageModified);
            //Fix: S3 image CORS error in jsPDF

            console.log("Checking Doc Type")
            console.log(this.$route.params.document_typex)

            if (secureStorage.getItem("documentTypeInternalCode") == 'OTHPWS'){
                this.backLink = "/products_v2?type=OTHPWS"
            }else if (secureStorage.getItem("documentTypeInternalCode") == 'OTHBAR'){
                this.backLink = "/products_v2?type=OTHBAR"
            } else {
                if (this.$route.params.document_typex != undefined){
                    this.backLink = "/documents?type=" + this.$route.params.document_typex
                    this.existingDocumentTypeDetails.type = this.$route.params.document_typex
                } else if (this.$route.query.type != undefined) {
                    this.backLink = "/documents?type=" + this.$route.query.type
                    this.existingDocumentTypeDetails.type = this.$route.query.type
                } else {
                    this.backLink = "/documents?type=" + secureStorage.getItem("documentTypeInternalCode")
                }
            }

            if(this.$route.params.document_type_v2 != undefined){
                console.log(this.$route.params.document_type_v2)
                this.backLink = "/physical_count_v2"
                this.backLabel = "Back to Physical Count V2"
            } else if (['OTHPCN', 'OTHCNS'].includes(secureStorage.getItem("documentTypeInternalCode"))) {
                this.backLink = "/physical_count_v2"
                this.backLabel = "Back to Physical Count V2"
            }

            console.log(">>> Back Link")
            console.log(this.backLink)

            if (this.$route.params.id != undefined){
                if (this.$route.params.id > 0){
                    if(this.$route.params.id) secureStorage.setItem("temp_document_id", this.$route.params.id);
                } else {
                    secureStorage.setItem("temp_document_id", 0);
                }
            }

            // If route params are missing but query.type is available, resolve document type from API
            if (this.$route.params.document_type_id == undefined && this.$route.query.type != undefined) {
                var docTypeQueryCode = this.$route.query.type
                var docTypesFromQuery = await HTTPRequest.getRequest(this.endPoint + 'document_types/get_document_types_on_system_modules?code=' + docTypeQueryCode, null)
                if (docTypesFromQuery && docTypesFromQuery.length > 0) {
                    var resolvedDocType = docTypesFromQuery[0]
                    this.existingDocumentTypeId = resolvedDocType.id
                    this.currentDocumentTypeId = resolvedDocType.id
                    this.existingDocumentTypeDetails.existingDocumentTypeId = resolvedDocType.id
                    this.currentDocumentTypeName = resolvedDocType.name
                    this.existingDocumentTypeDetails.currentDocumentTypeName = resolvedDocType.name
                    this.currentDocumentTypeCode = resolvedDocType.trans_code + resolvedDocType.type_code
                    this.existingDocumentTypeDetails.currentDocumentTypeCode = this.currentDocumentTypeCode
                    this.currentDocumentTypeFriendlyCode = resolvedDocType.friendly_code
                    this.existingDocumentTypeDetails.currentDocumentTypeFriendlyCode = resolvedDocType.friendly_code
                }
            } else {
            if (this.$route.params.document_type_id != undefined){
                if (this.$route.params.document_type_id > 0){
                    this.existingDocumentTypeId = this.$route.params.document_type_id 
                    this.currentDocumentTypeId = this.$route.params.document_type_id 
                    this.existingDocumentTypeDetails.existingDocumentTypeId = this.$route.params.document_type_id 
                }else {
                    this.currentDocumentTypeId = secureStorage.getItem('documentTypeId') 
                }
            }else {
                this.currentDocumentTypeId = secureStorage.getItem('documentTypeId') 
            }
            if (this.$route.params.documentTypeName != undefined){
                this.currentDocumentTypeName = this.$route.params.documentTypeName 
                this.existingDocumentTypeDetails.currentDocumentTypeName = this.currentDocumentTypeName
            }else {
                this.currentDocumentTypeName = secureStorage.getItem('documentTypeName')
            }
            if (this.$route.params.documentTypeCode != undefined){
                this.currentDocumentTypeCode = this.$route.params.documentTypeCode
                this.existingDocumentTypeDetails.currentDocumentTypeCode = this.currentDocumentTypeCode

            }else {
                this.currentDocumentTypeCode = secureStorage.getItem('documentTypeCode')
            }
            if (this.$route.params.documentTypeFriendlyCode != undefined){
                this.currentDocumentTypeFriendlyCode = this.$route.params.documentTypeFriendlyCode 
                this.existingDocumentTypeDetails.currentDocumentTypeFriendlyCode = this.currentDocumentTypeFriendlyCode
            }else {
                this.currentDocumentTypeFriendlyCode = secureStorage.getItem('documentTypeFriendlyCode')
            }
            }
            if (this.$route.params.documentSiteId !=undefined){
                this.documentCurrentSite = this.$route.params.documentSiteId
            }else {
                this.documentCurrentSite = secureStorage.getItem("defaultSiteId")
            }
            // check if the trigger is from stockCard hyperlink
            let fromStockCard = secureStorage.getItem('fromStockCard')
            console.log(fromStockCard)
            if(fromStockCard){
              this.backLink = "/products_v2"
            }

            this.documentNumber = secureStorage.getItem('temp_document_id');
            this.currentDocumentTypeFriendlyCodeWithId = this.currentDocumentTypeFriendlyCode+"#"+this.documentNumber

            await this.fetchValidDocumentSitesForPosting();
            await this.initializeDocument();
            await this.getSettings();
            this.mountedAlreadyRendered = true
           
        },
        computed: {
            ...mapState(['endPoint', 'parentId', 'parameters', 'serverType', 'publicUrl', 'checkCurrentSite']), 
            isDirty(){return this.isEditing},
            // Visibility of the blocking loading overlay shown while the document form
            // is still loading/building (see initializeDocument + isInitializing).
            showDocumentLoadingOverlay(){ return shouldShowLoadingOverlay(this.isInitializing) },
            // Action button disabled states. Each button stays disabled while the document
            // is initializing so it cannot be clicked before loading fully completes.
            updateButtonDisabled(){ return isDocumentActionDisabled(this.isUpdateDisabled, this.isInitializing) },
            confirmButtonDisabled(){ return isDocumentActionDisabled(this.isConfirmDisabled, this.isInitializing) },
            postButtonDisabled(){ return isDocumentActionDisabled(this.isPostDisabled, this.isInitializing) },
            // google: gmapApi,
            chargeRowSelection() {
                // eslint-disable-next-line
                const { chargeSelectedRowKeys } = this;
                return {
                    onChange: (chargeSelectedRowKeys) => {
                        var charges = [];
                        this.chargeData.forEach(function(x){
                            charges.push(x.line_no)
                        });
                        // eslint-disable-next-line
                        this.chargeSelectedRowKeys = _.intersection(chargeSelectedRowKeys, charges)
                    }
                }
            },
            additionalChargeRowSelection() {
                const { additionalChargeSelectedRowKeys } = this;

                return {
                    onChange: (additionalChargeSelectedRowKeys) => {
                        var additionalcharges = [];
                        this.additionalChargeData.forEach(function(x){
                            additionalcharges.push(x.line_no)
                        });
                        // eslint-disable-next-line
                        this.additionalChargeSelectedRowKeys = _.intersection(additionalChargeSelectedRowKeys, additionalcharges)
                    }
                }
            },
            formattedsearchFilter(){
                return (this.searchFilter == 'product_id') ? 'code' : this.searchFilter
            },
            formattedsearchFilterAddedProduct(){
                return (this.searchFilterAddedProduct == 'product_id') ? 'code' : this.searchFilterAddedProduct
            },
            isPhysicalCountV2Document(){
                if (this.$route.params.document_type_v2 === 'OTHPCNV2') return true;
                let extras = this.documentDetails && this.documentDetails.extras ? this.documentDetails.extras : {};
                if (typeof extras === 'string') {
                    try {
                        extras = JSON.parse(extras);
                    } catch {
                        extras = {};
                    }
                }
                return this.currentDocumentTypeCode === 'OTHPCN' && extras.physical_count_version === 'v2';
            },
            // Structured "created from" source stored in the document extras.
            // Full source detail (all source document ids) lives here regardless
            // of the reference_1 50-char limit.
            physicalCountCreatedFromSource(){
                let extras = this.documentDetails && this.documentDetails.extras ? this.documentDetails.extras : null;
                if (typeof extras === 'string') {
                    try {
                        extras = JSON.parse(extras);
                    } catch {
                        extras = null;
                    }
                }
                return extras && extras.physical_count_source ? extras.physical_count_source : null;
            },
            physicalCountCreatedFromLabel(){
                const source = this.physicalCountCreatedFromSource;
                if (source && source.type) {
                    const labels = {
                        auto_populate: 'Auto-Populate via Advanced Filter',
                        consolidate: 'Merged Similar Entries',
                        uncounted: 'Uncounted Items',
                        count_set_duplicates: 'Count Set Duplicates',
                        count_set_generated: 'Generated from Count Set',
                    };
                    const base = labels[source.type] || 'Physical Count';
                    const ids = Array.isArray(source.document_ids) ? source.document_ids : [];
                    return ids.length > 0 ? `${base} (${ids.length} source doc${ids.length === 1 ? '' : 's'})` : base;
                }
                // Fallback to raw reference_1 for legacy documents.
                return (this.documentDetails && this.documentDetails.reference_1) || '';
            },
            physicalCountCreatedFromTooltip(){
                const source = this.physicalCountCreatedFromSource;
                if (source && Array.isArray(source.document_ids) && source.document_ids.length > 0) {
                    return `Source document IDs: ${source.document_ids.join(', ')}`;
                }
                return (this.documentDetails && this.documentDetails.reference_1) || '';
            },
            requiresFreezeBeforePhysicalCountV2QuantityEdit(){

                // console.log("!!!!!!!!!!!!!!!!!>>>>>>>>")
                // console.log(this.document_config)

                if (!this.document_config || !this.document_config.document_type_settings) return false;
                return this.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.require_freeze_before_qty_edit === true;
            },
            isPhysicalCountV2Frozen(){
                return ['Frozen', 'Frozen/Fulfilled', 'Fulfilled', 'F'].includes(this.documentOrderStatus);
            },
            isPhysicalCountV2QuantityEditLocked(){
                return this.isPhysicalCountV2Document && this.requiresFreezeBeforePhysicalCountV2QuantityEdit && !this.isPhysicalCountV2Frozen;
            },
            isPhysicalCountV2ProductListLocked(){
                return this.isPhysicalCountV2Document && this.isPhysicalCountV2Frozen;
            },
            canPrintPhysicalCountV2CountSheet(){
                return this.isPhysicalCountV2Document && this.currentDocumentTypeCode === 'OTHPCN' && this.documentStatus === 'Saved';
            },
            canPostStiDestinationSite(){
                return this.hasStiDestinationSiteAccess();
            },
            canShowPostAction(){
                return this.accessRights.includes('P') && this.canPostStiDestinationSite;
            },
            // Merge Similar Entries is available only for persisted, saved
            // Physical Count V2 documents. Both document action menus use this
            // guard before calling mergePhysicalCountV2SimilarEntries().
            canMergePhysicalCountV2SimilarEntries(){
                return this.isPhysicalCountV2Document && this.documentNumber > 0 && this.documentStatus == 'Saved';
            },
        },
        created() {
            this.subscribe()
        },
        methods:{
            ...mapActions(['updateCheckCurrentSite']),
            siteIdValue(site) {
                if (site == undefined || site == null || site === '') return null;
                if (typeof site === 'number' || typeof site === 'string') return site;
                if (site.key != undefined && site.key != null && site.key !== '') return site.key;
                if (site.id != undefined && site.id != null && site.id !== '') return site.id;
                if (site.value != undefined && site.value != null && site.value !== '') return site.value;
                return null;
            },
            async fetchValidDocumentSitesForPosting() {
                const sites = await HTTPRequest.getRequest(this.endPoint + 'sites/get_valid_document_sites', null);
                this.validDocumentSitesForPosting = Array.isArray(sites) ? sites : [];
            },
            hasStiDestinationSiteAccess(document, documentTypeCode = this.currentDocumentTypeCode) {
                if (documentTypeCode !== 'RECTRX') return true;
                const destinationSiteId = this.siteIdValue(document && document.target_site_id)
                    || this.siteIdValue(this.requestingSite)
                    || this.siteIdValue(this.documentDetails && this.documentDetails.target_site_id);
                if (!destinationSiteId) return false;
                return this.validDocumentSitesForPosting.some(site => {
                    return this.siteIdValue(site).toString() === destinationSiteId.toString();
                });
            },
            rejectUnauthorizedStiView(redirect = true) {
                this.$notification['error']({
                    message: 'Access Denied',
                    description: 'You do not have access to this site.',
                    style: getNotificationStyle('error')
                });
                this.spinning = false;
                if (redirect) this.$router.replace(this.backLink);
            },
            rejectUnauthorizedStiPost() {
                this.notifMessage = ['You do not have access to this site.'];
                this.documentActionNotification('post', 'error');
                this.isPostDisabled = false;
                this.spinning = false;
                this.postClickCount = 0;
            },
            async filterViewableRelatedDocuments(relatedDocuments) {
                if (!Array.isArray(relatedDocuments) || relatedDocuments.length <= 0) return [];
                if (this.validDocumentSitesForPosting.length <= 0) {
                    await this.fetchValidDocumentSitesForPosting();
                }
                var documentTypes = await HTTPRequest.getRequest(this.endPoint + '/document_types/get_document_types_on_system_modules', null, null);
                var viewableDocuments = [];
                for (var i = 0; i < relatedDocuments.length; i++) {
                    var relatedDocument = relatedDocuments[i];
                    var relatedDocumentType = Array.isArray(documentTypes) ? documentTypes.find(x => x.id === relatedDocument.document_type_id) : undefined;
                    var relatedDocumentTypeCode = relatedDocumentType ? relatedDocumentType.trans_code + relatedDocumentType.type_code : '';
                    if (relatedDocumentTypeCode == 'RECTRX') {
                        var documentForAccessCheck = relatedDocument.target_site_id ? relatedDocument : await HTTPRequest.getRequest(this.endPoint + "documents/"+relatedDocument.id, null);
                        if (!this.hasStiDestinationSiteAccess(documentForAccessCheck, relatedDocumentTypeCode)) continue;
                    }
                    viewableDocuments.push(relatedDocument);
                }
                return viewableDocuments;
            },
          showCustomizeListDrawer() {
            this.isDrawerVisible = true
          },
          checkCustomizedFields(docTypeCode) {
            const currentSettings = this.documentTableFilteredList.filter(({ docType }) => docType === docTypeCode)
            
            if (currentSettings.length > 0) {
              var { customFields } = currentSettings[0]
              if (customFields.length !== 0) {
                var new_customFieldsX = this.customFieldsX.map(a => a.name)

                // console.log("Before filter")
                // console.log(customFields)

                console.log("// START - GETS USER DEFINED FIELDS //")
                var cur_customFields  = []
                for(var i =0; i < customFields.length; i++){
                    let chk = customFields[i]
                    if(chk.custom != undefined){
                        cur_customFields.push(chk)
                    }
                }
                cur_customFields = cur_customFields.map(a => a.name)
                // console.log("cur_customFields")
                // console.log(cur_customFields)
                // console.log("// END - GETS USER DEFINED FIELDS //") 

                // Add New
                for(var i = 0; i <= new_customFieldsX.length; i++){
                    let checker = new_customFieldsX[i]

                    if(!cur_customFields.includes(checker)){
                        var new_field = {
                            name: checker,
                            value: false,
                            custom: true
                        }
                        customFields.push(new_field)
                        // customFields[checker] = new_customFieldsX[checker]
                    }
                }

                // Remove
                for(var i = 0; i <= cur_customFields.length; i++){
                    let checker = cur_customFields[i]
                    
                    if(!new_customFieldsX.includes(checker)){
                        // Remove from customFields
                        customFields = customFields.filter(function( obj ) {
                            return obj.name !== checker;
                        });
                    }
                }

                // Merge in any newly-introduced built-in default fields that are
                // missing from the user's saved customization (e.g. a column added
                // in a later release like "discount"/Discount Amount). Without this,
                // users who already have a saved Customize List never see new default
                // columns in the grid or the Customize Fields drawer.
                var existing_field_names = customFields.map(function(obj){ return obj.name })
                this.defaultColumnFields.forEach(function(def){
                    if(!existing_field_names.includes(def.name)){
                        customFields.push({ name: def.name, value: def.value })
                    }
                })

                this.filteredColumnFields = customFields

                console.log("Custom Fields")
                console.log(customFields)

                this.renderColumnFields()
              } 
            } 
          },
          assignCustomizedFields(docTypeCode, fieldsList, docDefaultFields){
            console.log("Assign Customized Fields")
            console.log(this.documentTableFilteredList)
            // const currentSettings = this.documentTableFilteredList.filter(({ docType }) => docType === docTypeCode)
            const currentSettings = Array.isArray(this.documentTableFilteredList)
                ? this.documentTableFilteredList.filter(({ docType }) => docType === docTypeCode)
                : [];

            if (this.documentTableFilteredList !== null && currentSettings.length != 0) {
              this.checkCustomizedFields(docTypeCode)
            } else {
              secureStorage.setItem("documentTableFilteredList", [{ docType: docTypeCode, customFields: fieldsList }])
              this.documentTableFilteredList = [{ docType: docTypeCode, customFields: fieldsList }]
              this.filteredColumnFields = docDefaultFields
            }
          },

          onCheck(e) {
            const { checked, id } = e.target
            const tempValue = this.filteredColumnFields.map((field) => {
              if (field.name === id) {
                return { ...field, value: checked }
              }
              return field
            })
            this.filteredColumnFields = tempValue
          },
          closeCustomizeListDrawer() {
            const listIsZero = this.filteredColumnFields.filter(({ value }) => value === true)
            let data = listIsZero.length === 0 ? this.defaultColumnFields : this.filteredColumnFields
            if (listIsZero.length === 0) this.filteredColumnFields = data
            if (this.documentTableFilteredList !== null) {
              const isExisting = this.documentTableFilteredList.filter(({ docType }) => docType === this.currentDocumentTypeCode)
              if (isExisting.length === 0) {
                console.log("Not yet existing")
                secureStorage.setItem("documentTableFilteredList", [...this.documentTableFilteredList, { docType: this.currentDocumentTypeCode, customFields: data }])
                this.documentTableFilteredList = [...this.documentTableFilteredList, { docType: this.currentDocumentTypeCode, customFields: data }]
              } else {
                console.log("Already existing")
                const newState = this.documentTableFilteredList.map(
                    (prevState) => {
                        if (prevState.docType === this.currentDocumentTypeCode) {
                            console.log("For the document type")
                            return { ...prevState, customFields: data }
                        } 

                        return prevState
                    }
                )
                secureStorage.setItem("documentTableFilteredList", newState)
                this.documentTableFilteredList = newState
              }
            } else {
              console.log("documentTableFilteredList is null")
              secureStorage.setItem("documentTableFilteredList", [{ docType: this.currentDocumentTypeCode, customFields: data }])
              this.documentTableFilteredList = [{ docType: this.currentDocumentTypeCode, customFields: data }]
            }
            this.renderColumnFields()
            this.isDrawerVisible = false
          },
            disabledDate(current) {
                return false;
            },
            selectlotcodeSource(value) {
                this.lotcodeSources.map(item => {
                  if(item['id'] == value){
                    this.inputExpiryAt = item['expired_at']
                    this.inputLotCodeQuantity = 0
                    this.lotcodeAvailableQty = item['available_quantity']
                  }
                })
            },
            showInternalDocumentId(){
                this.modalInternalDocumentId = true;
            },
            handleCancel(e){
                this.modalInternalDocumentId = false;
            },
            showSortDrawer(){
                this.sortDrawerVisibility = true;
            },
            async saveSort(value) {
                if(value != null && value != '' && value != '[]' ){
                    let storeName = "documentTypeSort" + this.currentDocumentTypeCode
                    localStorage.setItem(storeName, JSON.stringify(value));
                    await this.sortDocument(value)
                }else{
                    let storeName = "documentTypeSort" + this.currentDocumentTypeCode
                    localStorage.removeItem(storeName); 
                    this.tabulator.setSort([{column: 'line_no', dir: 'asc'}])
                }
                this.onCloseSortDrawer();
            },
            onCloseSortDrawer(){
                this.sortDrawerVisibility = false
            },
            async sortDocument(val){
                let newVal = []
                val.forEach((val) => {
                    newVal.push({column: val.field_name, dir: val.order_by})
                })
                await this.tabulator.setSort(newVal);
                // console.log(me, this.tabulator.getSorters())
            },
            filterOption(input, option) {
                return (
                    option.componentOptions.children[0].text
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                );
            },
            isUnitCostDisabled(){
                if(this.currentDocumentTypeCode === 'ORISOX'){
                     if(this.isDocumentLineFormDisabled || this.isOrderSourceMode){
                        return true
                    }else {
                        return false
                    }
                }else{
                    if(this.isDocumentLineFormDisabled){
                        return true
                    }else{
                        return false
                    }
                }
            },
            printDupSKUs() {
                let csv = 'Barcode\n' + this.dlDUplicateSkusItems.toString().replace(/,/g, '\n');
                const anchor = document.createElement('a');
                anchor.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv);
                anchor.target = '_blank';
                anchor.download = 'Duplicate Barcodes.csv';
                anchor.click();

            },
            printSKUsNotFound() {
                let csv = 'Barcode\n' + this.dlSkusNotFoundItems.toString().replace(/,/g, '\n');
                const anchor = document.createElement('a');
                anchor.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv);
                anchor.target = '_blank';
                anchor.download = 'Barcodes Not Found.csv';
                anchor.click();

            },
            async selectSiteSublocation (siteSublocation) {
                var arr = {
                    key:siteSublocation.key.replace('sublocations',''),
                    label:siteSublocation.label
                }
                siteSublocation = arr
                Object.assign(this, {
                    siteSublocation,
                    sublocations: [],
                    fetching: false,
                })
            },
            async submitFile(){
                this.spinning = true;
                let data = new FormData();
                data.append('file', this.file);

                //Get S3 uploader endpoint
                var uploader_endpoint = await HTTPRequest.getRequest(this.endPoint + 'settings/api_s3_uploader', null, null)
                var config = {
                    method: 'post',
                    url: uploader_endpoint['endpoint'] + '?profile=' + secureStorage.getItem('documentTypeName') + '&account_name=' + secureStorage.getItem("accountName"),
                    headers: {'Authorization': 'Bearer ' + secureStorage.getItem("accessToken")},
                    data : data
                };
                var response_data;
                await axios(config)
                    .then(function (response) {
                        response_data = response.data
                    })
                    .catch(function (error) {
                        //console.log(error)
                });
                this.imageFileUrl = response_data.path || ''
                this.spinning = false;

                var documentPayload = {document_id: this.documentNumber, image_url: this.imageFileUrl}
                var post_request = await HTTPRequest.postRequest(this.endPoint + 'documents/save_image_url', null, documentPayload)

            },
            handleFileUpload(){
                this.file = this.$refs.file.files[0];
            },
            async saveDrawerSublocationAllocation(){
                await this.tabulator.updateData([{line_no: this.selectedSublocationAllocationProduct.line_no, sublocation_allocation: this.drawerCurrentSublocationAllocation}])
                this.closeDrawer('sublocationAllocation');
            },
            async saveDrawerSiteAllocation(){
                await this.tabulator.updateData([{line_no: this.selectedSiteAllocationProduct.line_no, site_allocation: this.drawerCurrentSiteAllocation}])
                this.closeDrawer('siteAllocation');
            },
            async saveDrawerLotCodeExpiry(){
                if(this.isPhysicalCountV2QuantityEditLocked){
                    return
                }
                var line_no = this.selectedLotCodeExpiryProduct.line_no
                var lineqty = (this.currentDrawerLotCodeExpiry.length > 0) ? this.currentDrawerLotCodeExpiry.map(row => row.quantity).reduce((sumqty, qty) => Number(qty) + Number(sumqty)) : 0;
                var contentqty = ((this.selectedDocumentLines[0].product_type == 'P' && this.currentDocumentTypeCode.includes('REL')) ? this.selectedDocumentLines[0].content_quantity : 1)
                if(lineqty != (this.selectedDocumentLines[0].quantity) && lineqty > 0 && (this.currentDocumentTypeCode.includes("REC") || this.currentDocumentTypeCode.includes("REL") || this.currentDocumentTypeCode.includes("OTH"))){
                    this.$confirm({
                        title: 'Proceed?',
                        content: h => <div>Quantity is not equal, do you want to override?</div>,
                        onOk: () => {
                            this.applyLotCodes(lineqty, line_no)
                        },
                        onCancel() {}
                    });
                    return
                } else if(lineqty != (this.selectedDocumentLines[0].quantity) && lineqty > 0 && this.currentDocumentTypeCode.includes("REL")){
                    this.$notification['error']({
                        message: 'Lot Code Expiry',
                        description: "Line Quantity and Lot Code Total Quantity should be equal!",
                        style: getNotificationStyle('error')
                    });
                    return
                } else if(pcv2LotSaveBlocked(this.currentDrawerLotCodeExpiry)){
                    // LOT-007 (TC-PCV2-LOT-007): a zero lot quantity is a valid
                    // non-negative whole number and must be accepted. Only block
                    // when NO lot rows were entered at all — not when rows exist
                    // but their total happens to be 0.
                    this.$notification['error']({
                        message: 'Lot Code Expiry',
                        description: "Lot Code & Expiry date is required for this item!",
                        style: getNotificationStyle('error')
                    });
                    return
                } else {
                    await this.tabulator.updateData([{line_no: line_no, product_id: this.selectedLotCodeExpiryProduct.product_id, quantity: (lineqty), document_line_locations: this.currentDrawerLotCodeExpiry}])
                    //Recalculate
                    await this.recalculateLine(this.selectedLotCodeExpiryProduct.product_id, line_no)
                    this.calculateSummary();
                    this.closeDrawer('lotCodeExpiry')
                }
            },
            async changeFormLotCodeExpiry(type) {
                if(type == "Create"){
                    this.isLotCodeExpiryDisabled = false
                } else {
                    this.isLotCodeExpiryDisabled = true
                }
            },
            async applyLotCodes(lineqty, line_no) {
                 if(this.isPhysicalCountV2QuantityEditLocked){
                     return
                 }
                 await this.tabulator.updateData([{line_no: line_no, product_id: this.selectedLotCodeExpiryProduct.product_id, quantity: lineqty, document_line_locations: this.currentDrawerLotCodeExpiry}])
                 //Recalculate
                 await this.recalculateLine(this.selectedLotCodeExpiryProduct.product_id, line_no)
                 this.calculateSummary();
                 this.closeDrawer('lotCodeExpiry')
            },
            isValidLotCodeQuantityValue(value){
                return value === '' || /^[0-9]+$/.test(String(value));
            },
            preventInvalidLotCodeQuantityKey(event){
                if(!this.isPhysicalCountV2Document) return
                if(event.ctrlKey || event.metaKey || event.altKey) return

                const allowedKeys = ['Backspace', 'Delete', 'Tab', 'Enter', 'Escape', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End']
                if(allowedKeys.includes(event.key)) return
                if(/^[0-9]$/.test(event.key)) return

                event.preventDefault()
            },
            preventInvalidLotCodeQuantityPaste(event){
                if(!this.isPhysicalCountV2Document) return
                const pastedValue = event.clipboardData ? event.clipboardData.getData('text') : ''
                if(!this.isValidLotCodeQuantityValue(pastedValue)){
                    event.preventDefault()
                }
            },
            preventInvalidLotCodeQuantityDrop(event){
                if(!this.isPhysicalCountV2Document) return
                const droppedValue = event.dataTransfer ? event.dataTransfer.getData('text') : ''
                if(!this.isValidLotCodeQuantityValue(droppedValue)){
                    event.preventDefault()
                }
            },
            normalizeLotCodeQuantityInput(value){
                if(!this.isPhysicalCountV2Document) return
                const inputValue = value && value.target ? value.target.value : value
                if(!this.isValidLotCodeQuantityValue(inputValue)){
                    this.inputLotCodeQuantity = ''
                }
            },
            normalizeLotCodeExpiryDate(value){
                if(value == undefined || value === '') return ''
                if(moment.isMoment(value)) return value.format('YYYY-MM-DD')
                return moment(String(value)).format('YYYY-MM-DD')
            },
            selectedLotCodeExpiryValue(selectedLotCode){
                return {
                    lotCode: String((selectedLotCode == null || selectedLotCode == 0) ? this.inputLotCode : selectedLotCode).trim(),
                    expiryAt: this.normalizeLotCodeExpiryDate(this.inputExpiryAt),
                }
            },
            lotCodeExpiryRows(locations){
                if(Array.isArray(locations)) return locations
                if(locations && locations.data != undefined) return this.lotCodeExpiryRows(locations.data)
                if(locations && typeof locations === 'object') return [locations]
                return []
            },
            hasDuplicateLotCodeExpiryForSameBarcode(selectedLotCode){
                if(!this.isPhysicalCountV2Document || !this.tabulator) return null

                const selectedLineNo = Number(this.selectedLotCodeExpiryProduct.line_no)
                const selectedBarcode = String(this.selectedLotCodeExpiryProduct.barcode || '').trim()
                if(!selectedBarcode) return null

                const selected = this.selectedLotCodeExpiryValue(selectedLotCode)
                if(!selected.lotCode || !selected.expiryAt) return null

                const matchingLine = this.tabulator.getData().find(row => {
                    if(Number(row.line_no) === selectedLineNo) return false
                    if(String(row.barcode || '').trim() !== selectedBarcode) return false

                    const locations = this.lotCodeExpiryRows(row.document_line_locations)
                    return locations.some(location => {
                        return String(location.lot_code || '').trim() === selected.lotCode &&
                            this.normalizeLotCodeExpiryDate(location.expiry_at) === selected.expiryAt &&
                            location.status !== 'D'
                    })
                })

                return matchingLine || null
            },
            duplicateLotCodeExpiryMessagesForPhysicalCountV2(lines = []){
                if(!this.isPhysicalCountV2Document) return []

                const seen = {}
                const messages = []

                lines.forEach(row => {
                    const barcode = String(row.barcode || '').trim()
                    if(!barcode) return

                    this.lotCodeExpiryRows(row.document_line_locations)
                        .filter(location => location.status !== 'D')
                        .forEach(location => {
                            const lotCode = String(location.lot_code || '').trim()
                            const expiryAt = this.normalizeLotCodeExpiryDate(location.expiry_at)
                            if(!lotCode || !expiryAt) return

                            const key = `${barcode}|${lotCode}|${expiryAt}`
                            if(seen[key] != undefined){
                                messages.push(`Lot code and expiry date combination ${lotCode} / ${expiryAt} is already used by line number ${seen[key]} for barcode ${barcode}. Line number ${row.line_no} must use a different lot code or expiry date.`)
                            } else {
                                seen[key] = row.line_no
                            }
                        })
                })

                return messages
            },
            async submitDrawerLotCodeExpiry() {
                if(this.isPhysicalCountV2QuantityEditLocked){
                    return
                }
                if(this.inputExpiryAt == undefined || this.inputExpiryAt == ''){
                    this.$notification['error']({
                        message: 'Lot Code Expiry',
                        description: "Cannot add Lot Code. Expiry date is required",
                        style: getNotificationStyle('error')
                    });
                    return
                }
                if(this.inputLotCode == undefined || this.inputLotCode == ''){
                    this.$notification['error']({
                        message: 'Lot Code Expiry',
                        description: "Cannot add Lot Code. Lot Code is required"
                    });
                    return
                }
                if(this.isPhysicalCountV2Document && !this.isValidLotCodeQuantityValue(this.inputLotCodeQuantity)){
                    this.$notification['error']({
                        message: 'Lot Code Expiry',
                        description: "Lot code quantity must be a non-negative whole number.",
                        style: getNotificationStyle('error')
                    });
                    return
                }

                let selectedLotCode = 0
                if (this.lotcodeSources && this.lotcodeSources.length) {
                    this.lotcodeSources.map(item => {
                        if(item['id'] == this.inputLotCode)
                            selectedLotCode = item['lotcode']
                    })
                }

                let lotCodeError = 0
                this.currentDrawerLotCodeExpiry.map(item => {
                    if((item['lot_code'] == selectedLotCode && this.isLotCodeExpiryDisabled) || (item['lot_code'] == this.inputLotCode && moment(String(item['expiry_at'])).format('YYYY-MM-DD') == moment(String(this.inputExpiryAt)).format('YYYY-MM-DD') && !this.isLotCodeExpiryDisabled))
                        lotCodeError++
                })

                if(this.currentDocumentTypeCode.includes('REL') && this.isLotCodeExpiryDisabled && Number(this.inputLotCodeQuantity) > Number(this.lotcodeAvailableQty)) {
                    this.$notification['error']({
                        message: 'Lot Code Expiry',
                        description: "Lot code quantity is greater than available quantity!",
                        style: getNotificationStyle('error')
                    });
                    return
                }

                if(lotCodeError > 0) {
                    this.$notification['error']({
                        message: 'Lot Code Expiry',
                        description: "Lot code selected or encoded is already on the list!",
                        style: getNotificationStyle('error')
                    });
                    return
                }

                const duplicateLine = this.hasDuplicateLotCodeExpiryForSameBarcode(selectedLotCode)
                if(duplicateLine) {
                    this.$notification['error']({
                        message: 'Lot Code Expiry',
                        description: `Lot code and expiry date combination is already used by line number ${duplicateLine.line_no} for the same barcode.`,
                        style: getNotificationStyle('error')
                    });
                    return
                } else {
                    var contentqty = ((this.selectedDocumentLines[0].product_type == 'P' && this.currentDocumentTypeCode.includes('REL')) ? this.selectedDocumentLines[0].content_quantity : 1)

                    this.currentDrawerLotCodeExpiry.push(
                        {
                            line_no: this.selectedLotCodeExpiryProduct.line_no,
                            lot_code: (selectedLotCode == null || selectedLotCode == 0) ? this.inputLotCode : selectedLotCode,
                            //expiry_at: (this.currentDocumentTypeCode.includes("REL")) ? this.inputExpiryAt : (new Date(this.inputExpiryAt)).toISOString(),
                            expiry_at: (this.currentDocumentTypeCode.includes("REL")) ? this.inputExpiryAt : moment(this.inputExpiryAt, "YYYY-MM-DD"),
                            status: "A",
                            quantity: Number(this.inputLotCodeQuantity / contentqty),
                            actual_quantity: Number(this.inputLotCodeQuantity),
                            content_quantity: this.selectedLotCodeExpiryProduct.content_quantity.toString()
                        }
                    )
                    this.inputLotCode = ''
                    this.inputLotCodeQuantity = 0
                    this.inputExpiryAt = ''
                    this.lotcodeTotalQty = 0
                    this.lotcodeAvailableQty = 0
                    this.currentDrawerLotCodeExpiry.map(item => {
                        if (contentqty == 1)
                            this.lotcodeTotalQty += Number(item['quantity'])
                        else 
                            this.lotcodeTotalQty += Number(item['actual_quantity'])
                    })
                }
            },
            updateSerialLineStatus(index){
                if(this.currentDrawerSerials[index].status == "D"){
                    this.currentDrawerSerials[index].status = "A"
                }else{
                    this.currentDrawerSerials[index].status = "D"
                }
            },
            removeSerialNumber(index){
                if(this.isPhysicalCountV2QuantityEditLocked){
                    return
                }
                this.currentDrawerSerials.splice(index, 1);
            },
            removeSublocationAllocation(index){
                this.drawerCurrentSublocationAllocation.splice(index, 1);
            },
            removeSiteAllocation(index){
                this.drawerCurrentSiteAllocation.splice(index, 1);
                var total_site_quantity = this.drawerCurrentSiteAllocation.reduce((a, {quantity}) => a + parseInt(quantity), 0);
                this.siteAllocationRemainingQuantity = Number(this.selectedSiteAllocationProduct.quantity) - Number(total_site_quantity)
            },
            removeLotCodeExpiry(index){
                if(this.isPhysicalCountV2QuantityEditLocked){
                    return
                }
                this.currentDrawerLotCodeExpiry.splice(index, 1);
                this.lotcodeTotalQty = 0
                this.currentDrawerLotCodeExpiry.map(item => {
                    if(this.selectedDocumentLines[0].product_type == 'P' && this.currentDocumentTypeCode.includes('REL'))
                        this.lotcodeTotalQty += Number(item['actual_quantity'])
                    else
                        this.lotcodeTotalQty += Number(item['quantity'])
                })
            },
            addDrawerSublocationQuantity: function () {
                if(this.isPhysicalCountV2QuantityEditLocked){
                    return
                }
                this.sublocationAllocationErrors = [];
                if (this.drawerSublocation.key > 0 && this.drawerSublocationQuantity > 0) {
                    var is_sublocation_existing = this.drawerCurrentSublocationAllocation.find(x => x.sublocation_id === this.drawerSublocation.key);
                    if (is_sublocation_existing == undefined) {
                        this.drawerCurrentSublocationAllocation.push(
                            {'sublocation_id': this.drawerSublocation.key,
                            "quantity": this.drawerSublocationQuantity}
                        )

                        var total_sublocation_quantity = this.drawerCurrentSublocationAllocation.reduce((a, {quantity}) => a + parseInt(quantity), 0);
                        if (total_sublocation_quantity > this.selectedSublocationAllocationProduct.quantity) {
                            this.sublocationAllocationErrors.push('You have exceeded the maximum allowed quantity: '+ this.selectedSublocationAllocationProduct.quantity)
                            this.drawerCurrentSublocationAllocation.pop();
                        }

                        this.drawerSublocationQuantity = ''
                        this.drawerSublocation = {key: 0, label: "Please select a sublocation"}
                    } else {
                        this.sublocationAllocationErrors.push('Sublocation already exists')
                    }
                } else {
                    this.sublocationAllocationErrors.push('Sublocation and Quantity must have values')
                }
            },
            addDrawerSiteQuantityValidation(){
                if(this.isPhysicalCountV2QuantityEditLocked){
                    return 1
                }
                this.siteAllocationErrors = [];
                this.siteAllocationErrors.push(ValidateField.greaterThanZero('Quantity', this.drawerSiteQuantity));
                this.siteAllocationErrors.push(ValidateField.required('Quantity', this.drawerSiteQuantity));
                this.siteAllocationErrors.push(ValidateField.required('Site', this.drawerSite.key));
                this.siteAllocationErrors = this._.compact(this.siteAllocationErrors);
                return this.siteAllocationErrors.length;
            },
            addDrawerSiteQuantity: function () {
                if(this.isPhysicalCountV2QuantityEditLocked){
                    return
                }
                if(!this.addDrawerSiteQuantityValidation()){
                    var is_site_existing = this.drawerCurrentSiteAllocation.find(x => x.site_id === this.drawerSite.key);
                    if (this.currentDocumentTypeCode == 'OTHPCK') {
                        if (is_site_existing == undefined) {
                            this.siteAllocationErrors.push('Site selected is not available below')
                        } else {
                            if (is_site_existing.quantity < this.drawerSiteQuantity){
                                this.siteAllocationErrors.push('You have exceeded the site maximum allowed quantity: ' +is_site_existing.quantity)
                            }else{
                                is_site_existing.available_quantity = this.drawerSiteQuantity
                            }
                        }
                    } else {
                        if (is_site_existing == undefined) {
                            var code = (this.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.AllocationDefaultValue == 'SC') ? this.drawerSite.code : this.drawerSite.reference_code;
                            this.drawerCurrentSiteAllocation.push(
                                {'site_id': this.drawerSite.key,
                                "quantity": this.drawerSiteQuantity,
                                "code": code}
                            )
                            var total_site_quantity = this.drawerCurrentSiteAllocation.reduce((a, {quantity}) => a + parseInt(quantity), 0);
                            this.siteAllocationRemainingQuantity = Number(this.selectedSiteAllocationProduct.quantity) - Number(total_site_quantity)
                            if (total_site_quantity > this.selectedSiteAllocationProduct.quantity) {
                                this.siteAllocationErrors.push('You have exceeded the maximum allowed quantity: '+ this.selectedSiteAllocationProduct.quantity)
                                this.drawerCurrentSiteAllocation.pop();
                            }else {
                                this.siteAllocationRemainingQuantity = Number(this.selectedSiteAllocationProduct.quantity) - Number(total_site_quantity)
                            }
                            this.drawerSiteQuantity = 0
                            // this.drawerSite = {key: 0, label: "Please select a site"}
                        } else {
                            this.siteAllocationErrors.push('Site already exists')
                        }
                    }
                }
            },
            selectDrawerSublocations (drawerSublocation) {
                var arr = {
                    key:drawerSublocation.key.replace('drawerSublocations',''),
                    label:drawerSublocation.label
                }
                drawerSublocation = arr
                Object.assign(this, {
                    drawerSublocation,
                    drawerSublocations: [],
                    fetching: false,
                })
            },
            selectDrawerSites (drawerSite) {
                var currencyDetails = this.drawerSites.find(c => parseInt(c.id) == parseInt(drawerSite.key.replace('drawerSites','')))
                var arr = {
                    key:drawerSite.key.replace('drawerSites',''),
                    label:drawerSite.label,
                    code:currencyDetails.code,
                    reference_code:currencyDetails.refcode,
                }
                drawerSite = arr
                Object.assign(this, {
                    drawerSite,
                    drawerSites: [],
                    fetching: false,
                })
            },

            async fetchDrawerSublocations(){
                if (this.drawerSublocationSiteId) {
                    this.fetching = true
                    this.drawerSublocations = await HTTPRequest.getRequest(this.endPoint + 'sublocations/get_site_sublocations?site_id='+this.drawerSublocationSiteId, null)
                    this.fetching = false
                }
            },

            async fetchDrawerSites(){
                this.fetching = true
                this.drawerSites = await HTTPRequest.getRequest(this.endPoint + 'sites/get_all_document_sites', null)
                this.fetching = false
            },
            isUrl(string) {
                var res = string.match(/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g);
                //console.log("-----------")
                //console.log(res !== null)
                return (res !== null)
            },
            async fetchCurrencies() {
                this.fetching = true
                if(this.currencies.length <= 0 || this.forceFetchCurrency){
                    var params = '?default_currency='+this.hasDefaultCurrency
                    this.hasDefaultCurrency == true ? params+='&default_currency_id='+this.defaultCurrencyDetails.id : ""
                    try{
                        params += this.supplierDetails.currency_id!=undefined && this.supplierDetails.currency_id!=null ? '&currency_id='+this.supplierDetails.currency_id : ''
                    }catch (e){
                        console.log(e)
                    }
                    this.currencies = await HTTPRequest.getRequest(this.endPoint + 'currencies/get_document_currencies', null)
                    // this.currencies = await HTTPRequest.getRequest(this.endPoint + 'currencies/get_document_currencies' + params, null)
                    this.forceFetchCurrency = false
                }
                this.fetching = false
            },
            async selectCurrency (currency) {
                var arr = {}
                if(currency.key == 0){
                    arr = {
                        key: currency.key,
                        label: currency.label
                    }
                } else {
                    arr = {
                        key: currency.key.replace('currencies',''),
                        label: currency.label
                    }
                }
                currency = arr
                var currencyDetails = this.currencies.find(c => parseInt(c.id) == parseInt(currency.key))
                var rate = currencyDetails.conversion || 0
                this.currencyRate = rate;
                Object.assign(this, {
                    currency,
                    fetching: false,
                    currencyDetails:currencyDetails,
                })
                await this.showConversionCurrencyRate()
                this.calculateSummary();
            },

            async saveRemark(){
                this.isEditing = true
                var documentPayload = {document_id: this.documentNumber, remark: this.remark}
                var post_request = await HTTPRequest.postRequest(this.endPoint + 'documents/edit_remark', null, documentPayload)
                if(post_request.id > 0){
                    this.documentActionNotification('Save', 'success')
                }else{
                    this.documentActionNotification('Save', 'error')
                }
            },

            exportExcelDocument(){
                let tabulatorInstance = this.$refs.tabulator.getInstance();
                tabulatorInstance.download("xlsx", this.friendlyCodeAndDocumentNo+".xlsx", {sheetName:"Document"});
            },
            exportCsvDocument(){
                let tabulatorInstance = this.$refs.tabulator.getInstance();
                // TC-PCV2-EXP-006: a Count Set (OTHCNS) exports its linked Physical
                // Documents, NOT the product-line grid columns. Build the required
                // 7-column CSV (one row per linked Physical Document) from the member
                // data already loaded into the grid via get_pcount_document_details.
                if (this.currentDocumentTypeCode == 'OTHCNS') {
                    this.exportCountSetCsv(tabulatorInstance);
                    return;
                }
                tabulatorInstance.download("csv", this.friendlyCodeAndDocumentNo+".csv", {delimiter:","});
            },
            exportCountSetCsv(tabulatorInstance){
                const members = tabulatorInstance.getData();
                const csv = buildCountSetExportCsv(members);
                const url = window.URL.createObjectURL(new Blob([csv], { type: 'text/csv;charset=utf-8;' }));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', this.friendlyCodeAndDocumentNo + ".csv");
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            },
            handleRemove(file) {
                const index = this.fileList.indexOf(file);
                const newFileList = this.fileList.slice();
                newFileList.splice(index, 1);
                this.fileList = newFileList;
            },
            pwsErrorMessages(errors) {
              if (this.currentDocumentTypeCode != "OTHPWS") return;

              if (!errors.validUniqueCodeHeader) {
                const currentSaveVia = this.saveMassUploadProductVia == 'stock_no' ? 'stock no' : 'barcode';
                const invalidSaveVia = this.saveMassUploadProductVia == 'stock_no' ? 'barcode' : 'stock no';
                this.massAddProductErrors.push(`Invalid ${invalidSaveVia} column. CSV first column must be ${currentSaveVia}`);
              }

              if (errors.invalidOrdering.length > 0)
                this.massAddProductErrors.push(`Invalid New Ordering in ${errors.uniqueCodeText}: ${errors.invalidOrdering.join(", ")}`);
                if (errors.invalidLanded.length > 0)
                this.massAddProductErrors.push(`Invalid New Landed in ${errors.uniqueCodeText}: ${errors.invalidLanded.join(", ")}`);

              if (errors.invalidPrice.length > 0)
                this.massAddProductErrors.push(`Invalid New Price in ${errors.uniqueCodeText}: ${errors.invalidPrice.join(", ")}`);
                
               if (errors.invalidPriceCost.length > 0)
                 this.massAddProductErrors.push(`Atleast one Price/Cost field is required in ${errors.uniqueCodeText}: ${errors.invalidPriceCost.join(", ")}`);

              if (errors.negativeOrdering.length > 0)
                this.massAddProductErrors.push(`Negative New Ordering in ${errors.uniqueCodeText}: ${errors.negativeOrdering.join(", ")}`);

              if (errors.negativePrice.length > 0)
                this.massAddProductErrors.push(`Negative New Price in ${errors.uniqueCodeText}: ${errors.negativePrice.join(", ")}`);

              if (errors.negativeLanded.length > 0)
                this.massAddProductErrors.push(`Negative New Landed in ${errors.uniqueCodeText}: ${errors.negativeLanded.join(", ")}`);
            },
            pwsMassProductUploadValidation(lines, linePointer) {
              let validUniqueCodeHeader = true;
              let blankUniqueCodeCount = 0;
              let invalidOrdering = '';
              let invalidPrice = '';
              let negativeOrdering = '';
              let negativePrice = '';
              let negativeLanded = '';
              let invalidLanded = '';
              let invalidPriceCost = '';


              if (linePointer == 0) {
                const csvHeaders = lines[0].split(',');
                const currentSaveVia = this.saveMassUploadProductVia == 'stock_no' ? 'stock no' : 'barcode';

                if (csvHeaders[0].toString().toLowerCase() != currentSaveVia) validUniqueCodeHeader = false;

                return { validUniqueCodeHeader,
                         blankUniqueCodeCount, negativeLanded,
                         invalidOrdering, invalidPrice, invalidLanded, invalidPriceCost,
                         negativeOrdering, negativePrice };
              }


              const productLine = lines[linePointer].split(',');
              // Check if barcode/stock no is blank
              if (lines[linePointer].length > 0 && productLine[0].length == 0)
                blankUniqueCodeCount += 1

              if (blankUniqueCodeCount == 0) {
                const parsedOrdering = parseFloat(productLine[1])
                if (isNaN(parsedOrdering)) {
                  // Check if New Ordering is present
                  invalidOrdering = `${productLine[0]}`;
                } else if (parsedOrdering < 0) {
                  // Check if New Ordering is negative
                  negativeOrdering = `${productLine[0]}`;
                }

                const parsedLanded = parseFloat(productLine[2])
                if (!isNaN(parsedLanded) && parsedLanded < 0) {
                  // Check if New Landed is negative
                  negativeLanded = `${productLine[0]}`;
                } else if(isNaN(parsedLanded)) {
                  invalidLanded = `${productLine[0]}`
                }


                const parsedPrice = parseFloat(productLine[3])
                if (isNaN(parsedPrice)) {
                  // Check if New Price is blank
                  invalidPrice = `${productLine[0]}`;
                } else if (parsedPrice < 0) {
                  // Check if New Price is negative
                  negativePrice = `${productLine[0]}`;
                }

                // Check if all three invalid values are present
                if (invalidLanded && invalidPrice && invalidOrdering) {
                    invalidPriceCost = `${productLine[0]}`;
                }

              }

              return { validUniqueCodeHeader,
                       blankUniqueCodeCount, negativeLanded,
                       invalidOrdering, invalidPrice, invalidLanded, invalidPriceCost,
                       negativeOrdering, negativePrice };
            },
            dateIsValid(dateStr){
                const regex = /^\d{4}-\d{2}-\d{2}$/;

                if (dateStr.match(regex) === null) {
                    return false;
                }

                const date = new Date(dateStr);

                const timestamp = date.getTime();

                if (typeof timestamp !== 'number' || Number.isNaN(timestamp)) {
                    return false;
                }

                return date.toISOString().startsWith(dateStr);
            },
            beforeUpload(file) {
                this.fileList = [];
                const reader = new FileReader();
                reader.onload = async e => {
                    //     this.processCsvMassAdd(e.target.result);
                    this.massAddProductErrors = [];
                    this.massAddProductErrorsDL = [];
                    this.csvData = '';

                    var text = e.target.result;
                    var skulist = [];
                    var qtylist = [];
                    var orderingCost = [];
                    var lines = text.split(/[\r\n]+/g); // tolerate both Windows and Unix linebreaks
                    let productCount = 0;
                    let blankUniqueCodeCount = 0;
                    let pwsErrors = { validUniqueCodeHeader: true, uniqueCodeText: '', invalidOrdering: [], invalidPrice: [], invalidLanded: [], invalidPriceCost: [],
                                      negativeOrdering: [], negativePrice: [], negativeLanded: [] }

                    const exemptedDocTypes = !["OTHPWS"].includes(this.currentDocumentTypeCode)

                    pwsErrors.uniqueCodeText = lines[0].split(',')[0];

                    if(lines.length - 1 > this.maxLines)
                        this.massAddProductErrors.push('Total lines exceeded.  Please only upload up to ' + this.maxLines + ' lines.');

                    for(var i = 0; i < lines.length; i++) {
                        if( i == 0 && (lines[i].split(',')[0] != 'barcode' || lines[i].split(',')[1] != 'qty' || (lines[i].split(',')[2] && lines[i].split(',')[2] != 'ordering_cost' && lines[i].split(',')[2] != 'landed_cost' && lines[i].split(',')[2] != 'remarks')) && exemptedDocTypes && !['OTHTRA', 'RECDEL','RELTRX','RECTRX','RELSLO','RECSLI','OTHPCN','RECADJ','RELADJ','ORISOX'].includes(this.currentDocumentTypeCode)){
                            this.massAddProductErrors.push('Column names are incorrect and invalid.');
                        }
                        
                        
                        if( i == 0 && this.currentDocumentTypeCode == "OTHTRA" ) {
                            if( lines[0].split(',').length == 5){
                                if( lines[i].split(',')[0] != 'barcode' || lines[i].split(',')[1] != 'qty' || lines[i].split(',')[2] != 'lot_table_1'|| lines[i].split(',')[3] != 'lot_table_2' || lines[i].split(',')[4] != 'lot_table_3'  )  
                                    this.massAddProductErrors.push('Column names are incorrect and invalid.');
                            }else{
                                if( lines[i].split(',')[0] != 'barcode' || lines[i].split(',')[1] != 'qty'  )  
                                    this.massAddProductErrors.push('Column names are incorrect and invalid.');
                            }
                        }


                        if( i == 0 && (lines[i].split(',')[0] != 'barcode' || lines[i].split(',')[1] != 'qty' || lines[i].split(',')[2] != 'ordering_cost') && this.currentDocumentTypeCode === "ORIPOX" )  
                              this.massAddProductErrors.push('Column names are incorrect and invalid.');
                        // if Sales Order the format should be (barcode, qty, price)
                        if( i == 0 && (lines[i].split(',')[0] != 'barcode' || lines[i].split(',')[1] != 'qty' || lines[i].split(',')[2] != 'price') && this.currentDocumentTypeCode === "ORISOX" )  
                              this.massAddProductErrors.push('Column names are incorrect and invalid.');
                        
                        if( i == 0 && (lines[i].split(',')[0] != 'barcode' || lines[i].split(',')[1] != 'qty' || lines[i].split(',')[2] != 'lot_code' || lines[i].split(',')[3] != 'expiry_at') && ['RECDEL','RELTRX','RECTRX','RELSLO','RECSLI','OTHPCN','RECADJ','RELADJ'].includes(this.currentDocumentTypeCode) && lines[i].split(',').length == 4)  
                            this.massAddProductErrors.push('Column names are incorrect and invalid for lotcode and expiry. Kindly follow this format barcode,qty,lot_code,expiry_date');

                        if(i > 0 && ['RECDEL','RELTRX','RECTRX','RELSLO','RECSLI','OTHPCN','RECADJ','RELADJ'].includes(this.currentDocumentTypeCode) && lines[i].split(',').length == 4 && !this.dateIsValid(lines[i].split(',')[3].toString()) && lines[i].split(',')[3] != '')
                            this.massAddProductErrors.push('Invalid expiry date format on line: '+i+'. Value: ' + lines[i].split(',')[3].toString());
                        
                        if(i > 0 && ['RECDEL','RELTRX','RECTRX','RELSLO','RECSLI','OTHPCN','RECADJ','RELADJ'].includes(this.currentDocumentTypeCode) && lines[i].split(',').length == 4 && (lines[i].split(',')[2] == '' || lines[i].split(',')[3] == ''))
                            this.massAddProductErrors.push('Lotcode or Expiry Date must not be empty');

                        if(i > 0 && lines[i].includes(',') && exemptedDocTypes) {

                            if(typeof lines[i].split(',')[1] === 'string')
                                qtylist.push(parseInt(lines[i].split(',')[1]));
                            else
                                qtylist.push(parseInt(lines[i].split(',')[1]) || 0);

                            skulist.push(lines[i].split(',')[0]);
                            orderingCost.push(lines[i].split(',')[2])
                            
                            if(['RECDEL','RELTRX','RECTRX','RELSLO','RECSLI','OTHPCN','RECADJ','RELADJ'].includes(this.currentDocumentTypeCode) && lines[i].split(',').length == 4){
                                this.csvData += lines[i].split(',')[0] +','+ parseInt(lines[i].split(',')[1])+ ',' + lines[i].split(',')[2].toString() + ',' + lines[i].split(',')[3].toString();
                                this.importLotCode = 1;
                            }
                            else if(['OTHTRA'].includes(this.currentDocumentTypeCode) && lines[i].split(',').length == 5){
                                this.csvData += lines[i].split(',')[0] +','+ parseInt(lines[i].split(',')[1])+ ',' + lines[i].split(',')[2].toString() + ',' + lines[i].split(',')[3].toString() + ',' + lines[i].split(',')[4].toString();
                                this.importLotCode = 0;
                            }else{
                                const lineParts = lines[i].split(',');
                                const optionalThirdColumn = lineParts[2] !== undefined ? lineParts[2] : '';
                                this.csvData += `${lineParts[0]},${parseInt(lineParts[1])},${optionalThirdColumn}`;
                                this.importLotCode = 0;
                            }
                                
                            if(i < lines.length)
                                this.csvData += '\n'
                        }

                        if (i > 0 && productCount == 0) {
                          // Check if there's any product present
                          productCount = lines[i].replace(",","").length;
                        }

                        if (this.currentDocumentTypeCode == "OTHPWS" && pwsErrors.validUniqueCodeHeader) {
                          const pwsValidation = this.pwsMassProductUploadValidation(lines, i);

                          if (!pwsValidation.validUniqueCodeHeader) {
                            pwsErrors.validUniqueCodeHeader = false;
                            break;
                          }

                          blankUniqueCodeCount += pwsValidation.blankUniqueCodeCount;
                        //   if (pwsValidation.invalidOrdering) pwsErrors.invalidOrdering.push(pwsValidation.invalidOrdering);
                        //   if (pwsValidation.invalidPrice) pwsErrors.invalidPrice.push(pwsValidation.invalidPrice);
                          if (pwsValidation.negativeOrdering) pwsErrors.negativeOrdering.push(pwsValidation.negativeOrdering);
                          if (pwsValidation.negativePrice) pwsErrors.negativePrice.push(pwsValidation.negativePrice);
                          if (pwsValidation.negativeLanded) pwsErrors.negativeLanded.push(pwsValidation.negativeLanded);
                          if (pwsValidation.invalidPriceCost) pwsErrors.invalidPriceCost.push(pwsValidation.invalidPriceCost);
                        }

                        if (!exemptedDocTypes) {
                            this.csvData += lines[i] + '\n'
                        }
                    }
                    // console.log(this.csvData)
                    // Get duplicate sku's/barcode
                    if (this.importLotCode == 0){
                        const findDuplicates = (skulist) => {
                            let sorted_arr = skulist.slice().sort();
                            let results = [];
                            for (let i = 0; i < sorted_arr.length - 1; i++) {
                                if (sorted_arr[i + 1] == sorted_arr[i]) {
                                    results.push(sorted_arr[i]);
                                }
                            }
                            return results;
                        }

                        // Result duplicate sku's/barcode -> download list
                        if(findDuplicates(skulist).length > 0 && this.document_config.document_type_settings.editorBehavior.radio != "L") {
                            this.massAddProductErrors.push('With duplicate Barcodes');
                            this.dlDUplicateSkus = 1
                            this.dlDUplicateSkusItems = findDuplicates(skulist)
                            this.massAddProductErrorsDL.push('With duplicate Barcodes');
                        } else {
                            this.dlDUplicateSkus = 0
                        }
                    }

                    // Get 0 / - quantity
                    const zQty = qtylist.filter(qty => {
                        if(isNaN(qty))
                            return true
                        else if(qty == 0 && this.currentDocumentTypeCode == 'OTHPCN')
                            return false
                        else
                            return qty < 1
                    });

                    // Result 0 / - quantity

                    // 2021-08-23 - https://tools.iripple.com/barter-11/bxi-backend/-/issues/1686
                    // Allow 0 quantity for PCOUNT document [OTHPCN]
                    if(zQty.length > 0 && exemptedDocTypes){
                      this.massAddProductErrors.push('All quantities must be POSITIVE integers and no blanks/characters.');
                    }

                    // Get blank skus
                    const bSku = skulist.filter(sku => sku.length < 1);
                    // const bOrderingCost = orderingCost.filter(ordercost => ordercost === "");

                    // Result blank skus & blank ordering_cost
                    if(bSku.length > 0 && exemptedDocTypes)
                        this.massAddProductErrors.push('File has blank lines that generate rows with no data but with a comma.');

                    //this will make the field ordering_cost required not to be empty
                    // if(bOrderingCost.length > 0 && exemptedDocTypes )
                    //     this.massAddProductErrors.push('File has blank lines that generate rows with no data but with a comma.');

                    // Check if PWS Uploaded file has no product indicated
                    if (productCount == 0)
                        this.massAddProductErrors.push('File has no data');

                    // Check if PWS Uploaded file has some lines without barcode/stock no
                    if (blankUniqueCodeCount > 0)
                        this.massAddProductErrors.push(`${blankUniqueCodeCount} blank ${lines[0].split(',')[0]}`);

                    // Render PWS Error messages if there's any
                    this.pwsErrorMessages(pwsErrors);

                    //Check if CSV has valid data
                    if (this.csvData.length == 0)
                        this.massAddProductErrors.push('File has no valid data. Please check file.');

                    // Check if CSV has no error
                    // Proceed validating if barcodes are valid

                    if(this.massAddProductErrors.length < 1){
                      this.spinning = true;

                      // Hot Fix - https://tools.iripple.com/barter-11/bxi-backend/-/issues/1639
                      // Check supplier in header if exist for product mass update
                      if(this.validationdocutypes.includes(this.currentDocumentTypeCode) && this.filterBySupp) {
                        await this.getSuppItems(skulist)
                      } else {
                        this.spinning = false;
                      }

                      if (this.massAddProductErrors.length == 0 && this.massAddProductErrorsDL.length == 0) {
                        this.fileList = [...this.fileList, file];
                      }
                    }
                    this.massAddProductErrors = this._.compact(this.massAddProductErrors);

                };
                reader.readAsText(file);
                this.spinning = false;
                return false;
            },
            async getSuppItems(skulist){
                const supplier_param = (this.supplier.key != null && this.supplier.key != "") ? "supplier_ids="+this.supplier.key+"&" : ""
                // var suppItems = await HTTPRequest.getRequest(component_x.endPoint + "products?"+supplier_param+"per_page=500&type=document", null);
                let suppItems = await HTTPRequest.getRequest(component_x.endPoint + "products/check_supplier_products?"+supplier_param+"per_page=500", null);
                let supplierProducts = suppItems.products || [];
                var pageCount = suppItems.total_pages
                this.suppItems = [];

                supplierProducts.map(product => {
                  this.suppItems.push(product.barcode)
                })

                // Get succeeding records
                if(pageCount > 1) {
                  for (var i = 2; i <= pageCount; i++) {
                    // suppItems = await HTTPRequest.getRequest(component_x.endPoint + "products?"+supplier_param+"per_page=500&page="+i+"&type=document");
                    suppItems = await HTTPRequest.getRequest(`${component_x.endPoint}products/check_supplier_products?${supplier_param}per_page=500&page=${i}`, null);
                    supplierProducts = suppItems.products || [];
                    supplierProducts.map(product => {
                      this.suppItems.push(product.barcode)
                    })
                  }
                }

                let errorBarcodes = []
                this.spinning = false;
                skulist.map(item => {
                  if (!this.suppItems.includes(item)) {
                    errorBarcodes.push(item);
                  }
                })

                const arrNF = skulist.filter(i => !this.suppItems.includes(i))
                if(arrNF.length > 0) {
                    this.massAddProductErrors.push(`The following barcodes are not under the selected supplier or does not exist: ${arrNF.join(', ')}`);
                    this.massAddProductErrorsDL.push('With duplicate Barcodes');
                    this.dlSkusNotFound = 1
                    this.dlSkusNotFoundItems = arrNF
                }

                return true;
            },
            async importFile(){
                if (!this.fileList[0]) {
                    return false;
                }
                this.documentStatus = 'Uploading';
                await this.processCsvMassAdd(this.csvData);
                return false;
            },
            pollS3ImportStatus(){
                // Poll every 5 seconds to check if S3 import has completed
                var component_x = this;
                if(this.s3ImportPollInterval) clearInterval(this.s3ImportPollInterval);
                this.s3ImportPollInterval = setInterval(async function(){
                    var job = await HTTPRequest.getRequest(component_x.endPoint+'import_jobs?profile_name='+component_x.currentDocumentTypeCode+'-%23-'+component_x.documentNumber, null);
                    if(job != undefined && job.length > 0){
                        if(job[0].formatted_status != 'Ongoing'){
                            // Import finished — stop polling and reload the page
                            clearInterval(component_x.s3ImportPollInterval);
                            component_x.s3ImportPollInterval = null;
                            component_x.isS3Importing = false;
                            // Reload the document to show the imported lines
                            component_x.$router.go(0);
                        }
                    } else {
                        // No job found — stop polling
                        clearInterval(component_x.s3ImportPollInterval);
                        component_x.s3ImportPollInterval = null;
                        component_x.isS3Importing = false;
                    }
                }, 5000);
            },
            async processCsvMassAdd(csvtext){
                this.CsvUploadParams = {'csv_lines': csvtext, 'import_mode': this.importMode, 'is_lotcode': this.importLotCode, 'importer_type': this.importerType}
                this.processingCsvUpload = true
                try {
                    if (this.documentNumber > 1) {
                        await this.update();
                    } else {
                        await this.save();
                    }
                } finally {
                    this.processingCsvUpload = false;
                    this.closeDrawer('massAdd');
                }
            },
            subscribe(){
                var pusher = new Pusher('b74fa07f1048125271b8', {
                  cluster: 'ap1'
                });
                pusher.subscribe('my-channel')
                pusher.bind('my-event', data => {
                    // Delivery Document # "+ data.message.order.points[0].client_order_id + "
                    this.bookingDetails = data.message
                    // this.$notification['info']({
                    //   message: 'Status Change',
                    //   description: "Your booking status has changed."
                    // });
                })
            },
            haversineDistance(coords1, coords2, isMiles) {
                function toRad(x) {
                  return x * Math.PI / 180;
                }

                var lon1 = coords1[0];
                var lat1 = coords1[1];

                var lon2 = coords2[0];
                var lat2 = coords2[1];

                var R = 6371; // km

                var x1 = lat2 - lat1;
                var dLat = toRad(x1);
                var x2 = lon2 - lon1;
                var dLon = toRad(x2)
                var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
                  Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) *
                  Math.sin(dLon / 2) * Math.sin(dLon / 2);
                var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
                var d = R * c;

                if(isMiles) d /= 1.60934;

                return d;
            },
            handleDestinationChange(location){
                var newPosition = {
                    lat: location.latLng.lat(),
                    lng: location.latLng.lng()
                }
                var distance = this.haversineDistance([newPosition.lng, newPosition.lat], [this.originalGeoLocation[1].position.lng, this.originalGeoLocation[1].position.lat], false)
                if(distance < 1){
                    this.markers[1].position = newPosition;
                } else {
                    this.markers[1].position = this.originalGeoLocation[1].position;
                    this.mapKey++;
                    this.$message['error'](
                      "Cannot pin to new location. Distance from original should be within 1 km radius."
                    )
                }

                this.recompute = true;
            },
            getFromAddress(from_address, placeResultData, id) {
                this.from_address = from_address;
            },
            getToAddress(to_address, placeResultData, id){
                this.to_address = to_address;
            },
            handleError(error){
                alert(error)
            },
            filteredBySupplierChange(e){
                this.filteredBySupplier = e.target.checked
            },
            selectCustomerContact(value){
                switch(value) {
                    case 'Telephone':
                        this.activeCustomerContact = this.customerContactTelephone
                        break;
                    case 'Mobile':
                        this.activeCustomerContact = this.customerContactMobile
                        break;
                    case 'Fax':
                        this.activeCustomerContact = this.customerContactFax
                        break;
                    case 'Email':
                        this.activeCustomerContact = this.customerContactEmail
                        break;
                }
            },
            createCustomer(){
                this.customerDrawerVisible = true
                this.customerDrawerKey++
            },
            onClose() {
                this.errors = [];
                this.customerDrawerVisible = false
                this.customerDrawerKey++
            },
            // closeDrawer(){
            //     this.onClose()
            // },
            async refreshPage(event) {
                var new_customer_data = JSON.parse(event.target.response)
                if (new_customer_data.id > 0 && new_customer_data.name != undefined) {
                    this.customer = {key: new_customer_data.id, label: new_customer_data.name}
                    if (new_customer_data.id){
                        var customer = await HTTPRequest.getRequest(component_x.endPoint + "customers/"+new_customer_data.id, null);
                        this.customerAddress = (customer["address"]) ? customer["address"] : "No Customer Address";
                        this.customerContactMobile = (customer["mobile"]) ? customer["mobile"] : "No Customer Mobile";
                        this.customerContactTelephone = (customer["telephone"]) ? customer["telephone"] : "No Customer Telephone";
                        this.customerContactFax = (customer["fax"]) ? customer["fax"] : "No Customer Fax";
                        this.customerContactEmail = (customer["email"]) ? customer["email"] : "No Customer Email";
                        this.selectedCustomerContact = (customer["mobile"]) ? 'Mobile' : (customer["telephone"]) ? 'Telephone' : (customer["fax"]) ? 'Fax' : (customer["email"]) ? 'Email' : 'Telephone'
                        this.activeCustomerContact = (customer["mobile"]) ? this.customerContactMobile : (customer["telephone"]) ? this.customerContactTelephone : (customer["fax"]) ? this.customerContactFax : (customer["email"]) ? this.customerContactEmail : this.customerContactTelephone
                        this.isProductSearchDisabled = false;
                    }
                }

                this.onClose()
                this.documentActionNotification('Create customer', 'success')
            },
            moment,
            selectForThisSite (forThisSite) {
              let arr = {
                key:forThisSite.key.replace('forThisSites',''),
                label:forThisSite.label
              }

              forThisSite = arr
              Object.assign(this, {
                forThisSite,
                forThisSites: [],
                fetching: false,
              })
            },
            showApplyDocumentToOtherSitesButton() {
              if (this.header.showApplyDocumentToOtherSitesButton &&
                  this.documentStatus == "Confirmed") {
                return true;
              }
              return false;
            },
            toggleApplyDocumentToOtherSitesDrawer(open) {
              this.applyDocumentToOtherSitesDrawer = open;
            },
            showStockCard(product){
                this.stockCardVisible = true
                this.selectedStockCardProduct = product[0].product_id;
                this.stockCardKey++;
            },
            async handleLineAmountCellEdited(cell) {
                const rowData = cell && cell.getRow ? cell.getRow().getData() : null
                if (!rowData || rowData.line_no <= 0 || !rowData.product_id) {
                    return
                }

                await this.recalculateLine(rowData.product_id)
                this.calculateSummary()
            },
            // Count Set "View Document Lines": fetch the document lines for the
            // SELECTED Physical Count document and show them in the existing
            // modal. A Count Set links several Physical Count documents, and the
            // Count Set grid rows ARE those documents, so we scope the request to
            // the selected document's id (pcount_document_id) rather than the
            // Count Set id; the backend returns ONLY that document's lines.
            //
            // Robustness requirements handled here:
            //  - Replace (never append) the displayed collection on each open.
            //  - Clear stale lines immediately when a new request starts.
            //  - Ignore out-of-order responses via a monotonic request token so a
            //    slow earlier request cannot overwrite a newer selection.
            //  - Empty document -> cleared table + "No document lines found".
            //  - On failure -> clear stale data and surface the existing toast.
            async viewCountSetDocumentLines(selectedDocument){
                // "View Document Lines" shows exactly ONE Physical Count
                // document's lines. Classify the current selection: reject an
                // empty selection, and reject an ambiguous multi-selection
                // (Option A) rather than silently showing only the first row.
                var selection = classifyViewDocumentLinesSelection(selectedDocument, this.selectedDocumentLines)
                if (selection.status === 'none') {
                    this.$message.warning("Select a Physical Count document first.")
                    return
                }
                if (selection.status === 'multiple') {
                    this.$message.warning("Please select only one Physical Count document to view its lines.")
                    return
                }
                var pcountDocumentId = selection.id

                // New request: bump the token, clear stale data, open + load.
                this.countSetLinesRequestToken++
                var requestToken = this.countSetLinesRequestToken
                this.countSetLinesData = []
                this.countSetLinesLoading = true
                this.countSetLinesModalVisible = true

                var didError = false
                var document_lines = null
                try {
                    var url = buildCountSetLinesUrl(this.endPoint, this.documentNumber, pcountDocumentId)
                    document_lines = await HTTPRequest.getRequest(url, null);
                } catch (error) {
                    didError = true
                }

                var outcome = resolveCountSetLinesResponse(requestToken, this.countSetLinesRequestToken, document_lines, didError)
                // Ignore out-of-order / stale responses entirely.
                if (!outcome.apply) {
                    return
                }
                this.countSetLinesData = outcome.data
                this.countSetLinesLoading = false
                if (didError) {
                    this.$message.error("Unable to load document lines for this document.")
                }
            },
            async recalculateLine(product_id, targetLineNo = null){
                var data = this.tabulator.getData();
                var line_no = targetLineNo || data.find(item => product_id === item.product_id).line_no
                if(data.find(item => line_no === item.line_no)){
                    //Quantity Change
                    var cost = data.find(item => line_no === item.line_no).cost
                    var quantity = data.find(item => line_no === item.line_no).quantity
                    var subtotal = Number(quantity) * Number(cost)
                    await this.tabulator.updateData([{line_no: line_no,product_id: product_id, subtotal: subtotal}])

                    //Discount Change and Unit Cost Change
                    var discount_text = ''
                    if(data.find(item => line_no === item.line_no).discount_text != null)
                        discount_text = _.compact((data.find(item => line_no === item.line_no).discount_text).split(','));

                    var discountTotal = 0;
                    var unitNetCost = data.find(item => line_no === item.line_no).price
                    var decimalPlaces = this.decimalPlaces
                    if (discount_text.length > 0) {
                        var lessDiscount = /^L[0-9]+(\.[0-9][0-9]?)?$/;
                        var numberRegex = /^[0-9]+(\.[0-9][0-9]?)?$/;
                        // eslint-disable-next-line
                        var percentDiscount = /^[0-9]+(\.[0-9][0-9]?)?\%$/;
                        discount_text.forEach(function(row) {
                            var discount;
                            var discountAmount;
                            if (lessDiscount.test(row)) {
                                discount = row.slice(1)
                                discountAmount = (unitNetCost) - (discount)
                                unitNetCost = unitNetCost - ((unitNetCost) - (discountAmount)).toFixed(decimalPlaces)
                            } else if (numberRegex.test(row)) {
                                discount = row;
                                discount = (discount / quantity)
                                discountAmount = (unitNetCost) - ((unitNetCost) - (discount))
                                unitNetCost = unitNetCost - (discountAmount).toFixed(decimalPlaces)
                            } else if (percentDiscount.test(row)) {
                                discount = row.slice(0,-1)
                                discountAmount = (unitNetCost) * (discount / 100)
                                unitNetCost = ((unitNetCost) - (discountAmount)).toFixed(decimalPlaces)
                            }
                            if (lessDiscount.test(row)) {
                                discountTotal = discountTotal + (discount * quantity);
                            } else {
                                discountTotal = discountTotal + (discountAmount * quantity);
                            }

                        });
                    }

                    if (this.currentDocumentTypeCode =='RELDDE') {
                        if (unitNetCost < 0) unitNetCost = 0
                        subtotal = (quantity * unitNetCost).toFixed(this.fixedDecimalPlaces)
                        await this.tabulator.updateData([{line_no: line_no,product_id: product_id, cost: unitNetCost, subtotal: subtotal, discount: discountTotal}])
                    } else {
                        if (unitNetCost < 0) unitNetCost = 0

                        let computeTotalGross = this.numberOrZero(unitNetCost) * this.numberOrZero(quantity)
                        if (discountTotal >= computeTotalGross) {
                            discountTotal = computeTotalGross
                        }
                        
                        subtotal = (quantity * unitNetCost).toFixed(this.fixedDecimalPlaces)

                        await this.tabulator.updateData([{line_no: line_no,product_id: product_id, cost: unitNetCost, subtotal: subtotal, discount: discountTotal, total_gross: computeTotalGross}])
                    }
                }
            },
            serialRows(serials) {
                if (Array.isArray(serials)) return serials;
                if (serials && serials.data != undefined) return this.serialRows(serials.data);
                if (serials && typeof serials === 'object') return [serials];
                return [];
            },
            async saveDrawerSerialization() {
                if(this.isPhysicalCountV2QuantityEditLocked){
                    return
                }
                this.currentDrawerSerials = this.serialRows(this.currentDrawerSerials).filter(item => item.status == "A")
                var data = this.tabulator.getData();
                var line_no = data.find(item => this.selectedSerialProduct.product_id === item.product_id).line_no
                if(this.currentDocumentTypeCode.includes('REL')) { this.currentDrawerSerials = this.currentDrawerSerials.filter(item => item.checked)}
                await this.tabulator.updateData([{line_no: line_no,product_id: this.selectedSerialProduct.product_id, quantity: this.currentDrawerSerials.length, document_line_serials: this.currentDrawerSerials }])
                //Recalculate
                await this.recalculateLine(this.selectedSerialProduct.product_id)
                this.calculateSummary();
                this.serializationVisible = false
                // this.closeDrawer('serialization');
            },
            async submitDrawerSerials() {
                if(this.isPhysicalCountV2QuantityEditLocked){
                    return
                }
                //  ------CHECKING IF SERIAL EXIST IN A PRODUCT
                // console.log("---PRODUCT")
                // console.log(this.selectedSerialProduct)

                var ctr_chk = 0
                var releasing_documents = ["RELTRX", "RELADJ", "RELCSI", "ORISOX", "RELSLO", "RELDDE"]
                if( !releasing_documents.includes(this.currentDocumentTypeCode) ){
                    var inventory_serials = await HTTPRequest.getRequest(component_x.endPoint + `inventory_serials?product_id=${this.selectedSerialProduct.product_id}&serial_no=${this.inputSerialNumber}&status=A`, null);
                    ctr_chk = inventory_serials.data.length
                }

                if( ctr_chk > 0){
                    this.$notification['error']({
                                message: 'Serial Manager',
                                description: "Cannot add serial. Serial Number exists",
                                style: getNotificationStyle('error')
                            });
                    // alert("Cannot add serial. Serial already exist.")
                } else {
                    if (this.currentDocumentTypeCode.includes("REL")) {
                       var exists = this.currentDrawerSerials.find(x => x.serial_no == this.inputSerialNumber)
                        if (exists) {
                            exists.status = "A"
                            this.inputSerialNumber = ''
                        } else {
                            this.inputSerialNumber = ''
                        }
                    } else {
                        var exists = this.currentDrawerSerials.find(x => x.serial_no == this.inputSerialNumber)
                        if (exists) {
                            this.$notification['error']({
                                message: 'Serial Manager',
                                description: "Serial Number exists",
                                style: getNotificationStyle('error')
                            });
                        } else {
                            this.currentDrawerSerials.push({line_no: this.selectedSerialProduct.line_no, serial_no: this.inputSerialNumber, status: "A"})
                        }
                        this.inputSerialNumber = ''
                    }
                }
                this.currentSerialCount = this.currentDrawerSerials.length
            },
            selectSerial(e){
              if(this.isPhysicalCountV2QuantityEditLocked){
                return
              }
              const { id, checked } = e.target
              this.currentDrawerSerials = this.currentDrawerSerials.map((item) => {
                if(item.serial_no === id){
                  item = {...item, checked}
                }
                return item
              })
              this.currentSerialCount = this.currentDrawerSerials.filter(({checked}) => checked).length
              this.previousSerialCount = this.currentSerialCount > this.previousSerialCount ?  this.currentSerialCount : this.defaultCountValue;
            },
            async showSerialization(product){
                var site_id = secureStorage.getItem("defaultSiteId");
                this.selectedSerialProduct = product[0];
                if (this.currentDocumentTypeCode.includes("REL")) {
                  if (product[0].document_line_serials) {
                    // TC-PCV2-INV-011: for a POSTED release/adjustment-out, the
                    // serials it moved are already consumed in the register
                    // (inventory_serials flipped to 'U'), so re-querying
                    // get_serials_for_release_document (which only returns 'A'
                    // available serials) returns nothing and the drawer showed
                    // "0 out of 0". The posted document's serial history lives on
                    // its own document_line_serials — show those directly.
                    if (this.documentStatus === "Posted") {
                        this.currentDrawerSerials = this.serialRows(product[0].document_line_serials).map((item) => {
                          return { ...item, checked: true };
                        });
                    } else {
                        var inventory_serials = await HTTPRequest.getRequest(component_x.endPoint + "inventory_serials/get_serials_for_release_document?product_id="+product[0].product_id+"&site_id="+site_id+"&line_no="+product[0].line_no, null);

                        var selected = this.serialRows(product[0].document_line_serials).map(x => x.serial_no)
                        var merged = inventory_serials.map((item) =>  {
                          return {...item, checked: selected.includes(item.serial_no) }
                        } )

                        this.currentDrawerSerials = merged;
                    }
                      } else {
                        var inventory_serials = await HTTPRequest.getRequest(component_x.endPoint + "inventory_serials/get_serials_for_release_document?product_id="+product[0].product_id+"&site_id="+site_id+"&line_no="+product[0].line_no, null);
                        this.currentDrawerSerials = inventory_serials.map((item) => {
                          item = {...item, checked:false}
                          return item
                        });
                      }
                      this.serialMessage = "selected"
                      this.documentIsRel = true
                      this.defaultCountValue = Number(product[0].quantity) > this.currentDrawerSerials.length? this.currentDrawerSerials.length : Number(product[0].quantity);
                } else {
                    if (this.documentStatus == null) {
                        this.currentDrawerSerials = this.serialRows(product[0].document_line_serials);
                    } else {
                        if (product[0].document_line_serials) {
                            this.currentDrawerSerials = this.serialRows(product[0].document_line_serials);
                          } else {
                            var document_line_serials = await HTTPRequest.getRequest(component_x.endPoint + "document_line_serials/?document_line_id="+product[0].id, null);
                            this.currentDrawerSerials = this.serialRows(document_line_serials);
                          }
                        }
                      }
                      
               
                this.currentSerialCount = this.documentIsRel? this.currentDrawerSerials.filter(({checked}) => checked).length : this.currentDrawerSerials.length
                // this.previousSerialCount = this.currentDocumentTypeCode.includes("REL")? this.currentDrawerSerials.length : Number(product[0].quantity);
                this.previousSerialCount = this.documentIsRel ? this.defaultCountValue : Number(product[0].quantity);
                this.currentDrawerSerials = this.serialRows(this.currentDrawerSerials)
                this.currentDrawerSerialsInstance = [...this.currentDrawerSerials]
                this.serializationVisible = true
                this.serializationKey++;
            },
            async showDocumentPayment(status){
                var document_payments = await HTTPRequest.getRequest(component_x.endPoint + "document_payments?document_id="+this.documentNumber, null);
                this.documentPaymentsList = document_payments["data"]
                if(status==undefined){
                  this.documentPaymentsDrawerVisible = true
                    this.documentPaymentsKey++;
                }
            },
            async showSublocationAllocation(product){
                this.sublocationAllocationVisible = true
                this.selectedSublocationAllocationProduct = product[0];
                this.sublocationAllocationKey++;

                var document_type_code = '';
                var document_trans_code = '';
                var document_type_trans_code = await HTTPRequest.getRequest(component_x.endPoint + "document_types?table_prefix=inventory&id="+this.currentDocumentTypeId, null);
                if (document_type_trans_code.find(x => x.id === this.currentDocumentTypeId)) {
                    document_type_code = document_type_trans_code.find(x => x.id === this.currentDocumentTypeId).type_code
                    document_trans_code = document_type_trans_code.find(x => x.id === this.currentDocumentTypeId).trans_code
                }

                var site_id = secureStorage.getItem("defaultSiteId");
                if ((document_trans_code == 'REC' && document_type_code == 'SLI')  || (document_trans_code == 'REL' && document_type_code == 'SLO') || (document_trans_code == 'ORI' && document_type_code == 'SOX') || (document_trans_code == 'REL' && document_type_code == 'DDE' || (document_trans_code == 'OTH' && document_type_code == 'SIN') || (document_trans_code == 'REC' && document_type_code == 'CSR'))){
                    site_id = this.distributionSite.key
                }
                if ((document_trans_code == 'REL' && document_type_code == 'TRX') || (document_trans_code == 'REL' && document_type_code == 'CSX') || (document_trans_code == 'ORO' && document_type_code == 'TRQ' ) || (document_trans_code == 'ORO' && document_type_code == 'CSQ' )){
                    site_id = this.supplyingSite.key
                }
                if ((document_trans_code == 'REC' && document_type_code == 'TRX') || (document_trans_code == 'REC' && document_type_code == 'CSX') || (document_trans_code == 'ORI' && document_type_code == 'TRQ' ) || (document_trans_code == 'ORI' && document_type_code == 'CSQ' ) || (document_trans_code == 'ORI' && document_type_code == 'POX' )){
                    site_id = this.requestingSite.key
                }
                if ((document_trans_code == 'OTH' && document_type_code == 'PWS')){
                    site_id = this.forThisSite.key
                }

                this.drawerSublocationSiteId = (this.drawerSublocationSiteId > 0) ? this.drawerSublocationSiteId : site_id

                this.drawerSublocations = await HTTPRequest.getRequest(this.endPoint + 'sublocations/get_site_sublocations?site_id='+this.drawerSublocationSiteId, null)
                if (product[0].sublocation_allocation != undefined) this.drawerCurrentSublocationAllocation = product[0].sublocation_allocation
            },
            async showSiteAllocation(product){
                this.siteAllocationVisible = true
                this.selectedSiteAllocationProduct = product[0];
                this.siteAllocationKey++;

                this.drawerSites = await HTTPRequest.getRequest(this.endPoint + 'sites/get_all_document_sites', null)
                if (product[0].site_allocation != undefined) this.drawerCurrentSiteAllocation = product[0].site_allocation
                var total_site_quantity = this.drawerCurrentSiteAllocation.reduce((a, {quantity}) => a + parseInt(quantity), 0);
                this.siteAllocationRemainingQuantity = Number(this.selectedSiteAllocationProduct.quantity) - Number(total_site_quantity)
            },
            async showLotCodeExpiry(product){
                this.selectedLotCodeExpiryProduct = product[0];
                if (this.documentStatus == null) {
                    this.currentDrawerLotCodeExpiry = product[0].document_line_locations || [];
                } else {
                    if (product[0].document_line_locations) {
                        this.currentDrawerLotCodeExpiry = product[0].document_line_locations || [];
                    } else {
                        var document_line_locations = await HTTPRequest.getRequest(component_x.endPoint + "document_line_locations/?document_line_id="+product[0].id, null);
                        this.currentDrawerLotCodeExpiry = document_line_locations.data;
                    }
                }

                // Load available lotcodes
                var lotCodes = await HTTPRequest.getRequest(component_x.endPoint + "inventories/site_product_inventory_with_lotcode_expiry?product_id="+ product[0].product_id +"&product_type=" + product[0].product_type +"&site_id=" + secureStorage.getItem("defaultSiteId"), null);
                this.lotcodeSources = lotCodes;

                this.lotcodeTotalQty = 0
                this.currentDrawerLotCodeExpiry.map(item => {
                    if(this.selectedDocumentLines[0].product_type == 'P' && this.currentDocumentTypeCode.includes('REL'))
                        this.lotcodeTotalQty += Number(item['actual_quantity'])
                    else
                        this.lotcodeTotalQty += Number(item['quantity'])
                })

                this.lotCodeExpiryVisible = true
                //if (product[0].document_line_lotcode != undefined) this.drawerLotCode = product[0].document_line_lotcode;
                //if (product[0].document_line_expiry != undefined) this.drawerExpiryAt = product[0].document_line_expiry;
                //if (product[0].document_line_locations != undefined && product[0].document_line_locations.length > 0){
                //    this.drawerLotCode = product[0].document_line_locations[0].lot_code
                //    this.drawerExpiryAt = product[0].document_line_locations[0].expiry_at
                //}
                this.lotCodeExpiryKey++;
            },
            handleScroll () {
                var regular = document.getElementsByClassName("regular-header");
                var sticky = document.getElementsByClassName("sticky-header");
                if(window.scrollY>=160){
                    regular[0].style.visibility = 'hidden';
                    sticky[0].style.visibility = 'visible';
                } else {
                    regular[0].style.visibility = 'visible';
                    sticky[0].style.visibility = 'hidden';
                }
            },
            rowSelectionChanged(data, rows){
                this.selectedDocumentLines = data
                this.selectedDocumentLineRows = rows
            },
            totalGrossMutator(value, data){
                var total_gross = data.quantity * data.price
                return total_gross;
            },
            searchProducts(){
                if (this.productSearchInput){
                    this.tabulator.clearFilter();
                    this.searchFilter
                    this.tabulator.addFilter(this.searchFilter, "like", this.productSearchInput);
                } else {
                    this.tabulator.clearFilter();
                }
            },
            searchAddedProducts(){
                if (this.addedProductSearchInput){
                    this.tabulator.clearFilter();
                    this.searchFilterAddedProduct
                    this.tabulator.addFilter(this.searchFilterAddedProduct, "like", this.addedProductSearchInput);
                } else {
                    this.tabulator.clearFilter();
                }
            },
            validateTableDiscount(cell, value){
                var discount_text = value.split(',');
                var isValid = true
                var discountRegex = /(^\d{0,10}(\.\d{1,4})? *%?$)/;
                if (discount_text != '') {
                    discount_text.forEach(function(row) {
                        if (!discountRegex.test(row)) isValid = false;
                    });
                }
                return isValid;
            },
            isCellEditable(cell){

                //Disbale Editing if Option encoding behavior is "Linear"
                // if(this.document_config.document_type_settings.editorBehavior.radio == "L"){
                //     return false
                // }

                var column = cell.getColumn().getField();
                if ((this.documentStatus == 'Posted' ) || (this.documentStatus == 'Voided' ) || (this.documentStatus == 'Confirmed') || this.currentDocumentTypeCode=="OTHSIN"){
                    return false
                } else {
                    if (!this.accessRights.includes('W')){
                        return false
                    } else {
                        var physicalCountV2QuantityFields = ['quantity', 'actual_quantity', 'requested_quantity', 'delivery_quantity', 'goods_issue_quantity', 'actual_yield'];
                        if (this.isPhysicalCountV2QuantityEditLocked && physicalCountV2QuantityFields.includes(column)) {
                            return false;
                        }

                        // Check Edit Cost / Edit Price permissions for price/cost columns
                        var priceFields = ['price', 'price_pi', 'subtotal', 'price_without_vat', 'subtotal_without_vat']
                        var costFields = ['cost', 'total_cost', 'landed_cost', 'ordering_cost', 'original_cost']
                        if (priceFields.includes(column)) {
                            var priceChoice = this.productPriceChoice || ''
                            var isCostBasedPrice = (priceChoice == 'landed_cost' || priceChoice == 'ordering_cost' || priceChoice == 'original_cost')
                            if (isCostBasedPrice && !this.accessCostPriceRights.includes('B')) {
                                return false
                            } else if (!isCostBasedPrice && !this.accessCostPriceRights.includes('F')) {
                                return false
                            }
                        }
                        if (costFields.includes(column) && !this.accessCostPriceRights.includes('B')) {
                            return false
                        }

                        if (this.currentDocumentTypeCode=="RELDDE") {
                            if (this.documentNumber > 0) {
                                if (column == 'goods_issue_quantity' || column == 'remarks') {
                                    return true
                                } else {
                                    return false
                                }
                            } else {
                                if (column == 'delivery_quantity' || column == 'remarks') {
                                    return true
                                } else {
                                    return false
                                }
                            }
                        }
                        else if(this.currentDocumentTypeCode=="ORISOX"){
                            if (column == 'price' || column == 'discount_text' || column == 'quantity') {
                                return true
                            }
                        }
                        else if(this.currentDocumentTypeCode=="OTHSBI"){
                            if (column == 'price_pi') {
                                return true
                            } else {
                                return false
                            }
                        }
                        else if(this.currentDocumentTypeCode=="RECCSR"){
                            if (column == 'remarks' || column == 'quantity' || column == 'price') {
                                return true
                            } else {
                                return false
                            }
                        }
                        else if(this.currentDocumentTypeCode=="OTHPCK"){
                            if (column == 'quantity') {
                                if (this.originDocumentNumber > 0){
                                    return false
                                }else{
                                    return true
                                }
                            }else{
                                return true
                            }
                        }else if(this.currentDocumentTypeCode=="ORORSO"){
                            if (column == 'requested_quantity') {
                                if (secureStorage.getItem("defaultSiteId").toString() == this.requestingSite.key && this.forThisSite.key != secureStorage.getItem("defaultSiteId").toString()){
                                    return false
                                }else{
                                    return true
                                }
                            }else{
                                return true
                            }
                        }else {
                            return true
                        }
                    }
                }
            },
            quantityTooltip(cell){
                if(!cell._cell.row.data.is_weighted){
                    return 'Decimal Quantity is not allowed for this item'
                }else{
                    return 'Decimal Quantity is allowed for this item.Maximum number of decimal digit is 4'
                }
            },
            validateQuantity(cell, value){
                console.log(this.currentDocumentTypeCode, cell,value)
                if (value < 0){
                    return false;
                }else {
                    var field = cell._cell.column.field;
                    var ordered_quantity = 0;
                    var actual_quantity = 0;
                    var quantity = 0;
                    var isValid = true;
                    console.log(this.currentDocumentTypeCode)
                    if (this.currentDocumentTypeCode=="RELDDE"){
                        if (value > 0){
                            if (field == 'delivery_quantity'){
                                if (this.isOrderSourceMode) {
                                    ordered_quantity = cell._cell.row.data.ordered_quantity
                                    if (value > ordered_quantity) isValid = false
                                    if (value < 1) isValid = false
                                    return isValid;
                                } else {
                                    ordered_quantity = cell._cell.row.data.ordered_quantity
                                    actual_quantity = cell._cell.row.data.actual_quantity
                                    if (value > ordered_quantity) isValid = false
                                    if (value > actual_quantity) isValid = false
                                    if (value < 1) isValid = false
                                    return isValid;
                                }
                            } else if (field == 'goods_issue_quantity') {
                                ordered_quantity = cell._cell.row.data.ordered_quantity
                                if (value > Number(ordered_quantity)) isValid = false
                                if (value < 1) isValid = false
                                return isValid;
                            } else{
                                return true;
                            }
                        }else {
                            return true;
                        }
                    } else {
                        if (field == 'quantity') {
                            if (value < 0){
                                isValid = false
                            }
                            
                            if(!cell._cell.row.data.is_weighted){
                                if(Number.isInteger(Number(value)) == false){
                                    isValid=false
                                }
                            }else{
                                if (Number.isInteger(Number(value)) == false){
                                    if(value.toString().split('.')[1].length > 4){
                                        isValid = false
                                    }
                                }
                            }
                            
                            return isValid;
                        }else {
                            return true;
                        }
                    }
                }
            },
            //event when document line table has been edited
            async tabulatorCellEdit(e){
                console.log("begin edit")
                this.isEditing = true;
                const { field } = e._cell.column
                if(field === "quantity"){
                  const { product_type } = e._cell.row.data
                  const { value: quantity, oldValue:oldQuantity} = e._cell
                  if (product_type === "S") {
                    this.showSerialization([{...e._cell.row.data, quantity, oldQuantity}])
                  }
                }
                var cellElement = e.getElement(); 
                var product_id = e._cell.row.data.product_id
                var line_no = e._cell.row.data.line_no
                var unitPrice = 0
                if(field === "quantity"){
                    console.log(cellElement)
                    cellElement.setAttribute("data-testid", "tabulator-quantity-input-"+line_no);
                }

                if (e._cell.column.field == 'delivery_quantity'){
                    await this.tabulator.updateData([{line_no: line_no,product_id: product_id, quantity: Number(e._cell.value)}])
                }
                if (e._cell.column.field == 'goods_issue_quantity'){
                    await this.tabulator.updateData([{line_no: line_no,product_id: product_id, quantity: Number(e._cell.value)}])
                }
                if (this.orderSource=="shopify" || this.orderSource=="lazada" || this.orderSource=="shopee"|| this.orderSource=='zalora'){
                  // Insert code here
                }else{
                    if (e._cell.column.field == 'unit_name'){
                        var productCompositions = await HTTPRequest.getRequest(this.endPoint + 'products/'+e._cell.row.data.product_id+'/get_product_unit_compositions', null)
                        var selectedUnit = Number(e._cell.value)
                        var selectedProductId = productCompositions.find(x => x.unit_id == selectedUnit).key
                        var selectedProduct = await HTTPRequest.getRequest(this.endPoint + '/products/'+ selectedProductId);

                        unitPrice = eval('selectedProduct.'+this.productPriceChoice)
                        var unitCost = eval('selectedProduct.'+this.productPriceChoice)
                        var unitNetCost = eval('selectedProduct.'+this.productPriceChoice)

                        if (selectedProduct){
                            this.notifMessage = []
                            if (this.currentDocumentTypeCode=="RELTRX" || this.currentDocumentTypeCode=="RELCSX"){
                                var inventory = await HTTPRequest.getRequest(this.endPoint + 'inventories/site_product_inventory?product_id='+selectedProduct.id+'&site_id='+this.supplyingSite.key, null)
                                if (inventory.error) {
                                    this.notifMessage.push(inventory.error)
                                    this.documentActionNotification('Add document line', 'error')
                                    e.restoreOldValue();
                                    return
                                } else{
                                    this.delete_line(e._cell.row.data.line_no)
                                    var onHandQuantity = inventory.quantity
                                    var productName = selectedProduct.name
                                    var quantity = 1
                                    unitCost = Number(unitCost).toFixed(this.fixedDecimalPlaces)
                                    var discountText = []
                                    unitNetCost = Number(unitNetCost).toFixed(this.fixedDecimalPlaces)
                                    var discountTotal = 0
                                    var subTotal =  (quantity * unitCost).toFixed(this.fixedDecimalPlaces)

                                    console.log("add reg 6")
                                    this.addWarningForCostRestriction(selectedProduct, productName, quantity, 0, unitCost, subTotal, unitNetCost, discountTotal, discountText, onHandQuantity, '', '', 0);
                                }
                            }
                        }
                    }

                    if (e._cell.column.field == 'markup_percent'){
                        let landedCost = 0
                        if(e._cell.row.data != undefined){
                            landedCost = e._cell.row.data.landed_cost;
                        }
                        
                        let markUpPercent = e._cell.value;
                        let newRetailPrice = (Number(landedCost) + Number(landedCost) * markUpPercent / 100);
                        if (newRetailPrice < 0) newRetailPrice = 0;
                        await this.tabulator.updateData([{line_no: line_no,product_id: product_id, retail_price: newRetailPrice}]);
                    }

                    if (e._cell.column.field == 'landed_cost'){
                        let landedCost = e._cell.value;
                        let retailPrice = e._cell.row.data.retail_price;
                        let markUpPercent = '';
                        if (retailPrice && landedCost && !isNaN(retailPrice) && !isNaN(landedCost)) {
                            markUpPercent = 0;
                            if (landedCost > 0) markUpPercent = ((retailPrice - landedCost) / landedCost) * 100;
                        }
                        if (markUpPercent < 0) markUpPercent = 0;
                        await this.tabulator.updateData([{line_no: line_no,product_id: product_id, markup_percent: markUpPercent}]);
                    }

                    if (e._cell.column.field == 'retail_price'){
                        let landedCost = 0;
                        if(e._cell.row.data != undefined){
                            landedCost = e._cell.row.data.landed_cost;
                        }
                        let retailPrice = e._cell.value;
                        let markUpPercent = '';
                        if (retailPrice && landedCost && !isNaN(retailPrice) && !isNaN(landedCost)) {
                            markUpPercent = 0;
                            if (landedCost > 0) markUpPercent = ((retailPrice - landedCost) / landedCost) * 100;
                        }
                        if (markUpPercent < 0) markUpPercent = 0;
                        await this.tabulator.updateData([{line_no: line_no,product_id: product_id, markup_percent: markUpPercent}]);
                    }

                    var data = this.tabulator.getData();
                    this.sumSubtotal = 0
                    for(let i = 0; i < data.length; i++){
                        let item = data[i]
                        this.sumSubtotal = this.sumSubtotal + Number(item.subtotal)
                    }
                    let distributedOverallDiscount = 0
                    if(data.find(item => line_no === item.line_no)){
                        //Quantity Change
                        var cost = data.find(item => line_no === item.line_no).cost
                        quantity = data.find(item => line_no === item.line_no).quantity
                        var subtotal = Number(quantity) * Number(cost)
                        let distributedOverallDiscount = 0
                        if (Number(subtotal) != 0 || this.sumSubtotal != 0 || this.overallDiscount != 0){
                            distributedOverallDiscount = this.overallDiscount * (subtotal / this.sumSubtotal)
                        }
                        console.log("distOverallDisc", distributedOverallDiscount)
                        //Discount Change and Unit Cost Change
                        var discount_text = ""
                        var line_discount_text = data.find(item => line_no === item.line_no).discount_text
                        if (line_discount_text != null) {
                            discount_text = line_discount_text.split(',')
                        }
                        
                        //discount_text = _.compact(discount_text);
                        discountTotal = 0;
                        unitNetCost = data.find(item => line_no === item.line_no).price
                        var decimalPlaces = this.decimalPlaces
                        var notifMessage = []
                        var discountRegex = /(^\d{0,10}(\.\d{1,4})? *%?$)/;
                        if (discount_text.length > 0) {
                            discount_text.forEach(function(row) {
                                if (!discountRegex.test(row)) notifMessage.push(row + ' discount input is invalid \n \r');
                            });

                            if (notifMessage.length == 0) {
                                // var lessDiscount = /^L[0-9]+(\.[0-9][0-9]?)?$/;
                                var lessDiscount = /^L[0-9]+$/;
                                var lessDiscountDecimal = /^\d{0,10}(\.\d{1,10})?$/;
                                var numberRegex = /^[0-9]+$/;
                                // eslint-disable-next-line
                                // var percentDiscount = /^[0-9]+(\.[0-9][0-9]?)?\%$/;
                                var percentDiscount = /^[1][0][0]\.[0]{2}\%|[0-9]+\%|[1-9]?[0-9]\.[0-9]{1,4}\%$/;

                                discount_text.forEach(function(row) {
                                    var discount;
                                    var discountAmount;
                                    if (lessDiscount.test(row)) {
                                        discount = row.slice(1)
                                        discountAmount = (unitNetCost) - (discount)
                                        unitNetCost = unitNetCost - ((unitNetCost) - (discountAmount)).toFixed(decimalPlaces)
                                    } else if (lessDiscountDecimal.test(row)) {
                                        discount = row
                                        discountAmount = (unitNetCost) - (discount)
                                        unitNetCost = unitNetCost - ((unitNetCost) - (discountAmount)).toFixed(decimalPlaces)
                                    } else if (numberRegex.test(row)) {
                                        discount = row;
                                        discount = (discount / quantity)
                                        discountAmount = (unitNetCost) - ((unitNetCost) - (discount))
                                        unitNetCost = unitNetCost - (discountAmount).toFixed(decimalPlaces)
                                    } else if (percentDiscount.test(row)) {
                                        discount = row.slice(0,-1)
                                        discountAmount = (unitNetCost) * (discount / 100)
                                        unitNetCost = ((unitNetCost) - (discountAmount)).toFixed(decimalPlaces)
                                    }
                                    if (lessDiscount.test(row) || lessDiscountDecimal.test(row)) {
                                        discountTotal = discountTotal + (discount * quantity);
                                    } else {
                                        discountTotal = discountTotal + (discountAmount * quantity);
                                    }

                                });
                            } else {
                                discount_text.pop();
                                this.notifMessage = notifMessage
                                this.documentActionNotification('Document line discount', 'error')
                            }
                        }
                        if (this.currentDocumentTypeCode =='RELDDE') {
                            if (unitNetCost < 0) unitNetCost = 0
                            subtotal = (quantity * unitNetCost).toFixed(this.fixedDecimalPlaces)
                            await this.tabulator.updateData([{line_no: line_no,product_id: product_id, cost: unitNetCost, subtotal: subtotal, discount: discountTotal}])
                        } else {
                            if (unitNetCost < 0) unitNetCost = 0
                            var totalGross = data.find(item => line_no === item.line_no).total_gross
                            if (discountTotal >= totalGross) discountTotal = totalGross
                            subtotal = (quantity * unitNetCost).toFixed(this.fixedDecimalPlaces)

                            await this.tabulator.updateData([{line_no: line_no,product_id: product_id, cost: unitNetCost, subtotal: subtotal, discount: discountTotal, total_gross: totalGross}])
                        }
                    }

                    // Recalculate subtotal_without_vat, price_without_vat, tax_amount 
                    // Apply line discount
                    var subtotal_without_vat = 0
                    var price_without_vat = 0
                    var tax_amount = 0
                    let subtotal_less_overall_discount = Number(subtotal) - Number(distributedOverallDiscount)
                    console.log("distributedOverallDiscount3", distributedOverallDiscount)
                    if(this.party_tax_type == 'V' || this.party_tax_type == undefined){
                        if(e._cell.row.data.tax_type == "V"){
                            subtotal_without_vat = (subtotal_less_overall_discount / (1+Number(this.taxRate))).toFixed(this.fixedDecimalPlaces)
                            price_without_vat = (Number(unitPrice) / (1+Number(this.taxRate))).toFixed(this.fixedDecimalPlaces)
                            tax_amount =  (subtotal_less_overall_discount - subtotal_without_vat).toFixed(this.fixedDecimalPlaces)
                        } else {
                            subtotal_without_vat = (subtotal_less_overall_discount).toFixed(this.fixedDecimalPlaces)
                            price_without_vat = (Number(unitPrice)).toFixed(this.fixedDecimalPlaces)
                        }
                    } else {
                        subtotal_without_vat = (subtotal_less_overall_discount).toFixed(this.fixedDecimalPlaces)
                        price_without_vat = (Number(unitPrice)).toFixed(this.fixedDecimalPlaces)
                    }
                    
                    await this.tabulator.updateData([{line_no: line_no,product_id: product_id, subtotal_without_vat: subtotal_without_vat, price_without_vat:price_without_vat, tax_amount:tax_amount}])

                    this.calculateSummary();
                }

                console.log("end edit")
            },
            async populateMatrixItems(selectedProduct, productName, quantity, paramDiscountText) {
                window.scrollTo(0,0);
                this.spinning = true;
                this.spinMessage = 'Loading matrix items from ' + productName;
                
                var params = '/products/get_matrix_items?matrix_parent_id='+selectedProduct.id+'&matrix_item=1';
                var selectedProducts = await HTTPRequest.getRequest(this.endPoint + params);
                if (selectedProducts.length > 0){
                    const userInputUnitCost = this.matrixUserInputUnitCost();
                    const hasUserInputUnitCost = userInputUnitCost !== null;
                    for (let i = 0; i < selectedProducts.length; i++) {
                        var productName = selectedProducts[i].name
                        // unitcost equals to retail price note
                        var unitCost = hasUserInputUnitCost ? userInputUnitCost : selectedProducts[i][this.productPriceChoice]
                        var discountText = []
                        var unitNetCost = unitCost
                        var discountTotal = 0;

                        // for alternate supplier costing
                        if(!hasUserInputUnitCost && (this.currentDocumentTypeCode == 'OTHPUR' || this.currentDocumentTypeCode=="ORIPOX")){
                            let site_product_cost;
                            let site_product = await HTTPRequest.getRequest(this.endPoint + '/site_products/get_site_product?product_id=' + selectedProducts[i].matrix_parent_id + '&site_id=' + this.requestingSite.key);
                            
                            if(site_product != null){
                                let siteProductCost = site_product[this.productPriceChoice]
                                site_product_cost = Number(siteProductCost).toFixed(this.decimalPlaces)
                            }

                            if(site_product_cost && site_product_cost > 0){
                                unitCost = site_product_cost
                                unitNetCost = site_product_cost
                            }

                            if(this.supplier != null && this.supplier != undefined && this.supplier != ""){
                                if(Number(this.supplier.key) != Number(selectedProducts[i].supplier_id)){
                                    // if not main supplier get cost based on supplier products table
                                    let findSupplierProduct = await HTTPRequest.getRequest(this.endPoint + '/supplier_products?product_id='+ selectedProducts[i].matrix_parent_id+ '&supplier_id=' + this.supplier.key);
                                    if(findSupplierProduct != null){
                                        if(findSupplierProduct.data.length > 0){
                                            let supplierProduct = findSupplierProduct.data[0]
                                            unitCost = supplierProduct.ordering_cost
                                            unitNetCost = supplierProduct.ordering_cost
                                        }
                                    }
                                }
                            }
                        }

                        unitCost = Number(unitCost).toFixed(this.fixedDecimalPlaces)
                        unitNetCost = Number(unitNetCost).toFixed(this.fixedDecimalPlaces)

                        var notifMessage = []
                        if (paramDiscountText.length > 0) {
                            // eslint-disable-next-line
                            var discountRegex = /(^\d{0,10}(\.\d{1,4})? *%?$)/;
                            var discountText = paramDiscountText.join();
                            discountText = discountText.split(',');

                            discountText.forEach(function(row) {
                                if (!discountRegex.test(row)) notifMessage.push(row + ' discount input is invalid \n \r');
                            });

                            if (notifMessage.length == 0) {
                                var lessDiscount = /^L[0-9]+$/;
                                var lessDiscountDecimal = /^\d{0,10}(\.\d{1,10})?$/;
                                var numberRegex = /^[0-9]+$/;
                                // eslint-disable-next-line
                                var percentDiscount = /^[1][0][0]\.[0]{2}\%|[0-9]+\%|[1-9]?[0-9]\.[0-9]{1,4}\%$/;

                                var unitNetCost = unitCost
                                var quantity = quantity
                                var decimalPlaces = this.fixedDecimalPlaces

                                discountText.forEach(function(row) {
                                    var discount = 0;
                                    var discountAmount = 0;
                                    if (lessDiscount.test(row)) {
                                        discount = row.slice(1)
                                        discountAmount = (unitNetCost) - (discount)
                                        unitNetCost = unitNetCost - ((unitNetCost) - (discountAmount)).toFixed(decimalPlaces)
                                    } else if (lessDiscountDecimal.test(row)) {
                                        discount = row
                                        discountAmount = (unitNetCost) - (discount)
                                        unitNetCost = unitNetCost - ((unitNetCost) - (discountAmount)).toFixed(decimalPlaces)
                                    } else if (numberRegex.test(row)) {
                                        discount = row;
                                        discount = (discount / quantity)
                                        discountAmount = (unitNetCost) - ((unitNetCost) - (discount))
                                        unitNetCost = unitNetCost - (discountAmount).toFixed(decimalPlaces)
                                    } else if (percentDiscount.test(row)) {
                                        discount = row.slice(0,-1)
                                        discountAmount = (unitNetCost) * (discount / 100)
                                        unitNetCost = ((unitNetCost) - (discountAmount)).toFixed(decimalPlaces)
                                    }
                                    if (lessDiscount.test(row) || lessDiscountDecimal.test(row)) {
                                        discountTotal = discountTotal + (discount * quantity);
                                    } else{
                                        discountTotal = discountTotal + (discountAmount * quantity);
                                    }
                                });
                                if (unitNetCost < 0) unitNetCost = 0
                                unitNetCost = Number(unitNetCost).toFixed(decimalPlaces)
                                var subTotal = (quantity * unitNetCost).toFixed(decimalPlaces)
                                discountTotal = discountTotal
                            } else {
                                paramDiscountText.pop();
                                this.notifMessage = notifMessage
                                this.documentActionNotification('Document line discount', 'error')
                            }
                        }else {
                            var subTotal = (quantity * unitCost).toFixed(this.fixedDecimalPlaces)
                        }
                        // this.unitCost gets whats in price
                        console.log("add reg 1", discountTotal)
                        this.addWarningForCostRestriction(selectedProducts[i], productName, quantity, 0, unitCost, subTotal, unitNetCost, discountTotal, discountText, 0, "", "", 1);
                    }

                    this.calculateSummary();
                    this.$refs.autocomplete.clear();
                    this.clearProduct();
                }
                this.spinning = false;
                this.costUpdated = false;
                this.spinMessage = 'Loading...';
            },

            matrixUserInputUnitCost() {
                return this.unitCost === "" || this.unitCost === null || this.unitCost === undefined
                    ? null
                    : this.unitCost;
            },

            // function to clear current document line upon clicking "OK" on modal
            clearDocumentLine(){
              this.popUpModal.isVisible = false
              this.spinning = true;
              this.spinMessage = 'Clearing document lines'
              const data = this.tabulator.getRows()
              setTimeout(()=>{
                data.forEach((item, idx)=>{
                  let line_no = idx + 1
                  this.delete_line(line_no)
                  })  
              this.spinning = false;  
              this.spinMessage = 'Loading...'
              this.calculateSummary()
              this.populateBySupplier(this.supplier)
              },500)  
            },

            checkDocumentLine(){
              // validate if document line is currently filled
                if(this.tabulator.getRows().length > 0){
                 this.popUpModal.isVisible = true 
                 this.popUpModal.initializeProcess = this.clearDocumentLine
                 this.popUpModal.message = "Do you want to overwrite existing item(s)?"
                 this.popUpModal.text = "Click 'OK' to overwrite , 'Cancel' to retain current list and add item(s) below"
                 this.popUpModal.toClear = true
                }

               if(this.tabulator.getRows().length === 0){
                    this.popUpModal.isVisible = true 
                    this.popUpModal.initializeProcess = ()=>{this.populateBySupplier(this.supplier) } 
                    this.popUpModal.message = "Auto Populate By Supplier"
                    this.popUpModal.text = "Are you sure you want to populate the products from this supplier?"
               }

            },
            async populateMinMaxProducts(){
                this.spinning = true;

                const data = this.tabulator.getRows()
                data.forEach((item, idx)=>{
                  let line_no = idx + 1
                  this.delete_line(line_no)
                })

                for (let i = 0; i < this.minMaxProducts.length; i++) {
                        var productName = this.minMaxProducts[i].name
                        var quantity = this.minMaxProducts[i].order_quantity
                        var unitCost = eval('this.minMaxProducts[i].'+this.productPriceChoice)
                        var discountText = []
                        var unitNetCost = eval('this.minMaxProducts[i].'+this.productPriceChoice)
                
                        unitCost = Number(unitCost).toFixed(this.fixedDecimalPlaces)
                        unitNetCost = Number(unitNetCost).toFixed(this.fixedDecimalPlaces)
                        var discountTotal = 0

                        var subTotal = unitCost * quantity
                        if(this.minMaxProducts.length == (i+1)){
                            var triggerCompute = 0
                        }
                        else {
                            var triggerCompute = 1
                        }
                        this.addWarningForCostRestriction(this.minMaxProducts[i], productName, quantity, 0, unitCost, subTotal, unitNetCost, discountTotal, discountText, 0, "", "", triggerCompute);
                    }
                this.modalMinMaxProducts = false;
                this.spinning = false;
            },
            async populateOffTakeProducts(){
                this.spinning = true;
                const data = this.tabulator.getRows()
                data.forEach((item, idx)=>{
                  let line_no = idx + 1
                  this.delete_line(line_no)
                })

                for (let i = 0; i < this.offtakeProducts.length; i++) {
                        var productName = this.offtakeProducts[i].name
                        var quantity = this.offtakeProducts[i].order_quantity
                        var unitCost = eval('this.offtakeProducts[i].'+this.productPriceChoice)
                        var discountText = []
                        var unitNetCost = eval('this.offtakeProducts[i].'+this.productPriceChoice)
                
                        unitCost = Number(unitCost).toFixed(this.fixedDecimalPlaces)
                        unitNetCost = Number(unitNetCost).toFixed(this.fixedDecimalPlaces)
                        var discountTotal = 0

                        var subTotal = unitCost * quantity
                        if(this.offtakeProducts.length == (i+1)){
                            var triggerCompute = 0
                        } else {
                            var triggerCompute = 1
                        }
                        this.addWarningForCostRestriction(this.offtakeProducts[i], productName, quantity, 0, unitCost, subTotal, unitNetCost, discountTotal, discountText, 0, "", "", triggerCompute);
                    }
                this.modalOffTakeProducts = false;
                this.spinning = false;
            },
            async populateBySupplier(supplier){
                
               if(supplier == undefined || supplier == "" || supplier == null){
                    component_x.$notification['error']({
                        message: 'Supplier is required',
                        description: "Cannot auto-populate without a selected supplier.",
                        style: getNotificationStyle('error')
                    });
                    return false
               }

               this.popUpModal.isVisible = false
               this.showAddingProgress.isVisible = true
                var params = '/products/?per_page=200&supplier_id='+supplier.key+'&all=1';
                if (this.currentDocumentTypeCode == 'ORIPOX'){
                    params += '&is_non_trade=' + !this.isDocumentTrade;
                }
                var selectedProducts = await HTTPRequest.getRequest(this.endPoint + params);
                this.showAddingProgress.productCount = selectedProducts.data.length
                if (selectedProducts.data.length > 0){
                  for (let i = 0; i < selectedProducts.data.length; i++) {
                        this.showAddingProgress.productAdded = (i + 1)
                        var productName = selectedProducts.data[i].name
                        var quantity = 1.0
                        var unitCost = eval('selectedProducts.data[i].'+this.productPriceChoice)
                        var discountText = []
                        var unitNetCost = eval('selectedProducts.data[i].'+this.productPriceChoice)
                        
                        // for alternate supplier costing
                        if(this.currentDocumentTypeCode == 'OTHPUR' || this.currentDocumentTypeCode=="ORIPOX"){
                            let site_product_cost;
                            let site_product = await HTTPRequest.getRequest(this.endPoint + '/site_products/get_site_product?product_id=' + selectedProducts.data[i].id + '&site_id=' + this.requestingSite.key);
                                    
                            if(site_product != null){
                                let siteProductCost = eval('site_product.'+this.productPriceChoice)
                                site_product_cost = Number(siteProductCost).toFixed(this.decimalPlaces)
                            }

                            if(site_product_cost && site_product_cost > 0){
                                unitCost = site_product_cost
                                unitNetCost = site_product_cost
                            }

                            if(supplier != null && supplier != undefined && supplier != ""){
                                if(Number(supplier.key) != Number(selectedProducts.data[i].supplier_id)){
                                    // if not main supplier get cost based on supplier products table
                                    let findSupplierProduct = await HTTPRequest.getRequest(this.endPoint + '/supplier_products?product_id='+ selectedProducts.data[i].id+ '&supplier_id=' + supplier.key);
                                    if(findSupplierProduct != null){
                                        if(findSupplierProduct.data.length > 0){
                                            let supplierProduct = findSupplierProduct.data[0]
                                            unitCost = supplierProduct.ordering_cost
                                            unitNetCost = supplierProduct.ordering_cost
                                        }
                                    }
                                }
                            }
                        }

                        unitCost = Number(unitCost).toFixed(this.fixedDecimalPlaces)
                        unitNetCost = Number(unitNetCost).toFixed(this.fixedDecimalPlaces)
                        var discountTotal = 0

                        var subTotal = unitCost * quantity
                        if(selectedProducts.data.length == (i+1)){
                            var triggerCompute = 0
                        } else {
                            var triggerCompute = 1
                        }
                        this.addWarningForCostRestriction(selectedProducts.data[i], productName, quantity, 0, unitCost, subTotal, unitNetCost, discountTotal, discountText, 0, "", "", triggerCompute);
                    }
                }
                this.spinning = false;
                this.spinMessage = 'Loading...';
                this.showAddingProgress.isVisible = false
                this.showAddingProgress.productAdded = 0
                this.showAddingProgress.productCount = 0

               setTimeout(()=>{ 
                // Prompt how many product/s are successfully populated.
                 this.popUpModal.isVisible = true 
                 this.popUpModal.isAutoPopulate = true 
                 this.popUpModal.initializeProcess = () => {
                  this.popUpModal.isVisible = false
                  this.popUpModal.isAutoPopulate = false
                }
                 this.popUpModal.message = `Auto-populate Successful`
                 this.popUpModal.text = `${selectedProducts.data.length} Item(s) added to list`
                // alert(`${selectedProducts.data.length} Product(s) has been added to list.`)
                }
                ,1000)

            },
            reasonLookup(){
                var response = '';
                var request = new XMLHttpRequest();
                request.open('GET', this.endPoint + 'reasons/get_tabulator_reasons', false);
                request.setRequestHeader('Authorization', 'Bearer ' + secureStorage.getItem("accessToken"));
                request.setRequestHeader('Request-Source',"BXI-Web");
                request.setRequestHeader('ip',secureStorage.getItem("ipAddress"));
                request.send(null);
                if (request.status === 200) {
                    response = request.responseText;
                }
                var json_response = JSON.parse(response)
                return {values:json_response}
            },
            reasonFormatter(cell){
                var label = 'No Reason'
                if (cell._cell.row.data.reason_id != undefined){
                    var response = '';
                    var request = new XMLHttpRequest();
                    request.open('GET', this.endPoint + 'reasons/get_tabulator_reasons', false);
                    request.setRequestHeader('Authorization', 'Bearer ' + secureStorage.getItem("accessToken"));
                    request.setRequestHeader('Request-Source',"BXI-Web");
                    request.setRequestHeader('ip',secureStorage.getItem("ipAddress"));
                    request.send(null);
                    if (request.status === 200) {
                        response = request.responseText;
                    }
                    var json_response = JSON.parse(response)
                    if (json_response[0]!=undefined){
                        if (json_response[0].value != undefined) {
                            try {
                                label = json_response.find(element => element.value == cell._cell.row.data.reason_id.toString()).label;
                            } catch (error) {}
                        }
                    }

                }
                return label;
            },
            unitLookup(cell){
                var response = '';
                var request = new XMLHttpRequest();
                request.open('GET', this.endPoint + 'products/'+cell._cell.row.data.product_id+'/get_product_unit_compositions', false);
                request.setRequestHeader('Authorization', 'Bearer ' + secureStorage.getItem("accessToken"));
                request.setRequestHeader('Request-Source',"BXI-Web");
                request.setRequestHeader('ip',secureStorage.getItem("ipAddress"));
                request.send(null);
                if (request.status === 200) {
                    response = request.responseText;
                }
                var json_response = JSON.parse(response)
                json_response.forEach(element => {element.value = element.unit_id; delete element.unit_id;});
                return {values:json_response}
            },
            phpFormatter(cell){
                var field = (cell._cell.column.field).replace('_php','');
                var value = eval('cell._cell.row.data.'+field);
                var value_php
                if (this.isCurrencyToPhp){
                    if (this.supplierCurrencyId>0 && Number(this.supplierCurrencyRate) > 0 && (this.documentStatus == 'Posted' || this.documentStatus == 'Voided')){
                        value_php = Number(value * this.supplierCurrencyRate) || 0;
                    }else if (this.supplierDetails.currency_rate!=undefined && this.supplierDetails.currency_rate !=null && this.supplierDetails.currency_rate != 0 && this.supplierDetails.currency_rate != '0.0'){
                        value_php = Number(value * this.supplierCurrencyRate) || Number(value * this.supplierDetails.currency_rate) || 0;
                    }else if (this.documentDetails.currency_rate !=undefined && this.documentDetails.currency_rate !=null && this.documentDetails.currency_rate != 0 && this.documentDetails.currency_rate != '0.0'){
                        value_php = Number(value * this.documentDetails.currency_rate) || 0;
                    }else if (this.hasDefaultCurrency && this.defaultCurrencyRate!=0){
                        value_php = Number(value * this.defaultCurrencyRate) || 0;
                    }else {
                        value_php = Number(value * 1);
                    }
                }else{
                    value_php = Number(value / this.currencyRate) || 0;
                }
                value_php =  Math.round(value_php * 100) / 100
                var values = {}
                values[cell._cell.column.field] = value_php
                cell.getRow().update(values)
                return value_php;
            },
            async unitFormatter(cell){
                var label = 'No Product Unit'
                var unit_label = cell.getRow().getData().unit_label
                if (unit_label!=undefined){
                    label = unit_label
                }else{
                    let unitComposition = []
                    unitComposition = await HTTPRequest.getRequest(this.endPoint + 'products/'+cell._cell.row.data.product_id+'/get_product_unit_compositions')
                    if(unitComposition != undefined && unitComposition != '[]') {
                        if(unitComposition[0].key != undefined){
                            unitComposition.forEach(element => {element.value = element.unit_id; delete element.unit_id;});
                            // for request function
                            // console.log(unitComposition,'WORKING')
                            try {
                                label = unitComposition.find(element => element.value == cell._cell.row.data.unit_id.toString() && element.key == cell._cell.row.data.product_id.toString()).label;
                                // console.log(label)
                            } catch (error) {}
                        }
                    }
                }
                cell.getRow().update({"unit_label":label})
                return label;
            },
            // Document Header
            getSiteDropdownConfig(context) {
                const usesAllDocumentSites = this.currentDocumentTypeCode == 'RELTRX' || this.currentDocumentTypeCode == 'RECTRX' || this.currentDocumentTypeCode == 'OTHTRA'
                const endpoint = usesAllDocumentSites ? 'sites/get_all_document_sites' : 'sites/get_valid_document_sites'
                let notIncludedId = ''

                if (context == 'requestingSite' && this.currentDocumentTypeCode == 'RELTRX' && this.supplyingSite.key) {
                    notIncludedId = this.supplyingSite.key
                }

                if (context == 'supplyingSite' && this.currentDocumentTypeCode == 'ORITRQ' && this.requestingSite.key) {
                    notIncludedId = this.requestingSite.key
                }

                return {
                    cacheKey: `${context}|${endpoint}|${notIncludedId}`,
                    requestUrl: `${this.endPoint}${endpoint}${notIncludedId ? `?not_included_id=${notIncludedId}` : ''}`,
                }
            },
            async handleSitesDropdownVisibleChange(visible, context) {
                if (!visible || this.fetching) return

                const { cacheKey } = this.getSiteDropdownConfig(context)
                const cacheKeyField = context == 'supplyingSite' ? 'supplyingSitesCacheKey' : 'requestingSitesCacheKey'
                const sitesField = context == 'supplyingSite' ? 'supplyingSites' : 'requestingSites'

                if (this[cacheKeyField] == cacheKey && this[sitesField].length > 0) return

                await this.fetchSites(context)
            },
            async fetchSites(context) {
                const { cacheKey, requestUrl } = this.getSiteDropdownConfig(context)
                const cacheKeyField = context == 'supplyingSite' ? 'supplyingSitesCacheKey' : 'requestingSitesCacheKey'
                const sitesField = context == 'supplyingSite' ? 'supplyingSites' : 'requestingSites'

                this.fetching = true
                this[sitesField] = await HTTPRequest.getRequest(requestUrl, null)
                this[cacheKeyField] = cacheKey
                this.fetching = false
            },
            async fetchForThisSites() {
                this.fetching = true
                this.forThisSites = await HTTPRequest.getRequest(this.endPoint + 'sites/get_valid_document_sites', null)
                this.forThisSites.unshift({id: 0, code: 'All', name: 'All'})
                this.forThisSites.unshift({id: -1, code: 'Master', name: 'Master'})
                this.fetching = false
            },
            async handleDistributionSitesDropdownVisibleChange(visible) {
                if (!visible || this.fetching) return
                if (this.distributionSitesCacheKey == 'loaded' && this.distributionSites.length > 0) return

                await this.fetchDistributionSites()
            },
            async fetchDistributionSites() {
                if (this.distributionSitesCacheKey == 'loaded' && this.distributionSites.length > 0) return

                this.fetching = true
                this.distributionSites = await HTTPRequest.getRequest(this.endPoint + 'sites/get_valid_document_sites', null)
                this.distributionSitesCacheKey = 'loaded'
                this.fetching = false
            },
            async fetchPcountSublocations(){
                this.fetching = true
                this.sublocations = await HTTPRequest.getRequest(this.endPoint + 'sublocations/get_site_sublocations?site_id='+secureStorage.getItem("defaultSiteId"), null)
                this.fetching = false
            },
            async fetchSublocations(){
                if (this.distributionSite.key) {
                    this.fetching = true
                    this.sublocations = await HTTPRequest.getRequest(this.endPoint + 'sublocations/get_site_sublocations?site_id='+this.distributionSite.key, null)
                    this.fetching = false
                }
            },
            async fetchCustomers(value){
                this.customer = {key: '', label: value}
                if (value == undefined) value = ''
                this.customers = await HTTPRequest.getRequest(this.endPoint + 'customers/get_valid_customers?name='+value, null)
            },
            async selectCustomer (customer, option) {
                customer = customer.replace('customers','')
                this.customer = {key: customer, label: option.data.attrs.text}
                if (customer){
                    var customer = await HTTPRequest.getRequest(component_x.endPoint + "customers/"+customer, null);
                    this.customerAddress = (customer["address"]) ? customer["address"] : "No Customer Address";
                    this.customerContactMobile = (customer["mobile"]) ? customer["mobile"] : "No Customer Mobile";
                    this.customerContactTelephone = (customer["telephone"]) ? customer["telephone"] : "No Customer Telephone";
                    this.customerContactFax = (customer["fax"]) ? customer["fax"] : "No Customer Fax";
                    this.customerContactEmail = (customer["email"]) ? customer["email"] : "No Customer Email";
                    this.selectedCustomerContact = (customer["mobile"]) ? 'Mobile' : (customer["telephone"]) ? 'Telephone' : (customer["fax"]) ? 'Fax' : (customer["email"]) ? 'Email' : 'Telephone'
                    this.activeCustomerContact = (customer["mobile"]) ? this.customerContactMobile : (customer["telephone"]) ? this.customerContactTelephone : (customer["fax"]) ? this.customerContactFax : (customer["email"]) ? this.customerContactEmail : this.customerContactTelephone
                }

                if (this.currentDocumentTypeCode == 'ORISOX'){
                  // bryan
                    if (this.distributionSite.key > 0 && this.customer.key > 0) {
                        this.isProductSearchDisabled = false
                    } else {
                        this.isProductSearchDisabled = true
                    }
                }
            },
            async fetchSalesmen(value){
                this.salesman = {key: '', label: value}
                if (value == undefined) value = ''
                this.salesmen = await HTTPRequest.getRequest(this.endPoint + 'salesmen/get_valid_salesmen?name='+value, null)
            },
            async selectSalesman (salesman, option) {
                salesman = salesman.replace('salesman','')
                this.salesman = {key: salesman, label: option.data.attrs.text}
            },
            async selectDistributionSite (distributionSite) {
                distributionSite = {
                    key: distributionSite.key.replace('sites1',''),
                    label: distributionSite.label,
                }
                Object.assign(this, {
                    originSublocation: [],
                    destinationSublocation: [],
                    sublocations: [],
                })
                this.distributionSite = distributionSite

                await this.tabulator.clearData();

                if (this.currentDocumentTypeCode == 'ORISOX'){
                  // bryan
                    if (this.distributionSite.key > 0 && this.customer.key > 0) {
                        this.isProductSearchDisabled = false
                    } else {
                        this.isProductSearchDisabled = true
                    }
                } else {
                    if (this.distributionSite.key > 0) {
                        this.isProductSearchDisabled = false
                    } else {
                        this.isProductSearchDisabled = true
                    }
                }

                if (this.distributionSite.key > 0) {
                    this.isDestinationSublocationDisabled = false
                } else {
                    this.isDestinationSublocationDisabled = true
                }
            },
            async selectOriginSublocation (originSublocation) {
                var arr = {
                    key:originSublocation.key.replace('sublocations1',''),
                    label:originSublocation.label
                }
                originSublocation = arr
                Object.assign(this, {
                    originSublocation,
                    sublocations: [],
                    fetching: false,
                })

                //RELOAD Document Lines to retrieve actual quantity of sublocation on RELDDE
                window.scrollTo(0,0);
                this.spinning = true;
                var sales_order_id = this.$route.params.sales_order_id
                let document_lines = []
                document_lines = await HTTPRequest.getRequest(this.endPoint+'document_lines/'+sales_order_id+'?field_name=document_id&origin_sublocation='+originSublocation.key, null)
                if(document_lines != undefined && document_lines != null && document_lines != []){
                    document_lines.forEach( row => {
                        row.quantity = 0
                    });
                    await this.tabulator.clearData();
                    await this.tabulator.addData(document_lines, true);
                }
                this.tabulator.addFilter("line_no", ">", 0);
                if(document_lines != undefined && document_lines != null && document_lines != []){
                    component_x.origData = JSON.stringify(document_lines.reverse()) //For isDirty Data on Document lines
                } 
                this.spinning = false;
            },
            selectDestinationSublocation (destinationSublocation) {
                var arr = {
                    key:destinationSublocation.key.replace('sublocations2',''),
                    label:destinationSublocation.label
                }
                destinationSublocation = arr
                Object.assign(this, {
                    destinationSublocation,
                    sublocations: [],
                    fetching: false,
                })
            },
            selectSupplyingSite (supplyingSite) {
                 var arr = {
                    key:supplyingSite.key.replace('sites',''),
                    label:supplyingSite.label
                }
                supplyingSite = arr
                Object.assign(this, {
                    supplyingSite,
                    fetching: false,
                    requestingSites: [],
                    requestingSitesCacheKey: '',
                })
            },
            selectRequestingSite (requestingSite) {
                var arr = {
                    key:requestingSite.key.replace('selectRequestingSite',''),
                    label:requestingSite.label
                }
                requestingSite = arr
                Object.assign(this, {
                    requestingSite,
                    fetching: false,
                    supplyingSites: [],
                    supplyingSitesCacheKey: '',
                })
            },
            selectRevenue (revenue) {
                this.revenue = revenue.replace('selectRevenue','')
                this.fetching=false
            },
            async fetchSuppliers(value) {
                this.supplier = {key: '', label: value}
                if (value == undefined) value = ''
                this.suppliers = await HTTPRequest.getRequest(this.endPoint + 'suppliers/get_valid_suppliers?name='+value, null)
                this.supplierDetails = {}
                if (this.supplier.key !=undefined && this.supplier.key!=''){
                    this.forceFetchCurrency = true
                    this.showConversionRate = false
                    this.showConversionCurrencyRate()
                }
            },
            async fetchDefaultCurrency() {
                var default_currency = await HTTPRequest.getRequest(this.endPoint + 'currencies/get_default_currency', null)
                if(default_currency["error"] == undefined){
                    try{
                        if(this.currency.key==undefined){
                            this.currency = {key: default_currency.id, label: default_currency.currency}
                        }
                    }catch(e){
                        this.currency = {key: default_currency.id, label: default_currency.currency}
                    }
                    this.hasDefaultCurrency = default_currency.has_default_currency
                    this.defaultCurrencyDetails = default_currency
                    this.defaultCurrencyRate = default_currency.currency_rate
                    this.isRunDefaultCurrency = true
                }else{
                    this.notifMessage = default_currency["error"].split(",");
                }
            },

            // Start
            // https://tools.iripple.com/barter-11/bxi-backend/-/issues/1724
            // Target Date & Cancellation Date for PO is not getting the assigned date from supplier template

            changeDate () {
                    this.isEditing = true
                if( ['ORIPOX', 'OTHPUR', 'RELRSR', 'RECDEL'].includes(this.currentDocumentTypeCode) ) {
                    this.targetDate = moment(this.documentDate, "YYYY-MM-DD").add(this.suppDetails.delivery_lead_time, 'days');
                    this.cancellationDate = moment(this.documentDate, "YYYY-MM-DD").add(this.suppDetails.delivery_lead_time + this.suppDetails.days_to_cancel, 'days');
                }
            },

            // https://tools.iripple.com/barter-11/bxi-backend/-/issues/1724
            // Target Date & Cancellation Date for PO is not getting the assigned date from supplier template
            // End

            async selectSupplier (supplier, option) {
                supplier = supplier.replace('selectSupplier','')

                // Start
                // https://tools.iripple.com/barter-11/bxi-backend/-/issues/1724
                // Target Date & Cancellation Date for PO is not getting the assigned date from supplier template

                if( ['OROTRQ', 'OROCSQ', 'ORITRQ', 'ORICSQ', 'RECTRX', 'RELTRX', 'OTHPUR', 'ORIPOX', 'RECDEL', 'RELRSR', 'ORITRQ', 'OROTRQ', 'RECTRX', 'RELTRX'].includes(this.currentDocumentTypeCode) ) {
                    this.suppDetails = await HTTPRequest.getRequest(this.endPoint + 'suppliers/' + supplier, null)

                    this.targetDate = moment(this.documentDate, "YYYY-MM-DD").add(this.suppDetails.delivery_lead_time, 'days').utc().startOf('day');
                    this.cancellationDate = moment(this.documentDate, "YYYY-MM-DD").add(this.suppDetails.delivery_lead_time + this.suppDetails.days_to_cancel, 'days').utc().startOf('day');

                    //1935 - Populate supplier header and support discount
                    if(this.suppDetails.support_discount_text!=null && this.suppDetails.support_discount_text.length > 0 )
                        this.supportDiscount = this.suppDetails.support_discount_text.toString().split(",")
                    else
                        this.supportDiscount = []
                    if(this.suppDetails.discount_text!=null && this.suppDetails.discount_text.length > 0 )
                        this.headerDiscount = this.suppDetails.discount_text.toString().split(",")
                    else
                        this.headerDiscount = []

                    //2370
                    this.party_tax_type = this.suppDetails.vat_type
                }

                // https://tools.iripple.com/barter-11/bxi-backend/-/issues/1724
                // Target Date & Cancellation Date for PO is not getting the assigned date from supplier template
                // End

                this.forceFetchCurrency = true
                let check_supplier = this.suppliers.findIndex(x=> x.id == supplier)
                let currency_id =null
                if (check_supplier>=0){
                    let supplier_details = this.suppliers[check_supplier]
                    this.supplierDetails = supplier_details
                    if (supplier_details.currency_id>0){
                        this.supplierCurrencyRate = supplier_details.currency_rate
                        this.supplierCurrencyId = supplier_details.currency_id
                        currency_id = supplier_details.currency_id
                        if(this.currencies.length <= 0 || this.hasDefaultCurrency){
                            this.forceFetchCurrency = true
                            await this.fetchCurrencies()
                        }
                        let currency_details = this.currencies.find(c => parseInt(c.id) == parseInt(this.suppliers[check_supplier].currency_id))
                        if (currency_details!=undefined){
                            let currency = {
                                key:this.suppliers[check_supplier].currency_id,
                                label:currency_details.code,
                            }
                            this.currencyRate = currency_details.conversion || 0
                            Object.assign(this, {
                                currency,
                                fetching: false,
                                currencyDetails:currency_details,
                            })
                            this.forceFetchCurrency = true
                            await this.fetchCurrencies()
                            await this.showConversionCurrencyRate()
                        }
                        this.calculateSummary();    
                    }else{
                        this.supplierCurrencyRate = 0
                        this.supplierCurrencyId = -1
                        this.supplierDetails = {}
                        await this.fetchCurrencies()
                    }
                }else{
                    supplier = 0
                    this.supplierCurrencyRate = 0
                    this.supplierCurrencyId = -1
                    this.supplierDetails = {}
                    await this.fetchCurrencies()
                }
                Object.assign(this, {
                    suppliers: [],
                })
                this.supplier = {key: supplier, label: option.data.attrs.text,currency_id:currency_id}
                this.$refs.supplierAutoCompleteInput.blur()
                this.$refs.autocomplete.clear()
            },

            showSupplierModal(){
                if(this.currentDocumentTypeCode == 'OTHPUR' || this.currentDocumentTypeCode == 'ORIPOX'){
                    let _data = this.tabulator.getData();
                    if(_data.length > 0){
                        this.showChangeSupplierModal = true
                    }
                }
            },

            //Add Product / Search Product
            changeProductFormMode(val) {
                this.productFormMode = val
                if (val == "Add") {
                    this.tabulator.clearFilter();
                    this.productSearchInput = ''
                }
            },
            changeSearchFilter(searchFilter){
                this.productSearchInput = ''
                var search_text = searchFilter.split('_');
                if (this.currentDocumentTypeCode=='OTHCNS'){
                    this.placeholder = "Search by " + search_text.join(' ')
                }else{
                    this.placeholder = "Search product by " + search_text.join(' ')
                }
                // if (searchFilter == 'code') {
                //     searchFilter = 'product_id'
                // }
                // if (searchFilter == 'document_id') {
                //     searchFilter = 'id'
                // }
                this.searchFilter = searchFilter
            },

            changesearchFilterAddedProduct(searchFilter){
                this.addedProductSearchInput = ''
                if(this.addedProductSearchInput == ''){
                    this.searchAddedProducts()
                }
                var search_text = searchFilter.split('_');
                if (this.currentDocumentTypeCode=='OTHCNS'){
                    this.addedProductPlaceholder = "Search by " + search_text.join(' ')
                }else{
                    this.addedProductPlaceholder = "Search added product by " + search_text.join(' ')
                }
                if (searchFilter == 'code') {
                    searchFilter = 'product_id'
                }
                if (searchFilter == 'name') {
                    searchFilter = 'product_name'
                }
                this.searchFilterAddedProduct = searchFilter
            },

            productEndpointOld (input) {

                let siteId = this.documentCurrentSite || secureStorage.getItem("defaultSiteId");
                var params = '/products?&type=document&site_id=' + siteId + "&"
                const siteScopedDocumentTypes = ['RECDEL', 'RECTRX', 'RECCSR', 'RELSLO', 'RECSLI', 'OTHPCN', 'OTHTRA', 'OROTRQ', 'OROCSQ', 'ORORSO'];
                if (this.currentDocumentTypeCfode == 'OTHASM' || this.currentDocumentTypeCode == 'OTHDSM'){
                    params = '/products?&type=ASMDSMDOC&site_id' + siteId + "&"
                }
                if (this.currentDocumentTypeCode == 'ORISOX'){
                    params = '/products?site_id='+this.distributionSite.key+'&type=ORISOXDOC&'
                }

                if(this.supplier.key == ''){
                    this.supplier.key = undefined
                }

                if (this.filterBySupp && this.supplier.key > 0){
                    params = '/products?type=document&supplier_id=' + this.supplier.key + '&site_id=' + siteId  + "&"
                }
                else if (this.filterBySupp && this.supplier.key == undefined) {
                    if (this.document_config.document_type_settings.incomingOrder.requireSupplierInPo){
                        component_x.$notification['error']({
                            message: 'Supplier is required',
                            description: "Filter product by supplier is enabled.",
                            style: getNotificationStyle('error')
                        });
                    }
                    params = '/products?type=document&supplier_id=0&site_id=' + siteId + "&"
                }
                else {
                    params = '/products?type=document&site_id=' + siteId + "&"
                }

                if (this.currentDocumentTypeCode == 'OTHPWS') {
                    if (this.filterBySupp == false || this.filteredBySupplier == false) {
                        params = '/products?type=document&site_id=' + siteId + '&'
                    } else {
                        params = '/products?type=document&supplier_id=' + this.supplier.key + '&site_id=' + siteId + '&'
                    }
                }

                if(['OTHPUR', 'RECDEL'].includes(this.currentDocumentTypeCode)) {
                    if (this.filterBySupp == false || this.supplier.key == undefined){
                        params = '/products?type=document&site_id=' + siteId + "&"
                    } else {
                        params = '/products?type=document&supplier_id=' + this.supplier.key + '&site_id=' + siteId + "&"
                    }
                }

                if (this.currentDocumentTypeCode == 'RECCSR' && component_x.openCSR != undefined && !(component_x.openCSR)){
                    var document_id = this.$route.params.sales_order_id
                    params = `/products?type=RECCSRDOC&origin_document_id=${component_x.documentNumber > 0 ?  component_x.documentNumber : this.$route.params.sales_order_id }&`
                }
                if (this.currentDocumentTypeCode == 'ORIPOX'){
                    siteId = (this.requestingSite && this.requestingSite.key)
                        ? this.requestingSite.key
                        : (this.documentCurrentSite || secureStorage.getItem("defaultSiteId"));
                    params += 'site_id=' + siteId + '&' + 'is_non_trade=' + !this.isDocumentTrade + '&' + 'documenttype=ORIPOX&';
                }
                if (['RELTRX', 'RELCSX', 'OTHTRA', 'OROTRQ', 'OROCSQ'].includes(this.currentDocumentTypeCode) && this.supplyingSite && this.supplyingSite.key) {
                    siteId = this.supplyingSite.key;
                }
                if (['RECTRX', 'RECCSX', 'ORITRQ', 'ORICSQ'].includes(this.currentDocumentTypeCode) && this.requestingSite && this.requestingSite.key) {
                    siteId = this.requestingSite.key;
                }
                if (['RECCSR', 'RELSLO', 'RECSLI'].includes(this.currentDocumentTypeCode) && this.distributionSite && this.distributionSite.key) {
                    siteId = this.distributionSite.key;
                }
                if (this.currentDocumentTypeCode == 'OTHPWS' && this.forThisSite && this.forThisSite.key) {
                    siteId = this.forThisSite.key;
                }
                if (this.currentDocumentTypeCode == 'ORORSO' && this.requestingSite && this.requestingSite.key) {
                    siteId = this.requestingSite.key;
                }
                if (!params.includes('site_id=') && siteScopedDocumentTypes.includes(this.currentDocumentTypeCode) && siteId) {
                    params += 'site_id=' + siteId + '&';
                }
                if (this.document_config.document_type_settings.editorBehavior.radio == 'P' || this.document_config.document_type_settings.editorBehavior.radio == 'L'){
                    params +='is_scanner=true&'
                }
                //2114
                if(['OTHPUR', 'RECDEL', 'OTHASM', 'OTHDSM'].includes(this.currentDocumentTypeCode)) {
                    params += 'documenttype=' + this.currentDocumentTypeCode + '&';
                } 
                // console.log(this.endPoint + params + this.searchFilter + '=' + input + '&sort=alphabetical', this.currentDocumentTypeCode);
                return this.endPoint + params + this.searchFilter + '=' + input + '&sort=alphabetical';
            },

            productEndpoint(input) {
                const documentType = this.currentDocumentTypeCode;
                const params = new URLSearchParams();

                const supplierId = this.supplier && this.supplier.key !== ''
                    ? this.supplier.key
                    : undefined;

                // Transfer Documents should consider common site_products of both supplying and requesting sites #
                if (['RELTRX', 'RECTRX'].includes(documentType)) {
                    var supplyingSiteId  = this.supplyingSite.key
                    var requestingSiteId = this.requestingSite.key
                }else{
                    console.log("I must be here...")
                    var siteId = this.resolveProductSiteId(documentType);
                }

                params.set('type', this.resolveProductType(documentType));

                if (this.isClosedCsrProductLookup(documentType)) {
                    params.set('type', 'RECCSRDOC');
                    params.set(
                        'origin_document_id',
                        component_x.documentNumber > 0
                            ? component_x.documentNumber
                            : this.$route.params.sales_order_id
                    );
                } else {
                    if (['RELTRX', 'RECTRX'].includes(documentType)) {
                        params.set('supplying_site_id', supplyingSiteId);
                        params.set('requesting_site_id', requestingSiteId);
                        params.set('documenttype', documentType);
                    } else {
                        if (siteId) {
                            params.set('site_id', siteId);
                        }
                    }

                    if (this.filterBySupp)
                        this.applySupplierProductFilter(params, documentType, supplierId);

                    if (documentType === 'ORIPOX') {
                        params.set('site_id', siteId);
                        params.set('is_non_trade', !this.isDocumentTrade);
                        params.set('documenttype', 'ORIPOX');
                    }

                    if (['OTHPUR', 'RECDEL', 'OTHASM', 'OTHDSM'].includes(documentType)) {
                        params.set('documenttype', documentType);
                    }
                }

                const scannerMode = ['P', 'L'].includes(
                    this.document_config.document_type_settings.editorBehavior.radio
                );

                if (scannerMode) {
                    params.set('is_scanner', true);
                }

                params.set(this.searchFilter, input);
                params.set('sort', 'alphabetical');

                return `${this.endPoint}/products?${params.toString()}`;
            },

            resolveProductType(documentType) {
                if (['OTHASM', 'OTHDSM'].includes(documentType)) {
                    return 'ASMDSMDOC';
                }

                if (documentType === 'ORISOX') {
                    return 'ORISOXDOC';
                }

                return 'document';
            },

            resolveProductSiteId(documentType) {
                const defaultSiteId = this.documentCurrentSite || secureStorage.getItem('defaultSiteId');

                if (['RELCSX', 'OTHTRA', 'OROTRQ', 'OROCSQ'].includes(documentType)) {
                    return this.supplyingSite && this.supplyingSite.key
                        ? this.supplyingSite.key
                        : defaultSiteId;
                }

                if (['RECCSX', 'ORITRQ', 'ORICSQ', 'ORIPOX', 'ORORSO'].includes(documentType)) {
                    return this.requestingSite && this.requestingSite.key
                        ? this.requestingSite.key
                        : defaultSiteId;
                }

                if (['RECCSR', 'RELSLO', 'RECSLI', 'ORISOX'].includes(documentType)) {
                    return this.distributionSite && this.distributionSite.key
                        ? this.distributionSite.key
                        : defaultSiteId;
                }

                if (documentType === 'OTHPWS') {
                    return this.forThisSite && this.forThisSite.key
                        ? this.forThisSite.key
                        : defaultSiteId;
                }

                return defaultSiteId;
            },

            applySupplierProductFilter(params, documentType, supplierId) {
                if (documentType === 'OTHPWS') {
                    if (this.filteredBySupplier && supplierId) {
                        params.set('supplier_id', supplierId);
                    }

                    return;
                }

                if (['OTHPUR', 'RECDEL'].includes(documentType)) {
                    if (supplierId) {
                        params.set('supplier_id', supplierId);
                    }

                    return;
                }

                if (!this.filterBySupp) {
                    return;
                }

                if (supplierId > 0) {
                    params.set('supplier_id', supplierId);
                    return;
                }

                if (this.document_config.document_type_settings.incomingOrder.requireSupplierInPo) {
                    component_x.$notification.error({
                        message: 'Supplier is required',
                        description: 'Filter product by supplier is enabled.',
                        style: getNotificationStyle('error')
                    });
                }

                params.set('supplier_id', 0);
            },

            isClosedCsrProductLookup(documentType) {
                return documentType === 'RECCSR'
                    && component_x.openCSR !== undefined
                    && !component_x.openCSR;
            },

            formattedDisplay (result) {
                if (this.searchFilter == 'name'){
                    let namePrefix = result[this.document_config.document_type_settings.editorBehavior.prefixSearch]
                    let resultPrefix = (namePrefix) ? `[ ${namePrefix} ] ` : '';
                    return resultPrefix + eval('result.'+this.searchFilter);
                } else{
                    return eval('result.'+this.searchFilter) + ' ['+result.name+']';
                }
            },
            async getProduct (group) {
                 // On initial loading of document the value of on-hand quantity/available quantity in the UI is (*).
                if(this.isRefreshInventory == false && (this.documentStatus == 'Saved' || this.documentStatus == null)) {
                    this.onHandQuantity = '*'
                } else {
                    var lastinv = await HTTPRequest.getRequest(this.endPoint + 'inventories/site_product_inventory?product_id='+group.selectedObject.id+'&site_id='+secureStorage.getItem("defaultSiteId"), null)
                    if (lastinv.onhand_quantity != undefined)
                        this.onHandQuantity = lastinv.onhand_quantity
                    else
                        this.onHandQuantity = 0
                }

                this.notifMessage = []
                if (this.currentDocumentTypeCode == 'OTHASM' && group.selectedObject.product_type == "R"){
                    this.actual_yield = group.selectedObject.yield_quantity || 0;
                    this.tolerance_quantity = group.selectedObject.tolerance_quantity || 0;
                    this.showActualYield = true;
                }

                if (this.currentDocumentTypeCode=="RELTRX" || this.currentDocumentTypeCode=="RELCSX"){
                    var inventory = await HTTPRequest.getRequest(this.endPoint + 'inventories/site_product_inventory?product_id='+group.selectedObject.id+'&site_id='+this.supplyingSite.key, null)
                    if (inventory.error) {
                        this.notifMessage.push(inventory.error)
                        this.documentActionNotification('Add document line', 'error')
                        return
                    } else{
                        this.onHandQuantity = inventory.onhand_quantity / group.selectedObject.content_quantity
                    }
                }

                if (this.currentDocumentTypeCode=="ORISOX"){
                    var inventory = await HTTPRequest.getRequest(this.endPoint + 'inventories/site_product_inventory?product_id='+group.selectedObject.id+'&site_id='+this.distributionSite.key, null)
                    if (inventory.error) {
                        this.notifMessage.push(inventory.error)
                        this.documentActionNotification('Add document line', 'error')
                        return
                    } else{
                        this.onHandQuantity = inventory.onhand_quantity  / group.selectedObject.content_quantity
                    }
                }

                if (this.currentDocumentTypeCode=="OTHTRA"){
                    var inventory = await HTTPRequest.getRequest(this.endPoint + 'inventories/site_product_inventory?product_id='+group.selectedObject.id+'&site_id='+this.supplyingSite.key, null)
                    if (inventory.error) {
                        this.notifMessage.push(inventory.error)
                        this.documentActionNotification('Add document line', 'error')
                        return
                    } else{
                        this.onHandQuantity = inventory.onhand_quantity  / group.selectedObject.content_quantity
                    }
                }
                var unitCost = eval('group.selectedObject.'+this.productPriceChoice)
                var unitNetCost = eval('group.selectedObject.'+this.productPriceChoice)

                var site_id = secureStorage.getItem("defaultSiteId");
                var isRel = this.currentDocumentTypeCode.includes("REL");
                var isRec = this.currentDocumentTypeCode.includes("REC");
                if (isRel || isRec) {
                    let currency_params = ""
                    if (this.supplier.currency_id!=null && this.currencyRate!=null){
                        currency_params = '&currency_id='+this.supplier.currency_id+'&currency_rate='+this.currencyRate
                    }
                    // var inventory_cost = await HTTPRequest.getRequest(this.endPoint + 'inventory_costs/get_latest_inventory_cost?product_id='+group.selectedObject.id+'&site_id='+site_id+' ' +currency_params, null)
                    // if (inventory_cost.cost){
                    //     this.unitCost = inventory_cost.cost
                    //     this.unitNetCost= inventory_cost.cost
                    // } else {
                        this.unitCost = unitCost
                        this.unitNetCost= unitNetCost
                    //}
                }else {
                    this.unitCost = unitCost
                    this.unitNetCost= unitNetCost

                    // for alternate supplier costing
                    if(this.currentDocumentTypeCode == 'OTHPUR' || this.currentDocumentTypeCode=="ORIPOX"){
                        let site_product_cost;
                        let site_product = await HTTPRequest.getRequest(this.endPoint + '/site_products/get_site_product?product_id=' + group.selectedObject.id + '&site_id=' + this.requestingSite.key);
                                
                        if(site_product != null){
                            let siteProductCost = eval('site_product.'+this.productPriceChoice)
                            site_product_cost = Number(siteProductCost).toFixed(this.decimalPlaces)
                        }

                        if(site_product_cost && site_product_cost > 0){
                            this.unitCost = site_product_cost
                            this.unitNetCost = site_product_cost
                        }

                        if(this.supplier != null && this.supplier != undefined && this.supplier != ""){
                            if(Number(this.supplier.key) != Number(group.selectedObject.supplier_id)){
                                // if not main supplier get cost based on supplier products table
                                let findSupplierProduct = await HTTPRequest.getRequest(this.endPoint + '/supplier_products?product_id='+ group.selectedObject.id+ '&supplier_id=' + this.supplier.key);
                                if(findSupplierProduct != null){
                                    if(findSupplierProduct.data.length > 0){
                                        let supplierProduct = findSupplierProduct.data[0]
                                        this.unitCost = supplierProduct.ordering_cost
                                        this.unitNetCost = supplierProduct.ordering_cost
                                    }
                                }
                            }
                        }
                    }
                }

                this.selectedParentProduct = group.selectedObject
                this.selectedProduct = group.selectedObject
                if (group.selectedObject.product_type == "R") {
                    this.productName = group.selectedObject.name + ' : ' + group.selectedObject.finished_product_name
                } else {
                    this.productName = group.selectedObject.name
                }

                this.inputProduct = group.selectedObject.name
                this.quantity = 0
                this.productComposition = group.selectedObject.product_unit_content
                console.log("unitcost", this.unitCost, this.unitNetCost, this.decimalPlaces)
                // For supplier related document (PO)
                // IF PO and Supplier is Non-VAt and Product is Vatable / Remove vat from Unit Cost
                if(this.currentDocumentTypeCode == 'ORIPOX') {
                    if (this.party_tax_type == 'N' || this.party_tax_type == 'X'){
                        if (group.selectedObject.tax_type == 'V'){
                            this.unitCost = Number(this.unitCost / (1+Number(this.taxRate))).toFixed(this.fixedDecimalPlaces)
                            this.unitNetCost = Number(this.unitNetCost / (1+Number(this.taxRate))).toFixed(this.fixedDecimalPlaces)
                        } else {
                            this.unitCost = Number(this.unitCost).toFixed(this.fixedDecimalPlaces)
                            this.unitNetCost = Number(this.unitNetCost).toFixed(this.fixedDecimalPlaces)
                        }
                    } else {
                        this.unitCost = Number(this.unitCost).toFixed(this.fixedDecimalPlaces)
                        this.unitNetCost = Number(this.unitNetCost).toFixed(this.fixedDecimalPlaces)
                    }
                } else {
                    this.unitCost = Number(this.unitCost).toFixed(this.fixedDecimalPlaces)
                    this.unitNetCost = Number(this.unitNetCost).toFixed(this.fixedDecimalPlaces)
                }
                console.log("after unitcost", this.unitCost, this.unitNetCost, this.decimalPlaces)
                this.isDocumentLineFormDisabled = false
                this.isProductNameDisabled = this.isProductNameEditConfigDisabled
                this.discountText = []
                this.subTotal = (this.quantity * this.unitCost).toFixed(this.fixedDecimalPlaces)

                if (this.currentDocumentTypeCode=="ORISOX" && this.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.allowPromotionComputation) {
                    var request_body = {
                        document_date: this.documentDate.format(),
                        site_id: this.distributionSite.key,
                        unit_cost: this.unitCost,
                        product_id: group.selectedObject.id,
                        customer_id: this.customer.key
                    }
                    var promotion = await HTTPRequest.postRequest(this.endPoint + 'promotions/is_applicable', null, request_body)

                    if (promotion.applied_promo_reward_code != null) {
                        this.unitNetCost = promotion.new_unit_cost.toFixed(this.fixedDecimalPlaces)
                        this.promoName = promotion.applied_promo_name
                        this.rewardCode = promotion.applied_promo_reward_code
                        this.rewardDiscountAmount = promotion.discounted_amount
                        this.discountText.push(promotion.discounted_amount)
                        this.subTotal = (this.subTotal - promotion.discounted_amount).toFixed(this.fixedDecimalPlaces)
                    }
                }
                // price work sheet
                if (this.currentDocumentTypeCode=="OTHPWS"){
                    this.oldOrdering = group.selectedObject.ordering_cost
                    this.oldLanded = group.selectedObject.landed_cost
                    this.oldRetailPrice = group.selectedObject.retail_price
                }

            },
            clearProduct (){
                this.selectedParentProduct = ''
                this.selectedProduct = ''
                this.productName = '';
                this.inputProduct = ''
                this.quantity = 0
                this.productComposition = ''
                this.unitCost = 0
                this.discountTotal = 0
                this.discountText = []
                this.unitNetCost = 0
                this.subTotal =  0
                this.isDocumentLineFormDisabled = true
                this.isProductNameDisabled = true
                this.rewardCode = null
                this.rewardDiscountAmount = 0
                this.showActualYield = false;
                this.actual_yield = 0;
                this.tolerance_quantity = 0;
                this.oldOrdering = ''
                this.newOrdering = ''
                this.oldLanded = ''
                this.newLanded = ''
                this.oldRetailPrice = ''
                this.newRetailPrice = ''
                this.oldLeastPrice = ''
                this.oldWholesalePrice = ''
                this.oldSpecialPrice = ''
                this.oldOriginal = ''
                this.markUp = ''
            },
                calculatePwsCosts(field) {
                  if (field == 'markUp') {
                    let landedCost = this.newLanded;
                    let markUpPercent = this.markUp;
                    let newRetailPrice = (Number(landedCost) + Number(landedCost) * markUpPercent / 100);
                    this.newRetailPrice = newRetailPrice > 0 ? newRetailPrice.toFixed(this.decimalPlaces) : 0;
                  }

                  if (field == 'newLanded') {
                    let landedCost = this.newLanded;
                    let retailPrice = this.newRetailPrice;
                    if (landedCost && retailPrice &&
                        !isNaN(landedCost) && !isNaN(retailPrice)) {
                      let markUpPercent = 0;
                      if (landedCost > 0) markUpPercent = ((retailPrice - landedCost) / landedCost) * 100;
                      this.markUp = markUpPercent > 0 ? markUpPercent.toFixed(this.decimalPlaces) : 0;
                    } else { this.markUp = ''; }
                  }

                  if (field == 'newPrice') {
                    let landedCost = this.newLanded;
                    let retailPrice = this.newRetailPrice;
                    if (landedCost && retailPrice &&
                        !isNaN(landedCost) && !isNaN(retailPrice)) {
                      let markUpPercent = 0;
                      if (landedCost > 0) markUpPercent = ((retailPrice - landedCost) / landedCost) * 100;
                      this.markUp = markUpPercent > 0 ? markUpPercent.toFixed(this.decimalPlaces) : 0;
                    } else { this.markUp = ''; }
                  }
                },
                calculateCost(){
                  this.calculateSelectedProduct()
                  this.costUpdated = true
                },
                calculateSelectedProduct () {
                    var notifMessage = []
                    if (this.discountText.length > 0) {
                        // eslint-disable-next-line
                        //var discountRegex = /(^L[0-9]+$|^[0-9]+$|^[0-9]+\%$)/;
                        var discountRegex = /(^\d{0,10}(\.\d{1,4})? *%?$)/;
                        var discountText = this.discountText.join();
                        discountText = discountText.split(',');

                        discountText.forEach(function(row) {
                            if (!discountRegex.test(row)) notifMessage.push(row + ' discount input is invalid \n \r');
                        });

                        if (notifMessage.length == 0) {
                            var lessDiscount = /^L[0-9]+$/;
                            var lessDiscountDecimal = /^\d{0,10}(\.\d{1,10})?$/;
                            var numberRegex = /^[0-9]+$/;
                            // eslint-disable-next-line 
                            //var percentDiscount = /^[0-9]+\%$/;
                            var percentDiscount = /^[1][0][0]\.[0]{2}\%|[0-9]+\%|[1-9]?[0-9]\.[0-9]{1,4}\%$/;

                            var unitNetCost = this.unitCost
                            var quantity = this.quantity
                            var discountTotal = 0;
                            var decimalPlaces = this.decimalPlaces

                            discountText.forEach(function(row) {
                                var discount;
                                var discountAmount;
                                if (lessDiscount.test(row)) {
                                    discount = row.slice(1)
                                    discountAmount = (unitNetCost) - (discount)
                                    unitNetCost = unitNetCost - ((unitNetCost) - (discountAmount)).toFixed(decimalPlaces)
                                } else if (lessDiscountDecimal.test(row)) {
                                    discount = row
                                    discountAmount = (unitNetCost) - (discount)
                                    unitNetCost = unitNetCost - ((unitNetCost) - (discountAmount)).toFixed(decimalPlaces)
                                } else if (numberRegex.test(row)) {
                                    discount = row;
                                    discount = (discount / quantity)
                                    discountAmount = (unitNetCost) - ((unitNetCost) - (discount))
                                    unitNetCost = unitNetCost - (discountAmount).toFixed(decimalPlaces)
                                } else if (percentDiscount.test(row)) {
                                    discount = row.slice(0,-1)
                                    discountAmount = (unitNetCost) * (discount / 100)
                                    unitNetCost = ((unitNetCost) - (discountAmount)).toFixed(decimalPlaces)
                                }
                                if (lessDiscount.test(row) || lessDiscountDecimal.test(row)) {
                                    discountTotal = discountTotal + (discount * quantity);
                                } else{
                                    discountTotal = discountTotal + (discountAmount * quantity);
                                }
                            });
                            if (unitNetCost < 0) unitNetCost = 0
                            this.unitNetCost = Number(unitNetCost).toFixed(this.fixedDecimalPlaces)
                            this.subTotal = (this.quantity * this.unitNetCost).toFixed(this.fixedDecimalPlaces)
                            this.discountTotal = discountTotal
                        } else {
                            this.discountText.pop();
                            this.notifMessage = notifMessage
                            this.documentActionNotification('Document line discount', 'error')
                        }
                    }else {
                        this.unitNetCost = Number(this.unitCost).toFixed(this.fixedDecimalPlaces)
                        this.subTotal = (this.quantity * this.unitCost).toFixed(this.fixedDecimalPlaces)
                    }
                },
                //Document Line Form
                documentLineErrorNotif(type) {
                    this.$notification[type]({
                        message: 'Document Line Notification',
                        // eslint-disable-next-line
                        description: h => {
                            return <ul class='m-0 p-0'>
                                {this.notifMessage.map((value, index) => {
                                    return <li key={index}>{value}</li>
                                })}
                            </ul>
                        },
                        style: getNotificationStyle(type)
                    });
                },
                async fetchProductCompositions() {
                    this.fetching = true
                    this.productCompositions = await HTTPRequest.getRequest(this.endPoint + 'products/'+this.selectedParentProduct.id+'/get_product_unit_compositions', null)
                    this.fetching = false
                },
                async selectProductComposition(productComposition) {
                    var arr = {
                        key:productComposition.key.replace('productCompositions',''),
                        label:productComposition.label
                    }
                    productComposition = arr
                    var unitId = this.productCompositions.find(x => x.key == productComposition.key).unit_id
                    Object.assign(this, {
                        productComposition,
                        productCompositions: [],
                        fetching: false,
                    })
                    this.productComposition.unit_id = unitId
                    var product = await HTTPRequest.getRequest(this.endPoint + '/products/'+ this.productComposition.key);

                    if (product){
                         this.notifMessage = []
                        if (this.currentDocumentTypeCode=="RELTRX" || this.currentDocumentTypeCode=="RELCSX"){
                            var inventory = await HTTPRequest.getRequest(this.endPoint + 'inventories/site_product_inventory?product_id='+product.id+'&site_id='+this.supplyingSite.key, null)
                            if (inventory.error) {
                                this.notifMessage.push(inventory.error)
                                this.documentActionNotification('Add document line', 'error')
                                return
                            } else{
                               this.onHandQuantity = inventory.quantity
                            }
                        }


                        var unitCost = eval('product.'+this.productPriceChoice)
                        var unitNetCost = eval('product.'+this.productPriceChoice) //VAT EXCLUDE PRICE

                        var site_id = secureStorage.getItem("defaultSiteId");
                        var isRel = this.currentDocumentTypeCode.includes("REL");
                        var isRec = this.currentDocumentTypeCode.includes("REC");
                        if (isRel || isRec) {
                            var inventory_cost = await HTTPRequest.getRequest(this.endPoint + 'inventory_costs/get_latest_inventory_cost?product_id='+product.id+'&site_id='+site_id, null)
                            if (inventory_cost.cost && Number(inventory_cost.cost) != 0){
                                this.unitCost = inventory_cost.cost
                                this.unitNetCost= inventory_cost.cost
                            } else {
                                this.unitCost = unitCost
                                this.unitNetCost= unitNetCost
                            }
                        }else {
                            this.unitCost = unitCost
                            this.unitNetCost= unitNetCost
                        }

                        this.selectedProduct = product
                        this.productName = product.name
                        this.inputProduct = product.name
                        this.quantity = 1
                        this.unitCost = Number(this.unitCost).toFixed(this.fixedDecimalPlaces)
                        this.discountText = [] //Not Hardcoded
                        this.unitNetCost = Number(this.unitNetCost).toFixed(this.fixedDecimalPlaces)
                        this.subTotal =  (this.quantity * this.unitCost).toFixed(this.fixedDecimalPlaces)
                    }
                },

                //isDirtyData
                preventNav(event) {
                    if (!this.isDirty) return
                    event.preventDefault()
                    event.returnValue = ""
                },
                filterExistingProducts(e){
                    if (this.document_config.document_type_settings.editorBehavior.radio == 'P' || this.document_config.document_type_settings.editorBehavior.radio == 'L'){
                        this.filterExistingProductData = e.data
                        return e.data
                    }else{
                        var data = this.tabulator.getData();
                        var product_ids = data.map(({product_id}) => product_id)
                        return e.data.filter(item => !product_ids.includes(item.id))
                    }
                },

                async awaitConfirm(options){
                    return new Promise((resolve, reject) => {
                        this.$confirm({
                            okText: 'Proceed',
                            cancelText: 'Cancel',
                            ...options,
                            onOk: () => resolve(true),
                            onCancel: () => reject(false),
                        });
                    });
                },
                getOthPcnDuplicateGroups(lines = this.tabulator ? this.tabulator.getData() : []){
                    if (this.currentDocumentTypeCode !== 'OTHPCN') return [];

                    const groups = {};
                    lines
                        .filter(row => Number(row.line_no) > 0 && `${row.barcode || ''}`.trim().length > 0)
                        .forEach((row) => {
                            const barcode = `${row.barcode}`.trim();
                            if (!groups[barcode]) groups[barcode] = [];
                            groups[barcode].push(row);
                        });

                    return Object.entries(groups)
                        .filter(([, rows]) => rows.length > 1)
                        .map(([barcode, rows]) => ({
                            barcode,
                            lineNumbers: rows.map(row => row.line_no).sort((a, b) => Number(a) - Number(b)),
                        }));
                },
                async confirmOthPcnDuplicatesBeforePersist(){
                    const duplicateGroups = this.getOthPcnDuplicateGroups();
                    if (duplicateGroups.length < 1) return true;

                    const lineNumbers = [...new Set(duplicateGroups.flatMap(group => group.lineNumbers))].sort((a, b) => Number(a) - Number(b));

                    try{
                        await this.awaitConfirm({
                            title: 'Proceed?',
                            content: () => <div>There are duplicate items in line [{lineNumbers.join(', ')}]. Do you want to continue?</div>,
                        });
                        return true;
                    }catch{
                        this.spinning = false;
                        this.isUpdateDisabled = false;
                        return false;
                    }
                },
                async ensureOthPcnReadyForPost(){
                    if (this.currentDocumentTypeCode !== 'OTHPCN' || !this.documentNumber) return true;

                    let keepChecking = true;
                    while (keepChecking){
                        const issues = await HTTPRequest.getRequest(this.endPoint + 'documents/othpcn_post_issues?document_id=' + this.documentNumber, null);

                        if (issues == undefined || issues.error){
                            this.notifMessage = [issues && issues.error ? issues.error : 'Unable to validate Physical Count document.'];
                            this.documentActionNotification('post', 'error');
                            this.isPostDisabled = false;
                            this.spinning = false;
                            this.postClickCount = 0;
                            return false;
                        }

                        if (issues.has_duplicates){
                            const lineNumbers = [...new Set((issues.duplicate_groups || []).flatMap(group => group.line_numbers || []))].sort((a, b) => Number(a) - Number(b));

                            try{
                                await this.awaitConfirm({
                                    title: 'Proceed?',
                                    content: () => <div>There are duplicate items in the document. Do you want to merge now?</div>,
                                });
                            }catch{
                                this.isPostDisabled = false;
                                this.spinning = false;
                                this.postClickCount = 0;
                                return false;
                            }

                            const mergeResponse = await HTTPRequest.postRequest(this.endPoint + 'documents/merge_othpcn_duplicates?document_id=' + this.documentNumber, null, null);
                            if (mergeResponse == undefined || mergeResponse.error){
                                this.notifMessage = [mergeResponse && mergeResponse.error ? mergeResponse.error : `Unable to merge duplicate items in line [${lineNumbers.join(', ')}].`];
                                this.documentActionNotification('post', 'error');
                                this.isPostDisabled = false;
                                this.spinning = false;
                                this.postClickCount = 0;
                                return false;
                            }

                            await this.openDocument(this.documentNumber, this.existingDocumentTypeDetails);
                            continue;
                        }

                        if (issues.has_package_items){
                            try{
                                await this.awaitConfirm({
                                    title: 'Proceed?',
                                    content: () => <div>There are unmerged package items in the document. Do you want to merge now?</div>,
                                });
                            }catch{
                                this.isPostDisabled = false;
                                this.spinning = false;
                                this.postClickCount = 0;
                                return false;
                            }

                            const mergeResponse = await HTTPRequest.postRequest(this.endPoint + 'documents/merge_othpcn_package_items?document_id=' + this.documentNumber, null, null);
                            if (mergeResponse == undefined || mergeResponse.error){
                                this.notifMessage = [mergeResponse && mergeResponse.error ? mergeResponse.error : 'Unable to merge package items.'];
                                this.documentActionNotification('post', 'error');
                                this.isPostDisabled = false;
                                this.spinning = false;
                                this.postClickCount = 0;
                                return false;
                            }

                            await this.openDocument(this.documentNumber, this.existingDocumentTypeDetails);
                            continue;
                        }

                        keepChecking = false;
                    }

                    return true;
                },

                //Document Lines
                validateAddLine(quantity, productName, unitCost, selectedProduct){
                    this.notifMessage = [];
                    var data = this.tabulator.getData();
                    if (this.document_config.document_type_settings.editorBehavior.radio != 'P' && this.document_config.document_type_settings.editorBehavior.radio != 'L'){
                        var product = data.find(element => element.product_id == selectedProduct.id)
                        if (product != undefined) this.notifMessage.push("Item Exists");
                    }
                    this.notifMessage.push(ValidateField.positiveNumber('Quantity', quantity));
                    this.notifMessage.push(ValidateField.charMinAndMax("Product Name", productName, 0, 255));
                    this.notifMessage.push(ValidateField.positiveNumber('Cost', unitCost));

                    if(!selectedProduct.is_weighted){
                        this.notifMessage.push(ValidateField.isWholeNumber('Quantity', quantity, 'Decimal Quantity is not allowed for this item. Please enter a whole number.'));
                    }else{
                        this.notifMessage.push(ValidateField.decimalDigitsLessThan('Quantity', quantity, 4));
                    }
                    
                    this.notifMessage = this._.compact(this.notifMessage);
                    return this.notifMessage.length;
                },
                validateAddPwsLine(productName, newOrdering, newLanded, newRetailPrice, markUp){
                    this.notifMessage = [];
                    this.notifMessage.push(ValidateField.charMinAndMax("Product Name", productName, 0, 255));
                    if (newOrdering) {
                        this.notifMessage.push(ValidateField.positiveNumber('New Ordering', newOrdering));
                    }
                    if (newLanded) {
                        this.notifMessage.push(ValidateField.positiveNumber('New Landed', newLanded));
                    }
                    if (newRetailPrice){
                        this.notifMessage.push(ValidateField.positiveNumber('New Retail Price', newRetailPrice));
                    }
                    if (markUp) {
                        this.notifMessage.push(ValidateField.positiveNumber('Mark Up %', markUp));
                    }
                    if ((newOrdering == "" || newOrdering == null) && (newLanded == "" || newLanded == null) && (newRetailPrice == "" || newRetailPrice == null)) {
                        this.notifMessage.push("Atleast one price/cost field is required.")
                    }
                    this.notifMessage = this._.compact(this.notifMessage);
                    return this.notifMessage.length;
                },
                async refreshInventory() {
                    // this.isRefreshInventory = true
                    var items = this.tabulator.getData();
                    let refreshProducts = [];

                        for (const product of items) {
                            var site_id = secureStorage.getItem("defaultSiteId")
                            var refreshInventory = 0
                            var lastinv = await HTTPRequest.getRequest(this.endPoint + 'inventories/site_product_inventory?product_id='+product.product_id+'&site_id='+site_id, null)

                            if (lastinv.onhand_quantity != undefined)
                                refreshInventory = lastinv.onhand_quantity
                            //Get Available QTY 
                                //https://tools.iripple.com/barter-11/bxi-backend/-/issues/3113
                                var available_qty = await HTTPRequest.getRequest(this.endPoint + 'inventories/site_product_movement_quantity?product_id='+product.product_id+'&site_id='+site_id, null);
                                
                                const intransit_quantity = (available_qty.find(({ label }) => label  === "intransit_quantity") != undefined) ? (available_qty.find(({ label }) => label  === "intransit_quantity")['quantity']) : 0;
                                const incoming_quantity = (available_qty.find(({ label }) => label  === "incoming_quantity") != undefined) ? (available_qty.find(({ label }) => label  === "incoming_quantity")['quantity']) : 0;
                                const outgoing_quantity = (available_qty.find(({ label }) => label  === "outgoing_quantity") != undefined) ? (available_qty.find(({ label }) => label  === "outgoing_quantity")['quantity']) : 0;

                                // var available_quantity = (Number(lastinv.onhand_quantity) + Number(intransit_quantity) + Number(incoming_quantity)) - Number(outgoing_quantity);
                                var available_quantity = (Number(lastinv.onhand_quantity) - Number(outgoing_quantity));
                                
                                var data = {
                                    "line_no": product.line_no,
                                    "stock_no": product.stock_no,
                                    "product_name": product.product_name,
                                    "supplier_stock_no": product.supplier_stock_no,
                                    "design": product.design,
                                    "size": product.size,
                                    "product_id": product.product_id,
                                    "ref_code": product.ref_code,
                                    "erp_code": product.erp_code,
                                    "barcode": product.barcode,
                                    "unit_name": product.unit_name,
                                    "ordered_quantity": product.ordered_quantity,
                                    "actual_quantity": product.actual_quantity,
                                    "balance_quantity": product.balance_quantity,
                                    "quantity": product.quantity,
                                    "reason_id": product.reason_id,
                                    "actual_yield": product.actual_yield,
                                    "delivery_quantity": product.delivery_quantity,
                                    "goods_issue_quantity": product.goods_issue_quantity,
                                    "frozen_quantity": product.frozen_quantity,
                                    "content_quantity": product.content_quantity,
                                    "price": product.price,
                                    "price_php": product.price_php,
                                    "price_pi": product.price_pi,
                                    "cost": product.cost,
                                    "cost_php": product.cost_php,
                                    "total_gross": product.total_gross,
                                    "total_gross_php": product.total_gross_php,
                                    "subtotal": product.subtotal,
                                    "subtotal_php": product.subtotal_php,
                                    "discount": product.discount,
                                    "discount_text": product.discount_text,
                                    "old_landed_cost": product.old_landed_cost,
                                    "landed_cost": product.landed_cost,
                                    "old_retail_price": product.old_retail_price,
                                    "retail_price": product.retail_price,
                                    "markup_percent": product.markup_percent,
                                    "old_original_cost": product.old_original_cost,
                                    "original_cost": product.original_cost,
                                    "old_ordering_cost": product.old_ordering_cost,
                                    "ordering_cost": product.ordering_cost,
                                    "old_wholesale_price": product.old_wholesale_price,
                                    "wholesale_price": product.wholesale_price,
                                    "old_least_price": product.old_least_price,
                                    "least_price": product.least_price,
                                    "old_special_price": product.old_special_price,
                                    "special_price": product.special_price,
                                    "on_hand_quantity": refreshInventory,
                                    "invoice_amount": product.invoice_amount,
                                    "invoice_discount": product.invoice_discount,
                                    "unit_price_vat": product.unit_price_vat,
                                    "net_price_vat": product.net_price_vat,
                                    "subtotal_vat": product.subtotal_vat,
                                    "unit_price_no_vat": product.unit_price_no_vat,
                                    "price_without_vat": product.price_without_vat,
                                    "subtotal_without_vat": product.subtotal_without_vat,
                                    "effective_discount": product.effective_discount,
                                    "incoming_quantity": product.incoming_quantity,
                                    "code_and_document_no": product.code_and_document_no,
                                    "id": product.id,
                                    "reference_1": product.reference_1,
                                    "document_date": product.document_date,
                                    "total_quantity": product.total_quantity,
                                    "status": product.status,
                                    "order_status": product.order_status,
                                    "created_by": product.created_by,
                                    "updated_by": product.updated_by,
                                    "remarks": product.remarks,
                                    "salesman_name": product.salesman_name,
                                    "line_extras": product.line_extras,
                                    "brand_name": product.brand_name,
                                    "product_grade_level": product.product_grade_level,
                                    "sublocation_allocation": product.sublocation_allocation,
                                    "product_type": product.product_type,
                                    "document_line_serials_text": product.document_line_serials_text,
                                    "document_line_locations": product.document_line_locations,
                                    // "size": product.size_name,
                                    "color": product.color,
                                    "available_quantity": available_quantity,
                                    "is_require_lotcode": product.is_require_lotcode,
                                    "supplier": product.supplier_name,
                                    "category": product.category_name,
                                    "department": product.department_name,
                                    "section": product.section_name,
                                    "division": product.division_name,
                                    "product_group": product.product_group,
                                    "product_series": product.product_grade_level
                                }
                                refreshProducts.push(data)
                        }
                    await this.tabulator.clearData();
                    await this.tabulator.addData(refreshProducts);
                },
                addProduct() {
                    if (this.isPhysicalCountV2ProductListLocked) {
                        return;
                    }
                    this.notifMessage = []
                    var data = this.tabulator.getData();

                    if (this.inputProduct) {
                        if (!(data.length == this.maximumDocumentLineNumber)) {
                            if (this.currentDocumentTypeCode == 'OTHPWS'){
                                this.addPwsProduct(this.selectedProduct, this.newOrdering, this.newLanded, this.newRetailPrice, this.markUp);
                            } else {
                                if (this.selectedProduct.product_type == "M") {
                                    this.populateMatrixItems(this.selectedProduct, this.productName, this.quantity, this.discountText)
                                } else {
                                    console.log("add reg 5")
                                    this.addWarningForCostRestriction(this.selectedProduct, this.productName, this.quantity, this.actual_yield, this.unitCost, this.subTotal, this.unitNetCost, this.discountTotal, this.discountText, this.onHandQuantity, this.rewardCode, this.rewardDiscountAmount, 0);
                                    if(this.currentDocumentTypeCode == 'RECCSR'){
                                        this.limitCsrProduct(this.tabulator.getData().at(-1));
                                    }
                                    console.log(">>CURR RATE<<")
                                    console.log(this.currencyRate)
                                    if(this.currencyRate > 0)
                                        console.log(">>Computing currency")
                                        this.selectCurrency(this.currency)
                                }
                            }
                        } else {
                            this.documentActionNotification('Add Product', 'error')
                        }
                    }
                    this.showActualYield = false;
                    this.actual_yield = 0;
                    this.tolerance_quantity = 0;
                    this.addProductConfirmationVisible = false;
                },
                async limitCsrProduct(selectedProduct){
                    // change good issued quantity here
                    var returnable_product = component_x.returnable_qtys.data.find(line => line.product_id == selectedProduct.product_id)
                    var updatedProduct = {product_id: selectedProduct.product_id}
                    updatedProduct.goods_issue_quantity = returnable_product == undefined ? 0 : (returnable_product.returnable_qty)
                    updatedProduct.delivery_quantity = updatedProduct.goods_issue_quantity
                    updatedProduct.discount_text = (returnable_product == undefined) ? '' : returnable_product.discount_text
                    this.tabulator.updateData([updatedProduct])
                    await this.recalculateLine(updatedProduct.product_id)
                    this.calculateSummary();
                },

                async addPwsProduct(selectedProduct, newOrdering, newLanded, newRetailPrice, markUp){
                    if(!this.validateAddPwsLine(selectedProduct, newOrdering, newLanded, newRetailPrice, markUp)) {
                        let _products = []
                        if(selectedProduct.product_type == 'M'){
                            var prodMatrix = await HTTPRequest.getRequest(this.endPoint + 'products/get_matrix_items?document_form=true&matrix_parent_id='+selectedProduct.id, null )
                            if(prodMatrix != null){
                                _products = prodMatrix
                            }
                        }
                        _products.push(selectedProduct)

                        let newProducts = [];
                        _products.forEach((product) => {
                            var oldLeastPrice = (Number(product.least_price) > 0) ? product.least_price : product.retail_price
                            var oldWholesalePrice = (Number(product.wholesale_price) > 0) ? product.wholesale_price : product.retail_price
                            var oldSpecialPrice = (Number(product.special_price) > 0) ? product.special_price : product.retail_price
                            var oldOriginal = (Number(product.original_cost)>0) ? product.original_cost : product.ordering_cost

                           var data = {
                                "parent_line_no": 0,
                                "product_id": product.id,
                                "barcode": product.barcode,
                                "quantity": 0, 
                                "subtotal": 0,
                                "original_cost": "",
                                "ordering_cost": newOrdering,
                                "landed_cost": newLanded,
                                "retail_price": newRetailPrice,
                                "wholesale_price": "",
                                "least_price": "",
                                "special_price": "",
                                "markup_percent": markUp,
                                "old_original_cost": oldOriginal,
                                "old_ordering_cost": product.ordering_cost,
                                "old_landed_cost": product.landed_cost,
                                "old_retail_price": product.site_retail_price || product.retail_price,
                                "old_wholesale_price": oldWholesalePrice,
                                "old_least_price": oldLeastPrice,
                                "old_special_price": oldSpecialPrice,
                                "unit_name": product.unit_name,
                                "product_name": product.name,
                                "stock_no": product.stock_no,
                                "ref_code": product.reference_code,
                                "erp_code": product.erp_code,
                                "size": product.size,
                                "color": product.color,
                                "design": selectedProduct.design,
                                "is_weighted": product.is_weighted,
                                "is_require_lotcode": product.is_require_lotcode,
                                "product_icon": product.product_type
                            };
                            newProducts.push(data)
                        })
                            this.tabulator.addData(newProducts);
                            this.recountLineNo();
                            this.calculateSummary();
                            this.$refs.autocomplete.clear();
                            this.clearProduct();

                    } else {
                        if (this.notifMessage.length) this.documentLineErrorNotif('error');
                    }

                },
                addWarningForCostRestriction(selectedProduct, productName, quantity, actualYield, unitCost, subTotal, unitNetCost, discountTotal, discountText, on_hand_quantity, rewardCode, rewardDiscountAmount, autoPopulate){
                    if (this.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.restrictRecOfCostEqualOrHigherRetailPrice !=undefined && this.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.restrictRecOfCostEqualOrHigherRetailPrice == true){
                        if(this.productPriceChoice.includes("cost") && (parseFloat(selectedProduct.retail_price) <= parseFloat(unitCost))) {
                            var is_equal = (parseFloat(selectedProduct.retail_price) == parseFloat(unitCost)) ? "equal to" : "higher then";
                            this.notifMessage.push();
                            this.$confirm({
                            title: "Warning",
                            content: h => <div>Cost ({unitCost}) of item {productName} is {is_equal} retail price of ({selectedProduct.retail_price}). Do you want to continue?</div>,
                            onOk: () => {
                                this.addRegularProduct(selectedProduct, productName, quantity, actualYield, unitCost, subTotal, unitNetCost, discountTotal, discountText, on_hand_quantity, rewardCode, rewardDiscountAmount, autoPopulate)
                            },
                            onCancel() {
                                component_x.$refs.autocomplete.clear();
                                component_x.clearProduct();
                            }
                            });
                        } else {
                            this.addRegularProduct(selectedProduct, productName, quantity, actualYield, unitCost, subTotal, unitNetCost, discountTotal, discountText, on_hand_quantity, rewardCode, rewardDiscountAmount, autoPopulate)
                        }
                    }else{
                        this.addRegularProduct(selectedProduct, productName, quantity, actualYield, unitCost, subTotal, unitNetCost, discountTotal, discountText, on_hand_quantity, rewardCode, rewardDiscountAmount, autoPopulate)
                    }
                },
                getPosWholeQuantity(quantity){
                    var numericQuantity = Number(quantity)
                    if (isNaN(numericQuantity) || numericQuantity < 1) return 1
                    return parseInt(numericQuantity)
                },
                async addRegularProduct(selectedProduct, productName, quantity, actualYield, unitCost, subTotal, unitNetCost, discountTotal, discountText, on_hand_quantity, rewardCode, rewardDiscountAmount, autoPopulate){
                    if(!this.validateAddLine(quantity, productName, unitCost, selectedProduct)) {
                        let items = this.tabulator.getData();
                        this.sumSubtotal = 0
                        for(let i = 0; i < items.length; i++){
                            let item = items[i]
                            this.sumSubtotal = this.sumSubtotal + Number(item.subtotal)
                        }
                        // total all subtotal first

                        // add new subtotal
                        this.sumSubtotal = this.sumSubtotal + Number(subTotal)

                        // remove old subtotal if update
                        var check_existing_data = []
                        if(Number(quantity) > 0) {
                            if (this.document_config.document_type_settings.editorBehavior.radio == 'P'){
                                check_existing_data = await this.tabulator.searchData("product_id","=",selectedProduct.id);
                                if (check_existing_data != undefined && check_existing_data.length > 0){
                                    if(Number(check_existing_data[0].quantity) > 0){
                                        // remove old subtotal if update
                                        this.sumSubtotal = this.sumSubtotal - Number(check_existing_data[0].subtotal)
                                    }
                                }
                            }
                        }
                        
                        let distributedOverallDiscount = 0
                        if (Number(subTotal) != 0 || this.sumSubtotal != 0 || this.overallDiscount != 0){
                            distributedOverallDiscount = this.overallDiscount * (Number(subTotal) / this.sumSubtotal)
                        }

                        console.log("distributedOverallDiscount1", distributedOverallDiscount)
                        
                        var subtotal = Number(subTotal).toFixed(this.fixedDecimalPlaces)
                        var subtotal_without_vat = 0
                        var price_without_vat = 0
                        var tax_amount = 0
                        let subtotal_less_overall_discount = Number(subTotal) - Number(distributedOverallDiscount)
                        if(this.party_tax_type == 'V' || this.party_tax_type == undefined){
                            if (selectedProduct.tax_type == 'V'){
                                subtotal_without_vat = (subtotal_less_overall_discount/ (1+Number(this.taxRate))).toFixed(this.fixedDecimalPlaces)
                                price_without_vat = (Number(unitCost)/ (1+Number(this.taxRate))).toFixed(this.fixedDecimalPlaces)
                                tax_amount = (subtotal_less_overall_discount - subtotal_without_vat).toFixed(this.fixedDecimalPlaces)
                            } else {
                                subtotal_without_vat = (subtotal_less_overall_discount).toFixed(this.fixedDecimalPlaces)
                                price_without_vat = (Number(unitCost)).toFixed(this.fixedDecimalPlaces)
                            }
                        } else {
                            subtotal_without_vat = (subtotal_less_overall_discount).toFixed(this.fixedDecimalPlaces)
                            price_without_vat = (Number(unitCost)).toFixed(this.fixedDecimalPlaces)
                        }

                        check_existing_data = []
                        if (this.document_config.document_type_settings.editorBehavior.radio == 'P'){
                            check_existing_data = await this.tabulator.searchData("product_id","=",selectedProduct.id);
                            if (check_existing_data != undefined && check_existing_data.length > 0){
                                if (selectedProduct.is_weighted){
                                    check_existing_data[0].quantity = Number(check_existing_data[0].quantity) + Number(quantity)
                                } else {
                                    check_existing_data[0].quantity = this.getPosWholeQuantity(check_existing_data[0].quantity) + this.getPosWholeQuantity(quantity)
                                }
                            }
                        }

                        var data = {
                            "parent_line_no": 0,
                            "product_type": selectedProduct.product_type,
                            "product_id": selectedProduct.id,
                            "barcode": selectedProduct.barcode,
                            "actual_quantity": 0, // :TODO: if physical count document must have actual quantity value
                            "on_hand_quantity": on_hand_quantity,
                            "unit_name": selectedProduct.unit_name,
                            "content_quantity": selectedProduct.content_quantity,
                            "product_name": productName,
                            "tax_type": selectedProduct.tax_type,
                            "quantity": quantity,
                            "price": Number(unitCost),
                            "subtotal": subtotal,
                            "subtotal_without_vat": Number(subtotal_without_vat).toFixed(this.fixedDecimalPlaces),
                            "price_without_vat": price_without_vat,
                            "discount": discountTotal,
                            "discount_text": discountText.join(),
                            "stock_no": selectedProduct.stock_no,
                            "cost": Number(unitNetCost).toFixed(this.fixedDecimalPlaces),
                            "remarks": "",
                            "retail_price": selectedProduct.retail_price,
                            "tax_rate": this.taxRate,
                            "tax_amount": tax_amount,
                            "reward_code": rewardCode,
                            "reward_discount_amount": rewardDiscountAmount,
                            "actual_yield": actualYield,
                            "extras":selectedProduct.extras,
                            "brand_name": selectedProduct.brand_name,
                            "product_grade_level": selectedProduct.product_grade_level,
                            "ref_code": selectedProduct.reference_code,
                            "erp_code": selectedProduct.erp_code,
                            "matrix_parent_id": selectedProduct.matrix_parent_id,
                            "size": selectedProduct.size,
                            "color": selectedProduct.color,
                            "design": selectedProduct.design,
                            "is_weighted": selectedProduct.is_weighted,
                            "is_require_lotcode": selectedProduct.is_require_lotcode,
                            "product_icon": selectedProduct.product_type,
                            "supplier": selectedProduct.supplier_name,
                            "category": selectedProduct.category_name,
                            "department": selectedProduct.department_name,
                            "section": selectedProduct.section_name,
                            "division": selectedProduct.division_name,
                            "product_group": selectedProduct.product_group || "No Product Group",
                            "product_series": selectedProduct.product_grade_level || "No Product Series"
                        };

                        console.log(">>> DATA.EXTRAS")
                        console.log(data.extras)

                        // Handle custom fields
                        if(data.extras != undefined){
                            console.log("SHOULD BE HERE")
                            console.log(this.customFieldsX)
                            var extras = data.extras
                            var extra_keys = Object.keys(extras) 

                            console.log(">> extra keys <<")
                            console.log(extra_keys)
                            console.log(extra_keys.length)

                            for(var k = 0; k <= extra_keys.length; k++){
                                var chk = extra_keys[k]
                                if(this.customFieldsX.map(a => a.name).includes(chk)){
                                    data[chk] = extras[chk]
                                } 
                            }

                        }else{
                            console.log("No extras")
                        }

                        console.log(">> data <<")
                        console.log("hello",data)

                        if(this.currentDocumentTypeCode == 'RELDDE'){
                            data["ordered_quantity"] = quantity
                            data["delivery_quantity"] = quantity
                        }
                        if (this.document_config.document_type_settings.editorBehavior.radio == 'P'){
                            if (check_existing_data != undefined && check_existing_data.length > 0){
                                await this.tabulator.updateData(check_existing_data);
                            }else{
                                await this.tabulator.addRow(data);
                            }
                        }else{
                            await this.tabulator.addRow(data);
                        }

                        this.isEditing = true;
                        this.recountLineNo();

                        if(autoPopulate == 0){
                            this.calculateSummary();
                            if(selectedProduct.product_type == 'S'){
                                await this.showSerialization([{...this.tabulator.getRowFromPosition(this.tabulator.getRows().length-1).getData(), quantity}])
                            }
                            if(selectedProduct.is_require_lotcode && /^RE(C|L)/.test(this.currentDocumentTypeCode)){
                                await this.tabulator.updateData([{product_id: selectedProduct.id, is_require_lotcode: selectedProduct.is_require_lotcode}])
                                this.rowSelectionChanged([this.tabulator.getData().at(-1)], [this.tabulator.getRowFromPosition(this.tabulator.getRows().length-1)])
                                this.showLotCodeExpiry([this.tabulator.getData().at(-1)])
                            }
                            this.$refs.autocomplete.clear();
                            this.clearProduct();
                        }
                    } else {
                        if (this.notifMessage.length) this.documentLineErrorNotif('error');
                    }
                    this.calculateSummary();
                },

                //START OF Document Line TABLE
                mass_delete_line() {
                    if (this.isPhysicalCountV2ProductListLocked) {
                        return;
                    }
                    var ids = this.selectedDocumentLines.map(({line_no}) => line_no)
                    console.log(ids)
                    ids.forEach(
                       line_no => this.delete_line(line_no)
                    );
                    this.calculateSummary();
                },
                async delete_line(line_no) {
                    if (this.isPhysicalCountV2ProductListLocked) {
                        return;
                    }
                    // var data = this.tabulator.getData();
                    // var product_id = data.find(item => item.line_no == line_no).line_no
                    await this.tabulator.deleteRow(line_no);
                    this.recountLineNo();
                },
                recountLineNo(){
                    var data = this.tabulator.getData();
                    var lineCounter = 1
                    data.forEach( row => {
                        if (row.line_no == undefined){
                            row.line_no = lineCounter
                            lineCounter = lineCounter + 1
                        } else if (row.line_no != undefined && row.line_no > 0) {
                            if (row.parent_line_no === -1){
                                if (data.find(x => x.parent_line_no === row.line_no)) {
                                    data.find(x => x.parent_line_no === row.line_no).parent_line_no = lineCounter
                                }
                                row.line_no = lineCounter
                            }else{
                                row.line_no = lineCounter
                            }
                            lineCounter = lineCounter + 1
                        }
                    });
                    var negativeLineCounter = -1
                    data.forEach(function(row) {
                        if (row.line_no != undefined && row.line_no < 0) {
                            row.line_no = negativeLineCounter
                            negativeLineCounter = negativeLineCounter - 1
                        }
                    });
                    this.tabulator.replaceData(data)
                },
                //END OF VUE ANT TABLE`

                async initializeFooterCalculation() {
                    var tQuantity = 0;
                    var data = this.tabulator.getData();
                    data.forEach(function(element) {
                        //Total Quantity
                        if (element.line_no > 0){
                            if(element.quantity) tQuantity = Number(tQuantity) + Number(element.quantity)
                        }
                    })
                    component_x.totalQuantity = tQuantity
                },
                // >>> CALC SUMMARY  <<<//
                calculateSummary(calcOverDisc=true){
                    //Calculate Overall Discount
                    if(calcOverDisc == true){
                        this.calculateOverallDiscount();
                    }
                    
                    var summaryResults = this.tabulator.getCalcResults() || {};
                    var summaryBottom = summaryResults.bottom || {};

                    //Calcualates discount_amount
                    var netAmount = (this.numberOrZero(summaryBottom.total_gross) - this.numberOrZero(summaryBottom.discount) - this.numberOrZero(component_x.overallDiscount))
                    if (netAmount <= 0) netAmount = 0
                    component_x.netAmount = Number(netAmount).toFixed(this.decimalPlaces)

                    let data = this.tabulator.getData();

                    component_x.totalQuantity = 0 
                    component_x.grossAmount = 0
                    component_x.itemDiscount = 0
                    component_x.grossAmountwithoutTax = 0
                    component_x.netAmountWithoutTax = 0

                    data.forEach(function(element) {
                        //Total Quantity
                        if (element.line_no > 0){
                            if(Number(element.quantity) > 0) {
                                const lineGrossAmount = component_x.isFiniteNumberValue(element.total_gross) && element.total_gross !== null && element.total_gross !== undefined && element.total_gross !== '' ? element.total_gross : element.subtotal
                                //Calculates Quantity
                                component_x.totalQuantity = component_x.totalQuantity + component_x.numberOrZero(element.quantity)
                                component_x.grossAmount = component_x.grossAmount + component_x.numberOrZero(lineGrossAmount)
                                component_x.itemDiscount = component_x.itemDiscount + component_x.numberOrZero(element.discount)
                                component_x.netAmountWithoutTax = component_x.netAmountWithoutTax + component_x.numberOrZero(element.subtotal_without_vat)
                                component_x.grossAmountwithoutTax = component_x.grossAmountwithoutTax + component_x.numberOrZero(lineGrossAmount)
                            }
                        }
                    })
                    
                    console.log("total", component_x.netAmountWithoutTax)

                    //Calculate Vat Amount
                    component_x.vatAmount = (component_x.numberOrZero(component_x.netAmount) - component_x.numberOrZero(component_x.netAmountWithoutTax)).toFixed(component_x.decimalPlaces)
                    console.log("vat amount", component_x.vatAmount, Number(component_x.netAmount), Number(component_x.netAmountWithoutTax))

                    

                    //Calculate Gross Amount Without Tax
                    component_x.grossAmountwithoutTax = component_x.numberOrZero(component_x.grossAmountwithoutTax) - component_x.numberOrZero(component_x.vatAmount)

                    //Update grossAmount UI Display Data when Vat Exempt is Toggled on PO / RR
                    component_x.grossAmountDisplay = component_x.vatExclusiveCheckbox ? component_x.numberOrZero(component_x.grossAmountwithoutTax).toFixed(component_x.decimalPlaces) : component_x.numberOrZero(component_x.grossAmount).toFixed(component_x.decimalPlaces)
                    component_x.netAmountDisplay = component_x.vatExclusiveCheckbox ? component_x.numberOrZero(component_x.netAmountWithoutTax).toFixed(component_x.decimalPlaces) : component_x.numberOrZero(component_x.netAmount).toFixed(component_x.decimalPlaces)

                    //Set Total With Vat
                    component_x.totalWithVat = component_x.numberOrZero(component_x.grossAmount).toFixed(this.decimalPlaces)

                    //format Net Amount w/o Vat
                    component_x.netAmountWithoutTax = component_x.numberOrZero(component_x.netAmountWithoutTax).toFixed(this.decimalPlaces)
                },

            //SUMARRY
            calculateOverallDiscount(){
                var notifMessage = [];
                // eslint-disable-next-line
                //var discountRegex = /(^[0-9]+$|^[0-9]+\%$)/;
                var discountRegex = /(^\d{0,10}(\.\d{1,4})? *%?$)/;
                
                if(this.headerDiscount.length > 0 && (!component_x.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.termsAndDiscount || this.currentDocumentTypeCode == "ORISOX")){
                    this.headerDiscount.forEach(function(row) {
                        if (!discountRegex.test(row)) notifMessage.push(row + ' discount input is invalid \n \r');
                    });

                    if (notifMessage.length == 0) {

                        var numberRegex = /^[0-9]+$/;
                        //var percentDiscount = /^[0-9]+\%$/;
                        var percentDiscount = /^[1][0][0]\.[0]{2}\%|[0-9]+\%|[1-9]?[0-9]\.[0-9]{1,4}\%$/;
                        var lessDiscount = /^L[0-9]+$/;
                        var lessDiscountDecimal = /^\d{0,10}(\.\d{1,10})?$/;
                        
                        var beforeDiscount = Number(component_x.grossAmount) - Number(component_x.itemDiscount)
                        var overallDiscount = 0;

                        component_x.headerDiscount.forEach(function(row) {
                            var discount;
                            if (numberRegex.test(row)) {
                                discount = row;
                                beforeDiscount = (beforeDiscount - discount)
                            } else if (lessDiscount.test(row)) {
                                discount = row.slice(1)
                                beforeDiscount = (beforeDiscount - discount)
                            } else if (lessDiscountDecimal.test(row)) {
                                discount = row
                                beforeDiscount = (beforeDiscount - discount)
                            } else if (percentDiscount.test(row)) {
                                discount = row.slice(0,-1)
                                discount = (beforeDiscount) * (discount / 100)
                            }
                            overallDiscount = overallDiscount + Number(discount)
                        });

                        if (overallDiscount <= 0) overallDiscount = 0

                        var totalDiscount = Number(overallDiscount) + Number(component_x.itemDiscount)
                        if (totalDiscount <= Number(component_x.grossAmount) || Number(component_x.grossAmount) == 0) {
                            component_x.overallDiscount = overallDiscount.toFixed(this.decimalPlaces)
                            component_x.overallDiscountWithoutSupportDiscount = Number(overallDiscount)
                        } else {
                            this.notifMessage = ['Discount total must not be greater than gross amount']
                            this.documentActionNotification('Overall discount', 'error')
                        }
                    } else {
                        this.notifMessage = notifMessage
                        this.documentActionNotification('Document line discount', 'error')
                    }
                }

                if(this.supportDiscount.length > 0 && !component_x.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.termsAndDiscount){
                    this.supportDiscount.forEach(function(row) {
                        if (!discountRegex.test(row)) notifMessage.push(row + ' discount input is invalid \n \r');
                    });

                    if (notifMessage.length == 0) {

                        var numberRegex = /^[0-9]+$/;
                        //var percentDiscount = /^[0-9]+\%$/;
                        var percentDiscount = /^[1][0][0]\.[0]{2}\%|[0-9]+\%|[1-9]?[0-9]\.[0-9]{1,4}\%$/;
                        var lessDiscount = /^L[0-9]+$/;
                        var lessDiscountDecimal = /^\d{0,10}(\.\d{1,10})?$/;

                        var beforeDiscount = Number(component_x.grossAmount) - Number(component_x.itemDiscount) - ((Number(component_x.overallDiscount) > 0) ? Number(component_x.overallDiscount) : 0)
                        var overallDiscount = (Number(component_x.overallDiscount) > 0) ? Number(component_x.overallDiscount) : 0;

                        component_x.supportDiscount.forEach(function(row) {
                            var discount;
                            if (numberRegex.test(row)) {
                                discount = row;
                                beforeDiscount = (beforeDiscount - discount)
                            } else if (lessDiscount.test(row)) {
                                discount = row.slice(1)
                                beforeDiscount = (beforeDiscount - discount)
                            } else if (lessDiscountDecimal.test(row)) {
                                discount = row
                                beforeDiscount = (beforeDiscount - discount)
                            } else if (percentDiscount.test(row)) {
                                discount = row.slice(0,-1)
                                discount = (beforeDiscount) * (discount / 100)
                            }
                            overallDiscount = overallDiscount + Number(discount)
                        });

                        if (overallDiscount <= 0) overallDiscount = 0

                        var totalDiscount = Number(overallDiscount) + Number(component_x.itemDiscount)
                        if (totalDiscount <= Number(component_x.grossAmount) || Number(component_x.grossAmount) == 0) {
                            component_x.overallDiscount = overallDiscount.toFixed(this.decimalPlaces)
                        } else {
                            this.notifMessage = ['Discount total must not be greater than gross amount']
                            this.documentActionNotification('Overall discount', 'error')
                        }
                    } else {
                        this.notifMessage = notifMessage
                        this.documentActionNotification('Document line discount', 'error')
                    }
                }

                // add code for recomputing subtotal w/o vat when applying discounts.
                let items = this.tabulator.getData();
                let newItems = []
                
                this.sumSubtotal = 0
                for(let i = 0; i < items.length; i++){
                    let item = items[i]
                    this.sumSubtotal = this.sumSubtotal + Number(item.subtotal)
                }

                for(let i = 0; i < items.length; i++){
                    let item = items[i]
                    let distributedOverallDiscount = 0
                    if (Number(item.subtotal) != 0 || this.sumSubtotal != 0 || this.overallDiscount != 0){
                        distributedOverallDiscount = this.overallDiscount * (Number(item.subtotal) / this.sumSubtotal)
                    }
                    console.log("distributedOverallDiscount2", distributedOverallDiscount)
                    let subtotal_less_overall_discount = Number(item.subtotal) - Number(distributedOverallDiscount)
                    console.log(Number(item.subtotal), this.party_tax_type, item.tax_type)
                    if(this.party_tax_type == 'V' || this.party_tax_type == undefined){
                        if(item.tax_type == 'V'){
                            item.subtotal_without_vat = (subtotal_less_overall_discount/ (1+Number(this.taxRate))).toFixed(this.fixedDecimalPlaces)
                            item.price_without_vat = (Number(item.price)/ (1+Number(this.taxRate))).toFixed(this.fixedDecimalPlaces)
                            item.tax_amount = (subtotal_less_overall_discount - item.subtotal_without_vat).toFixed(this.fixedDecimalPlaces)
                        } else {
                            item.subtotal_without_vat = (subtotal_less_overall_discount).toFixed(this.fixedDecimalPlaces)
                            item.price_without_vat = (Number(item.price)).toFixed(this.fixedDecimalPlaces)
                            item.tax_amount = 0
                        }
                    } else {
                        item.subtotal_without_vat = (subtotal_less_overall_discount).toFixed(this.fixedDecimalPlaces)
                        item.price_without_vat = (Number(item.price)).toFixed(this.fixedDecimalPlaces)
                        item.tax_amount = 0
                    }
                    
                    newItems.push(item)
                }
                this.tabulator.updateData(newItems)

                //recalculate summary and pass false parameter for loop prevention
                this.calculateSummary(false);
            },
            onHeaderDiscountChange() {
                var netAmount;
                if (component_x.headerDiscount.length != 0){
                    this.calculateOverallDiscount();

                    //Calcualates Net Amount
                    netAmount = (Number(component_x.grossAmount) - Number(component_x.itemDiscount) - Number(component_x.overallDiscount))
                    if (netAmount <= 0) netAmount = 0
                    component_x.netAmount = netAmount.toFixed(this.decimalPlaces)
                    component_x.netAmountDisplay = component_x.netAmount

                } else {
                    component_x.overallDiscount = Number(0).toFixed(this.decimalPlaces)
                    this.calculateOverallDiscount();

                    //Calcualates Net Amount
                    netAmount = (Number(component_x.grossAmount) - Number(component_x.itemDiscount) - Number(component_x.overallDiscount))
                    if (netAmount <= 0) netAmount = 0
                    component_x.netAmount = netAmount.toFixed(this.decimalPlaces)
                    component_x.netAmountDisplay = component_x.netAmount
                }
            },
            onSupportDiscountChange () {

                if(['ORIPOX', 'OTHPUR', 'RELRSR', 'RECDEL'].includes(this.currentDocumentTypeCode)) {

                    var netAmount;
                    if (component_x.supportDiscount.length != 0){
                        this.calculateOverallDiscount();

                        //Calculates Net Amount
                        netAmount = (Number(component_x.grossAmount) - Number(component_x.itemDiscount) - Number(component_x.overallDiscount))
                        if (netAmount <= 0) netAmount = 0
                        component_x.netAmount = netAmount.toFixed(this.decimalPlaces)
                        component_x.netAmountDisplay = component_x.netAmount

                    } else {
                        component_x.overallDiscount = Number(0).toFixed(this.decimalPlaces)
                        this.calculateOverallDiscount();

                        //Calculates Net Amount
                        netAmount = (Number(component_x.grossAmount) - Number(component_x.itemDiscount) - Number(component_x.overallDiscount))
                        if (netAmount <= 0) netAmount = 0
                        component_x.netAmount = netAmount.toFixed(this.decimalPlaces)
                        component_x.netAmountDisplay = component_x.netAmount
                    }

                } else {
                    this.isSupportDiscountValid = false
                    var notifMessage = []
                    // eslint-disable-next-line
                    //var discountRegex = /(^L[0-9]+$|^[0-9]+$|^[0-9]+\%$)/;
                    var discountRegex = /(^\d{0,10}(\.\d{1,4})? *%?$)/;

                    this.supportDiscount.forEach(function(row) {
                        if (!discountRegex.test(row)) notifMessage.push(row + ' discount input is invalid \n \r');
                    });

                    if (notifMessage.length == 0) {
                        this.isSupportDiscountValid = true
                    } else {
                        this.notifMessage = notifMessage
                        this.documentActionNotification('Document line discount', 'error')
                    }
                }
            },
            toggleVatExclusive(e) {
                this.vatExclusiveCheckbox = e.target.checked
                
                // for some weird reason e.target.checked doesnt change to false eventhough you click it multiple times.
                // we need a source of truth using isVatEx variable as current status.
                if(this.isVatEx == true){
                    this.vatExclusiveCheckbox = false
                } else {
                    this.vatExclusiveCheckbox = true
                }
                this.isVatEx = this.vatExclusiveCheckbox

                this.calculateSummary();
                if (this.vatExclusiveCheckbox) {
                    this.grossAmountDisplay = this.numberOrZero(this.grossAmountwithoutTax).toFixed(this.decimalPlaces)
                    this.netAmountDisplay = this.numberOrZero(this.netAmountWithoutTax).toFixed(this.decimalPlaces)
                } else {
                    this.grossAmountDisplay = this.numberOrZero(this.grossAmount).toFixed(this.decimalPlaces)
                    this.netAmountDisplay = this.numberOrZero(this.netAmount).toFixed(this.decimalPlaces)
                }
            },
            // Advanced Info
            showAdvancedInfoDiv(){
                this.showAdvancedInfo ? this.showAdvancedInfo = false : this.showAdvancedInfo = true
            },
            async fetchPaymentTerms() {
                this.fetching = true
                this.paymentTerms = await HTTPRequest.getRequest(this.endPoint + 'payment_terms/get_valid_payment_terms', null)
                this.fetching = false
            },
            selectPaymentTerm (paymentTerm) {
                var arr = {
                    key:paymentTerm.key.replace('paymentTerms',''),
                    label:paymentTerm.label
                }
                paymentTerm = arr
                Object.assign(this, {
                    paymentTerm,
                    paymentTerms: [],
                    fetching: false,
                })
            },
            async fetchShippingMethods() {
                this.fetching = true
                this.shippingMethods = await HTTPRequest.getRequest(this.endPoint + 'shipping_methods/get_valid_shipping_methods', null)
                this.fetching = false
            },
            numberOrZero(value) {
                if (value === null || value === undefined || value === '') {
                    return 0
                }

                const parsedValue = Number(String(value).replace(/,/g, ''))
                return Number.isFinite(parsedValue) ? parsedValue : 0
            },
            isDocumentFormDebugEnabled() {
                const debugFlag = process.env.VUE_APP_DEBUG_DOCUMENT_FORM
                return debugFlag === undefined || debugFlag === null || String(debugFlag).toLowerCase() !== 'false'
            },
            documentFormDebugWarn(message, payload) {
                if (!this.isDocumentFormDebugEnabled()) {
                    return
                }

                console.warn(message, payload)
            },
            isFiniteNumberValue(value) {
                if (value === null || value === undefined || value === '') {
                    return true
                }

                return Number.isFinite(Number(String(value).replace(/,/g, '')))
            },
            logSummaryAmountsForSubmit(action) {
                const fields = [
                    'grossAmount',
                    'grossAmountDisplay',
                    'grossAmountwithoutTax',
                    'netAmount',
                    'netAmountDisplay',
                    'netAmountWithoutTax',
                    'itemDiscount',
                    'overallDiscount',
                    'vatAmount',
                    'totalWithVat'
                ]
                const rows = this.tabulator ? this.tabulator.getData() : []
                const calcResults = this.tabulator ? this.tabulator.getCalcResults() : null
                const summaryValues = {}
                const invalidSummaryFields = []
                const invalidLineAmountFields = []
                const requiredLineAmountFields = ['quantity', 'total_gross', 'discount', 'subtotal_without_vat']

                fields.forEach(fieldName => {
                    summaryValues[fieldName] = this[fieldName]
                    if (!this.isFiniteNumberValue(this[fieldName])) {
                        invalidSummaryFields.push({
                            fieldName,
                            rawValue: this[fieldName]
                        })
                    }
                })

                rows.forEach(row => {
                    if (row.line_no <= 0 || this.numberOrZero(row.quantity) <= 0) {
                        return
                    }

                    const invalidFields = requiredLineAmountFields.filter(fieldName => {
                        const value = row[fieldName]
                        return value === null || value === undefined || value === '' || !this.isFiniteNumberValue(value)
                    })

                    if (invalidFields.length > 0) {
                        invalidLineAmountFields.push({
                            line_no: row.line_no,
                            product_id: row.product_id,
                            barcode: row.barcode,
                            product_name: row.product_name,
                            invalidFields,
                            values: invalidFields.reduce((acc, fieldName) => {
                                acc[fieldName] = row[fieldName]
                                return acc
                            }, {})
                        })
                    }
                })

                this.documentFormDebugWarn('[DocumentForm] Summary amounts before document submit', {
                    action,
                    documentNumber: this.documentNumber,
                    documentStatus: this.documentStatus,
                    currentDocumentTypeCode: this.currentDocumentTypeCode,
                    selectedDocumentLinesCount: this.selectedDocumentLines ? this.selectedDocumentLines.length : 0,
                    tabulatorRowsCount: rows.length,
                    summaryValues,
                    invalidSummaryFields,
                    calcResults,
                    calcResultsBottom: calcResults ? calcResults.bottom : null,
                    invalidLineAmountFields,
                    vatExclusiveCheckbox: this.vatExclusiveCheckbox,
                    stack: new Error().stack
                })
            },
            logDocumentAmountResponse(context, document) {
                if (!document) {
                    this.documentFormDebugWarn('[DocumentForm] Document amount response is blank', {
                        context,
                        documentNumber: this.documentNumber,
                        currentDocumentTypeCode: this.currentDocumentTypeCode,
                        stack: new Error().stack
                    })
                    return
                }

                const amountFields = [
                    'amount_gross',
                    'amount_net',
                    'amount_header_discount',
                    'tax_amount',
                    'tax_exempt_amount',
                    'amount_line_discount',
                    'gross_amount_without_tax',
                    'net_amount_without_tax',
                    'total_quantity'
                ]
                const amountValues = {}
                const missingOrInvalidAmountFields = []

                amountFields.forEach(fieldName => {
                    const value = document[fieldName]
                    amountValues[fieldName] = value
                    if (value === null || value === undefined || value === '' || !this.isFiniteNumberValue(value)) {
                        missingOrInvalidAmountFields.push({
                            fieldName,
                            value
                        })
                    }
                })

                if (this.currentDocumentTypeCode === 'RECTRX' || missingOrInvalidAmountFields.length > 0) {
                    this.documentFormDebugWarn('[DocumentForm] Document amount fields loaded', {
                        context,
                        documentNumber: this.documentNumber,
                        currentDocumentTypeCode: this.currentDocumentTypeCode,
                        amountValues,
                        missingOrInvalidAmountFields,
                        currentSummaryBeforeAssign: {
                            grossAmountDisplay: this.grossAmountDisplay,
                            grossAmount: this.grossAmount,
                            grossAmountwithoutTax: this.grossAmountwithoutTax,
                            netAmount: this.netAmount,
                            netAmountDisplay: this.netAmountDisplay,
                            netAmountWithoutTax: this.netAmountWithoutTax
                        },
                        stack: new Error().stack
                    })
                }
            },
            logDocumentLineAmountFields(context, rows) {
                const documentLines = Array.isArray(rows) ? rows : []
                const watchedFields = [
                    'quantity',
                    'total_gross',
                    'subtotal',
                    'discount',
                    'subtotal_without_vat',
                    'price',
                    'retail_price'
                ]
                const invalidLineAmountFields = []
                const lineAmountSample = documentLines.slice(0, 10).map(row => {
                    const values = {}
                    watchedFields.forEach(fieldName => {
                        values[fieldName] = row[fieldName]
                    })

                    return {
                        line_no: row.line_no,
                        product_id: row.product_id,
                        barcode: row.barcode,
                        product_name: row.product_name,
                        values
                    }
                })

                documentLines.forEach(row => {
                    if (row.line_no <= 0) {
                        return
                    }

                    const invalidFields = watchedFields.filter(fieldName => {
                        const value = row[fieldName]
                        return value === null || value === undefined || value === '' || !this.isFiniteNumberValue(value)
                    })

                    if (invalidFields.length > 0) {
                        invalidLineAmountFields.push({
                            line_no: row.line_no,
                            product_id: row.product_id,
                            barcode: row.barcode,
                            product_name: row.product_name,
                            invalidFields,
                            values: invalidFields.reduce((acc, fieldName) => {
                                acc[fieldName] = row[fieldName]
                                return acc
                            }, {})
                        })
                    }
                })

                if (this.currentDocumentTypeCode === 'RECTRX' || invalidLineAmountFields.length > 0) {
                    this.documentFormDebugWarn('[DocumentForm] Document line amount fields loaded', {
                        context,
                        documentNumber: this.documentNumber,
                        currentDocumentTypeCode: this.currentDocumentTypeCode,
                        lineCount: documentLines.length,
                        invalidLineAmountFields,
                        lineAmountSample,
                        currentSummary: {
                            grossAmountDisplay: this.grossAmountDisplay,
                            grossAmount: this.grossAmount,
                            grossAmountwithoutTax: this.grossAmountwithoutTax,
                            netAmount: this.netAmount,
                            netAmountDisplay: this.netAmountDisplay,
                            netAmountWithoutTax: this.netAmountWithoutTax
                        },
                        stack: new Error().stack
                    })
                }
            },
            normalizeDocumentLineAmountFields(context, rows) {
                if (!Array.isArray(rows)) {
                    return rows
                }

                const normalizedRows = rows.map(row => {
                    const normalizedRow = Object.assign({}, row)
                    const hasInvalidTotalGross = normalizedRow.total_gross === null || normalizedRow.total_gross === undefined || normalizedRow.total_gross === '' || !this.isFiniteNumberValue(normalizedRow.total_gross)

                    if (hasInvalidTotalGross && this.isFiniteNumberValue(normalizedRow.subtotal) && normalizedRow.subtotal !== null && normalizedRow.subtotal !== undefined && normalizedRow.subtotal !== '') {
                        normalizedRow.total_gross = normalizedRow.subtotal
                    }

                    return normalizedRow
                })

                const normalizedLineAmountFields = normalizedRows.filter((row, index) => {
                    return rows[index] && rows[index].total_gross !== row.total_gross
                }).map(row => {
                    return {
                        line_no: row.line_no,
                        product_id: row.product_id,
                        barcode: row.barcode,
                        product_name: row.product_name,
                        total_gross: row.total_gross,
                        subtotal: row.subtotal
                    }
                })

                if (normalizedLineAmountFields.length > 0) {
                    this.documentFormDebugWarn('[DocumentForm] Document line amount fields normalized', {
                        context,
                        documentNumber: this.documentNumber,
                        currentDocumentTypeCode: this.currentDocumentTypeCode,
                        normalizedLineAmountFields
                    })
                }

                return normalizedRows
            },
            logCurrentSummaryAmounts(context) {
                const rows = this.tabulator ? this.tabulator.getData() : []
                const calcResults = this.tabulator ? this.tabulator.getCalcResults() : null
                const summaryValues = {
                    grossAmount: this.grossAmount,
                    grossAmountDisplay: this.grossAmountDisplay,
                    grossAmountwithoutTax: this.grossAmountwithoutTax,
                    netAmount: this.netAmount,
                    netAmountDisplay: this.netAmountDisplay,
                    netAmountWithoutTax: this.netAmountWithoutTax,
                    itemDiscount: this.itemDiscount,
                    overallDiscount: this.overallDiscount,
                    vatAmount: this.vatAmount,
                    totalWithVat: this.totalWithVat
                }
                const invalidSummaryFields = Object.keys(summaryValues).filter(fieldName => {
                    return !this.isFiniteNumberValue(summaryValues[fieldName])
                })

                this.documentFormDebugWarn('[DocumentForm] Current summary amount state', {
                    context,
                    documentNumber: this.documentNumber,
                    documentStatus: this.documentStatus,
                    currentDocumentTypeCode: this.currentDocumentTypeCode,
                    tabulatorRowsCount: rows.length,
                    summaryValues,
                    invalidSummaryFields,
                    calcResults,
                    calcResultsBottom: calcResults ? calcResults.bottom : null,
                    vatExclusiveCheckbox: this.vatExclusiveCheckbox,
                    stack: new Error().stack
                })
            },
            logInvalidFormatNumber(fieldName, rawNumber, rawDecimal, decimal, parsedNumber) {
                const logKey = `${fieldName}|${rawNumber}|${rawDecimal}`
                if (this._lastInvalidFormatNumberLog === logKey) {
                    return
                }

                this._lastInvalidFormatNumberLog = logKey
                this.documentFormDebugWarn('[DocumentForm] Invalid numeric value passed to formatMyNumber', {
                    fieldName,
                    rawNumber,
                    rawDecimal,
                    parsedNumber,
                    decimal,
                    grossAmountDisplay: this.grossAmountDisplay,
                    grossAmount: this.grossAmount,
                    grossAmountwithoutTax: this.grossAmountwithoutTax,
                    vatExclusiveCheckbox: this.vatExclusiveCheckbox,
                    documentNumber: this.documentNumber,
                    documentStatus: this.documentStatus,
                    currentDocumentTypeCode: this.currentDocumentTypeCode,
                    selectedDocumentLinesCount: this.selectedDocumentLines ? this.selectedDocumentLines.length : 0
                })
            },
            formatMyNumber(number, decimal, fieldName = 'formatMyNumber') {
                var splitNum;
                const rawNumber = number
                const rawDecimal = decimal
                decimal = parseInt(decimal, 10)
                decimal = Number.isFinite(decimal) && decimal >= 0 ? decimal : 2
                const parsedNumber = Number(String(number === null || number === undefined ? 0 : number).replace(/,/g, ''))
                if (!Number.isFinite(parsedNumber)) {
                    this.logInvalidFormatNumber(fieldName, rawNumber, rawDecimal, decimal, parsedNumber)
                }

                number = Number.isFinite(parsedNumber) ? Math.abs(parsedNumber) : 0
                number = number.toFixed(decimal);
                splitNum = number.split('.');
                splitNum[0] = splitNum[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                return splitNum.join(".");
            },
            async enableAdditionalCharges(){
                // Arvin
                this.modalAdditionalCharges = true
                this.totalPurchaseVariance = 0
            },
            async applyAdditionalCharges(){
                this.spinMessage = 'Calculating Additional Charges for Viewing'
                this.spinning2 = true;
                //Get lines cost layer
                //Allocate Charges
                this.itemCostLayerData = []
                this.itemCostLayerData = await HTTPRequest.getRequest(this.endPoint + 'documents/get_document_cost_layer?document_id='+this.documentNumber + '&additionalCharges=' + this.totalPurchaseVariance + '&chargeDistributionQuantity=' + this.chargeDistributionQuantity,null)
                this.spinning2 = false;
            },
            async saveAdditionalCharges(){
                //Apply Charges
                this.applyAdditionalCharges();
                this.spinMessage = 'Saving Additional Charges'
                this.spinning2 = true;
                //Save Charges
                var additionalChargeDataPayLoad = {"additionalChargeData": this.additionalChargeData}
                var saveAdditionalCharges = await HTTPRequest.postRequest(this.endPoint + 'documents/save_additional_charges?document_id='+ this.documentNumber + '&chargeDistributionQuantity=' + this.chargeDistributionQuantity, null, additionalChargeDataPayLoad)

                if(saveAdditionalCharges["error"] == undefined){
                   //Update Cost Layer
                   var itemCostLayerData = {"itemCostLayerData" : this.itemCostLayerData}
                   var applyAdditionalChargesToCostLayer = await HTTPRequest.postRequest(this.endPoint + 'documents/apply_additional_charges_to_cost_layer?document_id='+ this.documentNumber, null, itemCostLayerData)
                   if(applyAdditionalChargesToCostLayer["error"] == undefined){
                        this.$emit('refreshPage', event)
                        this.openDocument(this.documentNumber,this.existingDocumentTypeDetails)
                        this.documentActionNotification('Applying Additional Charges', 'success')
                        this.create_action_history('Apply Additional Charges')
                        this.modalAdditionalCharges = false
                        this.itemCostLayerData = []
                        this.additionalChargeData = []
                   } else {
                        this.documentActionNotification(applyAdditionalChargesToCostLayer["error"], 'error')
                   }
                }
                this.spinning2 = false;
                this.disableSaveCharges = false;
            },
            selectShippingMethod (shippingMethod) {
              this.isEditing = true
                var arr = {
                    key:shippingMethod.key.replace('shippingMethods',''),
                    label:shippingMethod.label
                }
                shippingMethod = arr
                Object.assign(this, {
                    shippingMethod,
                    shippingMethods: [],
                    fetching: false,
                })
            },
            async fetchPurposes() {
                this.fetching = true
                this.purposes = await HTTPRequest.getRequest(this.endPoint + 'purposes/get_valid_purposes?document_type_id='+this.currentDocumentTypeId, null)
                this.fetching = false
            },
            selectPurpose (purpose) {
              this.isEditing = true
                var arr = {
                    key:purpose.key.replace('purposes',''),
                    label:purpose.label
                }
                purpose = arr
                Object.assign(this, {
                    purpose,
                    purposes: [],
                    fetching: false,
                })
            },

            async autoSetPurpose(doc_type_id) {
                // Fetch the list of purposes based on the current document type ID
                this.purposes = await HTTPRequest.getRequest(this.endPoint + 'purposes/get_valid_purposes?document_type_id='+ doc_type_id, null)

                // Find the first purpose in the list
                const defaultPurpose = this.purposes.length > 0 ? this.purposes[0] : null;

                if (defaultPurpose) {
                    // If a purpose is found, set it in the component
                    const purpose = {
                    key: `purposes${defaultPurpose.id}`,
                    label: defaultPurpose.name,
                    };

                    this.purpose = purpose;
                    this.isEditing = true;
                } else {
                    // If no purpose is found, set purpose to null
                    const purpose = {
                    key: null,
                    label: '',
                    };
                    this.purpose = purpose;
                }
            },
            closeChargeDrawer() {
            },
            showDrawer(action) {

                if (action == 'charges') {
                    this.chargeDrawerVisible = true;
                } else if (action == 'history') {
                    this.historyDrawerVisible = true;
                }
                // Validation for PURCHASE TO PAYMENT documents -> SUPPLIER is required
                   else if (action == 'massAdd') {
                    if (this.isPhysicalCountV2ProductListLocked) {
                        return;
                    }

                    if( this.validationdocutypes.includes(this.currentDocumentTypeCode) && this.supplier.key === undefined  ) {
                        component_x.$notification['error']({
                            message: 'Supplier is required',
                            description: "Please select supplier.",
                            style: getNotificationStyle('error')
                        });
                    } else {
                        this.massAddDrawerVisible = true;
                        this.massAddDrawerKey++
                    }

                } else if (action == 'references') {
                    this.referenceDrawerVisible = true;
                } else if (action == 'extras') {
                    this.extrasDrawerVisible = true;
                } else if (action == 'document_image') {
                    this.documentImageDrawerVisible = true;
                }else if (action == "massAddWithAllocation"){
                    if (this.isPhysicalCountV2ProductListLocked) {
                        return;
                    }
                    this.massAddWithAllocationDrawerVisible = true;
                }else if (action == "view_allocation"){
                    this.viewSiteAllocation()
                }
                this.massAddProductErrors = [];
                this.massAddProductErrorsDL = [];
                this.dlDUplicateSkus = 0;
                this.dlSkusNotFound =  0;
            },
            closeDrawer(action) {
                if (action == 'charges'){
                    this.clearChargeFormDrawer();
                    this.selectChargeType();
                    this.chargeDrawerVisible = false;
                } else if (action == 'history'){
                    this.historyDrawerVisible = false;
                } else if (action == 'payments'){
                    this.paymentDrawerVisible = false;
                } else if (action == 'booking'){
                    this.bookingDrawerVisible = false;
                } else if (action == 'massAdd'){
                    this.massAddDrawerVisible = false;
                } else if (action == 'references'){
                    this.referenceDrawerVisible = false;
                } else if (action == 'extras'){
                    this.extrasDrawerVisible = false;
                } else if (action == 'document_image'){
                    this.documentImageDrawerVisible = false;
                } else if (action == 'serialization'){
                  if (this.isPhysicalCountV2QuantityEditLocked) {
                    this.serializationVisible = false;
                    return;
                  }
                  let drawerSnapshot = this.currentDocumentTypeCode.includes("REL") ? this.serialRows(this.currentDrawerSerials).filter(({checked}) => checked) : this.serialRows(this.currentDrawerSerialsInstance);
                  this.tabulator.updateData([{line_no: this.selectedSerialProduct.line_no, product_id: this.selectedSerialProduct.product_id, quantity: drawerSnapshot.length, document_line_serials: drawerSnapshot }])
                  this.calculateSummary();
                  this.serializationVisible = false;
                } else if (action == 'document_payments'){
                    this.documentPaymentsDrawerVisible = false;
                } else if (action == 'sublocationAllocation'){
                    this.sublocationAllocationVisible = false;
                    this.drawerCurrentSublocationAllocation = []
                    this.drawerSublocation = {key: 0, label: "Please select a sublocation"}
                    this.drawerSublocationQuantity = ''
                    this.sublocationAllocationErrors = [];
                } else if (action == 'siteAllocation'){
                    this.siteAllocationVisible = false;
                    this.drawerCurrentSiteAllocation = []
                    this.drawerSite = {key: 0, label: "Please select a site"}
                    this.drawerSiteQuantity = ''
                    this.siteAllocationErrors = [];
                    this.isEditAllocation=false
                    this.isEditAllocationIndex=0
                    this.siteAllocationRemainingQuantity = null
                } else if (action == "ecomForm"){
                    this.documentEcomDrawerVisible = false
                } else if(action == "initialDeposit"){
                    this.initialDepositDrawerVisible = false
                }else if (action == "massAddWithAllocation"){
                    this.massAddWithAllocationDrawerVisible = false
                }else if (action == "view_allocation"){
                    this.viewAllocation = false
                }else if (action == "lotCodeExpiry"){
                    this.inputExpiryAt = undefined
                    this.inputLotCode = ''
                    this.lotCodeExpiryVisible = false
                }
            },
            ecomCloseDrawer(){
                this.closeDrawer("ecomForm")
            },
            selectChargeType () {
                this.isChargeWeightDisabled = (this.chargeType == 'W') ?  false : true
                this.isChargeRateDisabled = (this.chargeType == 'W') ? false : true
                this.isChargeAmountDisabled = (this.chargeType == 'W') ? true : false
                this.chargeWeight = 0
                this.chargeRate = 0
                this.chargeAmount = 0
            },
            mass_delete_charge() {
                if (this.documentStatus == 'Posted'){
                    const newData = [...this.additionalChargeData]
                    var ids = this.additionalChargeSelectedRowKeys
                    var afterDelete = _.remove(newData, function(n) {
                        return !ids.includes(n.line_no);
                    });
                    this.additionalChargeData = afterDelete
                    this.chargeSelectedRowKeys = []
                } else {
                    const newData = [...this.chargeData]
                    var ids = this.chargeSelectedRowKeys
                    var afterDelete = _.remove(newData, function(n) {
                        return !ids.includes(n.line_no);
                    });
                    this.chargeData = afterDelete
                    this.chargeSelectedRowKeys = []
                }
                this.totalCharge();
            },
            validateCharge(){
                this.notifMessage = [];
                this.notifMessage.push(ValidateField.required('Description', this.chargeDescription));
                this.notifMessage.push(ValidateField.decimalFormat('Weight', this.chargeWeight));
                this.notifMessage.push(ValidateField.decimalFormat('Rate', this.chargeRate));
                this.notifMessage.push(ValidateField.decimalFormat('Amount', this.chargeAmount));
                this.notifMessage.push(ValidateField.lessThanZero('Weight', this.chargeWeight, 'Weight is required'));
                this.notifMessage.push(ValidateField.lessThanZero('Rate', this.chargeRate, 'Rate is required'));
                this.notifMessage.push(ValidateField.lessThanZero('Amount', this.chargeAmount, 'Amount is Required'));
                this.notifMessage = this._.compact(this.notifMessage);
                return this.notifMessage.length;
            },
            totalCharge() {
                let i = 0;
                this.totalCharges = 0
                this.totalPurchaseVariance = 0
                while (i < this.chargeData.length) {
                    this.totalCharges =  Number(this.totalCharges) + Number(this.chargeData[i]['amount']);
                    i++;
                }
                i = 0;
                while (i < this.additionalChargeData.length) {
                        this.totalPurchaseVariance =  Number(this.totalPurchaseVariance) + Number(this.additionalChargeData[i]['amount']);
                    i++;
                }  
            },
            clearChargeFormDrawer() {
                this.chargeDescription = null
                this.chargeType = 'R'
                this.chargeWeight = 0
                this.chargeRate = 0
                this.chargeAmount = 0
            },
            addCharge: async function() {
                if(!this.validateCharge()) {
                    var charges = this.chargeData.map(a => a.line_no);
                    var additional_charges = this.additionalChargeData.map(a => a.line_no);
                    if (charges.length == 0) charges = [0]
                    if (additional_charges.length == 0) additional_charges = [0]
                    if (this.documentStatus == 'Posted'){
                        this.additionalChargeData.push({
                            line_no: Math.max(...additional_charges) + 1,
                            name: this.chargeDescription,
                            remark: this.chargeType,
                            weight: this.chargeWeight,
                            rate: this.chargeRate,
                            amount: this.chargeAmount,
                            charge_type: 'A'
                        })
                    } else {
                        this.chargeData.push({
                            line_no: Math.max(...charges) + 1,
                            name: this.chargeDescription,
                            remark: this.chargeType,
                            weight: this.chargeWeight,
                            rate: this.chargeRate,
                            amount: this.chargeAmount,
                            charge_type: 'I'
                        })
                    }

                    this.totalCharge();
                    this.clearChargeFormDrawer();
                    this.closeDrawer('charges');
                    this.documentActionNotification('add charge', 'success')
                } else {
                    this.clearChargeFormDrawer();
                    this.closeDrawer('charges');
                    this.documentActionNotification('add charge', 'error')
                }
            },
            calculateChargeAmount () {
                this.notifMessage = [];
                this.notifMessage.push(ValidateField.decimalFormat('Weight', this.chargeWeight));
                this.notifMessage.push(ValidateField.decimalFormat('Rate', this.chargeRate));
                this.notifMessage = this._.compact(this.notifMessage);
                if (this.notifMessage.length == 0) {
                    this.chargeAmount = Number(this.chargeWeight * this.chargeRate * (1+Number(this.taxRate))).toFixed(this.decimalPlaces)
                }
            },

            // Footer Document Actions
            documentActionNotification(action, type) {
                if (type == 'success') {
                    this.$notification[type]({
                        message: _.startCase(action) + ' action success',
                        style: getNotificationStyle(type)
                    });
                } else if (type == 'error') {
                    this.$notification[type]({
                        message: _.startCase(action) + ' action failed',
                        // eslint-disable-next-line
                        description: h => {
                            return <ul class='m-0 p-0'>
                                {this.notifMessage.map((value, index) => {
                                    return <li key={index}>{value}</li>
                                })}
                            </ul>
                        },
                        style: getNotificationStyle(type)
                    });
                }
            },
            normalizeActionErrors(error) {
                if (Array.isArray(error)) {
                    return error;
                }

                if (error && typeof error.split === 'function') {
                    return error.split(',');
                }

                if (error && typeof error === 'object') {
                    return Object.keys(error).reduce((messages, key) => {
                        const value = error[key];
                        return messages.concat(Array.isArray(value) ? value : [value]);
                    }, []);
                }

                return [error || 'Action failed.'];
            },
            ensureSourceSiteId(action, options = {}) {
                if (!(this.header && this.header.showSupplyingSite)) {
                    return true;
                }

                const sourceSiteId = this.supplyingSite && this.supplyingSite.key;
                if (sourceSiteId !== undefined && sourceSiteId !== null && sourceSiteId !== '') {
                    return true;
                }

                this.notifMessage = ['Supplying Site is required. source_site_id must be present.'];
                if (options.resetPostState) {
                    this.isPostDisabled = false;
                    this.postClickCount = 0;
                }
                if (options.stopSpinner) {
                    this.spinning = false;
                }
                this.documentActionNotification(action, 'error');
                return false;
            },
            validateForm(options = {}){
                this.notifMessage = [];
                var data = this.tabulator.getData()
                var validatePhysicalCountV2Posting = options.validatePhysicalCountV2Posting === true;
                var shouldRunPhysicalCountV2PostingValidations = !this.isPhysicalCountV2Document || validatePhysicalCountV2Posting;
                //For Interbranch Documents
                if (['ORITRQ','OROTRQ','RECTRX','RELTRX','ORICSQ','OROCSQ','RECCSX','RELCSX'].includes(this.currentDocumentTypeCode)){
                    this.notifMessage.push(ValidateField.required('Supplying Site', this.supplyingSite.key));
                    this.notifMessage.push(ValidateField.required('Requesting Site', this.requestingSite.key));
                    this.notifMessage.push(ValidateField.identicalField('Supplying Site', 'Requesting Site', this.supplyingSite.key, this.requestingSite.key));
                }
                //For Purchase Documents
                if (['OTHPUR','ORIPOX','RECDEL','RELRSR'].includes(this.currentDocumentTypeCode)){
                    this.notifMessage.push(ValidateField.required('Supplier', this.supplier.key));
                }

                //For Local Documents
                if(['RECADJ','RELADJ'].includes(this.currentDocumentTypeCode)){
                    this.notifMessage.push(ValidateField.required('Purpose', this.purpose.key));
                    this.notifMessage.push(ValidateField.required('Party', this.party));
                }

                //For Transfer Allocation
                if(['OTHTRA'].includes(this.currentDocumentTypeCode) && this.processingXlsxUpload != true){
                    this.notifMessage.push(ValidateField.required('Supplying Site', this.supplyingSite.key));
                    if(this.supplyingSite.key == -1){
                        this.notifMessage.push('Supplying Site cannot be -1. Please select a valid site.');
                    }
                    data.forEach( line => {
                        if (line.site_allocation == undefined || line.site_allocation == []){
                            this.notifMessage.push(`Product ${line.product_name} has no site allocation`);
                        }
                    })
                }
                //For Distribution Documents
                if(['RECSLI','RELSLO'].includes(this.currentDocumentTypeCode)){
                    if (this.originSublocation.key == undefined){
                        this.notifMessage.push(ValidateField.required('Sublocation Origin', this.originSublocation.key));
                    }
                    if (this.destinationSublocation.key == undefined){
                        this.notifMessage.push(ValidateField.required('Sublocation Destination', this.destinationSublocation.key));
                    }
                    if (this.destinationSublocation.key != undefined && this.originSublocation.key != undefined){
                        this.notifMessage.push(ValidateField.identicalField('Sublocation Origin', 'Sublocation Destination', this.originSublocation.key, this.destinationSublocation.key));
                    }

                }

                //For Orisox Documents
                if(['ORISOX'].includes(this.currentDocumentTypeCode)){
                    this.notifMessage.push(ValidateField.required('Customer', this.customer.key));
                    if (this.isOrderSourceMode){
                        this.notifMessage.push(ValidateField.required('Order Source', this.orderSource));
                    }

                    var invalid = data.find(row => row.quantity == 0)
                    if (invalid != undefined){
                        this.notifMessage.push("Zero quantity is not allowed in the document line");
                    }
                }

                //For RelDde Documents
                if(['RELDDE'].includes(this.currentDocumentTypeCode)){
                    this.notifMessage.push(ValidateField.required('Customer', this.customer.key));

                    if (this.isOrderSourceMode){
                        this.notifMessage.push(ValidateField.required('Order Source', this.orderSource));
                    }else{
                        this.notifMessage.push(ValidateField.required('Sublocation Origin', this.originSublocation.key));
                    }

                    //when goods issue
                    if (this.documentNumber > 0) {
                        var invalid = data.find(row => (row.goods_issue_quantity == 0 && Number(row.ordered_quantity) > 0))
                        if (invalid != undefined){
                            this.notifMessage.push("Zero goods issue quantity is not allowed in the document line");
                        }
                    } else {
                        //when open delivery
                        console.log(data)
                        var any = data.find(row => (row.quantity > 0 && Number(row.ordered_quantity) > 0))
                        if (any == undefined){
                            this.notifMessage.push("Atleast one line of delivery quantity should be filled");
                        }
                    }
                }
                if(['RECCSR'].includes(this.currentDocumentTypeCode)){
                    //Validate each line
                    this.notifMessage.push(ValidateField.required('Customer', this.customer.key));
                    this.notifMessage.push(ValidateField.required('Site', this.distributionSite.key));
                    if(!component_x.openCSR){
                        data.forEach(row => {
                            this.notifMessage.push(ValidateField.isGreaterThan(`${row.product_name}`, parseInt(row.quantity),  parseInt(row.goods_issue_quantity)+1, `${row.product_name} quantity is more than the goods issued quantity.`))
                        });
                    }
                }

                this.notifMessage.push(ValidateField.required('Document Date', this.documentDate));
                this.notifMessage.push(ValidateField.required('Target Date', this.targetDate));
                this.notifMessage.push(ValidateField.required('Cancellation Date', this.cancellationDate));
                if (this.supportDiscount) this.notifMessage.push(ValidateField.validateBoolean('Support Discount', this.isSupportDiscountValid));
                this.notifMessage.push(ValidateField.charMinAndMax("Remark",this.remark,0,255));
                this.notifMessage.push(ValidateField.charMinAndMax("Reference",this.reference,0,50));

                if(this.isHeaderOnly != true && this.processingCsvUpload != true && this.processingXlsxUpload != true){
                    this.notifMessage.push(ValidateField.isEmpty('Document Line', data));
                }
                if(this.document_config.document_type_settings.editorBehavior.radio != "L" && shouldRunPhysicalCountV2PostingValidations){
                    this.notifMessage.push(ValidateField.isDuplicate('Document Line', data))
                }
                if(validatePhysicalCountV2Posting){
                    this.notifMessage.push(...this.duplicateLotCodeExpiryMessagesForPhysicalCountV2(data))
                }
                // Validate Release and Receive Documents
                if(shouldRunPhysicalCountV2PostingValidations && (/^RE(C|L)/.test(this.currentDocumentTypeCode) || ['OTHPCN'].includes(this.currentDocumentTypeCode)) ){
                    //Validate serial numbers matching the quantity
                    let serial_products = []
                    serial_products = data.filter(row => row.product_type === 'S')
                    if(serial_products.length > 0 && this.documentNumber > 0) {
                        serial_products.forEach(row => {
                            let serials = this.serialRows(row.document_line_serials).filter(serial => serial.status !== "D")
                            this.notifMessage.push(ValidateField.matchData('Quantity', row.quantity, serials.length, `Insufficient Serial Number provided for product in line number: ${row.line_no}. It must match quantity`));
                        })
                    } 
                    var data = this.tabulator.getData()
                    let require_lotcode_products = []
                    // Only do the checks when child document has been created separately //
                    if (this.existingDocumentTypeId == this.currentDocumentTypeId){
                        require_lotcode_products = data.filter(row => (row.is_require_lotcode != undefined && row.is_require_lotcode === true))
                        if(require_lotcode_products.length > 0) {
                            require_lotcode_products.forEach(row => {
                                if(row.document_line_locations == undefined){
                                    row.document_line_locations = []
                                }
                                var contentqty = ((row.product_type == 'P' && this.currentDocumentTypeCode.includes('REL')) ? row.content_quantity : 1)
                                var lineqty = (row.document_line_locations.length > 0) ? row.document_line_locations.map(lineloc => lineloc.quantity).reduce((sumqty, qty) => Number(qty) + Number(sumqty)) : 0;
                                this.notifMessage.push(ValidateField.matchData('Quantity', (row.quantity * contentqty), lineqty, `Insufficient Lot Codes provided for product in line number: ${row.line_no}. It must match quantity`));
                            })
                        }
                    }
                }

                // Site Allocation
                if(['OTHTRA'].includes(this.currentDocumentTypeCode)){
                    // Check lines and allocation //
                    let for_checking = []
                    for_checking = data.filter(row => (row.site_allocation != undefined && row.site_allocation.length > 0))
                    //console.log(">>>>>for_checking>>>>>")
                    //console.log(for_checking)
                    if(for_checking.length > 0) {
                         for_checking.forEach(row => {
                            var siteAllocQty =  row.site_allocation.map(siteAllocation => siteAllocation.quantity).reduce((sumqty, qty) => Number(qty) + Number(sumqty))
                            // console.log(">>>>>siteAllocQty>>>>>")
                            // console.log(siteAllocQty)
                            this.notifMessage.push(ValidateField.matchData('Quantity', parseInt(row.quantity), parseInt(siteAllocQty), `Site Allocation does not match expected quantity for product: ${row.product_name}.`));
                         })
                    } 
                }

                // Do not allow negative quantity
                var negative_qty = data.find(row => row.quantity < 0)
                if (negative_qty != undefined){
                    this.notifMessage.push("Invalid quantity is not allowed in the document line");
                }

                if (this.currentDocumentTypeCode == 'RECDEL') {
                    var negative_discount = data.find(row => {
                        if (row.discount === null || row.discount === undefined || row.discount === '') return false;
                        var discount = Number(row.discount);
                        return Number.isFinite(discount) && discount < 0;
                    });
                    if (negative_discount != undefined) {
                        this.notifMessage.push("Negative discount is not allowed in the receiving report line");
                    }
                }


                this.notifMessage = this._.compact(this.notifMessage);
                return this.notifMessage.length;
            },

            // RCG-1 (TC-PCV2-FRM-007 / FRM-009 / FRM-003 / IMP-024): normalize the
            // Physical Count V2 quantity fields in the persist payload so a cleared
            // field (""), a thousands-separated value ("1,000") or an accidental
            // NaN never reaches the backend's numericality validation and surfaces
            // as the generic "Document Line: actual quantity is not a number" toast.
            // Scoped strictly to PCN v2 lines so no other document type is affected.
            // Pure logic lives in utils/physicalCountV2Quantity.js (unit tested).
            normalizePhysicalCountV2Lines(lines) {
                if (!this.isPhysicalCountV2Document) return lines;
                return normalizePcv2Lines(lines);
            },

            // CNC-002: the generic dirty check compares the WHOLE enriched grid row
            // (component_x.origData === JSON.stringify(tabulator.getData())) against
            // origData captured from the raw server fetch. The grid adds computed
            // columns (total_gross, price_php, cost_php, design/color "" vs null,
            // product_status, ...) that never exist in origData, so isEditing was
            // ALWAYS true for a Physical Count V2 document — freezing was blocked
            // with "You have unsaved changes" even on an untouched, freshly loaded
            // document (and both users in a concurrent freeze were stuck). Compare
            // only the fields a user can actually edit on a PCN v2 line.
            isPhysicalCountV2GridDirty() {
                let orig = [];
                try { orig = JSON.parse(component_x.origData || '[]'); } catch (e) { orig = []; }
                return pcv2LinesDirty(orig, this.tabulator.getData());
            },

            async save(){
                // Physical Count V2: a PCount document must not be created/saved
                // with zero items. Guard the actual Save action (not just the
                // disabled button) so it cannot be triggered through another path.
                //
                // IMP-005: a CSV import into an empty PCount funnels through this
                // same save() (deferred-creation flow), but the imported rows are
                // carried in the `csv_lines` upload payload — they are NOT yet in
                // the grid. In that case the grid is legitimately empty, so the
                // "add at least one item" guard must NOT fire. Only block a manual
                // Save of a genuinely empty document (no grid rows AND no pending
                // CSV upload).
                if (this.isPhysicalCountV2Document) {
                    // IMP-005: detect an in-progress CSV import through several
                    // independent signals so the empty-grid guard never blocks a
                    // valid import regardless of importer type (Local vs S3) or the
                    // order in which the upload flags are set:
                    //   - processingCsvUpload / isUploaded : set by processCsvMassAdd
                    //   - documentStatus === 'Uploading'   : set by importFile()
                    //   - a file is staged in the uploader  : fileList has an entry
                    //   - csv_lines payload already built    : CsvUploadParams.csv_lines
                    var isCsvImportInProgress =
                        this.processingCsvUpload === true ||
                        this.isUploaded === true ||
                        this.processingXlsxUpload === true ||
                        this.documentStatus === 'Uploading' ||
                        (Array.isArray(this.fileList) && this.fileList.length > 0) ||
                        (this.CsvUploadParams && this.CsvUploadParams.csv_lines);
                    var pcountLines = this.tabulator ? this.tabulator.getData() : [];
                    if (pcv2EmptySaveBlocked(pcountLines, isCsvImportInProgress)) {
                        this.spinning = false;
                        this.$notification['error']({
                            message: 'Physical Count',
                            description: 'Please add at least one item before saving the PCount document.'
                        });
                        return;
                    }
                }
                this.documentFormDebugWarn('[DocumentForm] save clicked', {
                    documentNumber: this.documentNumber,
                    documentStatus: this.documentStatus,
                    currentDocumentTypeCode: this.currentDocumentTypeCode,
                    spinning: this.spinning,
                    grossAmountDisplay: this.grossAmountDisplay,
                    grossAmount: this.grossAmount,
                    selectedDocumentLinesCount: Array.isArray(this.selectedDocumentLines) ? this.selectedDocumentLines.length : null,
                    stack: new Error().stack
                })
                if(['OTHSBI'].includes(this.currentDocumentTypeCode) && this.continueWithPriceDiscrepancy == false) {
                    var data = this.tabulator.getData();
                    var notEqual = data.find(row => Number(row.price) != Number(row.price_pi))
                    if (notEqual != undefined){
                        this.$confirm({
                        title: 'Proceed?',
                        content: h => <div>There are lines where Cost and PI Price is not equal</div>,
                        onOk: () => {
                            this.continueWithPriceDiscrepancy = true
                            this.save()
                        },
                        onCancel() {}
                        });
                    }else {
                        this.continueWithPriceDiscrepancy = true
                        this.save()
                    }
                } else {
                    this.isChangeAction = true;
                    window.scrollTo(0,0);
                    this.spinning = true;
                    var saveValidationErrorsCount = this.validateForm();
                    this.documentFormDebugWarn('[DocumentForm] save validation result', {
                        documentNumber: this.documentNumber,
                        currentDocumentTypeCode: this.currentDocumentTypeCode,
                        validationErrorsCount: saveValidationErrorsCount,
                        notifMessage: this.notifMessage,
                        grossAmountDisplay: this.grossAmountDisplay,
                        grossAmount: this.grossAmount
                    })
                    if(!saveValidationErrorsCount) {
                        var hasSaveSourceSite = this.ensureSourceSiteId('save', { stopSpinner: true });
                        this.documentFormDebugWarn('[DocumentForm] save source-site guard result', {
                            documentNumber: this.documentNumber,
                            currentDocumentTypeCode: this.currentDocumentTypeCode,
                            hasSourceSite: hasSaveSourceSite,
                            grossAmountDisplay: this.grossAmountDisplay,
                            grossAmount: this.grossAmount
                        })
                        if (!hasSaveSourceSite) {
                            return;
                        }
                        this.logSummaryAmountsForSubmit('save')
                        // this.calculateSummary();

                        //To get document type and trans code
                        var document_type_code = '';
                        var document_trans_code = '';
                        var document_party_type = '';
                        var document_type_trans_code = await HTTPRequest.getRequest(component_x.endPoint + "document_types?table_prefix=inventory&id="+this.currentDocumentTypeId, null);
                        if (document_type_trans_code.find(x => x.id === this.currentDocumentTypeId)) {
                            document_type_code = document_type_trans_code.find(x => x.id === this.currentDocumentTypeId).type_code
                            document_trans_code = document_type_trans_code.find(x => x.id === this.currentDocumentTypeId).trans_code
                            document_party_type = document_type_trans_code.find(x => x.id === this.currentDocumentTypeId).party_type
                        }

                        if(this.processingCsvUpload || this.isUploaded ){
                            this.isUploaded = true
                        }

                        var party_id = -1
                        if ((document_trans_code == 'REL' && document_type_code == 'TRX') || (document_trans_code == 'REL' && document_type_code == 'CSX') || (document_trans_code == 'REC' && document_type_code == 'ADJ') || (document_trans_code == 'REL' && document_type_code == 'ADJ')){
                             // Save the current_site.id info in party_id
                             party_id = this.requestingSite.key
                        }
                        else if ((document_trans_code == 'ORI' && document_type_code == 'TRQ') || (document_trans_code == 'ORI' && document_type_code == 'CSQ' )){
                            party_id = this.supplyingSite.key
                        }

                        var site_id = secureStorage.getItem("defaultSiteId");
                        if ((document_trans_code == 'REC' && document_type_code == 'SLI')  || (document_trans_code == 'REL' && document_type_code == 'SLO') || (document_trans_code == 'ORI' && document_type_code == 'SOX') || (document_trans_code == 'REL' && document_type_code == 'DDE' || (document_trans_code == 'OTH' && document_type_code == 'SIN') || (document_trans_code == 'REC' && document_type_code == 'CSR'))){
                            site_id = this.distributionSite.key
                        }
                        if ((document_trans_code == 'REL' && document_type_code == 'TRX') || (document_trans_code == 'REL' && document_type_code == 'CSX') || (document_trans_code == 'ORO' && document_type_code == 'TRQ' ) || (document_trans_code == 'ORO' && document_type_code == 'CSQ' ) || (document_trans_code == 'OTH' && document_type_code == 'TRX' )){
                            site_id = this.supplyingSite.key
                        }

                        if ((document_trans_code == 'REC' && document_type_code == 'TRX') || (document_trans_code == 'REC' && document_type_code == 'CSX') || (document_trans_code == 'ORI' && document_type_code == 'TRQ' ) || (document_trans_code == 'ORI' && document_type_code == 'CSQ' ) || (document_trans_code == 'ORI' && document_type_code == 'POX')){
                            if(document_party_type == "Supplier"){
                                // Save the supplier info in party_id
                                party_id = this.supplier.key
                            
                                // Save the supplier info in party_name
                                this.party =  this.supplier.label
                            }
                           
                           site_id = this.requestingSite.key
                        }
                        if ((document_trans_code == 'OTH' && document_type_code == 'PWS')){
                            site_id = this.forThisSite.key
                        }

                        var origin_document_id = -1
                        if (this.originDocumentNumber > 0) {
                            origin_document_id = this.originDocumentNumber
                        }

                        var order_status = 'U'
                        if((document_trans_code == 'REL' && document_type_code == 'DDE') || (document_trans_code == 'REC' && document_type_code == 'CSR')){
                            origin_document_id = this.$route.params.sales_order_id
                            order_status = 'O'
                        } else if(document_trans_code == 'OTH' && document_type_code == 'SIN'){
                            origin_document_id = this.$route.params.delivery_document_id
                            order_status = 'G'
                        } else if(document_trans_code == 'OTH' && document_type_code == 'SBI'){
                            origin_document_id = this.$route.params.receiving_report_id
                        } else if(document_trans_code == 'OTH' && document_type_code == 'TRA'){
                            origin_document_id = this.$route.params.transfer_allocation_id || -1
                        } else if(document_trans_code == 'OTH' && document_type_code == 'BAR'){
                            origin_document_id = this.$route.params.barcode_printing_id
                        }else if(document_trans_code == 'ORO' && document_type_code == 'RSO'){
                            origin_document_id = this.$route.params.sales_order_id
                            if(this.documentExtras!= null){
                                this.documentExtras['revenue'] = this.revenue
                            }else{
                                this.documentExtras = {revenue:this.revenue}
                            }
                        }

                        var data = this.tabulator.getData();
                        if (this.document_config) {
                            if (this.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.automaticPostingOnSave == true) {
                                data.forEach(row => {row.goods_issue_quantity = row.delivery_quantity;});
                            }
                        }


                        var line_type = 'document_lines'
                        if ((document_trans_code == 'OTH' && document_type_code == 'PWS')){
                            line_type = 'pricecost_lines'
                        }else if((document_trans_code == 'OTH' && document_type_code == 'CNS')){
                            line_type = 'countset_lines'
                        }

                        // if ((document_trans_code == 'REC' && document_type_code == 'DEL')){
                        //     this.documentDate = moment(new Date())
                        // }

                        // Physical Count V2: tag NEW documents so the backend
                        // and the V2 hub list recognise them as V2 records. In
                        // the deferred-creation flow the document is created via
                        // this generic save(), so the tag (previously set by the
                        // backend blank/auto_populate) must be added here.
                        if (this.isPhysicalCountV2Document && this.documentNumber == 0) {
                            if (this.documentExtras == null || typeof this.documentExtras !== 'object') {
                                this.documentExtras = {}
                            }
                            this.documentExtras['physical_count_version'] = 'v2'
                        }

                        var documentPayload = {
                            document: {
                                site_id: site_id,
                                document_type_id: this.currentDocumentTypeId,
                                document_type_code: document_type_code,
                                document_trans_code: document_trans_code,
                                document_date : this.documentDate,
                                party_id: party_id,
                                target_date : this.targetDate,
                                cancellation_date : this.cancellationDate,
                                discount_text : this.headerDiscount.join(),
                                remark : this.remark,
                                source_site_id : this.supplyingSite.key,
                                target_site_id : this.requestingSite.key,
                                reference_1 :  this.reference,
                                payment_term_id : this.paymentTerm.key,
                                document_no: 0, //TEST ONLY,
                                [line_type]: this.normalizePhysicalCountV2Lines(data),
                                document_charges: this.chargeData,
                                shipping_method_id : this.shippingMethod.key,
                                support_discount_text: this.supportDiscount.join(),
                                amount_gross: this.grossAmount,
                                amount_header_discount: this.overallDiscount,
                                amount_net: this.netAmount,
                                tax_amount: this.vatAmount,
                                tax_exempt_amount: this.netAmountWithoutTax,
                                tax_rate: this.taxRate,
                                amount_line_discount: this.itemDiscount,
                                gross_amount_without_tax: this.grossAmountwithoutTax,
                                net_amount_without_tax: this.netAmountWithoutTax,
                                party_name: this.party,
                                purpose_id : this.purpose.key,
                                supplier_id: this.supplier.key,
                                origin_sublocation_id: this.originSublocation.key,
                                target_sublocation_id: this.destinationSublocation.key,
                                customer_id: this.customer.key,
                                salesman_id: this.salesman.key,
                                salesman_name: this.salesman.label,
                                origin_document_id: origin_document_id,
                                order_status: order_status,
                                order_source: this.orderSource,
                                total_quantity: this.totalQuantity,
                                is_header_only: this.isHeaderOnly,
                                is_trade: this.isDocumentTrade,
                                currency_id: this.currency.key,
                                sublocation_id: this.siteSublocation.key,
                                extras:this.documentExtras,
                                revenue_site_id:this.revenueSiteId,
                                supplier_currency_rate:this.supplierCurrencyRate,
                                supplier_currency_id:this.supplierCurrencyId,
                                party_tax_type: this.party_tax_type,
                                is_uploaded: this.isUploaded
                            }
                        }

                        documentPayload.document.currency_rate = this.currencyRate!=undefined && this.currencyRate!=0 ? this.currencyRate : (this.defaultCurrencyRate!=undefined && this.defaultCurrencyRate!=0) ?this.defaultCurrencyRate : this.currencyRate
                        try {
                            if(this.documentDetails.address_id!=undefined){
                                documentPayload.document.address_id = this.documentDetails.address_id
                            } 
                        } catch (error) {}

                        // Process references
                        var documentReferences = this.document_config.document_type_settings.references;
                        for(var i=0; i < documentReferences.length; i++){
                            var reference = documentReferences[i]
                            if(_.isUndefined(reference.input)){
                                //console.log("skip")
                            }else{
                                documentPayload.document["reference_" + (i + 1).toString()] = reference.input
                            }
                        }

                        //console.log("===============");
                        //console.log(documentPayload);
                        var post_request = await HTTPRequest.postRequest(this.endPoint + 'documents', null, documentPayload)
                        console.log(">>>>>>>")
                        console.log("post_request", post_request);
                        if (post_request == undefined) {
                                if (this.processingCsvUpload == true) {
                                    let url = `${this.endPoint}document_lines/mass_add_products?document_id=${post_request.id}`;
                                    if (document_trans_code == 'OTH' && document_type_code == 'PWS') {
                                        url = `${this.endPoint}pricecost_lines/import_pricecost_lines?document_id=${post_request.id}&save_via=${this.saveMassUploadProductVia}`;
                                    }

                                    var job = await HTTPRequest.postRequest(url, null, this.CsvUploadParams, undefined, "1");
                                    console.log("this.importerType", this.importerType)
                                    if (job.id > 1 && this.importerType == 0) {
                                        component_x.$notification['success']({
                                            message: 'Successful Operation',
                                            description: "CSV File has been uploaded. Your importation is ongoing, you can check the ongoing jobs for updates.",
                                            style: getNotificationStyle('success'),
                                            btn: h => {
                                                return h(
                                                'base-button',
                                                {
                                                    props: {
                                                    type: 'primary',
                                                    class: 'btn-sm',
                                                    },
                                                    on: {
                                                    click: () => component_x.$router.push("/jobs"),
                                                    },
                                                },
                                                'View Jobs',
                                                );
                                            },
                                        });
                                        this.$router.replace(this.backLink)
                                    } else if (job.id > 1 && this.importerType == 1){

                                        const uploadingFile = this.fileList[0];
                                        console.log("uploadingFile", uploadingFile)
                                        const myRenamedFile = new File([uploadingFile], job.s3_filename);
                                        const fileResponse = await uploadToS3BackgroundProcess(myRenamedFile, 'documents');
                                        component_x.$notification['success']({
                                            message: 'Successful Operation',
                                            description: "CSV File has been uploaded. Your [S3] importation is ongoing...",
                                            style: getNotificationStyle('success'),
                                            btn: h => {
                                                return h(
                                                'base-button',
                                                {
                                                    props: {
                                                    type: 'primary',
                                                    class: 'btn-sm',
                                                    },
                                                    on: {
                                                    click: () => component_x.$router.push("/jobs"),
                                                    },
                                                },
                                                'View Jobs',
                                                );
                                            },
                                        });
                                        this.$router.replace(this.backLink)
                                    }else {
                                        this.documentActionNotification('CSV Upload', 'error');
                                    }
                                } else if (this.processingXlsxUpload == true){
                                    let url = `${this.endPoint}document_lines/mass_add_products_with_allocation?document_id=${post_request.id}`;
                                    var job = await HTTPRequest.postRequest(url, null, this.xlsxUploadFormData, undefined, "1");
                                    if (job.id > 1) {
                                        component_x.$notification['success']({
                                            message: 'Successful Operation',
                                            description: "XLSX File has been uploaded. Your importation is ongoing, you can check the ongoing jobs for updates.",
                                            style: getNotificationStyle('success'),
                                            btn: h => {
                                                return h(
                                                'base-button',
                                                {
                                                    props: {
                                                    type: 'primary',
                                                    class: 'btn-sm',
                                                    },
                                                    on: {
                                                    click: () => component_x.$router.push("/jobs"),
                                                    },
                                                },
                                                'View Jobs',
                                                );
                                            },
                                        });
                                        this.$router.replace(this.backLink)
                                    } else {
                                        this.documentActionNotification('XLSX Upload', 'error');
                                    }
                                } else {
                                    this.documentNumber = post_request.id
                                    this.openDocument(post_request.id,component_x.existingDocumentTypeDetails)
                                    this.documentActionNotification('save', 'success')
                                }
                        } else {
                            console.log(">> POST REQUEST DEFINED")
                            if (post_request["error"] == undefined) {
                                console.log(">> POST REQUEST DEFINED >> NO ERROR")
                                if((['ORISOX','RELDDE','OTHSIN'].includes(this.currentDocumentTypeCode)) && (this.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.automaticPostingOnSave == true && this.processingCsvUpload == false) && (post_request.id > 0)){
                                    console.log(">> POST REQUEST DEFINED >> NO ERROR >> POST")
                                    this.documentNumber = post_request.id
                                    this.post();
                                } else {
                                    //this.$router.replace('/documents')
                                    console.log(">> POST REQUEST DEFINED >> NO ERROR >> CREATE")
                                    if (this.processingCsvUpload == true) {
                                        console.log(">> POST REQUEST DEFINED >> NO ERROR >> CREATE >> processingCsvUpload (true)")
                                        let url = `${this.endPoint}document_lines/mass_add_products?document_id=${post_request.id}`;
                                        if (document_trans_code == 'OTH' && document_type_code == 'PWS') {
                                            url = `${this.endPoint}pricecost_lines/import_pricecost_lines?document_id=${post_request.id}&save_via=${this.saveMassUploadProductVia}`;
                                        }

                                        var job = await HTTPRequest.postRequest(url, null, this.CsvUploadParams, undefined, "1");
                                        if (job.id > 1 && this.importerType == 0) {
                                            console.log(">> POST REQUEST DEFINED >> NO ERROR >> CREATE >> processingCsvUpload (true) >> with job id & local")
                                            component_x.$notification['success']({
                                                message: 'Successful Operation',
                                                description: "CSV File has been uploaded. Your importation is ongoing, you can check the ongoing jobs for updates.",
                                                style: getNotificationStyle('success'),
                                                btn: h => {
                                                    return h(
                                                    'base-button',
                                                    {
                                                        props: {
                                                        type: 'primary',
                                                        class: 'btn-sm',
                                                        },
                                                        on: {
                                                        click: () => component_x.$router.push("/jobs"),
                                                        },
                                                    },
                                                    'View Jobs',
                                                    );
                                                },
                                            });
                                        this.$router.replace(this.backLink)
                                        } else if (job.id > 1 && this.importerType == 1){
                                        console.log(">> POST REQUEST DEFINED >> NO ERROR >> CREATE >> processingCsvUpload (true) >> with job id & S3")
                                        const uploadingFile = this.fileList[0];
                                        console.log("uploadingFile", uploadingFile)
                                        const myRenamedFile = new File([uploadingFile], job.s3_filename);
                                        // const fileResponse = await uploadToS3(myRenamedFile, 'promotions');
                                        const fileResponse = await uploadToS3BackgroundProcess(myRenamedFile, 'documents');
                                        // const fileResponse = await uploadToS3BackgroundProcess(job.s3_filename, 'documents');
                                        component_x.$notification['success']({
                                            message: 'Successful Operation',
                                            description: "CSV File has been uploaded. Your [S3] importation is ongoing...",
                                            style: getNotificationStyle('success'),
                                            btn: h => {
                                                return h(
                                                'base-button',
                                                {
                                                    props: {
                                                    type: 'primary',
                                                    class: 'btn-sm',
                                                    },
                                                    on: {
                                                    click: () => component_x.$router.push("/jobs"),
                                                    },
                                                },
                                                'View Jobs',
                                                );
                                            },
                                        });
                                        this.$router.replace(this.backLink)
                                        }  else {
                                            console.log(">> POST REQUEST DEFINED >> NO ERROR >> CREATE >> processingCsvUpload (true) >> without job id")
                                            this.documentActionNotification('CSV Upload', 'error');
                                        }
                                    } else if (this.processingXlsxUpload == true){
                                        console.log(">> POST REQUEST DEFINED >> NO ERROR >> CREATE >> processingXlsxUpload (true)")
                                        let url = `${this.endPoint}document_lines/mass_add_products_with_allocation?document_id=${post_request.id}`;
                                        var job = await HTTPRequest.postRequest(url, null, this.xlsxUploadFormData, undefined, "1");
                                        if (job.id > 1) {
                                            component_x.$notification['success']({
                                                message: 'Successful Operation',
                                                description: "XLSX File has been uploaded. Your importation is ongoing, you can check the ongoing jobs for updates.",
                                                style: getNotificationStyle('success'),
                                                btn: h => {
                                                    return h(
                                                    'base-button',
                                                    {
                                                        props: {
                                                        type: 'primary',
                                                        class: 'btn-sm',
                                                        },
                                                        on: {
                                                        click: () => component_x.$router.push("/jobs"),
                                                        },
                                                    },
                                                    'View Jobs',
                                                    );
                                                },
                                            });
                                            this.$router.replace(this.backLink)
                                        } else {
                                            this.documentActionNotification('XLSX Upload', 'error');
                                        }
                                    } else {
                                        console.log(">> POST REQUEST DEFINED >> NO ERROR >> CREATE >> CREATED")
                                        this.documentNumber = post_request.id
                                        // this.$emit('refreshPage', event)
                                        this.openDocument(post_request.id,component_x.existingDocumentTypeDetails)
                                        // this.checkCustomizedFields(this.currentDocumentTypeCode)
                                        this.documentActionNotification('save', 'success')
                                    }
                                }
                            } else {
                                console.log(">> POST REQUEST DEFINED >> WITH ERROR")
                                this.notifMessage = post_request["error"].split(",")
                                this.documentActionNotification('save', 'error')
                            }
                        }
                    } else {
                        this.documentActionNotification('save', 'error')
                    }
                    this.spinning = false;
                }
            },
            async update() {
                // Guard: block updating until the document has fully loaded, and
                // prevent overlapping/rapid updates that can persist blank lines.
                // Re-entrant calls from confirm dialogs set continueWithPriceDiscrepancy
                // and are allowed to pass through.
                if (['RELTRX', 'RECTRX'].includes(this.currentDocumentTypeCode) && this.continueWithPriceDiscrepancy == false) {
                    if (!this.mountedAlreadyRendered) {
                        this.$notification['warning']({
                            message: 'Please wait',
                            description: 'The document is still loading. Please try again once it is fully loaded.'
                        });
                        return;
                    }
                    if (this.isUpdating || this.isUpdateDisabled) {
                        // An update is already in progress; ignore the extra trigger.
                        return;
                    }
                    this.isUpdating = true;
                    this.isUpdateDisabled = true;
                }
                if(['OTHSBI'].includes(this.currentDocumentTypeCode) && this.continueWithPriceDiscrepancy == false) {
                    var data = this.tabulator.getData();
                    var notEqual = data.find(row => Number(row.price) != Number(row.price_pi))
                    if (notEqual != undefined){
                        this.$confirm({
                        title: 'Proceed?',
                        content: h => <div>There are lines where Cost and PI Price is not equal</div>,
                        onOk: () => {
                            this.continueWithPriceDiscrepancy = true
                            this.update()
                        },
                        onCancel: () => {
                            // User cancelled; release the in-flight update guard.
                            this.isUpdating = false;
                            this.isUpdateDisabled = false;
                        }
                        });
                    }else {
                        this.continueWithPriceDiscrepancy = true
                        this.update()
                    }
                } else {
                    this.isUpdateDisabled = true;
                    this.isChangeAction = true;
                    window.scrollTo(0,0);
                    this.spinning = true;
                    if(!this.validateForm()) {
                        if (!this.ensureSourceSiteId('update', { stopSpinner: true })) {
                            this.isUpdating = false;
                            this.isUpdateDisabled = false;
                            return;
                        }
                        if (this.orderSource=="shopify" || this.orderSource=="lazada" || this.orderSource=="shopee"|| this.orderSource=="zalora"){
                        }else{
                            this.calculateSummary();
                        }
                        this.logSummaryAmountsForSubmit('update')

                            //To get document type and trans code
                            var document_type_code = '';
                            var document_trans_code = '';
                            var document_party_type = '';
                            var document_type_trans_code = await HTTPRequest.getRequest(component_x.endPoint + "document_types?table_prefix=inventory&id="+this.currentDocumentTypeId, null);
                            if (document_type_trans_code.find(x => x.id === this.currentDocumentTypeId)) {
                                document_type_code = document_type_trans_code.find(x => x.id === this.currentDocumentTypeId).type_code
                                document_trans_code = document_type_trans_code.find(x => x.id === this.currentDocumentTypeId).trans_code
                                document_party_type = document_type_trans_code.find(x => x.id === this.currentDocumentTypeId).party_type
                            }

                            if(this.processingCsvUpload){
                            let is_uploaded = this.processingCsvUpload
                            }

                            var party_id = -1
                            if ((document_trans_code == 'REL' && document_type_code == 'TRX') || (document_trans_code == 'REL' && document_type_code == 'CSX')){
                                party_id = this.requestingSite.key
                            }
                            else if ((document_trans_code == 'ORI' && document_type_code == 'TRQ') || (document_trans_code == 'ORI' && document_type_code == 'CSQ' )){
                                party_id = this.supplyingSite.key
                            }
                            var site_id = this.documentCurrentSite || secureStorage.getItem("defaultSiteId");
                            if ((document_trans_code == 'REC' && document_type_code == 'SLI')  || (document_trans_code == 'REL' && document_type_code == 'SLO') || (document_trans_code == 'ORI' && document_type_code == 'SOX') || (document_trans_code == 'REL' && document_type_code == 'DDE' || (document_trans_code == 'OTH' && document_type_code == 'SIN') || (document_trans_code == 'REC' && document_type_code == 'CSR'))){
                                site_id = this.distributionSite.key
                            }
                            if ((document_trans_code == 'REL' && document_type_code == 'TRX') || (document_trans_code == 'REL' && document_type_code == 'CSX') ||  (document_trans_code == 'ORO' && document_type_code == 'TRQ' ) || (document_trans_code == 'ORO' && document_type_code == 'CSQ' ) || (document_trans_code == 'OTH' && document_type_code == 'TRX' )){
                                site_id = this.supplyingSite.key
                            }

                            if ((document_trans_code == 'REC' && document_type_code == 'TRX') || (document_trans_code == 'REC' && document_type_code == 'CSX') || (document_trans_code == 'ORI' && document_type_code == 'TRQ' ) || (document_trans_code == 'ORI' && document_type_code == 'CSQ' ) || (document_trans_code == 'ORI' && document_type_code == 'POX')){
                            
                                if(document_party_type == "Supplier"){
                                    // Save the supplier info in party_id
                                    party_id = this.supplier.key
                                
                                    // Save the supplier info in party_name
                                    this.party =  this.supplier.label
                                }
                            
                            site_id = this.requestingSite.key
                            }
                            
                            if ((document_trans_code == 'OTH' && document_type_code == 'PWS') || (document_trans_code == 'ORO' && document_type_code == 'RSO')){
                                site_id = this.forThisSite.key
                            }

                            var origin_document_id = -1
                            if (this.originDocumentNumber > 0) {
                                origin_document_id =  this.originDocumentNumber
                            }
                            var order_status = 'U'
                            if((document_trans_code == 'REL' && document_type_code == 'DDE') || (document_trans_code == 'OTH' && document_type_code == 'SIN') || (document_trans_code == 'REC' && document_type_code == 'CSR')){
                                origin_document_id = this.$route.params.sales_order_id
                                order_status = 'O'
                            } else if(document_trans_code == 'OTH' && document_type_code == 'SIN'){
                                origin_document_id = this.$route.params.delivery_document_id
                                order_status = 'G'
                            } else if(document_trans_code == 'OTH' && document_type_code == 'SBI'){
                                origin_document_id = this.$route.params.receiving_report_id
                            } else if(document_trans_code == 'OTH' && document_type_code == 'TRA'){
                                origin_document_id = this.$route.params.transfer_allocation_id
                            } else if(document_trans_code == 'ORO' && document_type_code == 'RSO'){
                                origin_document_id = this.$route.params.sales_order_id
                                if(this.documentExtras!= null){
                                    this.documentExtras['revenue'] = this.revenue
                                }else{
                                    this.documentExtras = {revenue:this.revenue}
                                }
                            }

                            var line_type = 'document_lines'
                            if ((document_trans_code == 'OTH' && document_type_code == 'PWS')){
                                line_type = 'pricecost_lines'
                            }else if((document_trans_code == 'OTH' && document_type_code == 'CNS')){
                                line_type = 'countset_lines'
                            }
                            this.updateValueOfSupplierCurrency();

                        var data = this.tabulator.getData();


                        if (!(await this.confirmOthPcnDuplicatesBeforePersist())) {
                            this.isUpdating = false;
                            this.isUpdateDisabled = false;
                            return;
                        }

                        var documentPayload = {
                            document: {
                                site_id: site_id,
                                document_type_id: this.currentDocumentTypeId,
                                document_type_code: document_type_code,
                                document_trans_code: document_trans_code,
                                document_date : this.documentDate,
                                party_id: party_id,
                                target_date : this.targetDate,
                                cancellation_date : this.cancellationDate,
                                discount_text : this.headerDiscount.join(),
                                remark : this.remark,
                                source_site_id : this.supplyingSite.key,
                                target_site_id : this.requestingSite.key,
                                reference_1 :  this.reference,
                                payment_term_id : this.paymentTerm.key,
                                [line_type]: this.normalizePhysicalCountV2Lines(data),
                                document_charges: this.chargeData,
                                shipping_method_id : this.shippingMethod.key,
                                support_discount_text: this.supportDiscount.join(),
                                amount_gross: this.grossAmount,
                                amount_header_discount: this.overallDiscount,
                                amount_net: this.netAmount,
                                tax_amount: this.vatAmount,
                                tax_exempt_amount: this.netAmountWithoutTax,
                                tax_rate: this.taxRate,
                                amount_line_discount: this.itemDiscount,
                                gross_amount_without_tax: this.grossAmountwithoutTax,
                                net_amount_without_tax: this.netAmountWithoutTax,
                                party_name: this.party,
                                purpose_id : this.purpose.key,
                                supplier_id: this.supplier.key,
                                origin_sublocation_id: this.originSublocation.key,
                                target_sublocation_id: this.destinationSublocation.key,
                                customer_id: this.customer.key,
                                salesman_id: this.salesman.key,
                                salesman_name: this.salesman.label,
                                origin_document_id: origin_document_id,
                                order_status: order_status,
                                order_source: this.orderSource,
                                total_quantity: this.totalQuantity,
                                is_header_only: this.isHeaderOnly,
                                is_trade: this.isDocumentTrade,
                                currency_id: this.currency.key,
                                sublocation_id: this.siteSublocation.key,
                                extras:this.documentExtras,
                                revenue_site_id:this.revenueSiteId,
                                supplier_currency_rate:this.supplierCurrencyRate,
                                supplier_currency_id:this.supplierCurrencyId,
                                party_tax_type: this.party_tax_type,
                                is_uploaded: this.isUploaded
                            }
                        }

                            // if(parseInt(this.currency.key)>0){
                            //   documentPayload.document.currency_rate = this.currencyRate
                            // }
                            // Change setting of currency_rate process
                            // Update by Maron Justo
                            documentPayload.document.currency_rate = (this.currencyRate!=undefined && this.currencyRate!=0) ? this.currencyRate : (this.defaultCurrencyRate!=undefined && this.defaultCurrencyRate!=0) ? this.defaultCurrencyRate : this.currencyRate

                            // Process references
                            // Commented out this line to enable reference on documents to be updated
                            // Update by Bryan Alcaide
                            // Start
                            // var documentReferences = this.document_config.document_type_settings.references;
                            // for(var i=0; i < documentReferences.length; i++){
                            //     var reference = documentReferences[i]
                            //     if(_.isUndefined(reference.input)){
                            //         //console.log("skip")
                            //     }else{
                            //         documentPayload.document["reference_" + (i + 1).toString()] = reference.input
                            //     }
                            // }
                            // End

                            //console.log("===============");
                            //console.log(documentPayload);

                            var updateRequestSummary = {
                                amount_gross: documentPayload.document.amount_gross,
                                amount_net: documentPayload.document.amount_net,
                                tax_amount: documentPayload.document.tax_amount,
                                tax_exempt_amount: documentPayload.document.tax_exempt_amount,
                                gross_amount_without_tax: documentPayload.document.gross_amount_without_tax,
                                net_amount_without_tax: documentPayload.document.net_amount_without_tax
                            }
                            this.documentFormDebugWarn('[DocumentForm] update request before PUT', {
                                documentNumber: this.documentNumber,
                                currentDocumentTypeCode: this.currentDocumentTypeCode,
                                endpoint: this.endPoint + 'documents/'+this.documentNumber,
                                rowCount: Array.isArray(data) ? data.length : null,
                                grossAmountDisplay: this.grossAmountDisplay,
                                grossAmount: this.grossAmount,
                                requestSummary: updateRequestSummary
                            })
                            var put_request = await HTTPRequest.putRequest(this.endPoint + 'documents/'+this.documentNumber, null, documentPayload)
                            this.documentFormDebugWarn('[DocumentForm] update response after PUT', {
                                documentNumber: this.documentNumber,
                                currentDocumentTypeCode: this.currentDocumentTypeCode,
                                requestSummary: updateRequestSummary,
                                put_request
                            })
                            if(put_request == undefined){
                                    if (this.processingCsvUpload == true) {
                                        let url = `${this.endPoint}document_lines/mass_add_products?document_id=${this.documentNumber}`;
                                        if (document_trans_code == 'OTH' && document_type_code == 'PWS') {
                                            url = `${this.endPoint}pricecost_lines/import_pricecost_lines?document_id=${this.documentNumber}&save_via=${this.saveMassUploadProductVia}`;
                                        }

                                        var job = await HTTPRequest.postRequest(url, null, this.CsvUploadParams, undefined, "1");
                                        if (job.id > 1 && this.importerType == 0) {
                                            component_x.$notification['success']({
                                                message: 'Successful Operation',
                                                description: "CSV File has been uploaded. Your importation is ongoing, you can check the ongoing jobs for updates.",
                                                style: getNotificationStyle('success'),
                                                btn: h => {
                                                    return h(
                                                    'base-button',
                                                    {
                                                        props: {
                                                        type: 'primary',
                                                        class: 'btn-sm',
                                                        },
                                                        on: {
                                                        click: () => component_x.$router.push("/jobs"),
                                                        },
                                                    },
                                                    'View Jobs',
                                                    );
                                                },
                                            });
                                            this.$router.replace(this.backLink)
                                        } else if (job.id > 1 && this.importerType == 1){

                                            const uploadingFile = this.fileList[0];
                                            console.log("uploadingFile", uploadingFile)
                                            const myRenamedFile = new File([uploadingFile], job.s3_filename);
                                            // const fileResponse = await uploadToS3(myRenamedFile, 'promotions');
                                            const fileResponse = await uploadToS3BackgroundProcess(myRenamedFile, 'documents');
                                            component_x.$notification['success']({
                                                message: 'Successful Operation',
                                                description: "CSV File has been uploaded. Your [S3] importation is ongoing...",
                                                style: getNotificationStyle('success'),
                                                btn: h => {
                                                    return h(
                                                    'base-button',
                                                    {
                                                        props: {
                                                        type: 'primary',
                                                        class: 'btn-sm',
                                                        },
                                                        on: {
                                                        click: () => component_x.$router.push("/jobs"),
                                                        },
                                                    },
                                                    'View Jobs',
                                                    );
                                                },
                                            });
                                            this.$router.replace(this.backLink)
                                        }else {
                                            this.isUpdateDisabled = false;
                                            this.spinning = false;
                                            this.documentActionNotification('CSV Upload', 'error');
                                        }
                                    } else if (this.processingXlsxUpload == true){
                                        let url = `${this.endPoint}document_lines/mass_add_products_with_allocation?document_id=${this.documentNumber}`;
                                        var job = await HTTPRequest.postRequest(url, null, this.xlsxUploadFormData, undefined, "1");
                                        if (job.id > 1) {
                                            component_x.$notification['success']({
                                                message: 'Successful Operation',
                                                description: "XLSX File has been uploaded. Your importation is ongoing, you can check the ongoing jobs for updates.",
                                                style: getNotificationStyle('success'),
                                                btn: h => {
                                                    return h(
                                                    'base-button',
                                                    {
                                                        props: {
                                                        type: 'primary',
                                                        class: 'btn-sm',
                                                        },
                                                        on: {
                                                        click: () => component_x.$router.push("/jobs"),
                                                        },
                                                    },
                                                    'View Jobs',
                                                    );
                                                },
                                            });
                                            this.$router.replace(this.backLink)
                                        } else {
                                            this.isUpdateDisabled = false;
                                            this.spinning = false;
                                            this.documentActionNotification('XLSX Upload', 'error');
                                        }
                                    } else {
                                        console.log("First")
                                        // this.$emit('refreshPage', event)
                                    
                                        await this.openDocument(this.documentNumber,this.existingDocumentTypeDetails)
                                        this.isUpdateDisabled = false;
                                        this.spinning = false;
                                        this.documentActionNotification('update', 'success')
                                    }
                            } else {
                                if(put_request["error"] == undefined){
                                    if (this.processingCsvUpload == true) {
                                        let url = `${this.endPoint}document_lines/mass_add_products?document_id=${this.documentNumber}`;
                                        if (document_trans_code == 'OTH' && document_type_code == 'PWS') {
                                            url = `${this.endPoint}pricecost_lines/import_pricecost_lines?document_id=${this.documentNumber}&save_via=${this.saveMassUploadProductVia}`;
                                        }

                                        var job = await HTTPRequest.postRequest(url, null, this.CsvUploadParams, undefined, "1");
                                        if (job.id > 1 && this.importerType == 0) {
                                            component_x.$notification['success']({
                                                message: 'Successful Operation',
                                                duration: 0,
                                                description: "CSV File has been uploaded. Your importation is ongoing, you can check the ongoing jobs for updates.",
                                                btn: h => {
                                                    return h(
                                                    'base-button',
                                                    {
                                                        props: {
                                                        type: 'primary',
                                                        class: 'btn-sm',
                                                        },
                                                        on: {
                                                        click: () => component_x.$router.push("/jobs"),
                                                        },
                                                    },
                                                    'View Jobs',
                                                    );
                                                },
                                            });
                                            this.$router.replace(this.backLink)
                                        } else if (job.id > 1 && this.importerType == 1){

                                            const uploadingFile = this.fileList[0];
                                            console.log("uploadingFile", uploadingFile)
                                            const myRenamedFile = new File([uploadingFile], job.s3_filename);
                                            // const fileResponse = await uploadToS3(myRenamedFile, 'promotions');
                                            const fileResponse = await uploadToS3BackgroundProcess(myRenamedFile, 'documents');
                                            component_x.$notification['success']({
                                                message: 'Successful Operation',
                                                description: "CSV File has been uploaded. Your [S3] importation is ongoing...",
                                                style: getNotificationStyle('success'),
                                                btn: h => {
                                                    return h(
                                                    'base-button',
                                                    {
                                                        props: {
                                                        type: 'primary',
                                                        class: 'btn-sm',
                                                        },
                                                        on: {
                                                        click: () => component_x.$router.push("/jobs"),
                                                        },
                                                    },
                                                    'View Jobs',
                                                    );
                                                },
                                            });
                                            this.$router.replace(this.backLink)
                                        }else {
                                            this.isUpdateDisabled = false;
                                            this.spinning = false;
                                            this.documentActionNotification('CSV Upload', 'error');
                                        }
                                    } else if (this.processingXlsxUpload == true){
                                        let url = `${this.endPoint}document_lines/mass_add_products_with_allocation?document_id=${this.documentNumber}`;
                                        var job = await HTTPRequest.postRequest(url, null, this.xlsxUploadFormData, undefined, "1");
                                        if (job.id > 1) {
                                            component_x.$notification['success']({
                                                message: 'Successful Operation',
                                                description: "XLSX File has been uploaded. Your importation is ongoing, you can check the ongoing jobs for updates.",
                                                style: getNotificationStyle('success'),
                                                btn: h => {
                                                    return h(
                                                    'base-button',
                                                    {
                                                        props: {
                                                        type: 'primary',
                                                        class: 'btn-sm',
                                                        },
                                                        on: {
                                                        click: () => component_x.$router.push("/jobs"),
                                                        },
                                                    },
                                                    'View Jobs',
                                                    );
                                                },
                                            });
                                            this.$router.replace(this.backLink)
                                        } else {
                                            this.isUpdateDisabled = false;
                                            this.spinning = false;
                                            this.documentActionNotification('XLSX Upload', 'error');
                                        }
                                    } else {
                                        console.log("Second")
                                        // this.$emit('refreshPage', event)
                                        await this.openDocument(this.documentNumber,this.existingDocumentTypeDetails)
                                        this.isUpdateDisabled = false;
                                        this.spinning = false;
                                        this.documentActionNotification('update', 'success')
                                    }
                                } else {
                                    this.notifMessage = put_request["error"].split(",");
                                    this.isUpdateDisabled = false;
                                    this.spinning = false;
                                    this.documentActionNotification('update', 'error')
                                }
                            }
                        } else {
                            this.isUpdateDisabled = false;
                            this.spinning = false;
                            this.documentActionNotification('update', 'error')
                        }
                    }
                // Release the in-flight update guard so the button can be used again.
                this.isUpdating = false;
                this.isUpdateDisabled = false;
            },
            async payLater(){
                 window.scrollTo(0,0);
                    this.spinning = true;
                    this.notifMessage = [];
                    var data = this.tabulator.getData();

                    if(["ORISOX"].includes(this.currentDocumentTypeCode)){
                        if(this.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.autoCreatePostDD){
                            this.autoPostDD = true;
                        }else if (this.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.autoCreatePostDDAndSI){
                            this.autoPostDDAndSI = true;
                        }
                    } 

                    //For RelDde Documents
                    if(['RELDDE'].includes(this.currentDocumentTypeCode)){
                        if (this.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.automaticPostingOnSave != true) {
                            //when goods issue
                            if (this.documentNumber > 0) {
                                var invalid = data.find(row => row.goods_issue_quantity == 0 && Number(row.ordered_quantity) > 0)
                                if (invalid != undefined){
                                    this.notifMessage.push("Zero goods issue quantity is not allowed in the document line");
                                    this.documentActionNotification('post', 'error');
                                    this.spinning = false;
                                    return;
                                }
                            }
                        }
                    }


                    if (data.length > 0) {
                        this.isEditing = !(component_x.origData === JSON.stringify(data))
                    }

                    if(this.documentStatus == "Confirmed" && this.isEditing){
                        this.isChangeAction = true;
                    }

                    if (this.isEditing && !this.isChangeAction) {
                        this.notifMessage.push("You have unsaved changes, please save before posting")
                        this.documentActionNotification('post', 'error');
                        this.spinning = false;
                        return;
                    } else {
                        if (component_x.documentNumber > 0) {
                            var params = (this.autoPostDD) ? "&auto_post_dd=true" : (this.autoPostDDAndSI) ? "&auto_post_dd_and_si=true" : ""
                            var post_request = await HTTPRequest.postRequest(this.endPoint + 'documents/post/?document_id='+component_x.documentNumber+''+params, null)
                            if (post_request['success']){
                                this.openDocument(this.documentNumber,this.existingDocumentTypeDetails)
                                // this.$emit('refreshPage', event)
                                this.documentActionNotification('post', 'success')
                                if (this.documentDetails.order_source=="shopee" && this.documentDetails.order_source=="shopify" && this.documentDetails.order_source=="lazada" && this.documentDetails.order_source=="zalora" && (this.autoPostDD || this.autoPostDDAndSI)){
                                    var message = (this.autoPostDD) ? "Auto posting of DD failed" : (this.autoPostDDAndSI) ? "Auto posting of DD, creation & posting of SI failed" : ""
                                    if (message !=""){
                                        this.$notification['warning']({
                                            message: message,
                                            description: "the setting is only applicable for manually created SO's."
                                        });
                                    }
                                } 
                            } else if (post_request['error']){
                                this.notifMessage = post_request['error'].split(',');
                                this.documentActionNotification('post', 'error')
                            }
                        }
                    }

                    this.spinning = false;
                    this.paymentDrawerVisible = false;
            },
            async post(type="normal"){
                if (!this.isPostDisabled && !this.spinning){
                    if (!this.canPostStiDestinationSite) {
                        this.rejectUnauthorizedStiPost();
                        return;
                    }

                    if(!this.validateForm({ validatePhysicalCountV2Posting: true })) {
                        // Show create buttons
                        this.createButtonMain = true 
                        this.spinning = true

                        // Disable post button immediately after pressing post button
                        this.isPostDisabled = true
                        this.postClickCount++
                        // Commented out debug logging (kept for future troubleshooting).
                        // console.log("Post button click count:", this.postClickCount)

                        if (!this.ensureSourceSiteId('post', { stopSpinner: true, resetPostState: true })) {
                            return;
                        }

                    
                        // Helper: make confirm awaitable
                        const confirmDialog = (options) => {
                            return new Promise((resolve, reject) => {
                                this.$confirm({
                                ...options,
                                onOk: () => resolve(true),
                                onCancel: () => reject(false),
                                });
                            });
                        };

                        // --- Cost vs Price Checking ---
                        const doc_type_checking = ["RELTRX","RECTRX", "ORIPOX"]
                        if (doc_type_checking.includes(this.currentDocumentTypeCode) && type == "normal") {
                            var data_x = this.tabulator.getData();
                            let cost_price_variance = data_x.filter((row) => row.cost != row.price);
                            if (cost_price_variance.length > 0) {
                                try {
                                    await confirmDialog({
                                        title: "Proceed?",
                                        content: (h) => (
                                        <div>
                                            There are lines where cost and price are different. Do you want
                                            to proceed?
                                        </div>
                                        ),
                                        okText: "Yes",
                                        cancelText: "No",
                                    });
                                } catch {
                                    this.isPostDisabled = false;
                                    this.postClickCount = 0;
                                return; // stop execution if cancelled
                                }
                            }
                        }

                        // --- Stock Request Cut-Off Time ---
                        // For stock request document types, enforce the configured cut-off
                        // time on posting. Requests posted before the cut-off proceed; after
                        // the cut-off, either warn the user or block posting per config.
                        var stockRequestDocTypes = ["OROTRQ", "ORITRQ"];
                        var aeb = (this.document_config && this.document_config.document_type_settings)
                            ? this.document_config.document_type_settings.additionalEditorBehavior
                            : null;
                        if (
                            stockRequestDocTypes.includes(this.currentDocumentTypeCode) &&
                            type == "normal" &&
                            aeb && aeb.enableStockRequestCutOff && aeb.stockRequestCutOffTime
                        ) {
                            var cutOff = moment(aeb.stockRequestCutOffTime, 'hh:mm A');
                            if (cutOff.isValid()) {
                                // Compare against "now" using today's date at the cut-off time.
                                var cutOffToday = moment().set({
                                    hour: cutOff.hour(),
                                    minute: cutOff.minute(),
                                    second: 0,
                                    millisecond: 0
                                });
                                if (moment().isAfter(cutOffToday)) {
                                    var cutOffLabel = cutOff.format('hh:mm A');
                                    if (aeb.stockRequestCutOffBehavior == 'disable') {
                                        // Block posting.
                                        this.$notification['error']({
                                            message: 'Cut-Off Time Reached',
                                            description: 'The stock request cut-off time (' + cutOffLabel + ') has been reached. Document posting is disabled.'
                                        });
                                        this.isPostDisabled = false;
                                        this.postClickCount = 0;
                                        this.spinning = false;
                                        this.createButtonMain = true;
                                        return;
                                    } else {
                                        // Warn only: let the user decide whether to proceed.
                                        try {
                                            await confirmDialog({
                                                title: 'Cut-Off Time Reached',
                                                content: () => (
                                                    <div>
                                                        The stock request cut-off time ({cutOffLabel}) has been reached.
                                                        Do you want to proceed with posting?
                                                    </div>
                                                ),
                                                okText: 'Yes',
                                                cancelText: 'No',
                                            });
                                        } catch {
                                            this.isPostDisabled = false;
                                            this.postClickCount = 0;
                                            this.spinning = false;
                                            this.createButtonMain = true;
                                            return; // stop execution if cancelled
                                        }
                                    }
                                }
                            }
                        }

                        // --- Zero qty validation ---
                        if (/^RE(C|L)/.test(this.currentDocumentTypeCode)) {
                            var data_x = this.tabulator.getData();
                            let zero_qty_lines = data_x.filter(
                                (row) => row.quantity !== undefined && row.quantity == 0
                            );

                            if (zero_qty_lines.length > 0) {
                                try {
                                    await confirmDialog({
                                        title: "Proceed?",
                                        content: (h) => (
                                        <div>
                                            Unable to post the document. There are lines with zero quantity.
                                            Do you want to automatically delete them?
                                        </div>
                                        ),
                                        okText: "Yes",
                                        cancelText: "No",
                                    });

                                    for (var i = 0; i < zero_qty_lines.length; i++) {
                                        var row_line_no = zero_qty_lines[i]["line_no"];
                                        this.delete_line(row_line_no);
                                    }
                                    this.update();
                                } catch {
                                    this.isPostDisabled = false;
                                    this.postClickCount = 0;
                                    return;
                                }
                            }
                        }
                    
                        // Check last document action
                        var doc_data = this.tabulator.getData()
                        var response = await HTTPRequest.getRequest(this.endPoint + 'document_action_histories?document_id='+ doc_data[0].document_id, null)
                        var last_action = ""
                        if (response[response.length - 1] != undefined){
                            last_action = response[response.length - 1].action
                        }

                        if(last_action == "ONGOING POSTING"){
                            this.documentStatus = 'ONGOING POSTING'
                            this.postClickCount++
                        } else if (last_action != "ONGOING POSTING" || last_action != "POSTED") {
                            this.postClickCount = 1
                        }

                        //Check Lot codes
                        if(/^RE(C|L)/.test(this.currentDocumentTypeCode) || ['OTHPCN'].includes(this.currentDocumentTypeCode) ){
                            this.notifMessage = [];
                            var data = this.tabulator.getData()
                            let require_lotcode_products = []
                            require_lotcode_products = data.filter(row => (row.is_require_lotcode != undefined && row.is_require_lotcode === true))
                            if(require_lotcode_products.length > 0) {
                                require_lotcode_products.forEach(row => {
                                    if(row.document_line_locations == undefined){
                                        row.document_line_locations = []
                                    }
                                    var contentqty = ((row.product_type == 'P' && this.currentDocumentTypeCode.includes('REL')) ? row.content_quantity : 1)
                                    var lineqty = (row.document_line_locations.length > 0) ? row.document_line_locations.map(lineloc => lineloc.quantity).reduce((sumqty, qty) => Number(qty) + Number(sumqty)) : 0;
                                    this.notifMessage.push(ValidateField.matchData('Quantity', (row.quantity * contentqty), lineqty, `Insufficient Lot Codes provided for product in line number: ${row.line_no}. It must match quantity`));
                                })
                            }
                            this.notifMessage = this._.compact(this.notifMessage);
                            if (this.notifMessage.length > 0) {
                                this.spinning = false;
                                this.documentActionNotification('post', 'error');
                                return;
                            }
                    
                            if(/^RE(C)/.test(this.currentDocumentTypeCode)){
                                //Validation for document setting to restrict posting of zero cost - 2895
                                var zeroCost = []
                                data.forEach(row => {
                                    if (Number(row.cost) == 0 || Number(row.cost) < 0)
                                        zeroCost.push(row.line_no)
                                })
                                if(zeroCost.length > 0 && this.document_config.document_type_settings.receivingDocument.strictPostingWithZeroCost){
                                    this.notifMessage.push(`Unable to proceed posting this document, line: ${zeroCost} have zero cost.`);
                                    this.spinning = false;
                                    this.documentActionNotification('post', 'error');
                                    return;
                                } else if(zeroCost.length > 0 && !this.document_config.document_type_settings.receivingDocument.strictPostingWithZeroCost && this.allowZeroCost == 0){
                                    this.$confirm({
                                        title: 'Proceed?',
                                        content: h => <div>Line: {zeroCost.toString()} have zero cost, this will affect your cost layer. Do you want to proceed?</div>,
                                        okText: 'Yes',
                                        onOk: () => {
                                            this.allowZeroCost = 1
                                            this.isPostDisabled = false
                                            this.spinning = false
                                            this.post()
                                        },
                                        onCancel() {
                                            component_x.isPostDisabled = false
                                            component_x.spinning = false
                                        }
                                    });
                                    return;
                                }
                            }

                        }

                        if (['ORISOX','RELDDE','OTHSIN'].includes(this.currentDocumentTypeCode) && (this.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.allowPaymentOnPosting || false == true) && this.forPaymentIsProcessed == false) {
                            this.forPaymentIsPosting = true;
                            this.showPaymentMethods();
                        }else if (['ORIPOX'].includes(this.currentDocumentTypeCode) && (this.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.enableRecordingOfInitialDeposit || false == true) && this.forPaymentIsProcessed == false) {
                            this.forPaymentIsPosting = true;
                            // Add validation //
                            if( Number(this.grossAmountDisplay) == 0){
                                this.notifMessage.push("PO gross amount should be greater than zero.");
                                this.documentActionNotification('post', 'error');
                            }else{
                                this.showInitialDepositMethods();
                            }  
                        } else if(['RECDEL'].includes(this.currentDocumentTypeCode) && this.continueAutoCreatePoExceedRr == false) {
                            this.notifMessage = [];
                            var data = this.tabulator.getData()
                            let require_lotcode_products = []
                            require_lotcode_products = data.filter(row => (row.is_require_lotcode != undefined && row.is_require_lotcode === true))
                            if(require_lotcode_products.length > 0) {
                                require_lotcode_products.forEach(row => {
                                    if(row.document_line_locations == undefined){
                                        row.document_line_locations = []
                                    }
                                    var contentqty = ((row.product_type == 'P' && this.currentDocumentTypeCode.includes('REL')) ? row.content_quantity : 1)
                                    var lineqty = (row.document_line_locations.length > 0) ? row.document_line_locations.map(lineloc => lineloc.quantity).reduce((sumqty, qty) => Number(qty) + Number(sumqty)) : 0;
                                    this.notifMessage.push(ValidateField.matchData('Quantity', (row.quantity * contentqty), lineqty, `Insufficient Lot Codes provided for product in line number: ${row.line_no}. It must match quantity`));
                                })
                            }
                            this.notifMessage = this._.compact(this.notifMessage);
                            if (this.notifMessage.length > 0) {
                                this.spinning = false;
                                this.isPostDisabled = false
                                this.documentActionNotification('post', 'error');
                                return;
                            }

                            if (this.document_config.document_type_settings.receivingDocumentWithOrder.autoCreatePurchaseOrderExceedingQuantity == true && this.notifMessage.length == 0){
                                var result = await HTTPRequest.getRequest(this.endPoint + 'documents/check_has_exceeding_receiving_report/?document_id='+component_x.documentNumber, null)
                                if (result.exceeding == true){
                                    this.$confirm({
                                        title: 'Proceed?',
                                        content: h => <div>This action will auto create PO documents from exceeding RR quantity</div>,
                                        onOk: () => {
                                            this.continueAutoCreatePoExceedRr = true
                                            this.isPostDisabled = false
                                            this.spinning = false
                                            this.post()
                                        },
                                        onCancel() {
                                            component_x.isPostDisabled = false
                                            component_x.spinning = false
                                        }
                                    });
                                } else {
                                    this.continueAutoCreatePoExceedRr = true
                                    this.isPostDisabled = false
                                    this.spinning = false
                                    this.post()
                                }
                            } else {
                                    this.continueAutoCreatePoExceedRr = true
                                    this.isPostDisabled = false
                                    this.spinning = false
                                    this.post()
                            }
                        }else if(this.currentDocumentTypeCode=='OTHCNS' && this.continuePostCountSetDocument == false){
                            this.$confirm({
                                title: 'Proceed?',
                                content: h => <div>Set not included products to zero (0) inventory ? </div>,
                                okText: 'Yes',
                                cancelText: 'No',
                                onOk: () => {
                                    component_x.continuePostCountSetDocument = true
                                    component_x.isSetOtherItemInventoryToZero = true
                                    component_x.isPostDisabled = false
                                    component_x.spinning = false
                                    component_x.post()
                                },
                                onCancel() {
                                    component_x.continuePostCountSetDocument = true
                                    component_x.isSetOtherItemInventoryToZero = false
                                    component_x.isPostDisabled = false
                                    component_x.spinning = false
                                    component_x.post()
                                }
                            });
                        }else {
                            window.scrollTo(0,0);
                            this.notifMessage = [];
                            var data = this.tabulator.getData();
                            if(["ORISOX"].includes(this.currentDocumentTypeCode)){
                                if(this.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.autoCreatePostDD){
                                    this.autoPostDD = true;
                                }else if (this.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.autoCreatePostDDAndSI){
                                    this.autoPostDDAndSI = true;
                                }
                            } 
                            //For RelDde Documents
                            if(['RELDDE'].includes(this.currentDocumentTypeCode)){
                                if (this.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.automaticPostingOnSave != true) {
                                    //when goods issue
                                    if (this.documentNumber > 0) {
                                        var invalid = data.find(row => row.goods_issue_quantity == 0 && Number(row.ordered_quantity) > 0)
                                        if (invalid != undefined){
                                            this.notifMessage.push("Zero goods issue quantity is not allowed in the document line");
                                            this.documentActionNotification('post', 'error');
                                            this.spinning = false;
                                            this.isPostDisabled = false
                                            return;
                                        }
                                    }
                                }
                            }
                            if (['ORORSO'].includes(this.currentDocumentTypeCode)){
                                if (this.documentNumber > 0) {
                                    var invalidDoc = data.find(row => row.requested_quantity == 0 && row.quantity == 0)
                                    if (invalidDoc != undefined){
                                        this.notifMessage.push("Zero quantity is not allowed in the document line");
                                        this.documentActionNotification('post', 'error');
                                        this.spinning = false;
                                        this.isPostDisabled = false
                                        return;
                                    }
                                    var checkQty = data.find(row => row.requested_quantity < row.quantity)
                                    if (checkQty != undefined){
                                        this.notifMessage.push("quantity must less than or equal to requested quantity");
                                        this.documentActionNotification('post', 'error');
                                        this.isPostDisabled = false
                                        this.spinning = false;
                                        return;
                                    }
                                    var checkNotAvailableQty = data.find(row => parseFloat(row.quantity) > parseFloat(row.on_hand_quantity))
                                    if (checkNotAvailableQty != undefined){
                                        this.notifMessage.push("containing item that cannot be fulfilled because of lack of inventory.");
                                        this.documentActionNotification('post', 'error');
                                        this.spinning = false;
                                        this.isPostDisabled = false
                                        return;
                                    }
                                }
                            }

                            // For Purchase Return Validation
                            if(['RELRSR'].includes(this.currentDocumentTypeCode)) {
                                this.notifMessage = [];
                                var data = this.tabulator.getData()
                                
                                var result = await HTTPRequest.getRequest(this.endPoint + 'documents/check_has_exceeding_purchase_return/?document_id='+component_x.documentNumber, null)
                                if (result.exceeding == false){
                                    console.log("Continue posting")
                                } else {
                                    this.notifMessage.push(`Return Quantity exceeds received quantity.`);
                                    this.notifMessage = this._.compact(this.notifMessage);
                                    if (this.notifMessage.length > 0) {
                                        this.spinning = false;
                                        this.isPostDisabled = false
                                        this.documentActionNotification('post', 'error');
                                        return;
                                    }
                                }    
                            }

                            if (data.length > 0) {
                                this.isEditing = !(component_x.origData === JSON.stringify(data))
                            }

                            if(this.documentStatus == "Confirmed" && this.isEditing){
                                this.isChangeAction = true;
                            }

                            if (this.isEditing && !this.isChangeAction) {
                                this.notifMessage.push("You have unsaved changes, please save before posting")
                                this.documentActionNotification('post', 'error');
                                if(this.currentDocumentTypeCode=='OTHCNS'){
                                    this.continuePostCountSetDocument = false
                                }
                                this.isPostDisabled = false
                                this.spinning = false;
                                this.documentStatus = 'Saved'
                                return;
                            } else {
                                if (component_x.documentNumber > 0) {
                                    var params = (this.isSetOtherItemInventoryToZero) ? "&set_other_item_inventory_to_zero=true" : ""
                                    params += (this.autoPostDD) ? "&auto_post_dd=true" : (this.autoPostDDAndSI) ? "&auto_post_dd_and_si=true" : ""

                                    if (this.postClickCount == 1) {
                                        var post_request = await HTTPRequest.postRequest(this.endPoint + 'documents/post/?document_id='+component_x.documentNumber+''+params, null)
                                    } else {
                                        this.notifMessage.push("Post button clicked multiple times, document is ongoing posting.")
                                        this.documentActionNotification('post', 'error');
                                        this.spinning = false
                                        this.isPostDisabled = true
                                        return;
                                    }

                                    var linecost_recompute_request = []
                                    // 1935 - Line Cost (When posting Document with header discount)
                                    if(this.headerDiscount.length > 0)
                                    linecost_recompute_request = await HTTPRequest.postRequest(this.endPoint + 'documents/recompute_line_cost_with_discount/?document_id='+component_x.documentNumber+'&overallDiscountWithoutSupportDiscount='+component_x.overallDiscountWithoutSupportDiscount+'&grossAmount='+component_x.grossAmountDisplay, null)
                                    // 1935 - Line Cost (When posting Document with header discount)

                                    if ( (post_request['success'] && linecost_recompute_request['success'] && this.headerDiscount.length > 0) || (post_request['success'] && this.headerDiscount.length == 0) ){
                                        this.openDocument(component_x.documentNumber,component_x.existingDocumentTypeDetails);
                                        // this.$emit('refreshPage', event)
                                        this.documentActionNotification('post', 'success')
                                        this.documentStatus = 'POSTED'
                                    } else if (post_request['error']) {
                                        if(this.currentDocumentTypeCode=='OTHCNS'){
                                            this.continuePostCountSetDocument = false
                                        }

                                        this.notifMessage = post_request['error'].split(',');
                                        this.documentActionNotification('post', 'error')
                                        this.isPostDisabled = false
                                        this.spinning = false
                                        this.postClickCount = 0
                                    }
                                }
                            }
                            this.spinning = false;
                            // this.paymentDrawerVisible = false;
                        }
                    } else {
                        this.documentActionNotification('post', 'error')
                    }
                }
            },

            async voided() {
                window.scrollTo(0,0);
                this.spinning = true;

                //[Internal] - Issue on voiding REL - 2972
                //Prevent voiding REL (STO) if target document (STI) is not yet voided.
                var sti_status = ""
                var sto_status = ""
                if(this.currentDocumentTypeCode == 'RELTRX' && this.proceed_voiding!=1){
                    //Check STI if Voided
                    var sti_doc = await HTTPRequest.getRequest(this.endPoint + "documents/"+ this.documentNumber +"?field_name=origin_document_id", null);
                    this.proceed_voiding = ((sti_doc != null && sti_doc.status == 'Voided') || sti_doc == null) ? 1 : 0;
                    sti_status = (sti_doc != null && sti_doc.status == 'Posted') ? "P" : (sti_doc != null && sti_doc.status == 'Saved') ? "S" : "";
                    (sti_doc.doc_status != undefined && sti_status == "") ? sti_status = sti_doc.doc_status : ''
                } else if (this.currentDocumentTypeCode == 'RECTRX' && this.proceed_voiding!=1){
                    var sto_doc = await HTTPRequest.getRequest(this.endPoint + "documents/"+ this.originDocumentNumber +"?field_name=id", null);
                    sto_status = (sto_doc != null && sto_doc.status == 'Posted') ? "P" : "";
                }

                //Prevent voiding REC, if the cost layer has a movement. (For FIFO or LIFO costing method only)
                if(/^RE(C)/.test(this.currentDocumentTypeCode)){
                var credentials = await HTTPRequest.getRequest(this.endPoint + 'settings/accountSettings?field_name=code' , null)
                    //Check Costing Method
                    if (['FIFO','LIFO',''].includes(JSON.parse(credentials.value).documentCostingMethod)){
                        //Check Cost layer if has a movement
                        //Compare document line and cost layer
                        var document_lines = this.tabulator.getData();
                        var cost_layer = await HTTPRequest.getRequest(this.endPoint + 'documents/get_document_cost_layer_details?document_id='+ this.documentNumber,null)

                        var document_lines_qty = 0
                        var cost_layer_qty = 0
                        
                        if (document_lines.length > 0){
                            document_lines.forEach( line => {
                                document_lines_qty += Number(line.quantity)
                            })
                        }

                        if (cost_layer.length > 0){
                            cost_layer.forEach( line => {
                                cost_layer_qty += Number(line.quantity)
                            })
                        }
                        this.proceed_voiding = (document_lines_qty != cost_layer_qty && cost_layer_qty != 0 && this.proceed_voiding == 0) ? 0 : 1;
                    } else if (['BLENDED'].includes(JSON.parse(credentials.value).documentCostingMethod)){
                        this.proceed_voiding = 1
                    }
                }
                if(this.proceed_voiding == 0 && sti_status == "P" && this.currentDocumentTypeCode == 'RELTRX'){
                    this.notifMessage = []
                    this.notifMessage.push("Unable to Void the Transfer Out document, there is already a posted child Transfer In. Void first the child Transfer In before proceeding.")
                    this.documentActionNotification('voiding', 'error');
                } else if(this.proceed_voiding == 0 && sti_status == "S" && this.currentDocumentTypeCode == 'RELTRX'){
                    this.notifMessage = []
                        this.$confirm({
                        title: "Warning!!",
                        content: h => <div>There is saved child STI, voiding this Transfer Out document will automatically void the child saved STI</div>,
                        onOk: () => {
                                this.proceed_voiding = 1;
                                this.voided();
                            }, 
                        onCancel() {}
                            });
                } else if(sto_status == "P" && this.currentDocumentTypeCode == 'RECTRX'){
                    this.notifMessage = []
                        this.$confirm({
                        title: "Warning!!",
                        content: h => <div>There is a posted Transfer Out from the origin site. Please advise the origin site to void the Transfer Out also to correct the inventory.</div>,
                        onOk: () => {
                                this.proceed_voiding = 1;
                                this.voided();
                            }, 
                        onCancel() {
                            component_x.proceed_voiding = 0;
                        }
                            });
                } else if(this.proceed_voiding == 0 &&  /^RE(C)/.test(this.currentDocumentTypeCode)){
                    this.$confirm({
                    title: "The cost layer for this document has already moved",
                    content: h => <div>If there is not enough inventory, it will obtain it from the layer using the { JSON.parse(credentials.value).documentCostingMethod } costing method; however, if there is no more inventory, it will obtain the cost from the product's last received cost, or "landed cost." Click OK to continue.</div>,
                    onOk: () => {
                            this.proceed_voiding = 1;
                            this.voided();
                        },
                    onCancel() {}
                        });
                } else {
                    var status = -1;
                    var err_msg = [];
                    await axios({
                        method: 'delete',
                        url: this.endPoint + 'documents/' + this.documentNumber,
                        headers: { Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web", 'ip':secureStorage.getItem("ipAddress") },
                    })
                    .then(function () {
                        status = 1;
                    })
                    .catch(function (e) {
                        err_msg = JSON.parse(e.request.response).error
                        status = 0;
                    });
                    if (status) {
                        this.openDocument(this.documentNumber,this.existingDocumentTypeDetails)
                        this.documentActionNotification('void', 'success')
                    }  else {
                        this.notifMessage = err_msg
                        this.documentActionNotification('void', 'error')
                    }
                }
                this.spinning = false;
            },
            async confirm() {
                var data = this.tabulator.getData();
                if (['ORORSO'].includes(this.currentDocumentTypeCode)){
                    if (this.documentNumber > 0) {
                        var invalidQty = data.find(row => row.quantity == 0)
                        if (invalidQty != undefined){
                            this.notifMessage.push("Zero quantity is not allowed in the document line");
                            this.documentActionNotification('confirm', 'error');
                            this.spinning = false;
                            return;
                        }
                        var checkQty = data.find(row => row.requested_quantity < row.quantity)
                        if (checkQty != undefined){
                            this.notifMessage.push("quantity must less than or equal to requested quantity");
                            this.documentActionNotification('confirm', 'error');
                            this.spinning = false;
                            return;
                        }
                        var checkNotAvailableQty = data.find(row => row.quantity > row.on_hand_quantity)
                        if (checkNotAvailableQty != undefined){
                            this.continueAutoCreateTr = true
                        }
                    }
                    var put_request = await HTTPRequest.putRequest(this.endPoint + 'documents/'+this.documentNumber+'/confirm?auto_create_tr='+this.continueAutoCreateTr, null, null)
                }else{
                    var put_request = await HTTPRequest.putRequest(this.endPoint + 'documents/'+this.documentNumber+'/confirm', null, null)
                }
                if(put_request == undefined){
                    this.$emit('refreshPage', event)
                    this.openDocument(this.documentNumber,this.existingDocumentTypeDetails)
                    this.documentActionNotification('confirm', 'success')
                    this.create_action_history('CONFIRMED')
                } else {
                    if(put_request["error"] == undefined){
                        this.$emit('refreshPage', event)
                        this.openDocument(this.documentNumber,this.existingDocumentTypeDetails)
                        this.documentActionNotification('confirm', 'success')
                        this.create_action_history('CONFIRMED')
                    } else {
                        this.notifMessage = put_request["error"].split(",");
                        this.documentActionNotification('confirm', 'error')
                    }
                }
            },
            deliver(){

            },

            async updateOrderStatus(value){
              this.spinning = !this.spinning
              this.tabulator.clearData()
              await HTTPRequest.putRequest(`${this.endPoint}/documents/${this.documentNumber}/update_order_status`, null, {order_status:value})
              component_x.$notification['success']({
                                            message: 'Successful Operation',
                                            description: "Successfully Updated Order Status",
                                            style: getNotificationStyle('success'),
                                        });
              this.spinning = !this.spinning
              this.initializeDocument()
            },

            downloadTemplate(type){
                let urlDownload = "";
                if(type == 1 || type == 3)
                    urlDownload = this.endPoint + "import_templates/download_file?profile_name=documents&type=basic";
                else if(type == 2)
                    urlDownload = this.endPoint + "import_templates/download_file?profile_name=documents&type=lotcode_expiry";
                else
                    return;

                if (this.currentDocumentTypeCode == "OTHPWS") {
                    // Import Mass Upload Products for PWS
                    // Selection between Barcode and Stock No field must be visible
                    urlDownload = `${this.endPoint}import_templates/download_file?profile_name=pws_product&type=basic&save_via=${this.saveMassUploadProductVia}`;
                }
                if (this.currentDocumentTypeCode == "ORIPOX") {
                    urlDownload = `${this.endPoint}import_templates/download_file?profile_name=documents&type=purchase_order`;
                }
                if (this.currentDocumentTypeCode == "ORISOX") {
                    urlDownload = `${this.endPoint}import_templates/download_file?profile_name=documents&type=sales_order`;
                }

                if (this.currentDocumentTypeCode == "OTHTRA") {
                    if(type == 1)
                        urlDownload = this.endPoint + "import_templates/download_file?profile_name=documents&type=basic";
                    else if(type == 3)
                        urlDownload = this.endPoint + "import_templates/download_file?profile_name=documents&type=transfer_allocation_2";
                    else
                        urlDownload = `${this.endPoint}import_templates/download_file?profile_name=documents&type=transfer_allocation`;
                }

                axios({
                    url:  urlDownload,
                    method: 'POST',
                    responseType: 'blob', // important
                    headers: {
                        Authorization: 'Bearer ' + secureStorage.getItem("accessToken"),
                        "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-File", 'ip':secureStorage.getItem("ipAddress")
                    }
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    if(type == 3)
                        link.setAttribute('download', 'document_import_template.xlsx');
                    else
                        link.setAttribute('download', 'document_import_template.csv');
                    document.body.appendChild(link);
                    link.click();
                    component_x.$notification['success']({
                        message: 'Successful Download',
                        description: "You have succesfully downloaded the template for document upload.",
                        style: getNotificationStyle('success')
                    });
                });
            },

            showPaymentMethods(){
                this.paymentDrawerVisible = true
            },
            showInitialDepositMethods(){
                this.initialDepositDrawerVisible = true
            },
            async showBooking(){
                // https://robotapitest.mrspeedy.ph/api/business/1.1/calculate-order

                var activeBooking = await HTTPRequest.getRequest(this.endPoint + "document_bookings/get_active_booking?document_id="+ this.documentNumber, null);

                var siteId = secureStorage.getItem("defaultSiteId").toString();
                var siteDetails = await HTTPRequest.getRequest(this.endPoint + "sites/"+ siteId, null);

                this.siteAddress = siteDetails.address;

                if(_.isEmpty(this.siteAddress) || _.isEmpty(this.customerAddress)){
                    this.$notification['error']({
                      message: 'Address Missing',
                      description: "Please make sure site and customer address are both configured.",
                      style: getNotificationStyle('error')
                    });
                    return;
                }

                this.bookingDrawerVisible = true
                this.siteContactNumber = siteDetails.telephone;
                this.siteContactPerson = siteDetails.contact_person;
                this.orderParemeters = {
                    matter: "BXI Order",
                    vehicle_type_id: 8,
                    points: [
                        {
                            address: this.siteAddress,
                            contact_person: {
                                phone: this.siteContactNumber,
                                name: this.siteContactPerson
                            },
                            client_order_id: this.documentNumber
                        },
                        {
                            address: this.customerAddress,
                            contact_person: {
                                phone: this.customerContactMobile,
                                name: this.customer.label
                            },
                            client_order_id: this.documentNumber
                        }
                    ]
                }

                var bookingDetails = {}
                var response = {}
                if(activeBooking.length > 0){
                    this.bookingId = activeBooking[0].id
                    bookingDetails = activeBooking[0].booking_details
                    response = activeBooking[0].booking_details.order
                    this.activeBooking = true
                }  else {
                    var recomputeRequest = await HTTPRequest.postRequest(this.endPoint + '/logistics/get_quotation', null, this.orderParemeters)
                    bookingDetails = recomputeRequest
                    response = recomputeRequest.order
                }
                // var recomputeRequest = await HTTPRequest.postRequest(this.endPoint + '/logistics/get_quotation', null, this.orderParemeters)

                this.bookingDetails = bookingDetails;
                var response = response;
                this.recompute = false;
                this.center = {lat: parseFloat(response.points[0].latitude), lng: parseFloat(response.points[0].longitude)}
                this.markers = [{
                  id: 1,
                  position: {
                    lat: parseFloat(response.points[0].latitude),
                    lng: parseFloat(response.points[0].longitude)
                  }
                }, {
                  id: 2,
                  position: {
                    lat: parseFloat(response.points[1].latitude),
                    lng: parseFloat(response.points[1].longitude)
                  }
                }]

                this.originalGeoLocation = [{
                  id: 1,
                  position: {
                    lat: parseFloat(response.points[0].latitude),
                    lng: parseFloat(response.points[0].longitude)
                  }
                }, {
                  id: 2,
                  position: {
                    lat: parseFloat(response.points[1].latitude),
                    lng: parseFloat(response.points[1].longitude)
                  }
                }]

                // this.$notification['success']({
                //   message: 'Completed Recomputation',
                //   description: "Please see updated booking fee."
                // });

                    // await axios({
                    //     method: 'post',
                    //     url: "https://robotapitest.mrspeedy.ph/api/business/1.1/calculate-order",
                    //     data: this.orderParemeters,
                    //     headers: {"X-DV-Auth-Token": "BA98FA54AF033CBE8760BF29AD49581FC3ED95FA"}
                    // })
                    // .then(function (response) {
                    //     component_x.bookingDetails = response.data;
                    //     var response = response.data.order;

                    //     component_x.center = {lat: parseFloat(response.points[0].latitude), lng: parseFloat(response.points[0].longitude)}
                    //     component_x.markers = [{
                    //       id: 1,
                    //       position: {
                    //         lat: parseFloat(response.points[0].latitude),
                    //         lng: parseFloat(response.points[0].longitude)
                    //       }
                    //     }, {
                    //       id: 2,
                    //       position: {
                    //         lat: parseFloat(response.points[1].latitude),
                    //         lng: parseFloat(response.points[1].longitude)
                    //       }
                    //     }]

                    //     component_x.originalGeoLocation = [{
                    //       id: 1,
                    //       position: {
                    //         lat: parseFloat(response.points[0].latitude),
                    //         lng: parseFloat(response.points[0].longitude)
                    //       }
                    //     }, {
                    //       id: 2,
                    //       position: {
                    //         lat: parseFloat(response.points[1].latitude),
                    //         lng: parseFloat(response.points[1].longitude)
                    //       }
                    //     }]
                    //     // component_x.paymentMethods = response.data
                    // })
                    // .catch(async function (error) {
                    // })
            },
            async recomputeBooking(){
                this.orderParemeters = {
                    matter: "BXI Order",
                    vehicle_type_id: 8,
                    points: [
                        {
                            address: this.siteAddress,
                            latitude: this.markers[0].position.lat,
                            longitude: this.markers[0].position.lng,
                            contact_person: {
                                phone: this.siteContactNumber,
                                name: this.siteContactPerson
                            },
                            client_order_id: this.documentNumber
                        },
                        {
                            address: this.customerAddress,
                            latitude: this.markers[1].position.lat,
                            longitude: this.markers[1].position.lng,
                            contact_person: {
                                phone: this.customerContactMobile,
                                name: this.customer.label
                            },
                            client_order_id: this.documentNumber
                        }
                    ]
                }

                var recomputeRequest = await HTTPRequest.postRequest(this.endPoint + '/logistics/get_quotation', null, this.orderParemeters)
                this.bookingDetails = recomputeRequest;
                this.recompute = false;
                this.$notification['success']({
                  message: 'Completed Recomputation',
                  description: "Please see updated booking fee.",
                  style: getNotificationStyle('success')
                });

                // await axios({
                //     method: 'post',
                //     url: "https://robotapitest.mrspeedy.ph/api/business/1.1/calculate-order",
                //     data: this.orderParemeters,
                //     headers: {"X-DV-Auth-Token": "BA98FA54AF033CBE8760BF29AD49581FC3ED95FA"}
                // })
                // .then(function (response) {
                //     component_x.bookingDetails = response.data;
                //     component_x.recompute = false;
                //     // componennt_x.originalGeoLocation = component_x.markers
                // })
                // .catch(async function (error) {
                // })

                this.recomputeModal = false
            },
            async proceedBooking(){
                if(this.recompute == true){
                    this.recomputeModal = true
                }else{
                    this.bookingProper()
                }
            },
            async cancelBooking(){
                var cancelRequest = await HTTPRequest.postRequest(this.endPoint + '/logistics/cancel_booking?booking_id=' + this.bookingId , null, this.orderParemeters)
                this.$notification['success']({
                  message: 'Success',
                  description: "Your booking is successfully cancelled.",
                  style: getNotificationStyle('success')
                });
                this.activeBooking = false
            },
            async bookingProper(){
                this.recomputeModal = false
                this.orderParemeters = {
                    matter: "BXI Order",
                    vehicle_type_id: 8,
                    points: [
                        {
                            address: this.siteAddress,
                            latitude: this.markers[0].position.lat,
                            longitude: this.markers[0].position.lng,
                            contact_person: {
                                phone: this.siteContactNumber,
                                name: this.siteContactPerson
                            },
                            client_order_id: this.documentNumber
                        },
                        {
                            address: this.customerAddress,
                            latitude: this.markers[1].position.lat,
                            longitude: this.markers[1].position.lng,
                            contact_person: {
                                phone: this.customerContactMobile,
                                name: this.customer.label
                            },
                            client_order_id: this.documentNumber
                        }
                    ]
                }

                var bookRequest = await HTTPRequest.postRequest(this.endPoint + '/logistics/book?document_id=' + this.documentNumber , null, this.orderParemeters)

                if(bookRequest.error == undefined){
                    this.bookingDetails = bookRequest;
                    this.recompute = false;
                    this.$notification['success']({
                      message: 'Waiting for driver..',
                      description: "We will notify you once booking has been accepted.",
                      style: getNotificationStyle('success')
                    });
                    this.activeBooking = true
                } else {
                    this.$notification['error']({
                      message: 'Failed to book.',
                      description: bookRequest.error,
                      style: getNotificationStyle('error')
                    });
                }
            },
            async pay(documentNumber){
                this.spinning = true;
                var curr_document = await HTTPRequest.getRequest(this.endPoint + "documents/"+ documentNumber, null);

                if(this.paymentMode == "paymaya"){
                    var request_body = {
                        type: "paymaya",
                        document: curr_document
                    }
                    var post_request = await HTTPRequest.postRequest(this.endPoint + 'integrations/get_url', null, request_body)

                    if(post_request["error"] == undefined){
                        if (this.forPaymentIsPosting == true) {
                            this.forPaymentIsProcessed = true;
                            this.closeDrawer('initialDeposit')
                            this.post();
                        }else{
                        this.openDocument(documentNumber,this.existingDocumentTypeDetails);
                        this.documentActionNotification('pay', 'success')
                    }
                    }
                } else if(this.paymentMode == "dragonpay") {
                    this.paymentErrors = []
                    if (this.paymentMethod == null) {
                        this.paymentErrors.push("Please select a payment method")
                    }else{
                        var request_body = {
                            type: "dragonpay",
                            document: curr_document,
                            procId: this.paymentMethod
                        }
                        var post_request = await HTTPRequest.postRequest(this.endPoint + 'integrations/get_url', null, request_body)

                        if(post_request["error"] == undefined){
                            if (this.forPaymentIsPosting == true) {
                                this.forPaymentIsProcessed = true;
                                this.closeDrawer('initialDeposit')
                                this.post();
                            }else{
                                this.openDocument(documentNumber,this.existingDocumentTypeDetails)
                                this.documentActionNotification('pay', 'success')
                            }
                        }
                    }
                } else {
                    this.paymentErrors = []
                    if (this.bankTransferReference == "") {
                        this.paymentErrors.push("Please input a reference number")
                    }else{
                        var request_body = {
                            type: "bank",
                            document: curr_document,
                            reference: this.bankTransferReference
                        }
                        var post_request = await HTTPRequest.postRequest(this.endPoint + 'integrations/get_url', null, request_body)
                        if(post_request["error"] == undefined){
                            if (this.forPaymentIsPosting == true) {
                                this.forPaymentIsProcessed = true;
                                this.closeDrawer('initialDeposit')
                                this.post();
                            }else{
                                this.openDocument(documentNumber,this.existingDocumentTypeDetails)
                                this.documentActionNotification('pay', 'success')
                            }
                        }
                    }
                }
                this.spinning = false;
            },
            async unconfirm() {
                var put_request = await HTTPRequest.putRequest(this.endPoint + 'documents/'+this.documentNumber+'/unconfirm', null, null)
                if(put_request == undefined){
                    this.$emit('refreshPage', event)
                    this.openDocument(this.documentNumber,this.existingDocumentTypeDetails)
                    this.documentActionNotification('unconfirm', 'success')
                    this.create_action_history('UNCONFIRMED')
                } else {
                    if(put_request["error"] == undefined){
                        this.$emit('refreshPage', event)
                        this.openDocument(this.documentNumber,this.existingDocumentTypeDetails)
                        this.documentActionNotification('unconfirm', 'success')
                        this.create_action_history('UNCONFIRMED')
                    } else {
                        this.notifMessage = put_request["error"].split(",");
                        this.documentActionNotification('unconfirm', 'error')
                    }
                }
            },
            async create_action_history(action) {
                var actionHistoryPayload = {
                    action: action,
                    action_at: moment(new Date()),
                    action_by: secureStorage.getItem("userName"),
                    document_id: this.documentNumber,
                    remark: "Document Form",
                    status: "A"
                }
                await HTTPRequest.postRequest(this.endPoint + 'document_action_histories/', null, actionHistoryPayload)
            },
            async freeze(){
                window.scrollTo(0,0);
                this.spinning = true;
                this.notifMessage = [];
                var data = this.tabulator.getData();

                if (data.length > 0) {
                    // CNC-002: for PCN v2 use the editable-fields dirty check so
                    // grid-computed columns don't falsely mark the doc as edited.
                    if (this.isPhysicalCountV2Document) {
                        this.isEditing = this.isPhysicalCountV2GridDirty();
                    } else {
                        this.isEditing = !(component_x.origData === JSON.stringify(data))
                    }
                }

                if (this.isEditing && !this.isChangeAction) {
                    this.notifMessage.push("You have unsaved changes, please save before freezing inventory")
                    this.documentActionNotification('freeze', 'error');
                    this.spinning = false;
                    return;
                } else if (this.validateForm()) {
                    this.documentActionNotification('freeze', 'error');
                    this.spinning = false;
                    return;
                } else {
                    if (component_x.documentNumber > 0) {
                        // CNC-002: echo the server updated_at we loaded so the
                        // backend can detect a concurrent update/freeze by another
                        // user (optimistic concurrency). Only PCN v2 docs track it.
                        var freezeUrl = this.endPoint + 'documents/freeze/?document_id=' + component_x.documentNumber;
                        if (this.isPhysicalCountV2Document && component_x.documentKnownUpdatedAt) {
                            freezeUrl += '&known_updated_at=' + encodeURIComponent(component_x.documentKnownUpdatedAt);
                        }
                        if (this.isPhysicalCountV2Document && component_x.documentKnownOrderStatus != null) {
                            freezeUrl += '&known_order_status=' + encodeURIComponent(component_x.documentKnownOrderStatus);
                        }
                        // CNC-002 (intent): tell the backend EXACTLY which action the
                        // user intends based on the current button state, so a losing
                        // concurrent session's "Freeze" click can never silently
                        // unfreeze the winner's snapshot (the endpoint is otherwise a
                        // pure toggle). 'Frozen' button => unfreeze; otherwise freeze.
                        if (this.isPhysicalCountV2Document) {
                            var freezeIntent = (component_x.documentOrderStatus == 'Frozen') ? 'unfreeze' : 'freeze';
                            freezeUrl += '&freeze_action=' + freezeIntent;
                        }
                        var post_request = await HTTPRequest.postRequest(freezeUrl, null)
                        if (post_request['success']){
                            this.$emit('refreshPage', event)
                            this.openDocument(component_x.documentNumber,this.existingDocumentTypeDetails)
                            if (component_x.documentOrderStatus == 'Frozen'){
                              this.documentActionNotification('unfreeze', 'success')
                            }else{
                              this.documentActionNotification('freeze', 'success')
                            }
                        } else if (post_request['error']){
                            // CNC-002: a STALE_DOCUMENT conflict means another user
                            // froze/updated this document first. Show the single
                            // canonical reload message (never "unsaved changes"),
                            // then reload so the user sees the winner's result.
                            if (pcv2IsStaleConflict(post_request)) {
                                this.notifMessage = pcv2FreezeErrorMessages(post_request);
                                this.documentActionNotification('freeze', 'error')
                                this.openDocument(component_x.documentNumber,this.existingDocumentTypeDetails)
                            } else {
                                this.notifMessage = this.normalizeActionErrors(post_request['error']);
                                this.documentActionNotification('freeze', 'error')
                            }
                        }
                    }
                }
                this.spinning = false;
            },
            autocompleteFilterOption(input, option) {
                return (
                    option.componentOptions.children[0].text.toUpperCase().indexOf(input.toUpperCase()) >= 0
                );
            },
            async toggleDocumentTrade(){
                this.isDocumentTrade = !this.isDocumentTrade
                await this.tabulator.clearData();
                this.calculateSummary();
            },
            refreshDocument() {
              this.openDocument(this.documentNumber,this.existingDocumentTypeDetails);
            },
            docPrint(format, opt){
                if(format == "cmg_po_print"){
                    CmgPoFormat.print(this.endPoint, this.documentId, true, opt);
                } else if(format == "goldwing_rr_print"){
                    GoldwingRrFormat.print(this.endPoint, this.documentId, true, opt);
                }
            },
            syncPhysicalCountV2CountSheetPrintFormat(){
                if(!Array.isArray(this.formPrintFormatOptions)) return;

                this.formPrintFormatOptions = this.formPrintFormatOptions.filter(option => option.function !== 'count_sheet');
                if(this.canPrintPhysicalCountV2CountSheet){
                    this.formPrintFormatOptions.push({id: -2, name: 'Count Sheet', function: 'count_sheet'});
                }else if(this.formPrintFormat === 'count_sheet'){
                    this.formPrintFormat = '';
                }
            },
            printPhysicalCountV2CountSheet(customFont){
                if(!this.canPrintPhysicalCountV2CountSheet) return;

                this.spinning = true;

                try {
                    const doc = new jsPDF('l', 'pt', 'a4');
                    if(customFont == 'dotMatrix'){
                        doc.addFileToVFS('Epson1-normal.ttf', Epsonfont);
                        doc.addFont('Epson1-normal.ttf', 'Epson1', 'normal');
                        doc.addFileToVFS('Epson1-bold.ttf', Epsonfontbold);
                        doc.addFont('Epson1-bold.ttf', 'Epson1', 'bold');
                        doc.setFont('Epson1');
                    }

                    const siteName = secureStorage.getItem("defaultSiteName") || '';
                    const documentDate = this.documentDate && this.documentDate.format ? this.documentDate.format('D-MMM-YYYY') : '';
                    const printDate = moment().format('lll') || '';
                    const documentType = this.currentDocumentTypeName || 'Physical Count';
                    const documentNumber = this.documentNo || this.documentNumber || '';
                    const reference = this.reference || '';
                    const remark = this.remark || '';
                    const rows = this.physicalCountV2CountSheetRows();

                    doc.setFontSize(14);
                    doc.setFontStyle('bold');
                    doc.text(siteName, 40, 30);
                    doc.text(`${documentType} - Count Sheet`, 520, 30);
                    doc.setFontStyle('normal');
                    doc.setFontSize(9);
                    doc.text(`# ${String(documentNumber)}`, 520, 45);
                    doc.text(`Document Date: ${documentDate}`, 40, 55);
                    doc.text(`Status: ${this.documentStatus || ''}`, 250, 55);
                    doc.text(`Reference: ${reference}`, 40, 70);
                    doc.text(`Remark: ${remark}`, 250, 70);

                    doc.autoTable({
                        startY: 90,
                        head: [['Line', 'Stock No', 'Barcode', 'Product', 'Lot Code', 'Expiry', 'Serial No', 'Quantity', 'Unit']],
                        body: rows,
                        theme: 'plain',
                        margin: { top: 50, bottom: 45 },
                        styles: {
                            font: customFont == 'dotMatrix' ? 'Epson1' : null,
                            fontSize: customFont == 'dotMatrix' ? 8 : 7,
                            overflow: 'linebreak',
                            cellPadding: 3,
                            minCellHeight: 34,
                        },
                        headStyles: {
                            halign: 'center',
                            valign: 'middle',
                            fontSize: customFont == 'dotMatrix' ? 9 : 8,
                        },
                        columnStyles: {
                            0: { halign: 'center', cellWidth: 35 },
                            1: { cellWidth: 70 },
                            2: { cellWidth: 85 },
                            3: { cellWidth: 150 },
                            4: { cellWidth: 80 },
                            5: { cellWidth: 70 },
                            6: { cellWidth: 80 },
                            7: { cellWidth: 120 },
                            8: { cellWidth: 45 },
                        },
                        didDrawCell: function(data){
                            if(data.section === 'body' && data.column.index === 7){
                                doc.rect(data.cell.x + 8, data.cell.y + 6, data.cell.width - 16, data.cell.height - 12);
                            }
                        },
                        didDrawPage: function(){
                            doc.setFontSize(customFont == 'dotMatrix' ? 7 : 6);
                            doc.text(`Printed By: ${secureStorage.getItem("userCode") || ''}`, 40, 560);
                            doc.text(`Print Date: ${printDate}`, 180, 560);
                        },
                    });

                    const pageCount = doc.internal.getNumberOfPages();
                    for(let i = 1; i <= pageCount; i++) {
                        doc.setPage(i);
                        doc.setFontSize(customFont == 'dotMatrix' ? 7 : 6);
                        doc.text(`Page ${i} of ${pageCount}`, 760, 560);
                    }

                    doc.save(`${this.currentDocumentTypeFriendlyCodeWithId || 'Physical_Count'}_Count_Sheet_${moment().format('YYYYMMDDHHmmss')}.pdf`);
                    this.modalFormPrinting = false;
                } finally {
                    this.spinning = false;
                }
            },
            physicalCountV2CountSheetRows(){
                if(!this.tabulator) return [];

                return this.tabulator.getData()
                    .filter(line => Number(line.line_no || 0) > 0)
                    .map(line => [
                        line.line_no || '',
                        line.stock_no || '',
                        line.barcode || '',
                        line.product_name || '',
                        this.physicalCountV2LineLotCodes(line),
                        this.physicalCountV2LineExpiryDates(line),
                        line.document_line_serials_text || '',
                        '',
                        line.unit_name || line.unit_label || '',
                    ]);
            },
            physicalCountV2LineLotCodes(line){
                if(Array.isArray(line.document_line_locations) && line.document_line_locations.length > 0){
                    return line.document_line_locations
                        .filter(location => location.status !== 'D')
                        .map(location => String(location.lot_code || '').trim())
                        .filter(lotCode => lotCode !== '')
                        .join(', ');
                }
                return line.document_line_lot_code || '';
            },
            physicalCountV2LineExpiryDates(line){
                if(Array.isArray(line.document_line_locations) && line.document_line_locations.length > 0){
                    return line.document_line_locations
                        .filter(location => location.status !== 'D')
                        .map(location => this.formatPhysicalCountV2ExpiryDate(location.expiry_at))
                        .filter(expiryAt => expiryAt !== '')
                        .join(', ');
                }
                return line.document_line_expiry || '';
            },
            formatPhysicalCountV2ExpiryDate(value){
                if(!value) return '';
                const expiryAt = moment(value);
                return expiryAt.isValid() ? expiryAt.format('YYYY-MM-DD') : String(value);
            },
            async customPrint(isDefaultPrint, customFont){
                let headerCustomPosition = 0
                let xCustomPosition = 0
                if(customFont == 'dotMatrix') {
                    headerCustomPosition = -10
                    xCustomPosition = 10
                }
                this.printDefault = isDefaultPrint;
                this.spinning = true;

                var fontSizeIncreaser = this.printFontSizeIncrease || 0
                var valueHeaderPos = this.printValueHeaderPos
                var valueFooterPos = this.printValueFooterPos

                var friendlyOriginDocumentNo = component_x.friendlyOriginDocumentNo || ''
                var currentDocumentTypeCode = this.currentDocumentTypeCode || ''
                var documentType = this.currentDocumentTypeName || ''
                var currentSiteName = secureStorage.getItem("defaultSiteName") || '';
                const currentSiteId = secureStorage.getItem("defaultSiteId") || '';
                let requestingSiteName = this.requestingSite.label;
                let requestingSiteId = this.requestingSite.key;

                var userCode = secureStorage.getItem("userCode") || '';
                var createdBy = this.createdBy || '';
                var postedBy = this.postedBy || '';


                var siteName = this.distributionSite.label || ''
                var customerName = this.customer.label || ''
                var customerAddress = this.customerAddress.trim() || ''

                var supplier = this.supplier.label || ''
                var supplyingBranch = this.supplyingSite.label || ''
                var requestingBranch = this.requestingSite.label || ''
                var sublocationSite = this.distributionSite.label || ''
                var originSublocation =  this.originSublocation.label || ''
                var destinationSublocation = this.destinationSublocation.label || ''
                var party = this.party || ''

                var documentDate = this.documentDate.format('D-MMM-YYYY') || ''
                var targetDate = this.targetDate.format('D-MMM-YYYY') || ''
                var cancellationDate = this.cancellationDate.format('D-MMM-YYYY') || ''

                var currentDocumentTypeFriendlyCode = this.currentDocumentTypeFriendlyCode || ''
                var documentStatus = this.documentStatus || ''
                var documentNumber = this.documentNo || ''

                var reference = this.reference || ''
                var referenceLabel = this.referenceLabel || 'Reference'
                var remark = this.remark || ''
                var purpose = this.purpose.label || ''

                var printDate = moment().format('lll') || '';
                var postDate = this.postDate || ''

                var doc = new jsPDF();
                let currencyKey = component_x.currency.key;
                let currencyLabel = component_x.currency.label;
                let currencyRate = (component_x.documentDetails.currency_rate!=0 && component_x.documentDetails.currency_rate!=null && component_x.documentDetails.currency_rate!=undefined && component_x.documentDetails.currency_rate!='0.0') ? component_x.documentDetails.currency_rate : '1';
                var header_position = 130 + headerCustomPosition
                var value_position = 170
                var line_position = 195
                var total_plus_width = 0
                var minus_height = 0
                var initial_deposit = 0
                var balance = 0
                var orientation = "portrait"
                var papersize = "a4"
                var x_position = 0
                var showDiscountAmountValue = 0
                var showTotalVatValue = 0

                if (currencyKey>0 && component_x.showConversionRate){
                    var subtotal = this.tabulator.getColumn("subtotal")
                    await subtotal.updateDefinition({download:false})
                    var subtotal_php = this.tabulator.getColumn("subtotal_php")
                    await subtotal_php.updateDefinition({downloadTitle: "Subtotal", download:true})
                    var price = this.tabulator.getColumn("price")
                    await price.updateDefinition({download:false})
                    var cost_php = this.tabulator.getColumn("price_php")
                    await cost_php.updateDefinition({downloadTitle: "Price", download:true})
                }
                var showRefCode = false,showStockNoInProductList = false, showErpCode = false
                var printSettingEnabledCount = 0;
                printSettingEnabledCount +=1
                var erp_code = this.tabulator.getColumn("erp_code")
                erp_code.updateDefinition({title: "SM Barcode", download: true})

                if (this.document_config.document_type_settings.printSettings!= undefined){
                    showRefCode = this.document_config.document_type_settings.printSettings.showRefCode
                    // showErpCode = this.document_config.document_type_settings.printSettings.showErpCode
                    showStockNoInProductList = this.document_config.document_type_settings.printSettings.showStockNoInProductList
                    
                    if(this.document_config.document_type_settings.printSettings.showSerialNoInProductList != undefined && this.document_config.document_type_settings.printSettings.showSerialNoInProductList == true){
                        printSettingEnabledCount +=1
                        var supplier_stock_no = this.tabulator.getColumn("document_line_serials_text")
                        supplier_stock_no.updateDefinition({download:true})
                    }
                    if(this.document_config.document_type_settings.printSettings.showDesignAndSizeInProductList != undefined && this.document_config.document_type_settings.printSettings.showDesignAndSizeInProductList == true){
                        printSettingEnabledCount +=2
                        var design = this.tabulator.getColumn("design")
                        design.updateDefinition({download:true})
                        var size = this.tabulator.getColumn("size")
                        size.updateDefinition({download:true})
                    }
                    if(this.document_config.document_type_settings.printSettings.enableShowingInitialDepositField!=undefined && this.document_config.document_type_settings.printSettings.enableShowingInitialDepositField==true){
                        printSettingEnabledCount +=1
                        this.showDocumentPayment("initialDeposit")
                        initial_deposit = Number(this.documentPaymentsList.reduce(function(prev, cur) { return Number(prev) + Number(cur.amount); }, 0)) || Number(this.documentDetails.reference_7) || 0
                    }
                    if(this.document_config.document_type_settings.printSettings.enableLandscapePrinting != undefined && this.document_config.document_type_settings.printSettings.enableLandscapePrinting == true){
                        orientation = "landscape"
                        header_position = 220 + headerCustomPosition
                        value_position = 260
                        line_position = 280
                        minus_height = 85
                        if (currentDocumentTypeCode == 'ORIPOX' && !this.document_config.document_type_settings.printSettings.showStockNoInProductList){
                            total_plus_width = 58
                        }else {
                            total_plus_width = 66
                        }
                        if(!this.document_config.document_type_settings.printSettings.showSerialNoInProductList){
                            total_plus_width = 78
                        }
                    }         

                    if(this.document_config.document_type_settings.printSettings.showTotalVat != undefined && this.document_config.document_type_settings.printSettings.showTotalVat == true){
                        var showTotalVat = this.document_config.document_type_settings.printSettings.showTotalVat
                        showTotalVatValue = this.documentDetails.tax_amount
                    }
                    if(this.document_config.document_type_settings.printSettings.showNetAmountWithoutVat != undefined && this.document_config.document_type_settings.printSettings.showNetAmountWithoutVat == true){
                        var showNetAmountWithoutVat = this.document_config.document_type_settings.printSettings.showNetAmountWithoutVat
                    }
                    if(this.document_config.document_type_settings.printSettings.showTotalPrice != undefined && this.document_config.document_type_settings.printSettings.showTotalPrice == true){
                        var showTotalPrice = this.document_config.document_type_settings.printSettings.showTotalPrice
                    }
                    if(this.document_config.document_type_settings.printSettings.showDiscountAmount != undefined && this.document_config.document_type_settings.printSettings.showDiscountAmount == true){
                        var showDiscountAmount = this.document_config.document_type_settings.printSettings.showDiscountAmount
                        showDiscountAmountValue = Number(this.itemDiscount || 0) + Number(this.overallDiscount || 0) 
                    }
                    if(this.document_config.document_type_settings.printSettings.showOtherCharges != undefined && this.document_config.document_type_settings.printSettings.showOtherCharges == true){
                        var showOtherCharges = this.document_config.document_type_settings.printSettings.showOtherCharges
                    }
                }

                let tempdata = this.tabulator.getData();

                // Fix: Use actual_quantity for posted & fulfilled RELTRX (STO) documents
                var documentOrderStatus = this.documentOrderStatus || ''
                var useActualQuantityForPrint = (currentDocumentTypeCode === 'RELTRX' && documentStatus === 'Posted' && documentOrderStatus === 'Fulfilled')
                var totalActualQuantity = 0
                if (useActualQuantityForPrint) {
                    tempdata.forEach(function(row) { totalActualQuantity += Number(row.actual_quantity || 0) })
                }
                var printQuantityTotal = useActualQuantityForPrint ? totalActualQuantity : null

                var column_names = []
                let siteData = {};
                let supplierData = {};
                if (this.continueWithPrintPdf){
                    requestingSiteId = this.documentDetails.site_id.key
                    requestingSiteName = this.documentDetails.site_id.label
                    siteData = await HTTPRequest.getRequest(`${this.endPoint}sites/${requestingSiteId}` , null, null);
                    supplierData = await HTTPRequest.getRequest(`${this.endPoint}suppliers/${this.supplier.key}` , null, null);
                    
                    let tabulatorInstance = this.$refs.tabulator.getInstance();
                    var calculation = tabulatorInstance.getCalcResults();
                    var startY = 90
                    // Field-name based cost/price column masking (robust to column order changes)
                    var costMaskIndexes = this.getPrintCostMaskColumnIndexes(tabulatorInstance);

                    // Same column-aligned footer totals as print(): the hardcoded x
                    // anchors for the Purchase Return totals row overlap each other,
                    // so resolve them from the real rendered column right-edges.
                    // See print() for the reasoning behind the candidate field lists.
                    var alignFooterTotalsToColumns = (currentDocumentTypeCode == 'RELRSR');
                    var quantityPrintColumnIndex = alignFooterTotalsToColumns ? this.getPrintColumnIndexByField(tabulatorInstance, ['quantity']) : -1;
                    var costPrintColumnIndex = alignFooterTotalsToColumns ? this.getPrintColumnIndexByField(tabulatorInstance, ['price_php', 'price', 'cost_php', 'cost']) : -1;
                    var subtotalPrintColumnIndex = alignFooterTotalsToColumns ? this.getPrintColumnIndexByField(tabulatorInstance, ['subtotal_php', 'subtotal', 'subtotal_without_vat']) : -1;
                    var printColumnRightEdges = {};

                    tabulatorInstance.downloadToTab("pdf", "data"+isDefaultPrint+".pdf", {
                        orientation:orientation,
                        jsPDF:{
                            unit:"mm",
                            putOnlyUsedFonts:true,
                            format:papersize
                        },
                        autoTable:function(doc){
                            //HEADER
                            doc.addFileToVFS('Epson1-normal.ttf', Epsonfont);
                            doc.addFont('Epson1-normal.ttf', 'Epson1', 'normal');
                            doc.addFileToVFS('Epson1-bold.ttf', Epsonfontbold);
                            doc.addFont('Epson1-bold.ttf', 'Epson1', 'bold');
                            if(customFont == 'dotMatrix'){
                                doc.setFont("Epson1");
                            }

                            if (currentDocumentTypeCode == 'ORITRQ' || currentDocumentTypeCode == 'OROTRQ' || currentDocumentTypeCode == 'RELTRX' || currentDocumentTypeCode == 'RECTRX' || currentDocumentTypeCode == 'ORICSQ' || currentDocumentTypeCode == 'OROCSQ' || currentDocumentTypeCode == 'RELCSX' || currentDocumentTypeCode == 'RECCSX') {
                                doc.setFontSize(10 + fontSizeIncreaser);
                                doc.text("Supplying Branch:", 15, 50);
                                doc.setFontStyle("bold");
                                doc.text(supplyingBranch, 50 + xCustomPosition, 50);
                                doc.setFontStyle("normal");

                                doc.text("Requesting Branch:", 15, 60);
                                doc.setFontStyle("bold");
                                doc.text(requestingBranch, 50 + xCustomPosition, 60);
                                doc.setFontStyle("normal");
                                doc.setFontSize(8 + fontSizeIncreaser);
                            }

                            doc.setFontSize(10 + fontSizeIncreaser);
                            doc.text(currentDocumentTypeFriendlyCode+" Date:", header_position, 50);
                            doc.text(documentDate, value_position, 50);
                            doc.text(((currentDocumentTypeFriendlyCode === 'PWS') ? "Effectivity Date:" : "Target Date:"), header_position, 55);
                            doc.text(targetDate, value_position, 55);
                            if(currentDocumentTypeFriendlyCode != 'PWS') {
                                x_position = 60
                                doc.text("Cancellation  Date:", header_position, x_position);
                                doc.text(cancellationDate, value_position, x_position);
                                doc.text(`${referenceLabel}:`, header_position, x_position + 5);
                                doc.text(reference, value_position, x_position + 5);
                                doc.text("Currency:", header_position, x_position + 10);
                                doc.text(currencyLabel, value_position, x_position + 10);
                                doc.text("Currency Rate:", header_position, x_position + 15);
                                doc.text(currencyRate, value_position, x_position + 15);
                            } else {
                                x_position = 55
                                doc.text(`${referenceLabel}:`, header_position, x_position + 5);
                                doc.text(reference, value_position, x_position + 5);
                                x_position = 45
                                startY = 80
                            }

                            doc.text("Status:", header_position, x_position + 20);
                            doc.text(documentStatus, value_position, x_position + 20);
                            doc.text("Purpose:", 15,  x_position + 20);
                            doc.text(purpose, 40,  x_position + 20);
                            doc.text("Remark:", 15, x_position + 25);
                            doc.text(remark, 40, x_position + 25);

                            let stockNoWidth = 30;

                            if (currentDocumentTypeCode == 'ORIPOX') {
                                stockNoWidth = 18;
                            }

                            doc.line(15, startY, line_position, startY);
                            return {
                                didParseCell: function (table) {
                                    if (table.section === 'head' && (table.column.index == 8 || table.column.index == 9 || table.column.index == 10 || table.column.index == 11 || table.column.index == 12)) {
                                        table.cell.styles.halign = 'right';
                                    }
                                    if(table.section === 'body' && costMaskIndexes.has(table.column.index)){
                                        table.cell.text = '***';
                                    }
                                },
                                // Left undefined for every document type other than
                                // RELRSR, so autoTable registers no hook at all and
                                // nothing extra runs for them. See print().
                                didDrawCell: !alignFooterTotalsToColumns ? undefined : function (data) {
                                    if (data.column.index === quantityPrintColumnIndex) {
                                        printColumnRightEdges.quantity = data.cell.x + data.cell.width - data.cell.padding('right');
                                    }
                                    if (data.column.index === costPrintColumnIndex) {
                                        printColumnRightEdges.cost = data.cell.x + data.cell.width - data.cell.padding('right');
                                    }
                                    if (data.column.index === subtotalPrintColumnIndex) {
                                        printColumnRightEdges.subtotal = data.cell.x + data.cell.width - data.cell.padding('right');
                                    }
                                },
                                didDrawPage: function (data) {
                                    //Main Header
                                    var logobarter = document.getElementById('logobarter');
                                    doc.addImage(logobarter, "PNG", 15, 20, 20, 20);
                                    doc.setFontStyle("bold");
                                    doc.setFontSize(14 + fontSizeIncreaser);
                                    doc.text(currentSiteName, 40, 25);
                                    
                                    doc.setFontSize(9 + fontSizeIncreaser);
                                    const companyName = siteData.company_name || '';
                                    const companyAddress = siteData.company_address || '';
                                    let splitTitle = doc.splitTextToSize(`${companyName}\n${companyAddress}`, 75);
                                    doc.text(40, 30, splitTitle);
                                    doc.setFontSize(14 + fontSizeIncreaser);

                                    doc.setFontStyle("normal");
                                    doc.text(documentType, header_position, 25);
                                    doc.text(
                                      (currentDocumentTypeCode === "RELTRX")
                                        ? "STO#100" + String(documentNumber)
                                        : "# " + String(documentNumber),
                                      header_position,
                                      35
                                    );
                                    doc.setFontSize(8 + fontSizeIncreaser);
                                    doc.text(String(friendlyOriginDocumentNo), header_position, 40);
                                    doc.line(15, 265-minus_height, line_position, 265-minus_height);

                                    // Printed By / Created By / Posted By share one row at
                                    // fixed x anchors. A long user code in the wider
                                    // dot-matrix font runs straight into the next label, so
                                    // flow each pair on from the previous one. Math.max keeps
                                    // the original anchors whenever they already fit, so
                                    // shorter user codes render exactly as before.
                                    var auditRowY = 270 - minus_height;
                                    var auditTextWidth = function (text) {
                                        return doc.getStringUnitWidth(String(text)) * doc.internal.getFontSize() / doc.internal.scaleFactor;
                                    };
                                    var auditRowRight = 0;
                                    [
                                        { label: "Printed By:", value: userCode, labelX: 15, valueX: 35 + xCustomPosition },
                                        { label: "Created By:", value: createdBy, labelX: 70, valueX: 90 + xCustomPosition },
                                        { label: "Posted By:", value: postedBy, labelX: 125, valueX: 145 + xCustomPosition }
                                    ].forEach(function (group) {
                                        var labelX = Math.max(group.labelX, auditRowRight);
                                        var valueX = Math.max(group.valueX, labelX + auditTextWidth(group.label) + 2);
                                        doc.text(group.label, labelX, auditRowY);
                                        doc.text(group.value, valueX, auditRowY);
                                        auditRowRight = valueX + auditTextWidth(group.value) + 3;
                                    });

                                    doc.text("Print Date:", 15, 275-minus_height);
                                    doc.text(printDate, 35 + xCustomPosition, 275-minus_height)
                                    doc.text("Post Date:", 15, 280-minus_height);
                                    doc.text(postDate, 35 + xCustomPosition, 280-minus_height)

                                },
                                startY: startY,
                                margin: {top: 50, bottom: 58},
                                bodyStyles: {
                                    fontSize: 7 + fontSizeIncreaser
                                },
                                headStyles: {
                                    fontSize: 8 + fontSizeIncreaser,
                                    halign: 'center',
                                    valign: 'middle'
                                },
                                styles: {
                                 overflow: 'linebreak',
                                 font: (customFont == 'dotMatrix') ? 'Epson1' : null
                                },
                                // columnStyles: { text: { cellWidth: 'auto' } },
                                theme: 'plain',
                                columnStyles: {
                                    0: {
                                        halign: 'center',
                                        cellWidth: (currentDocumentTypeCode == 'ORIPOX') ? 7 : 'auto'
                                    },
                                    1: {
                                        cellWidth: (currentDocumentTypeCode == 'ORIPOX') ? 14 : 'auto'
                                    },
                                    2: {
                                        halign: (currentDocumentTypeCode == 'ORISOX' || currentDocumentTypeCode == 'RELDDE' || currentDocumentTypeCode == 'OTHSIN' || currentDocumentTypeCode == 'RECCSR' || currentDocumentTypeCode== 'RELTRX') ? 'center' : '',
                                        cellWidth: (currentDocumentTypeCode == 'ORIPOX') ? 'auto' : 25
                                    },
                                    3: {
                                        halign: (currentDocumentTypeCode == 'ORISOX' || currentDocumentTypeCode == 'RELDDE' || currentDocumentTypeCode == 'OTHSIN' || currentDocumentTypeCode == 'RECCSR' || currentDocumentTypeCode== 'RELTRX') ? 'center' : '',
                                        cellWidth: (currentDocumentTypeCode == 'ORIPOX') ? 16 : 'auto'
                                    },
                                    4: {
                                        cellWidth: (currentDocumentTypeCode == 'ORISOX' || currentDocumentTypeCode == 'RELDDE' || currentDocumentTypeCode == 'OTHSIN' || currentDocumentTypeCode == 'RECCSR' || currentDocumentTypeCode== 'RELTRX') ? 25 : (currentDocumentTypeCode == 'ORIPOX') ? 16 : 15
                                    },
                                    5: {
                                        halign: (currentDocumentTypeCode == 'ORIPOX' &&  showRefCode == true && showStockNoInProductList != true)? 'auto' : 'right',
                                        cellWidth: (currentDocumentTypeCode == 'ORIPOX' &&  showRefCode == true && showStockNoInProductList != true) ? 20 : (currentDocumentTypeCode == 'ORIPOX') ? 12 : 15
                                    },

                                    6: {
                                        halign: (currentDocumentTypeCode == 'ORIPOX' &&  showRefCode == true && showStockNoInProductList == true) ?  'auto' : 'right',
                                        cellWidth: (currentDocumentTypeCode == 'ORIPOX' &&  showRefCode == true && showStockNoInProductList == true) ? 25 : (currentDocumentTypeCode == 'RELDDE' || currentDocumentTypeCode == 'OTHSIN') ? 15 : (currentDocumentTypeCode == 'ORIPOX') ? 17 : 20
                                    },
                                    7: {
                                        halign: 'right',
                                        cellWidth: (currentDocumentTypeCode == 'ORIPOX') ? 17 : 15
                                    },
                                    8: {
                                        halign: 'right',
                                        cellWidth: (currentDocumentTypeCode == 'ORISOX' || currentDocumentTypeCode == 'RECCSR' || currentDocumentTypeCode== 'RELTRX') ? 17 : (currentDocumentTypeCode == 'ORIPOX') ? 17 : 15
                                    },
                                    9: {
                                        halign: 'right',
                                        cellWidth: (currentDocumentTypeCode == 'ORIPOX') ? 16 : 15
                                    },
                                    10: {
                                        halign: 'right',
                                    },
                                    11: {
                                        halign: 'right',
                                    },
                                    12: {
                                        halign: 'right',
                                    },
                                    13: {
                                        halign: 'right',
                                    },
                                }
                            };
                        },
                        documentProcessing:function(doc){
                            let showRefCodeAdjustXpos = 13;
                            if(showRefCode!=undefined && showRefCode==true){
                                showRefCodeAdjustXpos += 2;
                            }
                            let quantityTotalWidth = 145 + showRefCodeAdjustXpos;
                            let priceTotalWidth = 163 + showRefCodeAdjustXpos;
                            let subTotalWidth = 178 + showRefCodeAdjustXpos;
                            if (currentDocumentTypeCode == 'RELRSR') {
                                priceTotalWidth = 161;
                                subTotalWidth = 181;
                                // Prefer the actual rendered column right-edges captured
                                // during the table draw so the Quantity / Cost / Subtotal
                                // footer values sit under their columns instead of
                                // overlapping each other and the row values.
                                if (typeof printColumnRightEdges.quantity === 'number') {
                                    quantityTotalWidth = printColumnRightEdges.quantity - total_plus_width;
                                }
                                if (typeof printColumnRightEdges.cost === 'number') {
                                    priceTotalWidth = printColumnRightEdges.cost - total_plus_width;
                                }
                                if (typeof printColumnRightEdges.subtotal === 'number') {
                                    subTotalWidth = printColumnRightEdges.subtotal - total_plus_width;
                                }
                            } else if (currentDocumentTypeCode == 'ORIPOX') {
                                if(showRefCode!=undefined && showRefCode==true){
                                    quantityTotalWidth = 165;
                                    priceTotalWidth = 185;
                                    subTotalWidth = 205;
                                } else {
                                    quantityTotalWidth = 155;
                                    priceTotalWidth = 175;
                                    subTotalWidth = 195;
                                }
                            }else if (currentDocumentTypeCode == 'RECDEL'){
                                if(showRefCode!=undefined && showRefCode==true){
                                    quantityTotalWidth = 168;
                                    priceTotalWidth = 185;
                                    subTotalWidth = 206;
                                } else {
                                    quantityTotalWidth = 168;
                                    priceTotalWidth = 190;
                                    subTotalWidth = 207;
                                }
                            }

                            doc.setFontSize(7 + fontSizeIncreaser);
                            const pageCount = doc.internal.getNumberOfPages();
                            const finalY = doc.lastAutoTable['finalY'];
                            for(var i = 1; i <= pageCount; i++) {
                                doc.setPage(i);
                                doc.text('Page ' + String(i) + ' of ' + String(pageCount),value_position,280 - minus_height);
                            }

                            doc.setFontStyle("bold");
                            var formatMyNumber = function (number, decimal) {
                                var splitNum;
                                number = Math.abs(number);
                                number = number.toFixed(decimal);
                                splitNum = number.split('.');
                                splitNum[0] = splitNum[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                                return splitNum.join(".");
                            }
                            doc.line(15, finalY, line_position, finalY, 'F');

                            // Dot-matrix prints in a noticeably wider font, so the
                            // longest footer label ("Net Amount w/o VAT:") runs
                            // underneath its own right-aligned value at the fixed x=60
                            // anchor. Shift the value column right by just enough to
                            // clear the labels. Stays 0 for every other print format,
                            // so their output is unchanged.
                            var totalsValueShift = 0
                            if (customFont == 'dotMatrix') {
                                var totalsTextWidth = function (text) {
                                    return doc.getStringUnitWidth(String(text)) * doc.internal.getFontSize() / doc.internal.scaleFactor
                                }
                                var totalsLabels = ["Total Quantity:", "Total Cost:", "Subtotal:", "Disc. Amount:",
                                    "Total VAT (" + (component_x.taxRate * 100) + "%):", "Net Amount w/o VAT:", "Total Price:"]
                                var totalsAmounts = [calculation.bottom.quantity, calculation.bottom.price, calculation.bottom.subtotal,
                                    calculation.bottom.price_php, calculation.bottom.subtotal_php, showDiscountAmountValue,
                                    component_x.vatAmount, component_x.netAmountWithoutTax, component_x.netAmount]
                                var widestLabel = 0
                                totalsLabels.forEach(function (label) {
                                    widestLabel = Math.max(widestLabel, totalsTextWidth(label))
                                })
                                var widestAmount = 0
                                totalsAmounts.forEach(function (amount) {
                                    widestAmount = Math.max(widestAmount, totalsTextWidth(formatMyNumber(Number(amount) || 0, 2)))
                                })
                                // labels start at x=15; values are right-aligned at x=60 + shift
                                totalsValueShift = Math.max(0, (15 + widestLabel + 2 + widestAmount) - 60)
                                // never widen so far that the values reach the "Noted By:" column at x=75
                                totalsValueShift = Math.min(totalsValueShift, 13)
                            }

                            // The three column totals under the table are right-aligned
                            // at their column right edges, but a value can be wider than
                            // its own column (e.g. "22,050.00" needs ~16.5mm in a 15mm
                            // Subtotal column) and then spills left over the total beside
                            // it. Walk right-to-left and pull each anchor left until it
                            // clears the value on its right. Only ever moves an anchor
                            // that would otherwise be overprinted.
                            if (alignFooterTotalsToColumns) {
                                var columnTotalWidth = function (text) {
                                    return doc.getStringUnitWidth(String(text)) * doc.internal.getFontSize() / doc.internal.scaleFactor
                                }
                                var widestColumnTotal = function (amounts) {
                                    var widest = 0
                                    amounts.forEach(function (amount) {
                                        widest = Math.max(widest, columnTotalWidth(formatMyNumber(Number(amount) || 0, 2)))
                                    })
                                    return widest
                                }
                                // widest of the base and the *_php conversion variant, since
                                // which one prints depends on the currency branch below
                                var costTotalTextWidth = widestColumnTotal([calculation.bottom.price, calculation.bottom.price_php])
                                var subtotalTotalTextWidth = widestColumnTotal([calculation.bottom.subtotal, calculation.bottom.subtotal_php])
                                var columnTotalsGap = 1.5
                                if (priceTotalWidth > (subTotalWidth - subtotalTotalTextWidth) - columnTotalsGap) {
                                    priceTotalWidth = (subTotalWidth - subtotalTotalTextWidth) - columnTotalsGap
                                }
                                if (quantityTotalWidth > (priceTotalWidth - costTotalTextWidth) - columnTotalsGap) {
                                    quantityTotalWidth = (priceTotalWidth - costTotalTextWidth) - columnTotalsGap
                                }
                            }
                            
                            if(currentDocumentTypeCode != 'OTHPWS'){
                                var positionTQ = 255
                                var positionTC = 259
                                var positionS = 263
                                var postionDA = 0
                                var positionNWOV = 0
                                var positionTP = 0
                                var positionTV = 0
                                if(currentDocumentTypeCode == 'RECADJ' || currentDocumentTypeCode == 'RELADJ'){
                                    positionS-=4
                                }
                                if (showDiscountAmount){
                                    positionTQ-=4
                                    positionTC-=4
                                    positionS-=4
                                    postionDA = positionS+4
                                    positionNWOV+=4
                                    positionTP+=4
                                    positionTV+=4
                                }
                                if (showTotalVat){
                                    positionTQ-=4
                                    positionTC-=4
                                    positionS-=4
                                    postionDA-=4
                                    positionTV = positionS+positionTV+4
                                    positionNWOV+= 4
                                    positionTP+=4
                                }
                                if(showNetAmountWithoutVat){
                                    positionTQ-=4
                                    positionTC-=4
                                    positionS-=4
                                    postionDA-=4
                                    positionTV-=4
                                    positionNWOV = positionS+positionNWOV+4
                                    positionTP+=4
                                }
                                if(showTotalPrice){
                                    positionTQ-=4
                                    positionTC-=4
                                    positionS-=4
                                    postionDA-=4
                                    positionTV-=4
                                    positionNWOV-=4
                                    positionTP = positionS+positionTP+4
                                }
                                if(currencyKey>0 && component_x.showConversionRate){
                                    if((currentDocumentTypeCode != 'OTHTRA' && currentDocumentTypeCode != 'OTHPCK') || isDefaultPrint){
                                        doc.text(doc.splitTextToSize((printQuantityTotal !== null ? printQuantityTotal : calculation.bottom.quantity).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","), 12), quantityTotalWidth+total_plus_width, finalY + 5, 'right')
                                        doc.text((!component_x.accessCostPriceRights.includes('Y') || !component_x.accessCostPriceRights.includes('Z')) ? "***" : doc.splitTextToSize((calculation.bottom.price_php).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","), 15), priceTotalWidth+total_plus_width, finalY + 5, 'right')
                                        doc.text((!component_x.accessCostPriceRights.includes('Y') || !component_x.accessCostPriceRights.includes('Z')) ? "***" : doc.splitTextToSize((calculation.bottom.subtotal_php).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","), 15), subTotalWidth+total_plus_width, finalY + 5, 'right')
                                    }
                                    // End Issue: 1474
                                    doc.text("Total Quantity:", 15, positionTQ-minus_height)
                                    doc.text((printQuantityTotal !== null ? printQuantityTotal : calculation.bottom.quantity).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","), 60 + totalsValueShift, positionTQ-minus_height, 'right')
                                    if(currentDocumentTypeCode != 'RECADJ' && currentDocumentTypeCode != 'RELADJ'){
                                        doc.text("Total Cost:", 15, positionTC-minus_height)
                                        doc.text((!component_x.accessCostPriceRights.includes('Z')) ? "***" : (calculation.bottom.price_php).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","), 60 + totalsValueShift, positionTC-minus_height, 'right')
                                    }
                                    doc.text("Subtotal:", 15, positionS-minus_height)
                                    doc.text(((!component_x.accessCostPriceRights.includes('Z') && (component_x.productPriceChoice == 'landed_cost' || component_x.productPriceChoice == 'ordering_cost' || component_x.productPriceChoice == 'original_cost')) || (!component_x.accessCostPriceRights.includes('Y') && (component_x.productPriceChoice == 'retail_price' || component_x.productPriceChoice == 'wholesale_price'))) ? "***" : (calculation.bottom.subtotal_php).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","), 60 + totalsValueShift, positionS-minus_height, 'right')
                                    if(showDiscountAmount){
                                        doc.text("Disc. Amount:", 15, postionDA-minus_height)
                                        doc.text(formatMyNumber(showDiscountAmountValue, 2), 50 + totalsValueShift, postionDA-minus_height, 'right')
                                    }
                                    if (showTotalVat){
                                        doc.text("Total VAT (" + (component_x.taxRate * 100) + "%):", 15, positionTV-minus_height)
                                        doc.text(formatMyNumber(Math.floor(component_x.vatAmount * 100) / 100, 2), 60 + totalsValueShift, positionTV-minus_height, 'right')
                                    }
                                    if(showNetAmountWithoutVat){
                                        doc.text("Net Amount w/o VAT:", 15, positionNWOV-minus_height)
                                        doc.text(formatMyNumber(Math.floor(component_x.netAmountWithoutTax * 100) / 100, 2), 60 + totalsValueShift, positionNWOV-minus_height, 'right')
                                    }
                                    if(showTotalPrice){
                                        doc.text("Total Price:", 15, positionTP-minus_height)
                                        doc.text((!component_x.accessCostPriceRights.includes('Y')) ? "***" : formatMyNumber(Math.floor(component_x.netAmount * 100) / 100, 2), 60 + totalsValueShift, positionTP-minus_height, 'right')
                                    }
                                    if(showOtherCharges){
                                        for (var index = 1; index <= component_x.chargeData.length; index++) { 
                                            var p = (index == 1) ? positionTQ-minus_height : (index == 2) ? positionTC-minus_height : (index == 3) ? positionS-minus_height : (index == 4) ? (positionS+4)-minus_height : (index == 5) ? (positionS+8)-minus_height : (index == 6) ? (positionS+12)-minus_height : (positionS+16)-minus_height
                                            doc.text(component_x.chargeData[index-1].name+':', 155, p)
                                            doc.text(formatMyNumber(component_x.chargeData[index-1].amount, 2), 190, p, 'right')
                                        }
                                    }
                                }else{
                                    doc.text("Total Quantity:", 15, positionTQ-minus_height)
                                    doc.text(formatMyNumber(printQuantityTotal !== null ? printQuantityTotal : calculation.bottom.quantity, 0), 60 + totalsValueShift, positionTQ-minus_height, 'right')
                                    if(currentDocumentTypeCode != 'RECADJ' && currentDocumentTypeCode != 'RELADJ'){
                                        doc.text("Total Cost:", 15, positionTC-minus_height)
                                        doc.text((!component_x.accessCostPriceRights.includes('Z')) ? "***" : formatMyNumber(calculation.bottom.price, 2), 60 + totalsValueShift, positionTC-minus_height, 'right')
                                    }
                                    doc.text("Subtotal:", 15, positionS-minus_height)
                                    doc.text(((!component_x.accessCostPriceRights.includes('Z') && (component_x.productPriceChoice == 'landed_cost' || component_x.productPriceChoice == 'ordering_cost' || component_x.productPriceChoice == 'original_cost')) || (!component_x.accessCostPriceRights.includes('Y') && (component_x.productPriceChoice == 'retail_price' || component_x.productPriceChoice == 'wholesale_price'))) ? "***" : formatMyNumber(calculation.bottom.subtotal, 2), 60 + totalsValueShift, positionS-minus_height, 'right')
                                    if(showDiscountAmount){
                                        doc.text("Disc. Amount:", 15, postionDA-minus_height)
                                        doc.text(formatMyNumber(showDiscountAmountValue, 2), 60 + totalsValueShift, postionDA-minus_height, 'right')
                                    }
                                    if (showTotalVat){
                                        doc.text("Total VAT (" + (component_x.taxRate * 100) + "%):", 15, positionTV-minus_height)
                                        doc.text(formatMyNumber(Math.floor(component_x.vatAmount * 100) / 100, 2), 60 + totalsValueShift, positionTV-minus_height, 'right')
                                    }
                                    if(showNetAmountWithoutVat){
                                        doc.text("Net Amount w/o VAT:", 15, positionNWOV-minus_height)
                                        doc.text(formatMyNumber(Math.floor(component_x.netAmountWithoutTax * 100) / 100, 2), 60 + totalsValueShift, positionNWOV-minus_height, 'right')
                                    }
                                    if(showTotalPrice){
                                        doc.text("Total Price:", 15, positionTP-minus_height)
                                        doc.text((!component_x.accessCostPriceRights.includes('Y')) ? "***" : formatMyNumber(Math.floor(component_x.netAmount * 100) / 100, 2), 60 + totalsValueShift, positionTP-minus_height, 'right')
                                    }
                                    if(showOtherCharges){
                                        for (var index = 1; index <= component_x.chargeData.length; index++) { 
                                            var p = (index == 1) ? positionTQ-minus_height : (index == 2) ? positionTC-minus_height : (index == 3) ? positionS-minus_height : (index == 4) ? (positionS+4)-minus_height : (index == 5) ? (positionS+8)-minus_height : (index == 6) ? (positionS+12)-minus_height : (positionS+16)-minus_height
                                            doc.text(component_x.chargeData[index-1].name+':', 155, p)
                                            doc.text(formatMyNumber(component_x.chargeData[index-1].amount, 2), 190, p, 'right')
                                        }
                                    }
                                }
                            }
                            doc.setFontStyle("normal");
                            doc.setFontSize(6 + fontSizeIncreaser);
                            doc.text("Noted By:", 95, 252-minus_height)
                            doc.text("______________________________", 115, 252-minus_height)
                            doc.text("Verified By:", 95, 256-minus_height)
                            doc.text("______________________________", 115, 256-minus_height)
                            doc.text("Approved By:", 95, 260-minus_height)
                            doc.text("______________________________", 115, 260-minus_height)
                        }
                    });
                }
                this.spinning = false;
            },
            async print(isDefaultPrint, customFont){
                let headerCustomPosition = 0
                let xCustomPosition = 0
                if(customFont == 'dotMatrix') {
                    headerCustomPosition = -10
                    xCustomPosition = 10
                }
                this.printDefault = isDefaultPrint;
                this.spinning = true;

                var fontSizeIncreaser = this.printFontSizeIncrease || 0
                var valueHeaderPos = this.printValueHeaderPos
                var valueFooterPos = this.printValueFooterPos

                var friendlyOriginDocumentNo = component_x.friendlyOriginDocumentNo || ''
                var currentDocumentTypeCode = this.currentDocumentTypeCode || ''
                var documentType = this.currentDocumentTypeName || ''
                var currentSiteName = secureStorage.getItem("defaultSiteName") || '';
                const currentSiteId = secureStorage.getItem("defaultSiteId") || '';
                let requestingSiteName = this.requestingSite.label;
                let requestingSiteId = this.requestingSite.key;

                var userCode = secureStorage.getItem("userCode") || '';
                var createdBy = this.createdBy || '';
                var postedBy = this.postedBy || '';


                var siteName = this.distributionSite.label || ''
                var customerName = this.customer.label || ''
                var customerAddress = this.customerAddress.trim() || ''

                var supplier = this.supplier.label || ''
                var supplyingBranch = this.supplyingSite.label || ''
                var requestingBranch = this.requestingSite.label || ''
                var sublocationSite = this.distributionSite.label || ''
                var originSublocation =  this.originSublocation.label || ''
                var destinationSublocation = this.destinationSublocation.label || ''
                var party = this.party || ''

                var documentDate = this.documentDate.format('D-MMM-YYYY') || ''
                var targetDate = this.targetDate.format('D-MMM-YYYY') || ''
                var cancellationDate = this.cancellationDate.format('D-MMM-YYYY') || ''

                var currentDocumentTypeFriendlyCode = this.currentDocumentTypeFriendlyCode || ''
                var documentStatus = this.documentStatus || ''
                var documentNumber = this.documentNo || ''

                var reference = this.reference || ''
                var referenceLabel = this.referenceLabel || 'Reference'
                var remark = this.remark || ''
                var purpose = this.purpose.label || ''

                var printDate = moment().format('lll') || '';
                var postDate = this.postDate || ''

                var doc = new jsPDF();
                let currencyKey = component_x.currency.key;
                let currencyLabel = component_x.currency.label;
                let currencyRate = (component_x.documentDetails.currency_rate!=0 && component_x.documentDetails.currency_rate!=null && component_x.documentDetails.currency_rate!=undefined && component_x.documentDetails.currency_rate!='0.0') ? component_x.documentDetails.currency_rate : '1';
                var header_position = 130 + headerCustomPosition
                var value_position = 170
                var line_position = 195
                var total_plus_width = 0
                var minus_height = 0
                var initial_deposit = 0
                var balance = 0
                var orientation = "portrait"
                var papersize = "a4"
                var x_position = 0
                var showDiscountAmountValue = 0
                var showTotalVatValue = 0

                let document_lines = []
                if (this.originDocumentNumber > 0){
                    document_lines = await HTTPRequest.getRequest(this.endPoint+'document_lines/'+this.originDocumentNumber+'?field_name=document_id&origin_sublocation=0', null)
                }
                if ((currentDocumentTypeCode == 'ORISOX' || currentDocumentTypeCode == 'RELDDE' || currentDocumentTypeCode == 'OTHSIN')){
                    if (customFont == 'NVD'){
                        var subtotal = this.tabulator.getColumn("subtotal")
                        await subtotal.updateDefinition({download:false,visible:true})
                        var subtotalnv = this.tabulator.getColumn("subtotal_without_vat")
                        await subtotalnv.updateDefinition({download:true,visible:true})
                    }else{
                        var subtotal = this.tabulator.getColumn("subtotal")
                        await subtotal.updateDefinition({download:true,visible:true})
                        var subtotalnv = this.tabulator.getColumn("subtotal_without_vat")
                        await subtotalnv.updateDefinition({download:false,visible:true})
                    }
                    if((customFont == undefined || customFont == 'NVD')){
                        var discount = this.tabulator.getColumn("discount")
                        await discount.updateDefinition({title: 'Discount',download:true})
                        this.tabulator.moveColumn("discount", "price", true);
                    }
                }
                if (currencyKey>0 && component_x.showConversionRate){
                    var subtotal = this.tabulator.getColumn("subtotal")
                    await subtotal.updateDefinition({download:false})
                    var subtotal_php = this.tabulator.getColumn("subtotal_php")
                    await subtotal_php.updateDefinition({downloadTitle: "Subtotal", download:true})
                    var price = this.tabulator.getColumn("price")
                    await price.updateDefinition({download:false})
                    var cost_php = this.tabulator.getColumn("price_php")
                    await cost_php.updateDefinition({downloadTitle: "Price", download:true})
                }
                if(currentDocumentTypeCode == 'OTHSIN'){
                     var subtotal = this.tabulator.getColumn("quantity")
                    await subtotal.updateDefinition({download:true})
                }
                if(currentDocumentTypeCode == 'OTHPWS'){
                    papersize = "a4"
                    orientation = "landscape"
                    header_position = 220 + headerCustomPosition
                    value_position = 300
                    line_position = 280
                    minus_height = 85
                    total_plus_width = 70
                    var old_landed_cost = this.tabulator.getColumn("old_landed_cost")
                    await old_landed_cost.updateDefinition({download:true})
                    var old_original_cost = this.tabulator.getColumn("old_original_cost")
                    await old_original_cost.updateDefinition({download:true})
                    var original_cost = this.tabulator.getColumn("original_cost")
                    await original_cost.updateDefinition({download:true})
                    var old_ordering_cost = this.tabulator.getColumn("old_ordering_cost")
                    await old_ordering_cost.updateDefinition({downloadTitle: "Old ORD", download:true})
                    var ordering_cost = this.tabulator.getColumn("ordering_cost")
                    await ordering_cost.updateDefinition({downloadTitle: "New ORD", download:true})
                    var old_wholesale_price = this.tabulator.getColumn("old_wholesale_price")
                    await old_wholesale_price.updateDefinition({downloadTitle: "Old WHS Price", download:true})
                    var wholesale_price = this.tabulator.getColumn("wholesale_price")
                    await wholesale_price.updateDefinition({downloadTitle: "New WHS Price", download:true})
                    var old_least_price = this.tabulator.getColumn("old_least_price")
                    await old_least_price.updateDefinition({downloadTitle: "Old LS Price", download:true})
                    var least_price = this.tabulator.getColumn("least_price")
                    await least_price.updateDefinition({downloadTitle: "New LS Price", download:true})
                    var old_special_price = this.tabulator.getColumn("old_special_price")
                    await old_special_price.updateDefinition({downloadTitle: "Old SP Price", download:true})
                    var special_price = this.tabulator.getColumn("special_price")
                    await special_price.updateDefinition({downloadTitle: "New SP Price", download:true})
                    var markup_percent = this.tabulator.getColumn("markup_percent")
                    await markup_percent.updateDefinition({downloadTitle: "Markup %", download:true, accessorParams:{}, 
                        accessor:function(value, data, accessorParams){
                            return Number(value).toFixed(2);
                        }})
                    var document_line_serials_text = this.tabulator.getColumn("document_line_serials_text")
                    await document_line_serials_text.updateDefinition({download:false})
                    var price = this.tabulator.getColumn("price")
                    await price.updateDefinition({download:false})
                    var subtotal = this.tabulator.getColumn("subtotal")
                    await subtotal.updateDefinition({download:false})
                    const columns = ["original_cost", "least_price", "wholesale_price", "special_price", "ordering_cost"];
                    const rowData = this.tabulator.getData();
                    rowData.forEach((row) => {
                        columns.forEach((col) => {
                            if (row[col] === null) {
                            row[col] = "";
                            }
                        });
                    });
                    this.tabulator.setData(rowData);


                }
                if(currentDocumentTypeCode == 'ORIPOX' || currentDocumentTypeCode == 'OTHTRA' || currentDocumentTypeCode == 'OTHPCK'){
                    var priceInclusion = this.documentDetails.reference_8 || ''
                    var comment1 = this.documentDetails.reference_9 || ''
                    var comment2 = this.documentDetails.reference_10 || ''
                }
                var showErpCode = false,showStockNoInProductList = false
                var printSettingEnabledCount = 0;
                if (this.document_config.document_type_settings.printSettings!= undefined){
                    showErpCode = this.document_config.document_type_settings.printSettings.showErpCode
                    showStockNoInProductList = this.document_config.document_type_settings.printSettings.showStockNoInProductList
                    if(showErpCode != undefined && showErpCode == true){
                        printSettingEnabledCount +=1
                        var erp_code = this.tabulator.getColumn("erp_code")
                        erp_code.updateDefinition({download: true})
                    }
                    
                    if(currentDocumentTypeCode == 'ORIPOX' && showStockNoInProductList != undefined && showStockNoInProductList == true){
                        printSettingEnabledCount +=1
                        var supplier_stock_no = this.tabulator.getColumn("supplier_stock_no")
                        supplier_stock_no.updateDefinition({download:true})
                        if (this.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.enableShowingSupplierStockNumber!=undefined && this.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.enableShowingSupplierStockNumber==true) {
                            this.tabulator.showColumn("supplier_stock_no")
                        }
                    }
                    if(this.document_config.document_type_settings.printSettings.showSerialNoInProductList != undefined && this.document_config.document_type_settings.printSettings.showSerialNoInProductList == true){
                        printSettingEnabledCount +=1
                        var supplier_stock_no = this.tabulator.getColumn("document_line_serials_text")
                        supplier_stock_no.updateDefinition({download:true})
                    }
                    if(this.document_config.document_type_settings.printSettings.showDesignAndSizeInProductList != undefined && this.document_config.document_type_settings.printSettings.showDesignAndSizeInProductList == true){
                        printSettingEnabledCount +=2
                        var design = this.tabulator.getColumn("design")
                        design.updateDefinition({download:true})
                        var size = this.tabulator.getColumn("size")
                        size.updateDefinition({download:true})
                    }
                    if(this.document_config.document_type_settings.printSettings.enableShowingInitialDepositField!=undefined && this.document_config.document_type_settings.printSettings.enableShowingInitialDepositField==true){
                        printSettingEnabledCount +=1
                        this.showDocumentPayment("initialDeposit")
                        initial_deposit = Number(this.documentPaymentsList.reduce(function(prev, cur) { return Number(prev) + Number(cur.amount); }, 0)) || Number(this.documentDetails.reference_7) || 0
                    }
                    if(this.document_config.document_type_settings.printSettings.enableLandscapePrinting != undefined && this.document_config.document_type_settings.printSettings.enableLandscapePrinting == true){
                        orientation = "landscape"
                        header_position = 220 + headerCustomPosition
                        value_position = 260
                        line_position = 280
                        minus_height = 85
                        if (currentDocumentTypeCode == 'ORIPOX' && !this.document_config.document_type_settings.printSettings.showStockNoInProductList){
                            total_plus_width = 58
                        }else {
                            total_plus_width = 66
                        }
                        if(!this.document_config.document_type_settings.printSettings.showSerialNoInProductList){
                            total_plus_width = 78
                        }
                    }         

                    if(this.document_config.document_type_settings.printSettings.showTotalVat != undefined && this.document_config.document_type_settings.printSettings.showTotalVat == true){
                        var showTotalVat = this.document_config.document_type_settings.printSettings.showTotalVat
                        showTotalVatValue = this.documentDetails.tax_amount
                    }
                    if(this.document_config.document_type_settings.printSettings.showNetAmountWithoutVat != undefined && this.document_config.document_type_settings.printSettings.showNetAmountWithoutVat == true){
                        var showNetAmountWithoutVat = this.document_config.document_type_settings.printSettings.showNetAmountWithoutVat
                    }
                    if(this.document_config.document_type_settings.printSettings.showTotalPrice != undefined && this.document_config.document_type_settings.printSettings.showTotalPrice == true){
                        var showTotalPrice = this.document_config.document_type_settings.printSettings.showTotalPrice
                    }
                    if(this.document_config.document_type_settings.printSettings.showDiscountAmount != undefined && this.document_config.document_type_settings.printSettings.showDiscountAmount == true){
                        var showDiscountAmount = this.document_config.document_type_settings.printSettings.showDiscountAmount
                        showDiscountAmountValue = Number(this.itemDiscount || 0) + Number(this.overallDiscount || 0) 
                    }
                    if(this.document_config.document_type_settings.printSettings.showOtherCharges != undefined && this.document_config.document_type_settings.printSettings.showOtherCharges == true){
                        var showOtherCharges = this.document_config.document_type_settings.printSettings.showOtherCharges
                    }
                }

                let tempdata = this.tabulator.getData();
                var column_names = []
                if(currentDocumentTypeCode =='OTHCNS'){
                    let document_lines = await HTTPRequest.getRequest(component_x.endPoint + "documents/get_count_set_pcount_lines?id="+component_x.documentNumber, null);
                    this.tabulator.replaceData(document_lines)
                    this.tabulator.toggleColumn("line_no")
                    this.tabulator.toggleColumn("product_name")
                    this.tabulator.toggleColumn("stock_no")
                    this.tabulator.toggleColumn("barcode")
                    this.tabulator.toggleColumn("unit_name")
                    this.tabulator.toggleColumn("quantity")
                    this.tabulator.getColumn('actual_quantity').updateDefinition({title:"Frozen Quantity"})
                    this.tabulator.toggleColumn("actual_quantity")
                    this.tabulator.toggleColumn("price")
                    this.tabulator.toggleColumn("cost")
                    this.tabulator.toggleColumn("subtotal")
                    this.tabulator.toggleColumn("on_hand_quantity")
                }else if ((currentDocumentTypeCode == 'OTHTRA' || currentDocumentTypeCode == 'OTHPCK') && isDefaultPrint == false){
                    var lines = this.tabulator.getData();
                    for(var i = 0; i < lines.length; i++) {
                        if (lines[i].site_allocation!=undefined && lines[i].site_allocation!=null){
                            lines[i].site_allocation.forEach(function(obj) {
                                if (currentDocumentTypeCode=='OTHPCK'){
                                    var qty = (obj.available_quantity == 0 || obj.available_quantity == undefined) ? obj.quantity : obj.available_quantity
                                    if(component_x.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.AllocationDefaultValue == 'SC'){
                                        lines[i][`${obj.code}`] = qty
                                    } else {
                                        lines[i][`${obj.refcode}`] = qty
                                    }
                                }else{
                                    var qty = (obj.quantity == 0) ? '' : obj.quantity
                                    if(component_x.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.AllocationDefaultValue == 'SC'){
                                        lines[i][`${obj.code}`] = qty
                                    } else {
                                        lines[i][`${obj.refcode}`] = qty
                                    }
                                }
                                if (!column_names.includes(obj.code) && component_x.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.AllocationDefaultValue == 'SC') {
                                    column_names.push(obj.code);
                                }

                                if (!column_names.includes(obj.refcode) && component_x.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.AllocationDefaultValue == 'RC') {
                                    column_names.push(obj.refcode);
                                }
                            });
                        }
                    }
                    this.tabulator.replaceData(lines)
                    for (var index = 0; index < column_names.length; index++) { this.tabulator.addColumn({title:column_names[index], field:column_names[index], download: true, visible:false, align: 'right'}) }
                    if (column_names.length > 5){
                        this.continueWithPrintPdf = false
                        this.$confirm({
                        title: "Allocation is more than 5 sites, print to pdf is not possible",
                        content: h => <div>Do you want to export this via excel?</div>,
                        onOk: () => {
                            this.downLoadExcelIfMoreThan5Site()
                        },
                        onCancel() {}
                        });
                    }
                }

                let siteData = {};
                let supplierData = {};
                if (this.continueWithPrintPdf){
                    if (currentDocumentTypeCode == 'ORIPOX' || currentDocumentTypeCode == 'RELRSR' || currentDocumentTypeCode == 'RECDEL' || currentDocumentTypeCode == 'OTHPUR' || currentDocumentTypeCode == 'OTHSBI' || currentDocumentTypeCode == 'ORIASN') {
                    requestingSiteId = this.documentDetails.site_id.key
                    requestingSiteName = this.documentDetails.site_id.label
                    siteData = await HTTPRequest.getRequest(`${this.endPoint}sites/${requestingSiteId}` , null, null);
                    supplierData = await HTTPRequest.getRequest(`${this.endPoint}suppliers/${this.supplier.key}` , null, null);
                        if(currentDocumentTypeCode == 'ORIPOX' && component_x.document_config.document_type_settings.printSettings.includeImageInPrintout!=undefined && component_x.document_config.document_type_settings.printSettings.includeImageInPrintout == true){
                            var imgLogo = new Image()
                            var arrImgLogos = []
                            var config = {
                                method: 'get',
                                url: `${this.endPoint}documents/get_product_image?stock_no=${this.tabulator.getData()[0].stock_no}`,
                                headers: {'Authorization': 'Bearer ' + secureStorage.getItem("accessToken"), 'Request-Source':"BXI-Web", 'ip':secureStorage.getItem("ipAddress")},
                                // headers: {'Authorization': 'Bearer ' + 'BX-pG09P8sgsNKczX9CtRaxNeH7S_kD6NCuxC3Twzo0'},
                            }
                            var imageResponse;
                            await axios(config)
                                .then(function (response) {
                                    imageResponse = response.data
                                })
                                .catch(function (error) {
                                    console.log(error)
                            });

                            if(imageResponse["error"] == undefined){
                                if (imageResponse.images_url != undefined && imageResponse.images_url.length > 0){
                                    for(let  i = 0; i < imageResponse.images_url.length; i++){
                                        var img = new Image()
                                        img.src = imageResponse.images_url[i]
                                        arrImgLogos.push(img)
                                    }
                                }
                                else if (imageResponse.image != undefined && imageResponse.image != ""){
                                    imgLogo.src = "data:image/"+imageResponse.file_type+";base64,"+imageResponse.image
                                    var stock_no = this.tabulator.getData()[0].stock_no
                                }
                            }
                            console.log(arrImgLogos)
                        }
                    }
                    let tabulatorInstance = this.$refs.tabulator.getInstance();
                    var calculation = tabulatorInstance.getCalcResults();
                    // Field-name based cost/price column masking (robust to column order changes)
                    var costMaskIndexes = this.getPrintCostMaskColumnIndexes(tabulatorInstance);

                    // Print-column indexes for the Quantity / Unit Cost / Subtotal
                    // columns so the footer column totals can be aligned to the
                    // actual rendered columns (fixes the overlapping totals on the
                    // Purchase Return printout). Scoped to RELRSR only for now; can
                    // be extended to other document types once confirmed.
                    //
                    // The printed "Unit Cost" column is the `price` field, not `cost`
                    // (`cost` / "Unit Net Cost" is download:false so it never prints),
                    // and the *_php variants replace `price` / `subtotal` when a
                    // conversion rate is shown. Each anchor therefore resolves against
                    // a list of candidate fields in print priority order.
                    var alignFooterTotalsToColumns = (currentDocumentTypeCode == 'RELRSR');
                    var quantityPrintColumnIndex = alignFooterTotalsToColumns ? this.getPrintColumnIndexByField(tabulatorInstance, ['quantity']) : -1;
                    var costPrintColumnIndex = alignFooterTotalsToColumns ? this.getPrintColumnIndexByField(tabulatorInstance, ['price_php', 'price', 'cost_php', 'cost']) : -1;
                    var subtotalPrintColumnIndex = alignFooterTotalsToColumns ? this.getPrintColumnIndexByField(tabulatorInstance, ['subtotal_php', 'subtotal', 'subtotal_without_vat']) : -1;
                    // Captured right-edge x positions of those columns, filled in by
                    // the autoTable didDrawCell hook below.
                    var printColumnRightEdges = {};

                    // Fix: Use actual_quantity for posted & fulfilled RELTRX (STO) documents
                    var documentOrderStatusForPrint = this.documentOrderStatus || ''
                    var useActualQuantityForPrint = (currentDocumentTypeCode === 'RELTRX' && documentStatus === 'Posted' && documentOrderStatusForPrint === 'Fulfilled')
                    var totalActualQuantity = 0
                    if (useActualQuantityForPrint) {
                        var tabulatorDataForPrint = this.tabulator.getData()
                        tabulatorDataForPrint.forEach(function(row) { totalActualQuantity += Number(row.actual_quantity || 0) })
                    }
                    var printQuantityTotal = useActualQuantityForPrint ? totalActualQuantity : null

                    var startY = 90

                    tabulatorInstance.downloadToTab("pdf", "data"+isDefaultPrint+".pdf", {
                        orientation:orientation,
                        jsPDF:{
                            unit:"mm",
                            putOnlyUsedFonts:true,
                            format:papersize
                        },
                        autoTable:function(doc){
                            //HEADER
                            doc.addFileToVFS('Epson1-normal.ttf', Epsonfont);
                            doc.addFont('Epson1-normal.ttf', 'Epson1', 'normal');
                            doc.addFileToVFS('Epson1-bold.ttf', Epsonfontbold);
                            doc.addFont('Epson1-bold.ttf', 'Epson1', 'bold');
                            if(customFont == 'dotMatrix'){
                                doc.setFont("Epson1");
                            }
                            if (currentDocumentTypeCode == 'ORISOX' || currentDocumentTypeCode == 'OTHSIN' || currentDocumentTypeCode == 'RELDDE' || currentDocumentTypeCode == 'RECCSR') {
                                doc.setFontSize(10 + fontSizeIncreaser);
                                doc.text("Site:", 15, 50);
                                doc.setFontStyle("bold");
                                doc.text(siteName, 40, 50);
                                doc.setFontStyle("normal");

                                doc.text("Customer:", 15, 60);
                                doc.setFontStyle("bold");
                                // Constrain width so a long customer name does not overlap the
                                // right-hand column (Cancellation Date etc.) which starts at header_position.
                                var customerNameMaxWidth = (header_position - 40) - 5;
                                doc.text(doc.splitTextToSize(String(customerName), customerNameMaxWidth), 40, 60);
                                doc.setFontStyle("normal");
                                doc.setFontSize(8 + fontSizeIncreaser);

                                if (customerAddress.length > 50){
                                    var cut = customerAddress.length /4;
                                    doc.text(customerAddress.slice(0, cut).trim(), 40, 65);
                                    doc.text(customerAddress.slice(cut, cut*2).trim(), 40, 70);
                                    doc.text(customerAddress.slice(cut*2, cut*3).trim(), 40, 75);
                                    doc.text(customerAddress.slice(cut*3, cut*4).trim(), 40, 80);
                                }else {
                                    doc.text(customerAddress, 40, 65);
                                }
                            }

                            // Lowest y the Purpose / Reference / Remark rows may use,
                            // or 0 for document types that print no supplier block.
                            // The Supplier / Address / TIN block grows downward from
                            // y=50 by however many lines the data wraps into, while the
                            // rows underneath it are drawn at a fixed y - so a long
                            // supplier name or address (more so in the wider dot-matrix
                            // font) makes the TIN line overprint "Purpose:". This keeps
                            // one full line of separation below the block.
                            var leftDetailsMinY = 0;

                            if (currentDocumentTypeCode == 'OTHPUR' || currentDocumentTypeCode == 'RECDEL' ||
                                currentDocumentTypeCode == 'OTHSBI' || currentDocumentTypeCode == 'ORIASN') {
                                doc.setFontSize(10 + fontSizeIncreaser);
                                doc.setFontStyle("bold");
                                const supplierAddress = supplierData.billing_address || '';
                                const tin = supplierData.tin || '';
                                let splitTitle = doc.splitTextToSize(`Supplier: ${supplier}\nAddress: ${supplierAddress}\nTIN #: ${tin}`, 75);
                                doc.text(15, 50, splitTitle);
                                leftDetailsMinY = 50 + (splitTitle.length * (doc.internal.getLineHeight() / doc.internal.scaleFactor));
                                doc.setFontStyle("normal");
                                }

                            if (currentDocumentTypeCode == 'ORIPOX' || currentDocumentTypeCode == 'RELRSR' ) {
                                doc.setFontSize(10 + fontSizeIncreaser);
                                doc.setFontStyle("bold");
                                const supplierName = supplierData.name || '';
                                const supplierAddress = supplierData.billing_address || '';
                                const tin = supplierData.tin || '';
                                let splitTitle = doc.splitTextToSize(`Supplier: ${supplierName}\nAddress: ${supplierAddress}\nTIN #: ${tin}`, 75);
                                doc.text(15, 50, splitTitle);
                                leftDetailsMinY = 50 + (splitTitle.length * (doc.internal.getLineHeight() / doc.internal.scaleFactor));
                                doc.setFontStyle("normal");
                            }

                            if (currentDocumentTypeCode == 'ORITRQ' || currentDocumentTypeCode == 'OROTRQ' || currentDocumentTypeCode == 'RELTRX' || currentDocumentTypeCode == 'RECTRX' || currentDocumentTypeCode == 'ORICSQ' || currentDocumentTypeCode == 'OROCSQ' || currentDocumentTypeCode == 'RELCSX' || currentDocumentTypeCode == 'RECCSX') {
                                doc.setFontSize(10 + fontSizeIncreaser);
                                doc.text("Supplying Branch:", 15, 50);
                                doc.setFontStyle("bold");
                                doc.text(supplyingBranch, 50 + xCustomPosition, 50);
                                doc.setFontStyle("normal");

                                doc.text("Requesting Branch:", 15, 60);
                                doc.setFontStyle("bold");
                                doc.text(requestingBranch, (fontSizeIncreaser != 0 ? 52 : 50) + xCustomPosition, 60);
                                doc.setFontStyle("normal");
                                doc.setFontSize(8 + fontSizeIncreaser);
                            }

                            if (currentDocumentTypeCode == 'RELSLO' || currentDocumentTypeCode == 'RECSLI') {
                                doc.setFontSize(10 + fontSizeIncreaser);
                                doc.text("Site:", 15, 50);
                                doc.setFontStyle("bold");
                                doc.text(sublocationSite, 40, 50);
                                doc.setFontStyle("normal");

                                doc.text("Origin:", 15, 60);
                                doc.setFontStyle("bold");
                                doc.text(originSublocation, 40, 60);
                                doc.setFontStyle("normal");

                                doc.text("Destination:", 15, 70);
                                doc.setFontStyle("bold");
                                doc.text(destinationSublocation, 40, 70);
                                doc.setFontStyle("normal");
                                doc.setFontSize(8 + fontSizeIncreaser);

                            }

                            if (currentDocumentTypeCode == 'RECADJ' || currentDocumentTypeCode == 'RELADJ') {
                                doc.setFontSize(10 + fontSizeIncreaser);
                                doc.text("Party:", 15, 50);
                                doc.setFontStyle("bold");
                                doc.text(party, 40, 50);
                                doc.setFontStyle("normal");
                            }

                            doc.setFontSize(10 + fontSizeIncreaser);
                            doc.text(currentDocumentTypeFriendlyCode+" Date:", header_position, 50);
                            doc.text(documentDate, value_position, 50);
                            doc.text(((currentDocumentTypeFriendlyCode === 'PWS') ? "Effectivity Date:" : "Target Date:"), header_position, 55);
                            doc.text(targetDate, value_position, 55);
                            if(currentDocumentTypeFriendlyCode != 'PWS') {
                                x_position = 60
                                doc.text("Cancellation  Date:", header_position, x_position);
                                doc.text(cancellationDate, value_position, x_position);
                                doc.text("Currency:", header_position, x_position + 5);
                                doc.text(currencyLabel, value_position, x_position + 5);
                                doc.text("Currency Rate:", header_position, x_position + 10);
                                doc.text(currencyRate, value_position, x_position + 10);
                            } else {
                                x_position = 55
                                x_position = 45
                                startY = 80
                            }

                            doc.text("Status:", header_position, x_position + 15);
                            doc.text(documentStatus, value_position, x_position + 15);
                            // Start the left-hand rows below the supplier block when it
                            // has grown far enough down to reach them. Unchanged (and
                            // skipped entirely) whenever the block is short enough or
                            // the document type prints no supplier block at all.
                            var leftDetailsY = x_position + 15;
                            if (leftDetailsMinY > leftDetailsY) {
                                leftDetailsY = leftDetailsMinY;
                            }
                            doc.text("Purpose:", 15,  leftDetailsY);
                            doc.text(purpose, 40,  leftDetailsY);
                            doc.text("Reference:", 15, leftDetailsY + 5);
                            doc.text(reference, 40, leftDetailsY + 5);
                            doc.text("Remark:", 15, leftDetailsY + 10);
                            doc.text(remark, 40, leftDetailsY + 10);
                            // Keep the table's top rule clear of the Remark row if the
                            // rows above had to be pushed down.
                            if (leftDetailsY + 15 > startY) {
                                startY = leftDetailsY + 15;
                            }
                            if(currentDocumentTypeCode == 'ORIPOX' || currentDocumentTypeCode == 'RECDEL'){
                                if (component_x.document_config.document_type_settings.printSettings!= undefined){
                                    if(component_x.document_config.document_type_settings.printSettings.enableShowingPriceInclusionField!=undefined && component_x.document_config.document_type_settings.printSettings.enableShowingPriceInclusionField==true){
                                        doc.text("Price Inclusion:", 15, 90);
                                        doc.text(priceInclusion, 40, 90);
                                    }
                                    if(component_x.document_config.document_type_settings.printSettings.enableShowingComment1Field!=undefined && component_x.document_config.document_type_settings.printSettings.enableShowingComment1Field==true){
                                        doc.text("Comment 1:", 15, 95);
                                        doc.text(comment1, 40, 95);
                                    }
                                    if(component_x.document_config.document_type_settings.printSettings.enableShowingComment2Field!=undefined && component_x.document_config.document_type_settings.printSettings.enableShowingComment2Field==true){
                                        doc.text("Comment 2:", 15, 100);
                                        doc.text(comment2, 40, 100);
                                    }
                                    if(component_x.document_config.document_type_settings.printSettings.enableShowingInitialDepositField!=undefined && component_x.document_config.document_type_settings.printSettings.enableShowingInitialDepositField==true){
                                        doc.text("Initial Deposit:", header_position, 90);
                                        doc.text(initial_deposit.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","), value_position, 90);
                                    }
                                    if(component_x.document_config.document_type_settings.printSettings.enableShowingBalanceField!=undefined && component_x.document_config.document_type_settings.printSettings.enableShowingBalanceField==true){
                                        balance = (calculation.bottom.subtotal).toFixed(2) - initial_deposit.toFixed(2)
                                        doc.text("Balance:", header_position, 95);
                                        doc.text(balance.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","), value_position, 95);
                                    }
                                }
                                startY = 105
                                doc.text("Total:", header_position, 100);
                                doc.text(((!component_x.accessCostPriceRights.includes('Z') && (component_x.productPriceChoice == 'landed_cost' || component_x.productPriceChoice == 'ordering_cost' || component_x.productPriceChoice == 'original_cost')) || (!component_x.accessCostPriceRights.includes('Y') && (component_x.productPriceChoice == 'retail_price' || component_x.productPriceChoice == 'wholesale_price'))) ? "***" : calculation.bottom.subtotal.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","), value_position, 100);
                            }

                            let stockNoWidth = 30;

                            if (currentDocumentTypeCode == 'RELRSR' || currentDocumentTypeCode == 'RELDEL') {
                                stockNoWidth = 20;
                            }

                            if (currentDocumentTypeCode == 'ORIPOX') {
                                stockNoWidth = 18;
                            }

                            doc.line(15, startY, line_position, startY);
                            return {
                                didParseCell: function (table) {
                                    // Align headers for certain columns
                                    if (
                                        table.section === 'head' &&
                                        [8, 9, 10, 11, 12].includes(table.column.index)
                                    ) {
                                        table.cell.styles.halign = 'right';
                                    }
                                
                                    // Cost hiding logic for body section:
                                    // mask cost/price columns identified by field name.
                                    if (table.section === 'body' && costMaskIndexes.has(table.column.index)) {
                                        table.cell.text = '***';
                                    }
                                },
                                // Capture the actual right-edge x position of the
                                // Quantity / Cost / Subtotal columns so the footer
                                // totals can be right-aligned under them instead of
                                // using hardcoded x positions that overlap each other
                                // and the row values.
                                //
                                // Deliberately left undefined for every document type
                                // other than RELRSR: autoTable only registers a hook
                                // when it is truthy, so no other document type runs
                                // any of this.
                                didDrawCell: !alignFooterTotalsToColumns ? undefined : function (data) {
                                    if (data.column.index === quantityPrintColumnIndex) {
                                        printColumnRightEdges.quantity = data.cell.x + data.cell.width - data.cell.padding('right');
                                    }
                                    if (data.column.index === costPrintColumnIndex) {
                                        printColumnRightEdges.cost = data.cell.x + data.cell.width - data.cell.padding('right');
                                    }
                                    if (data.column.index === subtotalPrintColumnIndex) {
                                        printColumnRightEdges.subtotal = data.cell.x + data.cell.width - data.cell.padding('right');
                                    }
                                },
                                didDrawPage: function (data) {
                                    //Main Header
                                    var logobarter = document.getElementById('logobarter');
                                    doc.addImage(logobarter, "PNG", 15, 20, 20, 20);
                                    doc.setFontStyle("bold");
                                    doc.setFontSize(14 + fontSizeIncreaser);
                                    if (currentDocumentTypeCode == 'ORIPOX' || currentDocumentTypeCode == 'RELRSR') {
                                    doc.text(requestingSiteName, 40, 25);
                                    } else {
                                    doc.text(currentSiteName, 40, 25);
                                    }


                                    if (currentDocumentTypeCode == 'ORIPOX' || currentDocumentTypeCode == 'RELRSR' || currentDocumentTypeCode == 'RECDEL' || currentDocumentTypeCode == 'OTHPUR' || currentDocumentTypeCode == 'OTHSBI' || currentDocumentTypeCode == 'ORIASN') {
                                    doc.setFontSize(9 + fontSizeIncreaser);
                                    const companyName = siteData.company_name || '';
                                    const companyAddress = siteData.company_address || '';
                                    const tin = siteData.tin || '';
                                    let splitTitle = doc.splitTextToSize(`Company Name: ${companyName}\nAddress: ${companyAddress}`, 75);
                                    doc.text(40, 30, splitTitle);
                                    doc.setFontSize(14 + fontSizeIncreaser);
                                    }

                                    doc.setFontStyle("normal");
                                    doc.text(documentType, header_position, 25);

                                    var isCasFormat = (component_x.formPrintFormat == 'cas_default')

                                    // For the CAS Document format, hide the document number and show the CAS number instead.
                                    if (isCasFormat) {
                                        if (component_x.documentDetails && component_x.documentDetails.cas_number) {
                                            doc.text(String(component_x.documentDetails.cas_number), header_position, 35);
                                        }
                                    } else {
                                        doc.text("# "+String(documentNumber), header_position, 35);
                                    }
                                    doc.setFontSize(8 + fontSizeIncreaser);
                                    doc.text(String(friendlyOriginDocumentNo), header_position, 40);
                                    doc.line(15, 265-minus_height, line_position, 265-minus_height);

                                    if (isCasFormat && component_x.documentDetails && component_x.documentDetails.cas_details) {
                                        // CAS footer: company CAS setup on the LEFT, signatory block on the RIGHT,
                                        // aligned row-by-row (Printed By aligns with Acknowledgement Certificate, etc.).
                                        var casDetails = component_x.documentDetails.cas_details
                                        var casPrevFontSize = doc.internal.getFontSize()
                                        doc.setFontSize(7 + fontSizeIncreaser)

                                        // Left column
                                        doc.text("Acknowledgement Certificate: " + String(casDetails.permit_no || ''), 15, 270-minus_height)
                                        doc.text("Date Issued: " + String(casDetails.date_issue || ''), 15, 275-minus_height)
                                        doc.text("Serial Number Range: " + String(casDetails.serial_range || ''), 15, 280-minus_height)

                                        // Right column (aligned to the same baselines as the left column)
                                        doc.text("Printed By:", 140, 270-minus_height);
                                        doc.text(userCode, 160 + xCustomPosition, 270-minus_height);
                                        doc.text("Print Date:", 140, 275-minus_height);
                                        doc.text(printDate, 160 + xCustomPosition, 275-minus_height)
                                        doc.text("Post Date:", 140, 280-minus_height);
                                        doc.text(postDate, 160 + xCustomPosition, 280-minus_height)

                                        doc.setFontSize(casPrevFontSize)
                                    } else {
                                        // Default layout. Printed By / Created By / Posted By
                                        // share one row at fixed x anchors. A long user code in
                                        // the wider dot-matrix font runs straight into the next
                                        // label, so flow each pair on from the previous one.
                                        // Math.max keeps the original anchors whenever they
                                        // already fit, so shorter user codes render as before.
                                        var auditRowY = 270 - minus_height;
                                        var auditTextWidth = function (text) {
                                            return doc.getStringUnitWidth(String(text)) * doc.internal.getFontSize() / doc.internal.scaleFactor;
                                        };
                                        var auditRowRight = 0;
                                        [
                                            { label: "Printed By:", value: userCode, labelX: 15, valueX: 35 + xCustomPosition },
                                            { label: "Created By:", value: createdBy, labelX: 70, valueX: 90 + xCustomPosition },
                                            { label: "Posted By:", value: postedBy, labelX: 125, valueX: 145 + xCustomPosition }
                                        ].forEach(function (group) {
                                            var labelX = Math.max(group.labelX, auditRowRight);
                                            var valueX = Math.max(group.valueX, labelX + auditTextWidth(group.label) + 2);
                                            doc.text(group.label, labelX, auditRowY);
                                            doc.text(group.value, valueX, auditRowY);
                                            auditRowRight = valueX + auditTextWidth(group.value) + 3;
                                        });

                                        doc.text("Print Date:", 15, 275-minus_height);
                                        doc.text(printDate, 35 + xCustomPosition, 275-minus_height)
                                        doc.text("Post Date:", 15, 280-minus_height);
                                        doc.text(postDate, 35 + xCustomPosition, 280-minus_height)
                                    }

                                },
                                startY: startY,
                                margin: {top: 50, bottom: 58},
                                bodyStyles: {
                                    fontSize: (customFont == 'dotMatrix' && fontSizeIncreaser == 0) ? 8 + fontSizeIncreaser : 7 + fontSizeIncreaser 
                                    
                                },
                                headStyles: {
                                    halign: 'center',
                                    valign: 'middle',
                                    fontSize: (customFont == 'dotMatrix' && fontSizeIncreaser == 0) ? 9 + fontSizeIncreaser : 8 + fontSizeIncreaser
                                },
                                styles: {
                                 overflow: 'linebreak',
                                 font: (customFont == 'dotMatrix') ? 'Epson1' : null
                                },
                                // columnStyles: { text: { cellWidth: 'auto' } },
                                theme: 'plain',
                                columnStyles: {
                                    0: {
                                        halign: 'center',
                                        cellWidth: (currentDocumentTypeCode == 'ORIPOX') ? 7 : 'auto'
                                    },
                                    1: {
                                        cellWidth: (currentDocumentTypeCode == 'ORIPOX') ? 14 : 'auto'
                                    },
                                    2: {
                                        halign: (currentDocumentTypeCode == 'ORISOX' || currentDocumentTypeCode == 'RELDDE' || currentDocumentTypeCode == 'OTHSIN' || currentDocumentTypeCode == 'RECCSR' || currentDocumentTypeCode== 'RELTRX') ? 'left' : '',
                                        cellWidth: (currentDocumentTypeCode == 'ORIPOX') ? 'auto' : (currentDocumentTypeCode == 'ORISOX' || currentDocumentTypeCode == 'RELDDE' || currentDocumentTypeCode == 'OTHSIN') ? 16 : 25
                                    },
                                    3: {
                                        halign: (currentDocumentTypeCode == 'ORISOX' || currentDocumentTypeCode == 'RELDDE' || currentDocumentTypeCode == 'OTHSIN' || currentDocumentTypeCode == 'RECCSR' || currentDocumentTypeCode== 'RELTRX') ? 'left' : '',
                                        cellWidth: (currentDocumentTypeCode == 'ORIPOX') ? 16 : 'auto'
                                    },
                                    4: {
                                        cellWidth: (currentDocumentTypeCode == 'ORISOX' || currentDocumentTypeCode == 'RELDDE' || currentDocumentTypeCode == 'OTHSIN' || currentDocumentTypeCode == 'RECCSR' || currentDocumentTypeCode== 'RELTRX') ? (showErpCode != true ? 15 :8) : (currentDocumentTypeCode == 'ORIPOX') ? 16 : 15
                                    },
                                    5: {
                                        halign: (currentDocumentTypeCode == 'ORIPOX' &&  showErpCode == true && showStockNoInProductList != true)? 'auto' : 'right',
                                        cellWidth: (currentDocumentTypeCode == 'ORIPOX' &&  showErpCode == true && showStockNoInProductList != true) ? 18 : showErpCode == true ? 29 : (currentDocumentTypeCode == 'ORIPOX') ? 18 : 15
                                    },

                                    6: {
                                        halign: (currentDocumentTypeCode == 'ORIPOX' &&  showErpCode == true && showStockNoInProductList == true) ?  'auto' : 'right',
                                        cellWidth: (currentDocumentTypeCode == 'ORIPOX' &&  showErpCode == true && showStockNoInProductList == true) ? 25 : (currentDocumentTypeCode == 'RELDDE' || currentDocumentTypeCode == 'OTHSIN') ? 15 : (currentDocumentTypeCode == 'ORIPOX') ? 17 : 20
                                    },
                                    7: {
                                        halign: 'right',
                                        cellWidth: showErpCode == true ? 20 : (currentDocumentTypeCode == 'ORIPOX') ? 17 : 19
                                    },
                                    8: {
                                        halign: 'right',
                                        cellWidth: (currentDocumentTypeCode == 'RECCSR' || currentDocumentTypeCode== 'RELTRX') ? 20 : (currentDocumentTypeCode == 'ORISOX' || currentDocumentTypeCode == 'RELDDE' || currentDocumentTypeCode == 'OTHSIN') ? 16 : (currentDocumentTypeCode == 'ORIPOX') ? 17 : 15
                                    },
                                    9: {
                                        halign: 'right',
                                        cellWidth: showErpCode == true ? 20 : customFont == 'NVD' ? 22 : (currentDocumentTypeCode == 'ORIPOX') ? 16 : 15
                                    },
                                    10: {
                                        halign: 'right',
                                    },
                                    11: {
                                        halign: 'right',
                                    },
                                    12: {
                                        halign: 'right',
                                    },
                                    13: {
                                        halign: 'right',
                                    },
                                }
                            };
                        },
                        documentProcessing:function(doc){
                            let showErpCodeAdjustXpos = 13;
                            if(showErpCode!=undefined && showErpCode==true){
                                showErpCodeAdjustXpos += 2;
                            }
                            let quantityTotalWidth = 145 + showErpCodeAdjustXpos;
                            let priceTotalWidth = 163 + showErpCodeAdjustXpos;
                            let subTotalWidth = 178 + showErpCodeAdjustXpos;
                            if (currentDocumentTypeCode == 'RELTRX') {
                                quantityTotalWidth = 140;
                                priceTotalWidth = 160;
                                subTotalWidth = 180;
                            }
                            if (currentDocumentTypeCode == 'RELRSR') {
                                priceTotalWidth = 161;
                                subTotalWidth = 181;
                                // Prefer the actual rendered column right-edges captured
                                // during the table draw so the Quantity / Cost / Subtotal
                                // footer values sit under their columns instead of
                                // overlapping each other and the row values.
                                if (typeof printColumnRightEdges.quantity === 'number') {
                                    quantityTotalWidth = printColumnRightEdges.quantity - total_plus_width;
                                }
                                // Known limitation: if the Unit Cost column is not
                                // printed at all (user unchecked `price` in Customize
                                // List) there is no column to align the Total Cost to,
                                // and the remaining space between the Quantity and
                                // Subtotal columns is narrower than the value itself.
                                // That case keeps the legacy anchor.
                                if (typeof printColumnRightEdges.cost === 'number') {
                                    priceTotalWidth = printColumnRightEdges.cost - total_plus_width;
                                }
                                if (typeof printColumnRightEdges.subtotal === 'number') {
                                    subTotalWidth = printColumnRightEdges.subtotal - total_plus_width;
                                }
                            } else if (currentDocumentTypeCode == 'ORIPOX') {
                                if(showErpCode!=undefined && showErpCode==true){
                                    quantityTotalWidth = 165;
                                    priceTotalWidth = 185;
                                    subTotalWidth = 205;
                                } else {
                                    quantityTotalWidth = 155;
                                    priceTotalWidth = 175;
                                    subTotalWidth = 195;
                                }
                            }else if (currentDocumentTypeCode == 'RECDEL'){
                                if(showErpCode!=undefined && showErpCode==true){
                                    quantityTotalWidth = 168;
                                    priceTotalWidth = 185;
                                    subTotalWidth = 206;
                                } else {
                                    quantityTotalWidth = 168;
                                    priceTotalWidth = 190;
                                    subTotalWidth = 207;
                                }
                            }else if (customFont == 'dotMatrix'){
                                quantityTotalWidth = 150;
                                priceTotalWidth = 175
                                subTotalWidth = 200
                            }
                            customFont == 'dotMatrix' && fontSizeIncreaser == 0 ? doc.setFontSize(8 + fontSizeIncreaser) : doc.setFontSize(7 + fontSizeIncreaser)
                            const pageCount = doc.internal.getNumberOfPages();
                            const finalY = doc.lastAutoTable['finalY'];
                            // For the CAS format, drop the page number to its own row below the footer,
                            // centered in the middle of the footer area.
                            var isCasFormatPage = (component_x.formPrintFormat == 'cas_default');
                            var pageNumberX = isCasFormatPage ? 90 : value_position;
                            var pageNumberY = isCasFormatPage ? 285 - minus_height : 280 - minus_height;
                            for(var i = 1; i <= pageCount; i++) {
                                doc.setPage(i);
                                doc.text('Page ' + String(i) + ' of ' + String(pageCount),pageNumberX,pageNumberY);
                            }

                            doc.setFontStyle("bold");
                            var formatMyNumber = function (number, decimal) {
                                var splitNum;
                                number = Math.abs(number);
                                number = number.toFixed(decimal);
                                splitNum = number.split('.');
                                splitNum[0] = splitNum[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                                return splitNum.join(".");
                            }
                            // Issue: 1474
                            // Update PO Print-out to include subtotal and total cost
                            doc.line(15, finalY, line_position, finalY, 'F');

                            // Dot-matrix prints in a noticeably wider font, so the
                            // longest footer label ("Net Amount w/o VAT:") runs
                            // underneath its own right-aligned value at the fixed x=60
                            // anchor. Shift the value column right by just enough to
                            // clear the labels. Stays 0 for every other print format,
                            // so their output is unchanged.
                            var totalsValueShift = 0
                            if (customFont == 'dotMatrix') {
                                var totalsTextWidth = function (text) {
                                    return doc.getStringUnitWidth(String(text)) * doc.internal.getFontSize() / doc.internal.scaleFactor
                                }
                                var totalsLabels = ["Total Quantity:", "Total Cost:", "Subtotal:", "Disc. Amount:",
                                    "Total VAT (" + (component_x.taxRate * 100) + "%):", "Net Amount w/o VAT:", "Total Price:"]
                                var totalsAmounts = [calculation.bottom.quantity, calculation.bottom.price, calculation.bottom.subtotal,
                                    calculation.bottom.price_php, calculation.bottom.subtotal_php, showDiscountAmountValue,
                                    component_x.vatAmount, component_x.netAmountWithoutTax, component_x.netAmount]
                                var widestLabel = 0
                                totalsLabels.forEach(function (label) {
                                    widestLabel = Math.max(widestLabel, totalsTextWidth(label))
                                })
                                var widestAmount = 0
                                totalsAmounts.forEach(function (amount) {
                                    widestAmount = Math.max(widestAmount, totalsTextWidth(formatMyNumber(Number(amount) || 0, 2)))
                                })
                                // labels start at x=15; values are right-aligned at x=60 + shift
                                totalsValueShift = Math.max(0, (15 + widestLabel + 2 + widestAmount) - 60)
                                // never widen so far that the values reach the "Noted By:" column at x=75
                                totalsValueShift = Math.min(totalsValueShift, 13)
                            }

                            // The three column totals under the table are right-aligned
                            // at their column right edges, but a value can be wider than
                            // its own column (e.g. "22,050.00" needs ~16.5mm in a 15mm
                            // Subtotal column) and then spills left over the total beside
                            // it. Walk right-to-left and pull each anchor left until it
                            // clears the value on its right. Only ever moves an anchor
                            // that would otherwise be overprinted.
                            if (alignFooterTotalsToColumns) {
                                var columnTotalWidth = function (text) {
                                    return doc.getStringUnitWidth(String(text)) * doc.internal.getFontSize() / doc.internal.scaleFactor
                                }
                                var widestColumnTotal = function (amounts) {
                                    var widest = 0
                                    amounts.forEach(function (amount) {
                                        widest = Math.max(widest, columnTotalWidth(formatMyNumber(Number(amount) || 0, 2)))
                                    })
                                    return widest
                                }
                                // widest of the base and the *_php conversion variant, since
                                // which one prints depends on the currency branch below
                                var costTotalTextWidth = widestColumnTotal([calculation.bottom.price, calculation.bottom.price_php])
                                var subtotalTotalTextWidth = widestColumnTotal([calculation.bottom.subtotal, calculation.bottom.subtotal_php])
                                var columnTotalsGap = 1.5
                                if (priceTotalWidth > (subTotalWidth - subtotalTotalTextWidth) - columnTotalsGap) {
                                    priceTotalWidth = (subTotalWidth - subtotalTotalTextWidth) - columnTotalsGap
                                }
                                if (quantityTotalWidth > (priceTotalWidth - costTotalTextWidth) - columnTotalsGap) {
                                    quantityTotalWidth = (priceTotalWidth - costTotalTextWidth) - columnTotalsGap
                                }
                            }
                            if (currentDocumentTypeCode == 'ORIPOX'){
                                if(component_x.document_config.document_type_settings.printSettings.includeImageInPrintout!=undefined && component_x.document_config.document_type_settings.printSettings.includeImageInPrintout == true){
                                    if(imageResponse["error"] == undefined){
                                        if (imageResponse.images_url != undefined && imageResponse.images_url.length > 0){
                                            let x = 20
                                            arrImgLogos.forEach(el => {
                                                doc.addImage(el,'JPEG', x,finalY + 3,15,15)
                                                x += 15
                                            })
                                        }
                                        else if (imageResponse.image != undefined && imageResponse.image != ""){
                                            doc.addImage(imgLogo, imageResponse.file_type, 30, 63, 14, 14);
                                        }
                                    }
                                }
                            }

                            if(currentDocumentTypeCode != 'OTHPWS'){
                                var positionTQ = 255
                                var positionTC = 259
                                var positionS = 263
                                var postionDA = 0
                                var positionNWOV = 0
                                var positionTP = 0
                                var positionTV = 0
                                if(currentDocumentTypeCode == 'RECADJ' || currentDocumentTypeCode == 'RELADJ'){
                                    positionS-=4
                                }
                                if (showDiscountAmount){
                                    positionTQ-=4
                                    positionTC-=4
                                    positionS-=4
                                    postionDA = positionS+4
                                    positionNWOV+=4
                                    positionTP+=4
                                    positionTV+=4
                                }
                                if (showTotalVat){
                                    positionTQ-=4
                                    positionTC-=4
                                    positionS-=4
                                    postionDA-=4
                                    positionTV = positionS+positionTV+4
                                    positionNWOV+= 4
                                    positionTP+=4
                                }
                                if(showNetAmountWithoutVat){
                                    positionTQ-=4
                                    positionTC-=4
                                    positionS-=4
                                    postionDA-=4
                                    positionTV-=4
                                    positionNWOV = positionS+positionNWOV+4
                                    positionTP+=4
                                }
                                if(showTotalPrice){
                                    positionTQ-=4
                                    positionTC-=4
                                    positionS-=4
                                    postionDA-=4
                                    positionTV-=4
                                    positionNWOV-=4
                                    positionTP = positionS+positionTP+4
                                }
                                if(currencyKey>0 && component_x.showConversionRate){
                                    if((currentDocumentTypeCode != 'OTHTRA' && currentDocumentTypeCode != 'OTHPCK') || isDefaultPrint){
                                        doc.text(doc.splitTextToSize((printQuantityTotal !== null ? printQuantityTotal : calculation.bottom.quantity).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","), 12), quantityTotalWidth+total_plus_width, finalY + 5, 'right')
                                        doc.text((!component_x.accessCostPriceRights.includes('Y') || !component_x.accessCostPriceRights.includes('Z')) ? "***" : doc.splitTextToSize((calculation.bottom.price_php).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","), 15), priceTotalWidth+total_plus_width, finalY + 5, 'right')
                                        doc.text((!component_x.accessCostPriceRights.includes('Y') || !component_x.accessCostPriceRights.includes('Z')) ? "***" : doc.splitTextToSize((calculation.bottom.subtotal_php).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","), 15), subTotalWidth+total_plus_width, finalY + 5, 'right')
                                    }
                                    // End Issue: 1474
                                    doc.text("Total Quantity:", 15, positionTQ-minus_height)
                                    doc.text((printQuantityTotal !== null ? printQuantityTotal : calculation.bottom.quantity).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","), 60 + totalsValueShift, positionTQ-minus_height, 'right')
                                    if(currentDocumentTypeCode != 'RECADJ' && currentDocumentTypeCode != 'RELADJ'){
                                        doc.text("Total Cost:", 15, positionTC-minus_height)
                                        doc.text((!component_x.accessCostPriceRights.includes('Z')) ? "***" : (calculation.bottom.price_php).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","), 60 + totalsValueShift, positionTC-minus_height, 'right')
                                    }
                                    doc.text("Subtotal:", 15, positionS-minus_height)
                                    doc.text(((!component_x.accessCostPriceRights.includes('Z') && (component_x.productPriceChoice == 'landed_cost' || component_x.productPriceChoice == 'ordering_cost' || component_x.productPriceChoice == 'original_cost')) || (!component_x.accessCostPriceRights.includes('Y') && (component_x.productPriceChoice == 'retail_price' || component_x.productPriceChoice == 'wholesale_price'))) ? "***" : (calculation.bottom.subtotal_php).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","), 60 + totalsValueShift, positionS-minus_height, 'right')
                                    if(showDiscountAmount){
                                        doc.text("Disc. Amount:", 15, postionDA-minus_height)
                                        doc.text(formatMyNumber(showDiscountAmountValue, 2), 50 + totalsValueShift, postionDA-minus_height, 'right')
                                    }
                                    if (showTotalVat){
                                        doc.text("Total VAT (" + (component_x.taxRate * 100) + "%):", 15, positionTV-minus_height)
                                        doc.text(formatMyNumber(Math.floor(component_x.vatAmount * 100) / 100, 2), 60 + totalsValueShift, positionTV-minus_height, 'right')
                                    }
                                    if(showNetAmountWithoutVat){
                                        doc.text("Net Amount w/o VAT:", 15, positionNWOV-minus_height)
                                        doc.text(formatMyNumber(Math.floor(component_x.netAmountWithoutTax * 100) / 100, 2), 60 + totalsValueShift, positionNWOV-minus_height, 'right')
                                    }
                                    if(showTotalPrice){
                                        doc.text("Total Price:", 15, positionTP-minus_height)
                                        doc.text((!component_x.accessCostPriceRights.includes('Y')) ? "***" : formatMyNumber(Math.floor(component_x.netAmount * 100) / 100, 2), 60 + totalsValueShift, positionTP-minus_height, 'right')
                                    }
                                    if(showOtherCharges){
                                        for (var index = 1; index <= component_x.chargeData.length; index++) { 
                                            var p = (index == 1) ? positionTQ-minus_height : (index == 2) ? positionTC-minus_height : (index == 3) ? positionS-minus_height : (index == 4) ? (positionS+4)-minus_height : (index == 5) ? (positionS+8)-minus_height : (index == 6) ? (positionS+12)-minus_height : (positionS+16)-minus_height
                                            doc.text(component_x.chargeData[index-1].name+':', 155, p)
                                            doc.text(formatMyNumber(component_x.chargeData[index-1].amount, 2), 190, p, 'right')
                                        }
                                    }
                                }else{
                                    if((currentDocumentTypeCode != 'OTHTRA' && currentDocumentTypeCode != 'OTHPCK') || isDefaultPrint){
                                        doc.text(doc.splitTextToSize((printQuantityTotal !== null ? printQuantityTotal : calculation.bottom.quantity).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","), 12), quantityTotalWidth+total_plus_width, finalY + 5, 'right')
                                        doc.text((!component_x.accessCostPriceRights.includes('Y') || !component_x.accessCostPriceRights.includes('Z')) ? "***" : doc.splitTextToSize((calculation.bottom.price).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","), customFont == 'dotMatrix' ? 25 : 15), priceTotalWidth+total_plus_width, finalY + 5, 'right')
                                        doc.text((!component_x.accessCostPriceRights.includes('Y') || !component_x.accessCostPriceRights.includes('Z')) ? "***" : doc.splitTextToSize((calculation.bottom.subtotal).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","), customFont == 'dotMatrix' ? 25 : 15), subTotalWidth+total_plus_width, finalY + 5, 'right')
                                    }
                                    // End Issue: 1474
                                    doc.text("Total Quantity:", 15, positionTQ-minus_height)
                                    doc.text(formatMyNumber(printQuantityTotal !== null ? printQuantityTotal : calculation.bottom.quantity, 0), 60 + totalsValueShift, positionTQ-minus_height, 'right')
                                    if(currentDocumentTypeCode != 'RECADJ' && currentDocumentTypeCode != 'RELADJ'){
                                        doc.text("Total Cost:", 15, positionTC-minus_height)
                                        doc.text((!component_x.accessCostPriceRights.includes('Z')) ? "***" : formatMyNumber(calculation.bottom.price, 2), 60 + totalsValueShift, positionTC-minus_height, 'right')
                                    }
                                    doc.text("Subtotal:", 15, positionS-minus_height)
                                    doc.text(((!component_x.accessCostPriceRights.includes('Z') && (component_x.productPriceChoice == 'landed_cost' || component_x.productPriceChoice == 'ordering_cost' || component_x.productPriceChoice == 'original_cost')) || (!component_x.accessCostPriceRights.includes('Y') && (component_x.productPriceChoice == 'retail_price' || component_x.productPriceChoice == 'wholesale_price'))) ? "***" : formatMyNumber(calculation.bottom.subtotal, 2), 60 + totalsValueShift, positionS-minus_height, 'right')
                                    if(showDiscountAmount){
                                        doc.text("Disc. Amount:", 15, postionDA-minus_height)
                                        doc.text(formatMyNumber(showDiscountAmountValue, 2), 60 + totalsValueShift, postionDA-minus_height, 'right')
                                    }
                                    if (showTotalVat){
                                        doc.text("Total VAT (" + (component_x.taxRate * 100) + "%):", 15, positionTV-minus_height)
                                        doc.text(formatMyNumber(Math.floor(component_x.vatAmount * 100) / 100, 2), 60 + totalsValueShift, positionTV-minus_height, 'right')
                                    }
                                    if(showNetAmountWithoutVat){
                                        doc.text("Net Amount w/o VAT:", 15, positionNWOV-minus_height)
                                        doc.text(formatMyNumber(Math.floor(component_x.netAmountWithoutTax * 100) / 100, 2), 60 + totalsValueShift, positionNWOV-minus_height, 'right')
                                    }
                                    if(showTotalPrice){
                                        doc.text("Total Price:", 15, positionTP-minus_height)
                                        doc.text((!component_x.accessCostPriceRights.includes('Y')) ? "***" : formatMyNumber(Math.floor(component_x.netAmount * 100) / 100, 2), 60 + totalsValueShift, positionTP-minus_height, 'right')
                                    }
                                    if(showOtherCharges){
                                        for (var index = 1; index <= component_x.chargeData.length; index++) { 
                                            var p = (index == 1) ? positionTQ-minus_height : (index == 2) ? positionTC-minus_height : (index == 3) ? positionS-minus_height : (index == 4) ? (positionS+4)-minus_height : (index == 5) ? (positionS+8)-minus_height : (index == 6) ? (positionS+12)-minus_height : (positionS+16)-minus_height
                                            doc.text(component_x.chargeData[index-1].name+':', 155, p)
                                            doc.text(formatMyNumber(component_x.chargeData[index-1].amount, 2), 190, p, 'right')
                                        }
                                    }
                                }
                            }
                            doc.setFontStyle("normal");
                            doc.setFontSize(currentDocumentTypeCode == 'RELTRX' && customFont == 'dotMatrix' ? 7 + fontSizeIncreaser : 6 + fontSizeIncreaser);
                            doc.text("Noted By:", 95, 252-minus_height)
                            doc.text("______________________________", 115, 252-minus_height)
                            doc.text("Verified By:", 95, 256-minus_height)
                            doc.text("______________________________", 115, 256-minus_height)
                            doc.text("Approved By:", 95, 260-minus_height)
                            doc.text("______________________________", 115, 260-minus_height)
                        }
                    });
                    if(currentDocumentTypeCode =='OTHCNS'){
                        this.tabulator.replaceData(tempdata)
                        var line_no = this.tabulator.getColumn("line_no")
                        line_no.updateDefinition({visible:false})
                        var product_name = this.tabulator.getColumn("product_name")
                        product_name.updateDefinition({visible:false})
                        var stock_no = this.tabulator.getColumn("stock_no")
                        stock_no.updateDefinition({visible:false})
                        var ref_code = this.tabulator.getColumn("ref_code")
                        ref_code.updateDefinition({visible:false})
                        var erp_code = this.tabulator.getColumn("erp_code")
                        erp_code.updateDefinition({visible:false})
                        var barcode = this.tabulator.getColumn("barcode")
                        barcode.updateDefinition({visible:false})
                        var unit_name = this.tabulator.getColumn("unit_name")
                        unit_name.updateDefinition({visible:false})
                        var quantity = this.tabulator.getColumn("quantity")
                        quantity.updateDefinition({visible:false})
                        var actual_quantity = this.tabulator.getColumn("actual_quantity")
                        actual_quantity.updateDefinition({visible:false})
                        var _price = this.tabulator.getColumn("price")
                        _price.updateDefinition({visible:false})
                        var cost = this.tabulator.getColumn("cost")
                        cost.updateDefinition({visible:false})
                        var _subtotal = this.tabulator.getColumn("subtotal")
                        _subtotal.updateDefinition({visible:false})
                        var on_hand_quantity = this.tabulator.getColumn("on_hand_quantity")
                        on_hand_quantity.updateDefinition({visible:false})
                    }else if (currentDocumentTypeCode == 'OTHTRA' || currentDocumentTypeCode == 'OTHPCK'){
                        for (var index = 0; index < column_names.length; index++) {
                            var customField = this.tabulator.getColumn(column_names[index])
                            customField.updateDefinition({visible:false,download:false})
                        }
                    }
                }
                this.spinning = false;
            },
            addProductCancel() {
                this.addProductConfirmationVisible = false;
            },
            handleAddProductVisibleChange(addProductConfirmationVisible){
                if (!addProductConfirmationVisible) {
                    this.addProductConfirmationVisible = false;
                    return;
                }
                if (this.currentDocumentTypeCode == 'ORISOX') {
                    if (Number(this.quantity) <= Number(this.onHandQuantity)) {
                        this.addProduct();
                    } else {
                        this.addProductConfirmationVisible = true;
                    }
                }else{
                    this.addProduct();
                }
            },
            unitAccessor(value, data){
                var response = '';
                var label = 'No Product Unit'
                var unit_label = data.unit_label
                if (unit_label!=undefined){
                    label = unit_label
                }else{
                    var request = new XMLHttpRequest();
                    request.open('GET', this.endPoint + 'products/'+data.product_id+'/get_product_unit_compositions', false);
                    request.setRequestHeader('Authorization', 'Bearer ' + secureStorage.getItem("accessToken"));
                    request.setRequestHeader('Request-Source',"BXI-Web");
                    request.setRequestHeader('ip',secureStorage.getItem("ipAddress"));
                    request.send(null);
                    if (request.status === 200) {
                        response = request.responseText;
                    }
                    var json_response = JSON.parse(response)
                    json_response.forEach(element => {element.value = element.unit_id; delete element.unit_id;});
                    if (json_response[0]!=undefined){
                        if (json_response[0].value != undefined) {
                            try {
                                label = json_response.find(element => element.value == data.unit_id.toString()).label;
                            } catch (error) {}
                        }
                    }
                }
                return label;
            },
            async openDocument(document_id,existingDocumentTypeDetails){
                this.documentFormDebugWarn('[DocumentForm] openDocument start', {
                    document_id,
                    existingDocumentTypeDetails,
                    currentDocumentTypeCode: this.currentDocumentTypeCode,
                    documentNumber: this.documentNumber,
                    grossAmountDisplay: this.grossAmountDisplay,
                    grossAmount: this.grossAmount
                })
                secureStorage.setItem("temp_document_id", document_id);
                secureStorage.setItem('documentTypeCode',this.currentDocumentTypeCode)
                secureStorage.setItem('DataOptions',this.$options.data())
                if (this.currentDocumentTypeCode=='OTHQUO' || this.currentDocumentTypeCode=='OTHBIN' || this.currentDocumentTypeCode=='OTHCPO'){
                    Object.assign(this.$data, this.$options.data());
                }else{
                    this.tabulator.clearData();
                    Object.assign(this.$data.options, secureStorage.getItem('DataOptions').options)
                }
                if (existingDocumentTypeDetails.existingDocumentTypeId != undefined){
                    if (existingDocumentTypeDetails.existingDocumentTypeId > 0){
                        this.currentDocumentTypeId = existingDocumentTypeDetails.existingDocumentTypeId
                    }else {
                        this.currentDocumentTypeId = secureStorage.getItem('documentTypeId') 
                    }
                }else {
                    this.currentDocumentTypeId = secureStorage.getItem('documentTypeId') 
                }
                if (existingDocumentTypeDetails.currentDocumentTypeName != undefined){
                    this.currentDocumentTypeName = existingDocumentTypeDetails.currentDocumentTypeName
                }else {
                    this.currentDocumentTypeName = secureStorage.getItem('documentTypeName')
                }
                if (existingDocumentTypeDetails.currentDocumentTypeCode != undefined){
                    this.currentDocumentTypeCode = existingDocumentTypeDetails.currentDocumentTypeCode

                }else {
                    this.currentDocumentTypeCode = secureStorage.getItem('documentTypeCode')
                }
                if (existingDocumentTypeDetails.currentDocumentTypeFriendlyCode != undefined){
                    this.currentDocumentTypeFriendlyCode = existingDocumentTypeDetails.currentDocumentTypeFriendlyCode
                }else {
                    this.currentDocumentTypeFriendlyCode = secureStorage.getItem('documentTypeFriendlyCode')
                }
                this.documentNumber = secureStorage.getItem('temp_document_id');
                this.currentDocumentTypeFriendlyCodeWithId = this.currentDocumentTypeFriendlyCode+"#"+this.documentNumber

                if (secureStorage.getItem("documentTypeInternalCode") == 'OTHPWS'){
                    this.backLink = "/products_v2?type=OTHPWS"
                    this.backLabel = "Back to Dashboard"
                }else if(secureStorage.getItem("documentTypeInternalCode") == 'OTHBAR'){
                    this.backLink = "/products_v2?type=OTHBAR"
                    this.backLabel = "Back to Dashboard"
                } else if (['OTHPCN', 'OTHCNS'].includes(secureStorage.getItem("documentTypeInternalCode"))) {
                    this.backLink = "/physical_count_v2"
                    this.backLabel = "Back to Physical Count V2"
                } else {
                    if(existingDocumentTypeDetails.type != undefined){
                        this.backLink = "/documents?type=" + existingDocumentTypeDetails.type
                    }else{
                        this.backLink = "/documents?type=" + secureStorage.getItem("documentTypeInternalCode")
                    }
                    this.backLabel = "Back to Dashboard"
                }
                await this.initializeDocument();
                this.documentFormDebugWarn('[DocumentForm] openDocument finished initializeDocument', {
                    document_id,
                    currentDocumentTypeCode: this.currentDocumentTypeCode,
                    documentNumber: this.documentNumber,
                    grossAmountDisplay: this.grossAmountDisplay,
                    grossAmount: this.grossAmount,
                    grossAmountwithoutTax: this.grossAmountwithoutTax
                })
            },
            // change for openOriginDocument to openRelatedDocument
            async openRelatedDocument(doc_id, doc_type_id){
                var documentTypes = await HTTPRequest.getRequest(this.endPoint + '/document_types/get_document_types_on_system_modules' , null, null)
                if (documentTypes){
                    var origin_document_type = documentTypes.find(x => x.id === doc_type_id)
                    if (origin_document_type) {
                        var origin_trans_code = origin_document_type.trans_code
                        var origin_type_code = origin_document_type.type_code
                        var origin_document_type = documentTypes.find(x => x.trans_code === origin_trans_code && x.type_code === origin_type_code)
                        if(origin_document_type == undefined){
                            this.$notification['error']({
                                message: 'Document Action Error',
                                description: origin_trans_code+origin_type_code+" origin document is not available",
                                style: getNotificationStyle('error')
                            });
                            return;
                        }
                        secureStorage.setItem("temp_document_id", doc_id);
                        secureStorage.setItem("documentTypeId", origin_document_type.id);
                        secureStorage.setItem("documentTypeName", origin_document_type.name);
                        secureStorage.setItem("documentTypeCode", origin_document_type.trans_code+origin_document_type.type_code);
                        secureStorage.setItem("documentTypeFriendlyCode", origin_document_type.friendly_code);
                        Object.assign(this.$data, this.$options.data());
                        await this.fetchValidDocumentSitesForPosting();
                        this.documentNumber = secureStorage.getItem('temp_document_id');

                        this.currentDocumentTypeId = secureStorage.getItem('documentTypeId')
                        this.currentDocumentTypeName = secureStorage.getItem('documentTypeName')
                        this.currentDocumentTypeCode = secureStorage.getItem('documentTypeCode')
                        this.currentDocumentTypeFriendlyCode = secureStorage.getItem('documentTypeFriendlyCode')
                        this.currentDocumentTypeFriendlyCodeWithId = this.currentDocumentTypeFriendlyCode+"#"+this.documentNumber
                    }
                }
                await this.getSettings();
                await this.initializeDocument();
            },
            async processChildDocument(isASN){
                 // Hide main create button
                this.createButtonMain = false
                console.log(">>>Processing Child Document")

                var originDocumentNumber = this.documentNumber
                var originDocumentTypeId = this.currentDocumentTypeId
                var originDocumentTypeName = this.currentDocumentTypeName
                var documentTypes = await HTTPRequest.getRequest(this.endPoint + '/document_types/get_document_types_on_system_modules', null, null)
                if (documentTypes){
                    var origin_document_type = documentTypes.find(x => x.id === this.currentDocumentTypeId)
                    if (origin_document_type) {
                        if (isASN) {
                            var child_trans_code = origin_document_type.child_trans_code2
                            var child_type_code = origin_document_type.child_type_code2
                        } else {
                            var child_trans_code = origin_document_type.child_trans_code
                            var child_type_code = origin_document_type.child_type_code
                        }

                        var child_document_type = documentTypes.find(x => x.trans_code === child_trans_code && x.type_code === child_type_code)
                        if(child_document_type == undefined){
                            this.$notification['error']({
                                message: 'Document Action Error',
                                description: child_trans_code+child_type_code+" child document is not available",
                                style: getNotificationStyle('error')
                            });
                            return;
                        }
                        secureStorage.setItem("temp_document_id", 0);
                        secureStorage.setItem("documentTypeId", child_document_type.id);
                        secureStorage.setItem("documentTypeName", child_document_type.name);
                        secureStorage.setItem("documentTypeCode", child_document_type.trans_code+child_document_type.type_code);
                        secureStorage.setItem("documentTypeFriendlyCode", child_document_type.friendly_code);
                        if (this.currentDocumentTypeCode=='OTHQUO' || this.currentDocumentTypeCode=='OTHBIN' || this.currentDocumentTypeCode=='OTHCPO'){
                            Object.assign(this.$data, this.$options.data());
                        }else{
                            this.tabulator.clearData();
                            Object.assign(this.$data.options,(secureStorage.hasOwnProperty('DataOptions')) ? secureStorage.getItem('DataOptions').options : this.$options.data())
                        }
                        if (child_document_type != undefined){
                            this.documentNumber = 0
                            this.currentDocumentTypeId = child_document_type.id
                            this.currentDocumentTypeName = child_document_type.name
                            this.currentDocumentTypeCode =  child_document_type.trans_code+child_document_type.type_code
                            this.currentDocumentTypeFriendlyCode = child_document_type.friendly_code
                            this.existingDocumentTypeDetails.existingDocumentTypeId = child_document_type.id
                            this.existingDocumentTypeDetails.currentDocumentTypeName = child_document_type.name
                            this.existingDocumentTypeDetails.currentDocumentTypeCode = this.currentDocumentTypeCode
                            this.existingDocumentTypeDetails.currentDocumentTypeFriendlyCode = this.currentDocumentTypeFriendlyCode
                        }else {
                            this.currentDocumentTypeId = secureStorage.getItem('documentTypeId')
                            this.currentDocumentTypeName = secureStorage.getItem('documentTypeName')
                            this.currentDocumentTypeCode = secureStorage.getItem('documentTypeCode')
                            this.currentDocumentTypeFriendlyCode = secureStorage.getItem('documentTypeFriendlyCode')
                        }
                        this.currentDocumentTypeFriendlyCodeWithId = this.currentDocumentTypeFriendlyCode+"#"+this.documentNumber
                        this.originDocumentNumber = originDocumentNumber
                        this.originDocumentTypeId = originDocumentTypeId
                        this.originDocumentTypeName = originDocumentTypeName
                    }
                }

                console.log("** " + this.currentDocumentTypeCode + " **")
                if(this.currentDocumentTypeCode == "RECDEL"){
                    let currentSite = parseInt(secureStorage.getItem("defaultSiteId"))
                    console.log("Current Site :: " + currentSite)
                    
                    var document = await HTTPRequest.getRequest(this.endPoint + "documents/"+ originDocumentNumber, null);
                    if (document != null || document != undefined){
                        let docSiteId = document['site_id']['key']
                        if(docSiteId != currentSite){
                            this.$notification['warning']({
                                message: 'Cannot create document. Please ensure you are in the correct site.',
                            });
                            return false;
                        }else{
                            console.log("Site ID Match")
                        }
                    }
                }

                await this.initializeDocument();
                await this.save();
            },
            async initializeDocument() {
                console.log("Initializing Document")
                console.log(this.isProductSearchDisabled)
                // Show the loading overlay and block the action buttons for the entire
                // duration of the load. The heavy synchronous work below (building the
                // Tabulator data, snapshotting origData, sequential requests) can keep the
                // main thread busy after the form is visible; without this the user could
                // click Update/Confirm/Post before loading finished and the click would be
                // swallowed. Cleared in the finally block at the end of this method.
                this.isInitializing = true;
                this.spinMessage = 'Loading document...';
                // Wrapped in try/finally so the loading overlay is ALWAYS cleared and the
                // action buttons re-enabled, even if any awaited request below rejects or
                // the document type takes an early-exit path. Without this a failed request
                // (e.g. a new document that has not been persisted yet) would leave the
                // overlay stuck on screen.
                try {
                this.showFreezeButton = false
                window.addEventListener('scroll', this.handleScroll);
                component_x = this
                //Retrieve TaxRate from Global Settings
                var tax_rate_settings = await HTTPRequest.getRequest(this.endPoint + '/system_settings');
                var default_vat_rate = 12
                if (tax_rate_settings.data[0]) {
                    default_vat_rate = JSON.parse(tax_rate_settings.data[0].settings_json).default_vat_rate || 12
                }

                this.taxRate = Number(default_vat_rate) / 100

                //Retrieving and application of Document Access Rights
                var system_module = await HTTPRequest.getRequest(this.endPoint+'/system_modules?status=A&code='+ this.currentDocumentTypeCode, null)
                var accessRightsRequest = await HTTPRequest.getRequest(this.endPoint + 'users/' + secureStorage.getItem("userId") + "/access_rights?system_module_id=" + system_module[0].id, null)

                if (accessRightsRequest.access_rights[system_module[0].id]) {
                    this.accessRights  = accessRightsRequest.access_rights[system_module[0].id];
                } else {
                    this.accessRights = [];
                }

                //3082
                var accessCostPriceRightsRequest = await HTTPRequest.getRequest(this.endPoint + 'users/' + secureStorage.getItem("userId") + "/access_rights?system_module_id=123", null)
                if (_.isEmpty(accessCostPriceRightsRequest.access_rights) == false){
                    this.accessCostPriceRights = accessCostPriceRightsRequest.access_rights[123]
                }else {
                    this.accessCostPriceRights = []
                }

                component_x.isSaveDisabled = (!this.accessRights.includes('W')) ? true : false;
                component_x.isfreezeDisabled = (!this.accessRights.includes('W')) ? true : false;
                component_x.isUpdateDisabled = (!this.accessRights.includes('W')) ? true : false;
                component_x.isTableEditable = (!this.accessRights.includes('W')) ? true : false;
                component_x.isSupplyingSiteDisabled = (!this.accessRights.includes('W')) ? true : false;
                component_x.isRequestingSiteDisabled = (!this.accessRights.includes('W')) ? true : false;
                component_x.isHeaderDiscountDisabled = (!this.accessRights.includes('W')) ? true : false;
                component_x.productFormMode = (!this.accessRights.includes('W')) ? "Search" : "Add";
                component_x.isReferenceDisabled = (!this.accessRights.includes('W')) ? true : false;
                component_x.isPaymentTermDisabled = (!this.accessRights.includes('W')) ? true : false;
                component_x.isShippingMethodDisabled = (!this.accessRights.includes('W')) ? true : false;
                component_x.isSupportsDiscountDisabled = (!this.accessRights.includes('W')) ? true : false;
                component_x.isPurposeDisabled = (!this.accessRights.includes('W')) ? true : false;
                component_x.isDocumentDateDisabled = (!this.accessRights.includes('W')) ? true : false;
                component_x.isTargetDateDisabled = (!this.accessRights.includes('W')) ? true : false;
                component_x.isCancellationDateDisabled = (!this.accessRights.includes('W')) ? true : false;
                component_x.isOriginSublocationDisabled = (!this.accessRights.includes('W')) ? true : false;
                component_x.isDestinationSublocationDisabled = (!this.accessRights.includes('W')) ? true : false;
                component_x.isCustomerDisabled = (!this.accessRights.includes('W')) ? true : false;
                component_x.isSalesmanDisabled = (!this.accessRights.includes('W')) ? true : false;
                component_x.isCustomerCreateDisabled = (!this.accessRights.includes('W')) ? true : false;
                // bryan
                component_x.isForThisSiteDisabled = (!this.accessRights.includes('W') || !secureStorage.getItem("sitePricingEnabled")) ? true : false; 
                this.isLotCodeExpiryDisabled = (this.currentDocumentTypeCode.substring(0,3) == "REC" || this.currentDocumentTypeCode.substring(0,3) == "OTH") ? false : true;
            
                //Get Tabulator Instance
                this.tabulator = this.$refs.tabulator.getInstance();
                this.tabulator.clearData();

                //Document Configuration Application
                var document_config = []
                if(this.currentDocumentTypeCode == "OTHBAR"){
                    document_config = await HTTPRequest.getRequest(component_x.endPoint+'/document_types/get_document_type_settings?trans_code=OTH&type_code=BAR', null)
                } else {
                    document_config = await HTTPRequest.getRequest(component_x.endPoint+'/document_types/get_document_type_settings?id='+ component_x.currentDocumentTypeId, null)
                }
                if(document_config) this.document_config = document_config
                if (this.document_config && document_config.document_type_settings.editorBehavior) 
                    this.maxLines = this.document_config.document_type_settings.editorBehavior.maxMassUploadLineRestrictionInput

                if (this.document_config && document_config.document_type_settings.incomingOrder) 
                    this.autoCreateAlterSupp = this.document_config.document_type_settings.incomingOrder.disableAutocreationAlternateSupplierPosting
                
                if (this.document_config && document_config.document_type_settings.additionalEditorBehaviorCheckboxes) 
                    this.filterBySupp = this.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.filterProductBySupplier

                //Mount selected Product Price/Cost depending on the configuration
                if (this.document_config && document_config.document_type_settings.priceOrCost) {
                    this.productPriceChoice = document_config.document_type_settings.priceOrCost
                    this.productPriceChoice = _.snakeCase(this.productPriceChoice);
                    // Label the unit column based on whether priceOrCost is a COST or PRICE type,
                    // so the header matches the masked value (avoids "Unit Price" showing a cost).
                    var isUnitCostChoice = (this.productPriceChoice == 'landed_cost' || this.productPriceChoice == 'ordering_cost' || this.productPriceChoice == 'original_cost');
                    var unitColumnLabel = isUnitCostChoice ? 'Unit Cost' : 'Unit Price';
                    var unit_cost_column = this.tabulator.getColumn("price")
                    if (unit_cost_column)
                        await unit_cost_column.updateDefinition({title: unitColumnLabel})

                    var unit_cost_column_php = this.tabulator.getColumn("price_php")
                    if (unit_cost_column_php)
                        await unit_cost_column_php.updateDefinition({title: unitColumnLabel + ' (PHP)' })
                }

                //Disable Editing Depending on Config
                if (component_x.document_config && !component_x.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.itemDescEditForPrinting) {
                    component_x.isProductNameEditConfigDisabled = !component_x.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.itemDescEditForPrinting
                }

            
                // Enable Confirm and Unconfirm Document - Config
                if (component_x.document_config) {
                    this.showconfirmUnconfirmButton = component_x.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.confirmDocumentStatus
                }

                //Set Maximum Document Line Limit - Config
                if (component_x.document_config && component_x.document_config.document_type_settings.editorBehavior.lineRestrictionInput){
                    this.maximumDocumentLineNumber = component_x.document_config.document_type_settings.editorBehavior.lineRestrictionInput
                }

                //Set Decimal Places Config
                if (component_x.document_config && component_x.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.fourDecimalPlaces){
                    if (component_x.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.fourDecimalPlaces) {
                        this.decimalPlaces = 4
                    }
                }

                //Set Order Source
                var orisox_doc_config = await HTTPRequest.getRequest(component_x.endPoint+'/document_types/get_document_type_settings?type_code=SOX&trans_code=ORI', null)
                var isSourceMode = null
                var user_settings = await HTTPRequest.getRequest(this.endPoint + '/user_settings?user_specific=Y&module_name=ORISOX');
                if (user_settings.data[0]) isSourceMode = user_settings.data[0].settings_json.isSourceMode

                if (orisox_doc_config && orisox_doc_config.document_type_settings.orderSource){
                    if (isSourceMode == null) isSourceMode = orisox_doc_config.document_type_settings.orderSource.enableOrderSourceMode
                    this.isOrderSourceMode = isSourceMode
                    this.isOrderSourceDisabled = !this.isOrderSourceMode
                    if (this.isOrderSourceMode && orisox_doc_config.document_type_settings.orderSource.orderSources) {
                        this.orderSources = orisox_doc_config.document_type_settings.orderSource.orderSources
                    }
                }

                if(component_x.document_config){
                    var enableAddCharges = component_x.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.enableAddCharges
                    //if(enableAddCharges && component_x.currentDocumentTypeCode == "RECDEL") {
                    if(enableAddCharges && ["RECDEL", "ORISOX"].includes(component_x.currentDocumentTypeCode) ) {
                        component_x.showChargesTable = true
                    }
                    component_x.showVatExclusiveCheckboxConfig = component_x.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.showVatExclusiveAmount
                }

                // get trans_code and type_code
                let x_trans_code = '';
                let x_type_code = '';
                let x_document_type_trans_code = await HTTPRequest.getRequest(component_x.endPoint + "document_types?table_prefix=inventory&id="+component_x.currentDocumentTypeId, null);
                if (x_document_type_trans_code.find(x => x.id === this.currentDocumentTypeId)) {
                    x_type_code = x_document_type_trans_code.find(x => x.id === this.currentDocumentTypeId).type_code
                    x_trans_code = x_document_type_trans_code.find(x => x.id === this.currentDocumentTypeId).trans_code
                }

                let form_print_formats = await HTTPRequest.getRequest(
                component_x.endPoint + "form_print_formats/get_valid_form_print_formats?trans_code=" + x_trans_code + "&type_code=" + x_type_code, null);
                component_x.formPrintFormatOptions = form_print_formats;
                  
                if(component_x.formPrintFormatOptions.error == undefined){
                    component_x.formPrintFormatOptions.push({id: 0, name: 'Default', function: ''})
                    component_x.formPrintFormatOptions.push({id: -1, name: 'NV Default', function: 'NVD'})
                }else{
                    component_x.formPrintFormatOptions = [{id: 0, name: 'Default', function: ''}]
                    component_x.formPrintFormatOptions.push({id: -1, name: 'NV Default', function: 'NVD'})
                }
                component_x.syncPhysicalCountV2CountSheetPrintFormat()
                let listIsZero = []
                let fieldsList = []

                if (['RELTRX', 'RECTRX', 'RELADJ', 'RECADJ', 'RELDDE', 'RECDEL', 'RECCSR'].includes(this.currentDocumentTypeCode)) this.allowSublocationAllocation = true
                if (['OTHTRA', 'OTHPCK'].includes(this.currentDocumentTypeCode)) this.allowSiteAllocation = true
                //Setting columns on Document Form Table
                switch(this.currentDocumentTypeCode) {
                    case 'ORITRQ':

                        //1935 - Show Header / Supports Discount for ORITRQ
                        component_x.showHeaderDiscount = true
                        var oritrq_doc_config = await HTTPRequest.getRequest(component_x.endPoint+'/document_types/get_document_type_settings?type_code=TRQ&trans_code=ORI', null)

                        var custom_fields = []
                        if(oritrq_doc_config.document_type_settings.customFields != undefined){
                            var additional_fields = oritrq_doc_config.document_type_settings.customFields;
                            for(var i = 0; i < additional_fields.length; i++){
                                custom_fields.push({ name: additional_fields[i], value: false, custom: true})
                                this.customFieldsX = custom_fields
                                var add_column = {
                                    title: additional_fields[i].split("_").map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) .join(" "),
                                    field: additional_fields[i],
                                    sorter: 'string',
                                    visible: false,
                                    download: false,
                                    editable: false,
                                    cellClick:function(e, cell){e.stopPropagation();}
                                }
                                
                                this.tabulator.addColumn(add_column);
                                override = true
                            }
                        }

                        listIsZero = this.filteredColumnFields.filter(({ value }) => value === true)
                        fieldsList = listIsZero.length === 0 ? this.defaultColumnFields : this.filteredColumnFields
                        this.assignCustomizedFields(this.currentDocumentTypeCode, fieldsList, this.defaultColumnFields)
                        this.header = InterbranchDocuments.header
                        this.renderColumnFields()

                        // Arvin
                        // Check if account has autorep feature
                        var categoryId = await HTTPRequest.getRequest(this.endPoint + '/system_module_categories?code=PTP-001', null, null)
                        var autoRepModules = await HTTPRequest.getRequest(this.endPoint + '/system_module_categories/' +  categoryId[0].id + '/enabled_modules', null, null)
                            
                        if(autoRepModules.length > 0) {
                            for (var key in autoRepModules) {
                                //Retrieving and application of User Access Rights
                                var system_module = await HTTPRequest.getRequest(this.endPoint+'/system_modules?status=A&code='+ autoRepModules[key].code, null)
                                var accessRightsRequest = await HTTPRequest.getRequest(this.endPoint + 'users/' + secureStorage.getItem("userId") + "/access_rights?system_module_id=" + system_module[0].id, null)

                                if (accessRightsRequest.access_rights[system_module[0].id]) {
                                    var withaccessRights  = (accessRightsRequest.access_rights[system_module[0].id].includes('V')) ? 1 : 0
                                    if(autoRepModules[key].code == 'ORIPOX-AM' && withaccessRights == 1)
                                        this.autoRepMinMaxAccess = 1;
                                
                                    if(autoRepModules[key].code == 'ORIPOX-AO' && withaccessRights == 1)
                                        this.autoRepOfftakeAccess = 1;
                                } 
                            }   
                        }

                        component_x.requestingSite = {key: secureStorage.getItem("defaultSiteId").toString(), label: secureStorage.getItem("defaultSiteName")}
                        component_x.isRequestingSiteDisabled = true
                        component_x.createChildDocButtonLabel = 'Create Transfer Order'

                        if (this.document_config && this.document_config.document_type_settings.incomingOrder) {
                            this.cancellationDate = moment(new Date()).add(this.document_config.document_type_settings.incomingOrder.cancellationDays, 'days')

                            if(this.document_config.document_type_settings.additionalEditorBehavior){
                                this.offtakeDays = this.document_config.document_type_settings.additionalEditorBehavior.offtakeDays
                            }
                        }
                        break;
                    case 'OROTRQ':

                        //1935 - Show Header / Supports Discount for OROTRQ
                        component_x.showHeaderDiscount = true
                
                        var orotrq_doc_config = await HTTPRequest.getRequest(component_x.endPoint+'/document_types/get_document_type_settings?type_code=TRQ&trans_code=ORO', null)

                        var custom_fields = []
                        if(orotrq_doc_config.document_type_settings.customFields != undefined){
                            var additional_fields = orotrq_doc_config.document_type_settings.customFields;
                            for(var i = 0; i < additional_fields.length; i++){
                                custom_fields.push({ name: additional_fields[i], value: false, custom: true})
                                this.customFieldsX = custom_fields
                                var add_column = {
                                    title: additional_fields[i].split("_").map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) .join(" "),
                                    field: additional_fields[i],
                                    sorter: 'string',
                                    visible: false,
                                    download: false,
                                    editable: false,
                                    cellClick:function(e, cell){e.stopPropagation();}
                                }
                                
                                this.tabulator.addColumn(add_column);
                                override = true
                            }
                        }

                        listIsZero = this.filteredColumnFields.filter(({ value }) => value === true)
                        fieldsList = listIsZero.length === 0 ? this.defaultColumnFields : this.filteredColumnFields
                        this.assignCustomizedFields(this.currentDocumentTypeCode, fieldsList, this.defaultColumnFields)
                        this.header = InterbranchDocuments.header
                        this.renderColumnFields()

                        component_x.supplyingSite = {key: secureStorage.getItem("defaultSiteId").toString(), label: secureStorage.getItem("defaultSiteName")}
                        component_x.isSupplyingSiteDisabled = true
                        component_x.showCreateChildDocButton = true
                        component_x.createChildDocButtonLabel = 'Create Transfer Out'

                        if (this.document_config && this.document_config.document_type_settings.outgoingOrder){
                            this.cancellationDate = moment(new Date()).add(this.document_config.document_type_settings.outgoingOrder.cancellationDays, 'days')
                        }

                        if (component_x.documentNumber < 1) {
                            var document = await HTTPRequest.getRequest(component_x.endPoint + "documents/"+this.originDocumentNumber, null);
                            if (document != null){
                                component_x.requestingSite = document['target_site_id']
                                component_x.supplyingSite = document['source_site_id']
                                component_x.reference = document['reference']
                                component_x.remark = document['remark']
                                component_x.targetDate = moment(document["target_date"])
                                component_x.cancellationDate = moment(document["cancellation_date"])

                                //Populate Footer and Calculation Data
                                component_x.grossAmount =  document['amount_gross']
                                component_x.grossAmountDisplay = document['amount_gross']
                                component_x.overallDiscount = document['amount_header_discount']
                                component_x.netAmount = document['amount_net']
                                component_x.netAmountDisplay = document['amount_net']
                                component_x.vatAmount = document['tax_amount']
                                component_x.totalWithVat = document['tax_exempt_amount']
                                component_x.itemDiscount = document['amount_line_discount']
                                component_x.taxRate = document['tax_rate']
                                component_x.grossAmountwithoutTax = document['gross_amount_without_tax']
                                component_x.netAmountWithoutTax = document['net_amount_without_tax']
                                component_x.isRequestingSiteDisabled = true
                            }

                            //Load document lines
                            window.scrollTo(0,0);
                            this.spinning = true;
                            let document_lines = []
                            document_lines = await HTTPRequest.getRequest(this.endPoint+'document_lines/'+this.originDocumentNumber+'?field_name=document_id&origin_sublocation=0', null)
                            if(document_lines != undefined && document_lines != null && document_lines != []){
                                await this.tabulator.addData(document_lines, true);
                            } 
                                
                            this.tabulator.addFilter("line_no", ">", 0);
                            if(document_lines != undefined && document_lines != null && document_lines != []){
                                component_x.origData = JSON.stringify(document_lines.reverse()) //For isDirty Data on Document lines
                            } 

                            this.spinning = false;
                            this.initializeFooterCalculation();
                        }

                        break;
                    case 'RECTRX':

                        //1935 - Show Header for RECTRX
                        component_x.showHeaderDiscount = true

                        this.defaultColumnFields = [
                            ...this.defaultColumnFields,
                            { name: "color", value: true },
                            { name: "retail_price", value: true },
                        ]
                        
                        if (!this.accessRights.includes("Z")){
                            this.defaultColumnFields.forEach((item) => {
                                if (item.name === 'cost') {
                                    item.value = false;
                                }
                            });
                        }

                        var rectrx_doc_config = await HTTPRequest.getRequest(component_x.endPoint+'/document_types/get_document_type_settings?type_code=TRX&trans_code=REC', null)

                        var custom_fields = []
                        if(rectrx_doc_config.document_type_settings.customFields != undefined){
                            var additional_fields = rectrx_doc_config.document_type_settings.customFields;
                            for(var i = 0; i < additional_fields.length; i++){
                                custom_fields.push({ name: additional_fields[i], value: false, custom: true})
                                this.customFieldsX = custom_fields
                                var add_column = {
                                    title: additional_fields[i].split("_").map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) .join(" "),
                                    field: additional_fields[i],
                                    sorter: 'string',
                                    visible: false,
                                    download: false,
                                    editable: false,
                                    cellClick:function(e, cell){e.stopPropagation();}
                                }
                                
                                this.tabulator.addColumn(add_column);
                                override = true
                            }
                        }

                        listIsZero = this.filteredColumnFields.filter(({ value }) => value === true)
                        fieldsList = listIsZero.length === 0 ? this.defaultColumnFields : this.filteredColumnFields
                        console.log("here", fieldsList, "next", this.defaultColumnFields ) 
                        this.assignCustomizedFields(this.currentDocumentTypeCode, fieldsList, this.defaultColumnFields)
                        this.header = InterbranchDocuments.header

                        this.renderColumnFields()

                        component_x.requestingSite = {key: secureStorage.getItem("defaultSiteId").toString(), label: secureStorage.getItem("defaultSiteName")}
                        component_x.isRequestingSiteDisabled = true

                        if (component_x.documentNumber < 1) {
                            var document = await HTTPRequest.getRequest(component_x.endPoint + "documents/"+this.originDocumentNumber, null);

                            if (document != null) {
                                component_x.requestingSite = document['target_site_id']
                                component_x.supplyingSite = document['source_site_id']
                                component_x.reference = document['reference']
                                component_x.remark = document['remark']
                                component_x.targetDate = moment(document["target_date"])
                                component_x.cancellationDate = moment(document["cancellation_date"])

                                //Populate Footer and Calculation Data
                                component_x.grossAmount =  document['amount_gross']
                                component_x.grossAmountDisplay = document['amount_gross']
                                component_x.overallDiscount = document['amount_header_discount']
                                component_x.netAmount = document['amount_net']
                                component_x.netAmountDisplay = document['amount_net']
                                component_x.vatAmount = document['tax_amount']
                                component_x.totalWithVat = document['tax_exempt_amount']
                                component_x.itemDiscount = document['amount_line_discount']
                                component_x.taxRate = document['tax_rate']
                                component_x.grossAmountwithoutTax = document['gross_amount_without_tax']
                                component_x.netAmountWithoutTax = document['net_amount_without_tax']
                                component_x.isSupplyingSiteDisabled = true
                            }

                            //Load document lines
                            window.scrollTo(0,0);
                            this.spinning = true;
                            let document_lines = []
                            document_lines = await HTTPRequest.getRequest(this.endPoint+'document_lines/'+this.originDocumentNumber+'?field_name=document_id&origin_sublocation=0', null)
                            if(document_lines != undefined && document_lines != null && document_lines != []){
                                await this.tabulator.addData(document_lines, true);
                            } 
                            this.tabulator.addFilter("line_no", ">", 0);
                            if(document_lines != undefined && document_lines != null && document_lines != []){
                                component_x.origData = JSON.stringify(document_lines.reverse()) //For isDirty Data on Document lines
                            } 
                            this.spinning = false;
                            this.initializeFooterCalculation();
                        }

                        break;
                    case 'RELTRX':

                        var reltrx_doc_config = await HTTPRequest.getRequest(component_x.endPoint+'/document_types/get_document_type_settings?type_code=TRX&trans_code=REL', null)

                        //1935 - Show Header / Supports Discount for RELTRX
                        component_x.showHeaderDiscount = true

                        this.defaultColumnFields = [
                        ...this.defaultColumnFields,
                            { name: "color", value: true },
                            { name: "retail_price", value: true },
                        ]

                        if (!this.accessRights.includes("Z")){
                            this.defaultColumnFields.forEach((item) => {
                                if (item.name === 'cost') {
                                    item.value = false;
                                }
                            });
                        }

                        var custom_fields = []
                        if(reltrx_doc_config.document_type_settings.customFields != undefined){
                            var additional_fields = reltrx_doc_config.document_type_settings.customFields;
                            for(var i = 0; i < additional_fields.length; i++){
                                custom_fields.push({ name: additional_fields[i], value: false, custom: true})
                                this.customFieldsX = custom_fields
                                var add_column = {
                                    title: additional_fields[i].split("_").map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) .join(" "),
                                    field: additional_fields[i],
                                    sorter: 'string',
                                    visible: false,
                                    download: false,
                                    editable: false,
                                    cellClick:function(e, cell){e.stopPropagation();}
                                }
                                
                                this.tabulator.addColumn(add_column);
                                override = true
                            }
                        }

                        listIsZero = this.filteredColumnFields.filter(({ value }) => value === true)
                        fieldsList = listIsZero.length === 0 ? this.defaultColumnFields : this.filteredColumnFields
                        this.assignCustomizedFields(this.currentDocumentTypeCode, fieldsList, this.defaultColumnFields)
                        this.header = InterbranchDocuments.header
                        this.renderColumnFields()

                        component_x.supplyingSite = {key: secureStorage.getItem("defaultSiteId").toString(), label: secureStorage.getItem("defaultSiteName")}
                        component_x.isSupplyingSiteDisabled = true
                        component_x.createChildDocButtonLabel = 'Create Transfer In'
                        if (component_x.documentNumber < 1) {
                            var document = await HTTPRequest.getRequest(component_x.endPoint + "documents/"+this.originDocumentNumber, null);
                            if (document != null) {
                                component_x.requestingSite = document['target_site_id']
                                component_x.supplyingSite = document['source_site_id']
                                component_x.reference = document['reference']
                                component_x.remark = document['remark']
                                component_x.targetDate = moment(document["target_date"])
                                component_x.cancellationDate = moment(document["cancellation_date"])

                                //Populate Footer and Calculation Data
                                component_x.grossAmount =  document['amount_gross']
                                component_x.grossAmountDisplay = document['amount_gross']
                                component_x.overallDiscount = document['amount_header_discount']
                                component_x.netAmount = document['amount_net']
                                component_x.netAmountDisplay = document['amount_net']
                                component_x.vatAmount = document['tax_amount']
                                component_x.totalWithVat = document['tax_exempt_amount']
                                component_x.itemDiscount = document['amount_line_discount']
                                component_x.taxRate = document['tax_rate']
                                component_x.grossAmountwithoutTax = document['gross_amount_without_tax']
                                component_x.netAmountWithoutTax = document['net_amount_without_tax']
                            }

                            //Load document lines
                            window.scrollTo(0,0);
                            this.spinning = true;
                            let document_lines = []
                            document_lines = await HTTPRequest.getRequest(this.endPoint+'document_lines/'+this.originDocumentNumber+'?field_name=document_id&origin_sublocation=0', null)
                            if(document_lines != undefined && document_lines != null && document_lines != []){
                                await this.tabulator.addData(document_lines, true);
                            } 
                            this.tabulator.addFilter("line_no", ">", 0);
                            if(document_lines != undefined && document_lines != null && document_lines != []){
                                component_x.origData = JSON.stringify(document_lines.reverse()) //For isDirty Data on Document lines
                            } 
                                
                            this.spinning = false;
                            this.initializeFooterCalculation();
                        }

                        break;
                    case 'ORICSQ':

                        var oricsq_doc_config = await HTTPRequest.getRequest(component_x.endPoint+'/document_types/get_document_type_settings?type_code=CSQ&trans_code=ORI', null)

                        var custom_fields = []
                        if(oricsq_doc_config.document_type_settings.customFields != undefined){
                            var additional_fields = oricsq_doc_config.document_type_settings.customFields;
                            for(var i = 0; i < additional_fields.length; i++){
                                custom_fields.push({ name: additional_fields[i], value: false, custom: true})
                                this.customFieldsX = custom_fields
                                var add_column = {
                                    title: additional_fields[i].split("_").map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) .join(" "),
                                    field: additional_fields[i],
                                    sorter: 'string',
                                    visible: false,
                                    download: false,
                                    editable: false,
                                    cellClick:function(e, cell){e.stopPropagation();}
                                }
                                
                                this.tabulator.addColumn(add_column);
                                override = true
                            }
                        }

                        listIsZero = this.filteredColumnFields.filter(({ value }) => value === true)
                        fieldsList = listIsZero.length === 0 ? this.defaultColumnFields : this.filteredColumnFields
                        this.assignCustomizedFields(this.currentDocumentTypeCode, fieldsList, this.defaultColumnFields)
                        this.header = InterbranchDocuments.header
                        this.renderColumnFields()

                        component_x.requestingSite = {key: secureStorage.getItem("defaultSiteId").toString(), label: secureStorage.getItem("defaultSiteName")}
                        component_x.isRequestingSiteDisabled = true
                        component_x.showCreateChildDocButton = true
                        component_x.createChildDocButtonLabel = 'Create Transfer Order'

                        if (this.document_config && this.document_config.document_type_settings.incomingOrder) {
                            this.cancellationDate = moment(new Date()).add(this.document_config.document_type_settings.incomingOrder.cancellationDays, 'days')
                        }
                        break;
                    case 'OROCSQ':
                  
                        var orocsq_doc_config = await HTTPRequest.getRequest(component_x.endPoint+'/document_types/get_document_type_settings?type_code=CSQ&trans_code=ORO', null)

                        var custom_fields = []
                        if(orocsq_doc_config.document_type_settings.customFields != undefined){
                            var additional_fields = orocsq_doc_config.document_type_settings.customFields;
                            for(var i = 0; i < additional_fields.length; i++){
                                custom_fields.push({ name: additional_fields[i], value: false, custom: true})
                                this.customFieldsX = custom_fields
                                var add_column = {
                                    title: additional_fields[i].split("_").map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) .join(" "),
                                    field: additional_fields[i],
                                    sorter: 'string',
                                    visible: false,
                                    download: false,
                                    editable: false,
                                    cellClick:function(e, cell){e.stopPropagation();}
                                }
                                
                                this.tabulator.addColumn(add_column);
                                override = true
                            }
                        }

                        listIsZero = this.filteredColumnFields.filter(({ value }) => value === true)
                        fieldsList = listIsZero.length === 0 ? this.defaultColumnFields : this.filteredColumnFields
                        this.assignCustomizedFields(this.currentDocumentTypeCode, fieldsList, this.defaultColumnFields)
                        this.header = InterbranchDocuments.header
                        this.renderColumnFields()

                        component_x.supplyingSite = {key: secureStorage.getItem("defaultSiteId").toString(), label: secureStorage.getItem("defaultSiteName")}
                        component_x.isSupplyingSiteDisabled = true
                        component_x.showCreateChildDocButton = true
                        component_x.createChildDocButtonLabel = 'Create Transfer Out'

                        if (this.document_config && this.document_config.document_type_settings.outgoingOrder){
                            this.cancellationDate = moment(new Date()).add(this.document_config.document_type_settings.outgoingOrder.cancellationDays, 'days')
                        }

                        if (component_x.documentNumber < 1) {
                            var document = await HTTPRequest.getRequest(component_x.endPoint + "documents/"+this.originDocumentNumber, null);

                            if (document != null){
                                component_x.requestingSite = document['target_site_id']
                                component_x.supplyingSite = document['source_site_id']
                                component_x.reference = document['reference']
                                component_x.remark = document['remark']
                                component_x.targetDate = moment(document["target_date"])
                                component_x.cancellationDate = moment(document["cancellation_date"])

                                //Populate Footer and Calculation Data
                                component_x.grossAmount =  document['amount_gross']
                                component_x.grossAmountDisplay = document['amount_gross']
                                component_x.overallDiscount = document['amount_header_discount']
                                component_x.netAmount = document['amount_net']
                                component_x.netAmountDisplay = document['amount_net']
                                component_x.vatAmount = document['tax_amount']
                                component_x.totalWithVat = document['tax_exempt_amount']
                                component_x.itemDiscount = document['amount_line_discount']
                                component_x.taxRate = document['tax_rate']
                                component_x.grossAmountwithoutTax = document['gross_amount_without_tax']
                                component_x.netAmountWithoutTax = document['net_amount_without_tax']
                                component_x.isRequestingSiteDisabled = true
                            }

                            //Load document lines
                            window.scrollTo(0,0);
                            this.spinning = true;
                            let document_lines = []
                            document_lines = await HTTPRequest.getRequest(this.endPoint+'document_lines/'+this.originDocumentNumber+'?field_name=document_id&origin_sublocation=0', null)
                            if(document_lines != undefined && document_lines != null && document_lines != []){
                                await this.tabulator.addData(document_lines, true);
                            } 
                            this.tabulator.addFilter("line_no", ">", 0);
                            if(document_lines != undefined && document_lines != null && document_lines != []){
                                component_x.origData = JSON.stringify(document_lines.reverse()) //For isDirty Data on Document lines
                            } 
                            this.spinning = false;
                            this.initializeFooterCalculation();
                        }

                        break;
                    case 'RECCSX':
                    
                        var reccsx_doc_config = await HTTPRequest.getRequest(component_x.endPoint+'/document_types/get_document_type_settings?type_code=CSX&trans_code=REC', null)

                        var custom_fields = []
                        if(reccsx_doc_config.document_type_settings.customFields != undefined){
                            var additional_fields = reccsx_doc_config.document_type_settings.customFields;
                            for(var i = 0; i < additional_fields.length; i++){
                                custom_fields.push({ name: additional_fields[i], value: false, custom: true})
                                this.customFieldsX = custom_fields
                                var add_column = {
                                    title: additional_fields[i].split("_").map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) .join(" "),
                                    field: additional_fields[i],
                                    sorter: 'string',
                                    visible: false,
                                    download: false,
                                    editable: false,
                                    cellClick:function(e, cell){e.stopPropagation();}
                                }
                                
                                this.tabulator.addColumn(add_column);
                                override = true
                            }
                        }

                        listIsZero = this.filteredColumnFields.filter(({ value }) => value === true)
                        fieldsList = listIsZero.length === 0 ? this.defaultColumnFields : this.filteredColumnFields
                        this.assignCustomizedFields(this.currentDocumentTypeCode, fieldsList, this.defaultColumnFields)
                        this.header = InterbranchDocuments.header
                        this.renderColumnFields()

                        component_x.requestingSite = {key: secureStorage.getItem("defaultSiteId").toString(), label: secureStorage.getItem("defaultSiteName")}
                        component_x.isRequestingSiteDisabled = true

                        if (component_x.documentNumber < 1) {
                            var document = await HTTPRequest.getRequest(component_x.endPoint + "documents/"+this.originDocumentNumber, null);

                            if (document != null) {
                                component_x.requestingSite = document['target_site_id']
                                component_x.supplyingSite = document['source_site_id']
                                component_x.reference = document['reference']
                                component_x.remark = document['remark']
                                component_x.targetDate = moment(document["target_date"])
                                component_x.cancellationDate = moment(document["cancellation_date"])

                                //Populate Footer and Calculation Data
                                component_x.grossAmount =  document['amount_gross']
                                component_x.grossAmountDisplay = document['amount_gross']
                                component_x.overallDiscount = document['amount_header_discount']
                                component_x.netAmount = document['amount_net']
                                component_x.netAmountDisplay = document['amount_net']
                                component_x.vatAmount = document['tax_amount']
                                component_x.totalWithVat = document['tax_exempt_amount']
                                component_x.itemDiscount = document['amount_line_discount']
                                component_x.taxRate = document['tax_rate']
                                component_x.grossAmountwithoutTax = document['gross_amount_without_tax']
                                component_x.netAmountWithoutTax = document['net_amount_without_tax']
                                component_x.isSupplyingSiteDisabled = true
                            }

                            //Load document lines
                            window.scrollTo(0,0);
                            this.spinning = true;
                            let document_lines = []
                            document_lines = await HTTPRequest.getRequest(this.endPoint+'document_lines/'+this.originDocumentNumber+'?field_name=document_id&origin_sublocation=0', null)
                            if(document_lines != undefined && document_lines != null && document_lines != []){
                                await this.tabulator.addData(document_lines, true);
                            } 
                            this.tabulator.addFilter("line_no", ">", 0);
                            if(document_lines != undefined && document_lines != null && document_lines != []){
                                component_x.origData = JSON.stringify(document_lines.reverse()) //For isDirty Data on Document lines
                            } 
                            this.spinning = false;
                            this.initializeFooterCalculation();
                        }

                        break;
                    case 'RELCSX':
                    
                        var relcsx_doc_config = await HTTPRequest.getRequest(component_x.endPoint+'/document_types/get_document_type_settings?type_code=CSX&trans_code=REL', null)

                        var custom_fields = []
                        if(relcsx_doc_config.document_type_settings.customFields != undefined){
                            var additional_fields = relcsx_doc_config.document_type_settings.customFields;
                            for(var i = 0; i < additional_fields.length; i++){
                                custom_fields.push({ name: additional_fields[i], value: false, custom: true})
                                this.customFieldsX = custom_fields
                                var add_column = {
                                    title: additional_fields[i].split("_").map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) .join(" "),
                                    field: additional_fields[i],
                                    sorter: 'string',
                                    visible: false,
                                    download: false,
                                    editable: false,
                                    cellClick:function(e, cell){e.stopPropagation();}
                                }
                                
                                this.tabulator.addColumn(add_column);
                                override = true
                            }
                        }

                        listIsZero = this.filteredColumnFields.filter(({ value }) => value === true)
                        fieldsList = listIsZero.length === 0 ? this.defaultColumnFields : this.filteredColumnFields
                        this.assignCustomizedFields(this.currentDocumentTypeCode, fieldsList, this.defaultColumnFields)
                        this.header = InterbranchDocuments.header
                        this.renderColumnFields()

                        component_x.supplyingSite = {key: secureStorage.getItem("defaultSiteId").toString(), label: secureStorage.getItem("defaultSiteName")}
                        component_x.isSupplyingSiteDisabled = true
                        component_x.showCreateChildDocButton = true
                        component_x.createChildDocButtonLabel = 'Create Transfer In'

                        if (component_x.documentNumber < 1) {
                            var document = await HTTPRequest.getRequest(component_x.endPoint + "documents/"+this.originDocumentNumber, null);
                            if (document != null) {
                                component_x.requestingSite = document['target_site_id']
                                component_x.supplyingSite = document['source_site_id']
                                component_x.reference = document['reference']
                                component_x.remark = document['remark']
                                component_x.targetDate = moment(document["target_date"])
                                component_x.cancellationDate = moment(document["cancellation_date"])

                                //Populate Footer and Calculation Data
                                component_x.grossAmount =  document['amount_gross']
                                component_x.grossAmountDisplay = document['amount_gross']
                                component_x.overallDiscount = document['amount_header_discount']
                                component_x.netAmount = document['amount_net']
                                component_x.netAmountDisplay = document['amount_net']
                                component_x.vatAmount = document['tax_amount']
                                component_x.totalWithVat = document['tax_exempt_amount']
                                component_x.itemDiscount = document['amount_line_discount']
                                component_x.taxRate = document['tax_rate']
                                component_x.grossAmountwithoutTax = document['gross_amount_without_tax']
                                component_x.netAmountWithoutTax = document['net_amount_without_tax']
                            }

                            //Load document lines
                            window.scrollTo(0,0);
                            this.spinning = true;
                            let document_lines = []
                            document_lines = await HTTPRequest.getRequest(this.endPoint+'document_lines/'+this.originDocumentNumber+'?field_name=document_id&origin_sublocation=0', null)
                            if(document_lines != undefined && document_lines != null && document_lines != []){
                                await this.tabulator.addData(document_lines, true);
                            } 
                            this.tabulator.addFilter("line_no", ">", 0);
                            if(document_lines != undefined && document_lines != null && document_lines != []){
                                component_x.origData = JSON.stringify(document_lines.reverse()) //For isDirty Data on Document lines
                            } 
                            this.spinning = false;
                            this.initializeFooterCalculation();
                        }

                        break;

                    case 'OTHPUR':

                        //1935 - Show Header / Supports Discount for OTHPUR
                        component_x.showHeaderDiscount = true
                        component_x.showSupportDiscount = true

                        var othpur_doc_config = await HTTPRequest.getRequest(component_x.endPoint+'/document_types/get_document_type_settings?type_code=PUR&trans_code=OTH', null)

                        var custom_fields = []
                        if(othpur_doc_config.document_type_settings.customFields != undefined){
                            var additional_fields = othpur_doc_config.document_type_settings.customFields;
                            for(var i = 0; i < additional_fields.length; i++){
                                custom_fields.push({ name: additional_fields[i], value: false, custom: true})
                                this.customFieldsX = custom_fields
                                var add_column = {
                                    title: additional_fields[i].split("_").map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) .join(" "),
                                    field: additional_fields[i],
                                    sorter: 'string',
                                    visible: false,
                                    download: false,
                                    editable: false,
                                    cellClick:function(e, cell){e.stopPropagation();}
                                }
                                
                                this.tabulator.addColumn(add_column);
                                override = true
                            }
                        }

                        listIsZero = this.filteredColumnFields.filter(({ value }) => value === true)
                        fieldsList = listIsZero.length === 0 ? this.defaultColumnFields : this.filteredColumnFields
                        this.assignCustomizedFields(this.currentDocumentTypeCode, fieldsList, this.defaultColumnFields)
                        this.header = PurchaseDocuments.header
                        this.renderColumnFields()

                        component_x.showCreateChildDocButton = true
                        component_x.createChildDocButtonLabel = 'Create PO'

                        break;
                    case 'ORIPOX':
                        //1935 - Show Header / Supports Discount for ORIPOX
                        component_x.showHeaderDiscount = true
                        component_x.showSupportDiscount = true

                        this.defaultColumnFields = [
                        { name: "supplier_stock_no", value: false },
                        { name: "line_no", value: true },
                        { name: "product_icon", value: true },
                        { name: "stock_no", value: true },
                        { name: "barcode", value: true },
                        { name: "product_name", value: true },
                        { name: "unit_name", value: true },
                        { name: "quantity", value: true },
                        { name: "actual_quantity", value: true },
                        { name: "content_quantity", value: true },
                        { name: "price", value: true },
                        { name: "cost", value: true },
                        { name: "total_gross", value: true },
                        { name: "subtotal", value: true },
                        { name: "discount_text", value: true },
                        { name: "available_quantity", value: false },
                        { name: "supplier", value: false },
                        { name: "category_code", value: false },
                        { name: "section_code", value: false },
                        { name: "department", value: false },
                        { name: "division", value: false },
                        { name: "design", value: false },
                        { name: "size", value: false },
                        { name: "product_series", value: false },
                        { name: "product_group", value: false },
                        { name: "erp_code", value: false }
                        ]
                        
                            
                        // Arvin
                        // Check if account has autorep feature
                        var categoryId = await HTTPRequest.getRequest(this.endPoint + '/system_module_categories?code=PTP-001', null, null)
                        var autoRepModules = await HTTPRequest.getRequest(this.endPoint + '/system_module_categories/' +  categoryId[0].id + '/enabled_modules', null, null)
                            
                        if(autoRepModules.length > 0) {
                            for (var key in autoRepModules) {
                                //Retrieving and application of User Access Rights
                                var system_module = await HTTPRequest.getRequest(this.endPoint+'/system_modules?status=A&code='+ autoRepModules[key].code, null)
                                var accessRightsRequest = await HTTPRequest.getRequest(this.endPoint + 'users/' + secureStorage.getItem("userId") + "/access_rights?system_module_id=" + system_module[0].id, null)

                                if (accessRightsRequest.access_rights[system_module[0].id]) {
                                    var withaccessRights  = (accessRightsRequest.access_rights[system_module[0].id].includes('V')) ? 1 : 0;
                                    if(autoRepModules[key].code == 'ORIPOX-AM' && withaccessRights == 1)
                                        this.autoRepMinMaxAccess = 1;
                                    
                                    if(autoRepModules[key].code == 'ORIPOX-AO' && withaccessRights == 1)
                                        this.autoRepOfftakeAccess = 1;
                                } 
                            }   
                        }

                        var oripox_doc_config = await HTTPRequest.getRequest(component_x.endPoint+'/document_types/get_document_type_settings?type_code=POX&trans_code=ORI', null)

                        var custom_fields = []
                        if(oripox_doc_config.document_type_settings.customFields != undefined){
                            var additional_fields = oripox_doc_config.document_type_settings.customFields;
                            for(var i = 0; i < additional_fields.length; i++){
                                custom_fields.push({ name: additional_fields[i], value: false, custom: true})
                                this.customFieldsX = custom_fields
                                var add_column = {
                                    title: additional_fields[i].split("_").map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) .join(" "),
                                    field: additional_fields[i],
                                    sorter: 'string',
                                    visible: false,
                                    download: false,
                                    editable: false,
                                    cellClick:function(e, cell){e.stopPropagation();}
                                }
                                
                                this.tabulator.addColumn(add_column);
                                override = true
                            }
                        }

                        listIsZero = this.filteredColumnFields.filter(({ value }) => value === true)
                        fieldsList = listIsZero.length === 0 ? this.defaultColumnFields : this.filteredColumnFields
                        this.assignCustomizedFields(this.currentDocumentTypeCode, fieldsList, this.defaultColumnFields)
                        this.header = PurchaseDocuments.headerOriPox
                        this.renderColumnFields()

                        component_x.requestingSite = {key: secureStorage.getItem("defaultSiteId").toString(), label: secureStorage.getItem("defaultSiteName")}

                        if (this.document_config && this.document_config.document_type_settings.incomingOrder) {
                            this.cancellationDate = moment(new Date()).add(this.document_config.document_type_settings.incomingOrder.cancellationDays, 'days')
                        }

                        //Show Charges and Vat Exclusive Option
                        component_x.showChargesTable = false
                        if(component_x.document_config){
                            component_x.showVatExclusiveCheckboxConfig = component_x.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.showVatExclusiveAmount
                            
                            if(component_x.document_config.document_type_settings.additionalEditorBehavior){
                                this.offtakeDays = component_x.document_config.document_type_settings.additionalEditorBehavior.offtakeDays
                            }
                        }
                        component_x.showVatExclusiveCheckbox = true
                        component_x.showShippingMethod = true
                        component_x.showCreateChildDocButton = true
                        component_x.createChildDocButtonLabel = 'Create RR'
                        component_x.showSupplierOptions = true
                        component_x.showTradeToggle = true

                        //Document Charges
                        //Use document number if origin document number is not exist (TKT#2764)
                        var document_charges = []
                        document_charges = await HTTPRequest.getRequest(component_x.endPoint + "document_charges/"+((component_x.originDocumentNumber > 0) ? component_x.originDocumentNumber : component_x.documentNumber)+"?field_name=document_id",null);
                        if(document_charges) component_x.chargeData = document_charges

                        if (component_x.documentNumber < 1 && this.originDocumentNumber > 0) {
                            var document = await HTTPRequest.getRequest(component_x.endPoint + "documents/"+this.originDocumentNumber, null);
                            if (document != null) {
                                component_x.supplier = document["supplier_id"]
                                component_x.currency = document["currency_id"]
                                component_x.currencyDetails = document["currency_id"]
                                component_x.currencyRate = document["currency_rate"]
                                component_x.reference = document['reference']
                                component_x.remark = document['remark']
                                component_x.targetDate = moment(document["target_date"])
                                component_x.cancellationDate = moment(document["cancellation_date"])

                                //Populate Footer and Calculation Data
                                component_x.grossAmount =  document['amount_gross']
                                component_x.grossAmountDisplay = document['amount_gross']
                                component_x.overallDiscount = document['amount_header_discount']
                                component_x.netAmount = document['amount_net']
                                component_x.netAmountDisplay = document['amount_net']
                                component_x.vatAmount = document['tax_amount']
                                component_x.totalWithVat = document['tax_exempt_amount']
                                component_x.itemDiscount = document['amount_line_discount']
                                component_x.taxRate = document['tax_rate']
                                component_x.grossAmountwithoutTax = document['gross_amount_without_tax']
                                component_x.netAmountWithoutTax = document['net_amount_without_tax']
                                component_x.supplierCurrencyId = document['supplier_currency_id']
                                component_x.supplierCurrencyRate =  document['supplier_currency_rate']
                            }

                            //Load document lines
                            window.scrollTo(0,0);
                            this.spinning = true;
                            let document_lines = []
                            document_lines = await HTTPRequest.getRequest(this.endPoint+'document_lines/'+this.originDocumentNumber+'?field_name=document_id&origin_sublocation=0', null)
                            if(document_lines != undefined && document_lines != null && document_lines != []){
                                await this.tabulator.addData(document_lines, true);
                            } 
                            this.tabulator.addFilter("line_no", ">", 0);
                            if(document_lines != undefined && document_lines != null && document_lines != []){
                                component_x.origData = JSON.stringify(document_lines.reverse()) //For isDirty Data on Document lines
                            } 
                            this.spinning = false;
                            this.initializeFooterCalculation();
                        }

                        break;
                    case 'ORIASN':

                        this.defaultColumnFields = [
                        ...this.defaultColumnFields,
                        { name: "total_gross", value: true },
                        { name: "actual_quantity", value: true },
                        ]
                    
                        this.filteredColumnFields = this.defaultColumnFields
                        if (this.documentTableFilteredList !== null) this.checkCustomizedFields(this.currentDocumentTypeCode)
                        this.header = PurchaseDocuments.headerOriPox
                        this.renderColumnFields()

                        component_x.requestingSite = {key: secureStorage.getItem("defaultSiteId").toString(), label: secureStorage.getItem("defaultSiteName")}

                        if (this.document_config && this.document_config.document_type_settings.incomingOrder) {
                            this.cancellationDate = moment(new Date()).add(this.document_config.document_type_settings.incomingOrder.cancellationDays, 'days')
                        }

                        //Show Charges and Vat Exclusive Option
                        component_x.showChargesTable = false
                        if(component_x.document_config){
                            component_x.showVatExclusiveCheckboxConfig = component_x.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.showVatExclusiveAmount
                        }

                        component_x.showSupportDiscount = true
                        component_x.showVatExclusiveCheckbox = true
                        component_x.showShippingMethod = true
                        component_x.showCreateChildDocButton = true
                        component_x.createChildDocButtonLabel = 'Create RR'
                        component_x.showSupplierOptions = true
                        component_x.showTradeToggle = true

                        if (component_x.documentNumber < 1 && this.originDocumentNumber > 0) {
                            var document = await HTTPRequest.getRequest(component_x.endPoint + "documents/"+this.originDocumentNumber, null);

                            if (document != null) {
                                component_x.supplier = document["supplier_id"]
                                component_x.reference = document['reference']
                                component_x.remark = document['remark']
                                component_x.targetDate = moment(document["target_date"])
                                component_x.cancellationDate = moment(document["cancellation_date"])

                                //Populate Footer and Calculation Data
                                component_x.grossAmount =  document['amount_gross']
                                component_x.grossAmountDisplay = document['amount_gross']
                                component_x.overallDiscount = document['amount_header_discount']
                                component_x.netAmount = document['amount_net']
                                component_x.netAmountDisplay = document['amount_net']
                                component_x.vatAmount = document['tax_amount']
                                component_x.totalWithVat = document['tax_exempt_amount']
                                component_x.itemDiscount = document['amount_line_discount']
                                component_x.taxRate = document['tax_rate']
                                component_x.grossAmountwithoutTax = document['gross_amount_without_tax']
                                component_x.netAmountWithoutTax = document['net_amount_without_tax']
                            }

                            //Load document lines
                            window.scrollTo(0,0);
                            this.spinning = true;
                            let document_lines = []
                            document_lines = await HTTPRequest.getRequest(this.endPoint+'document_lines/'+this.originDocumentNumber+'?field_name=document_id&origin_sublocation=0', null)
                            if(document_lines != undefined && document_lines != null && document_lines != []){
                                await this.tabulator.addData(document_lines, true);
                            } 
                            this.tabulator.addFilter("line_no", ">", 0);
                            if(document_lines != undefined && document_lines != null && document_lines != []){
                                component_x.origData = JSON.stringify(document_lines.reverse()) //For isDirty Data on Document lines
                            } 
                            this.spinning = false;
                            this.initializeFooterCalculation();
                        }
                        break;
                    case 'RECDEL':
                        //1935 - Show Header / Supports Discount for RECDEL
                        component_x.showHeaderDiscount = true
                        component_x.showSupportDiscount = true

                        this.defaultColumnFields = [
                        ...this.defaultColumnFields,
                        { name: "ref_code", value: true },
                        { name: "reason_id", value:true},
                        { name: "actual_quantity", value: false },
                        { name: "total_gross", value: true },
                        { name: "invoice_amount", value: true },
                        { name: "invoice_discount", value: true },
                        { name: "color", value: false },
                        ]

                        // Arvin
                        // Check if account has purchase variance feature
                        var categoryId = await HTTPRequest.getRequest(this.endPoint + '/system_module_categories?code=PTP-002', null, null)
                        var purchaseVarianceModules = await HTTPRequest.getRequest(this.endPoint + '/system_module_categories/' +  categoryId[0].id + '/enabled_modules', null, null)
                            
                        if(purchaseVarianceModules.length > 0) {
                            for (var key in purchaseVarianceModules) {
                                //Retrieving and application of User Access Rights
                                var system_module = await HTTPRequest.getRequest(this.endPoint+'/system_modules?status=A&code='+ purchaseVarianceModules[key].code, null)
                                var accessRightsRequest = await HTTPRequest.getRequest(this.endPoint + 'users/' + secureStorage.getItem("userId") + "/access_rights?system_module_id=" + system_module[0].id, null)

                                if (accessRightsRequest.access_rights[system_module[0].id]) {
                                    var withaccessRights  = (accessRightsRequest.access_rights[system_module[0].id].includes('V')) ? 1 : 0
                                    if(purchaseVarianceModules[key].code == 'RECDEL-PV' && withaccessRights == 1)
                                        this.purchaseVarianceAccess = 1;
                                } 
                            }   
                        }
                    
                        var recdel_doc_config = await HTTPRequest.getRequest(component_x.endPoint+'/document_types/get_document_type_settings?type_code=DEL&trans_code=REC', null)

                        var custom_fields = []
                        if(recdel_doc_config.document_type_settings.customFields != undefined){
                            var additional_fields = recdel_doc_config.document_type_settings.customFields;
                            for(var i = 0; i < additional_fields.length; i++){
                                custom_fields.push({ name: additional_fields[i], value: false, custom: true})
                                this.customFieldsX = custom_fields
                                var add_column = {
                                    title: additional_fields[i].split("_").map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) .join(" "),
                                    field: additional_fields[i],
                                    sorter: 'string',
                                    visible: false,
                                    download: false,
                                    editable: false,
                                    cellClick:function(e, cell){e.stopPropagation();}
                                }
                                
                                this.tabulator.addColumn(add_column);
                                override = true
                            }
                        }

                        listIsZero = this.filteredColumnFields.filter(({ value }) => value === true)
                        fieldsList = listIsZero.length === 0 ? this.defaultColumnFields : this.filteredColumnFields
                        this.assignCustomizedFields(this.currentDocumentTypeCode, fieldsList, this.defaultColumnFields)
                        this.header = PurchaseDocuments.header
                        this.renderColumnFields()

                        //Show Charges and Vat Exclusive Option
                        component_x.showChargesTable = true
                        if(component_x.document_config){
                            component_x.showVatExclusiveCheckboxConfig = component_x.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.showVatExclusiveAmount
                        }

                        component_x.showCancellationDate = false
                        component_x.showTargetDate = false
                        component_x.showVatExclusiveCheckbox = true
                        component_x.showCreateChildDocButton = true
                        component_x.createChildDocButtonLabel = 'Create Purchase Return'

                        //Document Charges
                        //Use document number if origin document number is not exist (TKT#2764)
                        var document_charges = []
                        document_charges = await HTTPRequest.getRequest(component_x.endPoint + "document_charges/"+component_x.documentNumber+"?field_name=document_id",null);
                        if(document_charges) component_x.chargeData = document_charges

                        if (component_x.documentNumber < 1 && this.originDocumentNumber > 0) {
                            var document = await HTTPRequest.getRequest(component_x.endPoint + "documents/"+this.originDocumentNumber, null);
                            if (document != null) {
                                component_x.supplier = document["supplier_id"]
                                component_x.currency = document["currency_id"]
                                component_x.currencyDetails = document["currency_id"]
                                component_x.currencyRate = document["currency_rate"]
                                component_x.reference = document['reference']
                                component_x.remark = document['remark']
                                component_x.targetDate = moment(document["target_date"])
                                component_x.cancellationDate = moment(document["cancellation_date"])

                                //Populate Footer and Calculation Data
                                component_x.grossAmount =  document['amount_gross']
                                component_x.grossAmountDisplay = document['amount_gross']
                                component_x.overallDiscount = document['amount_header_discount']
                                component_x.netAmount = document['amount_net']
                                component_x.netAmountDisplay = document['amount_net']
                                component_x.vatAmount = document['tax_amount']
                                component_x.totalWithVat = document['tax_exempt_amount']
                                component_x.itemDiscount = document['amount_line_discount']
                                component_x.taxRate = document['tax_rate']
                                component_x.grossAmountwithoutTax = document['gross_amount_without_tax']
                                component_x.netAmountWithoutTax = document['net_amount_without_tax']
                                component_x.supplierCurrencyId = document['supplier_currency_id']
                                component_x.supplierCurrencyRate =  document['supplier_currency_rate']
                                component_x.documentDate = moment(new Date())
                                
                                if (document["purpose_id"].key){
                                    this.autoSetPurpose(this.currentDocumentTypeId)
                                }
                            }

                            if(component_x.document_config){
                                var setQuantityToZero = component_x.document_config.document_type_settings.receivingDocument.setZeroDefaultQuantityPo || false
                            }

                            //Load document lines
                            window.scrollTo(0,0);
                            this.spinning = true;
                            let document_lines = []
                            let new_document_lines = []
                            document_lines = await HTTPRequest.getRequest(this.endPoint+'document_lines/'+this.originDocumentNumber+'?field_name=document_id&origin_sublocation=0', null)
                            if(document_lines != undefined && document_lines != null && document_lines != []){
                                this.sumSubtotal = 0
                                document_lines.map((item) => {
                                    this.sumSubtotal = this.sumSubtotal + Number(item.subtotal)
                                })

                                document_lines = document_lines.map((item) => {
                                    item.quantity = item.quantity - item.actual_quantity
                                    //3058 Recalculate lines 
                                    item.subtotal = ((item.quantity * Number(item.price)) - Number(item.discount)).toFixed(this.fixedDecimalPlaces)
                                    // Compute overall discount per line for subtotal without vat computation
                                    let distributedOverallDiscount = 0
                                    if (Number(item.subtotal) != 0 || this.sumSubtotal != 0 || this.overallDiscount != 0){
                                        distributedOverallDiscount = this.overallDiscount * (Number(item.subtotal) / this.sumSubtotal)
                                    }

                                    let subtotal_less_overall_discount = Number(item.subtotal) - Number(distributedOverallDiscount)
                                    if(this.party_tax_type == 'V' || this.party_tax_type == undefined){
                                        if(item.tax_type == 'V'){
                                            item.subtotal_without_vat = (subtotal_less_overall_discount/ (1+Number(this.taxRate))).toFixed(this.fixedDecimalPlaces)
                                            item.price_without_vat = (Number(item.price)/ (1+Number(this.taxRate))).toFixed(this.fixedDecimalPlaces)
                                            item.tax_amount = (subtotal_less_overall_discount - item.subtotal_without_vat).toFixed(this.fixedDecimalPlaces)
                                        } else {
                                            item.subtotal_without_vat = (subtotal_less_overall_discount).toFixed(this.fixedDecimalPlaces)
                                            item.price_without_vat = (Number(item.price)).toFixed(this.fixedDecimalPlaces)
                                            item.tax_amount = 0
                                        }
                                    } else {
                                        item.subtotal_without_vat = (subtotal_less_overall_discount).toFixed(this.fixedDecimalPlaces)
                                        item.price_without_vat = (Number(item.price)).toFixed(this.fixedDecimalPlaces)
                                        item.tax_amount = 0
                                    }
                                    
                                    return item
                                })
                                
                                for(var i = 0; i < document_lines.length; i++){
                                    let document_line = document_lines[i]
                                    if (document_line.quantity > 0){
                                        new_document_lines.push(document_line)
                                    }
                                }
                            }
                            
                            
                            if (setQuantityToZero) {
                                new_document_lines.forEach( row => {
                                    row.quantity = 0
                                });
                            }else{
                              console.log(">>> Should get qty from original document")      
                            }

                            if (setQuantityToZero) {
                                new_document_lines.forEach( row => {
                                    row.quantity = 0
                                });
                            }else{
                                console.log(">>> Should get qty from original document")      
                            }

                            if(new_document_lines != undefined && new_document_lines != null && new_document_lines != []){
                                await this.tabulator.addData(new_document_lines, true);
                            } 

                            this.tabulator.addFilter("line_no", ">", 0);
                            if(new_document_lines != undefined && new_document_lines != null && new_document_lines != []){
                                component_x.origData = JSON.stringify(new_document_lines.reverse()) //For isDirty Data on Document lines
                            }

                            this.spinning = false;
                            this.initializeFooterCalculation();

                            this.isSupplierDisabled = true
                            
                            //3058 -> Recompute the summary
                            this.calculateSummary();
                        }
                        break;

                    case 'OTHSBI':

                        this.defaultColumnFields = [
                        ...this.defaultColumnFields,
                        { name: "actual_quantity", value: false },
                        { name: "price_pi", value: true},
                        { name: "total_gross", value: true },
                        { name: "invoice_amount", value: true },
                        { name: "invoice_discount", value: true },
                        ]
                    
                        this.filteredColumnFields = this.defaultColumnFields
                        if (this.documentTableFilteredList !== null) this.checkCustomizedFields(this.currentDocumentTypeCode)
                        this.header = PurchaseDocuments.headerOthSbi
                        this.renderColumnFields()


                        if(component_x.document_config){
                            component_x.showVatExclusiveCheckboxConfig = component_x.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.showVatExclusiveAmount
                        }
                        component_x.showVatExclusiveCheckbox = true
                        component_x.showDocumentBodyHeader = false
                        component_x.isPurposeDisabled = true
                        component_x.isSupportsDiscountDisabled = true
                        component_x.isSupplierDisabled =  true
                        component_x.isDocumentDateDisabled = true
                        component_x.isTargetDateDisabled = true
                        component_x.isCancellationDateDisabled = true

                        if (component_x.documentNumber < 1) {

                            var receiving_report_id = this.$route.params.receiving_report_id
                            var document = await HTTPRequest.getRequest(component_x.endPoint + "documents/"+receiving_report_id, null);

                            component_x.receivingReport = receiving_report_id
                            component_x.supplier = document["supplier_id"]
                            component_x.reference = document['reference']
                            component_x.remark = document['remark']
                            component_x.targetDate = moment(document["target_date"])
                            component_x.cancellationDate = moment(document["cancellation_date"])

                            if (document['support_discount_text']) component_x.supportDiscount = document['support_discount_text'].split(',')
                            if (document["discount_text"]!="") {
                                if (document['discount_text'] != null) component_x.headerDiscount = document["discount_text"].split(',')
                            }

                            //Load document lines
                            window.scrollTo(0,0);
                            this.spinning = true;
                            let document_lines = []
                            document_lines = await HTTPRequest.getRequest(this.endPoint+'document_lines/'+receiving_report_id+'?field_name=document_id', null)
                            if(document_lines != undefined && document_lines != null && document_lines != []){
                                document_lines.forEach( row => {
                                    row.goods_issue_quantity = row.quantity
                                });
                                await this.tabulator.addData(document_lines, true);
                            }
                            this.tabulator.addFilter("line_no", ">", 0);
                            if(document_lines != undefined && document_lines != null && document_lines != []){
                                component_x.origData = JSON.stringify(document_lines.reverse()) //For isDirty Data on Document lines
                            } 

                            this.spinning = false;

                            //Populate Footer and Calculation Data
                            component_x.grossAmount =  document['amount_gross']
                            component_x.grossAmountDisplay = document['amount_gross']
                            component_x.overallDiscount = document['amount_header_discount']
                            component_x.netAmount = document['amount_net']
                            component_x.netAmountDisplay = document['amount_net']
                            component_x.vatAmount = document['tax_amount']
                            component_x.totalWithVat = document['tax_exempt_amount']
                            component_x.itemDiscount = document['amount_line_discount']
                            component_x.taxRate = document['tax_rate']
                            component_x.grossAmountwithoutTax = document['gross_amount_without_tax']
                            component_x.netAmountWithoutTax = document['net_amount_without_tax']
                            this.initializeFooterCalculation()
                            if (component_x.totalQuantity == 0) component_x.totalQuantity = document['total_quantity']
                        }
                        break;
                    case 'OTHPWS':
                        this.defaultColumnFields = [
                            { name: "line_no", value: true },
                            { name: "product_icon", value: true },
                            { name: "product_name", value: true },
                            { name: "stock_no", value: true },
                            { name: "barcode", value: true },
                            { name: "old_landed_cost", value: true },
                            { name: "landed_cost", value: true },
                            { name: "old_retail_price", value: true },
                            { name: "retail_price", value: true },
                            { name: "markup_percent", value: true },
                            { name: "old_original_cost", value: true },
                            { name: "original_cost", value: true },
                            { name: "old_ordering_cost", value: true },
                            { name: "ordering_cost", value: true },
                            { name: "old_wholesale_price", value: true },
                            { name: "wholesale_price", value: true },
                            { name: "old_least_price", value: true },
                            { name: "least_price", value: true },
                            { name: "old_special_price", value: true },
                            { name: "special_price", value: true },
                            { name: "on_hand_quantity", value: true },
                            { name: "available_quantity", value: false },
                            { name: "supplier", value: false },
                            { name: "category_code", value: false },
                            { name: "section_code", value: false },
                            { name: "department", value: false },
                            { name: "division", value: false },
                            { name: "design", value: false },
                            { name: "size", value: false },
                            { name: "product_series", value: false },
                            { name: "product_group", value: false },
                            { name: "erp_code", value: false }
                        ]

                        this.filteredColumnFields = this.defaultColumnFields
                        if (this.documentTableFilteredList !== null) this.checkCustomizedFields(this.currentDocumentTypeCode)
                        var pwsSubtotalColumns = ["subtotal", "subtotal_php", "subtotal_vat", "subtotal_without_vat"]
                        this.filteredColumnFields = this.filteredColumnFields.filter(({ name }) => !pwsSubtotalColumns.includes(name))
                        this.header = PriceWorkSheet.header
                        this.renderColumnFields()
                        for (var i = 0; i < pwsSubtotalColumns.length; i++) {
                            var field = pwsSubtotalColumns[i]
                            var column = this.tabulator.getColumn(field)
                            if (column) {
                                await column.updateDefinition({ visible: false, download: false })
                                this.tabulator.hideColumn(field)
                            }
                        }

                        component_x.showSummaryCalculation = false
                        component_x.showTotalQuantity = false
                        component_x.showPwsCosts = true
                        component_x.showCancellationDate = false
                        component_x.showQuantity = false
                        component_x.showUnitCost = false
                        component_x.showDiscount = false
                        component_x.showUnitNetCost = false
                        component_x.showSubtotal = false
                        component_x.showFilteredBySupplier = false

                        // set site default to master if sitePricingEnabled
                        let sitePricingEnabled = secureStorage.getItem("sitePricingEnabled")

                        if ( component_x.documentNumber > 0 ) {
                            var document = await HTTPRequest.getRequest(component_x.endPoint + "documents/"+component_x.documentNumber, null);
                            if( component_x.currentDocumentTypeCode ==='OTHPWS'){
                                component_x.forThisSite = sitePricingEnabled ? document['site_id'] :  {key:'-1', label: 'Master'}
                            }else{
                                component_x.forThisSite = document['site_id']
                            } 
                        } else {
                            component_x.forThisSite = {key:'-1', label: 'Master'}
                        } 
                        break;
                    case 'OTHBAR':
                        this.defaultColumnFields = [
                        { name: "line_no", value: true },
                        { name: "barcode", value: true },
                        { name: "product_name", value: true },
                        { name: "stock_no", value: true },
                        { name: "quantity", value: true },
                        { name: "color", value: true },
                        { name: "size", value: true },
                        { name: "price", value: true },
                        { name: "supplier", value: false },
                        { name: "category_code", value: false },
                        { name: "section_code", value: false },
                        { name: "department", value: false },
                        { name: "division", value: false },
                        { name: "design", value: false },
                        { name: "size", value: false },
                        { name: "product_series", value: false },
                        { name: "product_group", value: false },
                        { name: "erp_code", value: false }
                        
                        ]
                        this.filteredColumnFields = this.defaultColumnFields
                        if (this.documentTableFilteredList !== null) this.checkCustomizedFields(this.currentDocumentTypeCode)
                        this.header = BarcodePrinting.header
                        this.renderColumnFields()
                        this.showSummaryCalculation = false
                        this.showTotalQuantity = true
                        this.showDiscount = false
                        this.showUnitNetCost = false
                        this.showSubtotal = false
                        this.showAdvancedInfo = false

                        if (component_x.documentNumber < 1) {
                            var barcode_printing_id = this.$route.params.barcode_printing_id
                            var document = await HTTPRequest.getRequest(component_x.endPoint + "documents/"+barcode_printing_id, null);

                            component_x.reference = document['reference']
                            component_x.remark = document['remark']

                            //Load document lines
                            window.scrollTo(0,0);
                            this.spinning = true;
                            let document_lines = []
                            document_lines = await HTTPRequest.getRequest(this.endPoint+'document_lines/'+barcode_printing_id+'?field_name=document_id&document_type_code='+this.currentDocumentTypeCode, null)
                            if(document_lines != undefined && document_lines != null && document_lines != []){
                                await this.tabulator.addData(document_lines, true);
                            }

                            this.tabulator.addFilter("line_no", ">", 0);
                            if(document_lines != undefined && document_lines != null && document_lines != []){
                                component_x.origData = JSON.stringify(document_lines.reverse()) //For isDirty Data on Document lines
                            } 
                            this.initializeFooterCalculation()
                            this.spinning = false;
                        }
                        break;
                    case 'RELRSR':

                        //1935 - Show Header / Supports Discount for RELRSR
                        component_x.showHeaderDiscount = true
                        component_x.showSupportDiscount = true
                        
                        var subtotal = this.tabulator.getColumn("ref_code");
                        if(subtotal)
                            await subtotal.updateDefinition({ download: true });
                        
                        var pricex = this.tabulator.getColumn("price");
                        if(pricex)
                            await pricex.updateDefinition({ editable: false });

                        this.defaultColumnFields = [
                        ...this.defaultColumnFields,
                        { name: "actual_quantity", value: false },
                        { name: "ref_code", value: true },
                        ]
                    
                        var relrsr_doc_config = await HTTPRequest.getRequest(component_x.endPoint+'/document_types/get_document_type_settings?type_code=RSR&trans_code=REL', null)

                        var custom_fields = []
                        if(relrsr_doc_config.document_type_settings.customFields != undefined){
                            var additional_fields = relrsr_doc_config.document_type_settings.customFields;
                            for(var i = 0; i < additional_fields.length; i++){
                                custom_fields.push({ name: additional_fields[i], value: false, custom: true})
                                this.customFieldsX = custom_fields
                                var add_column = {
                                    title: additional_fields[i].split("_").map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) .join(" "),
                                    field: additional_fields[i],
                                    sorter: 'string',
                                    visible: false,
                                    download: false,
                                    editable: false,
                                    cellClick:function(e, cell){e.stopPropagation();}
                                }
                                
                                this.tabulator.addColumn(add_column);
                                override = true
                            }
                        }

                        listIsZero = this.filteredColumnFields.filter(({ value }) => value === true)
                        fieldsList = listIsZero.length === 0 ? this.defaultColumnFields : this.filteredColumnFields
                        this.assignCustomizedFields(this.currentDocumentTypeCode, fieldsList, this.defaultColumnFields)
                        this.header = PurchaseDocuments.header
                        this.renderColumnFields()

                        if (component_x.documentNumber < 1 && this.originDocumentNumber > 0) {
                            var document = await HTTPRequest.getRequest(component_x.endPoint + "documents/"+this.originDocumentNumber, null);
                            if (document != null) {
                                component_x.supplier = document["supplier_id"]
                                component_x.currency = document["currency_id"]
                                component_x.currencyDetails = document["currency_id"]
                                component_x.currencyRate = document["currency_rate"]
                                component_x.reference = document['reference']
                                component_x.remark = document['remark']
                                component_x.targetDate = moment(document["target_date"])
                                component_x.cancellationDate = moment(document["cancellation_date"])

                                //Populate Footer and Calculation Data
                                component_x.grossAmount =  document['amount_gross']
                                component_x.grossAmountDisplay = document['amount_gross']
                                component_x.overallDiscount = document['amount_header_discount']
                                component_x.netAmount = document['amount_net']
                                component_x.netAmountDisplay = document['amount_net']
                                component_x.vatAmount = document['tax_amount']
                                component_x.totalWithVat = document['tax_exempt_amount']
                                component_x.itemDiscount = document['amount_line_discount']
                                component_x.taxRate = document['tax_rate']
                                component_x.grossAmountwithoutTax = document['gross_amount_without_tax']
                                component_x.netAmountWithoutTax = document['net_amount_without_tax']
                                component_x.supplierCurrencyId = document['supplier_currency_id']
                                component_x.supplierCurrencyRate =  document['supplier_currency_rate']
                            }

                            //Load document lines
                            window.scrollTo(0,0);
                            this.spinning = true;
                            let document_lines = []
                            let new_document_lines = []
                            document_lines = await HTTPRequest.getRequest(this.endPoint+'document_lines/'+this.originDocumentNumber+'?field_name=document_id&origin_sublocation=0', null)
                            if(document_lines != undefined && document_lines != null && document_lines != []){
                                document_lines = document_lines.map((item) => {
                                    item.quantity = item.quantity - item.actual_quantity
                                    return item
                                })
                                for(var i = 0; i < document_lines.length; i++){
                                    let document_line = document_lines[i]
                                    if (document_line.quantity > 0){
                                        new_document_lines.push(document_line)
                                    }
                                }
                                await this.tabulator.addData(new_document_lines, true);
                            }
                            

                            this.tabulator.addFilter("line_no", ">", 0);
                            if(new_document_lines != undefined && new_document_lines != null && new_document_lines != []){
                                component_x.origData = JSON.stringify(new_document_lines.reverse()) //For isDirty Data on Document lines
                            } 
                            
                            //Document Charges
                            var document_charges = []
                            document_charges = await HTTPRequest.getRequest(component_x.endPoint + "document_charges/"+component_x.originDocumentNumber+"?field_name=document_id", null);
                            if(document_charges) component_x.chargeData = document_charges

                            this.spinning = false;
                            // this.initializeFooterCalculation();

                            this.isSupplierDisabled = true
                            this.showCreateChildDocButton = false;
                        }
                        
                        component_x.showCancellationDate = false
                        component_x.showTargetDate = false
                        break;

                    case 'RECADJ':

                        this.defaultColumnFields = [
                            ...this.defaultColumnFields,
                            { name: "actual_quantity", value: false },
                            { name: "retail_price", value: true },
                        ]
                        this.requestingSite = {key: secureStorage.getItem("defaultSiteId").toString(), label: secureStorage.getItem("defaultSiteName")}
                        var recadj_doc_config = await HTTPRequest.getRequest(component_x.endPoint+'/document_types/get_document_type_settings?type_code=ADJ&trans_code=REC', null)

                        var custom_fields = []
                        if(recadj_doc_config.document_type_settings.customFields != undefined){
                            var additional_fields = recadj_doc_config.document_type_settings.customFields;
                            for(var i = 0; i < additional_fields.length; i++){
                                custom_fields.push({ name: additional_fields[i], value: false, custom: true})
                                this.customFieldsX = custom_fields
                                var add_column = {
                                    title: additional_fields[i].split("_").map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) .join(" "),
                                    field: additional_fields[i],
                                    sorter: 'string',
                                    visible: false,
                                    download: false,
                                    editable: false,
                                    cellClick:function(e, cell){e.stopPropagation();}
                                }
                                
                                this.tabulator.addColumn(add_column);
                                override = true
                            }
                        }

                        listIsZero = this.filteredColumnFields.filter(({ value }) => value === true)
                        fieldsList = listIsZero.length === 0 ? this.defaultColumnFields : this.filteredColumnFields
                        this.assignCustomizedFields(this.currentDocumentTypeCode, fieldsList, this.defaultColumnFields)
                        this.header = LocalDocuments.headerAdjustments
                        this.header = {...this.header, showParty:false}
                        this.party =  this.requestingSite.label
                        this.renderColumnFields()

                        component_x.showCancellationDate = false
                        component_x.showTargetDate = false
                        break;
                    case 'RELADJ':

                        this.defaultColumnFields = [
                            ...this.defaultColumnFields,
                            { name: "actual_quantity", value: false },
                            { name: "retail_price", value: true },
                        ]
                        this.requestingSite = {key: secureStorage.getItem("defaultSiteId").toString(), label: secureStorage.getItem("defaultSiteName")}
                        var reladj_doc_config = await HTTPRequest.getRequest(component_x.endPoint+'/document_types/get_document_type_settings?type_code=ADJ&trans_code=REL', null)

                        var custom_fields = []
                        if(reladj_doc_config.document_type_settings.customFields != undefined){
                            var additional_fields = reladj_doc_config.document_type_settings.customFields;
                            for(var i = 0; i < additional_fields.length; i++){
                                custom_fields.push({ name: additional_fields[i], value: false, custom: true})
                                this.customFieldsX = custom_fields
                                var add_column = {
                                    title: additional_fields[i].split("_").map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) .join(" "),
                                    field: additional_fields[i],
                                    sorter: 'string',
                                    visible: false,
                                    download: false,
                                    editable: false,
                                    cellClick:function(e, cell){e.stopPropagation();}
                                }
                                
                                this.tabulator.addColumn(add_column);
                                override = true
                            }
                        }

                        listIsZero = this.filteredColumnFields.filter(({ value }) => value === true)
                        fieldsList = listIsZero.length === 0 ? this.defaultColumnFields : this.filteredColumnFields
                        this.assignCustomizedFields(this.currentDocumentTypeCode, fieldsList, this.defaultColumnFields)
                        this.header = LocalDocuments.headerAdjustments
                        this.header = {...this.header, showParty:false}
                        this.party =  this.requestingSite.label
                        this.renderColumnFields()

                        component_x.showCancellationDate = false
                        component_x.showTargetDate = false
                        break;
                    case 'OTHUPC':
                    case 'OTHPCN':

                        //Default Sublocation Handling

                        this.sites = await HTTPRequest.getRequest(this.endPoint + 'sites/get_valid_document_sites', null)
                        this.sublocations = await HTTPRequest.getRequest(this.endPoint + 'sublocations/get_site_sublocations?site_id='+secureStorage.getItem("defaultSiteId"), null)
                        var default_sublocation_id = this.sites.find(element => element.id == secureStorage.getItem("defaultSiteId")).sublocation_id || 0

                        let default_sublocation_name = ""
                        if(this.sublocations.find(element => element.id == default_sublocation_id) != undefined){
                            default_sublocation_name = this.sublocations.find(element => element.id == default_sublocation_id).name || ""
                        }
                        this.siteSublocation = {key: default_sublocation_id, label: default_sublocation_name}

                        this.showSummaryCalculation = false
                        this.showUnitCost = false
                        this.showDiscount = false
                        this.showUnitNetCost = false
                        this.showSubtotal = false

                        this.defaultColumnFields = [
                          { name: "line_no", value: true },
                          { name: "product_icon", value: true },
                          { name: "stock_no", value: true },
                          { name: "product_name", value: true },
                          { name: "barcode", value: true },
                          { name: "unit_name", value: true },
                          { name: "quantity", value: true },
                          { name: "actual_quantity", value: true },
                          { name: "price", value: true },
                          { name: "cost", value: true },
                          { name: "subtotal", value: true },
                          { name: "on_hand_quantity", value: true },
                          { name: "remarks", value: true },
                          { name: "available_quantity", value: false },
                          { name: "supplier", value: false },
                          { name: "category_code", value: false },
                          { name: "section_code", value: false },
                          { name: "department", value: false },
                          { name: "division", value: false },
                          { name: "design", value: false },
                          { name: "size", value: false },
                          { name: "product_series", value: false },
                          { name: "product_group", value: false },
                          { name: "erp_code", value: false }
                        ]
                    
                        var othpcn_doc_config = await HTTPRequest.getRequest(component_x.endPoint+'/document_types/get_document_type_settings?type_code=PCN&trans_code=OTH', null)

                        var custom_fields = []
                        if(othpcn_doc_config.document_type_settings.customFields != undefined){
                            var additional_fields = othpcn_doc_config.document_type_settings.customFields;
                            for(var i = 0; i < additional_fields.length; i++){
                                custom_fields.push({ name: additional_fields[i], value: false, custom: true})
                                this.customFieldsX = custom_fields
                                var add_column = {
                                    title: additional_fields[i].split("_").map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) .join(" "),
                                    field: additional_fields[i],
                                    sorter: 'string',
                                    visible: false,
                                    download: false,
                                    editable: false,
                                    cellClick:function(e, cell){e.stopPropagation();}
                                }
                                
                                this.tabulator.addColumn(add_column);
                                override = true
                            }
                        }

                        listIsZero = this.filteredColumnFields.filter(({ value }) => value === true)
                        fieldsList = listIsZero.length === 0 ? this.defaultColumnFields : this.filteredColumnFields
                        this.assignCustomizedFields(this.currentDocumentTypeCode, fieldsList, this.defaultColumnFields)
                        this.header = PCount.header
                        this.renderColumnFields()

                        // Physical Count V2 deferred creation: when opening a
                        // NEW/unsaved PCount (Blank Count Sheet or Auto-Populate),
                        // inject the client-carried lines so the existing Save
                        // flow persists them at creation time. No document exists yet.
                        if (component_x.documentNumber < 1) {
                            var pcount_new_lines = this.$route.params.pcount_data != undefined ? this.$route.params.pcount_data : []
                            pcount_new_lines = JSON.parse(JSON.stringify(pcount_new_lines));
                            if (pcount_new_lines.length > 0) {
                                await this.tabulator.addData(pcount_new_lines, true);
                            }
                        }

                        this.showCreateChildDocButton = false
                        component_x.showCancellationDate = false
                        component_x.showTargetDate = false
                        break;
                    case 'OTHASM':
                        this.header.showDocumentHeader = false
                        this.showSummaryCalculation = false
                        this.showUnitCost = false
                        this.showDiscount = false
                        this.showUnitNetCost = false
                        this.showSubtotal = false

                        this.filteredColumnFields = this.defaultColumnFields
                        if (this.documentTableFilteredList !== null) this.checkCustomizedFields(this.currentDocumentTypeCode)
                        this.renderColumnFields()

                        component_x.showCancellationDate = false
                        component_x.showTargetDate = false
                        break;
                    case 'OTHDSM':
                        this.header.showDocumentHeader = false
                        this.showSummaryCalculation = false
                        this.showUnitCost = false
                        this.showDiscount = false
                        this.showUnitNetCost = false
                        this.showSubtotal = false

                        this.defaultColumnFields = [
                            ...this.defaultColumnFields, 
                            { name: "actual_quantity", value: true }
                        ]
                    
                        this.filteredColumnFields = this.defaultColumnFields
                        if (this.documentTableFilteredList !== null) this.checkCustomizedFields(this.currentDocumentTypeCode)
                        this.renderColumnFields()

                        component_x.showCancellationDate = false
                        component_x.showTargetDate = false
                        break;

                    case 'RELSLO':
                        this.defaultColumnFields = [
                            ...this.defaultColumnFields,
                            { name: "actual_quantity", value: true},
                        ]

                        var relslo_doc_config = await HTTPRequest.getRequest(component_x.endPoint+'/document_types/get_document_type_settings?type_code=SLO&trans_code=REL', null)

                        var custom_fields = []
                        if(relslo_doc_config.document_type_settings.customFields != undefined){
                            var additional_fields = relslo_doc_config.document_type_settings.customFields;
                            for(var i = 0; i < additional_fields.length; i++){
                                custom_fields.push({ name: additional_fields[i], value: false, custom: true})
                                this.customFieldsX = custom_fields
                                var add_column = {
                                    title: additional_fields[i].split("_").map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) .join(" "),
                                    field: additional_fields[i],
                                    sorter: 'string',
                                    visible: false,
                                    download: false,
                                    editable: false,
                                    cellClick:function(e, cell){e.stopPropagation();}
                                }
                                
                                this.tabulator.addColumn(add_column);
                                override = true
                            }
                        }

                        listIsZero = this.filteredColumnFields.filter(({ value }) => value === true)
                        fieldsList = listIsZero.length === 0 ? this.defaultColumnFields : this.filteredColumnFields
                        this.assignCustomizedFields(this.currentDocumentTypeCode, fieldsList, this.defaultColumnFields)
                        this.header = DistributionDocuments.header
                        this.renderColumnFields()

                        component_x.distributionSite = {key: secureStorage.getItem("defaultSiteId").toString(), label: secureStorage.getItem("defaultSiteName")}
                        if (this.serverType == 'branch'){
                            component_x.isDistributionSiteDisabled = true
                        }
                        break;
                    case 'RECSLI':

                        this.defaultColumnFields = [
                            ...this.defaultColumnFields,
                            { name: "actual_quantity", value: true},
                        ]

                        var recsli_doc_config = await HTTPRequest.getRequest(component_x.endPoint+'/document_types/get_document_type_settings?type_code=SLI&trans_code=REC', null)

                        var custom_fields = []
                        if(recsli_doc_config.document_type_settings.customFields != undefined){
                            var additional_fields = recsli_doc_config.document_type_settings.customFields;
                            for(var i = 0; i < additional_fields.length; i++){
                                custom_fields.push({ name: additional_fields[i], value: false, custom: true})
                                this.customFieldsX = custom_fields
                                var add_column = {
                                    title: additional_fields[i].split("_").map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) .join(" "),
                                    field: additional_fields[i],
                                    sorter: 'string',
                                    visible: false,
                                    download: false,
                                    editable: false,
                                    cellClick:function(e, cell){e.stopPropagation();}
                                }
                                
                                this.tabulator.addColumn(add_column);
                                override = true
                            }
                        }

                        listIsZero = this.filteredColumnFields.filter(({ value }) => value === true)
                        fieldsList = listIsZero.length === 0 ? this.defaultColumnFields : this.filteredColumnFields
                        this.assignCustomizedFields(this.currentDocumentTypeCode, fieldsList, this.defaultColumnFields)
                        this.header = DistributionDocuments.header
                        this.renderColumnFields()

                        component_x.distributionSite = {key: secureStorage.getItem("defaultSiteId").toString(), label: secureStorage.getItem("defaultSiteName")}
                        if (this.serverType == 'branch'){
                            component_x.isDistributionSiteDisabled = true
                        }
                        break;

                    case 'ORISOX':
                        var orisox_doc_config = await HTTPRequest.getRequest(component_x.endPoint+'/document_types/get_document_type_settings?type_code=SOX&trans_code=ORI', null)
                        //Set Order Source
                        if (orisox_doc_config && orisox_doc_config.document_type_settings.references){
                            this.referenceLabel = orisox_doc_config.document_type_settings.references[0].name || "Reference"
                        }
                        if (orisox_doc_config && orisox_doc_config.document_type_settings.additionalEditorBehaviorCheckboxes.displayVatAmount){
                            this.displayVatAmount = orisox_doc_config.document_type_settings.additionalEditorBehaviorCheckboxes.displayVatAmount || false
                        }
                        if (orisox_doc_config && orisox_doc_config.document_type_settings.additionalEditorBehaviorCheckboxes.displayNetAmountWOVat){
                            this.displayNetAmountWOVat = orisox_doc_config.document_type_settings.additionalEditorBehaviorCheckboxes.displayNetAmountWOVat || false
                            this.displayNetAmountWOVatLabel = orisox_doc_config.document_type_settings.additionalEditorBehaviorCheckboxes.displayNetAmountWOVatLabel || "Net Amount w/o VAT"
                        }
                        this.showPayButton = true
                        this.showDeliverButton = true

                        this.defaultColumnFields = [
                          { name: "line_no", value: true },
                          { name: "product_icon", value: true },
                          { name: "stock_no", value: true },
                          { name: "barcode", value: true },
                          { name: "product_name", value: true },
                          { name: "unit_name", value: true },
                          { name: "quantity", value: true },
                          { name: "price", value: true },
                          { name: "subtotal", value: true },
                          { name: "discount", value: true },
                          { name: "discount_text", value: true },
                          { name: "on_hand_quantity", value: true },
                          { name: "ref_code", value: true },
                          { name: "remarks", value: true },
                          { name: "salesman_name", value: true },
                          { name: "line_extras", value: true },
                          { name: "available_quantity", value: false },
                          { name: "brand_name", value: false },
                          { name: "product_grade_level", value: false },
                          { name: "supplier", value: false },
                          { name: "category_code", value: false },
                          { name: "section_code", value: false },
                          { name: "department", value: false },
                          { name: "division", value: false },
                          { name: "design", value: false },
                          { name: "size", value: false },
                          { name: "product_series", value: false },
                          { name: "product_group", value: false },
                          { name: "erp_code", value: false }
                        ]
                      
                        this.header = DistributionDocuments.headerOriSox
                        if (this.isOrderSourceMode){
                            this.header.showSublocationDestination = false
                            this.header.showOrderSource = true
                        } else {
                            this.header.showSublocationDestination = true
                            this.header.showOrderSource = false
                        }
                        
                        var orisox_doc_config = await HTTPRequest.getRequest(component_x.endPoint+'/document_types/get_document_type_settings?type_code=SOX&trans_code=ORI', null)

                        var custom_fields = []
                        if(orisox_doc_config.document_type_settings.customFields != undefined){
                            var additional_fields = orisox_doc_config.document_type_settings.customFields;
                            for(var i = 0; i < additional_fields.length; i++){
                                custom_fields.push({ name: additional_fields[i], value: false, custom: true})
                                this.customFieldsX = custom_fields
                                var add_column = {
                                    title: additional_fields[i].split("_").map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) .join(" "),
                                    field: additional_fields[i],
                                    sorter: 'string',
                                    visible: false,
                                    download: false,
                                    editable: false,
                                    cellClick:function(e, cell){e.stopPropagation();}
                                }
                                
                                this.tabulator.addColumn(add_column);
                                override = true
                            }
                        }

                        listIsZero = this.filteredColumnFields.filter(({ value }) => value === true)
                        fieldsList = listIsZero.length === 0 ? this.defaultColumnFields : this.filteredColumnFields
                        this.assignCustomizedFields(this.currentDocumentTypeCode, fieldsList, this.defaultColumnFields)
                        this.renderColumnFields()

                        //Display Discount Header
                       if(component_x.documentNumber > 0){
                        var document = await HTTPRequest.getRequest(component_x.endPoint + "documents/"+component_x.documentNumber, null);
                        if (document["discount_text"] != null && document["discount_text"] !== "") {
                           component_x.headerDiscount = document["discount_text"].split(',')
                        }
                       }

                        component_x.showHeaderDiscount = true
                      //  bryan
                        if (this.documentNumber > 0) {
                            this.isProductSearchDisabled = false
                        } else {
                            // this.isProductSearchDisabled = true
                        }
                        this.isDestinationSublocationDisabled = true
                        this.searchFilter = "barcode"
                        this.showShippingMethod = true

                        //component_x.distributionSite = {key: secureStorage.getItem("defaultSiteId").toString(), label: secureStorage.getItem("defaultSiteName")}
                        component_x.sublocationDestinationLabel = 'Serving Sublocation'
                        break;

                    case 'RELDDE':
                        component_x.showHeaderDiscount = true
                        var reldde_doc_config = await HTTPRequest.getRequest(component_x.endPoint+'/document_types/get_document_type_settings?type_code=DDE&trans_code=REL', null)
                        //Set Order Source
                        if (reldde_doc_config && reldde_doc_config.document_type_settings.orderSource){
                            this.isOrderSourceMode = reldde_doc_config.document_type_settings.orderSource.enableOrderSourceMode
                        }
                        //Set Order Source
                        var allowWIthoutSO = false;
                        if (reldde_doc_config && reldde_doc_config.document_type_settings.references){
                            this.referenceLabel = reldde_doc_config.document_type_settings.references[0].name || "Reference"
                            allowWIthoutSO = reldde_doc_config.document_type_settings.additionalEditorBehaviorCheckboxes.allowCreationOfDDWithoutSO
                        }

                        var custom_fields = []
                        var override = false
                        if(reldde_doc_config.document_type_settings.customFields != undefined){
                            var additional_fields = reldde_doc_config.document_type_settings.customFields;
                            for(var i = 0; i < additional_fields.length; i++){
                                custom_fields.push({ name: additional_fields[i], value: false, custom: true})
                                this.customFieldsX = custom_fields
                                var add_column = {
                                    title: additional_fields[i],
                                    field: additional_fields[i],
                                    sorter: 'string',
                                    visible: false,
                                    download: false,
                                    editable: false,
                                    cellClick:function(e, cell){e.stopPropagation();}
                                }
                                
                                this.tabulator.addColumn(add_column);
                                override = true
                            }
                            
                            // this.$refs.tabulator.refresh()
                        }

                        this.defaultColumnFields = [
                          { name: "line_no", value: true },
                          { name: "product_icon", value: true },
                          { name: "stock_no", value: true },
                          { name: "barcode", value: true },
                          { name: "product_name", value: true },
                          { name: "unit_name", value: true },
                          { name: "quantity", value: false },
                          { name: "ordered_quantity", value: true },
                          { name: "price", value: true },
                          { name: "subtotal", value: true },
                          { name: "discount_text", value: true },
                          { name: "delivery_quantity", value: true },
                          { name: "ref_code", value: true },
                          { name: "remarks", value: true },
                          { name: "available_quantity", value: false },
                          { name: "brand_name", value: false },
                          { name: "product_grade_level", value: false },
                          { name: "supplier", value: false },
                          { name: "category_code", value: false },
                          { name: "section_code", value: false },
                          { name: "department", value: false },
                          { name: "division", value: false },
                          { name: "design", value: false },
                          { name: "size", value: false },
                          { name: "product_series", value: false },
                          { name: "product_group", value: false },
                          { name: "erp_code", value: false }
                        ]
                        this.filteredColumnFields = this.defaultColumnFields
                        if (this.documentTableFilteredList !== null) this.checkCustomizedFields(this.currentDocumentTypeCode)
                        this.header = DistributionDocuments.headerRelDde

                        if (this.isOrderSourceMode){
                            this.header.showSublocationDestination = false
                            this.header.showSublocationOrigin = false
                            this.header.showOrderSource = true
                        } else {
                            this.header.showSublocationDestination = true
                            this.header.showSublocationOrigin = true
                            this.header.showOrderSource = false
                            this.tabulator.toggleColumn("actual_quantity")
                        }
                        if (!allowWIthoutSO && this.documentNumber==0){
                            this.showBookingButton = true
                            //this.showDocumentBodyHeader = false
                            this.productFormMode = "Search"
                            this.showShippingMethod = true
                        }
                        this.renderColumnFields()
                        //Disable fields
                        if (!allowWIthoutSO && this.documentNumber==0){
                            component_x.isOrderSourceDisabled = true
                            component_x.isCustomerDisabled = true
                            component_x.isCustomerCreateDisabled = true
                            component_x.isDestinationSublocationDisabled = true
                            component_x.isDistributionSiteDisabled = true
                            component_x.isDocumentDateDisabled = true
                            component_x.isTargetDateDisabled = true
                            component_x.isCancellationDateDisabled = true
                            component_x.isShippingMethodDisabled = true
                            component_x.isPurposeDisabled = true
                            component_x.sublocationDestinationLabel = 'SO Sublocation'
                            component_x.sublocationOriginLabel = 'Serving Sublocation'
                            component_x.remarkLabel = "Remarks (Picker Details, Truck Details, & Other Info)"

                            component_x.showHeaderDiscount = true
                            component_x.isHeaderDiscountDisabled = true
                        }else if (allowWIthoutSO && this.documentNumber==0){
                            component_x.isOrderSourceDisabled = false
                        }

                        if (component_x.documentNumber < 1) {
                            var sales_order_id = this.$route.params.sales_order_id
                            if (sales_order_id > -1){
                                var document = await HTTPRequest.getRequest(component_x.endPoint + "documents/"+sales_order_id, null);

                                var document_charges = []
                                document_charges = await HTTPRequest.getRequest(component_x.endPoint + "document_charges/"+sales_order_id+"?field_name=document_id", null);
                                if(document_charges) component_x.chargeData = document_charges
                                component_x.documentDetails = document
                            }
                            if (document["discount_text"]!="") {
                                if (document['discount_text'] != null) component_x.headerDiscount = document["discount_text"].split(',')
                            }

                            if (document["order_source"]!="") {
                                if (document['order_source'] != null) component_x.orderSource = document["order_source"]
                            }

                            if (document["payment_status"] == "Paid") {
                                this.forPaymentIsProcessed = true
                            }

                            //Populate Document Level Input
                            component_x.distributionSite = document['site_id']
                            component_x.destinationSublocation = document['target_sublocation_id']
                            component_x.documentDate = moment(document["document_date"])
                            component_x.targetDate = moment(document["target_date"])
                            component_x.cancellationDate = moment(document["cancellation_date"])
                            component_x.reference = document["reference"]
                            component_x.salesOrder = document["document_no"]
                            component_x.customer = document["customer_id"];
                            if (document["shipping_method_id"]["key"] > 0) component_x.shippingMethod = document["shipping_method_id"];

                            component_x.remark = document["remark"];

                            if (component_x.customer){
                                var customer = await HTTPRequest.getRequest(component_x.endPoint + "customers/"+component_x.customer.key, null);
                                this.customerAddress = (customer["address"]) ? customer["address"] : "No Customer Address";
                                this.customerContactMobile = (customer["mobile"]) ? customer["mobile"] : "No Customer Mobile";
                                this.customerContactTelephone = (customer["telephone"]) ? customer["telephone"] : "No Customer Telephone";
                                this.customerContactFax = (customer["fax"]) ? customer["fax"] : "No Customer Fax";
                                this.customerContactEmail = (customer["email"]) ? customer["email"] : "No Customer Email";
                                this.selectedCustomerContact = (customer["mobile"]) ? 'Mobile' : (customer["telephone"]) ? 'Telephone' : (customer["fax"]) ? 'Fax' : (customer["email"]) ? 'Email' : 'Telephone'
                                this.activeCustomerContact = (customer["mobile"]) ? this.customerContactMobile : (customer["telephone"]) ? this.customerContactTelephone : (customer["fax"]) ? this.customerContactFax : (customer["email"]) ? this.customerContactEmail : this.customerContactTelephone
                            }

                            if(document["address"]){
                                component_x.customerAddress = document["address"]
                            }

                            //Load document lines
                            window.scrollTo(0,0);
                            this.spinning = true;
                            let document_lines = []
                            if (sales_order_id > -1){
                                document_lines = await HTTPRequest.getRequest(this.endPoint+'document_lines/'+sales_order_id+'?field_name=document_id&origin_sublocation=0', null)
                            }
                            document_lines.forEach( row => {
                                row.quantity = 0
                            });
                            if(document_lines) {
                                // await this.tabulator.addData(document_lines, true);
                                let new_document_lines = []
                                for(var i = 0; i < document_lines.length; i++){
                                    let document_line = document_lines[i]
                                    let dl_product_extras = document_line.extras
                                    let merge_document_lines = {...document_line, ...dl_product_extras}
                                    new_document_lines.push(merge_document_lines)
                                }
                                console.log("NEW LINES DDE")
                                console.log("dl",new_document_lines)
                                await this.tabulator.addData(new_document_lines, true);
                            }
                            
                            this.tabulator.addFilter("line_no", ">", 0);
                            if(document_lines) component_x.origData = JSON.stringify(document_lines.reverse()) //For isDirty Data on Document lines
                            this.spinning = false;
                        } else {
                            component_x.isOriginSublocationDisabled = true
                            this.tabulator.toggleColumn("goods_issue_quantity")
                        }

                        break;

                    case 'OTHSIN':
                        component_x.showHeaderDiscount = true
                        var orisox_doc_config = await HTTPRequest.getRequest(component_x.endPoint+'/document_types/get_document_type_settings?type_code=SOX&trans_code=ORI', null)
                        //Set Order Source
                        if (orisox_doc_config && orisox_doc_config.document_type_settings.orderSource){
                            this.isOrderSourceMode = orisox_doc_config.document_type_settings.orderSource.enableOrderSourceMode
                        }
                        var othsin_doc_config = await HTTPRequest.getRequest(component_x.endPoint+'/document_types/get_document_type_settings?type_code=SIN&trans_code=OTH', null)
                        if (othsin_doc_config && othsin_doc_config.document_type_settings.references){
                            this.referenceLabel = othsin_doc_config.document_type_settings.references[0].name || "Reference"
                        }
                        if (this.isOrderSourceMode){
                            this.header.showSublocationDestination = false
                            this.header.showSublocationOrigin = false
                            this.header.showOrderSource = true
                        } else {
                            this.header.showSublocationDestination = true
                            this.header.showSublocationOrigin = true
                            this.header.showOrderSource = false
                        }

                        this.showDocumentBodyHeader = false
                        this.showShippingMethod = true

                        var custom_fields = []
                        var override = false
                        if(othsin_doc_config.document_type_settings.customFields != undefined){
                            var additional_fields = othsin_doc_config.document_type_settings.customFields;
                            for(var i = 0; i < additional_fields.length; i++){
                                custom_fields.push({ name: additional_fields[i], value: false, custom: true})
                                this.customFieldsX = custom_fields
                                var add_column = {
                                    title: additional_fields[i],
                                    field: additional_fields[i],
                                    sorter: 'string',
                                    visible: false,
                                    download: false,
                                    editable: false,
                                    cellClick:function(e, cell){e.stopPropagation();}
                                }

                                this.tabulator.addColumn(add_column);
                                override = true
                            }
                        }

                        this.defaultColumnFields = [
                          { name: "line_no", value: true },
                          { name: "product_icon", value: true },
                          { name: "stock_no", value: true },
                          { name: "barcode", value: true },
                          { name: "product_name", value: true },
                          { name: "unit_name", value: true },
                          { name: "ordered_quantity", value: true },
                          { name: "price", value: true },
                          { name: "subtotal", value: true },
                          { name: "discount_text", value: true },
                          { name: "goods_issue_quantity", value: true },
                          { name: "remarks", value: true },
                          { name: "ref_code", value: true },
                          { name: "available_quantity", value: false },
                          { name: "brand_name", value: false },
                          { name: "product_grade_level", value: false },
                          { name: "supplier", value: false },
                          { name: "category_code", value: false },
                          { name: "section_code", value: false },
                          { name: "department", value: false },
                          { name: "division", value: false },
                          { name: "design", value: false },
                          { name: "size", value: false },
                          { name: "product_series", value: false },
                          { name: "product_group", value: false },
                          { name: "erp_code", value: false }
                        ]
                      
                        this.filteredColumnFields = this.defaultColumnFields
                        if (this.documentTableFilteredList !== null) this.checkCustomizedFields(this.currentDocumentTypeCode)
                        this.header = DistributionDocuments.headerOthSin
                        this.renderColumnFields()

                        component_x.isCustomerDisabled = true
                        component_x.isCustomerCreateDisabled = true
                        component_x.isOrderSourceDisabled = true
                        component_x.isDeliveryDocumentDisabled = true
                        component_x.isDocumentDateDisabled = true
                        component_x.isOriginSublocationDisabled = true
                        component_x.isDestinationSublocationDisabled = true
                        component_x.isDistributionSiteDisabled = true
                        component_x.isTargetDateDisabled = true
                        component_x.isCancellationDateDisabled = true
                        component_x.isShippingMethodDisabled = true
                        component_x.isPurposeDisabled = true

                        component_x.sublocationDestinationLabel = 'SO Sublocation'
                        component_x.sublocationOriginLabel = 'Serving Sublocation'

                        if (component_x.documentNumber < 1) {

                            var delivery_document_id = this.$route.params.delivery_document_id
                            var document = await HTTPRequest.getRequest(component_x.endPoint + "documents/"+delivery_document_id, null);

                            //Populate Document Level Input
                            component_x.distributionSite = document['site_id']
                            component_x.destinationSublocation = document['target_sublocation_id']
                            component_x.originSublocation = document['origin_sublocation_id']
                            component_x.documentDate = moment(document["document_date"])
                            component_x.targetDate = moment(document["target_date"])
                            component_x.cancellationDate = moment(document["cancellation_date"])
                            component_x.salesOrder = document['origin_document_id']['label']
                            component_x.deliveryDocument = delivery_document_id
                            component_x.customer = document["customer_id"];
                            if (document["shipping_method_id"]["key"] > 0) component_x.shippingMethod = document["shipping_method_id"];
                            component_x.remark = document["remark"];
                            component_x.isHeaderOnly = document['is_header_only'] || false

                            if (component_x.customer){
                                var customer = await HTTPRequest.getRequest(component_x.endPoint + "customers/"+component_x.customer.key, null);
                                this.customerAddress = (customer["address"]) ? customer["address"] : "No Customer Address";
                                this.customerContactMobile = (customer["mobile"]) ? customer["mobile"] : "No Customer Mobile";
                                this.customerContactTelephone = (customer["telephone"]) ? customer["telephone"] : "No Customer Telephone";
                                this.customerContactFax = (customer["fax"]) ? customer["fax"] : "No Customer Fax";
                                this.customerContactEmail = (customer["email"]) ? customer["email"] : "No Customer Email";
                                this.selectedCustomerContact = (customer["mobile"]) ? 'Mobile' : (customer["telephone"]) ? 'Telephone' : (customer["fax"]) ? 'Fax' : (customer["email"]) ? 'Email' : 'Telephone'
                                this.activeCustomerContact = (customer["mobile"]) ? this.customerContactMobile : (customer["telephone"]) ? this.customerContactTelephone : (customer["fax"]) ? this.customerContactFax : (customer["email"]) ? this.customerContactEmail : this.customerContactTelephone
                            }

                            if (document['support_discount_text']) component_x.supportDiscount = document['support_discount_text'].split(',')
                            if (document["discount_text"]!="") {
                                if (document['discount_text'] != null) component_x.headerDiscount = document["discount_text"].split(',')
                            }

                            if (document["order_source"]!="") {
                                if (document['order_source'] != null) component_x.orderSource = document["order_source"]
                            }

                            var orisox_document = await HTTPRequest.getRequest(component_x.endPoint + "documents/"+document['origin_document_id']['key'], null);
                            if (orisox_document["payment_status"] == "Paid") {
                                this.forPaymentIsProcessed = true
                            }

                            //Load document lines
                            window.scrollTo(0,0);
                            this.spinning = true;
                            let document_lines = []
                            document_lines = await HTTPRequest.getRequest(this.endPoint+'document_lines/'+delivery_document_id+'?field_name=document_id', null)
                            if(document_lines != undefined && document_lines != null && document_lines != []){
                                document_lines.forEach( row => {
                                    row.goods_issue_quantity = row.quantity
                                });
                                await this.tabulator.addData(document_lines, true);

                            }
                            this.tabulator.addFilter("line_no", ">", 0);
                            if(document_lines != undefined && document_lines != null && document_lines != []){
                                component_x.origData = JSON.stringify(document_lines.reverse()) //For isDirty Data on Document lines
                            } 
                            this.spinning = false;

                            //Populate Footer and Calculation Data
                            component_x.grossAmount =  document['amount_gross']
                            component_x.grossAmountDisplay = document['amount_gross']
                            component_x.overallDiscount = document['amount_header_discount']
                            component_x.netAmount = document['amount_net']
                            component_x.netAmountDisplay = document['amount_net']
                            component_x.vatAmount = document['tax_amount']
                            component_x.totalWithVat = document['tax_exempt_amount']
                            component_x.itemDiscount = document['amount_line_discount']
                            component_x.taxRate = document['tax_rate']
                            component_x.grossAmountwithoutTax = document['gross_amount_without_tax']
                            component_x.netAmountWithoutTax = document['net_amount_without_tax']
                            this.initializeFooterCalculation()
                            if (component_x.totalQuantity == 0) component_x.totalQuantity = document['total_quantity']
                        }

                        break;
                    case 'RECCSR':
                        var orisox_doc_config = await HTTPRequest.getRequest(component_x.endPoint+'/document_types/get_document_type_settings?type_code=SOX&trans_code=ORI', null)
                        //Set Order Source
                        if (orisox_doc_config && orisox_doc_config.document_type_settings.orderSource){
                            this.isOrderSourceMode = orisox_doc_config.document_type_settings.orderSource.enableOrderSourceMode
                        }
                        if (this.isOrderSourceMode){
                            this.header.showSublocationDestination = false
                            this.header.showOrderSource = true
                        } else {
                            this.header.showSublocationDestination = true
                            this.header.showOrderSource = false
                        }

                        var custom_fields = []
                        var override = false
                        var reccsr_doc_config = await HTTPRequest.getRequest(component_x.endPoint+'/document_types/get_document_type_settings?type_code=CSR&trans_code=REC', null)
                        if(reccsr_doc_config.document_type_settings.customFields != undefined){
                            var additional_fields = reccsr_doc_config.document_type_settings.customFields;
                            for(var i = 0; i < additional_fields.length; i++){
                                custom_fields.push({ name: additional_fields[i], value: false, custom: true})
                                this.customFieldsX = custom_fields
                                var add_column = {
                                    title: additional_fields[i],
                                    field: additional_fields[i],
                                    sorter: 'string',
                                    visible: false,
                                    download: false,
                                    editable: false,
                                    cellClick:function(e, cell){e.stopPropagation();}
                                }

                                this.tabulator.addColumn(add_column);
                                override = true
                            }
                        }

                        var custom_fields = []
                        var override = false
                        var reccsr_doc_config = await HTTPRequest.getRequest(component_x.endPoint+'/document_types/get_document_type_settings?type_code=CSR&trans_code=REC', null)
                        if(reccsr_doc_config.document_type_settings.customFields != undefined){
                            var additional_fields = reccsr_doc_config.document_type_settings.customFields;
                            for(var i = 0; i < additional_fields.length; i++){
                                custom_fields.push({ name: additional_fields[i], value: false, custom: true})
                                this.customFieldsX = custom_fields
                                var add_column = {
                                    title: additional_fields[i],
                                    field: additional_fields[i],
                                    sorter: 'string',
                                    visible: false,
                                    download: false,
                                    editable: false,
                                    cellClick:function(e, cell){e.stopPropagation();}
                                }

                                this.tabulator.addColumn(add_column);
                                override = true
                            }
                        }
                          this.defaultColumnFields = [
                          { name: "line_no", value: true },
                          { name: "product_icon", value: true },
                          { name: "stock_no", value: true },
                          { name: "barcode", value: true },
                          { name: "product_name", value: true },
                          { name: "unit_name", value: true },
                          { name: "quantity", value: true },
                          { name: "price", value: true },
                          { name: "subtotal", value: true },
                          { name: "discount_text", value: true },
                          { name: "ref_code", value: true },
                          { name: "remarks", value: true },
                          { name: "available_quantity", value: false },
                          { name: "brand_name", value: false },
                          { name: "product_grade_level", value: false },
                          { name: "supplier", value: false },
                          { name: "category_code", value: false },
                          { name: "section_code", value: false },
                          { name: "department", value: false },
                          { name: "division", value: false },
                          { name: "design", value: false },
                          { name: "size", value: false },
                          { name: "product_series", value: false },
                          { name: "product_group", value: false },
                          { name: "erp_code", value: false }
                        ]
                      
                        this.filteredColumnFields = this.defaultColumnFields
                        if (this.documentTableFilteredList !== null) this.checkCustomizedFields(this.currentDocumentTypeCode)
                        this.header = DistributionDocuments.headerRecCsr
                        this.renderColumnFields()

                        //Disable fields
                        component_x.isTargetDateDisabled = true
                        component_x.isCancellationDateDisabled = true
                        component_x.isShippingMethodDisabled = true
                        component_x.sublocationDestinationLabel = 'SO Sublocation'
                        component_x.remarkLabel = "Remarks (Picker Details, Truck Details, & Other Info)"

                        component_x.isHeaderDiscountDisabled = true
                        var document_id = this.$route.params.sales_order_id
                        var documentExists = false
                        var openCSR = false
                        if( component_x.documentNumber > 0 ){
                            document_id = component_x.documentNumber
                            documentExists = true
                        } else if( this.$route.params.sales_order_id == undefined && component_x.documentNumber == 0){
                            openCSR = true
                        }
                        if(!openCSR){
                            var document = await HTTPRequest.getRequest(component_x.endPoint + "documents/"+document_id, null);

                            var document_charges = []
                            document_charges = await HTTPRequest.getRequest(component_x.endPoint + "document_charges/"+document_id+"?field_name=document_id", null);
                            if(document_charges) component_x.chargeData = document_charges

                            component_x.documentDetails = document
                            if (document["discount_text"]!="") {
                                if (document['discount_text'] != null) component_x.headerDiscount = document["discount_text"].split(',')
                            }

                            if (document["order_source"]!="") {
                                if (document['order_source'] != null) component_x.orderSource = document["order_source"]
                            }

                            if (document["payment_status"] == "Paid") {
                                this.forPaymentIsProcessed = true
                            }

                            //Populate Document Level Input
                            component_x.distributionSite = document['site_id']
                            component_x.destinationSublocation = document['target_sublocation_id']
                            component_x.documentDate = moment(document["document_date"])
                            component_x.targetDate = moment(document["target_date"])
                            component_x.cancellationDate = moment(document["cancellation_date"])
                            component_x.reference = document["reference"]

                            if(documentExists){
                                component_x.deliveryDocument = document['origin_document_id']['label']
                            }else {
                                component_x.deliveryDocument = document["code_and_document_no"]
                                component_x.documentDate = moment()
                                component_x.targetDate = moment()
                                component_x.cancellationDate = moment().add(1, 'months').calendar();
                            }
                            component_x.customer = document["customer_id"];
                            if (document["shipping_method_id"]["key"] > 0) component_x.shippingMethod = document["shipping_method_id"];

                            component_x.remark = document["remark"];

                            if (component_x.customer){
                                var customer = await HTTPRequest.getRequest(component_x.endPoint + "customers/"+component_x.customer.key, null);
                                this.customerAddress = (customer["address"]) ? customer["address"] : "No Customer Address";
                                this.customerContactMobile = (customer["mobile"]) ? customer["mobile"] : "No Customer Mobile";
                                this.customerContactTelephone = (customer["telephone"]) ? customer["telephone"] : "No Customer Telephone";
                                this.customerContactFax = (customer["fax"]) ? customer["fax"] : "No Customer Fax";
                                this.customerContactEmail = (customer["email"]) ? customer["email"] : "No Customer Email";
                                this.selectedCustomerContact = (customer["mobile"]) ? 'Mobile' : (customer["telephone"]) ? 'Telephone' : (customer["fax"]) ? 'Fax' : (customer["email"]) ? 'Email' : 'Telephone'
                                this.activeCustomerContact = (customer["mobile"]) ? this.customerContactMobile : (customer["telephone"]) ? this.customerContactTelephone : (customer["fax"]) ? this.customerContactFax : (customer["email"]) ? this.customerContactEmail : this.customerContactTelephone
                            }

                            if(document["address"]){
                                component_x.customerAddress = document["address"]
                            }


                            //Load document lines
                            window.scrollTo(0,0);
                            this.spinning = true;
                            let document_lines = []
                            var origin_doc_id = documentExists ? document['origin_document_id']['key'] : document_id
                            if(origin_doc_id == null || origin_doc_id == ''){
                                openCSR = true
                            }
                            if(!openCSR) var returnable_qtys = await HTTPRequest.getRequest(component_x.endPoint + '/documents/' + origin_doc_id + '/available_return_quantity', null)
                            document_lines = await HTTPRequest.getRequest(this.endPoint+'document_lines/'+document_id+'?field_name=document_id', null)
                            component_x.returnable_qtys = returnable_qtys

                            let new_document_lines = []
                            if(document_lines != undefined && document_lines != null && document_lines != []){
                                document_lines.forEach( row => {
                                    // if creating CSR, then reset the quantities
                                    if(!documentExists){
                                        row.quantity = 0
                                    }
                                    // check max qty per product that can be returned, actual quantity is available quantity
                                    if(!openCSR){
                                        var returnable_line = returnable_qtys.data.find(line => line.product_id == row.product_id)
                                        row.goods_issue_quantity
                                        row.goods_issue_quantity = returnable_line == undefined ? 0 : (returnable_line.returnable_qty)
                                        row.delivery_quantity = row.goods_issue_quantity
                                    }
                                });
                            }
                            if(documentExists) await this.tabulator.addData(document_lines, true);
                            this.tabulator.addFilter("line_no", ">", 0);
                            if(document_lines != undefined && document_lines != null && document_lines != []){
                                component_x.origData = JSON.stringify(document_lines.reverse())
                            } 
                            if( !openCSR && ((!documentExists) || ( documentExists && !(['Posted', 'Voided'].includes(document["status"])) ))) this.tabulator.toggleColumn("goods_issue_quantity")
                        }

                        console.log("Document Status")
                        let status_x = document ? document.status || 'X' : 'X';
                        console.log(status_x)
                        if (!(['Posted', 'Voided'].includes(status_x))){
                            component_x.tabulator.getColumn("discount_text").updateDefinition({ title: 'Discount', download: false, editable: true });
                            component_x.tabulator.showColumn("discount_text")
                        }
                        
                        component_x.openCSR = openCSR
                        this.spinning = false;
                        break;
                    case 'ORORSO':
                        var ororso_doc_config = await HTTPRequest.getRequest(component_x.endPoint+'/document_types/get_document_type_settings?type_code=RSO&trans_code=ORO', null)
                        if (ororso_doc_config && ororso_doc_config.document_type_settings.editorBehavior){
                            this.revenueCreditingMode = ororso_doc_config.document_type_settings.editorBehavior.revenueCreditingMode
                        }
                        if (this.revenueCreditingMode == 'R'){
                            this.requestingSite = {key: secureStorage.getItem("defaultSiteId").toString(), label: secureStorage.getItem("defaultSiteName")}
                            this.revenue = 'R'
                            this.revenueSiteId = secureStorage.getItem("defaultSiteId").toString()
                            this.header.showRevenue = false
                        }else if(this.revenueCreditingMode == 'T'){
                            this.revenue = 'T'
                            this.header.showRevenue = false
                        }else if (this.revenueCreditingMode == 'M'){
                            this.header.showRevenue = true
                        }
                        this.showShippingMethod = true
                        this.RequestingLabel = "Target"

                        this.defaultColumnFields = [
                          { name: "line_no", value: true },
                          { name: "product_icon", value: true },
                          { name: "stock_no", value: true },
                          { name: "barcode", value: true },
                          { name: "product_name", value: true },
                          { name: "unit_name", value: true },
                          { name: "requested_quantity", value: true },
                          { name: "ordered_quantity", value: true},
                          { name: "price", value: true },
                          { name: "subtotal", value: true },
                          { name: "discount_text", value: true },
                          { name: "actual_quantity", value: false },
                          { name: "quantity", value: false },
                          { name: "ref_code", value: true },
                          { name: "remarks", value: true },
                          { name: "available_quantity", value: false },
                          { name: "supplier", value: false },
                          { name: "category_code", value: false },
                          { name: "section_code", value: false },
                          { name: "department", value: false },
                          { name: "division", value: false },
                          { name: "design", value: false },
                          { name: "size", value: false },
                          { name: "product_series", value: false },
                          { name: "product_group", value: false },
                          { name: "erp_code", value: false }
                        ]
                    
                        this.filteredColumnFields = this.defaultColumnFields
                        if (this.documentTableFilteredList !== null) this.checkCustomizedFields(this.currentDocumentTypeCode)
                        this.header = DistributionDocuments.headerOroRso
                        this.renderColumnFields()

                        //Disable fields
                        component_x.showDocumentBodyHeader = false
                        component_x.isTargetDateDisabled = true
                        component_x.isCancellationDateDisabled = true
                        component_x.isShippingMethodDisabled = true
                        //component_x.isPurposeDisabled = true
                        component_x.remarkLabel = "Remarks (Picker Details, Truck Details, & Other Info)"
                        component_x.showHeaderDiscount = true
                        component_x.isHeaderDiscountDisabled = true
                        if (component_x.documentNumber < 1) {
                            var sales_order_id = this.$route.params.sales_order_id
                            var document = await HTTPRequest.getRequest(component_x.endPoint + "documents/"+sales_order_id, null);

                            var document_charges = []
                            document_charges = await HTTPRequest.getRequest(component_x.endPoint + "document_charges/"+sales_order_id+"?field_name=document_id", null);
                            if(document_charges) component_x.chargeData = document_charges

                            component_x.documentDetails = document
                            if (document["discount_text"]!="") {
                                if (document['discount_text'] != null) component_x.headerDiscount = document["discount_text"].split(',')
                            }

                            if (document["payment_status"] == "Paid") {
                                this.forPaymentIsProcessed = true
                            }

                            //Populate Document Level Input
                            component_x.distributionSite = document['site_id']
                            component_x.destinationSublocation = document['target_sublocation_id']
                            component_x.documentDate = moment(document["document_date"])
                            component_x.targetDate = moment(document["target_date"])
                            component_x.cancellationDate = moment(document["cancellation_date"])
                            component_x.reference = document["reference"]
                            component_x.siteSublocation = document["sublocation_id"]
                            component_x.salesOrder = sales_order_id
                            component_x.customer = document["customer_id"];
                            if (document["shipping_method_id"]["key"] > 0) component_x.shippingMethod = document["shipping_method_id"];

                            component_x.remark = document["remark"];

                            if (document["order_source"]!="") {
                                if (document['order_source'] != null) component_x.orderSource = document["order_source"]
                            }
                            
                            if (component_x.customer){
                                var customer = await HTTPRequest.getRequest(component_x.endPoint + "customers/"+component_x.customer.key, null);
                                this.customerAddress = (customer["address"]) ? customer["address"] : "No Customer Address";
                                this.customerContactMobile = (customer["mobile"]) ? customer["mobile"] : "No Customer Mobile";
                                this.customerContactTelephone = (customer["telephone"]) ? customer["telephone"] : "No Customer Telephone";
                                this.customerContactFax = (customer["fax"]) ? customer["fax"] : "No Customer Fax";
                                this.customerContactEmail = (customer["email"]) ? customer["email"] : "No Customer Email";
                                this.selectedCustomerContact = (customer["mobile"]) ? 'Mobile' : (customer["telephone"]) ? 'Telephone' : (customer["fax"]) ? 'Fax' : (customer["email"]) ? 'Email' : 'Telephone'
                                this.activeCustomerContact = (customer["mobile"]) ? this.customerContactMobile : (customer["telephone"]) ? this.customerContactTelephone : (customer["fax"]) ? this.customerContactFax : (customer["email"]) ? this.customerContactEmail : this.customerContactTelephone
                            }

                            //Load document lines
                            window.scrollTo(0,0);
                            this.spinning = true;
                            let document_lines = []
                            document_lines = await HTTPRequest.getRequest(this.endPoint+'document_lines/'+sales_order_id+'?field_name=document_id&origin_sublocation=0', null)
                            if(document_lines != undefined && document_lines != null && document_lines != []){
                                await this.tabulator.addData(document_lines, true);
                            } 
                            this.tabulator.addFilter("line_no", ">", 0);
                            if(document_lines != undefined && document_lines != null && document_lines != []){
                                component_x.origData = JSON.stringify(document_lines.reverse()) //For isDirty Data on Document lines
                            } 
                            this.spinning = false;
                        }
                        break;
                    case 'OTHTRA':
                    
                        this.header = TransferAllocationDocumentPicking.header
                        var othtra_doc_config = await HTTPRequest.getRequest(component_x.endPoint+'/document_types/get_document_type_settings?type_code=TRA&trans_code=OTH', null)

                        var custom_fields = []
                        if(othtra_doc_config.document_type_settings.customFields != undefined){
                            var additional_fields = othtra_doc_config.document_type_settings.customFields;
                            for(var i = 0; i < additional_fields.length; i++){
                                custom_fields.push({ name: additional_fields[i], value: false, custom: true})
                                this.customFieldsX = custom_fields
                                var add_column = {
                                    title: additional_fields[i].split("_").map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) .join(" "),
                                    field: additional_fields[i],
                                    sorter: 'string',
                                    visible: false,
                                    download: false,
                                    editable: false,
                                    cellClick:function(e, cell){e.stopPropagation();}
                                }
                                
                                this.tabulator.addColumn(add_column);
                                override = true
                            }
                        }

                        listIsZero = this.filteredColumnFields.filter(({ value }) => value === true)
                        fieldsList = listIsZero.length === 0 ? this.defaultColumnFields : this.filteredColumnFields
                        this.assignCustomizedFields(this.currentDocumentTypeCode, fieldsList, this.defaultColumnFields)
                        this.header = TransferAllocationDocumentPicking.header
                        this.renderColumnFields()
                        
                        component_x.isSupplyingSiteDisabled = false
                        component_x.supplyingSite = {key: secureStorage.getItem("defaultSiteId").toString(), label: secureStorage.getItem("defaultSiteName")}
                        if (component_x.documentNumber < 1) {

                            var transfer_allocation_id = this.$route.params.transfer_allocation_id
                            // Guard against an undefined source id. A brand-new Transfer
                            // Allocation opened without a source (transfer_allocation_id) would
                            // otherwise request documents/undefined and fail. Only pre-fill from
                            // the source document when we actually have a valid id.
                            if (transfer_allocation_id != undefined && transfer_allocation_id != null && transfer_allocation_id != '') {
                            var document = await HTTPRequest.getRequest(component_x.endPoint + "documents/"+transfer_allocation_id, null);

                            component_x.receivingReport = transfer_allocation_id
                            component_x.reference = document['reference']
                            component_x.remark = document['remark']
                            component_x.targetDate = moment(document["target_date"])
                            component_x.cancellationDate = moment(document["cancellation_date"])

                            if (document['support_discount_text']) component_x.supportDiscount = document['support_discount_text'].split(',')
                            if (document["discount_text"]!="") {
                                if (document['discount_text'] != null) component_x.headerDiscount = document["discount_text"].split(',')
                            }

                            //Load document lines
                            window.scrollTo(0,0);
                            this.spinning = true;
                            let document_lines = []
                            document_lines = await HTTPRequest.getRequest(this.endPoint+'document_lines/'+transfer_allocation_id+'?field_name=document_id&document_type_code='+this.currentDocumentTypeCode, null)
                            if(document_lines != undefined && document_lines != null && document_lines != []){
                                document_lines.forEach( row => {
                                    row.goods_issue_quantity = row.quantity
                                });
                                await this.tabulator.addData(document_lines, true);

                            }

                            this.tabulator.addFilter("line_no", ">", 0);
                            if(document_lines != undefined && document_lines != null && document_lines != []){
                                component_x.origData = JSON.stringify(document_lines.reverse()) //For isDirty Data on Document lines
                            } 
                            this.spinning = false;

                            //Populate Footer and Calculation Data
                            component_x.grossAmount =  document['amount_gross']
                            component_x.grossAmountDisplay = document['amount_gross']
                            component_x.overallDiscount = document['amount_header_discount']
                            component_x.netAmount = document['amount_net']
                            component_x.netAmountDisplay = document['amount_net']
                            component_x.vatAmount = document['tax_amount']
                            component_x.totalWithVat = document['tax_exempt_amount']
                            component_x.itemDiscount = document['amount_line_discount']
                            component_x.taxRate = document['tax_rate']
                            component_x.grossAmountwithoutTax = document['gross_amount_without_tax']
                            component_x.netAmountWithoutTax = document['net_amount_without_tax']
                            this.initializeFooterCalculation()
                            if (component_x.totalQuantity == 0) component_x.totalQuantity = document['total_quantity']
                            } // end guard: valid transfer_allocation_id
                        }

                        break;

                    case 'OTHPCK':
                        var othpck_doc_config = await HTTPRequest.getRequest(component_x.endPoint+'/document_types/get_document_type_settings?type_code=PCK&trans_code=OTH', null)

                        var custom_fields = []
                        if(othpck_doc_config.document_type_settings.customFields != undefined){
                            var additional_fields = othpck_doc_config.document_type_settings.customFields;
                            for(var i = 0; i < additional_fields.length; i++){
                                custom_fields.push({ name: additional_fields[i], value: false, custom: true})
                                this.customFieldsX = custom_fields
                                var add_column = {
                                    title: additional_fields[i].split("_").map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) .join(" "),
                                    field: additional_fields[i],
                                    sorter: 'string',
                                    visible: false,
                                    download: false,
                                    editable: false,
                                    cellClick:function(e, cell){e.stopPropagation();}
                                }
                                
                                this.tabulator.addColumn(add_column);
                                override = true
                            }
                        }

                        listIsZero = this.filteredColumnFields.filter(({ value }) => value === true)
                        fieldsList = listIsZero.length === 0 ? this.defaultColumnFields : this.filteredColumnFields
                        this.assignCustomizedFields(this.currentDocumentTypeCode, fieldsList, this.defaultColumnFields)
                        this.header = TransferAllocationDocumentPicking.header
                        this.renderColumnFields()

                        component_x.isSupplyingSiteDisabled = true
                        this.HideDeleteAndAddProductButton = true
                        if(component_x.originDocumentNumber < 1){
                            var document = await HTTPRequest.getRequest(component_x.endPoint + "documents/"+component_x.originDocumentNumber, null);
                            if(document!=null){
                                if(document["code_and_document_no"]=="TRA#"+document["document_no"]){
                                    this.tabulator.getColumn('quantity').updateDefinition({editable:false})
                                }
                            }
                        }
                        break;

                    case 'OTHCNS':
                        this.spinning = true;
                        this.showDocumentBodyHeader = false
                        this.showSummaryCalculation = false
                        this.showUnitCost = false
                        this.showDiscount = false
                        this.showUnitNetCost = false
                        this.showSubtotal = false
                        this.showTotalQuantity = false
                        this.defaultColumnFields = [
                            { name: "code_and_document_no", value: true },
                            { name: "id", value: true },
                            { name: "reference_1", value: true },
                            { name: "document_date", value: true },
                            { name: "total_quantity", value: true },
                            { name: "status", value: true },
                            { name: "order_status", value: true },
                            { name: "remarks", value: true },
                            { name: "updated_by", value: true },
                            { name: "created_by", value: true },
                            { name: "available_quantity", value: false },
                            { name: "supplier", value: false },
                            { name: "category_code", value: false },
                            { name: "section_code", value: false },
                            { name: "department", value: false },
                            { name: "division", value: false },
                            { name: "design", value: false },
                            { name: "size", value: false },
                            { name: "product_series", value: false },
                            { name: "product_group", value: false },
                            { name: "erp_code", value: false }
                        ]

                        this.filteredColumnFields = this.defaultColumnFields
                        if (this.documentTableFilteredList !== null) this.checkCustomizedFields(this.currentDocumentTypeCode)
                        this.header = CountSet.header
                        this.renderColumnFields()

                        if (component_x.documentNumber < 1){
                            var data = this.$route.params.pcount_data != undefined ? this.$route.params.pcount_data : []
                            data = JSON.parse(JSON.stringify(data));
                            await this.tabulator.addData(data, true);
                        }
                        this.searchFilter = "document_no"
                        this.placeholder = "Search by document no"
                        this.showCancellationDate = false
                        this.showTargetDate = false
                        this.spinning = false;
                        break;
                    default:
                }
                
                // Mount to Edit Record
                if (component_x.documentNumber > 0) {

                    //Action History
                    var documentHistory = await HTTPRequest.getRequest(component_x.endPoint + "document_action_histories/"+component_x.documentNumber+"?field_name=document_id", null);
                    if (documentHistory) this.historyData = documentHistory

                    var document = await HTTPRequest.getRequest(component_x.endPoint + "documents/"+component_x.documentNumber, null);
                    this.logDocumentAmountResponse('openDocument-current-document-fetch', document)
                    if (document.error_message != undefined && document.doc_status != "P"){
                        this.$confirm({
                            title: 'Proceed?',
                            content: h => <div> {document.error_message} Would you like to proceed?</div>,
                            okText: 'Yes',
                            cancelText: 'No',
                            onOk: async () => {
                                var clearDoc = await HTTPRequest.putRequest(component_x.endPoint + "documents/"+component_x.documentNumber+"/clear_access", null);
                                document = await HTTPRequest.getRequest(component_x.endPoint + "documents/"+component_x.documentNumber, null);
                                this.logDocumentAmountResponse('openDocument-current-document-fetch-after-clear-access', document)
                                this.initializeDocument();
                            },
                            onCancel: () => {
                                this.$router.replace(this.backLink)
                            }
                        });
                    }

                    this.isUploaded = document.is_uploaded

                    // Start
                    // https://tools.iripple.com/barter-11/bxi-backend/-/issues/1724
                    // Target Date & Cancellation Date for PO is not getting the assigned date from supplier template
                        this.suppDetails = await HTTPRequest.getRequest(this.endPoint + 'suppliers/' + document["supplier_id"]["key"], null)
                    // https://tools.iripple.com/barter-11/bxi-backend/-/issues/1724
                    // Target Date & Cancellation Date for PO is not getting the assigned date from supplier template
                    // End

                    //2370
                    this.party_tax_type = this.suppDetails.vat_type

                    component_x.documentDetails = document
                    component_x.friendlyCodeAndDocumentNo = document['code_and_document_no']
                    if(document['origin_document_id']["label"] != undefined) {
                        component_x.friendlyOriginDocumentNo = 'Origin Document No: ' + document['origin_document_id']["label"]
                    }
                    component_x.documentId = document['id'];
                    component_x.documentNo = document['document_no']
                    component_x.postDate = document['posted_at']
                    component_x.existingDocumentTypeId = document['document_type_id']
                    component_x.documentStatus = document['status']
                    component_x.documentOrderStatus = document['order_status']
                    // CNC-002: remember the server updated_at we loaded, so Freeze
                    // can send it back for optimistic concurrency detection. If
                    // another user updates/freezes the doc first, the backend will
                    // see this stamp no longer matches and reject with STALE_DOCUMENT.
                    component_x.documentKnownUpdatedAt = document['updated_at']
                    // CNC-002: also remember the raw order_status we loaded so the
                    // freeze endpoint can detect a same-second concurrent freeze
                    // that the second-precision updated_at would otherwise miss.
                    component_x.documentKnownOrderStatus = document['order_status']
                    component_x.syncPhysicalCountV2CountSheetPrintFormat()
                    component_x.originDocumentNumber = document["origin_document_id"]["key"]
                    component_x.isHeaderOnly = document['is_header_only'] || false 
                    component_x.isDocumentTrade = document['is_trade']

                    component_x.requestingSite = document['target_site_id']
                    component_x.supplyingSite = document['source_site_id']
                    component_x.distributionSite = document['site_id']
                    component_x.siteSublocation = document['sublocation_id']
                    component_x.forThisSite = document['site_id']
                    component_x.originSublocation = document['origin_sublocation_id']
                    component_x.destinationSublocation = document['target_sublocation_id']
                    component_x.reference = document['reference']
                    component_x.remark = document['remark']
                    component_x.documentDate = moment(document["document_date"])
                    component_x.targetDate = moment(document["target_date"])
                    component_x.cancellationDate = moment(document["cancellation_date"])
                    component_x.paymentTerm = document["payment_term_id"]
                    component_x.supplier = document["supplier_id"]
                    component_x.supplierDetails = document["supplier_id"]
                    component_x.currency = document['currency_id']
                    component_x.imageFileUrl = document['image_url']
                    if(document["origin_document_id"]["label"] != undefined){
                        component_x.originDocumentCodeAndNumber = document["origin_document_id"]["label"].split("-").slice(-1)[0]
                    } else {
                        component_x.originDocumentCodeAndNumber = ''
                    }

                    //Populate Footer and Calculation Data
                    if (this.currentDocumentTypeCode != "RELADJ"){
                        component_x.grossAmount =  document['amount_gross']
                        component_x.grossAmountDisplay = document['amount_gross']
                        component_x.netAmount = document['amount_net']
                        component_x.netAmountDisplay = document['amount_net']
                    }else{
                        this.calculateSummary();
                    }
                    component_x.overallDiscount = document['amount_header_discount']
                    component_x.vatAmount = document['tax_amount']
                    component_x.totalWithVat = document['tax_exempt_amount']
                    component_x.itemDiscount = document['amount_line_discount']
                    component_x.taxRate = document['tax_rate']
                    component_x.grossAmountwithoutTax = document['gross_amount_without_tax']
                    component_x.netAmountWithoutTax = document['net_amount_without_tax']
                    component_x.drawerSublocationSiteId = document['site_id']["key"]
                    component_x.currencyRateLabel = document["currency_rate"] != "0.00" && document["currency_rate"]!=null ? document["currency_rate"] : document['supplier_currency_rate'] != "0.00" && document['supplier_currency_rate'] != "0.0" && document['supplier_currency_rate'] != null ? document['supplier_currency_rate'] : 1
                    component_x.currencyRate = document["currency_rate"]
                    component_x.currencyDetails = document["currency_id"]
                    component_x.supplierCurrencyRate = document['supplier_currency_rate']
                    component_x.supplierCurrencyId = document['supplier_currency_id']

                    component_x.createdBy = document['created_by']
                    component_x.postedBy = document['posted_by']

                    var docTypeSystemModules = await HTTPRequest.getRequest(component_x.endPoint+"system_modules?code="+component_x.currentDocumentTypeCode+"&status=A", null);
                    var configgedExtras = await HTTPRequest.getRequest(component_x.endPoint+"account_system_modules/"+ docTypeSystemModules[0]["id"] +"?field_name=system_module_id", null);
                    if(configgedExtras!=undefined && configgedExtras != [] && configgedExtras != {} && configgedExtras["meta"]!=undefined && configgedExtras["meta"].customized_fields != undefined ){
                        var metaHolder = JSON.parse(configgedExtras["meta"]).customized_fields
                        this.configuredExtras = metaHolder.map(a => a.code)
                    }
                    this.documentExtras = document['extras']
                    component_x.extras = this.documentExtras
                    var documentReferences = component_x.document_config.document_type_settings.references
                    for(var i=0; i < documentReferences.length; i++){
                        var storedRef = document["reference_" + (i + 1).toString()]
                        if(_.isEmpty(storedRef)){
                            //console.log("skip")
                        } else {
                            documentReferences[i]["input"] = storedRef
                        }
                    }

                    if (document['support_discount_text']) component_x.supportDiscount = document['support_discount_text'].split(',')
                    if (component_x.document_config && !component_x.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.termsAndDiscount && document["discount_text"]) component_x.headerDiscount = document["discount_text"].split(',')

                    // Changed position of these initializers to render the right currency_rate in the tabulator
                    // Updated by Maron Justo
                    if(document["supplier_id"].currency_id!=document["currency_id"].key){
                        await component_x.showConversionCurrencyRate();
                    }
                    if (component_x.currentDocumentTypeCode=="OTHPWS"){
                        window.scrollTo(0,0);
                        this.spinning = true;
                        let document_lines = []
                        document_lines = await HTTPRequest.getRequest(component_x.endPoint + "pricecost_lines/"+component_x.documentNumber+"?field_name=document_id", null);
                        if(document_lines != undefined && document_lines != null && document_lines != []){
                            await this.tabulator.addData(document_lines, true);
                        } 
                        this.tabulator.addFilter("line_no", ">", 0);

                        if(document_lines != undefined && document_lines != null && document_lines != []){
                            component_x.origData = JSON.stringify(document_lines.reverse()) //For isDirty Data on Document lines
                        } 
                        this.spinning = false;
                    }else if(component_x.currentDocumentTypeCode=="OTHCNS"){
                        window.scrollTo(0,0);
                        this.spinning = true;
                        var pcount_documents = [];
                        pcount_documents = await HTTPRequest.getRequest(component_x.endPoint + "documents/get_pcount_document_details?id="+component_x.documentNumber, null);
                        if(pcount_documents) await this.tabulator.addData(pcount_documents, true);
                        if(pcount_documents) component_x.origData = JSON.stringify(pcount_documents.reverse()) //For isDirty Data on Document lines
                        this.spinning = false;
                    } 
                    else if(component_x.currentDocumentTypeCode=="RECCSR"){ 
                    }
                    else {
                        window.scrollTo(0,0);
                        this.spinning = true;

                        // Check if there's an ongoing S3 import job BEFORE loading document lines
                        var earlyImportCheck = await HTTPRequest.getRequest(component_x.endPoint+'import_jobs?profile_name='+this.currentDocumentTypeCode+'-%23-'+this.documentNumber, null)
                        if(earlyImportCheck != undefined && earlyImportCheck.length > 0 && earlyImportCheck[0].formatted_status == 'Ongoing'){
                            // S3 import is ongoing — show loading indicator, skip loading partial lines
                            this.isS3Importing = true;
                            this.documentStatus = 'Uploading';
                            this.spinning = false;
                            // Start polling for S3 import completion
                            this.pollS3ImportStatus();
                        } else {
                        // No ongoing S3 import — load document lines normally
                        // console.log('30')
                        let document_lines = []
                        document_lines = await HTTPRequest.getRequest(component_x.endPoint + "document_lines/" +component_x.documentNumber+ "?field_name=document_id", null);
                        this.logDocumentLineAmountFields('openDocument-document-lines-fetch', document_lines)
                        document_lines = this.normalizeDocumentLineAmountFields('openDocument-document-lines-fetch', document_lines)
                        this.logDocumentLineAmountFields('openDocument-document-lines-after-normalize', document_lines)
                        // if(document_lines != undefined && document_lines != null && document_lines != []) {
                        //     // console.log(document_lines)
                        //     await this.tabulator.addData(document_lines, true);
                        // }

                        if(document_lines != undefined && document_lines != null && document_lines != []){
                            let new_document_lines = []
                            for(var i = 0; i < document_lines.length; i++){
                                const document_line = document_lines[i]
                                // Commented out to avoid blocking the main thread when loading
                                // large documents (500+ lines). Logging one object per row
                                // (2x per line) freezes the UI right after the form appears,
                                // which makes the Update/Confirm/Post buttons feel unresponsive.
                                // console.log("before merging", document_line)
                                let dl_product_extras = document_line.extras
                                let merge_document_lines = {}
                                if (dl_product_extras!= undefined && dl_product_extras != null && dl_product_extras != ""){
                                    merge_document_lines = Object.assign(merge_document_lines, document_line, dl_product_extras)
                                } else {
                                    merge_document_lines = document_line
                                }
                                new_document_lines.push(merge_document_lines)
                                // Commented out for the same performance reason as above.
                                // console.log("after merging", merge_document_lines)
                            }
                            // Commented out for the same performance reason as above.
                            // console.log("NEW LINES")
                            // console.log(new_document_lines)
                            await this.tabulator.addData(new_document_lines, true);
                            this.logDocumentLineAmountFields('openDocument-document-lines-after-extras-merge', new_document_lines)
                            this.logCurrentSummaryAmounts('openDocument-after-document-lines-addData')
                        } 

                        if(document_lines != undefined && document_lines != null && document_lines != []) {
                            await this.tabulator.addFilter("line_no", ">", 0);
                            this.logCurrentSummaryAmounts('openDocument-after-line-no-filter')
                        }

                        if(document_lines != undefined && document_lines != null && document_lines != []){
                            component_x.origData = JSON.stringify(document_lines.reverse()) //For isDirty Data on Document lines
                        } 
                        this.spinning = false;
                        } // end of: no ongoing S3 import
                    }

                    //Document Charges
                    if(component_x.document_config){
                        var enableAddCharges = component_x.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.enableAddCharges
                        if(enableAddCharges) {
                            var document_charges = []
                            document_charges = await HTTPRequest.getRequest(component_x.endPoint + "document_charges/"+component_x.documentNumber+"?field_name=document_id", null);
                            if(document_charges) component_x.chargeData = document_charges
                        }
                    }

                    if (document["shipping_method_id"]["key"] > 0) component_x.shippingMethod = document["shipping_method_id"];
                    if (document["purpose_id"]["key"] > 0) component_x.purpose = document["purpose_id"];

                    component_x.party = document["party_name"];
                    component_x.customer = document["customer_id"];
                    component_x.salesman = {key: document["salesman_id"], label: document["salesman_name"]};

                    if(component_x.salesman)
                    if (component_x.customer){
                        var customer = await HTTPRequest.getRequest(component_x.endPoint + "customers/"+component_x.customer.key, null);
                        this.customerAddress = (customer["address"]) ? customer["address"] : "No Customer Address";
                        this.customerContactMobile = (customer["mobile"]) ? customer["mobile"] : "No Customer Mobile";
                        this.customerContactTelephone = (customer["telephone"]) ? customer["telephone"] : "No Customer Telephone";
                        this.customerContactFax = (customer["fax"]) ? customer["fax"] : "No Customer Fax";
                        this.customerContactEmail = (customer["email"]) ? customer["email"] : "No Customer Email";
                        this.selectedCustomerContact = (customer["mobile"]) ? 'Mobile' : (customer["telephone"]) ? 'Telephone' : (customer["fax"]) ? 'Fax' : (customer["email"]) ? 'Email' : 'Telephone'
                        this.activeCustomerContact = (customer["mobile"]) ? this.customerContactMobile : (customer["telephone"]) ? this.customerContactTelephone : (customer["fax"]) ? this.customerContactFax : (customer["email"]) ? this.customerContactEmail : this.customerContactTelephone
                    }

                    if(document["address"]){
                        this.customerAddress = document["address"]
                    }

                    // if Transfer Request
                    if (this.currentDocumentTypeCode == 'ORITRQ' || this.currentDocumentTypeCode == 'ORICSQ') {
                        if (document['source_site_id']['key'].toString() == secureStorage.getItem("defaultSiteId").toString()) component_x.showCreateChildDocButton = true
                    }

                    if (this.currentDocumentTypeCode == 'RELTRX' || this.currentDocumentTypeCode == 'RELCSX') {
                        if (document['target_site_id']['key'].toString() == secureStorage.getItem("defaultSiteId").toString()) component_x.showCreateChildDocButton = true
                    }

                    // if Stock Request For Serving /Concession
                    if (this.currentDocumentTypeCode == 'OROTRQ' || this.currentDocumentTypeCode == 'OROCSQ') {
                        if (this.originDocumentNumber > 0) {
                            this.isRequestingSiteDisabled = true
                        }
                    }

                    // if Transfer In /Concession
                    if (this.currentDocumentTypeCode == 'RECTRX' || this.currentDocumentTypeCode == 'RECCSX') {
                        if (this.originDocumentNumber > 0) {
                            this.isSupplyingSiteDisabled = true
                        }
                    }

                    // if Receiving Report
                    if (this.currentDocumentTypeCode == 'RECDEL') {
                        if (this.originDocumentNumber > 0) {
                            this.isSupplierDisabled = true
                        }
                    }

                    // if Sales order Document
                    if (this.currentDocumentTypeCode == 'ORISOX') {
                        if (document["order_source"]!="") {
                            if (document['order_source'] != null) component_x.orderSource = document["order_source"]
                        }
                        this.showPrint = true
                    }

                    // if Delivery Document
                    if (this.currentDocumentTypeCode == 'RELDDE') {
                        if (document["discount_text"]) component_x.headerDiscount = document["discount_text"].split(',')
                        
                        if (document["order_source"]!="") {
                            if (document['order_source'] != null) component_x.orderSource = document["order_source"]
                        }
                        
                        var orisox_document = await HTTPRequest.getRequest(component_x.endPoint + "documents/"+document['origin_document_id']['key'], null);
                        component_x.salesOrder = orisox_document["document_no"];
                        if (orisox_document["payment_status"] == "Paid") {
                            this.forPaymentIsProcessed = true
                        }
                        this.showPrint = true
                        if (document['order_source'] == 'zalora'){
                            if (this.zaloraPrintWayBillStatus == null){
                                this.exportShippingLabel();
                            }else {
                                this.fetchStatus(this.zaloraPrintWayBillId)
                            }
                        }

                    }

                    // if re-routed SO
                    if (this.currentDocumentTypeCode == 'ORORSO') {
                        component_x.salesOrder = document['origin_document_id']['label'];
                        if (document["discount_text"]) component_x.headerDiscount = document["discount_text"].split(',')

                        if (document["order_source"]!="") {
                            if (document['order_source'] != null) component_x.orderSource = document["order_source"]
                        }

                        var orisox_document = await HTTPRequest.getRequest(component_x.endPoint + "documents/"+document['origin_document_id']['key'], null);
                        if (orisox_document["payment_status"] == "Paid") {
                            this.forPaymentIsProcessed = true
                        }
                        this.showPrint = true
                    }

                    // if Customer Return
                    if (this.currentDocumentTypeCode == 'RECCSR') {
                        component_x.deliveryDocument = document['origin_document_id']['label'];
                        if (document["discount_text"]) component_x.headerDiscount = document["discount_text"].split(',')

                        if (document["order_source"]!="") {
                            if (document['order_source'] != null) component_x.orderSource = document["order_source"]
                        }

                        var orisox_document = await HTTPRequest.getRequest(component_x.endPoint + "documents/"+document['origin_document_id']['key'], null);
                        this.showPrint = true
                    }
                    // if Sales Invoice
                    if (this.currentDocumentTypeCode == 'OTHSIN') {
                        component_x.deliveryDocument = document['origin_document_id']['label'];
                        var delivery_document = await HTTPRequest.getRequest(component_x.endPoint + "documents/"+document['origin_document_id']['key'], null);
                        component_x.salesOrder = delivery_document['origin_document_id']['label'];

                        if (document["order_source"]!="") {
                            if (document['order_source'] != null) component_x.orderSource = document["order_source"]
                        }

                        var reldde_document = await HTTPRequest.getRequest(component_x.endPoint + "documents/"+document['origin_document_id']['key'], null);
                        var orisox_document = await HTTPRequest.getRequest(component_x.endPoint + "documents/"+reldde_document['origin_document_id']['key'], null);
                        if (orisox_document["payment_status"] == "Paid") {
                            this.forPaymentIsProcessed = true
                        }
                        this.showPrint = true
                    }

                    if (this.currentDocumentTypeCode == 'OTHSBI') {
                        component_x.receivingReport = document['origin_document_id']['label'];
                    }

                    // if Sales Invoice
                    if (this.originDocumentNumber > 0) {
                        var originDocument = await HTTPRequest.getRequest(component_x.endPoint + "documents/"+this.originDocumentNumber, null);
                        this.originDocumentTypeId = originDocument['document_type_id']
                    }

                    //Disabled Actions When Document is already Posted
                    var disable_status = ["Posted", "Voided", "Confirmed"]
                        component_x.isSaveDisabled = (disable_status.includes(component_x.documentStatus)) ? true : false;
                        component_x.isUpdateDisabled = (disable_status.includes(component_x.documentStatus)) ? true : false;
                        component_x.isfreezeDisabled = (disable_status.includes(component_x.documentStatus)) ? true : false;
                        component_x.isSupplyingSiteDisabled = (disable_status.includes(component_x.documentStatus)) ? true : false;
                        component_x.isRequestingSiteDisabled = (disable_status.includes(component_x.documentStatus)) ? true : false;
                        component_x.isHeaderDiscountDisabled = (disable_status.includes(component_x.documentStatus)) ? true : false;
                        component_x.isSupplierDisabled = (disable_status.includes(component_x.documentStatus)) ? true : false;
                        component_x.isTradeToggleDisabled = (disable_status.includes(component_x.documentStatus)) ? true : false;
                        component_x.productFormMode = (disable_status.includes(component_x.documentStatus)) ? "Search" : "Add";
                        component_x.isReferenceDisabled = (disable_status.includes(component_x.documentStatus)) ? true : false;
                        component_x.isPaymentTermDisabled = (disable_status.includes(component_x.documentStatus)) ? true : false;
                        component_x.isShippingMethodDisabled = (disable_status.includes(component_x.documentStatus)) ? true : false;
                        component_x.isSupportsDiscountDisabled = (disable_status.includes(component_x.documentStatus)) ? true : false;
                        component_x.isDocumentDateDisabled = (disable_status.includes(component_x.documentStatus)) ? true : false;
                        component_x.isTargetDateDisabled = (disable_status.includes(component_x.documentStatus)) ? true : false;
                        component_x.isCancellationDateDisabled = (disable_status.includes(component_x.documentStatus)) ? true : false;
                        component_x.isAddChargeDisabled = (disable_status.includes(component_x.documentStatus)) ? true : false;
                        component_x.isPurposeDisabled = (disable_status.includes(component_x.documentStatus)) ? true : false;
                        component_x.isPartyDisabled = (disable_status.includes(component_x.documentStatus)) ? true : false;
                        component_x.isDistributionSiteDisabled = (disable_status.includes(component_x.documentStatus)) ? true : false;
                        component_x.isOriginSublocationDisabled = (disable_status.includes(component_x.documentStatus)) ? true : false;
                        component_x.isDestinationSublocationDisabled = (disable_status.includes(component_x.documentStatus)) ? true : false;
                        component_x.isCustomerDisabled = (disable_status.includes(component_x.documentStatus)) ? true : false;
                        component_x.isSalesmanDisabled = (disable_status.includes(component_x.documentStatus)) ? true : false;
                        component_x.isCustomerCreateDisabled = (disable_status.includes(component_x.documentStatus)) ? true : false;
                        component_x.isOrderSourceDisabled = (disable_status.includes(component_x.documentStatus)) ? true : false;
                        component_x.showSupplierOptions = (disable_status.includes(component_x.documentStatus)) ? true : false;
                        component_x.isForThisSiteDisabled = (disable_status.includes(component_x.documentStatus)) ? true : false;
                        component_x.isSiteSublocationDisabled = (disable_status.includes(component_x.documentStatus)) ? true : false;
                        component_x.isRevenueDisabled = (disable_status.includes(component_x.documentStatus)) ? true : false;
                        component_x.isPostDisabled = (disable_status.includes(component_x.documentStatus) && component_x.documentStatus != "Confirmed") ? true : false;
                        this.showAdvancedInfo = true
                        if(component_x.currentDocumentTypeCode=="ORORSO") {
                            if( this.documentExtras!='' && this.documentExtras!=undefined){
                                this.revenue = this.documentExtras["revenue"] || ''
                            }
                            if(this.requestingSite.key == secureStorage.getItem("defaultSiteId").toString()){
                                this.isPostDisabled = false
                                this.isConfirmDisabled = false
                                this.isRevenueDisabled = true
                                if(this.distributionSite.key != this.requestingSite.key){
                                    this.isRequestingSiteDisabled = true
                                }
                                this.tabulator.toggleColumn("quantity")
                                this.tabulator.toggleColumn("on_hand_quantity")
                            }else{
                                this.isPostDisabled = true
                                this.isConfirmDisabled = true
                            }
                        }
                        if (component_x.currentDocumentTypeCode == 'RECDEL') {
                          if (this.originDocumentNumber > 0) {
                            this.isSupplierDisabled = true
                          }
                        }
                    if (component_x.totalQuantity == 0){
                        component_x.totalQuantity = document['total_quantity']
                    }
                    
                    component_x.defaultSite = document['site_id']["key"]
                } else {
                    component_x.defaultSite = secureStorage.getItem("defaultSiteId")
                }

                // DISABLE BUTTON //
                console.log("<<< START HERE >>>")
                if (this.currentDocumentTypeCode == 'ORIPOX' && (document != null || document != undefined)) {
                    let currentSite = parseInt(secureStorage.getItem("defaultSiteId"))
                    let site_id = null
                    if (document != null || document != undefined){
                        site_id = parseInt(document['site_id']['key'])
                    }
                    
                    if(currentSite != site_id){
                        const formContainer =  window.document.getElementById('document-form');
                        const elements = formContainer.querySelectorAll('input, select, textarea, button');
                        
                        elements.forEach(element => {
                            element.disabled = true;
                        });

                        this.isPostDisabled = true
                    }
                }
                console.log("<<< END HERE >>>")
                
                //Check if with ongoing jobs
                var ongoingJob = await HTTPRequest.getRequest(component_x.endPoint+'import_jobs?profile_name='+this.currentDocumentTypeCode+'-%23-'+this.documentNumber, null)
                if(ongoingJob != undefined && ongoingJob.length > 0){
                    if(ongoingJob[0].formatted_status == 'Ongoing') {
                        this.documentStatus = 'Uploading'
                        this.isS3Importing = true;
                        // Start polling for S3 import completion
                        this.pollS3ImportStatus();
                    } else if(ongoingJob[0].formatted_status == 'With errors') {
                        this.isS3Importing = false;
                        // Only override the badge with 'Upload Error' when the document is
                        // not already in a finalized state. A Posted/Voided document must
                        // keep its real status even if an old import job errored out.
                        if(this.documentStatus != 'Posted' && this.documentStatus != 'Voided') {
                            this.documentStatus = 'Upload Error'
                            component_x.$notification['warning']({
                                message: 'Upload Error',
                                duration: 0,
                                description: "CSV file uploaded with errors ["+this.currentDocumentTypeCode+'-#-'+this.documentNumber+"] but you can ignore it and continue processing the document. Click 'View Jobs' button to review.",
                                style: getNotificationStyle('warning'),
                                btn: h => {
                                    return h(
                                    'base-button',
                                    {
                                        props: {
                                        type: 'warning',
                                        class: 'btn-sm',
                                        },
                                        on: {
                                        click: () => component_x.$router.push("/jobs"),
                                        },
                                    },
                                    'View Jobs',
                                    );
                                },
                            });
                        }
                    } else if(ongoingJob[0].formatted_status == 'Upload terminated') {
                        this.isS3Importing = false;
                        // Keep a finalized (Posted/Voided) document's real status intact.
                        if(this.documentStatus != 'Posted' && this.documentStatus != 'Voided') {
                            this.documentStatus = ongoingJob[0].formatted_status
                            component_x.$notification['warning']({
                                message: 'Upload terminated. Please reupload.',
                            });
                        }
                    } else {
                        this.isS3Importing = false;
                    }
                }

                //Check last document action
                var doc_data = this.tabulator.getData()
                var response = await HTTPRequest.getRequest(this.endPoint + 'document_action_histories?document_id='+ this.documentNumber, null)
                var last_action = ""
                if (response[response.length - 1] != undefined){
                    last_action = response[response.length - 1].action
                }

                if(last_action == "ONGOING POSTING"){
                    this.documentStatus = 'ONGOING POSTING'
                }

                //Setting Document Status Icon on Header
                switch(this.documentStatus) {
                    case 'Saved':
                        this.headerStatusIcon = 'fas fa-check-circle'
                        break;
                    case 'Uploading':
                        this.headerStatusIcon = 'fas fa-cloud-upload-alt text-blue'
                        break;
                    case 'Upload Error':
                        this.headerStatusIcon = 'fas fa-times text-red'
                        break;
                    case 'Posted':
                        this.headerStatusIcon = 'fas fa-check-circle text-green'
                        this.isPostDisabled = true
                        if (this.currentDocumentTypeCode == 'OTHASM' || this.currentDocumentTypeCode == 'OTHDSM') {
                            this.postedASMDSM = true
                        }
                        break;
                    case 'Voided':
                        this.headerStatusIcon = 'fas fa-times-circle text-red'
                        this.isPostDisabled = true
                        break;
                    case 'Confirmed':
                        this.headerStatusIcon = 'fas fa-check-circle'
                        break;
                    case 'ONGOING POSTING':
                        this.isPostDisabled = true
                        break;
                    default:
                        this.headerStatusIcon = ''
                        this.isPostDisabled = false
                }

                // console.log(this.documentOrderStatus)
                switch(this.documentOrderStatus){
                    case 'Unfulfilled':
                    this.headerOrderStatusIcon = 'fa-regular fa-circle mr-4 text-gray'
                    break;
                    case 'Fulfilled':
                    this.headerOrderStatusIcon = 'fas fa-check-circle mr-4 text-green'
                    break;
                    case 'Partially Delivered':
                    this.headerOrderStatusIcon = 'fa-solid fa-circle-half-stroke mr-4 text-green'
                    break;
                    case 'Done':
                    this.headerOrderStatusIcon = 'fa-solid fa-circle-dot mr-4 text-cyan'
                    break;
                    case 'Printed':
                    this.headerOrderStatusIcon = 'fas fa-print mr-4 text-black'
                    break;
                    default:
                    this.headerOrderStatusIcon = ''

                }

                
                //1935
                await this.calculateOverallDiscount()
                if(!component_x.isRunDefaultCurrency){
                    await component_x.fetchDefaultCurrency()
                }
                component_x.forceFetchCurrency = true
                await component_x.fetchCurrencies()
                this.showFreezeButton = true
                
                const docSortDrawerData = localStorage.getItem("documentTypeSort" + this.currentDocumentTypeCode);
                if(docSortDrawerData != undefined && docSortDrawerData != null && docSortDrawerData != "[]"){
                    let val = JSON.parse(docSortDrawerData)
                    await this.sortDocument(val);
                }
                if(this.documentId != undefined && this.documentId != '' && this.documentId != null){
                    var related_document = await HTTPRequest.getRequest(this.endPoint + '/documents/get_related_document?document_id=' + this.documentId, null, null)
                    if(related_document != undefined && related_document != null && related_document != "[]"){
                        this.relatedDocument = await this.filterViewableRelatedDocuments(related_document.data)
                        this.documentRelation = related_document.relation || ''
                    }
                }
                this.totalCharge();
                } finally {
                    // Loading finished (or failed): always hide the loading overlay and
                    // re-enable the action buttons so the form never gets stuck loading.
                    this.isInitializing = false;
                    this.spinMessage = 'Loading..';
                }
            },

            async copyDocument() {
                var duplicated_document = await HTTPRequest.postRequest(this.endPoint + '/documents/copy_document?document_id=' + this.documentNumber , null, null)
                this.openDocument(duplicated_document.id,this.existingDocumentTypeDetails)
            },
            async mergePhysicalCountV2SimilarEntries() {
                this.spinning = true;
                this.spinMessage = 'Merging similar entries...';
                this.notifMessage = [];
                const response = await HTTPRequest.postRequest(this.endPoint + 'physical_count_v2/merge_similar_entries', null, {
                    document_id: this.documentNumber
                });
                this.spinning = false;
                this.spinMessage = 'Loading..';

                if (response == undefined || response.error) {
                    this.notifMessage = [response && response.error ? response.error : 'Unable to merge similar entries.'];
                    this.documentActionNotification('merge similar entries', 'error');
                    return;
                }

                this.documentActionNotification('merge similar entries', 'success');
                await this.openDocument(this.documentNumber, this.existingDocumentTypeDetails);
            },
            voidEcomOrder(){
                if (this.orderSource == 'shopee' || this.orderSource == 'lazada' || this.orderSource == 'shopify' ||  this.orderSource == 'zalora'){
                    this.documentEcomDrawerVisible = true
                    this.ecomAction = 'Void'
                } else {
                    this.voided()
                }
            },
            deleteRow(id){
                this.documentNumber = id
                this.voided()
            },
            postEcomOrder(){
                window.scrollTo(0,0);
                this.spinning = true;
                this.notifMessage = [];
                var data = this.tabulator.getData();
                //For RelDde Documents
                if(['RELDDE'].includes(this.currentDocumentTypeCode)){
                    if (this.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.automaticPostingOnSave != true) {
                        //when goods issue
                        if (this.documentNumber > 0) {
                            var invalid = data.find(row => row.goods_issue_quantity == 0 && Number(row.ordered_quantity) > 0)
                            if (invalid != undefined){
                                this.notifMessage.push("Zero goods issue quantity is not allowed in the document line");
                                this.documentActionNotification('post', 'error');
                                this.spinning = false;
                                return;
                            }
                        }
                    }
                }
                if (data.length > 0) {
                    this.isEditing = !(component_x.origData === JSON.stringify(data))
                }

                if(this.documentStatus == "Confirmed" && this.isEditing){
                    this.isChangeAction = true;
                }

                if (this.isEditing && !this.isChangeAction) {
                    this.notifMessage.push("You have unsaved changes, please save before posting")
                    this.documentActionNotification('post', 'error');
                    this.spinning = false;
                    return;
                } else {
                    this.documentEcomDrawerVisible = true
                    this.ecomAction = 'Post'
                }
                this.spinning = false;
            },
            ecomPost(id){
                this.documentNumber = id
                this.post()
            },
            shopeePrintWayBill:async function(){
                this.spinning = true;
                var post_request = await HTTPRequest.postRequest(this.endPoint + '/shopee_integrations/get_airway_bill', null, {document_id:this.documentNumber})
                if (post_request["result"]["errors"].length <=0){
                    this.spinning = false;
                    window.open(post_request["result"]["airway_bills"][0]["airway_bill"], '_blank')
                }else {
                    this.$notification['error']({
                        message: post_request["result"]["errors"][0]["error_code"],
                        description: post_request["result"]["errors"][0]["error_description"],
                        style: getNotificationStyle('error')
                    });
                    this.spinning = false;
                }
            },
            lazadaPrintWayBill:async function(){
                this.spinning = true;
                var post_request = await HTTPRequest.postRequest(this.endPoint + '/lazada_integrations/print_waybill', null, {document_id:this.documentNumber})
                if (post_request["errors"] == undefined){
                    this.spinning = false;
                    let pdfWindow = window.open("");
                    pdfWindow.document.write(
                        "<iframe width='100%' height='100%' src='data:"+post_request["document"]["mime_type"]+";base64, " +
                        post_request["document"]["file"] + "'></iframe>"
                    )
                }else {
                    this.$notification['error']({
                        message: "Error",
                        description: post_request["errors"],
                        style: getNotificationStyle('error')
                    });
                    this.spinning = false;
                }
            },
            exportShippingLabel:async function(){
                var post_request = await HTTPRequest.postRequest(this.endPoint + '/zalora_integrations/print_waybill', null, {document_id:this.documentNumber})
                if (post_request["errors"] == undefined){
                    this.zaloraPrintWayBillStatus == post_request.data.status;
                    this.zaloraPrintWayBillId == post_request.data.id;
                    if (this.zaloraPrintWayBillStatus !== 'Finished') {
                        this.fetchStatus(post_request["data"].id);
                    }else {
                    this.zaloraPrintWayBillDisabled = false;
                    this.zaloraPrintWayBillDLink = 'https://sellercenter-staging.zalora.com.ph/'+post_request["data"]["downloadLinks"][0]
                    }
                }
            },
            fetchStatus:async function(item_id) {
                var post_request = await HTTPRequest.postRequest(this.endPoint + '/zalora_integrations/get_export_item', null, {document_id:this.documentNumber, exportItemId: item_id});
                this.zaloraPrintWayBillStatus = post_request.status;
                if (this.zaloraPrintWayBillStatus !== 'Finished') {
                    setTimeout(() => {
                        this.fetchStatus(post_request.id);
                    }, 30000);
                }else {
                    this.zaloraPrintWayBillDisabled = false;
                    this.zaloraPrintWayBillDLink = 'https://sellercenter-staging.zalora.com.ph/'+post_request["downloadLinks"][0]
                }
            },
            zaloraPrintWayBill:async function(){
                window.open(this.zaloraPrintWayBillDLink, '_blank');
            },
           
            documentEndpoint(input) {
                const siteId = this.distributionSite && this.distributionSite.key
                    ? this.distributionSite.key
                    : secureStorage.getItem("defaultSiteId")
                return `${this.endPoint}documents/pcount_for_count_set_document_search?site_id=${siteId}&${this.searchFilter}=${encodeURIComponent(input)}`
            },

            // documentEndpoint (input) {
            //     // var params = '/documents?type=OTHCNS&'
            //     var params = "documents/pcount_for_count_set_document_search?"
            //     return this.endPoint + params + this.searchFilter + '=' + input;
            // },
            filterExistingDocuments(e){
                var data = this.tabulator.getData();
                var ids = data.map(({id}) => id)
                return e.data.filter(item => !ids.includes(item.id))
            },
            async getDocument (group) {
                this.notifMessage = []
                this.documentID = group.value
                this.selectedDocument = group.selectedObject
            },
            clearDocument (){
                this.selectedDocument = ''
                this.documentID = null
            },
            formattedDocumentDisplay (result) {
                if (this.searchFilter !='document_id'){
                    return eval('result.'+this.searchFilter) + ' ['+result.id+']';
                }else{
                    return eval('result.id')  + ' ['+result.document_no+']';
                }
            },
            handleAddDocumentVisibleChange(addPCountDocumentConfirmationVisible){
                if (!addPCountDocumentConfirmationVisible) {
                    this.addPCountDocumentConfirmationVisible = false;
                    return;
                }
                if (this.currentDocumentTypeCode == 'OTHCNS') {
                    this.addPCount();
                }
            },
            async addPCount() {
                this.notifMessage = []
                var data = this.tabulator.getData();
                if (this.documentID) {
                    if (!(data.length == this.maximumDocumentLineNumber)) {
                        await this.tabulator.addRow(this.selectedDocument);
                        this.clearDocument()
                    } else {
                        this.documentActionNotification('Add Document', 'error')
                    }
                }
                this.addPCountDocumentConfirmationVisible = false;
            },
            addPCountCancel() {
                this.addPCountDocumentConfirmationVisible = false;
            },
            mass_delete_document_line() {
                this.selectedDocumentLineRows.forEach(function(x){
                   x.delete();
                });
                this.selectedDocumentLines = []
            },
            async showConversionCurrencyRate(){
                if (parseInt(this.supplierDetails.currency_id)>0){
                    if (Number(this.currencyRate) > 0 && parseInt(this.supplierDetails.currency_id)!=parseInt(this.currency.key)) {
                        this.isCurrencyToPhp = false
                        this.showConversionCurrencyRateColumns()
                    } else if (Number(this.currencyRate) <= 0 && parseInt(this.supplierDetails.currency_id)!=parseInt(this.currency.key)){
                        this.isCurrencyToPhp = true
                        this.showConversionCurrencyRateColumns()
                    }else{
                        this.hideConversionColumns()
                    }
                }else if (this.hasDefaultCurrency){
                    if (parseInt(this.currency.key) == 0){
                        this.isCurrencyToPhp = true
                        this.showConversionCurrencyRateColumns()
                    }else{
                        this.hideConversionColumns()
                    }
                } else if(Number(this.currencyRate) > 0 && parseInt(this.currency.key) != 0 && !this.hasDefaultCurrency){
                    this.isCurrencyToPhp = false
                    this.showConversionCurrencyRateColumns()
                } else {
                    this.hideConversionColumns()
                }
            },
            async hideConversionColumns(){
                let subtotal,cost,price,gross;
                this.isCurrencyToPhp = false
                this.showConversionRate = false
                this.tabulator.hideColumn("subtotal_php")
                subtotal = this.tabulator.getColumn("subtotal_php")
                await subtotal.updateDefinition({download:false})
                this.tabulator.hideColumn("cost_php")
                cost = this.tabulator.getColumn("cost_php")
                await cost.updateDefinition({download:false})
                this.tabulator.hideColumn("price_php")
                price = this.tabulator.getColumn("price_php")
                await price.updateDefinition({download:false})
                this.tabulator.hideColumn("total_gross_php")
                gross = this.tabulator.getColumn("total_gross_php")
                await gross.updateDefinition({download:false})
            },
            async showConversionCurrencyRateColumns(){
                let subtotal,cost,price,gross,label;
                label=this.currencyDetails.code == undefined ? 'PHP' : this.currencyDetails.code
                this.showConversionRate = true
                subtotal = this.tabulator.getColumn("subtotal_php")
                await subtotal.updateDefinition({title: "Subtotal ("+label+")", download:true})
                this.tabulator.showColumn("subtotal_php")
                cost = this.tabulator.getColumn("cost_php")
                await cost.updateDefinition({title: "Net Cost ("+label+")", download:true})
                this.tabulator.showColumn("cost_php")
                price = this.tabulator.getColumn("price_php")
                await price.updateDefinition({title: "Unit Cost ("+label+")", download:true})
                this.tabulator.showColumn("price_php")
                gross = this.tabulator.getColumn("total_gross_php")
                await gross.updateDefinition({title: "Total Gross ("+label+")", download:true})
                this.tabulator.showColumn("total_gross_php")
            },
            iconFormatter(cell){
                var product_type = cell.getRow().getData().product_type
                if (product_type == undefined) {
                    product_type = cell.getRow().getData().product_icon
                }
                var image_path = "";
                switch(product_type){
                    case '':
                    image_path =  'regular.png'
                    break;
                    case 'P':
                    image_path =  'packaged.png'
                    break;
                    case 'N':
                    image_path =  'non_inventory.png'
                    break;
                    case 'S':
                    image_path =  'serial.png'
                    break;
                    case 'K':
                    image_path =  'kit.png'
                    break;
                    case 'V':
                    image_path =  'virtual_kit.png'
                    break;
                    case 'M':
                    image_path =  'matrix.png'
                    break;
                    case 'I':
                    image_path =  'matrix.png'
                    break;
                    case 'B':
                    if(this.icon_code == 'FNB'){
                        image_path =  'combo.png'
                    }else{
                        image_path =  'regular.png'
                    }
                    break;
                    case 'R':
                    image_path =  'recipe.png'
                    break;
                    default:
                    image_path =  'regular.png'
                    break;
                }
                
                image_path = require('../../assets/icons/'+ this.icon_code + '/'+ image_path)
                return "<img class='table-product-icons2' src='"+ image_path +"' alt='icon'>"
            },
            supplierStockNumber(cell){
                if(this.currentDocumentTypeCode=='ORIPOX'){
                    var show_status = this.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.enableShowingSupplierStockNumber
                    var show_status1 = (this.document_config.document_type_settings.printSettings!=undefined) ? this.document_config.document_type_settings.printSettings.showStockNoInProductList : false
                    if(show_status==true || show_status1==true){
                        var label = ''
                        var supplier_stock_no = cell.getRow().getData().supplier_stock_no
                        if (supplier_stock_no!=undefined){
                            label = supplier_stock_no
                        }else{
                            var extras = cell.getRow().getData().extras
                            try{
                                if(extras["supplier_stock_no"] == undefined){
                                    label = ""
                                }else {
                                    label = extras["supplier_stock_no"]
                                }
                            }catch(e){
                                label = ""
                            }
                            cell.getRow().update({"supplier_stock_no":label})
                        }
                        return label
                    }
                }
            },
            sizeFormatter(cell){
                if(this.currentDocumentTypeCode=='ORIPOX'){
                    var show_status = (this.document_config.document_type_settings.printSettings!=undefined) ? this.document_config.document_type_settings.printSettings.showDesignAndSizeInProductList : false
                    if(show_status==true){
                        var label = ''
                        var size = cell.getRow().getData().size
                        if (size==null){
                            label = ''
                            cell.getRow().update({"size":label})
                        }else{
                            label = size
                        }
                        return label
                    }
                }else{
                    label = ''
                    size = cell.getRow().getData().size
                    if (size==null){
                        label = ''
                        cell.getRow().update({"size":label})
                    }else{
                        label = size
                    }
                    return label
                }
            },
            colorFormatter(cell){
                if(this.currentDocumentTypeCode=='ORIPOX'){
                    var show_status = (this.document_config.document_type_settings.printSettings!=undefined) ? this.document_config.document_type_settings.printSettings.showColorInProductList : false
                    if(show_status==true){
                        var label = ''
                        var color = cell.getRow().getData().color
                        if (color==null){
                            label = ''
                            cell.getRow().update({"color":label})
                        }else{
                            label = color
                        }
                        return label
                    }
                }else{
                    label = ''
                    color = cell.getRow().getData().color
                    if (color==null){
                        label = ''
                        cell.getRow().update({"color":label})
                    }else{
                        label = color
                    }
                    return label
                }
            },
            designFormatter(cell){
                if(this.currentDocumentTypeCode=='ORIPOX'){
                    var show_status = (this.document_config.document_type_settings.printSettings!=undefined) ? this.document_config.document_type_settings.printSettings.showDesignAndSizeInProductList : false
                    if(show_status==true){
                        var label = ''
                        var design = cell.getRow().getData().design
                        if (design==null){
                            label = ''
                            cell.getRow().update({"design":label})
                        }else{
                            label = design
                        }
                        return label
                    }
                } else{
                    label = ''
                    design = cell.getRow().getData().design
                    if (design==null){
                        label = ''
                        cell.getRow().update({"design":label})
                    }else{
                        label = design
                    }
                    return label
                }
            },
            payInitialDepositValidation(){
                this.initialDepositErrors = [];
                this.initialDepositErrors.push(ValidateField.required('Amount', this.initialDeposit.amount));
                this.initialDepositErrors.push(ValidateField.required('Reference', this.initialDeposit.reference));
                this.initialDepositErrors = this._.compact(this.initialDepositErrors);
                return this.initialDepositErrors.length;
            },
            async payInitialDeposit(documentNumber){
                if(!this.payInitialDepositValidation()){
                    var InitialDepositPayload = {
                        document_payment:{
                            amount:this.initialDeposit.amount,
                            reference:this.initialDeposit.reference,
                            payment_mode:"Initial Deposit",
                            status:"A",
                            payment_date: moment(new Date()),
                            document_id:documentNumber
                        }
                    }
                    var post_request = await HTTPRequest.postRequest(this.endPoint + 'document_payments', null, InitialDepositPayload)
                    if (post_request["error"] == undefined) {
                        this.forPaymentIsProcessed = true;
                        this.closeDrawer('initialDeposit')
                        this.post("deposir");
                    } else {
                        this.notifMessage = post_request['error'].split(',');
                        this.documentActionNotification('Inital Deposit', 'error')
                    }
                }
            },
            async exportCSV(){
                if(this.currentDocumentTypeCode == 'ORIPOX'){
                    let tabulatorInstance = this.$refs.tabulator.getInstance();
                    var calculation = tabulatorInstance.getCalcResults();
                    var documentType = this.currentDocumentTypeName || ''
                    var currentSiteName = secureStorage.getItem("defaultSiteName") || '';
                    var userCode = secureStorage.getItem("userCode") || '';
                    var createdBy = this.createdBy || '';
                    var postedBy = this.postedBy || '';
                    var supplier = this.supplier.label || ''
                    var remark = this.remark || ''
                    var purpose = this.purpose.label || ''

                    var documentDate = this.documentDate.format('D-MMM-YYYY') || ''
                    var targetDate = this.targetDate.format('D-MMM-YYYY') || ''
                    var cancellationDate = this.cancellationDate.format('D-MMM-YYYY') || ''

                    var currentDocumentTypeFriendlyCode = this.currentDocumentTypeFriendlyCode || ''
                    var documentStatus = this.documentStatus || ''
                    var documentNumber = this.documentNo || ''

                    var reference = this.reference || ''
                    var currencyLabel = this.currency.label || '';
                    var currencyRate = this.documentDetails.currency_rate;

                    var printDate = moment().format('lll') || '';
                    var postDate = this.postDate || ''
                    var priceInclusion = this.documentDetails.reference_8 || ''
                    var comment1 = this.documentDetails.reference_9 || ''
                    var comment2 = this.documentDetails.reference_10 || ''
                    var initial_deposit = 0
                    var balance = 0
                    let currencyKey = component_x.currency.key;
                    var total_qty = 0
                    var total_cost = 0
                    var sub_total = 0
                    if (currencyKey>0 && this.showConversionRate){
                        var subtotal = this.tabulator.getColumn("subtotal")
                        await subtotal.updateDefinition({download:false})
                        var subtotal_php = this.tabulator.getColumn("subtotal_php")
                        await subtotal_php.updateDefinition({downloadTitle: "Subtotal", download:true})
                        var price = this.tabulator.getColumn("price")
                        await price.updateDefinition({download:false})
                        var cost_php = this.tabulator.getColumn("price_php")
                        await cost_php.updateDefinition({downloadTitle: "Cost", download:true})
                        total_qty = (calculation.bottom.quantity).toString()
                        total_cost = (calculation.bottom.price_php).toString()
                        sub_total = (calculation.bottom.subtotal_php).toString()
                    }else {
                        total_qty = (calculation.bottom.quantity).toString()
                        total_cost = (calculation.bottom.price_php).toString()
                        sub_total = (calculation.bottom.subtotal_php).toString()
                    }
                    // Mask cost/price totals when the user lacks the Access Cost ('Z') / price ('Y') right
                    if(!this.accessCostPriceRights.includes('Z')){
                        total_cost = "***"
                    }
                    if((!this.accessCostPriceRights.includes('Z') && (this.productPriceChoice == 'landed_cost' || this.productPriceChoice == 'ordering_cost' || this.productPriceChoice == 'original_cost')) || (!this.accessCostPriceRights.includes('Y') && (this.productPriceChoice == 'retail_price' || this.productPriceChoice == 'wholesale_price'))){
                        sub_total = "***"
                    }
                    if(this.document_config.document_type_settings.printSettings != undefined){
                        if(this.currentDocumentTypeCode == 'ORIPOX' && this.document_config.document_type_settings.printSettings.showStockNoInProductList!=undefined && this.document_config.document_type_settings.printSettings.showStockNoInProductList==true){
                            var supplier_stock_no = this.tabulator.getColumn("supplier_stock_no")
                            await supplier_stock_no.updateDefinition({download:true})
                            if (this.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.enableShowingSupplierStockNumber!=undefined && this.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.enableShowingSupplierStockNumber==true) {
                                this.tabulator.showColumn("supplier_stock_no")
                            }
                        }
                        if(this.document_config.document_type_settings.printSettings.showSerialNoInProductList != undefined && this.document_config.document_type_settings.printSettings.showSerialNoInProductList == true){
                            var supplier_stock_no = this.tabulator.getColumn("document_line_serials_text")
                            await supplier_stock_no.updateDefinition({download:true})
                        }else{
                            var document_line_serials_text = this.tabulator.getColumn("document_line_serials_text")
                            await document_line_serials_text.updateDefinition({download:false})
                        }
                        if(this.document_config.document_type_settings.printSettings.showDesignAndSizeInProductList != undefined && this.document_config.document_type_settings.printSettings.showDesignAndSizeInProductList == true){
                            var design = this.tabulator.getColumn("design")
                            await design.updateDefinition({download:true})
                            var size = this.tabulator.getColumn("size")
                            await size.updateDefinition({download:true})
                        }
                        if(component_x.document_config.document_type_settings.printSettings.enableShowingInitialDepositField!=undefined && component_x.document_config.document_type_settings.printSettings.enableShowingInitialDepositField==true){
                            await this.showDocumentPayment("initialDeposit")
                            initial_deposit = Number(this.documentPaymentsList.reduce(function(prev, cur) { return Number(prev) + Number(cur.amount); }, 0)) || Number(this.documentDetails.reference_7) || 0
                        }
                        if(this.showRefCode!=undefined && this.showRefCode==true){
                            var ref_code = this.tabulator.getColumn("ref_code")
                            await ref_code.updateDefinition({download: true})
                        }

                    }
                }
                var fileFormatter = function(columns, data, options, setFileContents){
                    var self = this,titles = [],fields = [],delimiter = options && options.delimiter ? options.delimiter : ",",
                        fileContents=[],output,main_header = [],second_main_header = [],supplier_header = [],target_date_header = [],
                        cancellation_date_header = [],reference_header = [],currency_header=[],currency_rate_header=[],status_header = [],purpose_header = [],remark_header = [],price_inclusion_and_initial_deposit_header = [],
                        comment1_and_balance = [],comment2_and_total = [],total_count = [],total_qty_row = [],total_cost_row = [],subtotal_row = [],
                        space_line = [],noted_by_row = [],verified_by_row = [],approved_by_row = [],printed_by_row = [],print_date_row = [],
                        post_date_row = [],created_by_row = [],posted_by_row = [];
                    //build column headers
                    function parseTitles() {
                        columns.forEach(function (column) {
                            titles.push(String(column.title).split('"').join('""'));
                            fields.push(column.field);
                        });
                        if(options.nested) {
                            titles.push(String(nestedParentTitle));
                        }
                    }
                    parseTitles();
                    // Cost/price masking for CSV export based on Access Cost ('Z') / price ('Y') rights.
                    var csvNoZ = !component_x.accessCostPriceRights.includes('Z');
                    var csvNoY = !component_x.accessCostPriceRights.includes('Y');
                    var csvPriceChoice = component_x.productPriceChoice;
                    var csvCostFields = ['cost','cost_php','unit_net_cost','landed_cost','old_landed_cost','ordering_cost','old_ordering_cost','original_cost','old_original_cost','markup_percent'];
                    var csvPriceFields = ['retail_price','old_retail_price','wholesale_price','old_wholesale_price','least_price','old_least_price','special_price','old_special_price'];
                    var csvAmbiguousFields = ['price','price_php','price_pi','subtotal','subtotal_php','subtotal_without_vat','total_gross','total_gross_php','unit_price_vat','net_price_vat','subtotal_vat','unit_price_no_vat','price_without_vat'];
                    var csvIsCostChoice = (csvPriceChoice == 'landed_cost' || csvPriceChoice == 'ordering_cost' || csvPriceChoice == 'original_cost');
                    var csvIsPriceChoice = (csvPriceChoice == 'retail_price' || csvPriceChoice == 'wholesale_price');
                    var csvAmbiguousMasked = (csvNoZ && (csvIsCostChoice || (!csvIsCostChoice && !csvIsPriceChoice))) || (csvNoY && csvIsPriceChoice);
                    var maskCsvField = function(field){
                        return (csvNoZ && csvCostFields.indexOf(field) !== -1) ||
                               (csvNoY && csvPriceFields.indexOf(field) !== -1) ||
                               (csvAmbiguousMasked && csvAmbiguousFields.indexOf(field) !== -1);
                    };
                    function parseMainAndRemarkHeader(i){
                        if(i==0){
                            main_header.push(currentSiteName)
                            purpose_header.push("Purpose:")
                            remark_header.push("Remark:")
                            noted_by_row.push("Noted By:")
                            verified_by_row.push("Verified By:")
                            approved_by_row.push("Approved By:")
                        }else if(i==1){
                            purpose_header.push(purpose)
                            remark_header.push(remark)
                        }else if(i == titles.length-1){
                            main_header.push(documentType)
                        }else{
                            main_header.push("")
                            remark_header.push("")
                        }
                    }
                    function parseSecondMainHeader(i) {
                        if(i == titles.length-1){
                            second_main_header.push("# "+String(documentNumber))
                        }else{
                            second_main_header.push("")
                        }
                    }
                    function parseSupplierAndCustomDetailsHeader(i) {
                        if(i==0){
                            supplier_header.push("Supplier:")
                            if(component_x.document_config.document_type_settings.printSettings.enableShowingPriceInclusionField!=undefined && component_x.document_config.document_type_settings.printSettings.enableShowingPriceInclusionField==true){
                                price_inclusion_and_initial_deposit_header.push("Price Inclusion:")
                            }else {
                                price_inclusion_and_initial_deposit_header.push("")
                            }
                            if(component_x.document_config.document_type_settings.printSettings.enableShowingComment1Field!=undefined && component_x.document_config.document_type_settings.printSettings.enableShowingComment1Field==true){
                                comment1_and_balance.push("Comment 1:")
                            }else{
                                comment1_and_balance.push("")
                            }
                            if(component_x.document_config.document_type_settings.printSettings.enableShowingComment2Field!=undefined && component_x.document_config.document_type_settings.printSettings.enableShowingComment2Field==true){
                                comment2_and_total.push("Comment 2:")
                            }else{
                                comment2_and_total.push("")
                            }
                        }else if(i == 1){
                            supplier_header.push(supplier)
                            if(component_x.document_config.document_type_settings.printSettings.enableShowingPriceInclusionField!=undefined && component_x.document_config.document_type_settings.printSettings.enableShowingPriceInclusionField==true){
                                price_inclusion_and_initial_deposit_header.push(priceInclusion)
                            }else {
                                price_inclusion_and_initial_deposit_header.push("")
                            }
                            if(component_x.document_config.document_type_settings.printSettings.enableShowingComment1Field!=undefined && component_x.document_config.document_type_settings.printSettings.enableShowingComment1Field==true){
                                comment1_and_balance.push(comment1)
                            }else{
                                comment1_and_balance.push("")
                            }
                            if(component_x.document_config.document_type_settings.printSettings.enableShowingComment2Field!=undefined && component_x.document_config.document_type_settings.printSettings.enableShowingComment2Field==true){
                                comment2_and_total.push(comment2)
                            }else{
                                comment2_and_total.push("")
                            }
                        }else if(i == titles.length-2){
                            supplier_header.push(currentDocumentTypeFriendlyCode+" Date:")
                            if(component_x.document_config.document_type_settings.printSettings.enableShowingInitialDepositField!=undefined && component_x.document_config.document_type_settings.printSettings.enableShowingInitialDepositField==true){
                                price_inclusion_and_initial_deposit_header.push("Initial Deposit:")
                            }else {
                                price_inclusion_and_initial_deposit_header.push("")
                            }
                            if(component_x.document_config.document_type_settings.printSettings.enableShowingBalanceField!=undefined && component_x.document_config.document_type_settings.printSettings.enableShowingBalanceField==true){
                                comment1_and_balance.push("Balance:")
                            }else {
                                comment1_and_balance.push("")
                            }
                            comment2_and_total.push("Total:")
                        }else if(i == titles.length-1){
                            supplier_header.push(documentDate)
                            if(component_x.document_config.document_type_settings.printSettings.enableShowingInitialDepositField!=undefined && component_x.document_config.document_type_settings.printSettings.enableShowingInitialDepositField==true){
                                price_inclusion_and_initial_deposit_header.push(initial_deposit.toFixed(2))
                            }else {
                                price_inclusion_and_initial_deposit_header.push("")
                            }
                            if(component_x.document_config.document_type_settings.printSettings.enableShowingBalanceField!=undefined && component_x.document_config.document_type_settings.printSettings.enableShowingBalanceField==true){
                                balance = Number(calculation.bottom.subtotal) - Number(initial_deposit)
                                comment1_and_balance.push(balance)
                            }else{
                                comment1_and_balance.push("")
                            }
                            if(calculation != undefined){
                                comment2_and_total.push(((!component_x.accessCostPriceRights.includes('Z') && (component_x.productPriceChoice == 'landed_cost' || component_x.productPriceChoice == 'ordering_cost' || component_x.productPriceChoice == 'original_cost')) || (!component_x.accessCostPriceRights.includes('Y') && (component_x.productPriceChoice == 'retail_price' || component_x.productPriceChoice == 'wholesale_price'))) ? "***" : calculation.bottom.subtotal.toFixed(2))
                            }
                        }else{
                            supplier_header.push("")
                            price_inclusion_and_initial_deposit_header.push("")
                            comment1_and_balance.push("")
                            comment2_and_total.push("")
                        }
                    }
                    function parseOtherDetailsInHeader(i) {
                        if(i == titles.length-1){
                            target_date_header.push(targetDate)
                            cancellation_date_header.push(cancellationDate)
                            reference_header.push(reference)
                            currency_header.push(currencyLabel)
                            currency_rate_header.push(currencyRate)
                            status_header.push(documentStatus)
                        }else if(i == titles.length-2){
                            target_date_header.push("Target Date:")
                            cancellation_date_header.push("Cancellation Date:")
                            reference_header.push("Reference:")
                            currency_header.push("Currency:")
                            currency_rate_header.push("Currency Rate:")
                            status_header.push("Status:")
                        }else{
                            target_date_header.push("")
                            cancellation_date_header.push("")
                            reference_header.push("")
                            currency_header.push("")
                            currency_rate_header.push("")
                            status_header.push("")
                        }
                    }
                    function parseTotalCountRow(i) {
                        if(i==0){
                            total_qty_row.push("Total Quantity:")
                            total_cost_row.push("Total Cost:")
                            subtotal_row.push("Subtotal:")
                            printed_by_row.push("Printed By:")
                            created_by_row.push("Created By:")
                            posted_by_row.push("Posted By:")
                            print_date_row.push("Print Date:")
                            post_date_row.push("Post Date:")
                        }else if(i == 1){
                            total_qty_row.push(total_qty)
                            total_cost_row.push(total_cost)
                            subtotal_row.push(sub_total)
                            printed_by_row.push(userCode)
                            print_date_row.push('"'+String(printDate)+'"')
                            post_date_row.push('"'+String(postDate)+'"')
                            created_by_row.push(createdBy)
                            posted_by_row.push(postedBy)
                        }else{
                            total_qty_row.push("")
                            total_cost_row.push("")
                            subtotal_row.push("")
                            printed_by_row.push("")
                            print_date_row.push("")
                            post_date_row.push("")
                            created_by_row.push("")
                            posted_by_row.push("")
                        }
                    }
                    function parseMainHeader(){
                        for (var i = 0; i < titles.length; i++) {
                            parseMainAndRemarkHeader(i)
                            parseSecondMainHeader(i)
                            parseSupplierAndCustomDetailsHeader(i)
                            parseOtherDetailsInHeader(i)
                            parseTotalCountRow(i)
                            if(titles[i] == "Cost"){
                                total_count.push(total_cost)
                            }else if(titles[i] == "Quantity"){
                                total_count.push(total_qty)
                            }else if(titles[i] == "Subtotal"){
                                total_count.push(sub_total)
                            } else {
                                total_count.push("")
                            }
                            space_line.push("")
                        }
                    }

                    parseMainHeader()
                    fileContents.push(main_header);
                    fileContents.push(second_main_header);
                    fileContents.push(supplier_header);
                    fileContents.push(target_date_header);
                    fileContents.push(cancellation_date_header);
                    fileContents.push(reference_header);
                    fileContents.push(currency_header);
                    fileContents.push(currency_rate_header);
                    fileContents.push(status_header);
                    fileContents.push(purpose_header);
                    fileContents.push(remark_header);
                    fileContents.push(price_inclusion_and_initial_deposit_header);
                    fileContents.push(comment1_and_balance);
                    fileContents.push(comment2_and_total);
                    fileContents.push(space_line);
                    fileContents.push(titles);
                    function parseRows(data,parentValue="") {
                        //generate each row of the table
                        data.forEach(function (row) {
                            var rowData = [];

                            fields.forEach(function (field) {
                                var value = self.getFieldValue(field, row);

                                switch (value === "undefined" ? "undefined" : value) {
                                    case "undefined":
                                    case "null":
                                        value = "";
                                        break;

                                    default:
                                        value = value;
                                }

                                // Mask cost/price cell values when the user lacks the right.
                                if (maskCsvField(field)) {
                                    value = "***";
                                }

                                //escape quotation marks
                                rowData.push('"' + String(value).split('"').join('""') + '"');
                            });

                            if(options.nested) {
                                rowData.push('"' + String(parentValue).split('"').join('""') + '"');
                            }

                            fileContents.push(rowData.join(delimiter));

                            if(options.nested) {
                                if(row._children) {
                                    parseRows(row._children, self.getFieldValue(nestedParentField, row));
                                }
                            }
                        });
                    }
                    parseRows(data);
                    fileContents.push(total_count);
                    fileContents.push(space_line);
                    fileContents.push(total_qty_row);
                    fileContents.push(total_cost_row);
                    fileContents.push(subtotal_row);
                    fileContents.push(space_line);
                    fileContents.push(noted_by_row);
                    fileContents.push(verified_by_row);
                    fileContents.push(approved_by_row);
                    fileContents.push(printed_by_row);
                    fileContents.push(print_date_row);
                    fileContents.push(post_date_row);
                    fileContents.push(created_by_row);
                    fileContents.push(posted_by_row);
                    output = fileContents.join("\n");

                    if (options.bom) {
                        output = "\uFEFF" + output;
                    }

                    setFileContents(output, "text/csv");
                }
                let tabulatorInstance = this.$refs.tabulator.getInstance();
                tabulatorInstance.download(fileFormatter, this.friendlyCodeAndDocumentNo+".csv");
            },
            async onEnterScanner(){
                if(this.document_config != null && this.document_config != undefined){
                    if(this.document_config.document_type_settings.editorBehavior.radio == 'P' || this.document_config.document_type_settings.editorBehavior.radio == 'L'){
                        setTimeout(async function() {
                            if (this.filterExistingProductData.length > 0){
                                var group = {selectedObject:this.filterExistingProductData[0]}
                                    await this.getProduct(group)
                                    await this.addProduct()
                                    this.filterExistingProductData = []
                                    await this.clearProduct()
                            }else {
                                this.$notification['error']({
                                    message: "barcode not found",
                                    description: "Error",
                                    style: getNotificationStyle('error')
                                });
                            }
                        }.bind(this), 600)
                    }
                }
            },
            saveAllocationValidation(index){
                this.siteAllocationErrors = [];
                this.siteAllocationErrors.push(ValidateField.greaterThanZero('Quantity', this.drawerCurrentSiteAllocation[index].temp_quantity));
                this.siteAllocationErrors.push(ValidateField.required('Quantity', this.drawerCurrentSiteAllocation[index].temp_quantity));
                this.siteAllocationErrors = this._.compact(this.siteAllocationErrors);
                return this.siteAllocationErrors.length;
            },
            async saveAllocation(index){
                if(!this.saveAllocationValidation(index)){
                    var total_site_quantity = this.drawerCurrentSiteAllocation.reduce((a, {quantity}) => a + parseInt(quantity), 0);
                    if (((Number(total_site_quantity)+Number(this.drawerCurrentSiteAllocation[index].temp_quantity))-Number(this.drawerCurrentSiteAllocation[index].quantity)) > this.selectedSiteAllocationProduct.quantity){
                        this.drawerCurrentSiteAllocation[index].temp_quantity = 0
                        this.isEditAllocation=true
                        this.siteAllocationErrors.push('You have exceeded the maximum allowed quantity: '+ this.selectedSiteAllocationProduct.quantity)
                    }else{
                        this.isEditAllocation=false
                        this.drawerCurrentSiteAllocation[index].quantity = this.drawerCurrentSiteAllocation[index].temp_quantity
                        total_site_quantity = this.drawerCurrentSiteAllocation.reduce((a, {quantity}) => a + parseInt(quantity), 0);
                    }
                    this.siteAllocationRemainingQuantity = Number(this.selectedSiteAllocationProduct.quantity) - Number(total_site_quantity)
                }
            },
            editAllocation(index){
                this.isEditAllocation=true
                this.drawerCurrentSiteAllocation[index].temp_quantity = this.drawerCurrentSiteAllocation[index].quantity
                this.isEditAllocationIndex = index
            },
            beforeUploadWithAllocation(file) {
                const reader = new FileReader()
                reader.onload = e => {
                    this.massAddWithAllocationProductErrors = []
                    var text = e.target.result;
                    var skulist = [];
                    var qtylist = [];
                    var workbook = XLSX.read(text, {type: 'array'})
                    let sheetName = workbook.SheetNames[0]
                    let worksheet = workbook.Sheets[sheetName]
                    var lines = XLSX.utils.sheet_to_json(worksheet,{defval: '', blankrows: true })

                    if(lines.length - 1 > this.maxLines)
                        this.massAddProductErrors.push('Total lines exceeded.  Please only upload up to ' + this.maxLines + ' lines.')

                    for(var i = 0; i < lines.length; i++) {
                        let filteredObj = this.objectWithoutProperties(lines[i],['Line No','Stock No','Description','Barcode','Unit','Quantity','Cost','Subtotal','Serial No','Lottable 1','Lottable 2','Lottable 3'])
                        let totalqtyAllocation = Object.keys(filteredObj).reduce((sum,key)=>sum+parseFloat(filteredObj[key]||0),0)
                        totalqtyAllocation = parseFloat(totalqtyAllocation.toFixed(10))
                        if (lines[i]["Quantity"] < totalqtyAllocation)
                            this.massAddWithAllocationProductErrors.push('Total allocated quantity:'+`${totalqtyAllocation}`+' > Maximum Quantity:'+`${lines[i]["Quantity"]}`+' for barcode number: '+`${lines[i]["Barcode"]}.`)

                        if(typeof lines[i]["Quantity"] === 'string')
                            qtylist.push(parseFloat(lines[i]["Quantity"]))
                        else
                            qtylist.push(parseFloat(lines[i]["Quantity"]) || 0)

                        skulist.push(lines[i]["Barcode"])
                    }
                    // Get duplicate sku's/barcode
                    const findDuplicates = (skulist) => {
                        let sorted_arr = skulist.slice().sort();
                        let results = [];
                        for (let i = 0; i < sorted_arr.length - 1; i++) {
                            if (sorted_arr[i + 1] == sorted_arr[i]) {
                                results.push(sorted_arr[i]);
                            }
                        }
                        return results;
                    }
                    // Result duplicate sku's/barcode -> download list
                    if(findDuplicates(skulist).length > 0  && this.document_config.document_type_settings.editorBehavior.radio != "L") {
                        // this.massAddWithAllocationProductErrors.push('With duplicate Barcodes');
                        const key = 'dup-barcode-warning';
                        this.$notification['warning']({
                            key,
                            message: 'Warning',
                            description: "Duplicate barcode(s) found in the uploaded file. This will override existing entries with the last occurrence. Would you like to continue?",
                            style: getNotificationStyle('warning'),
                            btn: h => {
                                return h(
                                'div',
                                { style: 'display: flex; gap: 8px;' },
                                [
                                    h(
                                    'base-button',
                                    {
                                        props: {
                                        type: 'primary',
                                        class: 'btn-sm',
                                        },
                                        on: {
                                        click: () => {
                                            // Yes clicked — do nothing special, just close notification
                                            this.$notification.close(key); 
                                        }
                                        }
                                    },
                                    'Yes'
                                    ),
                                    h(
                                    'base-button',
                                    {
                                        props: {
                                        type: 'danger',
                                        class: 'btn-sm',
                                        },
                                        on: {
                                        click: () => {
                                            this.closeDrawer('massAddWithAllocation')
                                            this.fileWithAllocationList = []
                                            this.$notification.close(key);
                                            this.$notification.info({
                                                message: 'Request Blocked',
                                                description: 'Upload cancelled due to duplicate barcodes.',
                                                style: getNotificationStyle('info'),
                                            });
                                            
                                        }
                                        }
                                    },
                                    'No'
                                    )
                                ]
                                );
                            }
                        });
                    }

                    // Get 0 / - quantity
                    const zQty = qtylist.filter(qty => {
                        if(isNaN(qty))
                            return true
                        else
                            return qty <= 0
                    });
                    if(zQty.length > 0){
                        this.massAddWithAllocationProductErrors.push('All quantities must be POSITIVE numbers and no blanks/characters.');
                    }
                    // Get blank skus
                    const bSku = skulist.filter(sku => sku.length < 1);
                    // Result blank skus
                    if(bSku.length > 0)
                        this.massAddWithAllocationProductErrors.push('File has blank lines that generate rows with no data but with a comma.');

                    // Proceed validating if barcodes are valid
                    if(this.massAddWithAllocationProductErrors.length < 1){
                        this.spinning = true;
                        if(this.validationdocutypes.includes(this.currentDocumentTypeCode) && this.filterBySupp)
                            this.getSuppItems(skulist)
                        else
                            this.spinning = false;

                        this.fileWithAllocationList = [...this.fileWithAllocationList, file];
                    }
                    this.massAddWithAllocationProductErrors = this._.compact(this.massAddWithAllocationProductErrors);
                }
                reader.readAsArrayBuffer(file);
                this.spinning = false;
                return false;
            },
            objectWithoutProperties(obj, keys){
                var target = {};
                for (var i in obj) {
                    if (keys.indexOf(i) >= 0) continue;
                    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
                    target[i] = obj[i];
                }
                return target;
            },
            async importWithAllocationFile(){
                var bodyFormData = new FormData();
                bodyFormData.append('file', this.fileWithAllocationList[0])
                this.xlsxUploadFormData = bodyFormData
                this.documentStatus = 'Uploading';
                this.processingXlsxUpload = true
                try {
                    if (this.documentNumber > 1) {
                        await this.update();
                    } else {
                        await this.save();
                    }
                } finally {
                    this.processingXlsxUpload = false;
                    this.closeDrawer('massAddWithAllocation');
                }
                return false;
            },
            async viewSiteAllocation(){
                this.viewAllocation = true
                this.documentLines = this.tabulator.getData();
            },
            async getMinMaxProducts(){
                this.spinning = true
                var site_id = this.requestingSite.key;
                var supplier_id = 0;
                if(this.currentDocumentTypeCode == 'ORIPOX'){
                    if (this.supplier.key == undefined || this.supplier.key == '' || this.supplier.key < 1) {
                        component_x.$notification['error']({
                            message: 'Auto-Rep (Min/Max)',
                            description: "Supplier is required.",
                            style: getNotificationStyle('error')
                        });
                        this.spinning = false
                        return
                    } else {
                        supplier_id = this.supplier.key
                    }
                }

                var minmax_products = await HTTPRequest.getRequest(this.endPoint + '/products/get_minmax_products?site_id=' + site_id + '&document_type=' + this.currentDocumentTypeCode + '&supplier_id=' + supplier_id + '&include_it=' + this.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.includeInTransitForMinMaxAutoRep);
                this.spinning = false

                if(minmax_products.length > 0){
                    this.minMaxProducts = minmax_products;
                    this.modalMinMaxProducts = true;
                    if(this.tabulator.getRows().length > 0)
                        this.overrideMinMaxProducts = 'And this will override the items added in this document.'
                } else {
                    component_x.$notification['error']({
                        message: 'Auto-Rep (Min/Max)',
                        description: "No products for min/max replenishment for the selected supplier.",
                        style: getNotificationStyle('error')
                    });
                    return
                }

            },
            async getOffTakeProducts(){
                this.spinning = true
                var site_id = this.requestingSite.key;
                var supplier_id = 0;
                if(this.currentDocumentTypeCode == 'ORIPOX'){
                    if (this.supplier.key == undefined || this.supplier.key == '' || this.supplier.key < 1) {
                        component_x.$notification['error']({
                            message: 'Auto-Rep (By Offtake)',
                            description: "Supplier is required.",
                            style: getNotificationStyle('error')
                        });
                        this.spinning = false
                        return
                    } else {
                        supplier_id = this.supplier.key
                    }
                }

                var offtake_products = await HTTPRequest.getRequest(this.endPoint + '/products/get_offtake_products?site_id=' + site_id + '&document_type=' + this.currentDocumentTypeCode + '&supplier_id=' + supplier_id + '&include_it=' + this.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.includeInTransitForMinMaxAutoRep + '&offtake_days=' + this.offtakeDays);
                this.spinning = false

                if(offtake_products.length > 0){
                    this.offtakeProducts = offtake_products;
                    this.modalOffTakeProducts = true;
                    if(this.tabulator.getRows().length > 0)
                        this.overrideOfftakeProducts = 'And this will override the items added in this document.'
                } else {
                    component_x.$notification['error']({
                        message: 'Auto-Rep (By Offtake)',
                        description: "No products for "+ this.offtakeDays +" days offtake-based replenishment for the selected supplier.",
                        style: getNotificationStyle('error')
                    });
                    return
                }
            },

            async exportWithAllocationDocumentFormatted() {
                try {
                    const allocation = await HTTPRequest.getRequest(
                        this.endPoint + 'documents/' + this.documentNumber + '/export_allocation_formatted'
                    );

                    console.log("REQUEST OK:", allocation);
                    console.log("NOTIF:", this.$notification);

                    this.$notification['success']({
                                            message: 'Successful Operation',
                                            description: "Export has been added to Job Monitoring. Check the ongoing jobs for status update.",
                                            style: getNotificationStyle('success'),
                                            btn: h => {
                                                return h(
                                                'base-button',
                                                {
                                                    props: {
                                                    type: 'primary',
                                                    class: 'btn-sm',
                                                    },
                                                    on: {
                                                    click: () => component_x.$router.push("/jobs"),
                                                    },
                                                },
                                                'View Jobs',
                                                );
                                            },
                                        });

                } catch (error) {
                    console.error("ERROR:", error);

                }
            },

            async exportWithAllocationDocument(){
                let formattedLines = []
                let lines = this.tabulator.getData()
                for(var i = 0; i < lines.length; i++) {
                    let formatLine = {
                        'Line No': lines[i].line_no,
                        'Stock No': lines[i].stock_no,
                        'Description': lines[i].product_name,
                        'Barcode': lines[i].barcode,
                        'Unit': lines[i].unit_label,
                        'Quantity': lines[i].quantity,
                        'Cost': (!this.accessCostPriceRights.includes('Z')) ? "***" : lines[i].cost,
                        'Subtotal': (((!this.accessCostPriceRights.includes('Z') && (this.productPriceChoice == 'landed_cost' || this.productPriceChoice == 'ordering_cost' || this.productPriceChoice == 'original_cost')) || (!this.accessCostPriceRights.includes('Y') && (this.productPriceChoice == 'retail_price' || this.productPriceChoice == 'wholesale_price')))) ? "***" : lines[i].subtotal,
                        'Serial No': lines[i].document_line_serials_text
                    }
                    if (lines[i].site_allocation!=undefined && lines[i].site_allocation!=null){
                        lines[i].site_allocation.forEach(function(obj) {
                            if (component_x.currentDocumentTypeCode=='OTHPCK'){
                                var qty = (obj.available_quantity == obj.quantity) ? '' : obj.available_quantity
                                // formatLine[' '+`${obj.code}`] = qty
                            }else{
                                var qty = (obj.quantity == 0) ? '' : obj.quantity
                                // formatLine[' '+`${obj.code}`] = qty
                            }

                            if(component_x.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.AllocationDefaultValue == 'SC'){
                                formatLine[' '+`${obj.code}`] = qty
                            } else {
                                formatLine[' '+`${obj.refcode}`] = qty
                            }
                        });
                    }
                    formattedLines.push(formatLine)
                }
                var dataWS = XLSX.utils.json_to_sheet(formattedLines)
                var wb = XLSX.utils.book_new()
                XLSX.utils.book_append_sheet(wb, dataWS, this.currentDocumentTypeFriendlyCodeWithId)
                XLSX.writeFile(wb, this.friendlyCodeAndDocumentNo+".xlsx")
            },
            async downLoadExcelIfMoreThan5Site(){
                var wb = XLSX.utils.book_new()
                var documentType = this.currentDocumentTypeName || ''
                var currentSiteName = secureStorage.getItem("defaultSiteName") || '';
                var userCode = secureStorage.getItem("userCode") || '';
                var documentDate = this.documentDate.format('D-MMM-YYYY') || ''
                var targetDate = this.targetDate.format('D-MMM-YYYY') || ''
                var cancellationDate = this.cancellationDate.format('D-MMM-YYYY') || ''
                var currentDocumentTypeFriendlyCode = this.currentDocumentTypeFriendlyCode || ''
                var documentStatus = this.documentStatus || ''
                var documentNumber = this.documentNo || ''
                var reference = this.reference || ''
                var remark = this.remark || ''
                var purpose = this.purpose.label || ''
                var printDate = moment().format('lll') || '';
                var postDate = this.postDate || ''
                let currencyKey = component_x.currency.key;
                let tabulatorInstance = this.$refs.tabulator.getInstance();
                var calculation = tabulatorInstance.getCalcResults();
                let formattedLines = []
                var lines = this.tabulator.getData();
                for(var i = 0; i < lines.length; i++) {
                    let formatLine = {
                        'Line No': lines[i].line_no,
                        'Stock No': lines[i].stock_no,
                        'Description': lines[i].product_name,
                        'Barcode': lines[i].barcode,
                        'Unit': lines[i].unit_label,
                        'Quantity': lines[i].quantity,
                        'Cost': (!this.accessCostPriceRights.includes('Z')) ? "***" : lines[i].cost,
                        'Subtotal': (((!this.accessCostPriceRights.includes('Z') && (this.productPriceChoice == 'landed_cost' || this.productPriceChoice == 'ordering_cost' || this.productPriceChoice == 'original_cost')) || (!this.accessCostPriceRights.includes('Y') && (this.productPriceChoice == 'retail_price' || this.productPriceChoice == 'wholesale_price')))) ? "***" : lines[i].subtotal,
                        'Serial No': lines[i].document_line_serials_text
                    }
                    if (lines[i].site_allocation!=undefined && lines[i].site_allocation!=null){
                        lines[i].site_allocation.forEach(function(obj) {
                            if (component_x.currentDocumentTypeCode=='OTHPCK'){
                                var qty = (obj.available_quantity == 0 || obj.available_quantity == undefined) ? obj.quantity : obj.available_quantity
                                // formatLine[' '+`${obj.code}`] = qty
                            }else{
                                var qty = (obj.quantity == 0) ? '' : obj.quantity
                                // formatLine[' '+`${obj.code}`] = qty
                            }

                            if(component_x.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.AllocationDefaultValue == 'SC'){
                                formatLine[' '+`${obj.code}`] = qty
                            } else {
                                formatLine[' '+`${obj.refcode}`] = qty
                            }
                        });
                    }
                    formattedLines.push(formatLine)
                }
                var lineCount = parseInt(formattedLines.length)
                // Mask cost/price totals when the user lacks the Access Cost ('Z') / price ('Y') right
                var maskCostTotal = !this.accessCostPriceRights.includes('Z')
                var maskSubtotal = (!this.accessCostPriceRights.includes('Z') && (this.productPriceChoice == 'landed_cost' || this.productPriceChoice == 'ordering_cost' || this.productPriceChoice == 'original_cost')) || (!this.accessCostPriceRights.includes('Y') && (this.productPriceChoice == 'retail_price' || this.productPriceChoice == 'wholesale_price'))
                var dataWS = XLSX.utils.sheet_add_json(wb.Sheets.sheet1,formattedLines,{origin: "A12"})
                XLSX.utils.sheet_add_aoa(dataWS,[[currentSiteName,"","","","","","","",documentType]],{origin: "A1"});
                XLSX.utils.sheet_add_aoa(dataWS,[["","","","","","","","","# "+String(documentNumber)]],{origin: "A2"});
                XLSX.utils.sheet_add_aoa(dataWS,[["","","","","","","","",currentDocumentTypeFriendlyCode+" Date:",documentDate]],{origin: "A3"});
                XLSX.utils.sheet_add_aoa(dataWS,[["","","","","","","","","Target Date:",targetDate]],{origin: "A4"});
                XLSX.utils.sheet_add_aoa(dataWS,[["","","","","","","","","Cancellation Date:",cancellationDate]],{origin: "A5"});
                XLSX.utils.sheet_add_aoa(dataWS,[["","","","","","","","","Reference:",reference]],{origin: "A6"});
                XLSX.utils.sheet_add_aoa(dataWS,[["","","","","","","",""]],{origin: "A7"});
                XLSX.utils.sheet_add_aoa(dataWS,[["Purpose",purpose,"","","","","","","Status:",documentStatus]],{origin: "A8"});
                XLSX.utils.sheet_add_aoa(dataWS,[["Remark:",remark,"","","","","",""]],{origin: "A9"});
                XLSX.utils.sheet_add_aoa(dataWS,[["","","","","","","","","Total:",maskSubtotal ? "***" : calculation.bottom.subtotal.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")]],{origin: "A10"});
                XLSX.utils.sheet_add_aoa(dataWS,[["","","","","","","",""]],{origin: "A11"});
                XLSX.utils.sheet_add_aoa(dataWS,[["Total Quantity:",(calculation.bottom.quantity).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),"","",""]],{origin: "A"+`${lineCount+17}`});
                if(currencyKey>0 && component_x.showConversionRate){
                    XLSX.utils.sheet_add_aoa(dataWS,[["Total Cost:",maskCostTotal ? "***" : (calculation.bottom.price_php).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","),"","",""]],{origin: "A"+`${lineCount+18}`});
                    XLSX.utils.sheet_add_aoa(dataWS,[["Subtotal:",maskSubtotal ? "***" : (calculation.bottom.subtotal_php).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","),"","",""]],{origin: "A"+`${lineCount+19}`});
                }else{
                    XLSX.utils.sheet_add_aoa(dataWS,[["Total Cost:",maskCostTotal ? "***" : (calculation.bottom.price).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","),"","",""]],{origin: "A"+`${lineCount+18}`});
                    XLSX.utils.sheet_add_aoa(dataWS,[["Subtotal:",maskSubtotal ? "***" : (calculation.bottom.subtotal).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","),"","",""]],{origin: "A"+`${lineCount+19}`});
                }
                XLSX.utils.sheet_add_aoa(dataWS,[["Noted By:","____________________________________","","",""]],{origin: "A"+`${lineCount+21}`});
                XLSX.utils.sheet_add_aoa(dataWS,[["Verified By:","____________________________________","","",""]],{origin: "A"+`${lineCount+22}`});
                XLSX.utils.sheet_add_aoa(dataWS,[["Approved By:","____________________________________","","",""]],{origin: "A"+`${lineCount+23}`});
                XLSX.utils.sheet_add_aoa(dataWS,[["","","","","",""]],{origin: "A"+`${lineCount+24}`});
                XLSX.utils.sheet_add_aoa(dataWS,[["Printed By:",userCode,"","","",""]],{origin: "A"+`${lineCount+25}`});
                XLSX.utils.sheet_add_aoa(dataWS,[["Print Date:",printDate,"","","",""]],{origin: "A"+`${lineCount+26}`});
                XLSX.utils.sheet_add_aoa(dataWS,[["Post Date:",postDate,"","","",""]],{origin: "A"+`${lineCount+27}`});
                XLSX.utils.book_append_sheet(wb, dataWS, this.currentDocumentTypeFriendlyCodeWithId)
                XLSX.writeFile(wb, this.friendlyCodeAndDocumentNo+".xlsx")
            },
            async changeCostBySupplier(){
                this.spinning = true
                this.confirmLoadingonSuppModal = true
                let items = this.tabulator.getData();
                let newItems = []
                this.sumSubtotal = 0
                for(let i = 0; i < items.length; i++){
                    let item = items[i]
                    this.sumSubtotal = this.sumSubtotal + Number(item.subtotal)
                }

                for(let i = 0; i < items.length; i++){
                   let item = items[i]
                   let product_id = item.product_id
                   let  supp_id = this.supplier.key
                   if(item.product_type == "I"){
                       product_id = item.matrix_parent_id
                   }

                   // should it change if wala sya na kita sa dating ordering cost from api or not?
                   var product = await HTTPRequest.getRequest(this.endPoint + 'products/' + product_id + '?supplier_id=' + supp_id)
                   if(product != null){
                       if(product.supplier_product_ordering_cost > 0 && this.productPriceChoice == 'ordering_cost'){
                           item.cost = Number(product.supplier_product_ordering_cost).toFixed(this.fixedDecimalPlaces)
                           item.price = Number(product.supplier_product_ordering_cost).toFixed(this.fixedDecimalPlaces)
                           item.subtotal = Number(product.supplier_product_ordering_cost).toFixed(this.fixedDecimalPlaces) * item.quantity
                           let distributedOverallDiscount = 0
                            if (Number(item.subtotal) != 0 || this.sumSubtotal != 0 || this.overallDiscount != 0){
                                distributedOverallDiscount = this.overallDiscount * (Number(item.subtotal) / this.sumSubtotal)
                            }
                           console.log("distOverallDisc", distributedOverallDiscount)
                           let subtotal_less_overall_discount = Number(item.subtotal) - Number(distributedOverallDiscount)
                           //2370
                           if(this.party_tax_type == 'V' || this.party_tax_type == undefined){
                                if(product.vat_type == 'V'){
                                    item.subtotal_without_vat = (subtotal_less_overall_discount/ (1+Number(this.taxRate))).toFixed(this.fixedDecimalPlaces)
                                    item.price_without_vat = (Number(item.price)/ (1+Number(this.taxRate))).toFixed(this.fixedDecimalPlaces)
                                    item.tax_amount = (subtotal_less_overall_discount - item.subtotal_without_vat).toFixed(this.fixedDecimalPlaces)
                                } else {
                                    item.subtotal_without_vat = (subtotal_less_overall_discount).toFixed(this.fixedDecimalPlaces)
                                    item.price_without_vat = (Number(item.price)).toFixed(this.fixedDecimalPlaces)
                                    item.tax_amount = 0
                                }
                           } else {
                                item.subtotal_without_vat = (subtotal_less_overall_discount).toFixed(this.fixedDecimalPlaces)
                                item.price_without_vat = (Number(item.price)).toFixed(this.fixedDecimalPlaces)
                                item.tax_amount = 0
                           }
                           
                        }else{
                           var site_id = secureStorage.getItem("defaultSiteId");
                           let product_id
                           if(item.matrix_parent_id == null){
                               product_id = item.product_id
                           }else{
                               product_id = item.matrix_parent_id
                           }

                           let order_cost
                           var site_product = await HTTPRequest.getRequest(this.endPoint + '/site_products/get_site_product?product_id=' + product_id + '&site_id=' + site_id);
                           if(site_product != null){
                               var siteUnitCost = eval('site_product.'+this.productPriceChoice)
                               if(siteUnitCost != null && siteUnitCost > 0){
                                   order_cost = Number(siteUnitCost).toFixed(this.decimalPlaces)
                               }else{
                                   var cost = eval('product.'+this.productPriceChoice)
                                   order_cost = Number(cost).toFixed(this.decimalPlaces)
                               }
                           }
                           item.cost = Number(order_cost).toFixed(this.fixedDecimalPlaces)
                           item.price = Number(order_cost).toFixed(this.fixedDecimalPlaces)
                           item.subtotal = Number(order_cost).toFixed(this.fixedDecimalPlaces) * item.quantity
                           let distributedOverallDiscount = 0
                            if (Number(item.subtotal) != 0 || this.sumSubtotal != 0 || this.overallDiscount != 0){
                                distributedOverallDiscount = this.overallDiscount * (Number(item.subtotal) / this.sumSubtotal)
                            }
                           console.log("distOverallDisc", distributedOverallDiscount)
                           let subtotal_less_overall_discount = Number(item.subtotal) - Number(distributedOverallDiscount)
                           //2370
                           if(this.party_tax_type == 'V' || this.party_tax_type == undefined){
                                if(product.vat_type == 'V'){
                                    item.subtotal_without_vat = (subtotal_less_overall_discount/ (1+Number(this.taxRate))).toFixed(this.fixedDecimalPlaces)
                                    item.price_without_vat = (Number(item.price)/ (1+Number(this.taxRate))).toFixed(this.fixedDecimalPlaces)
                                    item.tax_amount = (subtotal_less_overall_discount - item.subtotal_without_vat).toFixed(this.fixedDecimalPlaces)
                                } else {
                                    item.subtotal_without_vat = (subtotal_less_overall_discount).toFixed(this.fixedDecimalPlaces)
                                    item.price_without_vat = (Number(item.price)).toFixed(this.fixedDecimalPlaces)
                                    item.tax_amount = 0
                                }
                           } else {
                                item.subtotal_without_vat = (subtotal_less_overall_discount).toFixed(this.fixedDecimalPlaces)
                                item.price_without_vat = (Number(item.price)).toFixed(this.fixedDecimalPlaces)
                                item.tax_amount = 0
                           }
                       }
                       newItems.push(item)
                   }
                }
                console.log(newItems)
                await this.tabulator.updateData(newItems)
                this.confirmLoadingonSuppModal = false
                this.spinning = false
                this.showChangeSupplierModal = false
            },
            async handleSearchDrawerSites(value) {
                if (value == undefined) value = ''
                this.drawerSites = await HTTPRequest.getRequest(this.endPoint + 'sites/get_valid_document_sites?name='+value, null)
            },
            async getSettings(){
                let AccountSettings = await HTTPRequest.getRequest(this.endPoint + 'settings?code=accountSettings&status=A', null)
                if(AccountSettings.length > 0){
                    let as = JSON.parse(AccountSettings[0].value)
                    let printFontSize = as.printSettingsFontSizePTPM
                    if(printFontSize != null){
                        this.printFontSizeIncrease = printFontSize
                    }
                    let valueHeaderPos = as.printSettingsValueHeaderPos
                    if(valueHeaderPos != null){
                        this.printValueHeaderPos = valueHeaderPos
                    }
                    let valueFooterPos = as.printSettingsValueFooterPos
                    if(valueFooterPos != null){
                        this.printValueFooterPos = valueFooterPos
                    }
                    let printPaperSize = as.printSettingsPaperSizePTPM
                    if(printPaperSize != null){
                        this.printPaperSize = printPaperSize
                    }
                    // console.log(AccountSettings[0].value.userPasswordFormatStrict,AccountSettings[0].value[:userPasswordFormatStrict])
                    // if(AccountSettings[0].value.userPasswordFormatStrict!=null){
                    // }
                }
            },
            updateValueOfSupplierCurrency(){
                if (this.supplierCurrencyRate!=this.supplierDetails.currency_rate){
                    this.supplierCurrencyRate = this.supplierDetails.currency_rate
                }
                if (this.supplierCurrencyId!=this.supplierDetails.currency_id){
                    this.supplierCurrencyId = this.supplierDetails.currency_id
                }
                if (this.currencyDetails.key == this.supplierCurrencyId){
                    this.currencyRate = this.supplierCurrencyRate
                }
            },
            costFormatter(cell){return "***"},
            // Returns a Set of 0-based print-column indexes whose values must be
            // masked ("***") because the user lacks the Access Cost ('Z') and/or
            // price ('Y') right. This is field-name based (robust to column
            // reordering / added columns) instead of masking the last N columns.
            getPrintCostMaskColumnIndexes(tabulatorInstance){
                var maskIndexes = new Set();
                try {
                    var instance = tabulatorInstance || (this.$refs.tabulator ? this.$refs.tabulator.getInstance() : this.tabulator);
                    if (!instance) return maskIndexes;

                    var noZ = !this.accessCostPriceRights.includes('Z');
                    var noY = !this.accessCostPriceRights.includes('Y');
                    if (!noZ && !noY) return maskIndexes;

                    var priceChoice = this.productPriceChoice;

                    // Cost/price monetary line fields that can appear in the printout.
                    // Includes the PHP display variants that the download swaps in
                    // when showConversionRate is enabled.
                    var costFields = [
                        'cost', 'cost_php', 'unit_net_cost',
                        'landed_cost', 'old_landed_cost',
                        'ordering_cost', 'old_ordering_cost',
                        'original_cost', 'old_original_cost',
                        'markup_percent'
                    ];
                    // Concrete PRICE columns: always hidden when the user lacks the price right ('Y').
                    var priceFields = [
                        'price', 'price_php', 'price_pi',
                        'retail_price', 'old_retail_price',
                        'wholesale_price', 'old_wholesale_price',
                        'least_price', 'old_least_price',
                        'special_price', 'old_special_price'
                    ];
                    // Ambiguous "unit price / subtotal" columns whose meaning depends on the
                    // document's price/cost choice (cost-type doc -> gated by 'Z', price-type doc -> 'Y').
                    var ambiguousFields = [
                        'price', 'price_php', 'price_pi',
                        'subtotal', 'subtotal_php', 'subtotal_without_vat',
                        'total_gross', 'total_gross_php',
                        'unit_price_vat', 'net_price_vat', 'subtotal_vat',
                        'unit_price_no_vat', 'price_without_vat'
                    ];
                    var isCostChoice = (priceChoice == 'landed_cost' || priceChoice == 'ordering_cost' || priceChoice == 'original_cost');
                    var isPriceChoice = (priceChoice == 'retail_price' || priceChoice == 'wholesale_price');
                    // Default: if choice is not recognized, treat ambiguous columns as cost-based
                    // (procurement documents) so cost is never accidentally exposed.
                    var ambiguousMasked = (noZ && (isCostChoice || (!isCostChoice && !isPriceChoice))) || (noY && isPriceChoice);

                    // Rebuild the exact ordered list of columns the PDF exporter uses.
                    // Mirrors Tabulator Download.processColumns: field present,
                    // definition.download !== false, and (visible OR (hidden && download)).
                    var printIndex = 0;
                    instance.getColumns().forEach(function(column){
                        var def = column.getDefinition() || {};
                        var field = column.getField();
                        if (!field) return;
                        var isVisible = column.getVisibility();
                        var included = (def.download !== false) && (isVisible || (!isVisible && def.download));
                        if (!included) return;

                        var maskThis = false;
                        if (noZ && costFields.indexOf(field) !== -1) {
                            maskThis = true;
                        } else if (noY && priceFields.indexOf(field) !== -1) {
                            maskThis = true;
                        } else if (ambiguousMasked && ambiguousFields.indexOf(field) !== -1) {
                            maskThis = true;
                        }

                        if (maskThis) maskIndexes.add(printIndex);
                        printIndex++;
                    });
                } catch (error) {
                    // Fail safe: if anything goes wrong, return whatever was collected.
                }
                return maskIndexes;
            },
            // Returns the 0-based print-column index for a tabulator field,
            // mirroring the same column-inclusion logic the PDF exporter uses
            // (Download.processColumns: field present, definition.download !== false,
            // and visible OR hidden-but-download). Returns -1 when none of the
            // fields are part of the printout.
            //
            // `fieldName` accepts a single field or an array of candidates in
            // priority order, which is needed because the same logical column can
            // print under different fields depending on configuration (e.g. the
            // "Unit Cost" column is `price`, or `price_php` when a conversion rate
            // is shown). Used to align footer column totals to the actual rendered
            // columns instead of relying on hardcoded x positions.
            getPrintColumnIndexByField(tabulatorInstance, fieldName){
                try {
                    var instance = tabulatorInstance || (this.$refs.tabulator ? this.$refs.tabulator.getInstance() : this.tabulator);
                    if (!instance) return -1;
                    var candidates = Array.isArray(fieldName) ? fieldName : [fieldName];
                    var printIndex = 0;
                    var indexByField = {};
                    instance.getColumns().forEach(function(column){
                        var def = column.getDefinition() || {};
                        var field = column.getField();
                        if (!field) return;
                        var isVisible = column.getVisibility();
                        var included = (def.download !== false) && (isVisible || (!isVisible && def.download));
                        if (!included) return;
                        if (indexByField[field] === undefined) indexByField[field] = printIndex;
                        printIndex++;
                    });
                    for (var i = 0; i < candidates.length; i++) {
                        if (indexByField[candidates[i]] !== undefined) return indexByField[candidates[i]];
                    }
                    return -1;
                } catch (error) {
                    return -1;
                }
            },
            accessRightsMaskValidation(value){
                if((!this.accessCostPriceRights.includes('Z') && (this.productPriceChoice =='landed_cost' || this.productPriceChoice == 'ordering_cost' || this.productPriceChoice == 'original_cost')) || (!this.accessCostPriceRights.includes('Y') && (this.productPriceChoice =='retail_price' || this.productPriceChoice =='wholesale_price'))){
                    try {
                        return value.replace(/\d/g,"*")
                    } catch (error) {
                        return "***" 
                    }
                }else{
                    return value
                }
            },
            accessRightsDisableValidation(){
                if((!this.accessCostPriceRights.includes('B') && (this.productPriceChoice =='landed_cost' || this.productPriceChoice == 'ordering_cost' || this.productPriceChoice == 'original_cost')) || (!this.accessCostPriceRights.includes('F')&& (this.productPriceChoice =='retail_price' || this.productPriceChoice =='wholesale_price'))){
                    return true
                }else{
                    return false
                }
            },
            priceInputTypeAccessRights(){
                if(!this.accessCostPriceRights.includes('Y')){
                    return 'password'
                }else{
                    return ''
                }
            },
            costInputTypeAccessRights(){
                if(!this.accessCostPriceRights.includes('Z')){
                    return 'password'
                }else{
                    return ''
                }
            },
            disablePriceAccessRightsValidation(){
                if(!this.accessCostPriceRights.includes('F')){
                    return true
                }else{
                    return false
                }
            },
            disableCostAccessRightsValidation(){
                if(!this.accessCostPriceRights.includes('B')){
                    return true
                }else{
                    return false
                }
            },
            accessRightsInputTypeValidation(){
                if((!this.accessCostPriceRights.includes('Z') && (this.productPriceChoice =='landed_cost' || this.productPriceChoice == 'ordering_cost' || this.productPriceChoice == 'original_cost')) || (!this.accessCostPriceRights.includes('Y')&& (this.productPriceChoice =='retail_price' || this.productPriceChoice =='wholesale_price'))){
                    return 'password'
                }else{
                    return ''
                }
            },
            renderColumnFields() {
                // console.log("renderColumnFields function")
                // console.log(this.filteredColumnFields)
                this.filteredColumnFields.map(({ name, value }) => {

                // console.log("Processing for :: " + name)
                // console.log("Value is :: " + value )
                // console.log("--------")

                if (value) {
                  if (this.currentDocumentTypeCode === 'ORIPOX') {
                      if (name === "actual_quantity") this.tabulator.getColumn(name).updateDefinition({ title: "Received Quantity" });
                      if (name === "balance_quantity") this.tabulator.getColumn(name).updateDefinition({ title: "Balance Quantity" });
                      // Label the unit column based on the document's price/cost choice
                      // (cost-type -> "Unit Cost", price-type -> "Unit Price") to match the masked value.
                      if (name === "price") {
                          var isUnitCostChoiceRcf = (this.productPriceChoice == 'landed_cost' || this.productPriceChoice == 'ordering_cost' || this.productPriceChoice == 'original_cost');
                          this.tabulator.getColumn(name).updateDefinition({ title: isUnitCostChoiceRcf ? "Unit Cost" : "Unit Price" });
                      }
                  }
  
                  if (this.currentDocumentTypeCode === 'OTHUPC' || this.currentDocumentTypeCode === 'OTHPCN') {
                      if (name === "actual_quantity") this.tabulator.getColumn(name).updateDefinition({ title: "Frozen Quantity" });
                  }

                  if (this.currentDocumentTypeCode != 'OTHPWS') {
                      if (name === "retail_price") {
                          this.tabulator.getColumn(name).updateDefinition({ title: 'Retail Price', download: false, editable: false });
                          if (this.currentDocumentTypeCode == 'RECTRX' || this.currentDocumentTypeCode == 'RELTRX' || this.currentDocumentTypeCode == 'RECADJ' || this.currentDocumentTypeCode == 'RELADJ')
                          this.tabulator.getColumn(name).updateDefinition({ download: true });
                          // Retail Price is inherently a price field: mask it whenever the
                          // user lacks the Access Price ('Y') right, independent of the
                          // document's PriceOrCost configuration.
                          if (!this.accessCostPriceRights.includes('Y')) {
                              this.tabulator.getColumn(name).updateDefinition({ formatter: this.costFormatter });
                          }
                      }
                  }
  
                  if (this.currentDocumentTypeCode == 'RECCSR') {
                    if (name === "discount_text") {
                        this.tabulator.getColumn(name).updateDefinition({ title: 'Discount', download: false, editable: true });
                    }
                  }

                  if (name === "cost") {
                      if (
                          (!this.accessCostPriceRights.includes('Z') &&
                              (this.productPriceChoice == 'landed_cost' || this.productPriceChoice == 'ordering_cost' || this.productPriceChoice == 'original_cost' || this.productPriceChoice == 'retail_price')) ||
                          (!this.accessCostPriceRights.includes('Y') &&
                              (this.productPriceChoice == 'retail_price' || this.productPriceChoice == 'wholesale_price'))
                      ) {
                          this.tabulator.getColumn(name).updateDefinition({ formatter: this.costFormatter });
                      }
                  }
  
                  if (name === "price") {
                      if (
                          (!this.accessCostPriceRights.includes('Z') &&
                              (this.productPriceChoice == 'landed_cost' || this.productPriceChoice == 'ordering_cost' || this.productPriceChoice == 'original_cost' || this.productPriceChoice == 'retail_price')) ||
                          (!this.accessCostPriceRights.includes('Y') &&
                              (this.productPriceChoice == 'retail_price' || this.productPriceChoice == 'wholesale_price'))
                      ) {
                          this.tabulator.getColumn(name).updateDefinition({ formatter: this.costFormatter });
                      }
                  }
  
                  if (name === "subtotal") {
                      if (
                          (!this.accessCostPriceRights.includes('Z') &&
                              (this.productPriceChoice == 'landed_cost' || this.productPriceChoice == 'ordering_cost' || this.productPriceChoice == 'original_cost' || this.productPriceChoice == 'retail_price')) ||
                          (!this.accessCostPriceRights.includes('Y') &&
                              (this.productPriceChoice == 'retail_price' || this.productPriceChoice == 'wholesale_price'))
                      ) {
                          this.tabulator.getColumn(name).updateDefinition({ formatter: this.costFormatter });
                      }
                  }

                  if (name === "subtotal_without_vat") {
                      if (
                          (!this.accessCostPriceRights.includes('Z') &&
                              (this.productPriceChoice == 'landed_cost' || this.productPriceChoice == 'ordering_cost' || this.productPriceChoice == 'original_cost' || this.productPriceChoice == 'retail_price')) ||
                          (!this.accessCostPriceRights.includes('Y') &&
                              (this.productPriceChoice == 'retail_price' || this.productPriceChoice == 'wholesale_price'))
                      ) {
                          this.tabulator.getColumn(name).updateDefinition({ formatter: this.costFormatter });
                      }
                  }
  
                    if (this.currentDocumentTypeCode == "OTHPWS") {
                      if (name === "old_landed_cost") {
                          if (!this.accessCostPriceRights.includes('Z')) {
                              this.tabulator.getColumn(name).updateDefinition({ formatter: this.costFormatter });
                          }
                      }
                  
                      if (name === "landed_cost") {
                          if (!this.accessCostPriceRights.includes('Z')) {
                              this.tabulator.getColumn(name).updateDefinition({ formatter: this.costFormatter });
                          }
                      }
                  
                      if (name === "old_original_cost") {
                          if (!this.accessCostPriceRights.includes('Z')) {
                              this.tabulator.getColumn(name).updateDefinition({ formatter: this.costFormatter });
                          }
                      }
                  
                      if (name === "original_cost") {
                          if (!this.accessCostPriceRights.includes('Z')) {
                              this.tabulator.getColumn(name).updateDefinition({ formatter: this.costFormatter });
                          }
                      }
                  
                      if (name === "old_ordering_cost") {
                          if (!this.accessCostPriceRights.includes('Z')) {
                              this.tabulator.getColumn(name).updateDefinition({ formatter: this.costFormatter });
                          }
                      }
                  
                      if (name === "ordering_cost") {
                          if (!this.accessCostPriceRights.includes('Z')) {
                              this.tabulator.getColumn(name).updateDefinition({ formatter: this.costFormatter });
                          }
                      }
                  
                      if (name === "old_wholesale_price") {
                          if (!this.accessCostPriceRights.includes('Y')) {
                              this.tabulator.getColumn(name).updateDefinition({ formatter: this.costFormatter });
                          }
                      }
                      
                      if (name === "wholesale_price") {
                          if (!this.accessCostPriceRights.includes('Y')) {
                              this.tabulator.getColumn(name).updateDefinition({ formatter: this.costFormatter });
                          }
                      }
                  
                      if (name === "old_least_price") {
                          if (!this.accessCostPriceRights.includes('Y')) {
                              this.tabulator.getColumn(name).updateDefinition({ formatter: this.costFormatter });
                          }
                      }
                  
                      if (name === "least_price") {
                          if (!this.accessCostPriceRights.includes('Y')) {
                              this.tabulator.getColumn(name).updateDefinition({ formatter: this.costFormatter });
                          }
                      }
                  
                      if (name === "old_special_price") {
                          if (!this.accessCostPriceRights.includes('Y')) {
                              this.tabulator.getColumn(name).updateDefinition({ formatter: this.costFormatter });
                          }
                      }
                  
                      if (name === "special_price") {
                          if (!this.accessCostPriceRights.includes('Y')) {
                              this.tabulator.getColumn(name).updateDefinition({ formatter: this.costFormatter });
                          }
                      }
                    }else{
                        if(name === "landed_cost") if((!this.accessCostPriceRights.includes('Z') && (this.productPriceChoice =='landed_cost' || this.productPriceChoice == 'ordering_cost' || this.productPriceChoice == 'original_cost')) || (!this.accessCostPriceRights.includes('Y')&& (this.productPriceChoice =='retail_price' || this.productPriceChoice =='wholesale_price'))) this.tabulator.getColumn(name).updateDefinition({formatter:this.costFormatter})
                    }

                    this.tabulator.showColumn(name)
                } else {
                    this.tabulator.hideColumn(name)
                }
                })
            },
            async duplicateDocumentLines(){
                if (this.isPhysicalCountV2ProductListLocked) {
                    return;
                }
                let documentLines = this.selectedDocumentLines
                let data = this.tabulator.getData()
                documentLines.forEach((object) => {
                        let duplicateLine = Object.assign({}, object)
                        if(this.isPhysicalCountV2Document && duplicateLine.is_require_lotcode){
                            duplicateLine.document_line_locations = []
                            duplicateLine.document_line_lot_code = ''
                            duplicateLine.document_line_expiry = ''
                        }
                        data.splice(object.line_no, 0, duplicateLine)
                    }
                )
                await this.tabulator.replaceData(data)
                await this.recountLineNo()
                await this.calculateSummary();
            },
            async checkIfDocumentTypeIsCorrect(){
                if (this.existingDocumentTypeId != this.currentDocumentTypeId){
                    this.$warning({
                        title: "Your selected document has been changed.",
                        content: h => <div>This will return to the documents table. Please click 'OK' to continue.</div>,
                        button: {
                            yes: 'OK',
                        },
                        onOk: () => {
                            this.notEqualDocumentTypeIdStatus = false
                            this.$router.replace(this.backLink)
                        },
                    })
                }
            },
            async checkSiteIfCorrect(){
                if (parseInt(this.defaultSite)!=0 && parseInt(this.defaultSite)!=-1){
                    if (this.defaultSite != secureStorage.getItem("defaultSiteId") && this.defaultSite != this.documentCurrentSite){
                        this.$warning({
                            title: "Your default site has been changed.",
                            content: h => <div>This will return to the documents table. Please click 'OK' to continue.</div>,
                            button: {
                                yes: 'OK',
                            },
                            onOk: () => {
                                this.updateCheckCurrentSite(true)
                                this.$router.replace(this.backLink)
                            },
                        })
                    }
                }
            },
            showBarcodePrintingModal(){
                this.showPrintingModal = true;
                if (!qz.websocket.isActive()) {
                    this.loadingBarcodePrintingModal = true;
                    qz.websocket.connect().then(function() {
                        console.log("connected!")
                        component_x.loadingBarcodePrintingModal = false;
                        component_x.getlistOfPrinters();
                    }).catch(function(error) {
                        console.log(error);
                        component_x.loadingBarcodePrintingModal = true;
                    });
                }else {
                    this.loadingBarcodePrintingModal = false;
                    this.getlistOfPrinters();
                }
                this.getListOfPrinterFormat();
                this.documentLines = this.tabulator.getData();
            },
            hidePrintingModal: function(){
                this.showPrintingModal = false;
            },
            getlistOfPrinters(){
                this.fetchingPrinterList = true;
                qz.printers.find().then(function(data) {
                   console.log(data);
                   component_x.printerList = data;
                   component_x.fetchingPrinterList = false;
                }).catch(function(error) {
                    console.log(error);
                });
            },
            async getListOfPrinterFormat(){
                var response = await HTTPRequest.getRequest(this.endPoint + 'barcode_printing_templates/get_all_barcode_printing_template', null)
                console.log(response)
                this.printerFormatList = response
            },
            async printBarcode() {
                this.printBarcodeLoading = true;

                if (!this.printBarcodeValidation()) {
                    try {
                        var config = qz.configs.create(component_x.selectedPrinter);
                        var data = [];
                        var format = await fetch(component_x.selectedBarcodeFormat[0].file_url)
                            .then(response => response.text());
                        var printer = await qz.printers.find(component_x.selectedPrinter);
                        console.log(format)
                        for (const val of component_x.documentLines) {
                            var text = format;
                            text = text.replace(/{barcode}/g,val.barcode)
                            if (text.includes('{name}')) {
                                text = text.replace(/{name}/g,val.product_name)
                            }
                            if (text.includes('{price}')) {
                                text = text.replace(/{price}/g,component_x.formatMyNumber(Number(val.price),2))
                            }
                            if (text.includes('{quantity}')) {
                                text = text.replace(/{quantity}/g,parseInt(val.quantity))
                            }
                            var product_data = await HTTPRequest.getRequest(component_x.endPoint + 'products/' + val.product_id, null)
                            if (text.includes('{short_name}')) {
                                text = text.replace(/{short_name}/g,product_data.short_name)
                            }
                            if (text.includes('{stock_no}')) {
                                text = text.replace(/{stock_no}/g,val.stock_no)
                            }
                            if (text.includes('{color}')) {
                                text = text.replace(/{color}/g,val.color ? val.color : "")
                            }
                            if (text.includes('{size}')) {
                                text = text.replace(/{size}/g,val.size ? val.size : "")
                            }
                            if (text.includes('{design}')) {
                                text = text.replace(/{design}/g,val.design ? val.design : "")
                            }
                            if (text.includes('{department}')) {
                                text = text.replace(/{department}/g,product_data.department_refcode)
                            }
                            if (text.includes('{section}')) {
                                text = text.replace(/{section}/g,product_data.section_refcode)
                            }
                            if (text.includes('{class}')) {
                                text = text.replace(/{class}/g,product_data.category_refcode)
                            }
                            if (text.includes('{erp_code}')) {
                                text = text.replace(/{erp_code}/g,product_data.erp_code)
                            }
                            if (text.includes('{unit}')) {
                                text = text.replace(/{unit}/g,product_data.unit_code ? product_data.unit_code : "")
                            }
                            if (text.includes('{udf_text}')) {
                                text = text.replace(/{udf_text}/g,val.extras && val.extras.udf_text ? val.extras.udf_text : "")
                            }
                            if (text.includes('{floor_date}')) {
                                text = text.replace(/{floor_date}/g,product_data.intro_date ? moment(product_data.intro_date).format('MM-DD-YYYY') : "")
                            }
                            if (text.includes('{brand}')) {
                                var brands_data = await HTTPRequest.getRequest(component_x.endPoint + 'brands/' + product_data.brand_id, null)
                                text = text.replace(/{brand}/g,brands_data.name ? brands_data.name : "")
                            }
                            if (text.includes('{product_line}')) {
                                var product_lines_data = await HTTPRequest.getRequest(component_x.endPoint + 'product_lines/' + product_data.product_line_id, null)
                                text = text.replace(/{product_line}/g,product_lines_data.code)
                            }
                            if (text.includes('{p_tag}')) {
                                var product_properties_data
                                if (product_data.matrix_parent_id) {
                                    product_properties_data = await HTTPRequest.getRequest(component_x.endPoint + 'product_properties?product_id=' + product_data.matrix_parent_id, null)
                                } else {
                                    product_properties_data = await HTTPRequest.getRequest(component_x.endPoint + 'product_properties?product_id=' + val.product_id, null)
                                }

                                if (product_properties_data.data.length > 0) {
                                    var property_data = await HTTPRequest.getRequest(component_x.endPoint + 'properties/' + product_properties_data.data[0].property_id, null)
                                    text = text.replace(/{p_tag}/g, property_data.code)
                                } else {
                                    text = text.replace(/{p_tag}/g, "")
                                }
                            }
                            // add for multiple printing
                            if(parseInt(val.quantity) > 1){
                                for(let i = 1; i <= parseInt(val.quantity); i++) {
                                    data.push(text)
                                }
                            } else {
                                data.push(text)
                            }    
                        }
                        console.log(data)
                        await qz.print(config, data);

                        if (component_x.documentOrderStatus == "Printed"){
                            component_x.updateOrderStatus("RP");
                        }else{
                            component_x.updateOrderStatus("P");
                        }
                        component_x.hidePrintingModal();
                    } catch (error) {
                        this.barcodeTemplateErrors = error.split(',');
                    }
                }
                this.printBarcodeLoading = false;
            },
            async generateBarcodeText(val) {
                var format = await fetch(component_x.selectedBarcodeFormat[0].file_url)
                    .then(response => response.text());
                var text = format.replace(/{barcode}/g, val.barcode)
                                .replace(/{name}/g, val.product_name)
                                .replace(/{price}/g, component_x.formatMyNumber(Number(val.price), 2))
                                .replace(/{quantity}/g, parseInt(val.quantity));

                if (text.includes('{color}') || text.includes('{size}') || text.includes('{design}') || text.includes('{udf_text}') || text.includes('{p_tag}')) {
                    // Replace each placeholder with its corresponding value
                    text = text.replace(/{color}/g, val.color !== null ? val.color : "" )
                            .replace(/{size}/g, val.size !== null ? val.size : "" )
                            .replace(/{design}/g, val.design !== null ? val.design : "" )
                            .replace(/{udf_text}/g, val.extras && val.extras.udf_text ? val.extras.udf_text : "");

                    var product_properties_data = await HTTPRequest.getRequest(component_x.endPoint + 'product_properties?product_id=' + val.product_id, null);
                    if (product_properties_data.data.length > 0) {
                        var property_data = await HTTPRequest.getRequest(component_x.endPoint + 'properties/' + product_properties_data.data[0].property_id, null);
                        text = text.replace(/{p_tag}/g, property_data.code);
                    } else {
                        text = text.replace(/{p_tag}/g, "");
                    }
                }
                return text;
            },
            changePrinterFormat(value){
                this.selectedBarcodeFormat = this.printerFormatList.filter(d => d.id == value);
                this.selectedBarcodeFormat.descriptionList = this.selectedBarcodeFormat[0].description.split(", ")
                this.selectedPrinterFormat = value;
            },
            printBarcodeValidation(){
                this.barcodeTemplateErrors = []
                this.barcodeTemplateErrors.push(ValidateField.required('Printer Device', this.selectedPrinter));
                this.barcodeTemplateErrors.push(ValidateField.required('Format', this.selectedPrinterFormat));
                this.barcodeTemplateErrors = this._.compact(this.barcodeTemplateErrors);
                return this.barcodeTemplateErrors.length;
            },
             showScanningScreenModal(){
                this.viewScanningScreenModal = true
            },
            handleClose(){
                this.viewScanningScreenModal = false
            },
            async handleOk(){
                this.viewScanningScreenModal = false

                for (const product of this.scannedProduct) {
                    this.selectedProduct = product
                    this.inputProduct = product.name 
                    this.productName = product.name 
                    this.quantity = product.scanQuantity
                    this.actual_yield = 0
                    this.unitCost = eval('product.'+this.productPriceChoice)
                    this.subTotal = Number(product.scanQuantity * eval('product.'+this.productPriceChoice)).toFixed(this.fixedDecimalPlaces)
                    this.unitNetCost = 0
                    this.discountTotal = 0
                    this.discountText = []
                    this.onHandQuantity = 0
                    this.rewardCode = 0
                    this.rewardDiscountAmount = 0

                    await this.addProduct()
                }

                this.scannedProduct = []
            },
            handleEdit(index){
                this.scannedProduct[index].editMode = true
            },
            handleDoneEdit(index){
                this.scannedProduct[index].editMode = false
            },
            handleRemove(index) {
                this.scannedProduct.splice(index, 1)
            },
            async searchProductBarcode(){
                var product_data = await HTTPRequest.getRequest(this.endPoint + 'products/get_product_by_barcode?barcode=' + this.barcodeSearch , null)
                if (Object.keys(product_data).length !== 0) {
                    this.scannedProduct.push({
                        ...product_data,
                        editMode: false,
                        scanQuantity: 1
                    }),
                         this.$message['success'](
                            "Product found."
                    )
                }else{
                    this.$message['error'](
                            "Product not found. Please search another barcode."
                    )
                    this.scannedProduct = {}
                }
                this.barcodeSearch = ""
            },
        },
        watch: {
            grossAmountDisplay: function(newValue, oldValue) {
                if (this.isFiniteNumberValue(newValue)) {
                    return
                }

                this.documentFormDebugWarn('[DocumentForm] grossAmountDisplay changed to invalid value', {
                    newValue,
                    oldValue,
                    grossAmount: this.grossAmount,
                    grossAmountwithoutTax: this.grossAmountwithoutTax,
                    netAmount: this.netAmount,
                    netAmountDisplay: this.netAmountDisplay,
                    vatAmount: this.vatAmount,
                    vatExclusiveCheckbox: this.vatExclusiveCheckbox,
                    documentNumber: this.documentNumber,
                    documentStatus: this.documentStatus,
                    currentDocumentTypeCode: this.currentDocumentTypeCode,
                    selectedDocumentLinesCount: this.selectedDocumentLines ? this.selectedDocumentLines.length : 0,
                    stack: new Error().stack
                })
            },
            paymentMode: async function() {
                if(this.paymentMode == "dragonpay" && this.paymentMethods.length == 0){
                    var response = await HTTPRequest.getRequest(this.endPoint + 'integrations/get_dragonpay_processors', null)
                    component_x.paymentMethods = response
                }
            },
            documentStatus: function(){
                if (this.documentStatus == 'Posted' || this.documentStatus == 'Voided' || this.documentStatus == 'Confirmed'){
                    var elList = this.$el.querySelectorAll(".tabulator-cell");
                    elList.forEach(el => el.style.cssText = "pointer-events: none;");
                }
            },
            viewAllocation: async function(){
                if (this.viewAllocation){
                    this.totalAllocatedQty = 0
                    var column_names = []
                    var check_error = false
                    try{
                        component_x.tabulator1 = this.$refs.tabulator1.getInstance();
                        check_error = false
                    }catch(e){
                        check_error = true
                    }
                    var lines = this.documentLines;
                    for(var i = 0; i < lines.length; i++) {
                        if (lines[i].site_allocation!=undefined && lines[i].site_allocation!=null){
                            var ttl_quantity = 0
                            var isWeighted = lines[i].is_weighted
                            lines[i].site_allocation.forEach(function(obj) {
                                if (component_x.currentDocumentTypeCode=='OTHPCK'){
                                    // console.log("Here")
                                    // console.log("Avail Qty", obj.available_quantity)
                                    // console.log("Qty", obj.quantity)
                                    var qty = (obj.available_quantity == 0 || obj.available_quantity == undefined) ? obj.quantity : obj.available_quantity
                                    qty = isWeighted ? parseFloat(qty) : parseInt(qty)
                                    if(component_x.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.AllocationDefaultValue == 'SC'){
                                        lines[i][`${obj.code}`] = qty
                                    } else {
                                        lines[i][`${obj.refcode}`] = qty
                                    }
                                    ttl_quantity+= isNaN(qty) ? 0 : qty
                                }else{
                                    var qty = (obj.quantity == 0) ? '' : obj.quantity
                                    if (qty !== '') {
                                        qty = isWeighted ? parseFloat(qty) : parseInt(qty)
                                    }
                                    if(component_x.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.AllocationDefaultValue == 'SC'){
                                        lines[i][`${obj.code}`] = qty
                                    } else {
                                        lines[i][`${obj.refcode}`] = qty
                                    }
                                    ttl_quantity+= isNaN(parseFloat(qty)) ? 0 : (isWeighted ? parseFloat(qty) : parseInt(qty))
                                }
                                if (!column_names.includes(obj.code) && component_x.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.AllocationDefaultValue == 'SC') {
                                    column_names.push(obj.code);
                                }

                                if (!column_names.includes(obj.refcode) && component_x.document_config.document_type_settings.additionalEditorBehaviorCheckboxes.AllocationDefaultValue == 'RC') {
                                    column_names.push(obj.refcode);
                                }
                            });
                            lines[i]["total_allocated_quantity"] =  isWeighted ? parseFloat(ttl_quantity) : parseInt(ttl_quantity)
                            this.totalAllocatedQty += isWeighted ? parseFloat(ttl_quantity) : parseInt(ttl_quantity)
                        }
                    }
                    for (var index = 0; index < column_names.length; index++) {
                        try {
                            var customField = component_x.tabulator1.getColumn(column_names[index])
                            if (customField==undefined || customField==null || customField=='') {
                                if (check_error){
                                    component_x.optionsViewAllocation.columns.push({title:column_names[index], field:column_names[index]})
                                }else{
                                    component_x.tabulator1.addColumn({title:column_names[index], field:column_names[index]})
                                }
                            }
                        } catch (error) {
                            if (check_error){
                                component_x.optionsViewAllocation.columns.push({title:column_names[index], field:column_names[index]})
                            }else{
                                component_x.tabulator1.addColumn({title:column_names[index], field:column_names[index]})
                            }
                        }
                    }
                    if (column_names.length > 0){
                        try {
                            var total_allocated_quantity = component_x.tabulator1.getColumn("total_allocated_quantity")
                            if (total_allocated_quantity==undefined || total_allocated_quantity==null || total_allocated_quantity=='') {
                                if (check_error){
                                    component_x.optionsViewAllocation.columns.push({title:"Total Allocated Quantity", field:"total_allocated_quantity"})
                                }else{
                                    component_x.tabulator1.addColumn({title:"Total Allocated Quantity", field:"total_allocated_quantity"})
                                }
                            }
                        } catch (error) {
                            if (check_error){
                                component_x.optionsViewAllocation.columns.push({title:"Total Allocated Quantity", field:"total_allocated_quantity"})
                            }else{
                                component_x.tabulator1.addColumn({title:"Total Allocated Quantity", field:"total_allocated_quantity"})
                            }
                        }
                    }
                }

            },
            revenue: function(){
                if (this.revenue == 'R'){
                    this.revenueSiteId = secureStorage.getItem("defaultSiteId").toString()
                }else if(this.revenue =='T'){
                    this.revenueSiteId = this.requestingSite.key || 0
                }
            },
            supplierDetails: function(){
                if (this.currentDocumentTypeCode == 'ORIPOX' || this.currentDocumentTypeCode=='RECDEL'){
                    if (this.documentStatus != 'Posted' && this.documentStatus != 'Voided' && this.documentStatus != 'Saved'){
                       this.updateValueOfSupplierCurrency()
                    }
                }
            },
            currentSerialCount: function(){
              if(!this.currentDocumentTypeCode.includes("REL")){
                this.currentSerialCount === this.previousSerialCount && this.saveDrawerSerialization();
              }
            },
        }
    };

</script>

<style lang='scss'>
@import "~vue-tabulator/dist/scss/bootstrap/tabulator_bootstrap";

/* #135: "X" button for search product vertical align */
.autocomplete__icon.autocomplete--clear {
    height: 100%;
}

.tabulator-calcs-holder{
    display: none;
}

.sticky-header {
    z-index: 100;
}

.ant-steps-dot .ant-steps-item-content, .ant-steps-dot.ant-steps-small .ant-steps-item-content {
    width: 250px;
}

// .tabulator-menu {
//     position: absolute;
//     z-index: 999999;
//     background-color: white;
//     border: groove;
//     padding: 10px;
//     cursor: pointer;
// }

// .tabulator-menu-item:hover {
//     background-color: whitesmoke;
// }
.table-product-icons2{
    height: 15px;
    width: 15px;
}

</style>

<style scoped>
@media (min-width: 1200px) {
    .container {
        max-width: 100%;
    }
}
.table-scroll {
	position:relative;
	max-width:600px;
	margin:auto;
	overflow:hidden;
	border:1px solid #000;
}
.table-wrap {
	width:100%;
	overflow:auto;
}
.table-scroll table {
	width:100%;
	margin:auto;
	border-collapse:separate;
	border-spacing:0;
}
.table-scroll th, .table-scroll td {
	padding:5px 10px;
	border:1px solid #000;
	background:#fff;
	white-space:nowrap;
	vertical-align:top;
}
.fixed-side {
	border:1px solid #000;
	background:#eee;
	visibility:visible;
}
.refresh-document {
    margin: 0 10px;
    font-size: 20px;
    display: flex;
    align-items: center;
    height: 26px;
    color: inherit !important;
}
.si_customer_name{
  display:flex;
  justify-content: space-between;
}
.si_customer_name_input{
  flex: 10;
  border-radius: 5px 0px 0px 5px !important;
}
.si_customer_name_btn{
  flex: 1;
  border-radius: 0px 5px 5px 0px;
}
.table-product-icons2{
    height: 15px;
    width: 15px;
}
.deprecation-notice {
  background-color: #fff8db;   /* light yellow */
  border: 1px solid #ffe58f;
  color: #8a6d3b;
  padding: 8px 12px;
  border-radius: 4px;
  font-size: 13px;
}

/*
  Full-screen loading overlay used while the document form is still loading/building
  (see isInitializing). It sits above everything and captures pointer events so that no
  action button (Update / Confirm / Post) can be clicked until loading fully completes.
*/
.document-loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000000;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: rgba(255, 255, 255, 0.75);
  /* Explicitly capture clicks so buttons underneath are not interactable. */
  pointer-events: all;
  cursor: progress;
}
.document-loading-overlay__text {
  margin-top: 16px;
  font-size: 15px;
  font-weight: 600;
  color: #5e72e4;
}
</style>
